/* ds.AddressBean */
export class AddressBean {
	constructor() {
		this.address1 = '' ;
		this.address2 = '' ;
		this.address3 = '' ;
		this.address4 = '' ;
		this.address5 = '' ;
		this.address6 = '' ;
		this.address7 = '' ;
		this.city = '' ;
		this.state = '' ;
		this.country = '' ;
		this.zip = '' ;
		this.email = '' ;
		this.mobilePhone = '' ;
		this.phone1 = '' ;
		this.phone2 = '' ;
		this.fax = '' ;
		this.fax2 = '' ;
		this.website = '' ;
		this.contactPerson = '' ;
		this.ccEmail = '' ;
		this.county = '' ;
	}
}
/* ds.ApplicationConfigurationBean */
export class ApplicationConfigurationBean {
	constructor() {
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.BinaryDataBean */
export class BinaryDataBean {
	constructor() {
		this.id = '' ;
		this.streamdata = null ;
	}
}
/* ds.deps.response.RoleModuleDependenciesResponseBean */
export class RoleModuleDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.deps.RoleModuleDependenciesBean */
export class RoleModuleDependenciesBean {
	constructor() {
		this.moduleGroups = new Array() ;
		this.entitlements = new Array() ;
		this.moduleEntities = new Array() ;
		this.moduleGroupEntities = new Array() ;
	}
}
/* ds.EntityWithDetailWrapper */
export class EntityWithDetailWrapper {
	constructor() {
		this.entity = null ;
		this.entityDetail = null ;
	}
}
/* ds.lock.EntityLockBean */
export class EntityLockBean {
	constructor() {
		this.companyCode = '' ;
		this.lockType = 0 ;
		this.lockMode = 0 ;
		this.lockTypeName = '' ;
		this.securityPass = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.lock.EntityLockPageListBean */
export class EntityLockPageListBean {
	constructor() {
		this.entityLocks = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.lock.UnLockInputBean */
export class UnLockInputBean {
	constructor() {
		this.companyCode = '' ;
		this.entityTypeCode = '' ;
		this.securityPass = '' ;
	}
}
/* ds.LoginBean */
export class LoginBean {
	constructor() {
		this.password = '' ;
		this.entityCode = '' ;
		this.loginType = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.LoginSessionBean */
export class LoginSessionBean {
	constructor() {
		this.companyCode = '' ;
		this.securityPass = '' ;
		this.entityCode = '' ;
		this.loginType = '' ;
		this.workStationCode = '' ;
		this.workStationIpAddress = '' ;
		this.sessionType = 0 ;
		this.password = '' ;
		this.entityCode = '' ;
		this.loginType = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.MailDefaultInfoBean */
export class MailDefaultInfoBean {
	constructor() {
		this.from = '' ;
		this.tos = '' ;
		this.ccs = '' ;
		this.title = '' ;
		this.message = '' ;
	}
}
/* ds.MailInfoBean */
export class MailInfoBean {
	constructor() {
		this.from = '' ;
		this.tos = '' ;
		this.ccs = '' ;
		this.bccs = '' ;
		this.title = '' ;
		this.message = '' ;
		this.attachements = '' ;
	}
}
/* ds.MailTrackBean */
export class MailTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.emailTrackID = 0 ;
		this.from = '' ;
		this.tos = '' ;
		this.ccs = '' ;
		this.bccs = '' ;
		this.title = '' ;
		this.message = '' ;
		this.mailType = '' ;
		this.userID = '' ;
		this.trackDate = '' ;
		this.attachmentPath = '' ;
		this.mailStatus = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.merge.response.RoleModuleMergeResponseBean */
export class RoleModuleMergeResponseBean {
	constructor() {
		this.roleResponse = null ;
		this.lockResponse = null ;
		this.dependenciesResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.merge.response.UserModuleMergeResponseBean */
export class UserModuleMergeResponseBean {
	constructor() {
		this.userResponse = null ;
		this.lockResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.MessageBean */
export class MessageBean {
	constructor() {
		this.messageID = '' ;
		this.messageDescription = '' ;
		this.messageTarget = '' ;
	}
}
/* ds.NotesCommunicationBean */
export class NotesCommunicationBean {
	constructor() {
		this.companyCode = '' ;
		this.notesNumber = 0 ;
		this.notesEntityCode = '' ;
		this.notesEntityType = '' ;
		this.isEditable = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.PageListBean */
export class PageListBean {
	constructor() {
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.PeriodValueInfoBean */
export class PeriodValueInfoBean {
	constructor() {
		this.scalarValue = 0 ;
		this.startDate = '' ;
		this.endDate = '' ;
	}
}
/* ds.print.pagelist.PrinterPageListBean */
export class PrinterPageListBean {
	constructor() {
		this.printers = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.print.pagelist.PrintRequestPageListBean */
export class PrintRequestPageListBean {
	constructor() {
		this.printRequests = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.print.pagelist.response.PrinterPageListResponseBean */
export class PrinterPageListResponseBean {
	constructor() {
		this.printerPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.print.pagelist.response.PrintRequestPageListResponseBean */
export class PrintRequestPageListResponseBean {
	constructor() {
		this.printRequestPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.print.pagelist.response.UserPrinterPageListResponseBean */
export class UserPrinterPageListResponseBean {
	constructor() {
		this.userPrinterPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.print.pagelist.UserPrinterPageListBean */
export class UserPrinterPageListBean {
	constructor() {
		this.userPrinters = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.print.PrinterBean */
export class PrinterBean {
	constructor() {
		this.companyCode = '' ;
		this.printerCode = '' ;
		this.printerName = '' ;
		this.printerAreaCode = '' ;
		this.printerType = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.print.PrinterSearchCriteria */
export class PrinterSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.printerAreaCode = '' ;
		this.printerType = '' ;
		this.printerCode = '' ;
		this.printerName = '' ;
		this.createdDate = '' ;
	}
}
/* ds.print.PrintOutTrackBean */
export class PrintOutTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.printTrackType = 0 ;
		this.entityCode = '' ;
		this.printedBY = '' ;
		this.printedDate = '' ;
		this.printedDocumentFilePath = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.print.PrintRequestBean */
export class PrintRequestBean {
	constructor() {
		this.companyCode = '' ;
		this.userCode = '' ;
		this.printerName = '' ;
		this.printerCode = '' ;
		this.printerAreaCode = '' ;
		this.filePath = '' ;
		this.fileType = 0 ;
		this.numberOfCopies = 0 ;
		this.printStatus = '' ;
		this.remarks = '' ;
		this.printedDate = '' ;
		this.printServerId = '' ;
		this.printEntityType = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.print.PrintRequestSearchCriteria */
export class PrintRequestSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.printerAreaCode = '' ;
		this.printerType = '' ;
		this.printerCode = '' ;
		this.printerName = '' ;
		this.userCode = '' ;
		this.printerdDate = '' ;
		this.printServerId = '' ;
		this.printRequestCode = '' ;
		this.printStatus = '' ;
		this.printEntityType = 0 ;
		this.fromCreatedDate = '' ;
		this.toCreatedDate = '' ;
	}
}
/* ds.print.response.PrinterResponseBean */
export class PrinterResponseBean {
	constructor() {
		this.printer = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.print.response.PrintRequestResponseBean */
export class PrintRequestResponseBean {
	constructor() {
		this.printRequest = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.print.response.UserPrinterResponseBean */
export class UserPrinterResponseBean {
	constructor() {
		this.userPrinter = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.print.UserPrinterBean */
export class UserPrinterBean {
	constructor() {
		this.companyCode = '' ;
		this.userCode = '' ;
		this.printerCode = '' ;
		this.printEntityType = 0 ;
		this.isDefaultPrinter = false ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.print.UserPrinterSearchCriteria */
export class UserPrinterSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.printerCode = '' ;
		this.userCode = '' ;
		this.printEntityType = 0 ;
	}
}
/* ds.ReasonBean */
export class ReasonBean {
	constructor() {
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.report.ReportInfoBean */
export class ReportInfoBean {
	constructor() {
		this.reportGeneratedBy = '' ;
		this.reportGeneratedOn = '' ;
	}
}
/* ds.response.AttributeModuleEntityCompanyPageListResponseBean */
export class AttributeModuleEntityCompanyPageListResponseBean {
	constructor() {
		this.attributeModuleEntityCompanyPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.BinaryDataResponseBean */
export class BinaryDataResponseBean {
	constructor() {
		this.binaryData = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.EntitlementPageListResponseBean */
export class EntitlementPageListResponseBean {
	constructor() {
		this.entitlementPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.EntityLockPageListResponseBean */
export class EntityLockPageListResponseBean {
	constructor() {
		this.entityLockPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.LockResponseBean */
export class LockResponseBean {
	constructor() {
		this.lockedCode = '' ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.LoginResponseBean */
export class LoginResponseBean {
	constructor() {
		this.sessionBean = null ;
		this.entitlementPageListResponse = null ;
		this.userCompanyPageListResponse = null ;
		this.configs = new Array() ;
		this.companyConfigs = new Array() ;
		this.moduleConfigs = new Array() ;
		this.clientGUIVersion = '' ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.MailDefaultInfoResponseBean */
export class MailDefaultInfoResponseBean {
	constructor() {
		this.mailDefaultInfo = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.MailInfoResponseBean */
export class MailInfoResponseBean {
	constructor() {
		this.mailInfo = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.MergeOperationsResponseBean */
export class MergeOperationsResponseBean {
	constructor() {
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.ModuleEntityEntitlementPageListResponseBean */
export class ModuleEntityEntitlementPageListResponseBean {
	constructor() {
		this.moduleEntityEntitlementPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.ModuleEntityPageListResponseBean */
export class ModuleEntityPageListResponseBean {
	constructor() {
		this.moduleEntityPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.ModuleGroupResponseBean */
export class ModuleGroupResponseBean {
	constructor() {
		this.moduleGroups = new Array() ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.report.DummyReportData */
export class DummyReportData {
	constructor() {
		this.test = '' ;
	}
}
/* ds.response.report.ReportListResultResponseBean */
export class ReportListResultResponseBean {
	constructor() {
		this.reportResult = null ;
		this.printRequest = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.report.ReportMultiResultResponseBean */
export class ReportMultiResultResponseBean {
	constructor() {
		this.reportResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.report.ReportResultResponseBean */
export class ReportResultResponseBean {
	constructor() {
		this.reportResult = null ;
		this.printRequest = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.ResponseBean */
export class ResponseBean {
	constructor() {
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.RoleEntitlementPageListResponseBean */
export class RoleEntitlementPageListResponseBean {
	constructor() {
		this.roleEntitlementPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.RoleEntitlementResponseBean */
export class RoleEntitlementResponseBean {
	constructor() {
		this.roleEntitlements = new Array() ;
		this.count = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.RolePageListResponseBean */
export class RolePageListResponseBean {
	constructor() {
		this.rolePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.RoleResponseBean */
export class RoleResponseBean {
	constructor() {
		this.role = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.SequenceNumberResponseBean */
export class SequenceNumberResponseBean {
	constructor() {
		this.sequenceNumberCode = '' ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.UserCompanyPageListResponseBean */
export class UserCompanyPageListResponseBean {
	constructor() {
		this.userCompanyPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.UserCompanyResponseBean */
export class UserCompanyResponseBean {
	constructor() {
		this.userCompany = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.UserPageListResponseBean */
export class UserPageListResponseBean {
	constructor() {
		this.userPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.UserResponseBean */
export class UserResponseBean {
	constructor() {
		this.user = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.UserRolePageListResponseBean */
export class UserRolePageListResponseBean {
	constructor() {
		this.userRolePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.UserRoleResponseBean */
export class UserRoleResponseBean {
	constructor() {
		this.userRoles = new Array() ;
		this.count = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.lock.RestEntityLockBean */
export class RestEntityLockBean {
	constructor() {
		this.companyCode = '' ;
		this.lockType = '' ;
		this.lockMode = '' ;
		this.lockTypeName = '' ;
		this.securityPass = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.rest.lock.RestEntityLockPageListBean */
export class RestEntityLockPageListBean {
	constructor() {
		this.entityLocks = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.rest.print.RestPrinterBean */
export class RestPrinterBean {
	constructor() {
		this.companyCode = '' ;
		this.printerCode = '' ;
		this.printerName = '' ;
		this.printerAreaCode = '' ;
		this.printerType = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.rest.print.RestPrinterSearchCriteria */
export class RestPrinterSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.printerAreaCode = '' ;
		this.printerType = '' ;
		this.printerCode = '' ;
		this.printerName = '' ;
		this.createdDate = '' ;
	}
}
/* ds.rest.print.RestPrintRequestBean */
export class RestPrintRequestBean {
	constructor() {
		this.companyCode = '' ;
		this.userCode = '' ;
		this.printerName = '' ;
		this.printerCode = '' ;
		this.printerAreaCode = '' ;
		this.filePath = '' ;
		this.fileType = 0 ;
		this.numberOfCopies = 0 ;
		this.printStatus = '' ;
		this.remarks = '' ;
		this.printedDate = '' ;
		this.printServerId = '' ;
		this.printEntityType = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.rest.print.RestPrintRequestSearchCriteria */
export class RestPrintRequestSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.printerAreaCode = '' ;
		this.printerType = '' ;
		this.printerCode = '' ;
		this.printerName = '' ;
		this.userCode = '' ;
		this.printerdDate = '' ;
		this.printServerId = '' ;
		this.printRequestCode = '' ;
		this.printStatus = '' ;
		this.printEntityType = 0 ;
		this.fromCreatedDate = '' ;
		this.toCreatedDate = '' ;
	}
}
/* ds.rest.print.RestUserPrinterBean */
export class RestUserPrinterBean {
	constructor() {
		this.companyCode = '' ;
		this.userCode = '' ;
		this.printerCode = '' ;
		this.printEntityType = 0 ;
		this.isDefaultPrinter = false ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.rest.print.RestUserPrinterSearchCriteria */
export class RestUserPrinterSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.printerCode = '' ;
		this.userCode = '' ;
		this.printEntityType = 0 ;
	}
}
/* ds.rest.response.report.RestDummyReportData */
export class RestDummyReportData {
	constructor() {
		this.test = '' ;
	}
}
/* ds.rest.response.report.RestReportMultiResultResponseBean */
export class RestReportMultiResultResponseBean {
	constructor() {
		this.reportResult = null ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.response.report.RestReportResultResponseBean */
export class RestReportResultResponseBean {
	constructor() {
		this.reportResult = null ;
		this.printRequest = null ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.response.RestEntitlementPageListResponseBean */
export class RestEntitlementPageListResponseBean {
	constructor() {
		this.entitlementPageList = null ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.response.RestEntityLockPageListResponseBean */
export class RestEntityLockPageListResponseBean {
	constructor() {
		this.entityLockPageList = null ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.response.RestLockResponseBean */
export class RestLockResponseBean {
	constructor() {
		this.lockedCode = '' ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.response.RestLoginResponseBean */
export class RestLoginResponseBean {
	constructor() {
		this.sessionBean = null ;
		this.entitlementPageListResponse = null ;
		this.userCompanyPageListResponse = null ;
		this.configs = new Array() ;
		this.companyConfigs = new Array() ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.response.RestMergeOperationsResponseBean */
export class RestMergeOperationsResponseBean {
	constructor() {
		this.totalNumberOfOperations = '' ;
		this.executedOperations = '' ;
		this.successOperations = '' ;
		this.failureOperations = '' ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.response.RestResponseBean */
export class RestResponseBean {
	constructor() {
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.response.RestRoleEntitlementPageListResponseBean */
export class RestRoleEntitlementPageListResponseBean {
	constructor() {
		this.roleEntitlementPageList = null ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.response.RestRoleEntitlementResponseBean */
export class RestRoleEntitlementResponseBean {
	constructor() {
		this.roleEntitlements = new Array() ;
		this.count = '' ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.response.RestRolePageListResponseBean */
export class RestRolePageListResponseBean {
	constructor() {
		this.rolePageList = null ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.response.RestRoleResponseBean */
export class RestRoleResponseBean {
	constructor() {
		this.role = null ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.response.RestUserCompanyPageListResponseBean */
export class RestUserCompanyPageListResponseBean {
	constructor() {
		this.userCompanyPageList = null ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.response.RestUserCompanyResponseBean */
export class RestUserCompanyResponseBean {
	constructor() {
		this.userCompany = null ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.response.RestUserPageListResponseBean */
export class RestUserPageListResponseBean {
	constructor() {
		this.userPageList = null ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.response.RestUserResponseBean */
export class RestUserResponseBean {
	constructor() {
		this.user = null ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.response.RestUserRolePageListResponseBean */
export class RestUserRolePageListResponseBean {
	constructor() {
		this.userRolePageList = null ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.response.RestUserRoleResponseBean */
export class RestUserRoleResponseBean {
	constructor() {
		this.userRoles = new Array() ;
		this.count = '' ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.RestAddressBean */
export class RestAddressBean {
	constructor() {
		this.address1 = '' ;
		this.address2 = '' ;
		this.address3 = '' ;
		this.address4 = '' ;
		this.city = '' ;
		this.state = '' ;
		this.country = '' ;
		this.zip = '' ;
		this.email = '' ;
		this.mobilePhone = '' ;
		this.phone1 = '' ;
		this.phone2 = '' ;
		this.fax = '' ;
		this.website = '' ;
		this.contactPerson = '' ;
		this.ccEmail = '' ;
		this.county = '' ;
	}
}
/* ds.rest.RestLoginBean */
export class RestLoginBean {
	constructor() {
		this.companyCode = '' ;
		this.password = '' ;
		this.entityCode = '' ;
		this.loginType = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.rest.RestLoginSessionBean */
export class RestLoginSessionBean {
	constructor() {
		this.companyCode = '' ;
		this.securityPass = '' ;
		this.entityCode = '' ;
		this.loginType = '' ;
		this.workStationCode = '' ;
		this.workStationIpAddress = '' ;
		this.companyCode = '' ;
		this.password = '' ;
		this.entityCode = '' ;
		this.loginType = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.rest.RestMessageBean */
export class RestMessageBean {
	constructor() {
		this.messageID = '' ;
		this.messageDescription = '' ;
		this.messageTarget = '' ;
	}
}
/* ds.rest.RestNotesCommunicationBean */
export class RestNotesCommunicationBean {
	constructor() {
		this.companyCode = '' ;
		this.notesNumber = '' ;
		this.notesEntityCode = '' ;
		this.notesEntityType = '' ;
		this.isEditable = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.rest.RestPageListBean */
export class RestPageListBean {
	constructor() {
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.rest.RestReasonBean */
export class RestReasonBean {
	constructor() {
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.rest.RestSecureLoginBean */
export class RestSecureLoginBean {
	constructor() {
		this.userCode = '' ;
		this.password = '' ;
		this.encryptionType = '' ;
	}
}
/* ds.rest.RestSMTPInfoBean */
export class RestSMTPInfoBean {
	constructor() {
		this.smtpHost = '' ;
		this.smtpAuthenticaionRequired = false ;
		this.smtpUserName = '' ;
		this.smtpPassword = '' ;
		this.smtpSSLRequired = false ;
		this.smtpTLSRequired = false ;
		this.smtpPort = '' ;
	}
}
/* ds.rest.RestUserBean */
export class RestUserBean {
	constructor() {
		this.firstName = '' ;
		this.lastName = '' ;
		this.isUserGroup = false ;
		this.userGroupCode = '' ;
		this.address = null ;
		this.userRoles = new Array() ;
		this.companyCode = '' ;
		this.smtpUserName = '' ;
		this.smtpPassword = '' ;
		this.companyCode = '' ;
		this.password = '' ;
		this.entityCode = '' ;
		this.loginType = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.rest.RestUserPageListBean */
export class RestUserPageListBean {
	constructor() {
		this.users = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.rest.RestUserSearchCriteria */
export class RestUserSearchCriteria {
	constructor() {
		this.userCode = '' ;
		this.userName = '' ;
		this.firstName = '' ;
		this.lastName = '' ;
		this.loginType = '' ;
		this.entityCode = '' ;
		this.isUserGroup = false ;
		this.userGroupCode = '' ;
		this.overrideIsUserGroup = false ;
	}
}
/* ds.rest.security.RestAttributeModuleEntityCompanyBean */
export class RestAttributeModuleEntityCompanyBean {
	constructor() {
		this.companyCode = '' ;
		this.entityModuleCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.rest.security.RestEntitlementBean */
export class RestEntitlementBean {
	constructor() {
		this.accessRule = '' ;
		this.shortName = '' ;
		this.displayOrder = '' ;
		this.moduleEntityCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.rest.security.RestEntitlementPageListBean */
export class RestEntitlementPageListBean {
	constructor() {
		this.entitlements = new Array() ;
		this.entitlementsCount = '' ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.rest.security.RestRoleBean */
export class RestRoleBean {
	constructor() {
		this.roleEntitlements = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.rest.security.RestRoleEntitlementBean */
export class RestRoleEntitlementBean {
	constructor() {
		this.roleCode = '' ;
		this.entitlementCode = '' ;
		this.isAccessible = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.rest.security.RestRoleEntitlementPageListBean */
export class RestRoleEntitlementPageListBean {
	constructor() {
		this.roleEntitlements = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.rest.security.RestRoleEntitlementSearchCriteria */
export class RestRoleEntitlementSearchCriteria {
	constructor() {
		this.roleCode = '' ;
		this.entitlementCode = '' ;
		this.isAccessible = false ;
	}
}
/* ds.rest.security.RestRolePageListBean */
export class RestRolePageListBean {
	constructor() {
		this.roles = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.rest.security.RestRoleSearchCriteria */
export class RestRoleSearchCriteria {
	constructor() {
		this.roleCode = '' ;
		this.roleName = '' ;
	}
}
/* ds.rest.security.RestUserCompanyBean */
export class RestUserCompanyBean {
	constructor() {
		this.userCode = '' ;
		this.companyCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.rest.security.RestUserCompanyPageListBean */
export class RestUserCompanyPageListBean {
	constructor() {
		this.userCompanies = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.rest.security.RestUserCompanySearchCriteria */
export class RestUserCompanySearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.userCode = '' ;
	}
}
/* ds.rest.security.RestUserRoleBean */
export class RestUserRoleBean {
	constructor() {
		this.userCode = '' ;
		this.roleCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.rest.security.RestUserRolePageListBean */
export class RestUserRolePageListBean {
	constructor() {
		this.userRoles = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.rest.security.RestUserRoleSearchCriteria */
export class RestUserRoleSearchCriteria {
	constructor() {
		this.roleCode = '' ;
		this.userCode = '' ;
	}
}
/* ds.SecureLoginBean */
export class SecureLoginBean {
	constructor() {
		this.userCode = '' ;
		this.password = '' ;
		this.encryptionType = 0 ;
	}
}
/* ds.security.AttributeModuleEntityCompanyBean */
export class AttributeModuleEntityCompanyBean {
	constructor() {
		this.companyCode = '' ;
		this.entityModuleCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.security.AttributeModuleEntityCompanyPageListBean */
export class AttributeModuleEntityCompanyPageListBean {
	constructor() {
		this.attributeModuleEntityCompanies = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.security.AttributeModuleEntityCompanySearchCriteria */
export class AttributeModuleEntityCompanySearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.entityModuleCode = '' ;
	}
}
/* ds.security.EntitlementBean */
export class EntitlementBean {
	constructor() {
		this.accessRule = 0 ;
		this.shortName = '' ;
		this.displayOrder = 0 ;
		this.moduleEntityCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.security.EntitlementPageListBean */
export class EntitlementPageListBean {
	constructor() {
		this.entitlements = new Array() ;
		this.entitlementsCount = 0 ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.security.ModuleEntityBean */
export class ModuleEntityBean {
	constructor() {
		this.isAttribute = false ;
		this.isSystemEntity = false ;
		this.moduleGroupCode = '' ;
		this.moduleSubGroupCode = '' ;
		this.displayOrder = 0 ;
		this.menuLevel1 = '' ;
		this.menuLevel2 = '' ;
		this.entityEntitlements = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.security.ModuleEntityEntitlementBean */
export class ModuleEntityEntitlementBean {
	constructor() {
		this.entityModuleCode = '' ;
		this.entitlementCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.security.ModuleEntityEntitlementPageListBean */
export class ModuleEntityEntitlementPageListBean {
	constructor() {
		this.moduleEntityEntitlements = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.security.ModuleEntityEntitlementSearchCriteria */
export class ModuleEntityEntitlementSearchCriteria {
	constructor() {
		this.entityModuleCode = '' ;
		this.entitlementCode = '' ;
	}
}
/* ds.security.ModuleEntityPageListBean */
export class ModuleEntityPageListBean {
	constructor() {
		this.moduleEntities = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.security.ModuleEntitySearchCriteria */
export class ModuleEntitySearchCriteria {
	constructor() {
		this.isAttribute = false ;
		this.isSystemEntity = false ;
	}
}
/* ds.security.ModuleGroupBean */
export class ModuleGroupBean {
	constructor() {
		this.moduleSubGroups = new Array() ;
		this.moduleEntities = new Array() ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.security.ModuleGroupEntityBean */
export class ModuleGroupEntityBean {
	constructor() {
		this.moduleGroupCode = '' ;
		this.moduleEntityCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.security.ModuleSubGroupBean */
export class ModuleSubGroupBean {
	constructor() {
		this.moduleGroupCode = '' ;
		this.moduleSubGroupCode = '' ;
		this.displayOrder = 0 ;
		this.moduleEntities = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.security.RoleBean */
export class RoleBean {
	constructor() {
		this.roleEntitlements = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.security.RoleEntitlementBean */
export class RoleEntitlementBean {
	constructor() {
		this.roleCode = '' ;
		this.entitlementCode = '' ;
		this.isAccessible = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.security.RoleEntitlementPageListBean */
export class RoleEntitlementPageListBean {
	constructor() {
		this.roleEntitlements = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.security.RoleEntitlementSearchCriteria */
export class RoleEntitlementSearchCriteria {
	constructor() {
		this.roleCode = '' ;
		this.entitlementCode = '' ;
		this.isAccessible = false ;
	}
}
/* ds.security.RolePageListBean */
export class RolePageListBean {
	constructor() {
		this.roles = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.security.RoleSearchCriteria */
export class RoleSearchCriteria {
	constructor() {
		this.roleCode = '' ;
		this.roleName = '' ;
	}
}
/* ds.security.UserCompanyBean */
export class UserCompanyBean {
	constructor() {
		this.userCode = '' ;
		this.companyCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.security.UserCompanyPageListBean */
export class UserCompanyPageListBean {
	constructor() {
		this.userCompanies = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.security.UserCompanySearchCriteria */
export class UserCompanySearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.userCode = '' ;
	}
}
/* ds.security.UserRoleBean */
export class UserRoleBean {
	constructor() {
		this.userCode = '' ;
		this.roleCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.security.UserRolePageListBean */
export class UserRolePageListBean {
	constructor() {
		this.userRoles = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.security.UserRoleSearchCriteria */
export class UserRoleSearchCriteria {
	constructor() {
		this.roleCode = '' ;
		this.userCode = '' ;
	}
}
/* ds.SMTPInfoBean */
export class SMTPInfoBean {
	constructor() {
		this.smtpHost = '' ;
		this.smtpAuthenticaionRequired = false ;
		this.smtpUserName = '' ;
		this.smtpPassword = '' ;
		this.smtpSSLRequired = false ;
		this.smtpTLSRequired = false ;
		this.smtpPort = '' ;
	}
}
/* ds.UserBean */
export class UserBean {
	constructor() {
		this.firstName = '' ;
		this.lastName = '' ;
		this.isUserGroup = false ;
		this.userGroupCode = '' ;
		this.address = null ;
		this.userRoles = new Array() ;
		this.companyCode = '' ;
		this.smtpUserName = '' ;
		this.smtpPassword = '' ;
		this.isDeviceUser = false ;
		this.portalUserFlag = false ;
		this.orderSystemUserFlag = false ;
		this.isDataPortalUser = false ;
		this.password = '' ;
		this.entityCode = '' ;
		this.loginType = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.UserPageListBean */
export class UserPageListBean {
	constructor() {
		this.users = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.UserSearchCriteria */
export class UserSearchCriteria {
	constructor() {
		this.userCode = '' ;
		this.userName = '' ;
		this.firstName = '' ;
		this.lastName = '' ;
		this.loginType = '' ;
		this.entityCode = '' ;
		this.isUserGroup = false ;
		this.userGroupCode = '' ;
		this.overrideIsUserGroup = false ;
		this.loginTypes = new Array() ;
	}
}
/* ds.accountpayable.AccountPayableBean */
export class AccountPayableBean {
	constructor() {
		this.companyCode = '' ;
		this.isManualEntry = false ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.address = null ;
		this.isPosted = false ;
		this.postDate = '' ;
		this.bankCode = '' ;
		this.bankName = '' ;
		this.checkNumber = '' ;
		this.checkDate = '' ;
		this.isCleared = false ;
		this.currencyCode = '' ;
		this.totalAmount = 0 ;
		this.comments = '' ;
		this.status = '' ;
		this.lines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.AccountPayableLineBean */
export class AccountPayableLineBean {
	constructor() {
		this.companyCode = '' ;
		this.accountPayableNumber = '' ;
		this.lineNumber = 0 ;
		this.purchaseOrderLineNumber = 0 ;
		this.purchaseOrderReceiptLineNumber = 0 ;
		this.invoiceNumber = '' ;
		this.invoiceDate = '' ;
		this.invoiceDueDate = '' ;
		this.invoiceGrandTotalAmount = 0 ;
		this.invoiceOpenAmount = 0 ;
		this.paidAmount = 0 ;
		this.netAmount = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.AccountPayableStatusTrackBean */
export class AccountPayableStatusTrackBean {
	constructor() {
		this.accountPayableNumber = '' ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.BankAdjustmentBean */
export class BankAdjustmentBean {
	constructor() {
		this.companyCode = '' ;
		this.adjustmentNumber = '' ;
		this.bankCode = '' ;
		this.reasonCode = '' ;
		this.status = '' ;
		this.adjustmentAmount = 0 ;
		this.currencyCode = '' ;
		this.statusTracks = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.BankAdjustmentStatusTrackBean */
export class BankAdjustmentStatusTrackBean {
	constructor() {
		this.adjustmentNumber = '' ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.BatchPrintCheckTransactionBean */
export class BatchPrintCheckTransactionBean {
	constructor() {
		this.companyCode = '' ;
		this.checkTransactionNumber = new Array() ;
	}
}
/* ds.accountpayable.CheckCancelLineBean */
export class CheckCancelLineBean {
	constructor() {
		this.companyCode = '' ;
		this.checkNumber = '' ;
		this.checkCancelProcessCode = '' ;
		this.lineNumber = 0 ;
		this.vendorInvoiceCode = '' ;
		this.invoiceAmount = 0 ;
		this.invoiceDate = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.CheckCancelProcessBean */
export class CheckCancelProcessBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.checkNumber = '' ;
		this.checkDate = '' ;
		this.issuedBankCode = '' ;
		this.issuedBankName = '' ;
		this.checkAmount = 0 ;
		this.vendorName = '' ;
		this.status = '' ;
		this.comments = '' ;
		this.accountPayableNumber = '' ;
		this.checkCancelLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.CheckDataBean */
export class CheckDataBean {
	constructor() {
		this.companyCode = '' ;
		this.checkReferenceNumber = '' ;
		this.payeeCode = '' ;
		this.payeeName = '' ;
		this.accountNumber = '' ;
		this.checkAmount = 0 ;
		this.checkNumber = '' ;
		this.checkRoutingNumber = '' ;
		this.checkDate = '' ;
		this.bankName = '' ;
		this.bankAddress = '' ;
		this.sourceEntityType = '' ;
		this.sourceEntityCode = '' ;
		this.checkSourceDetails = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.CheckPrintHistoryBean */
export class CheckPrintHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.checkTransactionNumber = '' ;
		this.printDate = '' ;
		this.checkNumber = '' ;
		this.currencyCode = '' ;
		this.checkAmount = 0 ;
		this.remarks = '' ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.CheckSourceDetailBean */
export class CheckSourceDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.checkReferenceNumber = '' ;
		this.lineNumber = 0 ;
		this.sourceEntityCode = '' ;
		this.sourceEntityType = '' ;
		this.sourceEntityDate = '' ;
		this.sourceEntityReferenceNumber = '' ;
		this.sourceAmount = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.CheckTransactionAppliedDebitMemoLineBean */
export class CheckTransactionAppliedDebitMemoLineBean {
	constructor() {
		this.companyCode = '' ;
		this.checkTransactionNumber = '' ;
		this.debitMemoNumber = '' ;
		this.debitMemoAmount = 0 ;
		this.debitMemoAppliedAmount = 0 ;
		this.standardDebitMemoAmount = 0 ;
		this.standardDebitMemoAppliedAmount = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.CheckTransactionBean */
export class CheckTransactionBean {
	constructor() {
		this.companyCode = '' ;
		this.isManualEntry = false ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.address = null ;
		this.isPosted = false ;
		this.postDate = '' ;
		this.bankCode = '' ;
		this.bankName = '' ;
		this.checkNumber = '' ;
		this.checkDate = '' ;
		this.isCleared = false ;
		this.currencyCode = '' ;
		this.totalAmount = 0 ;
		this.comments = '' ;
		this.status = '' ;
		this.wireTransferInformation = '' ;
		this.wireTransferReferenceNumber = '' ;
		this.wireTransferDate = '' ;
		this.expenseType = '' ;
		this.memoText = '' ;
		this.transactionType = '' ;
		this.bankCurrencyCode = '' ;
		this.adjustedExchangeRate = 0 ;
		this.actualExchangeRate = 0 ;
		this.standardTotalAmount = 0 ;
		this.taxPercentage = 0 ;
		this.taxAmount = 0 ;
		this.cardNumber = '' ;
		this.cardAmount = 0 ;
		this.cardType = '' ;
		this.expiryMonth = '' ;
		this.expiryYear = '' ;
		this.entryDate = '' ;
		this.debitMemoAmount = 0 ;
		this.invoiceLines = new Array() ;
		this.letterOfCreditLines = new Array() ;
		this.glAppliedAmounts = new Array() ;
		this.printHistories = new Array() ;
		this.statusTracks = new Array() ;
		this.paymentLines = new Array() ;
		this.appliedDebitMemoLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.CheckTransactionGLAccountAppliedAmountBean */
export class CheckTransactionGLAccountAppliedAmountBean {
	constructor() {
		this.companyCode = '' ;
		this.checkTransactionNumber = '' ;
		this.glAccountNumber = '' ;
		this.AppliedAmount = 0 ;
		this.currencyCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.CheckTransactionInvoiceLineBean */
export class CheckTransactionInvoiceLineBean {
	constructor() {
		this.companyCode = '' ;
		this.checkTransactionNumber = '' ;
		this.lineNumber = 0 ;
		this.purchaseOrderLineNumber = 0 ;
		this.purchaseOrderReceiptLineNumber = 0 ;
		this.invoiceNumber = '' ;
		this.invoiceDescription = '' ;
		this.invoiceDate = '' ;
		this.invoiceDueDate = '' ;
		this.invoiceGrandTotalAmount = 0 ;
		this.invoiceDiscountAmount = 0 ;
		this.invoiceOpenAmount = 0 ;
		this.invoiceLinePaidAmount = 0 ;
		this.isManualInvoiceFlag = false ;
		this.expenseType = '' ;
		this.expenseSubType = '' ;
		this.currencyCode = '' ;
		this.debitMemoNumber = '' ;
		this.debitMemoAppliedAmount = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.CheckTransactionLetterOfCreditLineBean */
export class CheckTransactionLetterOfCreditLineBean {
	constructor() {
		this.companyCode = '' ;
		this.checkTransactionNumber = '' ;
		this.lineNumber = 0 ;
		this.bankCode = '' ;
		this.bankName = '' ;
		this.letterOfCreditNumber = '' ;
		this.letterOfCreditDate = '' ;
		this.letterOfCreditAmount = 0 ;
		this.transactionInformation = '' ;
		this.expenseType = '' ;
		this.expenseSubType = '' ;
		this.currencyCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.CheckTransactionPaymentDetailBean */
export class CheckTransactionPaymentDetailBean {
	constructor() {
		this.checkTransactionNumber = '' ;
		this.companyCode = '' ;
		this.lineNumber = 0 ;
		this.vendorInvoiceNumber = '' ;
		this.paymentType = '' ;
		this.paymentAmount = 0 ;
		this.currencyCode = '' ;
		this.documentNumber = '' ;
		this.isApplied = false ;
		this.isCancelled = false ;
		this.paymentDate = '' ;
		this.paymentPostDate = '' ;
		this.cancelledDate = '' ;
		this.cancelledByEntityType = 0 ;
		this.cancelledByEntityNumber = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.CheckTransactionPrintResultBean */
export class CheckTransactionPrintResultBean {
	constructor() {
		this.checkTransaction = null ;
		this.reportResult = null ;
		this.resultText = '' ;
	}
}
/* ds.accountpayable.CheckTransactionStatusTrackBean */
export class CheckTransactionStatusTrackBean {
	constructor() {
		this.checkTransactionNumber = '' ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.criteria.AccountPayableSearchCriteria */
export class AccountPayableSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.accountPayableNumber = '' ;
		this.accountPayableDate = '' ;
		this.vendorCode = '' ;
		this.accountPayableStatus = '' ;
		this.checkNumber = '' ;
		this.accountPayableNumberContains = '' ;
		this.accountPayableNumberStartsWith = '' ;
	}
}
/* ds.accountpayable.criteria.BankAdjustmentSearchCriteria */
export class BankAdjustmentSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.adjustmentNumber = '' ;
		this.status = '' ;
		this.adjustmentNumberContains = '' ;
		this.adjustmentNumberStartsWith = '' ;
	}
}
/* ds.accountpayable.criteria.CheckCancelProcessSearchCriteria */
export class CheckCancelProcessSearchCriteria {
	constructor() {
	}
}
/* ds.accountpayable.criteria.CheckDataCriteriaBean */
export class CheckDataCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.payeeCode = '' ;
		this.sourceEntityType = '' ;
		this.vendorInvoiceCode = '' ;
		this.vendorInvoiceReferenceNumber = '' ;
	}
}
/* ds.accountpayable.criteria.CheckTransactionSearchCriteria */
export class CheckTransactionSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.checkTransactionNumber = '' ;
		this.checkPrintDate = '' ;
		this.vendorCode = '' ;
		this.checkTransactionStatus = '' ;
		this.checkNumber = '' ;
		this.checkTransactionNumberContains = '' ;
		this.checkTransactionNumberStartsWith = '' ;
		this.bankCode = '' ;
		this.bankName = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.vendorCodeList = new Array() ;
		this.checkTransactionNumberList = new Array() ;
	}
}
/* ds.accountpayable.criteria.DepositSearchCriteria */
export class DepositSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.depositNumber = '' ;
		this.depositDate = '' ;
		this.status = '' ;
		this.depositNumberContains = '' ;
		this.depositNumberStartsWith = '' ;
		this.bankCode = '' ;
	}
}
/* ds.accountpayable.criteria.LetterOfCreditSearchCriteria */
export class LetterOfCreditSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.letterOfCreditNumber = '' ;
		this.letterOfCreditDate = '' ;
		this.vendorCode = '' ;
		this.letterOfCreditNumberContains = '' ;
		this.letterOfCreditNumberStartsWith = '' ;
	}
}
/* ds.accountpayable.criteria.UnDepositedAccountReceivableDetailCriteriaBean */
export class UnDepositedAccountReceivableDetailCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.paymentTypes = '' ;
		this.startPostDate = '' ;
		this.stopPostDate = '' ;
	}
}
/* ds.accountpayable.DepositBean */
export class DepositBean {
	constructor() {
		this.companyCode = '' ;
		this.depositNumber = '' ;
		this.bankCode = '' ;
		this.paymentTypes = '' ;
		this.paymentTypesName = '' ;
		this.status = '' ;
		this.remarks = '' ;
		this.depositTotalAmount = 0 ;
		this.currencyCode = '' ;
		this.depositBankReferenceNumber = '' ;
		this.postStartDate = '' ;
		this.postStopDate = '' ;
		this.depositDate = '' ;
		this.depositLines = new Array() ;
		this.statusTracks = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.DepositLineBean */
export class DepositLineBean {
	constructor() {
		this.companyCode = '' ;
		this.depositNumber = '' ;
		this.lineNumber = 0 ;
		this.paymentType = 0 ;
		this.arNumber = '' ;
		this.arDate = '' ;
		this.depositAmount = 0 ;
		this.customerName = '' ;
		this.paymentTypeName = '' ;
		this.customerCode = '' ;
		this.totalTenderAmount = 0 ;
		this.postingDate = '' ;
		this.paymentDocumentNumber = '' ;
		this.paymentDocumentDate = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.DepositStatusTrackBean */
export class DepositStatusTrackBean {
	constructor() {
		this.depositNumber = '' ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.LetterOfCreditBean */
export class LetterOfCreditBean {
	constructor() {
		this.companyCode = '' ;
		this.letterOfCreditNumber = '' ;
		this.bankCode = '' ;
		this.bankName = '' ;
		this.letterOfCreditDate = '' ;
		this.letterOfCreditAmount = 0 ;
		this.transactionInformation = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.vendorBankAddress = '' ;
		this.status = '' ;
		this.isApproved = false ;
		this.creditDetails = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.LetterOfCreditDetailBean */
export class LetterOfCreditDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.letterOfCreditNumber = '' ;
		this.lineNumber = 0 ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderStartDate = '' ;
		this.purchaseOrderEndDate = '' ;
		this.purchaseOrderAmount = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountpayable.merge.response.AccountPayableModuleMergeResponseBean */
export class AccountPayableModuleMergeResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.lockResponse = null ;
		this.additionalOperationResponse = null ;
		this.printReportResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountpayable.merge.response.BankAdjustmentModuleMergeResponseBean */
export class BankAdjustmentModuleMergeResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.lockResponse = null ;
		this.additionalOperationResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountpayable.merge.response.CheckCancelProcessMergeOperationsResponseBean */
export class CheckCancelProcessMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.lockResponse = null ;
		this.additionalOperationResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountpayable.merge.response.CheckTransactionModuleMergeResponseBean */
export class CheckTransactionModuleMergeResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.lockResponse = null ;
		this.additionalOperationResponse = null ;
		this.printReportResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountpayable.merge.response.DepositModuleMergeResponseBean */
export class DepositModuleMergeResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.lockResponse = null ;
		this.additionalOperationResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountpayable.merge.response.LetterOfCreditModuleMergeResponseBean */
export class LetterOfCreditModuleMergeResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.lockResponse = null ;
		this.additionalOperationResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountpayable.pagelist.AccountPayablePageListBean */
export class AccountPayablePageListBean {
	constructor() {
		this.accountPayables = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.accountpayable.pagelist.BankAdjustmentPageListBean */
export class BankAdjustmentPageListBean {
	constructor() {
		this.bankAdjustments = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.accountpayable.pagelist.CheckCancelProcessPageListBean */
export class CheckCancelProcessPageListBean {
	constructor() {
		this.checkCancelProcesses = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.accountpayable.pagelist.CheckDataPageListBean */
export class CheckDataPageListBean {
	constructor() {
		this.checkList = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.accountpayable.pagelist.CheckTransactionPageListBean */
export class CheckTransactionPageListBean {
	constructor() {
		this.checkTransactions = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.accountpayable.pagelist.CheckTransactionPaymentDetailPageListBean */
export class CheckTransactionPaymentDetailPageListBean {
	constructor() {
		this.checkTransactionPaymentDetails = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.accountpayable.pagelist.DepositPageListBean */
export class DepositPageListBean {
	constructor() {
		this.deposits = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.accountpayable.pagelist.LetterOfCreditPageListBean */
export class LetterOfCreditPageListBean {
	constructor() {
		this.letterOfCredits = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.accountpayable.pagelist.response.AccountPayablePageListResponseBean */
export class AccountPayablePageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountpayable.pagelist.response.BankAdjustmentPageListResponseBean */
export class BankAdjustmentPageListResponseBean {
	constructor() {
		this.bankAdjustmentPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountpayable.pagelist.response.CheckCancelProcessPageListResponseBean */
export class CheckCancelProcessPageListResponseBean {
	constructor() {
		this.checkCancelProcessPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountpayable.pagelist.response.CheckDataPageListResponseBean */
export class CheckDataPageListResponseBean {
	constructor() {
		this.checkPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountpayable.pagelist.response.CheckTransactionPageListResponseBean */
export class CheckTransactionPageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountpayable.pagelist.response.CheckTransactionPaymentDetailPageListResponseBean */
export class CheckTransactionPaymentDetailPageListResponseBean {
	constructor() {
		this.checkTransactionPaymentDetailPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountpayable.pagelist.response.DepositPageListResponseBean */
export class DepositPageListResponseBean {
	constructor() {
		this.depositPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountpayable.pagelist.response.LetterOfCreditPageListResponseBean */
export class LetterOfCreditPageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountpayable.response.AccountPayableResponseBean */
export class AccountPayableResponseBean {
	constructor() {
		this.accountPayable = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountpayable.response.BankAdjustmentResponseBean */
export class BankAdjustmentResponseBean {
	constructor() {
		this.bankAdjustmentBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountpayable.response.CheckCancelProcessResponseBean */
export class CheckCancelProcessResponseBean {
	constructor() {
		this.checkCancelProcess = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountpayable.response.CheckTransactionPrintResponseBean */
export class CheckTransactionPrintResponseBean {
	constructor() {
		this.checkTransactionPrintResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountpayable.response.CheckTransactionResponseBean */
export class CheckTransactionResponseBean {
	constructor() {
		this.checkTransaction = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountpayable.response.CheckTransactionsBatchPrintResponseBean */
export class CheckTransactionsBatchPrintResponseBean {
	constructor() {
		this.checkTransactionPrintResults = new Array() ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountpayable.response.DepositResponseBean */
export class DepositResponseBean {
	constructor() {
		this.depositBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountpayable.response.LetterOfCreditResponseBean */
export class LetterOfCreditResponseBean {
	constructor() {
		this.letterOfCreditBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.AccountReceivableApplicableCreditMemoBean */
export class AccountReceivableApplicableCreditMemoBean {
	constructor() {
		this.accountReceivableNumber = '' ;
		this.companyCode = '' ;
		this.creditMemoNumber = '' ;
		this.currencyCode = '' ;
		this.creditmemoCreatedDate = '' ;
		this.creditMemoAmount = 0 ;
		this.creditMemoAppliedAmount = 0 ;
		this.creditMemoProvisionalAppliedAmount = 0 ;
		this.applicableAmount = 0 ;
		this.selectedFlag = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.AccountReceivableApplicableInvoiceBean */
export class AccountReceivableApplicableInvoiceBean {
	constructor() {
		this.accountReceivableNumber = '' ;
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.currencyCode = '' ;
		this.invoiceCreatedDate = '' ;
		this.invoiceGrandTotalAmount = 0 ;
		this.invoicePaidAmount = 0 ;
		this.invoiceProvisionalPaymentAmount = 0 ;
		this.applicableAmount = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.AccountReceivableAppliedCreditMemoLineBean */
export class AccountReceivableAppliedCreditMemoLineBean {
	constructor() {
		this.companyCode = '' ;
		this.accountReceivableNumber = '' ;
		this.creditMemoNumber = '' ;
		this.creditMemoAmount = 0 ;
		this.creditMemoAppliedAmount = 0 ;
		this.standardCreditMemoAmount = 0 ;
		this.standardCreditMemoAppliedAmount = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.AccountReceivableAutoClearingHouseDetailBean */
export class AccountReceivableAutoClearingHouseDetailBean {
	constructor() {
		this.accountReceivableNumber = '' ;
		this.companyCode = '' ;
		this.lineNumber = 0 ;
		this.autoClearingHouseReferenceNumber = '' ;
		this.autoClearingHouseAmount = 0 ;
		this.currencyCode = '' ;
		this.autoClearingHouseDate = '' ;
		this.comments = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.AccountReceivableBean */
export class AccountReceivableBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.billToCode = '' ;
		this.accountReceivableDate = '' ;
		this.accountReceivableStatus = '' ;
		this.customerCurrencyCode = '' ;
		this.companyCurrencyCode = '' ;
		this.totalReceivedAmount = 0 ;
		this.checkAmount = 0 ;
		this.cardAmount = 0 ;
		this.cashAmount = 0 ;
		this.wireTransferAmount = 0 ;
		this.autoClearingHouseAmount = 0 ;
		this.createdSourceType = 0 ;
		this.createdSourceEntityNumber = '' ;
		this.isWarningAcceptedForCreditMemo = false ;
		this.overPaymentCreditMemoNumber = '' ;
		this.depositReferenceNumber = '' ;
		this.isDeposited = false ;
		this.reversalReasonCode = '' ;
		this.reversalReasonRemarks = '' ;
		this.paymentTypeCode = '' ;
		this.applicableInvoices = new Array() ;
		this.applicableCreditMemos = new Array() ;
		this.lines = new Array() ;
		this.paymentLines = new Array() ;
		this.checkDetailLines = new Array() ;
		this.wireTransferDetailLines = new Array() ;
		this.autoClearingHouseDetailLines = new Array() ;
		this.cardDetailLines = new Array() ;
		this.statusTracks = new Array() ;
		this.appliedCreditMemoLines = new Array() ;
		this.discountDetails = new Array() ;
		this.comments = '' ;
		this.checkNumber = '' ;
		this.WireNumber = '' ;
		this.cardNumber = '' ;
		this.achNumber = '' ;
		this.discountAmount = 0 ;
		this.checkBouncedARNumber = '' ;
		this.originalARNumber = '' ;
		this.postDatedCheckEntryNumber = '' ;
		this.remainingApplicableAmount = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.AccountReceivableBeanInputBean */
export class AccountReceivableBeanInputBean {
	constructor() {
		this.accountReceivableCount = 0 ;
		this.accountReceivables = new Array() ;
	}
}
/* ds.accountreceivable.AccountReceivableCardDetailBean */
export class AccountReceivableCardDetailBean {
	constructor() {
		this.accountReceivableNumber = '' ;
		this.companyCode = '' ;
		this.lineNumber = 0 ;
		this.cardNumber = '' ;
		this.cardAmount = 0 ;
		this.currencyCode = '' ;
		this.cardType = '' ;
		this.expiryMonth = '' ;
		this.expiryYear = '' ;
		this.cardTransactionGatewayName = '' ;
		this.cardTransactionReferenceNumber = '' ;
		this.cvv = '' ;
		this.isPaymentProcessRequired = false ;
		this.isDebitCard = false ;
		this.cardHolderFirstName = '' ;
		this.cardHolderLastName = '' ;
		this.cardIssuedDate = '' ;
		this.comments = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.AccountReceivableCheckDetailBean */
export class AccountReceivableCheckDetailBean {
	constructor() {
		this.accountReceivableNumber = '' ;
		this.companyCode = '' ;
		this.lineNumber = 0 ;
		this.checkNumber = '' ;
		this.checkAmount = 0 ;
		this.currencyCode = '' ;
		this.checkDate = '' ;
		this.issuedBankName = '' ;
		this.issuedBankAddress = '' ;
		this.issuerAccountNumber = '' ;
		this.comments = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.AccountReceivableCreateResultBean */
export class AccountReceivableCreateResultBean {
	constructor() {
		this.accountReceivable = null ;
		this.creditMemos = new Array() ;
	}
}
/* ds.accountreceivable.AccountReceivableDiscountDetailBean */
export class AccountReceivableDiscountDetailBean {
	constructor() {
		this.accountReceivableNumber = '' ;
		this.companyCode = '' ;
		this.lineNumber = 0 ;
		this.discountDetailReasonCode = '' ;
		this.discountDetailReasonName = '' ;
		this.invoiceNumber = '' ;
		this.discountAmount = 0 ;
		this.currencyCode = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.AccountReceivableLineBean */
export class AccountReceivableLineBean {
	constructor() {
		this.accountReceivableNumber = '' ;
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.currencyCode = '' ;
		this.openInvoiceAmount = 0 ;
		this.appliedAmount = 0 ;
		this.chargeBackAppliedAmount = 0 ;
		this.creditMemoAppliedAmount = 0 ;
		this.totalAppliedAmount = 0 ;
		this.isDiscountAmountApplied = false ;
		this.invoiceDate = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.standardOpenInvoiceAmount = 0 ;
		this.standardAppliedAmount = 0 ;
		this.standardChargeBackAppliedAmount = 0 ;
		this.standardCreditMemoAppliedAmount = 0 ;
		this.standardTotalAppliedAmount = 0 ;
		this.currencyExchangeRate = 0 ;
		this.cashAppliedAmount = 0 ;
		this.creditAppliedAmount = 0 ;
		this.isPaymentReceivedFlag = false ;
		this.selectedFlag = false ;
		this.creditMemoFlag = false ;
		this.customerCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.AccountReceivablePaymentDetailBean */
export class AccountReceivablePaymentDetailBean {
	constructor() {
		this.accountReceivableNumber = '' ;
		this.companyCode = '' ;
		this.lineNumber = 0 ;
		this.invoiceNumber = '' ;
		this.paymentType = 0 ;
		this.paymentAmount = 0 ;
		this.currencyCode = '' ;
		this.documentNumber = '' ;
		this.isApplied = false ;
		this.isCancelled = false ;
		this.paymentDate = '' ;
		this.paymentPostDate = '' ;
		this.cancelledDate = '' ;
		this.cancelledByEntityType = 0 ;
		this.cancelledByEntityNumber = '' ;
		this.cardTransactionReferenceNumber = '' ;
		this.customerCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.AccountReceivableStatusTrackBean */
export class AccountReceivableStatusTrackBean {
	constructor() {
		this.accountReceivableNumber = '' ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.AccountReceivableWireTransferDetailBean */
export class AccountReceivableWireTransferDetailBean {
	constructor() {
		this.accountReceivableNumber = '' ;
		this.companyCode = '' ;
		this.lineNumber = 0 ;
		this.wireTransferReferenceNumber = '' ;
		this.wireTransferAmount = 0 ;
		this.currencyCode = '' ;
		this.wireTransferDate = '' ;
		this.issuedBankName = '' ;
		this.issuedBankAddress = '' ;
		this.issuerAccountNumber = '' ;
		this.comments = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.CheckBounceDetailsBean */
export class CheckBounceDetailsBean {
	constructor() {
		this.accountReceivableBean = null ;
		this.checkDetailBean = null ;
		this.receivableLines = new Array() ;
		this.applicableInvoices = new Array() ;
		this.creditMemos = null ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.CheckBounceLinesBean */
export class CheckBounceLinesBean {
	constructor() {
		this.companyCode = '' ;
		this.checkNumber = '' ;
		this.customerCode = '' ;
		this.invoiceNumber = '' ;
		this.invoiceAmount = 0 ;
		this.invoiceDate = '' ;
		this.arCode = '' ;
		this.arDate = '' ;
		this.checkBounceProcessCode = '' ;
		this.lineNumber = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.CheckBounceProcessBean */
export class CheckBounceProcessBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.checkNumber = '' ;
		this.status = '' ;
		this.comments = '' ;
		this.billToCode = '' ;
		this.checkDate = '' ;
		this.issuedBankName = '' ;
		this.checkAmount = 0 ;
		this.checkBounceDate = '' ;
		this.checkBounceLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.CreateCheckBounceResult */
export class CreateCheckBounceResult {
	constructor() {
		this.checkBounceProcessBean = null ;
		this.invoice = null ;
		this.errorInfoMessage = '' ;
	}
}
/* ds.accountreceivable.criteria.AccountReceivableSearchCriteria */
export class AccountReceivableSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.accountReceivableNumber = '' ;
		this.customerCode = '' ;
		this.accountReceivableStatus = '' ;
		this.checkNumber = '' ;
		this.wireTransferNumber = '' ;
		this.cardNumber = '' ;
		this.achNumber = '' ;
		this.createdDate = '' ;
		this.accountReceivbaleDate = '' ;
		this.accountReceivableNumberContains = '' ;
		this.accountReceivableNumberStartsWith = '' ;
		this.totalReceivedAmount = 0 ;
		this.fromTotalReceivedAmount = 0 ;
		this.toTotalReceivedAmount = 0 ;
	}
}
/* ds.accountreceivable.criteria.CheckBounceProcessSearchCriteria */
export class CheckBounceProcessSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.checkBounceProcessNumber = '' ;
		this.customerCode = '' ;
		this.checkNumber = '' ;
		this.createdDate = '' ;
		this.checkBounceProcessNumberContains = '' ;
		this.checkBounceProcessNumberStartsWith = '' ;
		this.status = '' ;
	}
}
/* ds.accountreceivable.criteria.CustomerTenderSearchCriteria */
export class CustomerTenderSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerTenderNumber = '' ;
		this.customerCode = '' ;
		this.customerTenderStatus = '' ;
		this.checkNumber = '' ;
		this.createdDate = '' ;
		this.customerTenderNumberContains = '' ;
		this.customerTenderNumberStartsWith = '' ;
	}
}
/* ds.accountreceivable.criteria.PostDatedCheckEntrySearchCriteria */
export class PostDatedCheckEntrySearchCriteria {
	constructor() {
		this.postDatedCheckEntryNumber = '' ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.status = '' ;
		this.checkNumber = '' ;
		this.createdDate = '' ;
	}
}
/* ds.accountreceivable.CustomerTenderAmountCardDetailBean */
export class CustomerTenderAmountCardDetailBean {
	constructor() {
		this.customerTenderNumber = '' ;
		this.companyCode = '' ;
		this.lineNumber = 0 ;
		this.cardNumber = '' ;
		this.cardAmount = 0 ;
		this.currencyCode = '' ;
		this.cardType = '' ;
		this.expiryMonth = '' ;
		this.expiryYear = '' ;
		this.cardTransactionGatewayName = '' ;
		this.cardTransactionReferenceNumber = '' ;
		this.isPaymentProcessRequired = false ;
		this.isDebitCard = false ;
		this.cardHolderFirstName = '' ;
		this.cardHolderLastName = '' ;
		this.cardIssuedDate = '' ;
		this.comments = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.CustomerTenderAmountCheckDetailBean */
export class CustomerTenderAmountCheckDetailBean {
	constructor() {
		this.customerTenderNumber = '' ;
		this.companyCode = '' ;
		this.lineNumber = 0 ;
		this.checkNumber = '' ;
		this.checkAmount = 0 ;
		this.currencyCode = '' ;
		this.checkDate = '' ;
		this.issuedBankName = '' ;
		this.issuedBankAddress = '' ;
		this.issuerAccountNumber = '' ;
		this.comments = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.CustomerTenderAmountStatusTrackBean */
export class CustomerTenderAmountStatusTrackBean {
	constructor() {
		this.customerTenderNumber = '' ;
		this.totalTenderAmount = 0 ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.CustomerTenderAmountWireTransferDetailBean */
export class CustomerTenderAmountWireTransferDetailBean {
	constructor() {
		this.customerTenderNumber = '' ;
		this.companyCode = '' ;
		this.lineNumber = 0 ;
		this.wireTransferReferenceNumber = '' ;
		this.wireTransferAmount = 0 ;
		this.currencyCode = '' ;
		this.wireTransferDate = '' ;
		this.issuedBankName = '' ;
		this.issuedBankAddress = '' ;
		this.issuerAccountNumber = '' ;
		this.comments = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.CustomerTenderBean */
export class CustomerTenderBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerTenderStatus = '' ;
		this.billToCode = '' ;
		this.customerTenderDetails = '' ;
		this.totalReceivedAmount = 0 ;
		this.customerCurrencyCode = '' ;
		this.companyCurrencyCode = '' ;
		this.checkAmount = 0 ;
		this.cardAmount = 0 ;
		this.cashAmount = 0 ;
		this.wireTransferAmount = 0 ;
		this.appliedAmount = 0 ;
		this.openAmount = 0 ;
		this.notes = '' ;
		this.reasonCode = '' ;
		this.tenderType = 0 ;
		this.provisionalAppliedAmount = 0 ;
		this.createdSourceEntityNumber = '' ;
		this.createdSourceEntityType = '' ;
		this.cardDetailBean = new Array() ;
		this.checkDetailBean = new Array() ;
		this.wireTransferDetailBean = new Array() ;
		this.statusTrackBean = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.CustomerTenderCreateResultBean */
export class CustomerTenderCreateResultBean {
	constructor() {
		this.customerTender = null ;
	}
}
/* ds.accountreceivable.deps.AccountReceivableModuleDependenciesBean */
export class AccountReceivableModuleDependenciesBean {
	constructor() {
		this.customer = null ;
	}
}
/* ds.accountreceivable.deps.CustomerTenderModuleDependenciesBean */
export class CustomerTenderModuleDependenciesBean {
	constructor() {
		this.customer = null ;
	}
}
/* ds.accountreceivable.deps.PostDatedCheckEntryModuleDependenciesBean */
export class PostDatedCheckEntryModuleDependenciesBean {
	constructor() {
		this.customer = null ;
	}
}
/* ds.accountreceivable.deps.response.AccountReceivableModuleDependenciesResponseBean */
export class AccountReceivableModuleDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.deps.response.CustomerTenderModuleDependenciesResponseBean */
export class CustomerTenderModuleDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.deps.response.PostDatedCheckEntryModuleDependenciesResponseBean */
export class PostDatedCheckEntryModuleDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.merge.response.AccountReceivableCreateMergeOperationsResponseBean */
export class AccountReceivableCreateMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.lockResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.merge.response.AccountReceivableDependenciesOfCustomerMergeResponseBean */
export class AccountReceivableDependenciesOfCustomerMergeResponseBean {
	constructor() {
		this.customerResponse = null ;
		this.customerBillToResponse = null ;
		this.customerShipToResponse = null ;
		this.openInvoicesResponse = null ;
		this.openCreditMemosResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.merge.response.AccountReceivableMergeOperationsResponseBean */
export class AccountReceivableMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.lockResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.merge.response.AccountReceivableModuleMergeResponseBean */
export class AccountReceivableModuleMergeResponseBean {
	constructor() {
		this.accountReceivableResponse = null ;
		this.lockResponse = null ;
		this.dependenciesResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.merge.response.CheckBounceProcessMergeOperationsResponseBean */
export class CheckBounceProcessMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.lockResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.merge.response.CustomerTenderCreateMergeOperationsResponseBean */
export class CustomerTenderCreateMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.lockResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.merge.response.CustomerTenderMergeOperationsResponseBean */
export class CustomerTenderMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.lockResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.merge.response.CustomerTenderModuleMergeResponseBean */
export class CustomerTenderModuleMergeResponseBean {
	constructor() {
		this.customerTenderResponse = null ;
		this.lockResponse = null ;
		this.dependenciesResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.merge.response.PostDatedCheckMergeOperationsResponseBean */
export class PostDatedCheckMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.lockResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.merge.response.PostDatedCheckModuleMergeResponseBean */
export class PostDatedCheckModuleMergeResponseBean {
	constructor() {
		this.postDatedCheckResponse = null ;
		this.lockResponse = null ;
		this.postDatedDependenciesResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.pagelist.AccountReceivableCheckDetailPageListBean */
export class AccountReceivableCheckDetailPageListBean {
	constructor() {
		this.accountReceivableCheckDetails = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.accountreceivable.pagelist.AccountReceivablePageListBean */
export class AccountReceivablePageListBean {
	constructor() {
		this.accountReceivables = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.accountreceivable.pagelist.AccountReceivablePaymentDetailPageListBean */
export class AccountReceivablePaymentDetailPageListBean {
	constructor() {
		this.accountReceivablePaymentDetails = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.accountreceivable.pagelist.CheckBounceProcessPageListBean */
export class CheckBounceProcessPageListBean {
	constructor() {
		this.checkBounceProcesses = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.accountreceivable.pagelist.CustomerTenderPageListBean */
export class CustomerTenderPageListBean {
	constructor() {
		this.customerTender = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.accountreceivable.pagelist.PostDatedCheckEntryPageListBean */
export class PostDatedCheckEntryPageListBean {
	constructor() {
		this.postDatedChecks = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.accountreceivable.pagelist.response.AccountReceivableCheckDetailPageListResponseBean */
export class AccountReceivableCheckDetailPageListResponseBean {
	constructor() {
		this.accountReceivableCheckDetailPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.pagelist.response.AccountReceivablePageListResponseBean */
export class AccountReceivablePageListResponseBean {
	constructor() {
		this.accountReceivablePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.pagelist.response.AccountReceivablePaymentDetailPageListResponseBean */
export class AccountReceivablePaymentDetailPageListResponseBean {
	constructor() {
		this.accountReceivablePaymentDetailPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.pagelist.response.CheckBounceProcessPageListResponseBean */
export class CheckBounceProcessPageListResponseBean {
	constructor() {
		this.checkBounceProcessPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.pagelist.response.CustomerTenderPageListResponseBean */
export class CustomerTenderPageListResponseBean {
	constructor() {
		this.customerTendersPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.pagelist.response.PostDatedCheckEntryPageListResponseBean */
export class PostDatedCheckEntryPageListResponseBean {
	constructor() {
		this.postDatedCheckPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.PostDatedCheckEntryBean */
export class PostDatedCheckEntryBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.checkNumber = '' ;
		this.status = '' ;
		this.currencyCode = '' ;
		this.checkDate = '' ;
		this.checkAmount = 0 ;
		this.miscChargeAmount = 0 ;
		this.cancelDate = '' ;
		this.cancelReasonCode = '' ;
		this.cancelReasonDescription = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.invoiceNumber = '' ;
		this.bankName = '' ;
		this.remarks = '' ;
		this.appliedAmount = 0 ;
		this.statusTrackBean = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.PostDatedCheckEntryStatusTrackBean */
export class PostDatedCheckEntryStatusTrackBean {
	constructor() {
		this.postDatedCheckEntryNumber = '' ;
		this.checkAmount = 0 ;
		this.currencyCode = '' ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.accountreceivable.response.AccountReceivableCreateResultResponseBean */
export class AccountReceivableCreateResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.response.AccountReceivableInputResponseBean */
export class AccountReceivableInputResponseBean {
	constructor() {
		this.accountReceivableInputBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.response.AccountReceivableResponseBean */
export class AccountReceivableResponseBean {
	constructor() {
		this.accountReceivable = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.response.CheckBounceDetailsResponseBean */
export class CheckBounceDetailsResponseBean {
	constructor() {
		this.detailsBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.response.CheckBounceProcessResponseBean */
export class CheckBounceProcessResponseBean {
	constructor() {
		this.checkBounceProcess = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.response.CustomerTenderCreateResultResponseBean */
export class CustomerTenderCreateResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.response.CustomerTenderDetailsResponseBean */
export class CustomerTenderDetailsResponseBean {
	constructor() {
		this.customerTenderDetails = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.accountreceivable.response.PostDatedCheckEntryResponseBean */
export class PostDatedCheckEntryResponseBean {
	constructor() {
		this.postDatedCheckEntry = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.AccountReceivableDiscountDetailReasonBean */
export class AccountReceivableDiscountDetailReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.AccountReceivableReversalReasonBean */
export class AccountReceivableReversalReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.ARTypeBean */
export class ARTypeBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.AttributeCacheBean */
export class AttributeCacheBean {
	constructor() {
		this.currencies = new Array() ;
		this.cities = new Array() ;
		this.states = new Array() ;
		this.countries = new Array() ;
		this.paymentTerms = new Array() ;
		this.paymentMethods = new Array() ;
		this.warehouses = new Array() ;
		this.uoms = new Array() ;
		this.configs = new Array() ;
		this.attributeModuleEntities = new Array() ;
		this.salesPersons = new Array() ;
		this.customerTypes = new Array() ;
		this.customerDivisions = new Array() ;
		this.productDivisions = new Array() ;
		this.arTypes = new Array() ;
		this.financialTypes = new Array() ;
		this.shipVias = new Array() ;
		this.invoiceTemplates = new Array() ;
		this.zones = new Array() ;
		this.regions = new Array() ;
		this.districts = new Array() ;
		this.territories = new Array() ;
		this.seasons = new Array() ;
		this.shipmentTerms = new Array() ;
		this.fOBCities = new Array() ;
		this.incoTerms = new Array() ;
		this.vendorCategories = new Array() ;
		this.vendorShipVias = new Array() ;
		this.vendorTerms = new Array() ;
		this.productTypes = new Array() ;
		this.makeTypes = new Array() ;
		this.patternTypes = new Array() ;
		this.compositionTypes = new Array() ;
		this.royaltyClients = new Array() ;
		this.colors = new Array() ;
		this.employees = new Array() ;
		this.salesOrderTypes = new Array() ;
		this.salesOrderCancelReasons = new Array() ;
		this.salesOrderUnApprovalReasons = new Array() ;
		this.inventoryAdjustmentReasons = new Array() ;
		this.documentTypes = new Array() ;
		this.purchaseOrderCancelReasons = new Array() ;
		this.purchaseOrderExtraChargeReasons = new Array() ;
		this.purchaseOrderUnApprovalReasons = new Array() ;
		this.purchaseReceiptCancelReasons = new Array() ;
		this.badQualityReasons = new Array() ;
		this.invoicePrintoutTypes = new Array() ;
		this.extraChargeReasons = new Array() ;
		this.salesOrderAdjustmentReasons = new Array() ;
		this.invoiceCancelReasons = new Array() ;
		this.invoiceNonMerchandiseReasons = new Array() ;
		this.invoiceTypes = new Array() ;
		this.currencyExchangeRates = new Array() ;
		this.invoiceUnApprovalReasons = new Array() ;
		this.creditMemoTypes = new Array() ;
		this.creditMemoSubTypes = new Array() ;
		this.creditReasons = new Array() ;
		this.discountDetailReasons = new Array() ;
		this.vendorInvoiceCancelReasons = new Array() ;
		this.vendorInvoiceUnapprovalReasons = new Array() ;
		this.expenseTypes = new Array() ;
		this.vendorInvoiceMiscellaneousReasons = new Array() ;
		this.miscellaneousChargeReasons = new Array() ;
		this.generalLedgerAccountTypes = new Array() ;
		this.generalLedgerAccounts = new Array() ;
		this.bankAccounts = new Array() ;
		this.commissionTypes = new Array() ;
		this.allWarehouses = new Array() ;
		this.locations = new Array() ;
		this.allLocations = new Array() ;
		this.transactionTypes = new Array() ;
		this.vendorTypes = new Array() ;
		this.freightMethods = new Array() ;
		this.customerTenderReasons = new Array() ;
		this.customerTenderCancelReasons = new Array() ;
		this.customerTenderUnapprovalReasons = new Array() ;
		this.periodSalesCommissionAdjustmentReasons = new Array() ;
		this.accountReceivableReversalReasons = new Array() ;
		this.boxTypes = new Array() ;
		this.preProductionReasons = new Array() ;
		this.stageTypes = new Array() ;
		this.stageCollections = new Array() ;
		this.patternTypeCategories = new Array() ;
		this.codFundsCodes = new Array() ;
		this.customerDeliveries = new Array() ;
		this.purchaseOrderDateChangesReasons = new Array() ;
		this.inTransitCancelReasons = new Array() ;
		this.inTransitUnapproveReasons = new Array() ;
		this.purchaseOrderModels = new Array() ;
		this.preproductionOrderCancelReasons = new Array() ;
		this.preproductionOrderUnApprovalReasons = new Array() ;
		this.styleItemTypes = new Array() ;
		this.htses = new Array() ;
		this.productStatuses = new Array() ;
		this.customerSpecialTypes = new Array() ;
		this.purchaseOrderTypes = new Array() ;
		this.miscCostTypes = new Array() ;
		this.expenseSubTypes = new Array() ;
		this.bankAdjustmentReasons = new Array() ;
		this.depositCancelReasons = new Array() ;
		this.depositReversalReasons = new Array() ;
		this.fiscalYears = new Array() ;
		this.businessDivisions = new Array() ;
		this.comments = new Array() ;
		this.shipTos = new Array() ;
		this.fabricDetails = new Array() ;
		this.logisticMethods = new Array() ;
		this.webExportTypes = new Array() ;
		this.targetWebSiteDetails = new Array() ;
		this.logisticPackageInfoDetails = new Array() ;
		this.serviceInfos = new Array() ;
		this.cpmTemplates = new Array() ;
		this.fabricStatuses = new Array() ;
		this.shipToTypes = new Array() ;
		this.pickTicketCancelReasons = new Array() ;
		this.invoiceModel = new Array() ;
	}
}
/* ds.attributes.AttributeImageBean */
export class AttributeImageBean {
	constructor() {
		this.attributeType = '' ;
		this.attributeCode = '' ;
		this.imageCode = '' ;
		this.imagePart = '' ;
		this.imagePath = '' ;
		this.imageName = '' ;
		this.companyCode = '' ;
		this.imageOritinalname = '' ;
		this.tags = '' ;
		this.notesCommunication = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.BankAccountBean */
export class BankAccountBean {
	constructor() {
		this.address = null ;
		this.currencyCode = '' ;
		this.bankAccountNumber = '' ;
		this.currentBalanceAmount = 0 ;
		this.currentCheckNumber = 0 ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.BankAdjustmentReasonBean */
export class BankAdjustmentReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.BinLocationBean */
export class BinLocationBean {
	constructor() {
		this.wareHouseCode = '' ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.BoxTypeBean */
export class BoxTypeBean {
	constructor() {
		this.widthInInces = 0 ;
		this.heightInInces = 0 ;
		this.lengthInInces = 0 ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.BusinessDivisionBean */
export class BusinessDivisionBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CityBean */
export class CityBean {
	constructor() {
		this.countryCode = '' ;
		this.stateCode = '' ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CODFundsCodeBean */
export class CODFundsCodeBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.ColorBean */
export class ColorBean {
	constructor() {
		this.nrfCode = '' ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CommentBean */
export class CommentBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CommissionTypeBean */
export class CommissionTypeBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CompositionTypeBean */
export class CompositionTypeBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CountryBean */
export class CountryBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CreditMemoSubTypeBean */
export class CreditMemoSubTypeBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CreditMemoTypeBean */
export class CreditMemoTypeBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CreditReasonBean */
export class CreditReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.criteria.AccountReceivableDiscountDetailReasonSearchCriteria */
export class AccountReceivableDiscountDetailReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.AccountReceivableReversalReasonSearchCriteria */
export class AccountReceivableReversalReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.ArTypeSearchCriteria */
export class ArTypeSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.BankAccountSearchCriteria */
export class BankAccountSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.BankAdjustmentReasonSearchCriteria */
export class BankAdjustmentReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.BinLocationSearchCriteria */
export class BinLocationSearchCriteria {
	constructor() {
		this.wareHouseCode = '' ;
		this.shortCode = '' ;
		this.binLocationCodeContains = '' ;
		this.binLocationCodeStartsWith = '' ;
		this.shortCodeStartsWith = '' ;
		this.shortCodeContains = '' ;
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.BoxTypeSearchCriteria */
export class BoxTypeSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.BusinessDivisionSearchCriteria */
export class BusinessDivisionSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.CitySearchCriteria */
export class CitySearchCriteria {
	constructor() {
		this.countryCode = '' ;
		this.stateCode = '' ;
		this.modificationTrackNumber = 0 ;
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.ColorSearchCriteria */
export class ColorSearchCriteria {
	constructor() {
		this.colorCodesList = new Array() ;
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.CommentSearchCriteria */
export class CommentSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.CommissionTypeSearchCriteria */
export class CommissionTypeSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.CompositionTypeSearchCriteria */
export class CompositionTypeSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.CountrySearchCriteria */
export class CountrySearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.CreditMemoReasonSearchCriteria */
export class CreditMemoReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.CriticalPathManagementSearchCriteria */
export class CriticalPathManagementSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.cpmCode = '' ;
		this.cpmNameStartsWith = '' ;
		this.cpmNameContains = '' ;
		this.cpmDate = '' ;
		this.orderNumber = '' ;
		this.customerCode = '' ;
		this.cpmTemplateCode = '' ;
		this.cpmStatus = '' ;
		this.fromCpmDate = '' ;
		this.toCpmDate = '' ;
		this.cpmCodeStartsWith = '' ;
		this.cpmCodeContains = '' ;
		this.cpmType = '' ;
		this.searchName = '' ;
	}
}
/* ds.attributes.criteria.CriticalPathManagementTemplateSearchCriteria */
export class CriticalPathManagementTemplateSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.cpmTemplateCode = '' ;
		this.cpmTemplateCodes = new Array() ;
	}
}
/* ds.attributes.criteria.CurrencyExchangeRateSearchCriteria */
export class CurrencyExchangeRateSearchCriteria {
	constructor() {
		this.currencyExchangeRateCode = '' ;
		this.fromCurrencyCode = '' ;
		this.toCurrencyCode = '' ;
		this.date = '' ;
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.CurrencySearchCriteria */
export class CurrencySearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.CustomerDeliverySearchCriteria */
export class CustomerDeliverySearchCriteria {
	constructor() {
		this.noOfDays = 0 ;
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.CustomerDivisionSearchCriteria */
export class CustomerDivisionSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.CustomerSalesZoneSearchCriteria */
export class CustomerSalesZoneSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.CustomerSpecialTypeSearchCriteria */
export class CustomerSpecialTypeSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.CustomerTenderCancelReasonSearchCriteria */
export class CustomerTenderCancelReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.CustomerTenderReasonSearchCriteria */
export class CustomerTenderReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.CustomerTenderUnApprovalReasonSearchCriteria */
export class CustomerTenderUnApprovalReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.CustomerTypeSearchCriteria */
export class CustomerTypeSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.DepositCancelReasonSearchCriteria */
export class DepositCancelReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.DepositReversalReasonSearchCriteria */
export class DepositReversalReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.DocumentTypeSearchCriteria */
export class DocumentTypeSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.ExpenseSubTypeSearchCriteria */
export class ExpenseSubTypeSearchCriteria {
	constructor() {
		this.expenseType = '' ;
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.ExpenseTypeSearchCriteria */
export class ExpenseTypeSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.ExtraChargeReasonSearchCriteria */
export class ExtraChargeReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.FabricDetailSearchCriteria */
export class FabricDetailSearchCriteria {
	constructor() {
		this.fabricDetailType = '' ;
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.FabricStyleLogisticPackageInfoSearchCriteria */
export class FabricStyleLogisticPackageInfoSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.FabricVendorMiscellaneousCostReasonSearchCriteria */
export class FabricVendorMiscellaneousCostReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.FinancialTypeSearchCriteria */
export class FinancialTypeSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.FiscalYearSearchCriteria */
export class FiscalYearSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.FobCitySearchCriteria */
export class FobCitySearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.FreightMethodSearchCriteria */
export class FreightMethodSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.GeneralLedgerAccountSearchCriteria */
export class GeneralLedgerAccountSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.GeneralLedgerAccountTypeSearchCriteria */
export class GeneralLedgerAccountTypeSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.HTSSearchCriteria */
export class HTSSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.IncoTermSearchCriteria */
export class IncoTermSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.InventoryAdjustmentReasonSearchCriteria */
export class InventoryAdjustmentReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.InvoiceCancelReasonSearchCriteria */
export class InvoiceCancelReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.InvoiceModelSearchCriteria */
export class InvoiceModelSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.InvoiceNonMerchandiseReasonSearchCriteria */
export class InvoiceNonMerchandiseReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.InvoicePrintoutTypeSearchCriteria */
export class InvoicePrintoutTypeSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.InvoiceTemplateSearchCriteria */
export class InvoiceTemplateSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.InvoiceUnApprovalReasonSearchCriteria */
export class InvoiceUnApprovalReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.LogisticsMethodSearchCriteria */
export class LogisticsMethodSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.MakeTypeSearchCriteria */
export class MakeTypeSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.MiscellaneousChargeReasonSearchCriteria */
export class MiscellaneousChargeReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.PatternTypeCategorySearchCriteria */
export class PatternTypeCategorySearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.PatternTypeSearchCriteria */
export class PatternTypeSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.PaymentMethodSearchCriteria */
export class PaymentMethodSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.PaymentTermSearchCriteria */
export class PaymentTermSearchCriteria {
	constructor() {
		this.testProperty = '' ;
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.PeriodSalesCommissioinAdjustmentReasonSearchCriteria */
export class PeriodSalesCommissioinAdjustmentReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.PickTicketCancelReasonSearchCriteria */
export class PickTicketCancelReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.PreProductionChangeReasonSearchCriteria */
export class PreProductionChangeReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.PreProductionOrderCancelReasonSearchCriteria */
export class PreProductionOrderCancelReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.PreProductionOrderUnApprovalReasonSearchCriteria */
export class PreProductionOrderUnApprovalReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.ProductDivisionSearchCriteria */
export class ProductDivisionSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.ProductSpecialSearchCriteria */
export class ProductSpecialSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.ProductStatusSearchCriteria */
export class ProductStatusSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.ProductTypeSearchCriteria */
export class ProductTypeSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.PurchaseOrderCancelReasonSearchCriteria */
export class PurchaseOrderCancelReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.PurchaseOrderExtraChargeReasonSearchCriteria */
export class PurchaseOrderExtraChargeReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.PurchaseOrderModelSearchCriteria */
export class PurchaseOrderModelSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.PurchaseOrderReceiptBadQualityReasonSearchCriteria */
export class PurchaseOrderReceiptBadQualityReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.PurchaseOrderReceiptCancelReasonSearchCriteria */
export class PurchaseOrderReceiptCancelReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.PurchaseOrderUnApprovalReasonSearchCriteria */
export class PurchaseOrderUnApprovalReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.RoyaltyClientSearchCriteria */
export class RoyaltyClientSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.SalesOrderAdjustmentReasonSearchCriteria */
export class SalesOrderAdjustmentReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.SalesOrderUnApprovalReasonSearchCriteria */
export class SalesOrderUnApprovalReasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.SeasonSearchCriteria */
export class SeasonSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.ServiceSearchCriteria */
export class ServiceSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.ShipmentTermSearchCriteria */
export class ShipmentTermSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.ShipToSearchCriteria */
export class ShipToSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.ShipTypeSearchCriteria */
export class ShipTypeSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.ShipViaSearchCriteria */
export class ShipViaSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.StageCollectionSearchCriteria */
export class StageCollectionSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.stageCollectionCode = '' ;
		this.stageCode = '' ;
	}
}
/* ds.attributes.criteria.StageTypeSearchCriteria */
export class StageTypeSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.StateSearchCriteria */
export class StateSearchCriteria {
	constructor() {
		this.countryCode = '' ;
		this.modificationTrackNumber = 0 ;
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.StyleItemTypeSearchCriteria */
export class StyleItemTypeSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.TargetWebSiteDetailSearchCriteria */
export class TargetWebSiteDetailSearchCriteria {
	constructor() {
		this.webExportTypeCode = '' ;
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.UOMSearchCriteria */
export class UOMSearchCriteria {
	constructor() {
		this.uomCode = '' ;
		this.companyCode = '' ;
	}
}
/* ds.attributes.criteria.VendorCategorySearchCriteria */
export class VendorCategorySearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.VendorShipViaSearchCriteria */
export class VendorShipViaSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.VendorTermSearchCriteria */
export class VendorTermSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.VendorTypeSearchCriteria */
export class VendorTypeSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.criteria.WarehouseSearchCriteria */
export class WarehouseSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.CriticalPathManagementTaskSearchCriteria */
export class CriticalPathManagementTaskSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.name = '' ;
		this.sortBy = 0 ;
		this.modificationTrackNumber = 0 ;
		this.codeContains = '' ;
		this.codeList = new Array() ;
	}
}
/* ds.attributes.CurrencyBean */
export class CurrencyBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CurrencyExchangeRateBean */
export class CurrencyExchangeRateBean {
	constructor() {
		this.fromCurrencyCode = '' ;
		this.toCurrencyCode = '' ;
		this.fromCurrencyName = '' ;
		this.toCurrencyName = '' ;
		this.actualExchangeRate = 0 ;
		this.adjustedExchangeRate = 0 ;
		this.date = '' ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CustomerClassBean */
export class CustomerClassBean {
	constructor() {
		this.divisionCode = '' ;
		this.departmentCode = '' ;
		this.subClasses = new Array() ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CustomerDeliveryBean */
export class CustomerDeliveryBean {
	constructor() {
		this.noOfDays = 0 ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CustomerDepartmentBean */
export class CustomerDepartmentBean {
	constructor() {
		this.divisionCode = '' ;
		this.classes = new Array() ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CustomerDivisionBean */
export class CustomerDivisionBean {
	constructor() {
		this.departments = new Array() ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CustomerSalesDistrictBean */
export class CustomerSalesDistrictBean {
	constructor() {
		this.zoneCode = '' ;
		this.regionCode = '' ;
		this.territories = new Array() ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CustomerSalesRegionBean */
export class CustomerSalesRegionBean {
	constructor() {
		this.zoneCode = '' ;
		this.districts = new Array() ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CustomerSalesTerritoryBean */
export class CustomerSalesTerritoryBean {
	constructor() {
		this.zoneCode = '' ;
		this.regionCode = '' ;
		this.districtCode = '' ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CustomerSalesZoneBean */
export class CustomerSalesZoneBean {
	constructor() {
		this.regions = new Array() ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CustomerSpecialTypeBean */
export class CustomerSpecialTypeBean {
	constructor() {
		this.discountPercentage = 0 ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CustomerSubClassBean */
export class CustomerSubClassBean {
	constructor() {
		this.divisionCode = '' ;
		this.departmentCode = '' ;
		this.classCode = '' ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CustomerTenderCancelReasonBean */
export class CustomerTenderCancelReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CustomerTenderReasonBean */
export class CustomerTenderReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CustomerTenderUnApprovalReasonBean */
export class CustomerTenderUnApprovalReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.CustomerTypeBean */
export class CustomerTypeBean {
	constructor() {
		this.discountPercentage = 0 ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.DepositCancelReasonBean */
export class DepositCancelReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.DepositReversalReasonBean */
export class DepositReversalReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.DocumentTypeBean */
export class DocumentTypeBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.ExpenseSubTypeBean */
export class ExpenseSubTypeBean {
	constructor() {
		this.expenseTypeCode = '' ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.ExpenseTypeBean */
export class ExpenseTypeBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.ExtraChargeReasonBean */
export class ExtraChargeReasonBean {
	constructor() {
		this.extraChargesAmount = 0 ;
		this.currencyCode = '' ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.FabricDetailBean */
export class FabricDetailBean {
	constructor() {
		this.fabricDetailTypeCode = '' ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.FabricStatusBean */
export class FabricStatusBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.FabricStyleLogisticPackageInfoBean */
export class FabricStyleLogisticPackageInfoBean {
	constructor() {
		this.fabricStyleCode = '' ;
		this.uomCode = '' ;
		this.grossWeightOfUom = 0 ;
		this.netWeightOfUom = 0 ;
		this.caseLength = 0 ;
		this.caseWidth = 0 ;
		this.caseHeight = 0 ;
		this.casePack = 0 ;
		this.palletLength = 0 ;
		this.palletWidth = 0 ;
		this.palletHeight = 0 ;
		this.palletTie = 0 ;
		this.palletHigh = 0 ;
		this.palletWeight = 0 ;
		this.orderedQuantity = 0 ;
		this.balanceQuantity = 0 ;
		this.lotCodeRequiredFlag = false ;
		this.itemAvailableFlag = false ;
		this.lotCodeFormat = '' ;
		this.nmfcCode = '' ;
		this.ltlFreightClass = 0 ;
		this.harzadousDescription = '' ;
		this.miscDescription = '' ;
		this.receivedDate = '' ;
		this.shipedDate = '' ;
		this.weightUomCode = '' ;
		this.caseUomCode = '' ;
		this.palletUomCode = '' ;
		this.stackableFlag = false ;
		this.stackableQuantity = 0 ;
		this.qualityReceived = '' ;
		this.itemOnCaseFlag = false ;
		this.fabricStyleName = '' ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.FabricVendorMiscellaneousCostDetailReasonBean */
export class FabricVendorMiscellaneousCostDetailReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.FinancialTypeBean */
export class FinancialTypeBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.FiscalYearBean */
export class FiscalYearBean {
	constructor() {
		this.startDate = '' ;
		this.endDate = '' ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.FOBCityBean */
export class FOBCityBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.FreightMethodBean */
export class FreightMethodBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.GeneralLedgerAccountBean */
export class GeneralLedgerAccountBean {
	constructor() {
		this.currencyCode = '' ;
		this.generalLedgerAccountType = '' ;
		this.generalLedgerAccountAmount = 0 ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.GeneralLedgerAccountTypeBean */
export class GeneralLedgerAccountTypeBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.HarmonizedTariffScheduleBean */
export class HarmonizedTariffScheduleBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.IncoTermBean */
export class IncoTermBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.InventoryAdjustmentReasonBean */
export class InventoryAdjustmentReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.InvoiceCancelReasonBean */
export class InvoiceCancelReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.InvoiceModelBean */
export class InvoiceModelBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.InvoiceNonMerchandiseReasonBean */
export class InvoiceNonMerchandiseReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.InvoicePrintoutTypeBean */
export class InvoicePrintoutTypeBean {
	constructor() {
		this.address = null ;
		this.images = new Array() ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.InvoiceTemplateBean */
export class InvoiceTemplateBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.InvoiceTypeBean */
export class InvoiceTypeBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.InvoiceUnApprovalReasonBean */
export class InvoiceUnApprovalReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.LocationBean */
export class LocationBean {
	constructor() {
		this.locationType = 0 ;
		this.address = null ;
		this.locationEntityCode = '' ;
		this.rowCode = '' ;
		this.aisleCode = '' ;
		this.binCode = '' ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.LogisticMethodBean */
export class LogisticMethodBean {
	constructor() {
		this.logisticMethodPercentage = 0 ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.MakeTypeBean */
export class MakeTypeBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.MiscellaneousChargeReasonBean */
export class MiscellaneousChargeReasonBean {
	constructor() {
		this.miscellaneousChargesAmount = 0 ;
		this.currencyCode = '' ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.pagelist.AccountReceivableDiscountDetailReasonPageListBean */
export class AccountReceivableDiscountDetailReasonPageListBean {
	constructor() {
		this.accountReceivableDiscountDetailReasons = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.AccountReceivableReversalReasonPageListBean */
export class AccountReceivableReversalReasonPageListBean {
	constructor() {
		this.accountreceivableReversalReason = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.ARTypePageListBean */
export class ARTypePageListBean {
	constructor() {
		this.arTypes = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.BankAccountPageListBean */
export class BankAccountPageListBean {
	constructor() {
		this.bankAccounts = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.BankAdjustmentReasonPageListBean */
export class BankAdjustmentReasonPageListBean {
	constructor() {
		this.bankAdjustmentReasons = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.BinLocationPageListBean */
export class BinLocationPageListBean {
	constructor() {
		this.binLocations = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.BoxTypePageListBean */
export class BoxTypePageListBean {
	constructor() {
		this.boxTypes = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.BusinessDivisionPageListBean */
export class BusinessDivisionPageListBean {
	constructor() {
		this.businessDivisions = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.CityPageListBean */
export class CityPageListBean {
	constructor() {
		this.cities = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.ColorPageListBean */
export class ColorPageListBean {
	constructor() {
		this.colors = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.CommentPageListBean */
export class CommentPageListBean {
	constructor() {
		this.comments = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.CompositionTypePageListBean */
export class CompositionTypePageListBean {
	constructor() {
		this.compositionTypes = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.CountryPageListBean */
export class CountryPageListBean {
	constructor() {
		this.country = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.CreditMemoReasonPageListBean */
export class CreditMemoReasonPageListBean {
	constructor() {
		this.creditReason = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.CurrencyExchangeRatePageListBean */
export class CurrencyExchangeRatePageListBean {
	constructor() {
		this.currencyExchangeRates = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.CurrencyPageListBean */
export class CurrencyPageListBean {
	constructor() {
		this.currency = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.CustomerDeliveryPageListBean */
export class CustomerDeliveryPageListBean {
	constructor() {
		this.customerDeliveries = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.CustomerDivisionPageListBean */
export class CustomerDivisionPageListBean {
	constructor() {
		this.customerDivisions = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.CustomerSalesZonePageListBean */
export class CustomerSalesZonePageListBean {
	constructor() {
		this.customerZones = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.CustomerSpecialTypePageListBean */
export class CustomerSpecialTypePageListBean {
	constructor() {
		this.customerSpecialType = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.CustomerTenderCancelReasonPageListBean */
export class CustomerTenderCancelReasonPageListBean {
	constructor() {
		this.customerTenderCancelReasonBean = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.CustomerTenderReasonPageListBean */
export class CustomerTenderReasonPageListBean {
	constructor() {
		this.customerTender = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.CustomerTenderUnApprovalReasonPageListBean */
export class CustomerTenderUnApprovalReasonPageListBean {
	constructor() {
		this.customerTenderUnApprovalReason = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.CustomerTypePageListBean */
export class CustomerTypePageListBean {
	constructor() {
		this.customerType = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.DepositCancelReasonPageListBean */
export class DepositCancelReasonPageListBean {
	constructor() {
		this.depositCancelReason = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.DepositReversalReasonPageListBean */
export class DepositReversalReasonPageListBean {
	constructor() {
		this.depositReversalReason = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.DocumentTypePageListBean */
export class DocumentTypePageListBean {
	constructor() {
		this.documentTypeBean = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.ExpenseSubTypePageListBean */
export class ExpenseSubTypePageListBean {
	constructor() {
		this.expenseSubTypes = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.ExpenseTypePageListBean */
export class ExpenseTypePageListBean {
	constructor() {
		this.expenseTypes = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.ExtraChargeReasonPageListBean */
export class ExtraChargeReasonPageListBean {
	constructor() {
		this.extraChargeReasonBean = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.FabricDetailPageListBean */
export class FabricDetailPageListBean {
	constructor() {
		this.fabricDetails = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.FabricStyleLogisticPackageInfoPageListBean */
export class FabricStyleLogisticPackageInfoPageListBean {
	constructor() {
		this.logisticPackageInfos = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.FabricVendorMiscellaneousCostDetailReasonPageListBean */
export class FabricVendorMiscellaneousCostDetailReasonPageListBean {
	constructor() {
		this.vendorMiscellaneousCostDetailReasonBean = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.FinancialTypePageListBean */
export class FinancialTypePageListBean {
	constructor() {
		this.financialType = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.FiscalYearPageListBean */
export class FiscalYearPageListBean {
	constructor() {
		this.fiscalYears = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.FobCityPageListBean */
export class FobCityPageListBean {
	constructor() {
		this.fobCities = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.FreightMethodPageListBean */
export class FreightMethodPageListBean {
	constructor() {
		this.freightMethodsArray = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.GeneralLedgerAccountPageListBean */
export class GeneralLedgerAccountPageListBean {
	constructor() {
		this.generalLedgerAccountBean = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.GeneralLedgerAccountTypePageListBean */
export class GeneralLedgerAccountTypePageListBean {
	constructor() {
		this.generalLedgerAccountTypeBean = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.HarmonizedTariffSchedulePageListBean */
export class HarmonizedTariffSchedulePageListBean {
	constructor() {
		this.hts = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.IncoTermsPageListBean */
export class IncoTermsPageListBean {
	constructor() {
		this.incoTerms = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.InventoryAdjustmentReasonPageListBean */
export class InventoryAdjustmentReasonPageListBean {
	constructor() {
		this.inventoryAdjustmentReasonBean = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.InvoiceCancelReasonPageListBean */
export class InvoiceCancelReasonPageListBean {
	constructor() {
		this.invoiceCancelReasonBean = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.InvoiceModelPageListBean */
export class InvoiceModelPageListBean {
	constructor() {
		this.invoiceModel = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.InvoiceNonMerchandiseReasonPageListBean */
export class InvoiceNonMerchandiseReasonPageListBean {
	constructor() {
		this.invoiceNonMerchandiseReasonBean = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.InvoicePrintoutTypePageListBean */
export class InvoicePrintoutTypePageListBean {
	constructor() {
		this.invoicePrintoutTypes = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.InvoiceTemplatePageListBean */
export class InvoiceTemplatePageListBean {
	constructor() {
		this.invoiceTemplate = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.InvoiceUnApprovalReasonPageListBean */
export class InvoiceUnApprovalReasonPageListBean {
	constructor() {
		this.invoiceUnApprovalReason = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.LocationPageListBean */
export class LocationPageListBean {
	constructor() {
		this.locations = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.LogisticMethodPageListBean */
export class LogisticMethodPageListBean {
	constructor() {
		this.logisticMethod = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.MakeTypePageListBean */
export class MakeTypePageListBean {
	constructor() {
		this.makeTypes = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.MasterAttributePageListBean */
export class MasterAttributePageListBean {
	constructor() {
		this.attributes = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.MiscellaneousChargeReasonPageListBean */
export class MiscellaneousChargeReasonPageListBean {
	constructor() {
		this.miscChargeReasonBean = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.PatternTypeCategoryPageListBean */
export class PatternTypeCategoryPageListBean {
	constructor() {
		this.patternTypeCategories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.PatternTypePageListBean */
export class PatternTypePageListBean {
	constructor() {
		this.patternTypes = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.PaymentMethodPageListBean */
export class PaymentMethodPageListBean {
	constructor() {
		this.paymentMethod = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.PaymentTermPageListBean */
export class PaymentTermPageListBean {
	constructor() {
		this.paymentTerms = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.PeriodSalesCommissionAdjustmentReasonPageListBean */
export class PeriodSalesCommissionAdjustmentReasonPageListBean {
	constructor() {
		this.periodSalesCommissionAdjustmentBean = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.PickTicketCancelReasonPageListBean */
export class PickTicketCancelReasonPageListBean {
	constructor() {
		this.pickTicketCancelReasonBean = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.PreProductionChangeReasonPageListBean */
export class PreProductionChangeReasonPageListBean {
	constructor() {
		this.preProductionReasons = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.PreProductionOrderCancelReasonPageListBean */
export class PreProductionOrderCancelReasonPageListBean {
	constructor() {
		this.preproductionOrderCancelReasons = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.PreProductionOrderUnApprovalReasonPageListBean */
export class PreProductionOrderUnApprovalReasonPageListBean {
	constructor() {
		this.preproductionOrderUnApprovalReasons = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.ProductDivisionPageListBean */
export class ProductDivisionPageListBean {
	constructor() {
		this.productDivisions = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.ProductStatusPageListBean */
export class ProductStatusPageListBean {
	constructor() {
		this.productStatus = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.ProductTypePageListBean */
export class ProductTypePageListBean {
	constructor() {
		this.productTypes = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.PurchaseOrderCancelReasonPageListBean */
export class PurchaseOrderCancelReasonPageListBean {
	constructor() {
		this.PurchaseOrderCancelReason = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.PurchaseOrderExtraChargeReasonPageListBean */
export class PurchaseOrderExtraChargeReasonPageListBean {
	constructor() {
		this.purchaseOrderExtraChargeReasonBean = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.PurchaseOrderModelPageListBean */
export class PurchaseOrderModelPageListBean {
	constructor() {
		this.purchaseOrderModels = new Array() ;
		this.count = 0 ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.PurchaseOrderUnApprovalReasonPageListBean */
export class PurchaseOrderUnApprovalReasonPageListBean {
	constructor() {
		this.purchaseOrderUnApprovalReason = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.response.AccountReceivableDiscountDetailReasonPageListResponseBean */
export class AccountReceivableDiscountDetailReasonPageListResponseBean {
	constructor() {
		this.accountReceivableDiscountDetailReasonPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.AccountReceivableReversalReasonPageListResponseBean */
export class AccountReceivableReversalReasonPageListResponseBean {
	constructor() {
		this.accountReceivableReversalReasonPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.ArTypePageListResponseBean */
export class ArTypePageListResponseBean {
	constructor() {
		this.arTypePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.BankAccountPageListResponseBean */
export class BankAccountPageListResponseBean {
	constructor() {
		this.bankAccountPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.BoxTypePageListResponseBean */
export class BoxTypePageListResponseBean {
	constructor() {
		this.boxTypePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.BusinessDivisionPageListResponseBean */
export class BusinessDivisionPageListResponseBean {
	constructor() {
		this.businessDivision = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.CityPageListResponseBean */
export class CityPageListResponseBean {
	constructor() {
		this.cityPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.ColorPageListResponseBean */
export class ColorPageListResponseBean {
	constructor() {
		this.colorPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.CommentPageListResponseBean */
export class CommentPageListResponseBean {
	constructor() {
		this.comment = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.CompositionTypePageListResponseBean */
export class CompositionTypePageListResponseBean {
	constructor() {
		this.compositionTypePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.CountryPageListResponseBean */
export class CountryPageListResponseBean {
	constructor() {
		this.countryPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.CreditMemoReasonPageListResponseBean */
export class CreditMemoReasonPageListResponseBean {
	constructor() {
		this.creditMemoReasonPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.CurrencyExchangeRatePageListResponseBean */
export class CurrencyExchangeRatePageListResponseBean {
	constructor() {
		this.currencyExchangeRatePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.CurrencyPageListResponseBean */
export class CurrencyPageListResponseBean {
	constructor() {
		this.currencyPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.CustomerDeliveryPageListResponseBean */
export class CustomerDeliveryPageListResponseBean {
	constructor() {
		this.customerDeliveryPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.CustomerDivisionPageListResponseBean */
export class CustomerDivisionPageListResponseBean {
	constructor() {
		this.customerDivisionPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.CustomerSalesZonePageListResponseBean */
export class CustomerSalesZonePageListResponseBean {
	constructor() {
		this.customerSalesZonePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.CustomerSpecialTypePageListResponseBean */
export class CustomerSpecialTypePageListResponseBean {
	constructor() {
		this.customerSpecialTypePageList = null ;
		this.attributePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.CustomerTenderCancelReasonPageListResponseBean */
export class CustomerTenderCancelReasonPageListResponseBean {
	constructor() {
		this.customerTenderCancelPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.CustomerTenderReasonPageListResponseBean */
export class CustomerTenderReasonPageListResponseBean {
	constructor() {
		this.customerTenderReasonPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.CustomerTenderUnApprovalReasonPageListResponseBean */
export class CustomerTenderUnApprovalReasonPageListResponseBean {
	constructor() {
		this.customerTenderUnAppprovalReasonPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.CustomerTypePageListResponseBean */
export class CustomerTypePageListResponseBean {
	constructor() {
		this.customerTypePageList = null ;
		this.attributePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.DocumentTypePageListResponseBean */
export class DocumentTypePageListResponseBean {
	constructor() {
		this.documentTypePageListBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.ExpenseTypePageListResponseBean */
export class ExpenseTypePageListResponseBean {
	constructor() {
		this.expenseTypePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.ExtraChargeReasonPageListResponseBean */
export class ExtraChargeReasonPageListResponseBean {
	constructor() {
		this.extraChargeReasonPageListBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.FabricStyleLogisticPackageInfoPageListResponseBean */
export class FabricStyleLogisticPackageInfoPageListResponseBean {
	constructor() {
		this.fabricStyleLogisticPackageInfoPageList = null ;
		this.attributePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.FinancialTypePageListResponseBean */
export class FinancialTypePageListResponseBean {
	constructor() {
		this.financialTypePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.FiscalYearPageListResponseBean */
export class FiscalYearPageListResponseBean {
	constructor() {
		this.fiscalYearPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.FobCityPageListResponseBean */
export class FobCityPageListResponseBean {
	constructor() {
		this.fobCityPageList = null ;
		this.attributePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.FreightMethodPageListResponseBean */
export class FreightMethodPageListResponseBean {
	constructor() {
		this.freightMethodPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.GeneralLedgerAccountPageListResponseBean */
export class GeneralLedgerAccountPageListResponseBean {
	constructor() {
		this.generalLedgerAccountPageListBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.GeneralLedgerAccountTypePageListResponseBean */
export class GeneralLedgerAccountTypePageListResponseBean {
	constructor() {
		this.generalLedgerAccountTypePageListBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.HarmonizedTariffSchedulePageListResponseBean */
export class HarmonizedTariffSchedulePageListResponseBean {
	constructor() {
		this.htsPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.IncoTermPageListResponseBean */
export class IncoTermPageListResponseBean {
	constructor() {
		this.incoTermPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.InventoryAdjustmentReasonPageListResponseBean */
export class InventoryAdjustmentReasonPageListResponseBean {
	constructor() {
		this.inventoryAdjustmentReasonPageListBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.InvoiceCancelReasonPageListResponseBean */
export class InvoiceCancelReasonPageListResponseBean {
	constructor() {
		this.invoiceCancelReasonPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.InvoiceModelPageListResponseBean */
export class InvoiceModelPageListResponseBean {
	constructor() {
		this.invoiceModelPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.InvoiceNonMerchandiseReasonPageListResponseBean */
export class InvoiceNonMerchandiseReasonPageListResponseBean {
	constructor() {
		this.invoiceNonMerchandiseReasonPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.InvoicePrintoutPageListResponseBean */
export class InvoicePrintoutPageListResponseBean {
	constructor() {
		this.invoicePrintoutTypePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.InvoiceTemplatePageListResponseBean */
export class InvoiceTemplatePageListResponseBean {
	constructor() {
		this.invoiceTemplatePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.InvoiceUnApprovalReasonPageListResponseBean */
export class InvoiceUnApprovalReasonPageListResponseBean {
	constructor() {
		this.invoiceUnAppprovalReasonPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.LocationPageListResponseBean */
export class LocationPageListResponseBean {
	constructor() {
		this.LocationPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.LogisticMethodPageListResponseBean */
export class LogisticMethodPageListResponseBean {
	constructor() {
		this.logisticMethodPageList = null ;
		this.attributePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.MakeTypePageListResponseBean */
export class MakeTypePageListResponseBean {
	constructor() {
		this.makeTypePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.MiscellaneousChargeReasonPageListResponseBean */
export class MiscellaneousChargeReasonPageListResponseBean {
	constructor() {
		this.miscChargeReasonPageListBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.PatternTypeCategoryPageListResponseBean */
export class PatternTypeCategoryPageListResponseBean {
	constructor() {
		this.patternTypeCategoryPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.PatternTypePageListResponseBean */
export class PatternTypePageListResponseBean {
	constructor() {
		this.patternTypePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.PaymentMethodPageListResponseBean */
export class PaymentMethodPageListResponseBean {
	constructor() {
		this.paymentMethodPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.PaymentTermPageListResponseBean */
export class PaymentTermPageListResponseBean {
	constructor() {
		this.paymentTermPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.PeriodSalesCommissionAdjustmentReasonPageListResponseBean */
export class PeriodSalesCommissionAdjustmentReasonPageListResponseBean {
	constructor() {
		this.periodSalesCommissionReasonPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.PickTicketCancelReasonPageListResponseBean */
export class PickTicketCancelReasonPageListResponseBean {
	constructor() {
		this.pickTicketCancelReasonPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.PreProductionChangeReasonPageListResponseBean */
export class PreProductionChangeReasonPageListResponseBean {
	constructor() {
		this.preProductionReasonPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.PreProductionOrderCancelReasonPageListResponseBean */
export class PreProductionOrderCancelReasonPageListResponseBean {
	constructor() {
		this.preProductionOrderCancelReasonPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.PreProductionOrderUnApprovalReasonPageListResponseBean */
export class PreProductionOrderUnApprovalReasonPageListResponseBean {
	constructor() {
		this.preProductionOrderUnApprovalPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.ProductDivisionPageListResponseBean */
export class ProductDivisionPageListResponseBean {
	constructor() {
		this.productDivisionPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.ProductStatusPageListResponseBean */
export class ProductStatusPageListResponseBean {
	constructor() {
		this.productStatusPageList = null ;
		this.attributePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.ProductTypePageListResponseBean */
export class ProductTypePageListResponseBean {
	constructor() {
		this.productTypePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.PurchaseOrderCancelReasonPageListResponseBean */
export class PurchaseOrderCancelReasonPageListResponseBean {
	constructor() {
		this.purchaseOrderCancelReasonPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.PurchaseOrderExtraChargeReasonPageListResponseBean */
export class PurchaseOrderExtraChargeReasonPageListResponseBean {
	constructor() {
		this.purchaseOrderExtraChargeReasonPageListBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.PurchaseOrderModelPageListResponseBean */
export class PurchaseOrderModelPageListResponseBean {
	constructor() {
		this.purchaseOrderModelPageList = null ;
		this.count = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.PurchaseOrderUnApprovalReasonPageListResponseBean */
export class PurchaseOrderUnApprovalReasonPageListResponseBean {
	constructor() {
		this.purchaseOrderUnApprovalReasonPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.RoyaltyClientPageListResponseBean */
export class RoyaltyClientPageListResponseBean {
	constructor() {
		this.royaltyClientPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.SeasonPageListResponseBean */
export class SeasonPageListResponseBean {
	constructor() {
		this.seasonPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.ServicePageListResponseBean */
export class ServicePageListResponseBean {
	constructor() {
		this.service = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.ShipmentTermPageListResponseBean */
export class ShipmentTermPageListResponseBean {
	constructor() {
		this.shipmentTermPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.ShipToPageListResponseBean */
export class ShipToPageListResponseBean {
	constructor() {
		this.shipToPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.ShipViaPageListResponseBean */
export class ShipViaPageListResponseBean {
	constructor() {
		this.shipViaPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.StageCollectionPageListResponseBean */
export class StageCollectionPageListResponseBean {
	constructor() {
		this.collectionPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.StageTypePageListResponseBean */
export class StageTypePageListResponseBean {
	constructor() {
		this.stagePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.StatePageListResponseBean */
export class StatePageListResponseBean {
	constructor() {
		this.statePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.StyleItemTypePageListResponseBean */
export class StyleItemTypePageListResponseBean {
	constructor() {
		this.styleItemTypePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.TargetWebSiteDetailPageListResponseBean */
export class TargetWebSiteDetailPageListResponseBean {
	constructor() {
		this.webSitePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.UOMPageListResponseBean */
export class UOMPageListResponseBean {
	constructor() {
		this.uomPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.VendorCategoryPageListResponseBean */
export class VendorCategoryPageListResponseBean {
	constructor() {
		this.vendorCategoryPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.VendorShipViaPageListResponseBean */
export class VendorShipViaPageListResponseBean {
	constructor() {
		this.vendorShipViaPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.VendorTermPageListResponseBean */
export class VendorTermPageListResponseBean {
	constructor() {
		this.vendorTermPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.VendorTypePageListResponseBean */
export class VendorTypePageListResponseBean {
	constructor() {
		this.vendorTypePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.response.WarehousePageListResponseBean */
export class WarehousePageListResponseBean {
	constructor() {
		this.WarehousePageList = null ;
		this.attributePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.pagelist.RoyaltyClientPageListBean */
export class RoyaltyClientPageListBean {
	constructor() {
		this.royaltyClients = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.SalesOrderAdjustmentReasonPageListBean */
export class SalesOrderAdjustmentReasonPageListBean {
	constructor() {
		this.salesOrderAdjustmentReasons = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.SeasonPageListBean */
export class SeasonPageListBean {
	constructor() {
		this.seasons = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.ServicePageListBean */
export class ServicePageListBean {
	constructor() {
		this.serivces = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.ShipmentTermPageListBean */
export class ShipmentTermPageListBean {
	constructor() {
		this.shipmentTerms = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.ShipToPageListBean */
export class ShipToPageListBean {
	constructor() {
		this.shipTos = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.ShipViaPageListBean */
export class ShipViaPageListBean {
	constructor() {
		this.shipVia = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.StageCollectionPageListBean */
export class StageCollectionPageListBean {
	constructor() {
		this.stageCollections = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.StageTypePageListBean */
export class StageTypePageListBean {
	constructor() {
		this.stageTypes = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.StatePageListBean */
export class StatePageListBean {
	constructor() {
		this.states = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.StyleItemTypePageListBean */
export class StyleItemTypePageListBean {
	constructor() {
		this.styleItemTypes = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.TargetWebSiteDetailPageListBean */
export class TargetWebSiteDetailPageListBean {
	constructor() {
		this.websiteDetails = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.UOMPageListBean */
export class UOMPageListBean {
	constructor() {
		this.uoms = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.VendorCategoryPageListBean */
export class VendorCategoryPageListBean {
	constructor() {
		this.vendorCategoryTypes = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.VendorShipViaPageListBean */
export class VendorShipViaPageListBean {
	constructor() {
		this.vendorShipVias = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.VendorTermPageListBean */
export class VendorTermPageListBean {
	constructor() {
		this.vendorTerms = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.VendorTypePageListBean */
export class VendorTypePageListBean {
	constructor() {
		this.vendorType = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.pagelist.WareHousePageListBean */
export class WareHousePageListBean {
	constructor() {
		this.wareHouse = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.attributes.PatternTypeBean */
export class PatternTypeBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.PatternTypeCategoryBean */
export class PatternTypeCategoryBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.PaymentMethodBean */
export class PaymentMethodBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.PaymentTermBean */
export class PaymentTermBean {
	constructor() {
		this.termType = 0 ;
		this.termDays = 0 ;
		this.discountableDays = 0 ;
		this.lastDayOfMonthForInvoiceReceiveDate = 0 ;
		this.discountPercentage = 0 ;
		this.interestRate = 0 ;
		this.isPaidForceFlag = false ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.PeriodSalesCommissionAdjustmentReasonBean */
export class PeriodSalesCommissionAdjustmentReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.PickTicketCancelReasonBean */
export class PickTicketCancelReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.PreProductionChangeReasonBean */
export class PreProductionChangeReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.PreProductionOrderCancelReasonBean */
export class PreProductionOrderCancelReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.PreProductionOrderUnApprovalReasonBean */
export class PreProductionOrderUnApprovalReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.ProductClassBean */
export class ProductClassBean {
	constructor() {
		this.divisionCode = '' ;
		this.departmentCode = '' ;
		this.subClasses = new Array() ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.ProductDepartmentBean */
export class ProductDepartmentBean {
	constructor() {
		this.divisionCode = '' ;
		this.classes = new Array() ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.ProductDivisionBean */
export class ProductDivisionBean {
	constructor() {
		this.taxPercentage = 0 ;
		this.additionalTaxPercentage = 0 ;
		this.departments = new Array() ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.ProductStatusBean */
export class ProductStatusBean {
	constructor() {
		this.isOrderAllowed = false ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.ProductSubClassBean */
export class ProductSubClassBean {
	constructor() {
		this.divisionCode = '' ;
		this.departmentCode = '' ;
		this.classCode = '' ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.ProductTypeBean */
export class ProductTypeBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.PurchaseOrderCancelReasonBean */
export class PurchaseOrderCancelReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.PurchaseOrderDateChangeReasonBean */
export class PurchaseOrderDateChangeReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.PurchaseOrderExtraChargeReasonBean */
export class PurchaseOrderExtraChargeReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.PurchaseOrderInTransitCancelReasonBean */
export class PurchaseOrderInTransitCancelReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.PurchaseOrderInTransitUnApprovalReasonBean */
export class PurchaseOrderInTransitUnApprovalReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.PurchaseOrderModelBean */
export class PurchaseOrderModelBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.PurchaseOrderReceiptBadQualityReasonBean */
export class PurchaseOrderReceiptBadQualityReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.PurchaseOrderReceiptCancelReasonBean */
export class PurchaseOrderReceiptCancelReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.PurchaseOrderReceiptUnApprovalReasonBean */
export class PurchaseOrderReceiptUnApprovalReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.PurchaseOrderTypeBean */
export class PurchaseOrderTypeBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.PurchaseOrderUnApprovalReasonBean */
export class PurchaseOrderUnApprovalReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.response.AccountReceivableDiscountDetailReasonResponseBean */
export class AccountReceivableDiscountDetailReasonResponseBean {
	constructor() {
		this.accountReceivableDiscountDetailReason = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.AccountReceivableReversalReasonResponseBean */
export class AccountReceivableReversalReasonResponseBean {
	constructor() {
		this.accountReceivableReversalReason = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.ArTypeResponseBean */
export class ArTypeResponseBean {
	constructor() {
		this.arType = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.AttributeCacheResponseBean */
export class AttributeCacheResponseBean {
	constructor() {
		this.attributeCache = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.BankAccountResponseBean */
export class BankAccountResponseBean {
	constructor() {
		this.bankAccount = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.BankAdjustmentReasonPageListResponseBean */
export class BankAdjustmentReasonPageListResponseBean {
	constructor() {
		this.bankAdjustmentReasonPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.BankAdjustmentReasonResponseBean */
export class BankAdjustmentReasonResponseBean {
	constructor() {
		this.bankAdjustmentReasonBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.BinLocationPageListResponseBean */
export class BinLocationPageListResponseBean {
	constructor() {
		this.binLocationPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.BinLocationResponseBean */
export class BinLocationResponseBean {
	constructor() {
		this.binLocation = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.BoxTypeResponseBean */
export class BoxTypeResponseBean {
	constructor() {
		this.boxTypeBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.BusinessDivisionResponseBean */
export class BusinessDivisionResponseBean {
	constructor() {
		this.businessDivisionBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.CityResponseBean */
export class CityResponseBean {
	constructor() {
		this.cityBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.ColorResponseBean */
export class ColorResponseBean {
	constructor() {
		this.colorBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.CommentsResponseBean */
export class CommentsResponseBean {
	constructor() {
		this.commentBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.CompositionTypeResponseBean */
export class CompositionTypeResponseBean {
	constructor() {
		this.compositionTypeBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.CountryResponseBean */
export class CountryResponseBean {
	constructor() {
		this.countryBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.CreditMemoReasonResponseBean */
export class CreditMemoReasonResponseBean {
	constructor() {
		this.creditReason = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.CurrencyExchangeRateResponseBean */
export class CurrencyExchangeRateResponseBean {
	constructor() {
		this.currencyExchangeRateBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.CurrencyResponseBean */
export class CurrencyResponseBean {
	constructor() {
		this.currencyBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.CustomerDeliveryResponseBean */
export class CustomerDeliveryResponseBean {
	constructor() {
		this.customerDelivery = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.CustomerDivisionResponseBean */
export class CustomerDivisionResponseBean {
	constructor() {
		this.customerDivision = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.CustomerSalesZoneResponseBean */
export class CustomerSalesZoneResponseBean {
	constructor() {
		this.customerSalesZoneBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.CustomerSpecialTypeResponseBean */
export class CustomerSpecialTypeResponseBean {
	constructor() {
		this.customerSpecialType = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.CustomerTenderCancelReasonResponseBean */
export class CustomerTenderCancelReasonResponseBean {
	constructor() {
		this.customerTenderCancelReason = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.CustomerTenderReasonResponseBean */
export class CustomerTenderReasonResponseBean {
	constructor() {
		this.customerTenderReason = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.CustomerTenderUnApprovalReasonResponseBean */
export class CustomerTenderUnApprovalReasonResponseBean {
	constructor() {
		this.customerTenderUnApprovalReason = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.CustomerTypeResponseBean */
export class CustomerTypeResponseBean {
	constructor() {
		this.customerType = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.DepositCancelReasonPageListResponseBean */
export class DepositCancelReasonPageListResponseBean {
	constructor() {
		this.depositCancelReasonPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.DepositCancelReasonResponseBean */
export class DepositCancelReasonResponseBean {
	constructor() {
		this.depositCancelReason = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.DepositReversalReasonPageListResponseBean */
export class DepositReversalReasonPageListResponseBean {
	constructor() {
		this.depositReversalReasonPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.DepositReversalReasonResponseBean */
export class DepositReversalReasonResponseBean {
	constructor() {
		this.depositReversalReason = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.DocumentTypeResponseBean */
export class DocumentTypeResponseBean {
	constructor() {
		this.documentTypeBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.ExpenseSubTypePageListResponseBean */
export class ExpenseSubTypePageListResponseBean {
	constructor() {
		this.expenseSubTypePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.ExpenseSubTypeResponseBean */
export class ExpenseSubTypeResponseBean {
	constructor() {
		this.expenseSubType = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.ExpenseTypeResponseBean */
export class ExpenseTypeResponseBean {
	constructor() {
		this.expenseType = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.ExtraChargeReasonResponseBean */
export class ExtraChargeReasonResponseBean {
	constructor() {
		this.extraChargeReasonBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.FabricDetailPageListResponseBean */
export class FabricDetailPageListResponseBean {
	constructor() {
		this.fabricDetailPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.FabricDetailResponseBean */
export class FabricDetailResponseBean {
	constructor() {
		this.fabricDetail = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.FabricStyleLogisticPackageInfoResponseBean */
export class FabricStyleLogisticPackageInfoResponseBean {
	constructor() {
		this.fabricStyleLogisticPackageInfo = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.FabricVendorMiscellaneousCostDetailReasonPageListResponseBean */
export class FabricVendorMiscellaneousCostDetailReasonPageListResponseBean {
	constructor() {
		this.fabricVendorMiscellaneousCostDetailReasonPageListBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.FabricVendorMiscellaneousCostDetailResponseBean */
export class FabricVendorMiscellaneousCostDetailResponseBean {
	constructor() {
		this.fabricCostReasonBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.FinancialTypeResponseBean */
export class FinancialTypeResponseBean {
	constructor() {
		this.financialTypeBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.FiscalYearResponseBean */
export class FiscalYearResponseBean {
	constructor() {
		this.fiscalYear = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.FobCityResponseBean */
export class FobCityResponseBean {
	constructor() {
		this.fobCity = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.FreightMethodResponseBean */
export class FreightMethodResponseBean {
	constructor() {
		this.freightMethodBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.GeneralLedgerAccountResponseBean */
export class GeneralLedgerAccountResponseBean {
	constructor() {
		this.generalLedgerAccountBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.GeneralLedgerAccountTypeResponseBean */
export class GeneralLedgerAccountTypeResponseBean {
	constructor() {
		this.generalLedgerAccountTypeBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.HarmonizedTariffScheduleResponseBean */
export class HarmonizedTariffScheduleResponseBean {
	constructor() {
		this.htsBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.IncoTermResponseBean */
export class IncoTermResponseBean {
	constructor() {
		this.incoTermBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.InventoryAdjustmentReasonResponseBean */
export class InventoryAdjustmentReasonResponseBean {
	constructor() {
		this.inventoryAdjustmentReasonBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.InvoiceCancelReasonResponseBean */
export class InvoiceCancelReasonResponseBean {
	constructor() {
		this.invoiceCancelReason = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.InvoiceModelResponseBean */
export class InvoiceModelResponseBean {
	constructor() {
		this.invoiceModelBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.InvoiceNonMerchandiseReasonResponseBean */
export class InvoiceNonMerchandiseReasonResponseBean {
	constructor() {
		this.invoiceNonMerchandiseReason = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.InvoicePrintoutTypeResponseBean */
export class InvoicePrintoutTypeResponseBean {
	constructor() {
		this.invoicePrintoutTypeBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.InvoiceTemplateResponseBean */
export class InvoiceTemplateResponseBean {
	constructor() {
		this.invoiceTemplateBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.InvoiceUnApprovalReasonResponseBean */
export class InvoiceUnApprovalReasonResponseBean {
	constructor() {
		this.invoiceUnApprovalReason = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.LocationResponseBean */
export class LocationResponseBean {
	constructor() {
		this.locationBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.LogisticMethodResponseBean */
export class LogisticMethodResponseBean {
	constructor() {
		this.logisticMethod = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.MakeTypeResponseBean */
export class MakeTypeResponseBean {
	constructor() {
		this.makeTypeBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.MiscellaneousChargeReasonResponseBean */
export class MiscellaneousChargeReasonResponseBean {
	constructor() {
		this.miscChargeReasonBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.PatternTypeCategoryResponseBean */
export class PatternTypeCategoryResponseBean {
	constructor() {
		this.patternTypeCategoryBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.PatternTypeResponseBean */
export class PatternTypeResponseBean {
	constructor() {
		this.patternTypeBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.PaymentMethodResponseBean */
export class PaymentMethodResponseBean {
	constructor() {
		this.paymentMethodBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.PaymentTermResponseBean */
export class PaymentTermResponseBean {
	constructor() {
		this.paymentTerm = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.PeriodSalesCommissionAdjustmentReasonResponseBean */
export class PeriodSalesCommissionAdjustmentReasonResponseBean {
	constructor() {
		this.periodSalescommissionAdjustmentReason = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.PickTicketCancelReasonResponseBean */
export class PickTicketCancelReasonResponseBean {
	constructor() {
		this.pickTicketCancelReason = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.PreProductionChangeReasonResponseBean */
export class PreProductionChangeReasonResponseBean {
	constructor() {
		this.preProductionReasons = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.PreProductionOrderCancelReasonResponseBean */
export class PreProductionOrderCancelReasonResponseBean {
	constructor() {
		this.preProductionOrderCancelReason = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.PreProductionOrderUnApprovalReasonResponseBean */
export class PreProductionOrderUnApprovalReasonResponseBean {
	constructor() {
		this.preProductionOrderUnapprovalReason = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.ProductDivisionResponseBean */
export class ProductDivisionResponseBean {
	constructor() {
		this.productDivision = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.ProductSpecialResponseBean */
export class ProductSpecialResponseBean {
	constructor() {
		this.specialBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.ProductStatusResponseBean */
export class ProductStatusResponseBean {
	constructor() {
		this.productStatus = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.ProductTypeResponseBean */
export class ProductTypeResponseBean {
	constructor() {
		this.productTypeBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.PurchaseOrderCancelReasonResponseBean */
export class PurchaseOrderCancelReasonResponseBean {
	constructor() {
		this.purchaseOrderCancelReasonBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.PurchaseOrderExtraChargeReasonResponseBean */
export class PurchaseOrderExtraChargeReasonResponseBean {
	constructor() {
		this.purchaseOrderExtraChargeReasonResponseBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.PurchaseOrderModelResponseBean */
export class PurchaseOrderModelResponseBean {
	constructor() {
		this.purchaseOrderModel = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.PurchaseOrderUnApprovalReasonResponseBean */
export class PurchaseOrderUnApprovalReasonResponseBean {
	constructor() {
		this.purchaseOrderUnApprovalReason = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.RoyaltyClientResponseBean */
export class RoyaltyClientResponseBean {
	constructor() {
		this.royaltyClientBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.SeasonResponseBean */
export class SeasonResponseBean {
	constructor() {
		this.seasonBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.ServiceResponseBean */
export class ServiceResponseBean {
	constructor() {
		this.serviceBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.ShipmentTermResponseBean */
export class ShipmentTermResponseBean {
	constructor() {
		this.shipmentTermBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.ShipToResponseBean */
export class ShipToResponseBean {
	constructor() {
		this.shipToBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.ShipViaResponseBean */
export class ShipViaResponseBean {
	constructor() {
		this.shipViaBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.StageCollectionResponseBean */
export class StageCollectionResponseBean {
	constructor() {
		this.stageCollection = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.StageTypeResponseBean */
export class StageTypeResponseBean {
	constructor() {
		this.stageType = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.StateResponseBean */
export class StateResponseBean {
	constructor() {
		this.stateBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.StyleItemTypeResponseBean */
export class StyleItemTypeResponseBean {
	constructor() {
		this.styleItemTypeBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.TargetWebSiteDetailResponseBean */
export class TargetWebSiteDetailResponseBean {
	constructor() {
		this.targetWebsiteDetail = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.UOMResponseBean */
export class UOMResponseBean {
	constructor() {
		this.uom = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.VendorCategoryResponseBean */
export class VendorCategoryResponseBean {
	constructor() {
		this.vendorCategoryBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.VendorShipViaResponseBean */
export class VendorShipViaResponseBean {
	constructor() {
		this.vendorShipVia = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.VendorTermResponseBean */
export class VendorTermResponseBean {
	constructor() {
		this.vendorTerm = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.VendorTypeResponseBean */
export class VendorTypeResponseBean {
	constructor() {
		this.vendorType = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.response.WarehouseResponseBean */
export class WarehouseResponseBean {
	constructor() {
		this.warehouseBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.attributes.RoyaltyClientBean */
export class RoyaltyClientBean {
	constructor() {
		this.address = null ;
		this.remarks = '' ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.SalesOrderAdjustmentReasonBean */
export class SalesOrderAdjustmentReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.SalesOrderCancelReasonBean */
export class SalesOrderCancelReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.SalesOrderTypeBean */
export class SalesOrderTypeBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.SalesOrderUnApprovalReasonBean */
export class SalesOrderUnApprovalReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.SalesPersonBean */
export class SalesPersonBean {
	constructor() {
		this.commissionPercentage = 0 ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.SeasonBean */
export class SeasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.ServiceBean */
export class ServiceBean {
	constructor() {
		this.price = 0 ;
		this.quantity = 0 ;
		this.uomCode = '' ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.ShipmentTermBean */
export class ShipmentTermBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.ShipToBean */
export class ShipToBean {
	constructor() {
		this.shipToType = '' ;
		this.address = null ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.ShipToTypeBean */
export class ShipToTypeBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.ShipViaBean */
export class ShipViaBean {
	constructor() {
		this.oldSystemCode = '' ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.SpecialBean */
export class SpecialBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.StageCollectionBean */
export class StageCollectionBean {
	constructor() {
		this.companyCode = '' ;
		this.remarks = '' ;
		this.lines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.StageCollectionLineBean */
export class StageCollectionLineBean {
	constructor() {
		this.companyCode = '' ;
		this.stageCollectionCode = '' ;
		this.stageCode = '' ;
		this.orderSequence = 0 ;
		this.stageType = null ;
		this.duration = 0 ;
		this.leadTime = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.StageTypeBean */
export class StageTypeBean {
	constructor() {
		this.isUpdateRawMaterialInventory = false ;
		this.isUpdateFinishedInventory = false ;
		this.leadTime = 0 ;
		this.duration = 0 ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.StateBean */
export class StateBean {
	constructor() {
		this.countryCode = '' ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.StyleItemTypeBean */
export class StyleItemTypeBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.TargetWebSiteDetailBean */
export class TargetWebSiteDetailBean {
	constructor() {
		this.webExportTypCode = '' ;
		this.originalOrderSource = '' ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.TransactionTypeBean */
export class TransactionTypeBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.UOMBean */
export class UOMBean {
	constructor() {
		this.uomType = 0 ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.VendorCategoryBean */
export class VendorCategoryBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.VendorInvoiceCancelReasonBean */
export class VendorInvoiceCancelReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.VendorInvoiceMiscellaneousReasonBean */
export class VendorInvoiceMiscellaneousReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.VendorInvoiceUnApprovalReasonBean */
export class VendorInvoiceUnApprovalReasonBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.VendorShipViaBean */
export class VendorShipViaBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.VendorTermBean */
export class VendorTermBean {
	constructor() {
		this.termType = 0 ;
		this.termDays = 0 ;
		this.discountableDays = 0 ;
		this.lastDayOfMonthForInvoiceReceiveDate = 0 ;
		this.discountPercentage = 0 ;
		this.interestRate = 0 ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.VendorTypeBean */
export class VendorTypeBean {
	constructor() {
		this.discountPercentage = 0 ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.WarehouseBean */
export class WarehouseBean {
	constructor() {
		this.warehouseType = 0 ;
		this.address = null ;
		this.isHoldingWareHouse = false ;
		this.isInitialInventoryWareHouse = false ;
		this.isReservedWareHouse = false ;
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.attributes.WebExportTypeBean */
export class WebExportTypeBean {
	constructor() {
		this.internalTypeCode = '' ;
		this.companyCode = '' ;
		this.isDefault = false ;
		this.displayOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.BeanConst */
export class BeanConst {
	constructor() {
	}
}
/* ds.cpm.CriticalPathManagementBean */
export class CriticalPathManagementBean {
	constructor() {
		this.companyCode = '' ;
		this.cpmDate = '' ;
		this.cpmStatus = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.containerNumber = '' ;
		this.warehousePurchaseOrderNumber = '' ;
		this.inBoundOrderNumber = '' ;
		this.inBoundOrderReceiptNumber = '' ;
		this.salesOrderNumber = '' ;
		this.pickTicketNumber = '' ;
		this.templateCode = '' ;
		this.changeHistories = new Array() ;
		this.statusTracks = new Array() ;
		this.cmpLineBean = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.cpm.CriticalPathManagementDependenciesResponseBean */
export class CriticalPathManagementDependenciesResponseBean {
	constructor() {
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.cpm.CriticalPathManagementHistoryBean */
export class CriticalPathManagementHistoryBean {
	constructor() {
		this.criticalPathMangementNumber = '' ;
		this.trackNumber = 0 ;
		this.companyCode = '' ;
		this.workStationCode = '' ;
		this.workStationIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.cpm.CriticalPathManagementLineBean */
export class CriticalPathManagementLineBean {
	constructor() {
		this.cpmCode = '' ;
		this.cpmLineNumber = 0 ;
		this.cpmTemplateCode = '' ;
		this.companyCode = '' ;
		this.taskCode = '' ;
		this.taskName = '' ;
		this.scheduledDate = '' ;
		this.startDate = '' ;
		this.endDate = '' ;
		this.scheduledTime = '' ;
		this.startTime = '' ;
		this.endTime = '' ;
		this.comments = '' ;
		this.lineStatus = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.cpm.CriticalPathManagementStatusTrackBean */
export class CriticalPathManagementStatusTrackBean {
	constructor() {
		this.criticalPathMangementNumber = '' ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.cpm.CriticalPathManagementTemplateBean */
export class CriticalPathManagementTemplateBean {
	constructor() {
		this.companyCode = '' ;
		this.templateName = '' ;
		this.templateTasks = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.cpm.CriticalPathManagementTemplateDependenciesBean */
export class CriticalPathManagementTemplateDependenciesBean {
	constructor() {
		this.templateTasks = new Array() ;
	}
}
/* ds.cpm.CriticalPathManagementTemplateDependenciesResponseBean */
export class CriticalPathManagementTemplateDependenciesResponseBean {
	constructor() {
		this.templateDependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.cpm.CriticalPathManagementTemplateTaskBean */
export class CriticalPathManagementTemplateTaskBean {
	constructor() {
		this.cpmTemplateCode = '' ;
		this.companyCode = '' ;
		this.taskCode = '' ;
		this.taskName = '' ;
		this.scheduledDate = '' ;
		this.startDate = '' ;
		this.endDate = '' ;
		this.scheduledTime = '' ;
		this.startTime = '' ;
		this.endTime = '' ;
		this.comments = '' ;
		this.taskSequence = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.cpm.merge.repsonse.CriticalPathManagementMergeOperationsResponseBean */
export class CriticalPathManagementMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.lockResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.cpm.merge.repsonse.CriticalPathManagementMergeResponseBean */
export class CriticalPathManagementMergeResponseBean {
	constructor() {
		this.cpmResponseBean = null ;
		this.lockResponse = null ;
		this.cpmDependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.cpm.merge.repsonse.CriticalPathManagementTemplateMergeResponseBean */
export class CriticalPathManagementTemplateMergeResponseBean {
	constructor() {
		this.templateResponseBean = null ;
		this.lockResponse = null ;
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.cpm.response.CriticalPathManagementPageListBean */
export class CriticalPathManagementPageListBean {
	constructor() {
		this.cpmBean = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.cpm.response.CriticalPathManagementPageListResponseBean */
export class CriticalPathManagementPageListResponseBean {
	constructor() {
		this.cpmPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.cpm.response.CriticalPathManagementResponseBean */
export class CriticalPathManagementResponseBean {
	constructor() {
		this.cpmBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.cpm.response.CriticalPathManagementTemplatePageListBean */
export class CriticalPathManagementTemplatePageListBean {
	constructor() {
		this.cpmTemplates = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.cpm.response.CriticalPathManagementTemplatePageListResponseBean */
export class CriticalPathManagementTemplatePageListResponseBean {
	constructor() {
		this.cpmTemplatePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.cpm.response.CriticalPathManagementTemplateResponseBean */
export class CriticalPathManagementTemplateResponseBean {
	constructor() {
		this.cpmTemplateBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.creditmemo.CreditMemoAppliedInvoicesBean */
export class CreditMemoAppliedInvoicesBean {
	constructor() {
		this.companyCode = '' ;
		this.creditMemoNumber = '' ;
		this.invoiceNumber = '' ;
		this.arNumber = '' ;
		this.invoiceDate = '' ;
		this.arDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.currencyCode = '' ;
		this.grandTotalAmount = 0 ;
		this.openAmount = 0 ;
		this.appliedAmount = 0 ;
		this.paidAmount = 0 ;
		this.creditMemoAppliedAmount = 0 ;
		this.status = '' ;
	}
}
/* ds.creditmemo.CreditMemoBean */
export class CreditMemoBean {
	constructor() {
		this.companyCode = '' ;
		this.creditMemoStatus = '' ;
		this.customerCode = '' ;
		this.billToCode = '' ;
		this.customerName = '' ;
		this.creditMemoDate = '' ;
		this.customerCurrencyCode = '' ;
		this.companyCurrencyCode = '' ;
		this.creditType = '' ;
		this.invoiceNumber = '' ;
		this.isCommissionAdjustmentFlag = false ;
		this.isUpdateInventory = false ;
		this.nonMerchandiseCreditAmount = 0 ;
		this.merchandiseCreditAmount = 0 ;
		this.totalCreditAmount = 0 ;
		this.provisionalAppliedAmount = 0 ;
		this.appliedAmount = 0 ;
		this.createdSourceType = '' ;
		this.createdSourceEntityNumber = '' ;
		this.comments = '' ;
		this.isGeneratedForDiscountAmount = false ;
		this.standardTotalCreditAmount = 0 ;
		this.standardAppliedAmount = 0 ;
		this.currencyExchangeRate = 0 ;
		this.currencyExchangeRateCode = '' ;
		this.autoGeneratedARNumberForInvoiceApply = '' ;
		this.returnAmount = 0 ;
		this.nonMerchandiseLines = new Array() ;
		this.merchandiseLines = new Array() ;
		this.creditMemoSalesPersons = new Array() ;
		this.statusTracks = new Array() ;
		this.returnPaymentDetails = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.creditmemo.CreditMemoElementHistoryTrackBean */
export class CreditMemoElementHistoryTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.creditMemoCode = '' ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.creditmemo.CreditMemoForFabricStyleStatisticsBean */
export class CreditMemoForFabricStyleStatisticsBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.creditMemoNumber = '' ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.creditMemoReason = '' ;
		this.uomCode = '' ;
		this.quantity = 0 ;
		this.creditMemoDate = '' ;
	}
}
/* ds.creditmemo.CreditMemoForFabricStyleStatisticsResultBean */
export class CreditMemoForFabricStyleStatisticsResultBean {
	constructor() {
		this.creditMemos = new Array() ;
	}
}
/* ds.creditmemo.CreditMemoMerchandiseLineBean */
export class CreditMemoMerchandiseLineBean {
	constructor() {
		this.companyCode = '' ;
		this.creditMemoNumber = '' ;
		this.invoiceNumber = '' ;
		this.lineTotalReturnQuantity = 0 ;
		this.currencyCode = '' ;
		this.lineTotalAmount = 0 ;
		this.creditSubType = '' ;
		this.lineNumber = 0 ;
		this.locationCode = '' ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.lineStatus = '' ;
		this.skuNumber = 0 ;
		this.upcCode = '' ;
		this.uomCode = '' ;
		this.price = 0 ;
		this.extraPrice = 0 ;
		this.discount = 0 ;
		this.cost = 0 ;
		this.extraCharge = 0 ;
		this.productDivisionCode = '' ;
		this.productDepartmentCode = '' ;
		this.productClassCode = '' ;
		this.productSubClassCode = '' ;
		this.remarks = '' ;
		this.comments = '' ;
		this.isUpdateInventory = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.creditmemo.CreditMemoNonMerchandiseLineBean */
export class CreditMemoNonMerchandiseLineBean {
	constructor() {
		this.companyCode = '' ;
		this.creditMemoNumber = '' ;
		this.lineNumber = 0 ;
		this.lineTotalAmount = 0 ;
		this.creditSubType = '' ;
		this.documentType = '' ;
		this.documentNumber = '' ;
		this.currencyCode = '' ;
		this.lineStatus = '' ;
		this.remarks = '' ;
		this.comments = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.creditmemo.CreditMemoRefundDetailsBean */
export class CreditMemoRefundDetailsBean {
	constructor() {
		this.creditMemoNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.totalCreditAmount = 0 ;
		this.remainingCreditAmount = 0 ;
		this.previousRefundAmount = 0 ;
		this.refundAmount = 0 ;
		this.cashAmount = 0 ;
		this.checkAmount = 0 ;
		this.checkNumber = '' ;
		this.checkDate = '' ;
		this.cardAmount = 0 ;
		this.cardNumber = '' ;
		this.cardType = '' ;
		this.cardHolderName = '' ;
		this.currencyCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.creditmemo.CreditMemoReturnPaymentDetailBean */
export class CreditMemoReturnPaymentDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.creditMemoNumber = '' ;
		this.lineNumber = 0 ;
		this.cashAmount = 0 ;
		this.checkAmount = 0 ;
		this.checkNumber = '' ;
		this.bankName = '' ;
		this.cardAmount = 0 ;
		this.cardNumber = '' ;
		this.cardType = '' ;
		this.cardHolderName = '' ;
		this.cardCVVNumber = '' ;
		this.cardExpiryYear = '' ;
		this.cardExpiryMonth = '' ;
		this.currencyCode = '' ;
		this.cardTransactionGateWayName = '' ;
		this.cardTransactionReferenceNumber = '' ;
		this.checkDate = '' ;
		this.transactionDate = '' ;
		this.cardAuthorizationCode = '' ;
		this.cardAuthorizationTransactionReferenceNumber = '' ;
		this.remarks = '' ;
		this.documentType = '' ;
		this.documentNumber = '' ;
		this.transactionAuthorizationNumber = '' ;
		this.processInGatewayRequired = false ;
		this.returnPaymentReferenceNumber = '' ;
		this.creditMemoReturnPaymentDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.creditmemo.CreditMemoSalesPersonBean */
export class CreditMemoSalesPersonBean {
	constructor() {
		this.companyCode = '' ;
		this.creditMemoNumber = '' ;
		this.lineNumber = 0 ;
		this.salesPersonCode = '' ;
		this.commissionDeductionPercentage = 0 ;
		this.reasonCode = '' ;
		this.remarks = '' ;
		this.lineStatus = '' ;
		this.currencyCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.creditmemo.CreditMemoStatusTrackBean */
export class CreditMemoStatusTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.creditMemoNumber = '' ;
		this.totalCreditAmount = 0 ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.creditmemo.criteria.CreditMemoSearchCriteria */
export class CreditMemoSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.creditMemoNumber = '' ;
		this.customerCode = '' ;
		this.creditMemoStatus = '' ;
		this.creditMemoNumberContains = '' ;
		this.creditMemoNumberStartsWith = '' ;
		this.lastModificationTrackNumber = 0 ;
		this.createdDate = '' ;
		this.creditMemoType = '' ;
		this.invoiceNumber = '' ;
		this.startDate = '' ;
		this.stopDate = '' ;
		this.creditMemoStatusList = new Array() ;
	}
}
/* ds.creditmemo.deps.CreditMemoModuleDependenciesBean */
export class CreditMemoModuleDependenciesBean {
	constructor() {
	}
}
/* ds.creditmemo.deps.response.CreditMemoModuleDependenciesResponseBean */
export class CreditMemoModuleDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.creditmemo.merge.response.CreditMemoMergeOperationsResponseBean */
export class CreditMemoMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.printReportResponse = null ;
		this.lockResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.creditmemo.merge.response.CreditMemoModuleMergeResponseBean */
export class CreditMemoModuleMergeResponseBean {
	constructor() {
		this.creditMemoResponse = null ;
		this.lockResponse = null ;
		this.dependenciesResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.creditmemo.pagelist.CreditMemoAppliedInvoicesPageListBean */
export class CreditMemoAppliedInvoicesPageListBean {
	constructor() {
		this.appliedInvoices = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.creditmemo.pagelist.CreditMemoPageListBean */
export class CreditMemoPageListBean {
	constructor() {
		this.creditMemos = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.creditmemo.pagelist.response.CreditMemoAppliedInvoicesPageListResponseBean */
export class CreditMemoAppliedInvoicesPageListResponseBean {
	constructor() {
		this.pageListBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.creditmemo.pagelist.response.CreditMemoPageListResponseBean */
export class CreditMemoPageListResponseBean {
	constructor() {
		this.creditMemoPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.creditmemo.response.CreditMemoForFabricStyleStatisticsResultResponseBean */
export class CreditMemoForFabricStyleStatisticsResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.creditmemo.response.CreditMemoResponseBean */
export class CreditMemoResponseBean {
	constructor() {
		this.creditMemo = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.creditmemo.response.CreditMemoReturnPaymentResponseBean */
export class CreditMemoReturnPaymentResponseBean {
	constructor() {
		this.creditMemoReturn = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.creditmemo.response.CreditMemoRollLinesForInvoicesResponseBean */
export class CreditMemoRollLinesForInvoicesResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.customerallocation.criteria.ManualInventoryCustomerAllocationSearchCriteria */
export class ManualInventoryCustomerAllocationSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerAllocationCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.startDate = '' ;
		this.stopDate = '' ;
		this.status = '' ;
		this.locationCode = '' ;
		this.excludedLocationCodes = new Array() ;
	}
}
/* ds.customerallocation.ManualInventoryCustomerAllocationBean */
export class ManualInventoryCustomerAllocationBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.startDate = '' ;
		this.stopDate = '' ;
		this.status = '' ;
		this.allocatedQuantity = 0 ;
		this.locationCode = '' ;
		this.isCancelAllocation = false ;
		this.widthCode = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.customerallocation.ManualInventoryCustomerAllocationPageListBean */
export class ManualInventoryCustomerAllocationPageListBean {
	constructor() {
		this.customerAllocations = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.customerallocation.response.ManualInventoryCustomerAllocationMergeResponseBean */
export class ManualInventoryCustomerAllocationMergeResponseBean {
	constructor() {
		this.customerAllocationResponse = null ;
		this.lockResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.customerallocation.response.ManualInventoryCustomerAllocationPageListResponseBean */
export class ManualInventoryCustomerAllocationPageListResponseBean {
	constructor() {
		this.customerAllocationPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.customerallocation.response.ManualInventoryCustomerAllocationResponseBean */
export class ManualInventoryCustomerAllocationResponseBean {
	constructor() {
		this.customerAllocation = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.customerportal.CustomerUserBean */
export class CustomerUserBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.userCode = '' ;
		this.description = '' ;
		this.password = '' ;
		this.loginType = '' ;
		this.isUserGroup = false ;
		this.userGroupCode = '' ;
		this.firstName = '' ;
		this.lastName = '' ;
		this.portalUserFlag = false ;
		this.orderTypeUserFlag = false ;
		this.isDataPortalUser = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.customerportal.CustomerUserPageListBean */
export class CustomerUserPageListBean {
	constructor() {
		this.customerUsers = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.customerportal.CustomerUserPageListResponseBean */
export class CustomerUserPageListResponseBean {
	constructor() {
		this.customerUserPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.customerportal.CustomerUserResponseBean */
export class CustomerUserResponseBean {
	constructor() {
		this.customerUser = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.customerportal.CustomerUserSearchCriteria */
export class CustomerUserSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerUserCode = '' ;
		this.loginType = '' ;
	}
}
/* ds.customerreturn.criteria.CustomerReturnSearchCriteria */
export class CustomerReturnSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerReturnNumber = '' ;
		this.customerCode = '' ;
		this.customerReturnStatus = '' ;
		this.customerReturnNumberContains = '' ;
		this.customerReturnNumberStartsWith = '' ;
		this.lastModificationTrackNumber = 0 ;
		this.createdDate = '' ;
		this.customerReturnType = '' ;
		this.invoiceNumber = '' ;
		this.customerReturnStatusList = new Array() ;
	}
}
/* ds.customerreturn.CustomerReturnBean */
export class CustomerReturnBean {
	constructor() {
		this.companyCode = '' ;
		this.customerReturnStatus = '' ;
		this.customerCode = '' ;
		this.billToCode = '' ;
		this.customerName = '' ;
		this.customerReturnDate = '' ;
		this.customerCurrencyCode = '' ;
		this.companyCurrencyCode = '' ;
		this.invoiceNumber = '' ;
		this.isCommissionAdjustmentFlag = false ;
		this.isUpdateInventory = false ;
		this.merchandiseReturnAmount = 0 ;
		this.totalReturnAmount = 0 ;
		this.provisionalAppliedAmount = 0 ;
		this.appliedAmount = 0 ;
		this.createdSourceType = '' ;
		this.createdSourceEntityNumber = '' ;
		this.comments = '' ;
		this.isGeneratedForDiscountAmount = false ;
		this.standardTotalReturnAmount = 0 ;
		this.standardAppliedAmount = 0 ;
		this.currencyExchangeRate = 0 ;
		this.currencyExchangeRateCode = '' ;
		this.autoGeneratedARNumberForInvoiceApply = '' ;
		this.creditMemoReferenceNumber = '' ;
		this.returnAmount = 0 ;
		this.merchandiseLines = new Array() ;
		this.statusTracks = new Array() ;
		this.returnPaymentDetails = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.customerreturn.CustomerReturnMerchandiseLineBean */
export class CustomerReturnMerchandiseLineBean {
	constructor() {
		this.companyCode = '' ;
		this.customerReturnNumber = '' ;
		this.invoiceNumber = '' ;
		this.lineTotalReturnQuantity = 0 ;
		this.currencyCode = '' ;
		this.lineTotalAmount = 0 ;
		this.lineNumber = 0 ;
		this.locationCode = '' ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.lineStatus = '' ;
		this.skuNumber = 0 ;
		this.upcCode = '' ;
		this.uomCode = '' ;
		this.price = 0 ;
		this.extraPrice = 0 ;
		this.discount = 0 ;
		this.cost = 0 ;
		this.extraCharge = 0 ;
		this.productDivisionCode = '' ;
		this.productDepartmentCode = '' ;
		this.productClassCode = '' ;
		this.productSubClassCode = '' ;
		this.remarks = '' ;
		this.comments = '' ;
		this.invoiceLineNumber = 0 ;
		this.isUpdateInventory = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.customerreturn.CustomerReturnPaymentDetailBean */
export class CustomerReturnPaymentDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.customerReturnNumber = '' ;
		this.lineNumber = 0 ;
		this.cashAmount = 0 ;
		this.checkAmount = 0 ;
		this.checkNumber = '' ;
		this.bankName = '' ;
		this.cardAmount = 0 ;
		this.cardNumber = '' ;
		this.cardType = '' ;
		this.cardHolderName = '' ;
		this.cardCVVNumber = '' ;
		this.cardExpiryYear = '' ;
		this.cardExpiryMonth = '' ;
		this.currencyCode = '' ;
		this.cardTransactionGateWayName = '' ;
		this.cardTransactionReferenceNumber = '' ;
		this.checkDate = '' ;
		this.transactionDate = '' ;
		this.cardAuthorizationCode = '' ;
		this.cardAuthorizationTransactionReferenceNumber = '' ;
		this.remarks = '' ;
		this.documentType = '' ;
		this.documentNumber = '' ;
		this.transactionAuthorizationNumber = '' ;
		this.processInGatewayRequired = false ;
		this.returnPaymentReferenceNumber = '' ;
		this.customerReturnPaymentDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.customerreturn.CustomerReturnStatusTrackBean */
export class CustomerReturnStatusTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.customerReturnNumber = '' ;
		this.totalReturnAmount = 0 ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.customerreturn.deps.CustomerReturnModuleDependenciesBean */
export class CustomerReturnModuleDependenciesBean {
	constructor() {
	}
}
/* ds.customerreturn.deps.response.CustomerReturnModuleDependenciesResponseBean */
export class CustomerReturnModuleDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.customerreturn.merge.response.CustomerReturnMergeOperationsResponseBean */
export class CustomerReturnMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.printReportResponse = null ;
		this.lockResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.customerreturn.merge.response.CustomerReturnModuleMergeResponseBean */
export class CustomerReturnModuleMergeResponseBean {
	constructor() {
		this.customerReturnResponse = null ;
		this.lockResponse = null ;
		this.dependenciesResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.customerreturn.pagelist.CustomerReturnPageListBean */
export class CustomerReturnPageListBean {
	constructor() {
		this.customerReturns = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.customerreturn.pagelist.response.CustomerReturnPageListResponseBean */
export class CustomerReturnPageListResponseBean {
	constructor() {
		this.customerReturnPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.customerreturn.response.CustomerReturnResponseBean */
export class CustomerReturnResponseBean {
	constructor() {
		this.customerReturn = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.dashboard.BarchartDataBean */
export class BarchartDataBean {
	constructor() {
		this.category = '' ;
		this.value = 0 ;
		this.uomCode = '' ;
		this.currencyCode = '' ;
		this.name = '' ;
	}
}
/* ds.dashboard.DashBoardApprovalBean */
export class DashBoardApprovalBean {
	constructor() {
		this.userCode = '' ;
		this.companyCode = '' ;
		this.entityType = 0 ;
		this.entityCreatedBy = '' ;
		this.entityCreatedOn = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.dashboard.DashBoardApprovalContentBean */
export class DashBoardApprovalContentBean {
	constructor() {
		this.purchaseOrderApprovals = new Array() ;
		this.purchaseOrderUnApprovals = new Array() ;
		this.salesOrderApprovals = new Array() ;
		this.salesOrderUnApprovals = new Array() ;
		this.logisticOrderApprovals = new Array() ;
		this.logisticOrderUnApprovals = new Array() ;
		this.logisticOrderReceiptUnApprovals = new Array() ;
		this.purchaseOrderReceiptUnApprovals = new Array() ;
		this.invoiceUnApprovals = new Array() ;
		this.purchaseInTransitUnApprovals = new Array() ;
	}
}
/* ds.dashboard.DashBoardContentBean */
export class DashBoardContentBean {
	constructor() {
		this.approvalContents = null ;
		this.unApprovalContents = null ;
		this.fabricATSContentBean = null ;
		this.latePurchaseOrderContentBean = null ;
		this.dueCustomerInvoiceContentBean = null ;
		this.packedNotInvoicedContentBean = null ;
		this.shippedNotInvoicedContentBean = null ;
		this.summaryBean = null ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.dashboard.DashBoardDueInvoiceContentBean */
export class DashBoardDueInvoiceContentBean {
	constructor() {
		this.companyCode = '' ;
		this.dueInvoices = new Array() ;
	}
}
/* ds.dashboard.DashBoardFabricATSContentBean */
export class DashBoardFabricATSContentBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricCurrentAtsInfoBeans = new Array() ;
	}
}
/* ds.dashboard.DashBoardLatePurchaseOrderContentBean */
export class DashBoardLatePurchaseOrderContentBean {
	constructor() {
		this.companyCode = '' ;
		this.latePurchaseOrderDetailBeans = new Array() ;
	}
}
/* ds.dashboard.DashboardPackedNotInvoicedContentBean */
export class DashboardPackedNotInvoicedContentBean {
	constructor() {
		this.companyCode = '' ;
		this.pickedNotInvoiceInfoBean = new Array() ;
	}
}
/* ds.dashboard.DashBoardShippedNotInvoicedContentBean */
export class DashBoardShippedNotInvoicedContentBean {
	constructor() {
		this.companyCode = '' ;
		this.pickedNotInvoiceInfoBean = new Array() ;
	}
}
/* ds.dashboard.DashboardSummaryBean */
export class DashboardSummaryBean {
	constructor() {
		this.totalSalesOrders = 0 ;
		this.pendingSalesOrderApprovals = 0 ;
		this.weeklyGrowthPercentage = 0 ;
		this.customerOverDueAmount = 0 ;
		this.overdueCustomers = 0 ;
		this.avgLateDays = 0 ;
		this.purchasingAwaitingApprovalAmount = 0 ;
		this.avgApprovalDays = 0 ;
		this.openCreditMemoAmount = 0 ;
		this.openCreditMemoCount = 0 ;
	}
}
/* ds.dashboard.InvoiceDashBoardApprovalBean */
export class InvoiceDashBoardApprovalBean {
	constructor() {
		this.invoiceNumber = '' ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.entityType = 0 ;
		this.customerName = '' ;
		this.deliveryDate = '' ;
		this.invoiceAmount = 0 ;
		this.userCode = '' ;
		this.companyCode = '' ;
		this.entityType = 0 ;
		this.entityCreatedBy = '' ;
		this.entityCreatedOn = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.dashboard.LogisticOrderDashBoardApprovalBean */
export class LogisticOrderDashBoardApprovalBean {
	constructor() {
		this.logisticOrderNumber = '' ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.entityType = 0 ;
		this.customerName = '' ;
		this.orderDate = '' ;
		this.orderQuantity = 0 ;
		this.userCode = '' ;
		this.companyCode = '' ;
		this.entityType = 0 ;
		this.entityCreatedBy = '' ;
		this.entityCreatedOn = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.dashboard.LogisticOrderReceiptDashBoardApprovalBean */
export class LogisticOrderReceiptDashBoardApprovalBean {
	constructor() {
		this.logisticOrderReceiptNumber = '' ;
		this.logisticOrderNumber = '' ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.entityType = 0 ;
		this.customerName = '' ;
		this.receiptDate = '' ;
		this.userCode = '' ;
		this.companyCode = '' ;
		this.entityType = 0 ;
		this.entityCreatedBy = '' ;
		this.entityCreatedOn = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.dashboard.PieChartDataBean */
export class PieChartDataBean {
	constructor() {
		this.labelName = '' ;
		this.value = 0 ;
	}
}
/* ds.dashboard.PurchaseInTransitDashBoardApprovalBean */
export class PurchaseInTransitDashBoardApprovalBean {
	constructor() {
		this.purchaseInTransitNumber = '' ;
		this.purchaseOrderNumber = '' ;
		this.vendorCode = '' ;
		this.entityType = 0 ;
		this.vendorName = '' ;
		this.inTransitDate = '' ;
		this.etaDate = '' ;
		this.containerNumber = '' ;
		this.billOfLading = '' ;
		this.businessDivision = '' ;
		this.userCode = '' ;
		this.companyCode = '' ;
		this.entityType = 0 ;
		this.entityCreatedBy = '' ;
		this.entityCreatedOn = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.dashboard.PurchaseOrderDashBoardApprovalBean */
export class PurchaseOrderDashBoardApprovalBean {
	constructor() {
		this.purchaseOrderNumber = '' ;
		this.vendorCode = '' ;
		this.entityType = 0 ;
		this.vendorName = '' ;
		this.orderStopDate = '' ;
		this.orderDate = '' ;
		this.orderAmount = 0 ;
		this.userCode = '' ;
		this.companyCode = '' ;
		this.entityType = 0 ;
		this.entityCreatedBy = '' ;
		this.entityCreatedOn = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.dashboard.PurchaseOrderReceiptDashBoardApprovalBean */
export class PurchaseOrderReceiptDashBoardApprovalBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.purchaseOrderNumber = '' ;
		this.vendorCode = '' ;
		this.entityType = 0 ;
		this.vendorName = '' ;
		this.receiptDate = '' ;
		this.userCode = '' ;
		this.companyCode = '' ;
		this.entityType = 0 ;
		this.entityCreatedBy = '' ;
		this.entityCreatedOn = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.dashboard.response.DashBoardContentResponseBean */
export class DashBoardContentResponseBean {
	constructor() {
		this.contentBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.dashboard.response.FabricStylePieChartResultResponseBean */
export class FabricStylePieChartResultResponseBean {
	constructor() {
		this.topN = null ;
		this.others = null ;
		this.otherItems = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.dashboard.SalesOrderDashBoardApprovalBean */
export class SalesOrderDashBoardApprovalBean {
	constructor() {
		this.salesOrderNumber = '' ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.entityType = 0 ;
		this.customerName = '' ;
		this.orderStopDate = '' ;
		this.orderAmount = 0 ;
		this.userCode = '' ;
		this.companyCode = '' ;
		this.entityType = 0 ;
		this.entityCreatedBy = '' ;
		this.entityCreatedOn = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.debitmemo.criteria.DebitMemoSearchCriteria */
export class DebitMemoSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.debitMemoNumber = '' ;
		this.vendorCode = '' ;
		this.debitMemoStatus = '' ;
		this.debitMemoNumberContains = '' ;
		this.debitMemoNumberStartsWith = '' ;
		this.createdDate = '' ;
		this.debitMemoType = '' ;
		this.purchaseOrderNumber = '' ;
		this.debitMemoStatusList = new Array() ;
		this.debitMemoList = new Array() ;
	}
}
/* ds.debitmemo.DebitMemoBean */
export class DebitMemoBean {
	constructor() {
		this.companyCode = '' ;
		this.debitMemoStatus = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.debitMemoType = '' ;
		this.debitMemoAmount = 0 ;
		this.appliedAmount = 0 ;
		this.openAmount = 0 ;
		this.purchaseOrderNumber = '' ;
		this.comments = '' ;
		this.isUpdateInventory = false ;
		this.statusTracks = new Array() ;
		this.returnLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.debitmemo.DebitMemoReturnLineBean */
export class DebitMemoReturnLineBean {
	constructor() {
		this.companyCode = '' ;
		this.debitMemoNumber = '' ;
		this.lineTotalReturnQuantity = 0 ;
		this.currencyCode = '' ;
		this.upcCode = '' ;
		this.lineNumber = 0 ;
		this.locationCode = '' ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.lineStatus = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.remarks = '' ;
		this.comments = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.isUpdateInventory = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.debitmemo.DebitMemoStatusTrackBean */
export class DebitMemoStatusTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.debitMemoNumber = '' ;
		this.totalDebitAmount = 0 ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.debitmemo.deps.DebitMemoModuleDependenciesBean */
export class DebitMemoModuleDependenciesBean {
	constructor() {
	}
}
/* ds.debitmemo.deps.response.DebitMemoModuleDependenciesResponseBean */
export class DebitMemoModuleDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.debitmemo.merge.response.DebitMemoMergeOperationsResponseBean */
export class DebitMemoMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.printReportResponse = null ;
		this.lockResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.debitmemo.merge.response.DebitMemoModuleMergeResponseBean */
export class DebitMemoModuleMergeResponseBean {
	constructor() {
		this.debitMemoResponse = null ;
		this.lockResponse = null ;
		this.dependenciesResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.debitmemo.pagelist.DebitMemoPageListBean */
export class DebitMemoPageListBean {
	constructor() {
		this.debitMemos = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.debitmemo.pagelist.response.DebitMemoPageListResponseBean */
export class DebitMemoPageListResponseBean {
	constructor() {
		this.debitMemoPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.debitmemo.response.DebitMemoResponseBean */
export class DebitMemoResponseBean {
	constructor() {
		this.debitMemo = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.delete.track.DeletedPurchaseOrderInTransitTrackBean */
export class DeletedPurchaseOrderInTransitTrackBean {
	constructor() {
		this.deletedInTransitLineId = 0 ;
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.transitDate = '' ;
		this.isSynchronised = false ;
		this.syncronisedDate = '' ;
		this.syncronisedBy = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.delete.track.DeletedPurchaseOrderLineTrackBean */
export class DeletedPurchaseOrderLineTrackBean {
	constructor() {
		this.deletedPurchaseLineId = 0 ;
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.lineStatus = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.isSynchronised = false ;
		this.syncronisedDate = '' ;
		this.syncronisedBy = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.delete.track.DeletedPurchaseOrderTrackBean */
export class DeletedPurchaseOrderTrackBean {
	constructor() {
		this.deletedPurchaseOrderId = 0 ;
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.orderDate = '' ;
		this.orderStatus = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.etaDate = '' ;
		this.shipToCode = '' ;
		this.locationCode = '' ;
		this.isSynchronised = false ;
		this.syncronisedDate = '' ;
		this.syncronisedBy = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.delete.track.DeletedSalesOrderLineTrackBean */
export class DeletedSalesOrderLineTrackBean {
	constructor() {
		this.deletedSalesLineId = 0 ;
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.salesOrderLineNumber = 0 ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.lineStatus = '' ;
		this.skuNumber = 0 ;
		this.isSynchronised = false ;
		this.syncronisedDate = '' ;
		this.syncronisedBy = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.delete.track.DeletedSalesOrderTrackBean */
export class DeletedSalesOrderTrackBean {
	constructor() {
		this.deletedSalesOrderId = 0 ;
		this.companyCode = '' ;
		this.orderStatus = '' ;
		this.createdDate = '' ;
		this.orderDate = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.shipToCode = '' ;
		this.shipToName = '' ;
		this.billToCode = '' ;
		this.shipViaCode = '' ;
		this.isSynchronised = false ;
		this.syncronisedDate = '' ;
		this.syncronisedBy = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.delete.track.DeletedSKUBatchInventoryTrackBean */
export class DeletedSKUBatchInventoryTrackBean {
	constructor() {
		this.deletedSkuBatchInventoryId = 0 ;
		this.companyCode = '' ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.isSynchronised = false ;
		this.syncronisedDate = '' ;
		this.syncronisedBy = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.delete.track.PortalModifiedPurchaseOrderTrackLineTrackBean */
export class PortalModifiedPurchaseOrderTrackLineTrackBean {
	constructor() {
		this.modifiedPurchaseLineId = 0 ;
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.portalModificationTrackNumber = 0 ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.ecom.dataexport.ShopifyImageBean */
export class ShopifyImageBean {
	constructor() {
		this.id = 0 ;
		this.productId = 0 ;
		this.position = 0 ;
		this.createdAt = '' ;
		this.updatedAt = '' ;
		this.alt = null ;
		this.width = 0 ;
		this.height = 0 ;
		this.src = '' ;
		this.variantIds = null ;
		this.adminGraphqlApiId = '' ;
		this.additionalProperties = null ;
	}
}
/* ds.ecom.dataexport.ShopifyInventoryLevelBean */
export class ShopifyInventoryLevelBean {
	constructor() {
		this.inventoryItemId = 0 ;
		this.locationId = 0 ;
		this.available = 0 ;
		this.updatedAt = '' ;
		this.adminGraphqlApiId = '' ;
		this.additionalProperties = null ;
	}
}
/* ds.ecom.dataexport.ShopifyInventoryLevelsBean */
export class ShopifyInventoryLevelsBean {
	constructor() {
		this.inventoryLevels = null ;
		this.additionalProperties = null ;
	}
}
/* ds.ecom.dataexport.ShopifyOptionBean */
export class ShopifyOptionBean {
	constructor() {
		this.id = 0 ;
		this.productId = 0 ;
		this.name = '' ;
		this.position = 0 ;
		this.values = null ;
		this.additionalProperties = null ;
	}
}
/* ds.ecom.dataexport.ShopifyProductBean */
export class ShopifyProductBean {
	constructor() {
		this.id = 0 ;
		this.title = '' ;
		this.bodyHtml = '' ;
		this.vendor = '' ;
		this.productType = '' ;
		this.createdAt = '' ;
		this.handle = '' ;
		this.updatedAt = '' ;
		this.publishedAt = '' ;
		this.templateSuffix = '' ;
		this.status = '' ;
		this.publishedScope = '' ;
		this.tags = '' ;
		this.adminGraphqlApiId = '' ;
		this.variants = null ;
		this.options = null ;
		this.images = null ;
		this.additionalProperties = null ;
	}
}
/* ds.ecom.dataexport.ShopifyProductInputBean */
export class ShopifyProductInputBean {
	constructor() {
		this.product = null ;
		this.additionalProperties = null ;
	}
}
/* ds.ecom.dataexport.ShopifyProductsBean */
export class ShopifyProductsBean {
	constructor() {
		this.products = null ;
		this.additionalProperties = null ;
	}
}
/* ds.ecom.dataexport.ShopifyResponseBean */
export class ShopifyResponseBean {
	constructor() {
		this.companyCode = '' ;
		this.shopifyFabricStyles = new Array() ;
	}
}
/* ds.ecom.dataexport.ShopifyVariantBean */
export class ShopifyVariantBean {
	constructor() {
		this.id = 0 ;
		this.productId = 0 ;
		this.title = '' ;
		this.price = '' ;
		this.sku = '' ;
		this.position = 0 ;
		this.inventoryPolicy = '' ;
		this.compareAtPrice = '' ;
		this.fulfillmentService = '' ;
		this.inventoryManagement = '' ;
		this.option1 = '' ;
		this.option2 = null ;
		this.option3 = null ;
		this.createdAt = '' ;
		this.updatedAt = '' ;
		this.taxable = false ;
		this.barcode = '' ;
		this.grams = 0 ;
		this.imageId = 0 ;
		this.weight = 0 ;
		this.weightUnit = '' ;
		this.inventoryItemId = 0 ;
		this.inventoryQuantity = 0 ;
		this.oldInventoryQuantity = 0 ;
		this.requiresShipping = false ;
		this.adminGraphqlApiId = '' ;
		this.additionalProperties = null ;
	}
}
/* ds.ecom.EcomAmazonFabricStyleBean */
export class EcomAmazonFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fullDescription = '' ;
		this.price = 0 ;
		this.webSalesFlag = false ;
		this.lines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.ecom.EcomAmazonSkuLineFabricStyleBean */
export class EcomAmazonSkuLineFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.colorCode = '' ;
		this.fullDescription = '' ;
		this.price = 0 ;
		this.skuNumber = 0 ;
		this.webSalesFlag = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.ecom.EcomDataExportJobBean */
export class EcomDataExportJobBean {
	constructor() {
		this.jobId = 0 ;
		this.submittedJobId = 0 ;
		this.submittedUserCode = '' ;
		this.submittedDate = '' ;
		this.clientCode = '' ;
		this.targetWebsite = '' ;
		this.websiteType = '' ;
		this.jobType = '' ;
		this.priority = 0 ;
		this.status = '' ;
		this.processedDate = '' ;
		this.processedBy = '' ;
		this.processRemarks = '' ;
		this.processedStatus = '' ;
		this.processedRows = 0 ;
		this.successRows = 0 ;
		this.failureRows = 0 ;
		this.notProcessedRows = 0 ;
		this.jobResultFilePath = '' ;
		this.cancelledDate = '' ;
		this.cancelledUserCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.ecom.EcomEbayFabricStyleBean */
export class EcomEbayFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fullDescription = '' ;
		this.price = 0 ;
		this.webSalesFlag = false ;
		this.webSiteCode = '' ;
		this.ebayLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.ecom.EcomEbaySkuLineFabricStyleBean */
export class EcomEbaySkuLineFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fullDescription = '' ;
		this.price = 0 ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.webSalesFlag = false ;
		this.webSiteCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.ecom.EcomHouzzFabricStyleBean */
export class EcomHouzzFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fullDescription = '' ;
		this.price = 0 ;
		this.parentage = '' ;
		this.webSalesFlag = false ;
		this.houzzLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.ecom.EcomHouzzSkuLineFabricStyleBean */
export class EcomHouzzSkuLineFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fullDescription = '' ;
		this.price = 0 ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.webSalesFlag = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.ecom.EcomItsyFabricStyleBean */
export class EcomItsyFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fullDescription = '' ;
		this.price = 0 ;
		this.parentage = '' ;
		this.webSalesFlag = false ;
		this.itsyLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.ecom.EcomItsySkuLineFabricStyleBean */
export class EcomItsySkuLineFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fullDescription = '' ;
		this.price = 0 ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.webSalesFlag = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.ecom.EComJobStatusResultBean */
export class EComJobStatusResultBean {
	constructor() {
		this.count = 0 ;
		this.dataJobList = new Array() ;
	}
}
/* ds.ecom.EComJobStatusResultReponseBean */
export class EComJobStatusResultReponseBean {
	constructor() {
		this.responseResut = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.ecom.EcomJobUploadStatusCriteriaBean */
export class EcomJobUploadStatusCriteriaBean {
	constructor() {
		this.companyCode = '' ;
	}
}
/* ds.ecom.EcomOrderProcessedFailedOrderResultBean */
export class EcomOrderProcessedFailedOrderResultBean {
	constructor() {
		this.count = 0 ;
		this.salesOrders = new Array() ;
	}
}
/* ds.ecom.EcomOrderStatusCriteriaBean */
export class EcomOrderStatusCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.status = 0 ;
		this.ecomOrderId = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.websiteCode = '' ;
	}
}
/* ds.ecom.EComOrderStatusResultBean */
export class EComOrderStatusResultBean {
	constructor() {
		this.count = 0 ;
		this.orderTrackList = new Array() ;
	}
}
/* ds.ecom.EComOrderStatusResultReponseBean */
export class EComOrderStatusResultReponseBean {
	constructor() {
		this.responseResut = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.ecom.EcomProcessFailedOrderResultResponseBean */
export class EcomProcessFailedOrderResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.ecom.EcomShopifyFabricStyleBean */
export class EcomShopifyFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fullDescription = '' ;
		this.handle = '' ;
		this.title = '' ;
		this.body = '' ;
		this.vendor = '' ;
		this.standardProductType = '' ;
		this.customProductTypeTags = '' ;
		this.published = '' ;
		this.variantInventoryPolicy = '' ;
		this.variantFulfillmentService = '' ;
		this.variantInventoryTracker = '' ;
		this.variantRequiresShipping = '' ;
		this.variantTaxable = '' ;
		this.giftCard = '' ;
		this.sEOTitle = '' ;
		this.sEODescription = '' ;
		this.googleShoppingGoogleProductCategory = '' ;
		this.googleShoppingGender = '' ;
		this.googleShoppingAgeGroup = '' ;
		this.googleShoppingMPN = '' ;
		this.googleShoppingAdWordsGrouping = '' ;
		this.googleShoppingAdWordsLabels = '' ;
		this.googleShoppingCondition = '' ;
		this.googleShoppingCustomProduct = '' ;
		this.googleShoppingCustomLabel0 = '' ;
		this.googleShoppingCustomLabel1 = '' ;
		this.googleShoppingCustomLabel2 = '' ;
		this.googleShoppingCustomLabel3 = '' ;
		this.googleShoppingCustomLabel4 = '' ;
		this.variantTaxCode = '' ;
		this.status = '' ;
		this.imageSource = '' ;
		this.webSalesFlag = false ;
		this.webSiteCode = '' ;
		this.jsonBodyDetails = '' ;
		this.altDescription1 = '' ;
		this.altDescription2 = '' ;
		this.collectionName = '' ;
		this.tags = '' ;
		this.shippingWeight = 0 ;
		this.shopifyLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.ecom.EcomShopifySkuLineFabricStyleBean */
export class EcomShopifySkuLineFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fullDescription = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.option1Name = '' ;
		this.option1Value = '' ;
		this.option2Name = '' ;
		this.option2Value = '' ;
		this.option3Name = '' ;
		this.option3Value = '' ;
		this.variantSKU = '' ;
		this.variantGrams = 0 ;
		this.variantInventoryQuantity = 0 ;
		this.variantBarcode = '' ;
		this.imageSrc = '' ;
		this.imagePosition = 0 ;
		this.imageAltText = '' ;
		this.variantImage = '' ;
		this.variantWeightUnit = '' ;
		this.variantPrice = 0 ;
		this.variantCompareAtPrice = 0 ;
		this.costPerItem = 0 ;
		this.webSalesFlag = false ;
		this.webSiteCode = '' ;
		this.altImageName = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.ecom.EcomWalmartFabricStyleBean */
export class EcomWalmartFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fullDescription = '' ;
		this.price = 0 ;
		this.parentage = '' ;
		this.webSalesFlag = false ;
		this.walMartLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.ecom.EcomWalmartSkuLineFabricStyleBean */
export class EcomWalmartSkuLineFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fullDescription = '' ;
		this.price = 0 ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.webSalesFlag = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.ecom.EcomWayfairFabricStyleBean */
export class EcomWayfairFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.productType = '' ;
		this.collectionName = '' ;
		this.marketingCopy = '' ;
		this.featureBullet1 = '' ;
		this.featureBullet2 = '' ;
		this.featureBullet3 = '' ;
		this.featureBullet4 = '' ;
		this.featureBullet5 = '' ;
		this.featureBullet6 = '' ;
		this.featureBullet7 = '' ;
		this.countryOfManufacture = '' ;
		this.californiaProposition65WarningRequired = '' ;
		this.harmonizedCode = '' ;
		this.canadaCode = '' ;
		this.shipType = '' ;
		this.freightClass = '' ;
		this.leadTimeInDayHrs = '' ;
		this.leadTimeInReplacementHrs = '' ;
		this.nmfcCode = '' ;
		this.numberOfBoxes = 0 ;
		this.shippingWeight = 0 ;
		this.cartonHeight = 0 ;
		this.cartonWidth = 0 ;
		this.cartonDepth = 0 ;
		this.typeOfFabric = '' ;
		this.pattern = '' ;
		this.horizontalRepeat = '' ;
		this.frabicWeight = '' ;
		this.color = '' ;
		this.recommendedUse = '' ;
		this.fabricContent = '' ;
		this.genunineLeatherType = '' ;
		this.fauxLeatherType = '' ;
		this.productCare = '' ;
		this.supplierAttended = '' ;
		this.countryOfOrigin = '' ;
		this.cleaningCode = '' ;
		this.treatment = '' ;
		this.treatmentDetails = '' ;
		this.ulListed = '' ;
		this.actFlammabilityCompliant = '' ;
		this.taaCompliant = '' ;
		this.scsCertified = '' ;
		this.nepa701Certified = '' ;
		this.calCompliant = '' ;
		this.uplrCompliant = '' ;
		this.containsFlameRetardantMaterials = '' ;
		this.canadaProductRestriction = '' ;
		this.csaCertified = '' ;
		this.soffaCompliant = '' ;
		this.textileFlammabilityRegulations = '' ;
		this.overallLengthEndToEnd = 0 ;
		this.overallWidthSideToSide = 0 ;
		this.overallProductWeight = 0 ;
		this.weight = 0 ;
		this.commercialWarranty = '' ;
		this.productWarranty = '' ;
		this.webSalesFlag = false ;
		this.cost = 0 ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.supplierPartNumber = '' ;
		this.salesPrice = 0 ;
		this.retailPrice = 0 ;
		this.minimumnOrderQuantity = 0 ;
		this.forceMultiples = 0 ;
		this.displaySetQuantity = 0 ;
		this.image1Code = '' ;
		this.wayFairLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.ecom.EcomWayfairSkuLineFabricStyleBean */
export class EcomWayfairSkuLineFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.cost = 0 ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.supplierPartNumber = '' ;
		this.salesPrice = 0 ;
		this.retailPrice = 0 ;
		this.minimumnOrderQuantity = 0 ;
		this.forceMultiples = 0 ;
		this.displaySetQuantity = 0 ;
		this.image1Code = '' ;
		this.webSalesFlag = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.ecom.WebOrderDownloadTrackBean */
export class WebOrderDownloadTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.webOrderNumber = '' ;
		this.ecomOrderId = 0 ;
		this.salesOrderId = 0 ;
		this.trackNumber = 0 ;
		this.orderDate = '' ;
		this.ecomDate = '' ;
		this.erpDate = '' ;
		this.targetWebsite = '' ;
		this.websiteType = '' ;
		this.salesOrderNumber = '' ;
		this.status = '' ;
		this.failureReason = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.originalOrderNumber = '' ;
		this.originalOrderType = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.GUIClientConfig */
export class GUIClientConfig {
	constructor() {
		this.companyCode = '' ;
		this.applicationMode = '' ;
		this.maxAllowedScreenHeight = '' ;
		this.themeType = '' ;
		this.applicationName = '' ;
		this.applicationMainImagePath = '' ;
		this.guiVersion = '' ;
		this.serverVersion = '' ;
		this.applicationLogoImagePath = '' ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.history.report.ReportHistoryDetailBean */
export class ReportHistoryDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.reportId = 0 ;
		this.reportType = 0 ;
		this.pdfFilePath = '' ;
		this.excelFilePath = '' ;
		this.createdDate = '' ;
		this.reportDate = '' ;
		this.dataPath = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inquiry.AccountReceivableInputDataBean */
export class AccountReceivableInputDataBean {
	constructor() {
		this.divisionCode = '' ;
		this.type = '' ;
		this.arNumber = '' ;
		this.arDate = '' ;
		this.stampDate = '' ;
		this.client = '' ;
		this.clientCustomerType = '' ;
		this.salesRepresentative = '' ;
		this.daysLate = '' ;
		this.memo = '' ;
		this.checkNumber = '' ;
		this.amount = 0 ;
		this.glCode = '' ;
		this.glDesc = '' ;
		this.glType = '' ;
		this.controlNumber = '' ;
		this.commissionPercentage = 0 ;
		this.commAdjust = 0 ;
		this.invoiceNumber = '' ;
		this.invoiceDate = '' ;
		this.invoiceModel = '' ;
		this.invoiceIHD = '' ;
		this.invoiceFreight = 0 ;
		this.invoiceSubTotal = 0 ;
		this.invoiceGrandTotal = 0 ;
		this.invoiceTax = 0 ;
		this.invoiceMiscCharge = 0 ;
		this.invoiceTax3 = 0 ;
		this.packingListNumber = '' ;
		this.pLDate = '' ;
		this.pLSubTotal = 0 ;
		this.customerPurchaseOrderNumber = '' ;
		this.salesOrderNumber = '' ;
		this.salesOrderDate = '' ;
		this.vendorInvoiceNumber = '' ;
		this.billNumber = '' ;
		this.billDate = '' ;
		this.billVendor = '' ;
		this.rcvgNumber = '' ;
		this.rcvgDate = '' ;
		this.rcvgSupplier = '' ;
		this.totalDiscAmount = 0 ;
		this.totalCrNotesreturns = 0 ;
		this.totalCrNotesAllowances = 0 ;
		this.totalCrNotesAll = 0 ;
		this.totalCrNotesInv = 0 ;
		this.openBalance = 0 ;
		this.factorCode = '' ;
		this.factorName = '' ;
		this.commsiionable = '' ;
		this.disbNumber = '' ;
		this.disbAmount = 0 ;
		this.atch = '' ;
		this.addedBy = '' ;
		this.addedDateTime = '' ;
	}
}
/* ds.inquiry.AdvancePaymentInputDataBean */
export class AdvancePaymentInputDataBean {
	constructor() {
		this.advancePaymentNumber = '' ;
		this.type = '' ;
		this.client = '' ;
		this.date = '' ;
		this.amount = 0 ;
		this.checkNumber = '' ;
		this.disbNumber = '' ;
		this.invoiceNumber = '' ;
		this.memo = '' ;
		this.sourceLineNumber = 0 ;
		this.appliedInvoiceNumber = '' ;
		this.csvInvoiceNumber = '' ;
		this.grandTotalAmount = 0 ;
		this.disbAmount = 0 ;
	}
}
/* ds.inquiry.BinInfoBean */
export class BinInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.bins = new Array() ;
	}
}
/* ds.inquiry.CombinedPaymentInputDataBean */
export class CombinedPaymentInputDataBean {
	constructor() {
		this.type = '' ;
		this.appliedInvoiceNumber = '' ;
		this.csvInvoiceNumber = '' ;
		this.disbNumber = '' ;
		this.disbAmount = 0 ;
		this.amount = 0 ;
		this.grandTotalAmount = 0 ;
		this.client = '' ;
		this.date = '' ;
		this.memo = '' ;
		this.sourceLineNumber = 0 ;
		this.checkNumber = '' ;
	}
}
/* ds.inquiry.common.FabricStyleAverageAgeResult */
export class FabricStyleAverageAgeResult {
	constructor() {
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.quantity = 0 ;
	}
}
/* ds.inquiry.common.FabricStyleColorDateResult */
export class FabricStyleColorDateResult {
	constructor() {
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.processDate = '' ;
		this.totalReceivedQuantity = 0 ;
	}
}
/* ds.inquiry.common.FabricStyleColorQuantityResult */
export class FabricStyleColorQuantityResult {
	constructor() {
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.quantity = 0 ;
		this.entityDate = '' ;
		this.inTransitQuantity = 0 ;
		this.locationCode = '' ;
		this.numberOfRolls = 0 ;
		this.vendorCode = '' ;
	}
}
/* ds.inquiry.common.FabricStyleColorWithUomInfo */
export class FabricStyleColorWithUomInfo {
	constructor() {
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleColorName = '' ;
		this.uomCode = '' ;
		this.width = '' ;
		this.parentProductCode = '' ;
		this.fabricStyleImagePath = '' ;
		this.fabricStyleColorImagePath = '' ;
		this.businessDivisionCode = '' ;
		this.skuNumber = 0 ;
	}
}
/* ds.inquiry.CPMReportDetailBean */
export class CPMReportDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.cpmCode = '' ;
		this.cpmName = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.containerNumber = '' ;
		this.cpmDetailInfos = new Array() ;
	}
}
/* ds.inquiry.CPMReportDetailInfoBean */
export class CPMReportDetailInfoBean {
	constructor() {
		this.cpmCode = '' ;
		this.cpmLineNumber = 0 ;
		this.cpmTemplateCode = '' ;
		this.companyCode = '' ;
		this.taskCode = '' ;
		this.taskName = '' ;
		this.scheduledDate = '' ;
		this.startDate = '' ;
		this.endDate = '' ;
		this.scheduledTime = '' ;
		this.startTime = '' ;
		this.endTime = '' ;
		this.comments = '' ;
		this.lineStatus = '' ;
		this.durationDate = '' ;
		this.duration = '' ;
	}
}
/* ds.inquiry.CreditCardInputDataBean */
export class CreditCardInputDataBean {
	constructor() {
		this.type = '' ;
		this.appliedInvoiceNumber = '' ;
		this.csvInvoiceNumber = '' ;
		this.disbNumber = '' ;
		this.disbAmount = 0 ;
		this.amount = 0 ;
		this.client = '' ;
		this.date = '' ;
		this.memo = '' ;
		this.sourceLineNumber = 0 ;
		this.grandTotalAmount = 0 ;
		this.creditCardNumber = '' ;
	}
}
/* ds.inquiry.CreditMemoDataExportElectronicInputHeaderBean */
export class CreditMemoDataExportElectronicInputHeaderBean {
	constructor() {
		this.customerCode = '' ;
		this.customerName = '' ;
		this.creditMemoNumber = '' ;
		this.orderDate = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.shipDate = '' ;
		this.dueDate = '' ;
		this.itemName = '' ;
		this.totalAmount = 0 ;
		this.inputInvoiceLines = new Array() ;
	}
}
/* ds.inquiry.CreditMemoDataExportElectronicInputHeaderBean_texco */
export class CreditMemoDataExportElectronicInputHeaderBean_texco {
	constructor() {
		this.invoiceNumber = '' ;
		this.invoiceDate = '' ;
		this.dueDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.salesOrderNumber = '' ;
		this.pickTicketNumber = '' ;
		this.isPaid = false ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.comissionPercentage = 0 ;
		this.comissionAmount = 0 ;
		this.shipViaCode = '' ;
		this.shipViaDescription = '' ;
		this.paymentTermCode = '' ;
		this.customerPONumber = '' ;
		this.customerShipTo = '' ;
		this.customerShipToName = '' ;
		this.address1 = '' ;
		this.address2 = '' ;
		this.city = '' ;
		this.state = '' ;
		this.zip = '' ;
		this.country = '' ;
		this.locationCode = '' ;
		this.businessDivsion = '' ;
		this.totalMerchandiseAmount = 0 ;
		this.miscChargeAmount = 0 ;
		this.grandTotalAmount = 0 ;
		this.appliedAmount = 0 ;
		this.totalNonMerchandiseAmount = 0 ;
		this.lines = new Array() ;
	}
}
/* ds.inquiry.CreditMemoDataExportElectronicInputLineBean */
export class CreditMemoDataExportElectronicInputLineBean {
	constructor() {
		this.type = '' ;
		this.invoiceDate = '' ;
		this.creditMemoNumber = '' ;
		this.memo = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.shipDate = '' ;
		this.dueDate = '' ;
		this.itemName = '' ;
		this.itemDescription = '' ;
		this.representative = '' ;
		this.paidValue = '' ;
		this.openBalance = 0 ;
		this.skuNumber = 0 ;
	}
}
/* ds.inquiry.CreditMemoDataExportElectronicInputLineBean_texco */
export class CreditMemoDataExportElectronicInputLineBean_texco {
	constructor() {
		this.type = '' ;
		this.invoiceDate = '' ;
		this.lineNumber = 0 ;
		this.invoiceNumber = '' ;
		this.customerPONumber = '' ;
		this.customerName = '' ;
		this.shipDate = '' ;
		this.paymentTerm = '' ;
		this.item = '' ;
		this.itemDescription = '' ;
		this.quantity = 0 ;
		this.uom = '' ;
		this.salesPrice = 0 ;
		this.totalAmount = 0 ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.comissionPercentage = 0 ;
		this.comissionAmount = 0 ;
		this.secondSalesPersonCode = '' ;
		this.customerCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabrciStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleColorName = '' ;
		this.skuNumber = 0 ;
		this.paidStatus = '' ;
		this.isExtraCharge = false ;
		this.isNonMerchandiseLine = false ;
		this.commissionPercentage = 0 ;
		this.commissionAmount = 0 ;
		this.totalQuantity = 0 ;
		this.grandTotalAmount = 0 ;
		this.subTotalAmount = 0 ;
		this.totalOpenUnit = 0 ;
		this.taxAmount = 0 ;
		this.totalLineAmount = 0 ;
		this.totalLineUnits = 0 ;
		this.status = '' ;
		this.division = '' ;
		this.freightChargeAmount = 0 ;
		this.miscChargeAmount = 0 ;
		this.appliedAmount = 0 ;
		this.comments = 0 ;
	}
}
/* ds.inquiry.CreditMemoDetailsResponseBean */
export class CreditMemoDetailsResponseBean {
	constructor() {
		this.creditMemoDetailsList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.CreditMemoResultBean */
export class CreditMemoResultBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.totalCreditAmount = 0 ;
		this.totalAppliedAmount = 0 ;
		this.totalOpenAmount = 0 ;
		this.creditMemos = new Array() ;
	}
}
/* ds.inquiry.criteria.AllBinCriteriaBean */
export class AllBinCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.warehouseCode = '' ;
	}
}
/* ds.inquiry.criteria.AllCustomerPaymentAgingCriteriaBean */
export class AllCustomerPaymentAgingCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.countryCode = '' ;
		this.cityCode = '' ;
		this.customerCodeStartsWith = '' ;
		this.customerCodeContains = '' ;
		this.companyCurrencyCode = '' ;
		this.customerCurrencyCode = '' ;
	}
}
/* ds.inquiry.criteria.AllCustomerSalesBackOrderAgingCriteriaBean */
export class AllCustomerSalesBackOrderAgingCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.countryCode = '' ;
		this.cityCode = '' ;
		this.customerCodeStartsWith = '' ;
		this.customerCodeContains = '' ;
		this.companyCurrencyCode = '' ;
		this.customerCurrencyCode = '' ;
	}
}
/* ds.inquiry.criteria.AllFabricATSInquiryCriteriaBean */
export class AllFabricATSInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.colorCodeContains = '' ;
		this.sortColumnName = '' ;
		this.isDecending = false ;
		this.excludedFabricCodes = '' ;
		this.categoryType = '' ;
		this.fabricStyleCodeStartsWith = '' ;
		this.includedFabricCodes = new Array() ;
		this.itemCodeContains = '' ;
		this.parentProductCode = '' ;
		this.businessDivisionCode = '' ;
		this.excludedLocationCodes = new Array() ;
		this.locationCode = '' ;
		this.isFromPurchaseOrder = false ;
		this.showNonAvailableItemsFlag = false ;
		this.sKUNumber = 0 ;
		this.sequenceNumber = 0 ;
		this.isShowOnlyActiveItemFlag = false ;
		this.riskvalue = 0 ;
		this.customerCode = '' ;
	}
}
/* ds.inquiry.criteria.AllFabricStyleBackOrderAgingCriteriaBean */
export class AllFabricStyleBackOrderAgingCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.customerCode = '' ;
		this.fromStopDate = '' ;
		this.toStopDate = '' ;
	}
}
/* ds.inquiry.criteria.BankAccountBalanceHistoryTrackCriteriaBean */
export class BankAccountBalanceHistoryTrackCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.bankCode = '' ;
		this.historyDateFrom = '' ;
		this.historyDateTo = '' ;
	}
}
/* ds.inquiry.criteria.BookingReportCriteriaBean */
export class BookingReportCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fromOrderDate = '' ;
		this.toOrderDate = '' ;
		this.orderStatus = '' ;
	}
}
/* ds.inquiry.criteria.BouncedCheckInquiryCriteriaBean */
export class BouncedCheckInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.startDate = '' ;
		this.endDate = '' ;
		this.customerCode = '' ;
	}
}
/* ds.inquiry.criteria.CashPaymentReceiptActivityCriteriaBean */
export class CashPaymentReceiptActivityCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.arDate = '' ;
		this.customerCode = '' ;
	}
}
/* ds.inquiry.criteria.CheckPaymentDetailsPaymentInquiryCriteriaBean */
export class CheckPaymentDetailsPaymentInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.checkNumber = '' ;
		this.checkDate = '' ;
		this.customerCode = '' ;
		this.currencyCode = '' ;
		this.cardNumber = '' ;
		this.wireTransferNumber = '' ;
		this.achNumber = '' ;
		this.wireTransferDate = '' ;
		this.creditMemoNumber = '' ;
	}
}
/* ds.inquiry.criteria.CriticalPathManagementInquiryCriteria */
export class CriticalPathManagementInquiryCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.cpmTemplateCode = '' ;
		this.cpmStatus = '' ;
		this.containerNumber = '' ;
		this.fromCpmScheduledDate = '' ;
		this.toCpmCpmScheduledDate = '' ;
	}
}
/* ds.inquiry.criteria.CustomerATSInquiryCriteriaBean */
export class CustomerATSInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.includedFabricCodes = new Array() ;
		this.parentProductCode = '' ;
		this.businessDivisionCode = '' ;
	}
}
/* ds.inquiry.criteria.CustomerBalanceDetailHistoryCriteriaBean */
export class CustomerBalanceDetailHistoryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.historyDateFrom = '' ;
		this.historyDateTo = '' ;
	}
}
/* ds.inquiry.criteria.CustomerDetailsWithSalesInvoiceSearchCriteria */
export class CustomerDetailsWithSalesInvoiceSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.uomCode = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.customerCode = '' ;
	}
}
/* ds.inquiry.criteria.CustomerFabricStyleColorATSDetailsCriteriaBean */
export class CustomerFabricStyleColorATSDetailsCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
	}
}
/* ds.inquiry.criteria.CustomerInvoiceInquiryCriteriaBean */
export class CustomerInvoiceInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.customersList = new Array() ;
		this.salesPersonCodesList = new Array() ;
		this.customerCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.sortByField = 0 ;
		this.fromDate = '' ;
		this.toDate = '' ;
	}
}
/* ds.inquiry.criteria.CustomerLogisticOnOrderSearchCriteria */
export class CustomerLogisticOnOrderSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.locationCode = '' ;
		this.customerCode = '' ;
		this.excludedLocationCodes = new Array() ;
	}
}
/* ds.inquiry.criteria.CustomerPaymentAgingHistoryCriteriaBean */
export class CustomerPaymentAgingHistoryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.historyDate = '' ;
		this.salesPersonCode = '' ;
	}
}
/* ds.inquiry.criteria.CustomerSalesOnOrderSearchCriteria */
export class CustomerSalesOnOrderSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.salesOrderNumber = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.fromOrderStopDate = '' ;
		this.toOrderStopDate = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.fromOrderStartDate = '' ;
		this.toOrderStartDate = '' ;
		this.isFetchDetailsTillOrderStopDate = false ;
		this.salesPersonCodes = new Array() ;
		this.cityCode = '' ;
		this.locationCode = '' ;
		this.excludedLocationCodes = new Array() ;
	}
}
/* ds.inquiry.criteria.CustomerServiceInquiryCriteria */
export class CustomerServiceInquiryCriteria {
	constructor() {
		this.companyCode = '' ;
		this.fromOrderDate = '' ;
		this.toOrderDate = '' ;
		this.customerCode = '' ;
		this.salesPersonCode = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.salesPersonCodes = new Array() ;
		this.cityCode = '' ;
	}
}
/* ds.inquiry.criteria.CustomerStatementInquiryCriteria */
export class CustomerStatementInquiryCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerPONumber = '' ;
		this.invoiceNumber = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.salesPersonCode = '' ;
	}
}
/* ds.inquiry.criteria.CustomerStatisticsInquiryCriteriaBean */
export class CustomerStatisticsInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.currencyCode = '' ;
		this.historyDate = '' ;
	}
}
/* ds.inquiry.criteria.CustomerTransactionAccountSummarySearchCriteria */
export class CustomerTransactionAccountSummarySearchCriteria {
	constructor() {
		this.entityStatus = '' ;
		this.entityStatusList = new Array() ;
		this.transactionDateFrom = '' ;
		this.transactionDateTo = '' ;
		this.entityType = 0 ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerCodesList = new Array() ;
		this.customerCodeStartsWith = '' ;
		this.customerCodeContains = '' ;
		this.customerNameContains = '' ;
		this.customerName = '' ;
		this.currencyCode = '' ;
	}
}
/* ds.inquiry.criteria.CustomerTransactionInquiryCriteria */
export class CustomerTransactionInquiryCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.entityType = 0 ;
		this.entityStatus = '' ;
		this.transactionDateFrom = '' ;
		this.transactionDateTo = '' ;
		this.entityStatusList = new Array() ;
	}
}
/* ds.inquiry.criteria.CustomerTransactionSummaryCriteriaBean */
export class CustomerTransactionSummaryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerCodesList = new Array() ;
		this.customerCodeStartsWith = '' ;
		this.customerCodeContains = '' ;
		this.customerNameContains = '' ;
		this.customerName = '' ;
		this.currencyCode = '' ;
	}
}
/* ds.inquiry.criteria.DailyInventoryProcessTrackInquiryCriteriaBean */
export class DailyInventoryProcessTrackInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.vendorCode = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.customerCode = '' ;
		this.excludedLocationCodes = new Array() ;
		this.locationCode = '' ;
		this.entityType = '' ;
		this.entityCode = '' ;
		this.fabricStyleCodes = new Array() ;
		this.warehousePurchaseOrderNumber = '' ;
		this.customerReferenceNumber = '' ;
		this.palletNumber = '' ;
		this.imeiNumber = '' ;
		this.projectNumber = '' ;
	}
}
/* ds.inquiry.criteria.DailyInventoryTrackInquiryCriteriaBean */
export class DailyInventoryTrackInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.vendorCode = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.customerCode = '' ;
		this.excludedLocationCodes = new Array() ;
		this.locationCode = '' ;
		this.entityType = '' ;
		this.entityCode = '' ;
		this.fabricStyleCodes = new Array() ;
	}
}
/* ds.inquiry.criteria.FabricStyleBarCodeSearchCriteria */
export class FabricStyleBarCodeSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.logisticCustomerCode = '' ;
		this.fabricStyleCodes = new Array() ;
	}
}
/* ds.inquiry.criteria.FabricStyleCatalogueDetailInquiryCriteriaBean */
export class FabricStyleCatalogueDetailInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleDetails = new Array() ;
		this.fabricStyleStartsWith = '' ;
		this.colorCodeContains = '' ;
		this.itemCodeContains = '' ;
	}
}
/* ds.inquiry.criteria.FabricStyleCatalogueProductDetailCriteria */
export class FabricStyleCatalogueProductDetailCriteria {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCodes = new Array() ;
	}
}
/* ds.inquiry.criteria.FabricStyleColorStatisticsInquiryCriteria */
export class FabricStyleColorStatisticsInquiryCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.fabricStyleCodes = new Array() ;
		this.vendorCode = '' ;
	}
}
/* ds.inquiry.criteria.FabricStyleCustomerSalesSummaryCriteriaBean */
export class FabricStyleCustomerSalesSummaryCriteriaBean {
	constructor() {
		this.customerCode = '' ;
		this.startDate = '' ;
		this.endDate = '' ;
		this.companyCode = '' ;
		this.productTypeCode = '' ;
		this.patternTypeCode = '' ;
		this.makeTypeCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.vendorCode = '' ;
		this.historyDate = '' ;
		this.customerCode = '' ;
		this.excludedLocationCodes = new Array() ;
		this.locationCode = '' ;
	}
}
/* ds.inquiry.criteria.FabricStyleDashBoardCriteriaBean */
export class FabricStyleDashBoardCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.invoiceNumber = '' ;
		this.startDate = '' ;
		this.stopDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.dateMode = 0 ;
		this.productType = '' ;
		this.patternType = '' ;
		this.patternTypeCategory = '' ;
		this.salesPersonCode = '' ;
		this.stateCode = '' ;
		this.lotNumber = '' ;
		this.year = 0 ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.serviceCode = '' ;
		this.searchName = '' ;
		this.customerTypeCode = '' ;
		this.uomCode = '' ;
		this.topNCount = 0 ;
		this.locationCode = '' ;
		this.pageList = null ;
		this.detailsMode = 0 ;
	}
}
/* ds.inquiry.criteria.FabricStyleDetailInquiryCriteriaBean */
export class FabricStyleDetailInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.invoiceNumber = '' ;
		this.startDate = '' ;
		this.stopDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.receivedQuantityDateMode = 0 ;
		this.productType = '' ;
		this.patternType = '' ;
		this.patternTypeCategory = '' ;
		this.salesPersonCode = '' ;
		this.stateCode = '' ;
	}
}
/* ds.inquiry.criteria.FabricStyleFinderDetailInquiryCriteriaBean */
export class FabricStyleFinderDetailInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.startDate = '' ;
		this.stopDate = '' ;
	}
}
/* ds.inquiry.criteria.FabricStyleInAndOutStatisticsCriteriaBean */
export class FabricStyleInAndOutStatisticsCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.mode = 0 ;
		this.containerNumber = '' ;
		this.projectNumber = '' ;
		this.lotNumber = '' ;
	}
}
/* ds.inquiry.criteria.FabricStyleInventoryValuationCriteriaBean */
export class FabricStyleInventoryValuationCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.locationCode = '' ;
		this.reserveCustomerCode = '' ;
		this.logisticCustomerCode = '' ;
		this.fabricStyleCodes = new Array() ;
	}
}
/* ds.inquiry.criteria.FabricStylePriceAndCostInquiryCriteriaBean */
export class FabricStylePriceAndCostInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.uomCode = '' ;
		this.productTypeCode = '' ;
		this.patternTypeCode = '' ;
		this.makeTypeCode = '' ;
		this.patternTypeCategoryCode = '' ;
	}
}
/* ds.inquiry.criteria.FabricStylePurchaseHistoryCriteriaBean */
export class FabricStylePurchaseHistoryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.vendorCode = '' ;
	}
}
/* ds.inquiry.criteria.FabricStylePurchaseReceiptHistoryCriteriaBean */
export class FabricStylePurchaseReceiptHistoryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.mode = 0 ;
		this.containerNumber = '' ;
		this.projectNumber = '' ;
		this.lotNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
	}
}
/* ds.inquiry.criteria.FabricStyleReceivedInquiryCriteriaBean */
export class FabricStyleReceivedInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.uomCode = '' ;
		this.fromReceiptDate = '' ;
		this.toReceiptDate = '' ;
		this.vendorCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.binLocation = '' ;
	}
}
/* ds.inquiry.criteria.FabricStyleSalesBackOrderSearchCriteria */
export class FabricStyleSalesBackOrderSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.fromOrderStopDate = '' ;
		this.toOrderStopDate = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
	}
}
/* ds.inquiry.criteria.FabricStyleSalesPersonSalesSummaryCriteriaBean */
export class FabricStyleSalesPersonSalesSummaryCriteriaBean {
	constructor() {
		this.salesPersonCode = '' ;
		this.startDate = '' ;
		this.endDate = '' ;
		this.customerCode = '' ;
		this.startDate = '' ;
		this.endDate = '' ;
		this.companyCode = '' ;
		this.productTypeCode = '' ;
		this.patternTypeCode = '' ;
		this.makeTypeCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.vendorCode = '' ;
		this.historyDate = '' ;
		this.customerCode = '' ;
		this.excludedLocationCodes = new Array() ;
		this.locationCode = '' ;
	}
}
/* ds.inquiry.criteria.FabricStyleStatisticsInquiryCriteriaBean */
export class FabricStyleStatisticsInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.productTypeCode = '' ;
		this.patternTypeCode = '' ;
		this.makeTypeCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.vendorCode = '' ;
		this.historyDate = '' ;
		this.customerCode = '' ;
		this.excludedLocationCodes = new Array() ;
		this.locationCode = '' ;
	}
}
/* ds.inquiry.criteria.FabricStyleWeeklyMonthlyATSInquiryCriteriaBean */
export class FabricStyleWeeklyMonthlyATSInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.inquiryRange = 0 ;
		this.fromOrderStopDate = '' ;
		this.toOrderStopDate = '' ;
	}
}
/* ds.inquiry.criteria.FabricStyleYearlySalesCriteriaBean */
export class FabricStyleYearlySalesCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.startDate = '' ;
		this.stopDate = '' ;
		this.fetchMonthRange = 0 ;
	}
}
/* ds.inquiry.criteria.FiscalYearBookingSearchCriteria */
export class FiscalYearBookingSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.fiscalYearCode = '' ;
		this.customerCode = '' ;
		this.salesPersonCode = '' ;
		this.startDate = '' ;
		this.endDate = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
	}
}
/* ds.inquiry.criteria.InfoSearchCriteria */
export class InfoSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.infoType = 0 ;
	}
}
/* ds.inquiry.criteria.InventoryAdjustmentHistoryInquiryCriteriaBean */
export class InventoryAdjustmentHistoryInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.adjustmentCode = '' ;
		this.createdBy = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
	}
}
/* ds.inquiry.criteria.InventoryInquiryCriteriaBean */
export class InventoryInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.categoryCode = '' ;
		this.subCategoryCode = '' ;
		this.processTypeCode = '' ;
		this.productStateCode = '' ;
		this.sourceTypeCode = '' ;
		this.uomShortCode = '' ;
		this.locationCode = '' ;
		this.productCodes = new Array() ;
	}
}
/* ds.inquiry.criteria.InventorySalesPurchasePositionCriteriaBean */
export class InventorySalesPurchasePositionCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.vendors = new Array() ;
		this.fabricStyles = new Array() ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.purchaseOrderStatus = '' ;
	}
}
/* ds.inquiry.criteria.InvoiceCommoditySearchCriteria */
export class InvoiceCommoditySearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.commodityCode = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.customerCode = '' ;
	}
}
/* ds.inquiry.criteria.InvoicedNotApprovedCriteriaBean */
export class InvoicedNotApprovedCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fromInvoiceDate = '' ;
		this.toInvoiceDate = '' ;
		this.salesRepresentativeCode = '' ;
	}
}
/* ds.inquiry.criteria.InvoiceRegisterReportCriteria */
export class InvoiceRegisterReportCriteria {
	constructor() {
		this.companyCode = '' ;
		this.invoiceFromDate = '' ;
		this.invoiceToDate = '' ;
		this.salesPersonCodes = new Array() ;
		this.customerCodes = new Array() ;
		this.customerPurchaseOrderNumber = '' ;
		this.shipViaCode = '' ;
		this.locationCode = '' ;
	}
}
/* ds.inquiry.criteria.InvoiceSalesPersonCommissionCriteriaBean */
export class InvoiceSalesPersonCommissionCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.salesPersonCode = '' ;
		this.exclusionShipViaCode = '' ;
	}
}
/* ds.inquiry.criteria.InvoiceServiceSearchCriteria */
export class InvoiceServiceSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.serviceCode = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.customerCode = '' ;
	}
}
/* ds.inquiry.criteria.InvoiceYearlyInquiryCriteria */
export class InvoiceYearlyInquiryCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.fabricStyleCodes = new Array() ;
	}
}
/* ds.inquiry.criteria.LatePurchaseOrderSearchCriteria */
export class LatePurchaseOrderSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.date = '' ;
		this.lateDays = 0 ;
	}
}
/* ds.inquiry.criteria.MailTrackSearchCriteria */
export class MailTrackSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.userId = '' ;
		this.fromMailSendDate = '' ;
		this.toMailSendDate = '' ;
	}
}
/* ds.inquiry.criteria.MostRecentCustomerInquiryCriteriaBean */
export class MostRecentCustomerInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
	}
}
/* ds.inquiry.criteria.MostRecentFabricInquiryCriteriaBean */
export class MostRecentFabricInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
	}
}
/* ds.inquiry.criteria.MultiCustomersPaymentAgingCriteriaBean */
export class MultiCustomersPaymentAgingCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCodes = new Array() ;
		this.salesPersonCodes = new Array() ;
		this.masterCustomerCode = '' ;
		this.agingDisplayOptionValue = 0 ;
	}
}
/* ds.inquiry.criteria.ObseleteInventorySearchCriteria */
export class ObseleteInventorySearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.quantityRange = 0 ;
		this.invoiceDateBefore = '' ;
		this.receiptDateBefore = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.assessmentDate = '' ;
		this.locationCode = '' ;
		this.logisticCustomerCode = '' ;
		this.fabricStyleCodes = new Array() ;
	}
}
/* ds.inquiry.criteria.OpenPickTicketInquiryCriteriaBean */
export class OpenPickTicketInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fromPickedDate = '' ;
		this.toPickedDate = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.customerCode = '' ;
		this.pickerName = '' ;
		this.pickTicketSelectionStatus = 0 ;
		this.fromOrderStartDate = '' ;
		this.toOrderStartDate = '' ;
		this.fromOrderStopDate = '' ;
		this.toOrderStopDate = '' ;
	}
}
/* ds.inquiry.criteria.OpenVendorInvoiceAmountSearchCriteria */
export class OpenVendorInvoiceAmountSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.expenseType = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
	}
}
/* ds.inquiry.criteria.OrderCustomerSearchCriteria */
export class OrderCustomerSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.status = 0 ;
	}
}
/* ds.inquiry.criteria.PastDueInvoicesWithCCPaymentSearchCriteria */
export class PastDueInvoicesWithCCPaymentSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.noOfDaysAfterDueDate = 0 ;
		this.dueDate = '' ;
	}
}
/* ds.inquiry.criteria.PickedandShippedListInquiryCriteria */
export class PickedandShippedListInquiryCriteria {
	constructor() {
		this.companyCode = '' ;
		this.fromPickedDate = '' ;
		this.toPickedDate = '' ;
		this.salesRepresentativeCode = '' ;
		this.customerCode = '' ;
		this.isShippedFlag = false ;
	}
}
/* ds.inquiry.criteria.PickedNotInvoicedCriteriaBean */
export class PickedNotInvoicedCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fromPickedDate = '' ;
		this.toPickedDate = '' ;
		this.salesRepresentativeCode = '' ;
		this.isShippedFlag = false ;
	}
}
/* ds.inquiry.criteria.PickTicketPickerCriteriaBean */
export class PickTicketPickerCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fromPickedDate = '' ;
		this.toPickedDate = '' ;
		this.pickedBy = '' ;
	}
}
/* ds.inquiry.criteria.PostDatedAndBouncedChecksInquiryCriteria */
export class PostDatedAndBouncedChecksInquiryCriteria {
	constructor() {
		this.companyCode = '' ;
		this.startDate = '' ;
		this.endDate = '' ;
		this.customerCode = '' ;
	}
}
/* ds.inquiry.criteria.PostDatedChecksInquiryCriteria */
export class PostDatedChecksInquiryCriteria {
	constructor() {
		this.companyCode = '' ;
		this.accountReceivableDate = '' ;
		this.customerCode = '' ;
		this.invoiceNumber = '' ;
	}
}
/* ds.inquiry.criteria.PostedARRegisterCriteriaBean */
export class PostedARRegisterCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.startPostedDate = '' ;
		this.endPostedDate = '' ;
		this.customerCode = '' ;
		this.startAccountReceivableDate = '' ;
		this.stopAccountReceivableDate = '' ;
		this.salesPersonCode = '' ;
		this.paymentMethodType = 0 ;
		this.isCheckBounceFlag = false ;
	}
}
/* ds.inquiry.criteria.PrintOutTrackSearchCriteria */
export class PrintOutTrackSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.printTrackType = 0 ;
		this.printedBY = '' ;
		this.fromPrintedDate = '' ;
		this.toPrintedDate = '' ;
	}
}
/* ds.inquiry.criteria.PrintPickTicketInquiryCriteriaBean */
export class PrintPickTicketInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fromPickedDate = '' ;
		this.toPickedDate = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.customerCode = '' ;
		this.pickerName = '' ;
		this.salesOrderNumber = '' ;
		this.pickTicketNumber = '' ;
		this.status = '' ;
		this.fromOrderStartDate = '' ;
		this.toOrderStartDate = '' ;
		this.fromOrderStopDate = '' ;
		this.toOrderStopDate = '' ;
		this.rollSkuNumber = 0 ;
		this.locationCode = '' ;
	}
}
/* ds.inquiry.criteria.PrintPickTicketPrintOutCriteriaBean */
export class PrintPickTicketPrintOutCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.pickInfos = new Array() ;
	}
}
/* ds.inquiry.criteria.ProductAvailabilityCriteriaBean */
export class ProductAvailabilityCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
	}
}
/* ds.inquiry.criteria.PurchaseOrderInTransitInquirySearchCriteria */
export class PurchaseOrderInTransitInquirySearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderInTransitNumber = '' ;
		this.fromOrderStartDate = '' ;
		this.toOrderStartDate = '' ;
		this.fromOrderStopDate = '' ;
		this.toOrderStopDate = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.vendorCode = '' ;
		this.skuNumber = 0 ;
		this.logisticCustomerCode = '' ;
		this.fabricStyleCodes = new Array() ;
	}
}
/* ds.inquiry.criteria.PurchaseOrderUnApprovedCriteriaBean */
export class PurchaseOrderUnApprovedCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.startDate = '' ;
		this.stopDate = '' ;
		this.vendorCode = '' ;
	}
}
/* ds.inquiry.criteria.ReportHistoryDetailCriteria */
export class ReportHistoryDetailCriteria {
	constructor() {
		this.companyCode = '' ;
		this.reportType = 0 ;
		this.reportDate = '' ;
		this.downloadReportType = 0 ;
	}
}
/* ds.inquiry.criteria.ReturnCreditPersonCommissionCriteriaBean */
export class ReturnCreditPersonCommissionCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.salesPersonCode = '' ;
	}
}
/* ds.inquiry.criteria.SalesAnalysisInquiryCriteriaBean */
export class SalesAnalysisInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.fiscalCode = '' ;
		this.currentFiscalFromDate = '' ;
		this.currentFiscalToDate = '' ;
		this.previousFiscalFromDate = '' ;
		this.previousFiscalToDate = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.salesPersonCode = '' ;
		this.fabricStyleCode = '' ;
		this.startYear = '' ;
		this.endYear = '' ;
		this.excludeSampleItemFlag = false ;
	}
}
/* ds.inquiry.criteria.SalesAndPurchaseInquiryCriteriaBean */
export class SalesAndPurchaseInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.vendorCode = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.customerCode = '' ;
		this.excludedLocationCodes = new Array() ;
		this.locationCode = '' ;
		this.resultType = 0 ;
		this.customerPurchaseOrderNumber = '' ;
	}
}
/* ds.inquiry.criteria.SalesBackOrderSearchCriteria */
export class SalesBackOrderSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.salesPersonCode = '' ;
		this.fromOrderStopDate = '' ;
		this.toOrderStopDate = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.isBackOrderCheckFlag = false ;
	}
}
/* ds.inquiry.criteria.SalesOrderAdjustmentTrackInquiryCriteriaBean */
export class SalesOrderAdjustmentTrackInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.isDetailsRequired = false ;
		this.isLinesWithoutAdjustmentRequired = false ;
	}
}
/* ds.inquiry.criteria.SalesOrderCancelLineSearchCriteriaBean */
export class SalesOrderCancelLineSearchCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.customerCode = '' ;
		this.salesPersonCode = '' ;
		this.fromSalesOrderDate = '' ;
		this.toSalesOrderDate = '' ;
		this.fromAdjustmentCreatedDate = '' ;
		this.toAdjustmentCreatedDate = '' ;
	}
}
/* ds.inquiry.criteria.SalesOrderLineAdjustmentTrackInquiryCriteriaBean */
export class SalesOrderLineAdjustmentTrackInquiryCriteriaBean {
	constructor() {
		this.salesOrderNumber = '' ;
		this.companyCode = '' ;
	}
}
/* ds.inquiry.criteria.SalesOrderListReportCriteria */
export class SalesOrderListReportCriteria {
	constructor() {
		this.companyCode = '' ;
		this.orderFromStopDate = '' ;
		this.orderToStopDate = '' ;
		this.fromOrderDate = '' ;
		this.toOrderDate = '' ;
		this.salesPersonCodes = new Array() ;
		this.customerCodes = new Array() ;
		this.orderSelectionStatus = 0 ;
		this.salesRepresentativeCode = '' ;
		this.excludeCancelFlag = false ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
	}
}
/* ds.inquiry.criteria.SalesPersonInvoiceCommissionCriteria */
export class SalesPersonInvoiceCommissionCriteria {
	constructor() {
		this.companyCode = '' ;
		this.fromPaymentPostDate = '' ;
		this.toPaymentPostDate = '' ;
		this.salesPersonCode = '' ;
	}
}
/* ds.inquiry.criteria.SalesPriceInquiryCriteria */
export class SalesPriceInquiryCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.fabricStyleCodes = new Array() ;
		this.salesPersonCode = '' ;
	}
}
/* ds.inquiry.criteria.ShippingReportCriteriaBean */
export class ShippingReportCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fromInvoiceDate = '' ;
		this.toInvoiceDate = '' ;
		this.invoiceStatus = '' ;
	}
}
/* ds.inquiry.criteria.SKUSearchCriteria */
export class SKUSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
	}
}
/* ds.inquiry.criteria.SummaryReportInfoCriteriaBean */
export class SummaryReportInfoCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.status = '' ;
		this.pageList = null ;
		this.isExportAll = false ;
	}
}
/* ds.inquiry.criteria.UnPostedARListCriteriaBean */
export class UnPostedARListCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.startAccountReceivableDate = '' ;
		this.endAccountReceivableDate = '' ;
		this.customerCode = '' ;
	}
}
/* ds.inquiry.criteria.VendorInvoiceExpenseDetailSearchCriteria */
export class VendorInvoiceExpenseDetailSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.expenseType = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
	}
}
/* ds.inquiry.criteria.VendorPurchaseOnOrderSearchCriteria */
export class VendorPurchaseOnOrderSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.vendorCode = '' ;
		this.orderStopFromDate = '' ;
		this.orderStopToDate = '' ;
		this.isFetchDetailsTillOrderStopDate = false ;
		this.locationCode = '' ;
		this.customerCode = '' ;
		this.isUseReserveCustomerFlag = false ;
		this.isUseCustomerSalesOrderDetailsFlag = false ;
		this.excludedLocationCodes = new Array() ;
	}
}
/* ds.inquiry.criteria.VendorPurchaseOrderInTransitSearchCriteria */
export class VendorPurchaseOrderInTransitSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.vendorCode = '' ;
	}
}
/* ds.inquiry.criteria.VendorStatisticsInquiryCriteriaBean */
export class VendorStatisticsInquiryCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.currencyCode = '' ;
	}
}
/* ds.inquiry.criteria.WeightConversionInputCriteriaBean */
export class WeightConversionInputCriteriaBean {
	constructor() {
		this.sourceWeightUOM = '' ;
		this.weightValue = 0 ;
		this.widthInInches = '' ;
	}
}
/* ds.inquiry.CustomerDataExportElectronicInputLineBean */
export class CustomerDataExportElectronicInputLineBean {
	constructor() {
		this.customercode = '' ;
		this.customerName = '' ;
		this.invoiceNumber = '' ;
	}
}
/* ds.inquiry.CustomerSalesPersonDataExportInputBean */
export class CustomerSalesPersonDataExportInputBean {
	constructor() {
		this.customerName = '' ;
		this.salesPerson = '' ;
		this.salesRepresentative = '' ;
		this.deliveryType = '' ;
		this.customerType = '' ;
		this.customerCode = '' ;
		this.shipVia = '' ;
		this.paymentTerms = '' ;
		this.state = '' ;
		this.commissionPercentage = 0 ;
	}
}
/* ds.inquiry.DataElectronicInputBean */
export class DataElectronicInputBean {
	constructor() {
		this.entityCode = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.date = '' ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.rollNumber = '' ;
		this.lotNumber = '' ;
		this.price = 0 ;
		this.quantity = 0 ;
		this.customerName = '' ;
		this.skuNumber = 0 ;
	}
}
/* ds.inquiry.DiscountDisputetInputDataBean */
export class DiscountDisputetInputDataBean {
	constructor() {
		this.discountNumber = '' ;
		this.type = '' ;
		this.client = '' ;
		this.date = '' ;
		this.amount = 0 ;
		this.checkNumber = '' ;
		this.disbNumber = '' ;
		this.invoiceNumber = '' ;
		this.memo = '' ;
		this.sourceLineNumber = 0 ;
		this.appliedInvoiceNumber = '' ;
		this.csvInvoiceNumber = '' ;
		this.grandTotalAmount = 0 ;
		this.disbAmount = 0 ;
	}
}
/* ds.inquiry.DorellInvoiceDataExportElectronicInputHeaderBean */
export class DorellInvoiceDataExportElectronicInputHeaderBean {
	constructor() {
		this.invoiceNumber = '' ;
		this.invoiceDate = '' ;
		this.dueDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.salesOrderNumber = '' ;
		this.pickTicketNumber = '' ;
		this.isPaid = false ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.shipViaCode = '' ;
		this.shipViaDescription = '' ;
		this.paymentTermCode = '' ;
		this.customerPONumber = '' ;
		this.customerShipTo = '' ;
		this.customerShipToName = '' ;
		this.address1 = '' ;
		this.address2 = '' ;
		this.city = '' ;
		this.state = '' ;
		this.zip = '' ;
		this.country = '' ;
		this.locationCode = '' ;
		this.businessDivsion = '' ;
		this.lines = new Array() ;
	}
}
/* ds.inquiry.DorellInvoiceDataExportElectronicInputLineBean */
export class DorellInvoiceDataExportElectronicInputLineBean {
	constructor() {
		this.type = '' ;
		this.invoiceDate = '' ;
		this.lineNumber = 0 ;
		this.invoiceNumber = '' ;
		this.description = '' ;
		this.customerPONumber = '' ;
		this.customerName = '' ;
		this.shipDate = '' ;
		this.fob = '' ;
		this.shipVia = '' ;
		this.paymentTerm = '' ;
		this.dueDate = '' ;
		this.item = '' ;
		this.itemDescription = '' ;
		this.salesRepresentative = '' ;
		this.paidType = '' ;
		this.quantity = 0 ;
		this.uom = '' ;
		this.salesPrice = 0 ;
		this.totalAmount = 0 ;
		this.salesOrderNumber = '' ;
		this.pickTicketCode = '' ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.customerCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleColorName = '' ;
		this.skuNumber = 0 ;
		this.paidStatus = '' ;
		this.isExtraCharge = false ;
		this.isNonMerchandiseLine = false ;
		this.customerShipTo = '' ;
		this.customerShipToName = '' ;
		this.address1 = '' ;
		this.address2 = '' ;
		this.city = '' ;
		this.state = '' ;
		this.zip = '' ;
		this.country = '' ;
		this.totalQuantity = 0 ;
		this.grandTotalAmount = 0 ;
		this.totalOpenUnit = 0 ;
		this.taxAmount = 0 ;
		this.discountPercentage = 0 ;
		this.totalLineAmount = 0 ;
		this.totalLineUnits = 0 ;
		this.warehouseCode = '' ;
		this.freightCharge = 0 ;
		this.specialCharge = 0 ;
		this.shipViaDescription = '' ;
		this.status = '' ;
		this.additionalCharge = 0 ;
		this.businessDivsion = '' ;
	}
}
/* ds.inquiry.DorellPurchaseOrderDataExportHeaderBean */
export class DorellPurchaseOrderDataExportHeaderBean {
	constructor() {
		this.purchaseOrderNumber = '' ;
		this.orderDate = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.deliveryDate = '' ;
		this.grandTotalAmount = 0 ;
		this.orderQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.dueDate = '' ;
		this.xFactoryDate = '' ;
		this.inconsolidationDate = '' ;
		this.inDcDate = '' ;
		this.etaDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.locationCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.openQuantity = 0 ;
		this.city = '' ;
		this.address1 = '' ;
		this.address2 = '' ;
		this.state = '' ;
		this.zip = '' ;
		this.country = '' ;
		this.shipToCity = '' ;
		this.shipToAddress1 = '' ;
		this.shipToAddress2 = '' ;
		this.shipToState = '' ;
		this.shipToZip = '' ;
		this.shipToCountry = '' ;
		this.fob = '' ;
		this.shipVia = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.estimatedShipDate = '' ;
		this.shipTo = '' ;
		this.purchaseDivisionCode = '' ;
		this.orderType = '' ;
		this.factoryCode = '' ;
		this.purchaseOrderInputlines = new Array() ;
	}
}
/* ds.inquiry.DorellPurchaseOrderDataInputLineBean */
export class DorellPurchaseOrderDataInputLineBean {
	constructor() {
		this.OrderDate = '' ;
		this.startDate = '' ;
		this.stopDate = '' ;
		this.estimatedShipDate = '' ;
		this.lineNumber = 0 ;
		this.purchaseOrderNumber = '' ;
		this.sourceName = '' ;
		this.memo = '' ;
		this.deliveryDate = '' ;
		this.orderedQty = 0 ;
		this.receivedQty = 0 ;
		this.backOrderedQty = 0 ;
		this.salesPrice = 0 ;
		this.totalAmount = 0 ;
		this.fob = '' ;
		this.shipVia = '' ;
		this.paymentTerm = '' ;
		this.dueDate = '' ;
		this.item = '' ;
		this.itemDescription = '' ;
		this.account = '' ;
		this.openBalance = 0 ;
		this.shipToCity = '' ;
		this.shipToAddress1 = '' ;
		this.shipToAddress2 = '' ;
		this.shipToState = '' ;
		this.shipToZip = '' ;
		this.shipToCountry = '' ;
		this.skuNumber = 0 ;
		this.xFactoryDate = '' ;
		this.inConsolidationDate = '' ;
		this.inDcDate = '' ;
		this.etaDate = '' ;
		this.oldSystemPurchaseOrderLineNumber = '' ;
		this.shipTo = '' ;
		this.purchaseDivisionCode = '' ;
		this.orderType = '' ;
		this.sts = '' ;
		this.sailDate = '' ;
		this.availableDate = '' ;
		this.user = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.factoryCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.locationCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.openQuantity = 0 ;
		this.city = '' ;
		this.address1 = '' ;
		this.address2 = '' ;
		this.state = '' ;
		this.zip = '' ;
		this.country = '' ;
		this.price = 0 ;
		this.fobCost = 0 ;
		this.landedCost = 0 ;
	}
}
/* ds.inquiry.EcomConnectorMultiResponseBean */
export class EcomConnectorMultiResponseBean {
	constructor() {
		this.count = 0 ;
		this.submitedJobId = 0 ;
		this.submittedDate = null ;
		this.errorMessage = '' ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.EcomConnectorResponseBean */
export class EcomConnectorResponseBean {
	constructor() {
		this.count = 0 ;
		this.resultResponseInfos = null ;
		this.multiReposnse = new Array() ;
		this.submitedJobId = 0 ;
		this.submittedDate = null ;
		this.errorMessage = '' ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.ExpectedMonthlySalesDetails */
export class ExpectedMonthlySalesDetails {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.salesAmount = 0 ;
		this.invoiceDate = '' ;
		this.agingDate = '' ;
		this.yearMonthCode = '' ;
		this.week = 0 ;
		this.day = 0 ;
		this.month = 0 ;
		this.year = 0 ;
		this.salesPersonCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
	}
}
/* ds.inquiry.FabricStyleCatalogDetails */
export class FabricStyleCatalogDetails {
	constructor() {
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleColorName = '' ;
		this.uomCode = '' ;
		this.weight = 0 ;
		this.width = '' ;
		this.notes = '' ;
		this.fabricStyleImagePath = '' ;
		this.fabricStyleColorImagePath = '' ;
		this.price = 0 ;
		this.skuNumber = 0 ;
	}
}
/* ds.inquiry.FabricStyleColorDataExportElectronicInputLineBean */
export class FabricStyleColorDataExportElectronicInputLineBean {
	constructor() {
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleReferenceName = '' ;
		this.fabricStyleColorName = '' ;
	}
}
/* ds.inquiry.FabricStyleCostPriceDataExportInputBean */
export class FabricStyleCostPriceDataExportInputBean {
	constructor() {
		this.fabricStyleCode = '' ;
		this.fobCost = 0 ;
		this.designerPrice = 0 ;
		this.retailPrice = 0 ;
		this.aListPrice = 0 ;
		this.bListPrice = 0 ;
		this.lowestPrice = 0 ;
	}
}
/* ds.inquiry.FabricStyleFinderResponseBean */
export class FabricStyleFinderResponseBean {
	constructor() {
		this.count = 0 ;
		this.resultResponseInfos = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.FabricStyleInventoryHistoryInfo */
export class FabricStyleInventoryHistoryInfo {
	constructor() {
		this.historyId = 0 ;
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleColorName = '' ;
		this.uomCode = '' ;
		this.locationCode = '' ;
		this.price = 0 ;
		this.cost = 0 ;
		this.skuNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.onHandQuantity = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inquiry.FabricStyleSkuPriceDataExportInputBean */
export class FabricStyleSkuPriceDataExportInputBean {
	constructor() {
		this.fabricStyleReferenceName = '' ;
		this.fabricStyleDescription = '' ;
		this.price = 0 ;
		this.cost = 0 ;
		this.salesOrderQty = 0 ;
	}
}
/* ds.inquiry.FabricStyleWeeklyMonthlyATSInfoBean */
export class FabricStyleWeeklyMonthlyATSInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.openBalanceQuantity = 0 ;
		this.onHandQuantity = 0 ;
		this.customerOnOrderQuantity = 0 ;
		this.vendorOnOrderQuantity = 0 ;
		this.endBalanceQuantity = 0 ;
		this.agingDate = '' ;
		this.startDate = '' ;
		this.endDate = '' ;
		this.week = 0 ;
		this.day = 0 ;
		this.month = 0 ;
		this.year = 0 ;
	}
}
/* ds.inquiry.FabricStyleWeeklyMonthlyATSResultBean */
export class FabricStyleWeeklyMonthlyATSResultBean {
	constructor() {
		this.atsInfos = new Array() ;
	}
}
/* ds.inquiry.FactorChargeInputDataBean */
export class FactorChargeInputDataBean {
	constructor() {
		this.type = '' ;
		this.appliedInvoiceNumber = '' ;
		this.csvInvoiceNumber = '' ;
		this.disbNumber = '' ;
		this.amount = 0 ;
		this.grandTotalAmount = 0 ;
		this.client = '' ;
		this.date = '' ;
		this.memo = '' ;
		this.sourceLineNumber = 0 ;
	}
}
/* ds.inquiry.FixDuplicateSalesPersonDataExportInputBean */
export class FixDuplicateSalesPersonDataExportInputBean {
	constructor() {
		this.existingSalesPersonCode = '' ;
		this.targetSalesPersonCode = '' ;
	}
}
/* ds.inquiry.FixSalesCommissionTransactionBean */
export class FixSalesCommissionTransactionBean {
	constructor() {
		this.pickTicketNumber = '' ;
		this.pickedDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.salesOrderNumber = '' ;
		this.invoiceNumber = '' ;
		this.pickedBy = '' ;
		this.logisticMethodCode = '' ;
	}
}
/* ds.inquiry.FixUomDataExportInputBean */
export class FixUomDataExportInputBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.uomCode = '' ;
	}
}
/* ds.inquiry.info.AllCustomerBalanceInfoBean */
export class AllCustomerBalanceInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.agingAmount = 0 ;
		this.customerBalanceAmount = 0 ;
		this.customerAccountSummaryAmount = 0 ;
		this.unAppliedCreditMemoAmount = 0 ;
	}
}
/* ds.inquiry.info.AllCustomerOnlineAgingResultBean */
export class AllCustomerOnlineAgingResultBean {
	constructor() {
		this.agingBucketGroupBean = null ;
		this.agingInfos = new Array() ;
		this.allCustomerTotalInvoiceDueAmount = 0 ;
		this.allCustomerStandardTotalInvoiceDueAmount = 0 ;
		this.allCustomerCurrentAgeAmount = 0 ;
		this.allCustomerAgeAmount1 = 0 ;
		this.allCustomerAgeAmount2 = 0 ;
		this.allCustomerAgeAmount3 = 0 ;
		this.allCustomerAgeAmount4 = 0 ;
		this.allCustomerAgeAmount5 = 0 ;
		this.allCustomerAgeAmount6 = 0 ;
		this.allCustomerAgeAmount7 = 0 ;
		this.allCustomerAgeAmount8 = 0 ;
		this.allCustomerAgeAmount9 = 0 ;
		this.allCustomerAgeAmount10 = 0 ;
		this.allCustomerTotalCreditMemoAmount = 0 ;
		this.allCustomerProvisionalAppliedAmount = 0 ;
	}
}
/* ds.inquiry.info.AllCustomerTransactionBalanceResultBean */
export class AllCustomerTransactionBalanceResultBean {
	constructor() {
		this.companyCode = '' ;
		this.balanceInfos = new Array() ;
	}
}
/* ds.inquiry.info.ApprovedSalesOrderLinePickTicketGenerationLineBean */
export class ApprovedSalesOrderLinePickTicketGenerationLineBean {
	constructor() {
		this.companyCode = '' ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.orderedQuantity = 0 ;
		this.price = 0 ;
		this.salesOrderNumber = '' ;
		this.openQuantity = 0 ;
		this.pickTicketNumber = '' ;
	}
}
/* ds.inquiry.info.ApprovedSalesOrderPickTicketGenerationBean */
export class ApprovedSalesOrderPickTicketGenerationBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.salesOrderNumber = '' ;
		this.salesOrderDate = '' ;
		this.salesOrderStartDate = '' ;
		this.salesOrderStopDate = '' ;
		this.pickTicketDate = '' ;
		this.status = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.webSalesOrderNumber = '' ;
		this.webChanneledType = '' ;
		this.targetWebSite = '' ;
		this.pickTicketNumbers = '' ;
		this.lines = new Array() ;
	}
}
/* ds.inquiry.info.ApprovedSalesOrderPickTicketPageListBean */
export class ApprovedSalesOrderPickTicketPageListBean {
	constructor() {
		this.count = 0 ;
		this.infoBeans = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inquiry.info.AvailableToSaleInfoBean */
export class AvailableToSaleInfoBean {
	constructor() {
		this.beginingBalanceAmount = 0 ;
		this.onHandQuantity = 0 ;
		this.salesOnOrderQuantity = 0 ;
		this.purchaseOnOrderQuantity = 0 ;
		this.endBalanceAmount = 0 ;
		this.isAtRisk = false ;
		this.periodType = 0 ;
		this.startDate = '' ;
		this.endDate = '' ;
		this.displayName = '' ;
		this.displayOrderIndex = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inquiry.info.AvailableToSalePeriodDefinitionBean */
export class AvailableToSalePeriodDefinitionBean {
	constructor() {
		this.periodType = 0 ;
		this.startDate = '' ;
		this.endDate = '' ;
		this.displayName = '' ;
		this.displayOrderIndex = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inquiry.info.AvailableToSalePeriodInfoGroupBean */
export class AvailableToSalePeriodInfoGroupBean {
	constructor() {
		this.periodInfos = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inquiry.info.BankAccountBalanceHistoryTrackInquiryResultBean */
export class BankAccountBalanceHistoryTrackInquiryResultBean {
	constructor() {
		this.openingBalance = 0 ;
		this.closingBalance = 0 ;
		this.currency = '' ;
		this.historyTracks = new Array() ;
	}
}
/* ds.inquiry.info.BinLocationDataExportDetailInfoBean */
export class BinLocationDataExportDetailInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.binLocationCode = '' ;
		this.binLocationName = '' ;
	}
}
/* ds.inquiry.info.BookingReportDataBean */
export class BookingReportDataBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleShortName = '' ;
		this.colorCode = '' ;
		this.salesOrderNumber = '' ;
		this.salesOrderDate = '' ;
		this.salesOrderStartDate = '' ;
		this.salesOrderStopDate = '' ;
		this.salesPerson = '' ;
		this.salesPersonName = '' ;
		this.amount = 0 ;
		this.quantity = 0 ;
		this.skuNumber = 0 ;
		this.openQuantity = 0 ;
		this.lineTotalAmount = 0 ;
	}
}
/* ds.inquiry.info.BookingReportInfoBean */
export class BookingReportInfoBean {
	constructor() {
		this.totalQuantity = 0 ;
		this.totalAmount = 0 ;
		this.totalOpenQuantity = 0 ;
		this.bookingInfoBean = new Array() ;
	}
}
/* ds.inquiry.info.BouncedChecksInquiryInfoBean */
export class BouncedChecksInquiryInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.checkBounceProcessCode = '' ;
		this.accountReceivableNumber = '' ;
		this.accountReceivableDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.checkAmount = 0 ;
		this.checkNumber = '' ;
		this.checkDate = '' ;
		this.postedDate = '' ;
		this.reversedDate = '' ;
		this.reversalReasonCode = '' ;
		this.comments = '' ;
	}
}
/* ds.inquiry.info.BouncedChecksInquiryResultBean */
export class BouncedChecksInquiryResultBean {
	constructor() {
		this.count = 0 ;
		this.bouncedChecksInfos = new Array() ;
		this.totalBouncedCheckAmount = 0 ;
	}
}
/* ds.inquiry.info.CashReceiptsActivityDetailBean */
export class CashReceiptsActivityDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.arNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.arDate = '' ;
		this.paymentType = 0 ;
		this.paymentAmount = 0 ;
		this.invoiceNumber = '' ;
		this.invoiceAmount = 0 ;
		this.receivedPercentage = 0 ;
		this.documentNumber = '' ;
		this.createdBy = '' ;
		this.remarks = '' ;
	}
}
/* ds.inquiry.info.CashReceiptsActivityResultBean */
export class CashReceiptsActivityResultBean {
	constructor() {
		this.totalCardAmount = 0 ;
		this.totalCheckAmount = 0 ;
		this.totalWireAmount = 0 ;
		this.totalCashAmount = 0 ;
		this.totalCreditMemoAmount = 0 ;
		this.totalReceivedAmount = 0 ;
		this.tenderReceivedAmount = 0 ;
		this.detailInfos = new Array() ;
		this.customerPayments = new Array() ;
	}
}
/* ds.inquiry.info.CashReceiptsCustomerActivityDetail */
export class CashReceiptsCustomerActivityDetail {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.paymentAmount = 0 ;
		this.invoiceAmount = 0 ;
	}
}
/* ds.inquiry.info.CheckDetailsPaymentResultBean */
export class CheckDetailsPaymentResultBean {
	constructor() {
		this.infoBean = null ;
		this.checkAppliedInvoices = new Array() ;
		this.creditMemoAppliedInvoices = new Array() ;
		this.creditMemoBean = null ;
		this.reversedCheckDetails = new Array() ;
	}
}
/* ds.inquiry.info.CheckPaymentDetailsAppliedInvoicesInfoBean */
export class CheckPaymentDetailsAppliedInvoicesInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.accountReceivableNumber = '' ;
		this.invoiceNumber = '' ;
		this.invoiceDate = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.currencyCode = '' ;
		this.openInvoiceAmount = 0 ;
		this.appliedAmount = 0 ;
		this.totalAppliedAmount = 0 ;
		this.creditMemoAppliedAmount = 0 ;
	}
}
/* ds.inquiry.info.CheckPaymentDetailsForARInfoBean */
export class CheckPaymentDetailsForARInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.accountReceivableNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.currencyCode = '' ;
		this.overPaymentCreditMemoNumber = '' ;
		this.checkNumber = '' ;
		this.checkDate = '' ;
		this.checkAmount = 0 ;
		this.wireTransferNumber = '' ;
		this.wireTransferDate = '' ;
		this.wireAmount = 0 ;
		this.issuerBankAccountNumber = '' ;
		this.issuerBankName = '' ;
		this.issuerBankAddress = '' ;
		this.cardNumber = '' ;
		this.cardAmount = 0 ;
		this.cardType = '' ;
		this.cardHolderFirstName = '' ;
		this.cardHolderLastName = '' ;
		this.cardIssuedDate = '' ;
		this.expiryMonth = '' ;
		this.expiryYear = '' ;
		this.achNumber = '' ;
		this.achDate = '' ;
		this.achAmount = 0 ;
		this.creditMemoNumber = '' ;
		this.creditMemoAmount = 0 ;
		this.creditMemoAppliedAmount = 0 ;
		this.reversedDate = '' ;
		this.arStatus = '' ;
	}
}
/* ds.inquiry.info.ColorDataExportDetailInfoBean */
export class ColorDataExportDetailInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.colorCode = '' ;
		this.colorName = '' ;
	}
}
/* ds.inquiry.info.CustomerAccountTransactionInquiryResultBean */
export class CustomerAccountTransactionInquiryResultBean {
	constructor() {
		this.accountSummaryResult = null ;
	}
}
/* ds.inquiry.info.CustomerAllocationInTransitInfoBean */
export class CustomerAllocationInTransitInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.startDate = '' ;
		this.stopDate = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColor = '' ;
		this.inTransitQuantity = 0 ;
		this.uomCode = '' ;
		this.skuNumber = 0 ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.widthCode = '' ;
		this.fobCost = 0 ;
		this.landedCost = 0 ;
		this.locationCode = '' ;
		this.etaDate = '' ;
	}
}
/* ds.inquiry.info.CustomerAllocationInTransitInquiryResultBean */
export class CustomerAllocationInTransitInquiryResultBean {
	constructor() {
		this.count = 0 ;
		this.inTransitInfos = new Array() ;
	}
}
/* ds.inquiry.info.CustomerBalanceDetailHistoryInquiryResultBean */
export class CustomerBalanceDetailHistoryInquiryResultBean {
	constructor() {
		this.openingBalance = 0 ;
		this.closingBalance = 0 ;
		this.currency = '' ;
		this.historyInfos = new Array() ;
		this.creditMemoDetailsBean = new Array() ;
		this.totalUnAppliedCreditMemoAmount = 0 ;
	}
}
/* ds.inquiry.info.CustomerBalanceHistoryDetailsInputBean */
export class CustomerBalanceHistoryDetailsInputBean {
	constructor() {
		this.customerCode = '' ;
		this.customerBalanceDetails = new Array() ;
	}
}
/* ds.inquiry.info.CustomerBalanceMatchInfoBean */
export class CustomerBalanceMatchInfoBean {
	constructor() {
		this.customerCode = '' ;
		this.customerName = '' ;
		this.closingBalanceAmount = 0 ;
		this.totalAgingAmount = 0 ;
		this.totalUnAppliedAmount = 0 ;
		this.differenceAmount = 0 ;
	}
}
/* ds.inquiry.info.CustomerBalanceSimpleHistoryBean */
export class CustomerBalanceSimpleHistoryBean {
	constructor() {
		this.customerCode = '' ;
		this.balanceDetailHistoryNumber = 0 ;
		this.closingBalanceAmount = 0 ;
		this.historyDate = '' ;
	}
}
/* ds.inquiry.info.CustomerDataExportDetailInfoBean */
export class CustomerDataExportDetailInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerCompanyName = '' ;
		this.currencyCode = '' ;
		this.divisionCode = '' ;
		this.customerTypeCode = '' ;
		this.discountPercentage = 0 ;
		this.comments = '' ;
		this.instructions = '' ;
		this.markUpDownPercentage = 0 ;
		this.ShipToName = '' ;
		this.ShipToAddress = '' ;
		this.ShipToCity = '' ;
		this.ShipToState = '' ;
		this.ShipToZip = '' ;
		this.SoldToName = '' ;
		this.SoldToAddress1 = '' ;
		this.SoldToAddress2 = '' ;
		this.SoldToCity = '' ;
		this.SoldToState = '' ;
		this.SoldToCountry = '' ;
		this.SoldToZip = '' ;
		this.creditLimit = 0 ;
		this.TelePhone = '' ;
		this.TeleExt = '' ;
		this.faxNumber = '' ;
		this.contact = '' ;
		this.resaleNumber = '' ;
		this.salesTaxRequiredFlag = false ;
		this.paymentTerm = '' ;
		this.SalesPerson = '' ;
		this.SalesPersonName = '' ;
		this.DateOfBirth = '' ;
		this.commissionPercentage = 0 ;
		this.EntryDate = '' ;
		this.ShipAccount = '' ;
		this.customerCategory = '' ;
		this.autoFax = '' ;
		this.fobCity = '' ;
		this.priceLevel = 0 ;
		this.customerRepresentativeCode = '' ;
	}
}
/* ds.inquiry.info.CustomerDataExportDetailInfoBean_texco */
export class CustomerDataExportDetailInfoBean_texco {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerCompanyName = '' ;
		this.currencyCode = '' ;
		this.divisionCode = '' ;
		this.customerTypeCode = '' ;
		this.soldToName = '' ;
		this.address1 = '' ;
		this.address2 = '' ;
		this.city = '' ;
		this.state = '' ;
		this.country = '' ;
		this.zip = '' ;
		this.phone1 = '' ;
		this.phone2 = '' ;
		this.mobileNumber = '' ;
		this.creditLimit = 0 ;
		this.TelePhone = '' ;
		this.TeleExt = '' ;
		this.faxNumber = '' ;
		this.contact = '' ;
		this.resaleNumber = '' ;
		this.paymentTerm = '' ;
		this.salesPerson = '' ;
		this.salesPersonName = '' ;
		this.email = '' ;
		this.webAddress = '' ;
		this.accountNumber = '' ;
		this.territory = '' ;
		this.status = '' ;
		this.dbaName = '' ;
		this.salesCommissionPercentage = 0 ;
		this.salesManager = '' ;
		this.parentAccountNumber = '' ;
		this.parentName = '' ;
		this.salesPerson2 = '' ;
		this.shipVia = '' ;
	}
}
/* ds.inquiry.info.CustomerDetailsSalesInvoiceInfoBean */
export class CustomerDetailsSalesInvoiceInfoBean {
	constructor() {
		this.customerCode = '' ;
		this.customerName = '' ;
		this.onOrderQuantity = 0 ;
		this.invoicedQuantity = 0 ;
		this.salesOrderInfos = new Array() ;
		this.invoiceInfos = new Array() ;
	}
}
/* ds.inquiry.info.CustomerDetailsWithInvoiceInfoBean */
export class CustomerDetailsWithInvoiceInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.invoiceNumber = '' ;
		this.customerPONumber = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleShortName = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.widthCode = '' ;
		this.orderUom = '' ;
		this.shippedQuantity = 0 ;
	}
}
/* ds.inquiry.info.CustomerDetailsWithSalesOnOrderInfoBean */
export class CustomerDetailsWithSalesOnOrderInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.salesOrderNumber = '' ;
		this.customerPONumber = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleShortName = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.widthCode = '' ;
		this.orderUom = '' ;
		this.openOrderQuantity = 0 ;
	}
}
/* ds.inquiry.info.CustomerLogisticOnOrderDetailsBean */
export class CustomerLogisticOnOrderDetailsBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerStyleCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleShortName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.onOrderQuantity = 0 ;
		this.orderUom = '' ;
		this.logisticOrderNumber = '' ;
		this.logisticOrderLineNumber = 0 ;
		this.orderDate = '' ;
	}
}
/* ds.inquiry.info.CustomerLogisticOnOrderDetailsResultBean */
export class CustomerLogisticOnOrderDetailsResultBean {
	constructor() {
		this.count = 0 ;
		this.onOrderInfoDetails = new Array() ;
	}
}
/* ds.inquiry.info.CustomerOnlineAgingRegisterInfoBean */
export class CustomerOnlineAgingRegisterInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.email = '' ;
		this.mobilePhone = '' ;
		this.phone1 = '' ;
		this.phone2 = '' ;
		this.lastPaymentAmount = 0 ;
		this.lastPaymentDate = '' ;
		this.ratingStar = '' ;
		this.rating = 0 ;
		this.totalInvoiceDueAmount = 0 ;
		this.totalUnAppliedCreditMemoAmount = 0 ;
		this.totalUnAppliedChargeBackAmount = 0 ;
		this.totalProvisionalAppliedAmount = 0 ;
		this.currentAgeAmount = 0 ;
		this.ageAmount1 = 0 ;
		this.ageAmount2 = 0 ;
		this.ageAmount3 = 0 ;
		this.ageAmount4 = 0 ;
		this.ageAmount5 = 0 ;
		this.ageAmount6 = 0 ;
		this.ageAmount7 = 0 ;
		this.ageAmount8 = 0 ;
		this.ageAmount9 = 0 ;
		this.ageAmount10 = 0 ;
		this.currencyCode = '' ;
		this.salesPersonCodes = '' ;
		this.salesPersonNames = '' ;
		this.totalCreditMemoAmount = 0 ;
		this.customerClosingBalanceAmount = 0 ;
	}
}
/* ds.inquiry.info.CustomerOnOrderWithAtsInfoBean */
export class CustomerOnOrderWithAtsInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleColorName = '' ;
		this.uomCode = '' ;
		this.onHandQuantity = 0 ;
		this.customerOnOrderQuantity = 0 ;
		this.vendorOnOrderQuantity = 0 ;
		this.availableToSaleQuantity = 0 ;
		this.openOrderQuantity = 0 ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.salesOrder = '' ;
		this.customerPO = '' ;
		this.latestShipDate = '' ;
		this.vendorInfo = new Array() ;
	}
}
/* ds.inquiry.info.CustomerPaymentAgingHistoryInquiryBean */
export class CustomerPaymentAgingHistoryInquiryBean {
	constructor() {
		this.customerName = '' ;
		this.email = '' ;
		this.mobilePhone = '' ;
		this.phone1 = '' ;
		this.phone2 = '' ;
		this.ratingStar = '' ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.currencyCode = '' ;
		this.totalInvoiceDueAmount = 0 ;
		this.totalUnAppliedCreditMemoAmount = 0 ;
		this.totalUnAppliedChargeBackAmount = 0 ;
		this.totalProvisionalAppliedAmount = 0 ;
		this.currentAgeAmount = 0 ;
		this.ageAmount1 = 0 ;
		this.ageAmount2 = 0 ;
		this.ageAmount3 = 0 ;
		this.ageAmount4 = 0 ;
		this.ageAmount5 = 0 ;
		this.ageAmount6 = 0 ;
		this.ageAmount7 = 0 ;
		this.ageAmount8 = 0 ;
		this.ageAmount9 = 0 ;
		this.ageAmount10 = 0 ;
		this.customerDetails = null ;
		this.companyCurrencyCode = '' ;
		this.standardTotalInvoiceDueAmount = 0 ;
		this.standardCurrentAgeAmount = 0 ;
		this.standardAgeAmount1 = 0 ;
		this.standardAgeAmount2 = 0 ;
		this.standardAgeAmount3 = 0 ;
		this.standardAgeAmount4 = 0 ;
		this.standardAgeAmount5 = 0 ;
		this.standardAgeAmount6 = 0 ;
		this.standardAgeAmount7 = 0 ;
		this.standardAgeAmount8 = 0 ;
		this.standardAgeAmount9 = 0 ;
		this.standardAgeAmount10 = 0 ;
		this.remarks = '' ;
		this.invoiceDetails = new Array() ;
		this.creditMemoDetails = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inquiry.info.CustomerPaymentAgingHistoryInquiryResultBean */
export class CustomerPaymentAgingHistoryInquiryResultBean {
	constructor() {
		this.agingHistoryBean = null ;
		this.agingBucketGroupBean = null ;
		this.agingHistoryInquiries = new Array() ;
		this.allCustomerTotalInvoiceDueAmount = 0 ;
		this.allCustomerStandardTotalInvoiceDueAmount = 0 ;
	}
}
/* ds.inquiry.info.CustomerPaymentAgingHistorySimpleInfoBean */
export class CustomerPaymentAgingHistorySimpleInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.currencyCode = '' ;
		this.totalInvoiceDueAmount = 0 ;
		this.currentAgeAmount = 0 ;
		this.ageAmount1 = 0 ;
		this.ageAmount2 = 0 ;
		this.ageAmount3 = 0 ;
		this.ageAmount4 = 0 ;
		this.ageAmount5 = 0 ;
		this.ageAmount6 = 0 ;
		this.ageAmount7 = 0 ;
		this.ageAmount8 = 0 ;
		this.ageAmount9 = 0 ;
		this.ageAmount10 = 0 ;
		this.email = '' ;
		this.mobilePhone = '' ;
		this.phone1 = '' ;
		this.phone2 = '' ;
		this.ratingStar = '' ;
		this.lastPaymentAmount = 0 ;
		this.lastPaymentDate = '' ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.currencyCode = '' ;
		this.totalInvoiceDueAmount = 0 ;
		this.totalUnAppliedCreditMemoAmount = 0 ;
		this.totalUnAppliedChargeBackAmount = 0 ;
		this.totalProvisionalAppliedAmount = 0 ;
		this.currentAgeAmount = 0 ;
		this.ageAmount1 = 0 ;
		this.ageAmount2 = 0 ;
		this.ageAmount3 = 0 ;
		this.ageAmount4 = 0 ;
		this.ageAmount5 = 0 ;
		this.ageAmount6 = 0 ;
		this.ageAmount7 = 0 ;
		this.ageAmount8 = 0 ;
		this.ageAmount9 = 0 ;
		this.ageAmount10 = 0 ;
		this.customerDetails = null ;
		this.companyCurrencyCode = '' ;
		this.standardTotalInvoiceDueAmount = 0 ;
		this.standardCurrentAgeAmount = 0 ;
		this.standardAgeAmount1 = 0 ;
		this.standardAgeAmount2 = 0 ;
		this.standardAgeAmount3 = 0 ;
		this.standardAgeAmount4 = 0 ;
		this.standardAgeAmount5 = 0 ;
		this.standardAgeAmount6 = 0 ;
		this.standardAgeAmount7 = 0 ;
		this.standardAgeAmount8 = 0 ;
		this.standardAgeAmount9 = 0 ;
		this.standardAgeAmount10 = 0 ;
		this.remarks = '' ;
		this.invoiceDetails = new Array() ;
		this.creditMemoDetails = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inquiry.info.CustomerSalesBackOrderAgingHistoryInquiryBean */
export class CustomerSalesBackOrderAgingHistoryInquiryBean {
	constructor() {
		this.customerName = '' ;
		this.email = '' ;
		this.mobilePhone = '' ;
		this.phone1 = '' ;
		this.phone2 = '' ;
		this.ratingStar = '' ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.currencyCode = '' ;
		this.currentQuantity = 0 ;
		this.ageQuantity1 = 0 ;
		this.ageQuantity2 = 0 ;
		this.ageQuantity3 = 0 ;
		this.ageQuantity4 = 0 ;
		this.ageQuantity5 = 0 ;
		this.ageQuantity6 = 0 ;
		this.ageQuantity7 = 0 ;
		this.ageQuantity8 = 0 ;
		this.ageQuantity9 = 0 ;
		this.ageQuantity10 = 0 ;
		this.customerDetails = null ;
		this.companyCurrencyCode = '' ;
		this.remarks = '' ;
		this.totalOpenQuantity = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inquiry.info.CustomerSalesBackOrderAgingHistoryInquiryResultBean */
export class CustomerSalesBackOrderAgingHistoryInquiryResultBean {
	constructor() {
		this.agingHistoryBean = null ;
		this.agingBucketGroupBean = null ;
		this.agingHistoryInquiries = new Array() ;
		this.allCustomerTotalOpenQuantity = 0 ;
	}
}
/* ds.inquiry.info.CustomerSalesDashBoardInfoBean */
export class CustomerSalesDashBoardInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.totalShippedQuantity = 0 ;
		this.totalSoldAmount = 0 ;
	}
}
/* ds.inquiry.info.CustomerSalesOnOrderDetailsBean */
export class CustomerSalesOnOrderDetailsBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleShortName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.onOrderQuantity = 0 ;
		this.orderUom = '' ;
		this.salesOrderNumber = '' ;
		this.salesOrderLineNumber = 0 ;
		this.salesOrderStartDate = '' ;
		this.salesOrderStopDate = '' ;
		this.salesOrderDate = '' ;
		this.salesOrderCreatedDate = '' ;
		this.customerPONumber = '' ;
		this.price = 0 ;
		this.lineTotalAmount = 0 ;
		this.customerSalesRepresentativeCode = '' ;
		this.salesPersonCode = '' ;
		this.cityCode = '' ;
		this.orderTypeCode = '' ;
		this.locationCode = '' ;
		this.openQuantityLineTotalAmount = 0 ;
		this.shipToName = '' ;
		this.revisedLatestShipDate = '' ;
		this.remarks = '' ;
	}
}
/* ds.inquiry.info.CustomerSalesOnOrderDetailsResultBean */
export class CustomerSalesOnOrderDetailsResultBean {
	constructor() {
		this.onOrderInfoDetails = new Array() ;
	}
}
/* ds.inquiry.info.CustomerSalesOnOrderInfoBean */
export class CustomerSalesOnOrderInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleShortName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.onOrderQuantity = 0 ;
		this.orderUom = '' ;
	}
}
/* ds.inquiry.info.CustomerSalesOnOrderInfoResultBean */
export class CustomerSalesOnOrderInfoResultBean {
	constructor() {
		this.onOrderInfos = new Array() ;
	}
}
/* ds.inquiry.info.CustomerServiceInvoiceInfoBean */
export class CustomerServiceInvoiceInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.invoiceDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.status = '' ;
		this.invoiceAmount = 0 ;
		this.totalPaidAmount = 0 ;
		this.totalCreditAmount = 0 ;
		this.totalDueAmount = 0 ;
	}
}
/* ds.inquiry.info.CustomerServicePickTicketInfoBean */
export class CustomerServicePickTicketInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.pickTicketDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.status = '' ;
		this.invoiceInfos = new Array() ;
	}
}
/* ds.inquiry.info.CustomerServiceSalesOnOrderDetailsBean */
export class CustomerServiceSalesOnOrderDetailsBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleShortName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.orderUom = '' ;
		this.salesOrderNumber = '' ;
		this.salesOrderLineNumber = 0 ;
		this.salesOrderDate = '' ;
		this.customerPONumber = '' ;
		this.customerOnOrderQuantity = 0 ;
		this.OnHandQuantity = 0 ;
		this.vendorOnOrderQuantity = 0 ;
		this.inTransitQuantity = 0 ;
		this.cityCode = '' ;
		this.salesPersonCode = '' ;
	}
}
/* ds.inquiry.info.CustomerServiceSalesOnOrderDetailsResultBean */
export class CustomerServiceSalesOnOrderDetailsResultBean {
	constructor() {
		this.onOrderInfoDetails = new Array() ;
	}
}
/* ds.inquiry.info.CustomerServiceSalesOrderInfoBean */
export class CustomerServiceSalesOrderInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.orderDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.salesPerson = '' ;
		this.salesPersonName = '' ;
		this.OrderTotalQuantity = 0 ;
		this.salesOrderStatus = '' ;
		this.grandTotalAmount = 0 ;
		this.currencyCode = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.cityCode = '' ;
		this.pickTicketInfos = new Array() ;
	}
}
/* ds.inquiry.info.CustomerShipToDataExportDataBean */
export class CustomerShipToDataExportDataBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.shipToCode = '' ;
		this.shipToName = '' ;
		this.status = '' ;
		this.dc = '' ;
		this.address1 = '' ;
		this.address2 = '' ;
		this.city = '' ;
		this.state = '' ;
		this.zip = '' ;
		this.country = '' ;
		this.shipVia = '' ;
		this.storeCode = '' ;
	}
}
/* ds.inquiry.info.CustomerStatementInquiryInfoBean */
export class CustomerStatementInquiryInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.customerPONumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.invoiceDate = '' ;
		this.invoiceDueDate = '' ;
		this.paymentTerms = '' ;
		this.lateDays = 0 ;
		this.invoiceAmount = 0 ;
		this.creditAmount = 0 ;
		this.openBalanceAmount = 0 ;
		this.fineChargesAmount = 0 ;
		this.salesPersonCodes = '' ;
		this.isPostDatedCheckLine = false ;
		this.checkAmount = 0 ;
		this.checkNumber = '' ;
		this.checkDate = '' ;
		this.postDatedCheckNumber = '' ;
	}
}
/* ds.inquiry.info.CustomerStatementInquiryResultBean */
export class CustomerStatementInquiryResultBean {
	constructor() {
		this.customerCode = '' ;
		this.balanceDueAmount = 0 ;
		this.pastDueAmount = 0 ;
		this.inquiryInfos = new Array() ;
		this.bucketGroupBean = null ;
		this.historyBean = null ;
	}
}
/* ds.inquiry.info.CustomerSummarySalesDashBoardInfoBean */
export class CustomerSummarySalesDashBoardInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.invoiceDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.subTotalAmount = 0 ;
		this.taxAmount = 0 ;
		this.freightChargeAmount = 0 ;
		this.extraChargeAmount = 0 ;
		this.discountAmount = 0 ;
		this.totalAmount = 0 ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
	}
}
/* ds.inquiry.info.CustomerTransactionInputBean */
export class CustomerTransactionInputBean {
	constructor() {
		this.customerCode = '' ;
		this.customerTransaction = new Array() ;
		this.customerSummary = null ;
	}
}
/* ds.inquiry.info.CustomerTransactionInquiryResultBean */
export class CustomerTransactionInquiryResultBean {
	constructor() {
		this.inquiryResult = null ;
		this.totalUnAppliedCreditAmount = 0 ;
	}
}
/* ds.inquiry.info.CustomerTransactionPageListBean */
export class CustomerTransactionPageListBean {
	constructor() {
		this.customerTransactions = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inquiry.info.CustomerTransactiontSummaryResultBean */
export class CustomerTransactiontSummaryResultBean {
	constructor() {
		this.customerAccountSummaryPageList = null ;
		this.lastPaidAmount = 0 ;
		this.lastAccountReceivableNumber = '' ;
		this.lastPaidDate = '' ;
		this.totalDueAmount = 0 ;
		this.totalUnAppliedCreditAmount = 0 ;
	}
}
/* ds.inquiry.info.DorellFabricDataExportDataBean */
export class DorellFabricDataExportDataBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricCode = '' ;
		this.fabricDescription = '' ;
		this.classCode = '' ;
		this.subClassCode = '' ;
		this.country = '' ;
		this.divisionCode = '' ;
		this.departmentCode = '' ;
		this.leadTime = 0 ;
		this.minimumOrderQuantity = 0 ;
		this.cleanCode = '' ;
		this.directionCode = '' ;
		this.abrasionCode = '' ;
		this.contentCode = '' ;
		this.backingCode = '' ;
		this.cost = 0 ;
		this.standardCost = 0 ;
		this.landingCost = 0 ;
		this.contentDescription = '' ;
		this.colorCode = '' ;
		this.colorDescription = '' ;
		this.price1 = 0 ;
		this.price2 = 0 ;
		this.price3 = 0 ;
		this.price4 = 0 ;
		this.price5 = 0 ;
		this.price6 = 0 ;
		this.price7 = 0 ;
		this.hts = '' ;
		this.stats = '' ;
		this.millCode = '' ;
		this.parentSkuCode = '' ;
		this.rmbCost = 0 ;
		this.tariffFlag = false ;
	}
}
/* ds.inquiry.info.DorellSalesOrderDataExportDetailInfoBean */
export class DorellSalesOrderDataExportDetailInfoBean {
	constructor() {
		this.salesOrderNumber = '' ;
		this.orderType = '' ;
		this.divsion = '' ;
		this.orderDate = '' ;
		this.startDate = '' ;
		this.stopDate = '' ;
		this.customerPurchaseorderNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.shipTo = '' ;
		this.shipVia = '' ;
		this.terms = '' ;
		this.address1 = '' ;
		this.address2 = '' ;
		this.city = '' ;
		this.state = '' ;
		this.zip = '' ;
		this.country = '' ;
		this.totalOrderunit = 0 ;
		this.grandTotalAmount = 0 ;
		this.totalOpenUnit = 0 ;
		this.comm1 = '' ;
		this.comm2 = '' ;
		this.comm3 = '' ;
		this.comm4 = '' ;
		this.comm5 = '' ;
		this.comm6 = '' ;
		this.customerRepresentative = '' ;
		this.locationCode = '' ;
		this.dueDate = '' ;
		this.businessDivsion = '' ;
		this.fobCode = '' ;
		this.salesOrderLines = new Array() ;
	}
}
/* ds.inquiry.info.DorellSalesOrderLineDataExportDetailInfoBean */
export class DorellSalesOrderLineDataExportDetailInfoBean {
	constructor() {
		this.salesOrderNumber = '' ;
		this.itemCode = '' ;
		this.itemName = '' ;
		this.colorCode = '' ;
		this.price = 0 ;
		this.orderQuantity = 0 ;
		this.openQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.warehouseCode = '' ;
		this.revisedLatestDate = '' ;
		this.skuNumber = 0 ;
		this.salesPersonCode = '' ;
	}
}
/* ds.inquiry.info.DorellVendorDataExportElectronicInputLineBean */
export class DorellVendorDataExportElectronicInputLineBean {
	constructor() {
		this.activeString = '' ;
		this.isActive = false ;
		this.vendorName = '' ;
		this.companyName = '' ;
		this.address1 = '' ;
		this.address2 = '' ;
		this.address3 = '' ;
		this.address4 = '' ;
		this.address5 = '' ;
		this.address6 = '' ;
		this.address7 = '' ;
		this.city = '' ;
		this.state = '' ;
		this.country = '' ;
		this.zip = '' ;
		this.email = '' ;
		this.mobilePhone = '' ;
		this.phone1 = '' ;
		this.phone2 = '' ;
		this.fax = '' ;
		this.website = '' ;
		this.contactPerson = '' ;
		this.ccEmail = '' ;
		this.vendorCode = '' ;
		this.status = '' ;
		this.termCode = '' ;
		this.vendorClass = '' ;
		this.vendorClassDescription = '' ;
		this.vendorType = '' ;
		this.shipVia = '' ;
	}
}
/* ds.inquiry.info.DorellVendorFabricDataExportDataBean */
export class DorellVendorFabricDataExportDataBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricCode = '' ;
		this.fabricDescription = '' ;
		this.weight = '' ;
		this.vendor = '' ;
		this.vendorName = '' ;
		this.vendorItem = '' ;
		this.color = '' ;
		this.vendorColor = '' ;
		this.colorDescription = '' ;
	}
}
/* ds.inquiry.info.EDISalesOrderBean */
export class EDISalesOrderBean {
	constructor() {
		this.transactionID = '' ;
		this.accountingID = '' ;
		this.purchaseOrderNumber = '' ;
		this.pODate = '' ;
		this.shipToName = '' ;
		this.shipToAddress1 = '' ;
		this.shipToAddress2 = '' ;
		this.shipToCity = '' ;
		this.shipToState = '' ;
		this.shipToZipcode = '' ;
		this.shipToCountry = '' ;
		this.store = '' ;
		this.billToName = '' ;
		this.billToAddress1 = '' ;
		this.billToAddress2 = '' ;
		this.billToCity = '' ;
		this.billToState = '' ;
		this.billToZipCode = '' ;
		this.billToCountry = '' ;
		this.billToCode = '' ;
		this.shipVia = '' ;
		this.shipDate = '' ;
		this.salesOrderLines = null ;
	}
}
/* ds.inquiry.info.EDISalesOrderLineBean */
export class EDISalesOrderLineBean {
	constructor() {
		this.lineNumber = '' ;
		this.vendorPartNumber = '' ;
		this.buyerPartNumber = '' ;
		this.upcNumber = '' ;
		this.description = '' ;
		this.quantity = 0 ;
		this.uom = '' ;
		this.unitPrice = 0 ;
	}
}
/* ds.inquiry.info.FabricColorStatisticsDetailsResultBean */
export class FabricColorStatisticsDetailsResultBean {
	constructor() {
		this.count = 0 ;
		this.salesStatisticsDetails = new Array() ;
		this.purchaseStatisticsDetails = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inquiry.info.FabricColorStatisticsInquiryInfoBean */
export class FabricColorStatisticsInquiryInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.quantity = 0 ;
		this.amount = 0 ;
		this.price = 0 ;
		this.uomCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.invoiceDate = '' ;
		this.year = '' ;
		this.invoiceNumber = '' ;
		this.customerPurchaseOrderNumber = '' ;
	}
}
/* ds.inquiry.info.FabricDataExportDataBean_Texco */
export class FabricDataExportDataBean_Texco {
	constructor() {
		this.companyCode = '' ;
		this.fabricCode = '' ;
		this.fabricDescription = '' ;
		this.widthCode = '' ;
		this.weightCode1 = '' ;
		this.weightCode2 = '' ;
		this.weightCode3 = '' ;
		this.weightCode4 = '' ;
		this.weight1 = 0 ;
		this.weight2 = 0 ;
		this.weight3 = 0 ;
		this.weight4 = 0 ;
		this.price1 = 0 ;
		this.price2 = 0 ;
		this.price3 = 0 ;
		this.price4 = 0 ;
		this.categoryCode = '' ;
		this.colorCode = '' ;
		this.colorDescription = '' ;
		this.careInstruction = '' ;
		this.shrinkage = '' ;
		this.content = '' ;
		this.copyrightNumber = '' ;
		this.width = '' ;
		this.imageName = '' ;
		this.status = '' ;
	}
}
/* ds.inquiry.info.FabricDataExportDataBean_Texco_V1 */
export class FabricDataExportDataBean_Texco_V1 {
	constructor() {
		this.companyCode = '' ;
		this.fabricCode = '' ;
		this.fabricDescription = '' ;
		this.widthCode = '' ;
		this.weightCode1 = '' ;
		this.weightCode2 = '' ;
		this.weightCode3 = '' ;
		this.weightCode4 = '' ;
		this.weight1 = 0 ;
		this.weight2 = 0 ;
		this.weight3 = 0 ;
		this.weight4 = 0 ;
		this.price1 = 0 ;
		this.price2 = 0 ;
		this.price3 = 0 ;
		this.price4 = 0 ;
		this.categoryCode = '' ;
		this.colorCode = '' ;
		this.colorDescription = '' ;
		this.careInstruction = '' ;
		this.shrinkage = '' ;
		this.content = '' ;
		this.copyrightNumber = '' ;
	}
}
/* ds.inquiry.info.FabricImageDataExportDataBean */
export class FabricImageDataExportDataBean {
	constructor() {
		this.companyCode = '' ;
		this.brandName = '' ;
		this.upcCode = '' ;
		this.fabricCode = '' ;
		this.fabricColorCode = '' ;
		this.imageName = '' ;
		this.skuNumber = 0 ;
		this.productCategory = '' ;
		this.webPrice = 0 ;
		this.retailePrice = 0 ;
		this.bullet1 = '' ;
		this.bullet2 = '' ;
		this.bullet3 = '' ;
		this.bullet4 = '' ;
		this.bullet5 = '' ;
		this.bullet6 = '' ;
		this.bullet7 = '' ;
		this.bullet8 = '' ;
		this.harmonizedCode = '' ;
		this.leadTime = 0 ;
		this.countryOfOrigin = '' ;
		this.fabricContent = '' ;
		this.cleaningCode = '' ;
		this.metaTags = '' ;
		this.seoString = '' ;
		this.urlHandle = '' ;
		this.title = '' ;
		this.description = '' ;
		this.altDescription1 = '' ;
		this.altDescription2 = '' ;
		this.tags = '' ;
		this.collectionName = '' ;
		this.imageTitle = '' ;
		this.imageUrl = '' ;
		this.shippingWeight = 0 ;
	}
}
/* ds.inquiry.info.FabricPortalSkuInfo */
export class FabricPortalSkuInfo {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.skuNumber = 0 ;
	}
}
/* ds.inquiry.info.FabricPurchaseAnalysisDashBoardInfoBean */
export class FabricPurchaseAnalysisDashBoardInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.totalReceivedQuantity = 0 ;
		this.totalOrderQuantity = 0 ;
		this.totalAmount = 0 ;
	}
}
/* ds.inquiry.info.FabricSalesDashBoardInfoBean */
export class FabricSalesDashBoardInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.totalShippedQuantity = 0 ;
		this.totalSoldAmount = 0 ;
	}
}
/* ds.inquiry.info.FabricStyleAvailableToSalesDetailBean */
export class FabricStyleAvailableToSalesDetailBean {
	constructor() {
		this.numberOfRisks = 0 ;
		this.saleInfos = new Array() ;
	}
}
/* ds.inquiry.info.FabricStyleBackOrderAgingHistoryInquiryBean */
export class FabricStyleBackOrderAgingHistoryInquiryBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.currentQuantity = 0 ;
		this.ageQuantity1 = 0 ;
		this.ageQuantity2 = 0 ;
		this.ageQuantity3 = 0 ;
		this.ageQuantity4 = 0 ;
		this.ageQuantity5 = 0 ;
		this.ageQuantity6 = 0 ;
		this.ageQuantity7 = 0 ;
		this.ageQuantity8 = 0 ;
		this.ageQuantity9 = 0 ;
		this.ageQuantity10 = 0 ;
		this.customerDetails = null ;
		this.remarks = '' ;
		this.totalOpenQuantity = 0 ;
		this.totalOnHandQty = 0 ;
		this.totalPurchaseOnOrderQty = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inquiry.info.FabricStyleBackOrderAgingHistoryInquiryResultBean */
export class FabricStyleBackOrderAgingHistoryInquiryResultBean {
	constructor() {
		this.agingHistoryBean = null ;
		this.agingBucketGroupBean = null ;
		this.agingHistoryInquiries = new Array() ;
		this.allTotalOpenQuantity = 0 ;
		this.allTotalOnHandQty = 0 ;
		this.allTotalPOQty = 0 ;
	}
}
/* ds.inquiry.info.FabricStyleBackOrderDetailInfoBean */
export class FabricStyleBackOrderDetailInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerPONumber = '' ;
		this.orderDate = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.lineTotalAmount = 0 ;
		this.orderQuantity = 0 ;
		this.openQty = 0 ;
		this.shippedQty = 0 ;
	}
}
/* ds.inquiry.info.FabricStyleBackOrderDetailResultBean */
export class FabricStyleBackOrderDetailResultBean {
	constructor() {
		this.count = 0 ;
		this.Infos = new Array() ;
	}
}
/* ds.inquiry.info.FabricStyleBarCodeResultBean */
export class FabricStyleBarCodeResultBean {
	constructor() {
		this.infos = new Array() ;
	}
}
/* ds.inquiry.info.FabricStyleColorCodeUpdateInputBean */
export class FabricStyleColorCodeUpdateInputBean {
	constructor() {
		this.companyCode = '' ;
		this.skuNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleColorName = '' ;
		this.newFabricStyleColorCode = '' ;
		this.newFabricStyleColorName = '' ;
		this.fabricColors = new Array() ;
		this.fabricStyleSkus = new Array() ;
		this.fabricStyleSkuCosts = new Array() ;
		this.fabricStyleSkuVendorCosts = new Array() ;
		this.fabricStyleSkuPrices = new Array() ;
		this.fabricStyleSkuCustomerPrices = new Array() ;
		this.fabricStyleColorCustomerType = new Array() ;
		this.fabricInventoryAdjustmentLines = new Array() ;
		this.inventoryLocationTransferLines = new Array() ;
		this.skuInventories = new Array() ;
		this.skuInventoryTracks = new Array() ;
		this.skuBatchInventories = new Array() ;
		this.skuBatchInventoryTracks = new Array() ;
		this.purchaseOrderLines = new Array() ;
		this.purchaseOrderLineAdjustmentTracks = new Array() ;
		this.purchaseOrderReceiptLines = new Array() ;
		this.purchaseOrderReceiptRollLines = new Array() ;
		this.salesOrderLines = new Array() ;
		this.salesOrderLineAdjustments = new Array() ;
		this.salesOrderLineAdjustmentTracks = new Array() ;
		this.salesOrderShippedAdjustmentQuantities = new Array() ;
		this.pickTicketLines = new Array() ;
		this.pickTicketRollLines = new Array() ;
		this.pickTicketCloseOutRollLines = new Array() ;
		this.invoiceLines = new Array() ;
		this.invoiceRollLines = new Array() ;
		this.invoiceQuantityAdjustmentLines = new Array() ;
		this.invoiceCloseOutRollDetails = new Array() ;
		this.creditMemoMerchandiseLines = new Array() ;
	}
}
/* ds.inquiry.info.FabricStyleColorPriceInfo */
export class FabricStyleColorPriceInfo {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.currencyCode = '' ;
		this.uomCode = '' ;
		this.customerCode = '' ;
		this.customerTypeCode = '' ;
		this.itemWholeSalePrice = 0 ;
		this.itemRetailPrice = 0 ;
		this.itemCloseOutPrice = 0 ;
		this.itemSamplePrice = 0 ;
		this.itemSkuWholeSalePrice = 0 ;
		this.customerTypePrice = 0 ;
		this.customerTypeSamplePrice = 0 ;
		this.customerPrice = 0 ;
	}
}
/* ds.inquiry.info.FabricStyleColorStatisticsReceivedDataBean */
export class FabricStyleColorStatisticsReceivedDataBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.receiptDate = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.purchaseOrderNumber = '' ;
		this.locationCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.uomCode = '' ;
		this.purchaseOrderQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.totalAmount = 0 ;
		this.cost = 0 ;
		this.orderDate = '' ;
	}
}
/* ds.inquiry.info.FabricStyleCurrentATSInfoBean */
export class FabricStyleCurrentATSInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleColorName = '' ;
		this.width = '' ;
		this.uomCode = '' ;
		this.onHandQuantity = 0 ;
		this.customerOnOrderQuantity = 0 ;
		this.vendorOnOrderQuantity = 0 ;
		this.manualAllocatedQuantity = 0 ;
		this.availableToSaleQuantity = 0 ;
		this.isShortage = 0 ;
		this.salesQuantityToDate = 0 ;
		this.last3MonthsSalesQuantity = 0 ;
		this.last6MonthsSalesQuantity = 0 ;
		this.last12MonthsSalesQuantity = 0 ;
		this.last18MonthsSalesQuantity = 0 ;
		this.last24MonthsSalesQuantity = 0 ;
		this.last36MonthsSalesQuantity = 0 ;
		this.monthToDateQuantity = 0 ;
		this.yearToDateQuantity = 0 ;
		this.totalSalesQuantity = 0 ;
		this.totalReceivedQuantity = 0 ;
		this.atsYardage = 0 ;
		this.numberOfRolls = 0 ;
		this.price = 0 ;
		this.lastSalesDate = '' ;
		this.lastPurchaseReceiptDate = '' ;
		this.inTransitQuantity = 0 ;
		this.riskValue = 0 ;
		this.checked = false ;
		this.fabricStyleImagePath = '' ;
		this.fabricStyleColorImagePath = '' ;
		this.parentProductCode = '' ;
		this.businessDivisionCode = '' ;
		this.vendorCode = '' ;
		this.skuNumber = 0 ;
		this.logisticOnOrderQuantity = 0 ;
		this.etaDate = '' ;
	}
}
/* ds.inquiry.info.FabricStyleCustomerSalesSummaryBean */
export class FabricStyleCustomerSalesSummaryBean {
	constructor() {
		this.totalSalesQuantity = null ;
		this.last3MonthsPeriodSalesQuantity = null ;
		this.last6MonthsPeriodSalesQuantity = null ;
		this.last12MonthsPeriodSalesQuantity = null ;
		this.last18MonthsPeriodSalesQuantity = null ;
		this.last24MonthsPeriodSalesQuantity = null ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
	}
}
/* ds.inquiry.info.FabricStyleCustomerSalesSummaryDetailBean */
export class FabricStyleCustomerSalesSummaryDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.invoiceDate = '' ;
		this.invoiceNumber = '' ;
		this.invoiceQuantity = 0 ;
		this.uomCode = '' ;
		this.price = 0 ;
		this.salesAmount = 0 ;
		this.currencyCode = '' ;
	}
}
/* ds.inquiry.info.FabricStyleCustomerSalesSummaryDetailResultBean */
export class FabricStyleCustomerSalesSummaryDetailResultBean {
	constructor() {
		this.summaryDetailData = new Array() ;
	}
}
/* ds.inquiry.info.FabricStyleDashBoardInfoResultBean */
export class FabricStyleDashBoardInfoResultBean {
	constructor() {
		this.totalShippedQuantity = 0 ;
		this.totalSalesAmount = 0 ;
		this.totalSalesPercentage = 0 ;
		this.totalOnHandQuantity = 0 ;
		this.purchaseOrderQty = 0 ;
		this.receiptReceivedQty = 0 ;
		this.barChartImage = '' ;
		this.fabricStyleInfos = new Array() ;
		this.fabricStylePurchaseInfos = new Array() ;
		this.customerSalesData = new Array() ;
		this.itemSalesData = new Array() ;
		this.yearlySalesData = new Array() ;
		this.lotSalesData = new Array() ;
		this.customerFabricSalesData = new Array() ;
		this.vendorPurchaseData = new Array() ;
		this.itemPurchaseData = new Array() ;
		this.yearlyPurchaseData = new Array() ;
		this.lotPurchaseData = new Array() ;
		this.totalOrderQty = 0 ;
		this.totalReceivedQty = 0 ;
		this.totalReceivedAmount = 0 ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inquiry.info.FabricStyleDetailInfoBean */
export class FabricStyleDetailInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.invoiceDate = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.customerPONumber = '' ;
		this.shippedQuantity = 0 ;
		this.price = 0 ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.lineTotalAmount = 0 ;
	}
}
/* ds.inquiry.info.FabricStyleDetailInfoPageListBean */
export class FabricStyleDetailInfoPageListBean {
	constructor() {
		this.infoBeans = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inquiry.info.FabricStyleFinderInquiryInfoBean */
export class FabricStyleFinderInquiryInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
	}
}
/* ds.inquiry.info.FabricStyleFinderResultBean */
export class FabricStyleFinderResultBean {
	constructor() {
		this.count = 0 ;
		this.fabricInfos = new Array() ;
	}
}
/* ds.inquiry.info.FabricStyleGrandTotalAmountBean */
export class FabricStyleGrandTotalAmountBean {
	constructor() {
		this.companyCode = '' ;
		this.date = '' ;
		this.status = '' ;
		this.grandTotalAmount = 0 ;
		this.netPaidAmount = 0 ;
		this.balanceDueAmount = 0 ;
	}
}
/* ds.inquiry.info.FabricStyleInquiryDataBean */
export class FabricStyleInquiryDataBean {
	constructor() {
		this.criteria = null ;
		this.fabricStyleBean = new Array() ;
	}
}
/* ds.inquiry.info.FabricStyleInventoryValuationInfoBean */
export class FabricStyleInventoryValuationInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.uomCode = '' ;
		this.skuNumber = 0 ;
		this.onHandQuantity = 0 ;
		this.purchaseValuationAmount = 0 ;
		this.salesValuationAmount = 0 ;
		this.cost = 0 ;
		this.price = 0 ;
		this.fabricStyleSkuCost = 0 ;
		this.fabricStyleSkuPrice = 0 ;
		this.landedCost = 0 ;
		this.extendedLandedCost = 0 ;
		this.totalNetAmountCost = 0 ;
		this.locationCode = '' ;
		this.reservedCustomerCode = '' ;
		this.reservedCustomerName = '' ;
		this.fobCost = 0 ;
		this.inventoryLandedCost = 0 ;
		this.extendedInventoryLandedCost = 0 ;
		this.totalInventoryNetAmountCost = 0 ;
		this.totalInventoryFOBCost = 0 ;
		this.totalInventoryLandedCost = 0 ;
		this.lastPurchaseCost = 0 ;
		this.lastPurchaseValuationAmount = 0 ;
	}
}
/* ds.inquiry.info.FabricStyleOnHandDetailBean */
export class FabricStyleOnHandDetailBean {
	constructor() {
		this.locationCode = '' ;
		this.onHandQuatity = 0 ;
		this.noOfRolls = 0 ;
	}
}
/* ds.inquiry.info.FabricStylePieChartInfoResultBean */
export class FabricStylePieChartInfoResultBean {
	constructor() {
		this.totalShippedQuantity = 0 ;
		this.totalSoldAmount = 0 ;
		this.totalOrderQty = 0 ;
		this.fabricStyleInfos = new Array() ;
		this.fabricStylePurchaseInfos = new Array() ;
		this.customerSalesPieData = new Array() ;
		this.fabricSalesPieData = new Array() ;
		this.skuDetailsSalesPieData = new Array() ;
		this.totalSalesPieData = new Array() ;
		this.vendorPurchasePieData = new Array() ;
		this.fabricPurchasePieData = new Array() ;
		this.skuDetailsPurchasePieData = new Array() ;
		this.totalPurchasePieData = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inquiry.info.FabricStylePurchaseDashBoardInfoBean */
export class FabricStylePurchaseDashBoardInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.totalAmount = 0 ;
		this.purchaseOrderQty = 0 ;
		this.receiptReceivedQty = 0 ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.entityDate = '' ;
		this.productTypeCode = '' ;
		this.patternTypeCode = '' ;
		this.patternTypeCategoryCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.lotNumber = '' ;
	}
}
/* ds.inquiry.info.FabricStylePurchaseOrderHistoryInfoBean */
export class FabricStylePurchaseOrderHistoryInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderDate = '' ;
		this.purchaseOrderNumber = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColor = '' ;
		this.purchaseOrderQuantity = 0 ;
		this.purchaseOrderReceivedQuantity = 0 ;
		this.uomCode = '' ;
		this.skuNumber = 0 ;
		this.purchaseOrderStopDate = '' ;
	}
}
/* ds.inquiry.info.FabricStylePurchaseOrderHistoryResultBean */
export class FabricStylePurchaseOrderHistoryResultBean {
	constructor() {
		this.historyBeans = new Array() ;
	}
}
/* ds.inquiry.info.FabricStylePurchaseReceiptHistoryBean */
export class FabricStylePurchaseReceiptHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.containerNumber = '' ;
		this.projectNumber = '' ;
		this.lotNumber = '' ;
		this.receivedDate = '' ;
		this.receivedQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.differnceQuantity = 0 ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.fabricStyleName = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.boxNumber = '' ;
		this.locationCode = '' ;
		this.customerCode = '' ;
		this.invoiceNumber = '' ;
		this.uomCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inquiry.info.FabricStyleReceivedDetailInfoBean */
export class FabricStyleReceivedDetailInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.receiptDate = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.purchaseOrderNumber = '' ;
		this.locationCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.uomCode = '' ;
		this.receivedQuantity = 0 ;
		this.binLocation = '' ;
		this.binLocationInfo = '' ;
	}
}
/* ds.inquiry.info.FabricStyleReceivedDetailResultBean */
export class FabricStyleReceivedDetailResultBean {
	constructor() {
		this.count = 0 ;
		this.receiptInfos = new Array() ;
	}
}
/* ds.inquiry.info.FabricStyleSalesAndPurchaseDetailsBean */
export class FabricStyleSalesAndPurchaseDetailsBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.containerNumber = '' ;
		this.projectNumber = '' ;
		this.lotNumber = '' ;
		this.receivedDate = '' ;
		this.receivedQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.differnceQuantity = 0 ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.fabricStyleName = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.boxNumber = '' ;
		this.locationCode = '' ;
		this.customerCode = '' ;
		this.invoiceNumber = '' ;
		this.uomCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.price = 0 ;
		this.invoiceDate = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inquiry.info.FabricStyleSalesDashBoardInfoBean */
export class FabricStyleSalesDashBoardInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.totalShippedQuantity = 0 ;
		this.totalSoldAmount = 0 ;
		this.salesPercentage = 0 ;
		this.onHandQty = 0 ;
		this.purchaseOrderQty = 0 ;
		this.receiptReceivedQty = 0 ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.entityDate = '' ;
		this.productTypeCode = '' ;
		this.patternTypeCode = '' ;
		this.patternTypeCategoryCode = '' ;
		this.customerStateCode = '' ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.lotNumber = '' ;
	}
}
/* ds.inquiry.info.FabricStyleSalesDataBean */
export class FabricStyleSalesDataBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.invoiceDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.invoicedQuantity = 0 ;
		this.lineTotalAmount = 0 ;
		this.lineDiscountAmount = 0 ;
		this.lineExtrachargeAmount = 0 ;
		this.lineNetAmount = 0 ;
		this.uomCode = '' ;
		this.price = 0 ;
		this.customerPurchaseOrderNumber = '' ;
	}
}
/* ds.inquiry.info.FabricStyleSalesDataPageListBean */
export class FabricStyleSalesDataPageListBean {
	constructor() {
		this.fabricStyleSales = new Array() ;
		this.totalInvoiceAmount = 0 ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inquiry.info.FabricStyleSalesDetailsBean */
export class FabricStyleSalesDetailsBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.fabricStyleName = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.salesOrderNumber = '' ;
		this.pickTicketNumber = '' ;
		this.invoiceNumber = '' ;
		this.uomCode = '' ;
		this.status = '' ;
		this.orderDate = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.price = 0 ;
		this.orderQuantity = 0 ;
		this.openQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inquiry.info.FabricStyleSalesInquiryInfoBean */
export class FabricStyleSalesInquiryInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.totalShippedQuantity = 0 ;
		this.totalSoldAmount = 0 ;
		this.salesPercentage = 0 ;
		this.onHandQty = 0 ;
		this.purchaseOrderQty = 0 ;
		this.receiptReceivedQty = 0 ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.entityDate = '' ;
		this.productTypeCode = '' ;
		this.patternTypeCode = '' ;
		this.patternTypeCategoryCode = '' ;
		this.customerStateCode = '' ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
	}
}
/* ds.inquiry.info.FabricStyleSalesInquiryInfoResultBean */
export class FabricStyleSalesInquiryInfoResultBean {
	constructor() {
		this.totalShippedQuantity = 0 ;
		this.totalSalesAmount = 0 ;
		this.totalSalesPercentage = 0 ;
		this.totalOnHandQuantity = 0 ;
		this.purchaseOrderQty = 0 ;
		this.receiptReceivedQty = 0 ;
		this.barChartImage = '' ;
		this.fabricStyleInfos = new Array() ;
		this.customerSalesData = new Array() ;
		this.itemSalesData = new Array() ;
		this.yearlySalesData = new Array() ;
	}
}
/* ds.inquiry.info.FabricStyleSalesPersonSalesSummaryBean */
export class FabricStyleSalesPersonSalesSummaryBean {
	constructor() {
		this.salesPersonCode = '' ;
		this.totalSalesQuantity = null ;
		this.last3MonthsPeriodSalesQuantity = null ;
		this.last6MonthsPeriodSalesQuantity = null ;
		this.last12MonthsPeriodSalesQuantity = null ;
		this.last18MonthsPeriodSalesQuantity = null ;
		this.last24MonthsPeriodSalesQuantity = null ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
	}
}
/* ds.inquiry.info.FabricStyleSalesPersonSalesSummaryDetailBean */
export class FabricStyleSalesPersonSalesSummaryDetailBean {
	constructor() {
		this.salesPersonCode = '' ;
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.invoiceDate = '' ;
		this.invoiceNumber = '' ;
		this.invoiceQuantity = 0 ;
		this.uomCode = '' ;
		this.price = 0 ;
		this.salesAmount = 0 ;
		this.currencyCode = '' ;
	}
}
/* ds.inquiry.info.FabricStyleSalesPersonSalesSummaryDetailResultBean */
export class FabricStyleSalesPersonSalesSummaryDetailResultBean {
	constructor() {
		this.summaryDetailData = new Array() ;
	}
}
/* ds.inquiry.info.FabricStyleSalesStatisticsDetailBean */
export class FabricStyleSalesStatisticsDetailBean {
	constructor() {
		this.customerSalesStatistics = null ;
		this.salesPersonSalesStatistics = null ;
	}
}
/* ds.inquiry.info.FabricStyleSalesStatisticsDetailByCustomerBean */
export class FabricStyleSalesStatisticsDetailByCustomerBean {
	constructor() {
	}
}
/* ds.inquiry.info.FabricStyleSalesStatisticsDetailBySalesPersonBean */
export class FabricStyleSalesStatisticsDetailBySalesPersonBean {
	constructor() {
	}
}
/* ds.inquiry.info.FabricStyleServiceDashBoardInfoBean */
export class FabricStyleServiceDashBoardInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.grandTotalAmount = 0 ;
		this.totalServiceAmount = 0 ;
		this.unitPrice = 0 ;
		this.quantity = 0 ;
		this.uomCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.entityDate = '' ;
		this.serviceCode = '' ;
		this.serviceName = '' ;
		this.salesOrderNumber = '' ;
		this.pickTicketNumber = '' ;
		this.logisticOrderNumber = '' ;
		this.logisticOrderReceiptNumber = '' ;
	}
}
/* ds.inquiry.info.FabricStyleStatisticsInquirySummaryDataBean */
export class FabricStyleStatisticsInquirySummaryDataBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.lastReceivedDate = '' ;
		this.LastSalesDate = '' ;
		this.totalOnHandQuantity = 0 ;
		this.totalInventoryAverageAge = 0 ;
		this.totalCustOnOrderQuantity = 0 ;
		this.totalVendorOnOrderQuantity = 0 ;
		this.totalInTransitQuantity = 0 ;
	}
}
/* ds.inquiry.info.FabricStyleStatisticsInquirySummaryDetailBean */
export class FabricStyleStatisticsInquirySummaryDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.colorName = '' ;
		this.colorNotes = '' ;
		this.totalOnHandQuatity = 0 ;
		this.totalNoOfRolls = 0 ;
		this.totalCustomerOnOrderQuantity = 0 ;
		this.totalVendorOnOrderQuantity = 0 ;
		this.totalCreditReturnsQuantity = 0 ;
		this.last3MonthsCreditReturnsQuantity = 0 ;
		this.last6MonthsCreditReturnsQuantity = 0 ;
		this.last12MonthsCreditReturnsQuantity = 0 ;
		this.last18MonthsCreditReturnsQuantity = 0 ;
		this.last24MonthsCreditReturnsQuantity = 0 ;
		this.last3MonthsSalesQuantity = 0 ;
		this.last6MonthsSalesQuantity = 0 ;
		this.last12MonthsSalesQuantity = 0 ;
		this.last18MonthsSalesQuantity = 0 ;
		this.last24MonthsSalesQuantity = 0 ;
		this.last3MonthsReceiptQuantity = 0 ;
		this.last6MonthsReceiptQuantity = 0 ;
		this.last12MonthsReceiptQuantity = 0 ;
		this.last18MonthsReceiptQuantity = 0 ;
		this.last24MonthsReceiptQuantity = 0 ;
		this.onHandDetails = new Array() ;
		this.availableToSalesDetailBean = null ;
		this.salesStatisticsDetails = new Array() ;
		this.customerSalesSummaryData = new Array() ;
		this.salesPersonSalesSummaryData = new Array() ;
	}
}
/* ds.inquiry.info.FabricStyleWithColorDataBean */
export class FabricStyleWithColorDataBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.productTypeCode = '' ;
		this.patternTypeCode = '' ;
		this.makeTypeCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
	}
}
/* ds.inquiry.info.FabricStyleYearlySalesInfoBean */
export class FabricStyleYearlySalesInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.onHandQty = 0 ;
		this.year = 0 ;
		this.totalShippedQty = 0 ;
		this.totalReceivedQty = 0 ;
		this.totalPurchaseOrderQty = 0 ;
		this.totalSoldAmount = 0 ;
		this.dataBeans = new Array() ;
	}
}
/* ds.inquiry.info.FabricStyleYearlySalesInquiryInfoBean */
export class FabricStyleYearlySalesInquiryInfoBean {
	constructor() {
		this.year = 0 ;
		this.totalPurchaseOrderQuantity = 0 ;
		this.totalPurchaseReceiptQuantity = 0 ;
		this.totalShippedQuantity = 0 ;
		this.totalSoldAmount = 0 ;
		this.fabricStyleInfos = new Array() ;
	}
}
/* ds.inquiry.info.FabricStyleYearlySalesPeriodDataBean */
export class FabricStyleYearlySalesPeriodDataBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.purchaseOrderQty = 0 ;
		this.receiptReceivedQty = 0 ;
		this.shippedQuantity = 0 ;
		this.soldAmount = 0 ;
		this.date = '' ;
		this.month = 0 ;
		this.monthName = '' ;
		this.year = 0 ;
		this.startDate = '' ;
		this.stopDate = '' ;
	}
}
/* ds.inquiry.info.FabricStyleYearlySalesYearResultBean */
export class FabricStyleYearlySalesYearResultBean {
	constructor() {
		this.inquiryResultInfos = new Array() ;
		this.count = 0 ;
	}
}
/* ds.inquiry.info.FiscalYearBookingInfoBean */
export class FiscalYearBookingInfoBean {
	constructor() {
		this.companycode = '' ;
		this.salesOrderNumber = '' ;
		this.orderDate = '' ;
		this.createdDate = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.orderStatus = '' ;
		this.salesOrderCurrencyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.salesPersonCode = '' ;
		this.salesOrderQuantity = 0 ;
		this.adjustedQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.grandTotalAmount = 0 ;
		this.openQuantity = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.totalOpenQuantity = 0 ;
		this.price = 0 ;
		this.remainingAmount = 0 ;
		this.salesPersonName = '' ;
	}
}
/* ds.inquiry.info.InboundOpenOrderNotReceivedDetailsListInfo */
export class InboundOpenOrderNotReceivedDetailsListInfo {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.status = '' ;
		this.orderDate = '' ;
		this.salesRepresentativeCode = '' ;
		this.itemInfos = new Array() ;
	}
}
/* ds.inquiry.info.InboundOpenOrderNotReceivedResultBean */
export class InboundOpenOrderNotReceivedResultBean {
	constructor() {
		this.ListCount = 0 ;
		this.InfoList = new Array() ;
	}
}
/* ds.inquiry.info.InBoundOpenOrdersNotReceivedItemInfos */
export class InBoundOpenOrdersNotReceivedItemInfos {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderNumber = '' ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.lineStatus = '' ;
		this.orderQuantity = 0 ;
		this.openQuantity = 0 ;
		this.adjustedQuantity = 0 ;
		this.customerCode = '' ;
		this.customerName = '' ;
	}
}
/* ds.inquiry.info.InBoundReceiptItemsListInfos */
export class InBoundReceiptItemsListInfos {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderReceiptNumber = '' ;
		this.logisticOrderNumber = '' ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.lineStatus = '' ;
		this.openOrderQuantity = 0 ;
		this.logisticOrderQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.receivedQuantityToDate = 0 ;
	}
}
/* ds.inquiry.info.InBoundReceiptNotInvoicedDetailsListInfo */
export class InBoundReceiptNotInvoicedDetailsListInfo {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderReceiptNumber = '' ;
		this.logisticOrderNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.receiptDate = '' ;
		this.receiptStatus = '' ;
		this.salesRepresentativeCode = '' ;
		this.itemInfos = new Array() ;
	}
}
/* ds.inquiry.info.InBoundReceiptNotInvoicedListResultBean */
export class InBoundReceiptNotInvoicedListResultBean {
	constructor() {
		this.infoList = new Array() ;
	}
}
/* ds.inquiry.info.InfoResultBean */
export class InfoResultBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricDetails = new Array() ;
		this.customerDetails = new Array() ;
		this.vendorDetails = new Array() ;
	}
}
/* ds.inquiry.info.InventoryAdjustmentHistoryResultBean */
export class InventoryAdjustmentHistoryResultBean {
	constructor() {
		this.count = 0 ;
		this.historyInfos = new Array() ;
	}
}
/* ds.inquiry.info.InventorySalesPurchasePositionInquiryResultBean */
export class InventorySalesPurchasePositionInquiryResultBean {
	constructor() {
		this.skuInfos = new Array() ;
		this.totalInventoryCostAmount = 0 ;
		this.totalVendorOnOrderCostAmount = 0 ;
	}
}
/* ds.inquiry.info.InvoiceAndSalesPersonInfoBean */
export class InvoiceAndSalesPersonInfoBean {
	constructor() {
		this.invoiceNumber = '' ;
		this.salesPersonCode = '' ;
	}
}
/* ds.inquiry.info.InvoiceCommodityInfoBean */
export class InvoiceCommodityInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.invoiceNumber = '' ;
		this.commodityCode = '' ;
		this.CommoditiesDescription = '' ;
		this.customerPONumber = '' ;
		this.wareHousePurchaseOrderNumber = '' ;
		this.containerNumber = '' ;
		this.sealNumber = '' ;
		this.invoiceDate = '' ;
		this.subTotalAmount = 0 ;
		this.grandTotalAmount = 0 ;
		this.serviceAmount = 0 ;
	}
}
/* ds.inquiry.info.InvoicedDetailsListInfo */
export class InvoicedDetailsListInfo {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.salesOrderNumber = '' ;
		this.invoiceNumber = '' ;
		this.invoiceDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.status = '' ;
		this.customerPurchaseOrderNumber = '' ;
	}
}
/* ds.inquiry.info.InvoicedNotApprovedDetailsListInfo */
export class InvoicedNotApprovedDetailsListInfo {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.pickTicketNumber = '' ;
		this.salesOrderNumber = '' ;
		this.invoiceDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.status = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.salesRepresentativeCode = '' ;
		this.itemInfos = new Array() ;
	}
}
/* ds.inquiry.info.InvoicedNotApprovedItemsListInfos */
export class InvoicedNotApprovedItemsListInfos {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.invoiceLineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.lineStatus = '' ;
		this.totalShippedQuantity = 0 ;
	}
}
/* ds.inquiry.info.InvoicedNotApprovedListResultBean */
export class InvoicedNotApprovedListResultBean {
	constructor() {
		this.invoicesInfoList = new Array() ;
	}
}
/* ds.inquiry.info.InvoiceFabricSalesYearlyDetailsResultBean */
export class InvoiceFabricSalesYearlyDetailsResultBean {
	constructor() {
		this.count = 0 ;
		this.yearlyDetails = new Array() ;
		this.reportDetails = new Array() ;
	}
}
/* ds.inquiry.info.InvoiceFabricYearlySalesInquiryInfoBean */
export class InvoiceFabricYearlySalesInquiryInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.quantity = 0 ;
		this.amount = 0 ;
		this.price = 0 ;
		this.uomCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.invoiceDate = '' ;
		this.year = '' ;
		this.invoiceNumber = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.month = '' ;
	}
}
/* ds.inquiry.info.InvoicePaymentHistoryDetailsBean */
export class InvoicePaymentHistoryDetailsBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.paymentHistoryAmount = 0 ;
		this.documentNumber = '' ;
		this.documentType = '' ;
		this.date = '' ;
		this.memoDetails = '' ;
		this.status = '' ;
		this.systemDate = '' ;
	}
}
/* ds.inquiry.info.InvoicePaymentHistoryPageListBean */
export class InvoicePaymentHistoryPageListBean {
	constructor() {
		this.historyDetails = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inquiry.info.InvoicePrintPageData */
export class InvoicePrintPageData {
	constructor() {
		this.pageNumber = 0 ;
		this.startingLineNumber = 0 ;
		this.endingLineNumber = 0 ;
		this.isPrintSumaryDetails = false ;
		this.isPrintPaymentDetails = false ;
		this.paymentStartLine = 0 ;
		this.paymentEndLine = 0 ;
	}
}
/* ds.inquiry.info.InvoiceRegisterReportAmountSummaryBean */
export class InvoiceRegisterReportAmountSummaryBean {
	constructor() {
		this.summaryGrandTotalAmount = 0 ;
		this.summarySubTotalAmount = 0 ;
		this.summaryPaidOtherAppliedAmount = 0 ;
		this.summaryPaidCreditMemoAmount = 0 ;
		this.summaryInvoiceDueAmount = 0 ;
	}
}
/* ds.inquiry.info.InvoiceRegisterReportInfoBean */
export class InvoiceRegisterReportInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.invoiceDate = '' ;
		this.customer = '' ;
		this.customerName = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.invoiceStatus = '' ;
		this.salesPersons = '' ;
		this.salesPersonName = '' ;
		this.invoiceCurrencyCode = '' ;
		this.grandTotalAmount = 0 ;
		this.subTotalAmount = 0 ;
		this.paidOtherAppliedAmount = 0 ;
		this.paidCreditMemoAmount = 0 ;
		this.invoiceDueAmount = 0 ;
		this.shipViaCode = '' ;
		this.locationCode = '' ;
	}
}
/* ds.inquiry.info.InvoiceRegisterReportInfoResultBean */
export class InvoiceRegisterReportInfoResultBean {
	constructor() {
		this.invoiceInfos = new Array() ;
		this.amountSummaryInfo = null ;
	}
}
/* ds.inquiry.info.InvoiceSalesPersonCommissionDetailBean */
export class InvoiceSalesPersonCommissionDetailBean {
	constructor() {
		this.invoiceNumber = '' ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.invoiceDate = '' ;
		this.paymentTermCode = '' ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.commissionPercentage = 0 ;
		this.totalInvoiceAmount = 0 ;
		this.paidAmount = 0 ;
		this.commissionAmount = 0 ;
	}
}
/* ds.inquiry.info.InvoiceSalesPersonCommissionInfoBean */
export class InvoiceSalesPersonCommissionInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.commissionPercentage = 0 ;
		this.commissionAmount = 0 ;
		this.commissionStatus = '' ;
		this.invoiceDate = '' ;
		this.fabricStyle = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.quantity = 0 ;
		this.price = 0 ;
		this.discount = 0 ;
		this.netAmount = 0 ;
		this.lineTotalAmount = 0 ;
		this.accountReceivableNumber = '' ;
		this.accountRceivableDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.salesRepresentativeCode = '' ;
	}
}
/* ds.inquiry.info.InvoiceSalesPersonCommissionResultBean */
export class InvoiceSalesPersonCommissionResultBean {
	constructor() {
		this.totalCommissionAmount = 0 ;
		this.salesPersonCommissions = new Array() ;
	}
}
/* ds.inquiry.info.InvoiceSalesPersonCommissionSummaryBean */
export class InvoiceSalesPersonCommissionSummaryBean {
	constructor() {
		this.companyCode = '' ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.totalSalesCommissionAmount = '' ;
		this.commssionDetails = new Array() ;
	}
}
/* ds.inquiry.info.InvoiceSalesServiceInfoBean */
export class InvoiceSalesServiceInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.invoiceNumber = '' ;
		this.customerPONumber = '' ;
		this.serviceCode = '' ;
		this.serviceName = '' ;
		this.currencyCode = '' ;
		this.uomCode = '' ;
		this.invoiceDate = '' ;
		this.quantity = 0 ;
		this.price = 0 ;
		this.lineExtension = 0 ;
	}
}
/* ds.inquiry.info.InvoiceWithLineDataBean */
export class InvoiceWithLineDataBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.salesRepresentativeCode = '' ;
	}
}
/* ds.inquiry.info.ItemSalesDataBean */
export class ItemSalesDataBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.invoiceDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.invoicedQuantity = 0 ;
		this.lineTotalAmount = 0 ;
		this.lineDiscountAmount = 0 ;
		this.lineExtrachargeAmount = 0 ;
		this.lineNetAmount = 0 ;
		this.uomCode = '' ;
		this.price = 0 ;
	}
}
/* ds.inquiry.info.ItemSalesDataPageListBean */
export class ItemSalesDataPageListBean {
	constructor() {
		this.itemSales = new Array() ;
		this.totalInvoiceAmount = 0 ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inquiry.info.LastPurchaseCostResult */
export class LastPurchaseCostResult {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.skuNumber = 0 ;
		this.cost = 0 ;
	}
}
/* ds.inquiry.info.LatePurchaseOrderDetailBean */
export class LatePurchaseOrderDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderCreatedDate = '' ;
		this.purchaseOrderDate = '' ;
		this.purchaseOrderStartDate = '' ;
		this.purchaseOrderStopDate = '' ;
		this.locationCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.uomCode = '' ;
		this.skuNumber = 0 ;
		this.purchaseOrderQuantity = 0 ;
		this.inTransitQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.productionStatus = '' ;
		this.productionNotes = '' ;
	}
}
/* ds.inquiry.info.MailLatePurchaseOrderDetailBean */
export class MailLatePurchaseOrderDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderCreatedDate = '' ;
		this.purchaseOrderDate = '' ;
		this.purchaseOrderStartDate = '' ;
		this.purchaseOrderStopDate = '' ;
		this.locationCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.uomCode = '' ;
		this.skuNumber = 0 ;
		this.purchaseOrderQuantity = 0 ;
		this.inTransitQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.lineTotalAmount = 0 ;
		this.productionStatus = '' ;
		this.productionNotes = '' ;
		this.email = '' ;
		this.fobCity = '' ;
		this.shipmentTerm = '' ;
		this.shipVia = '' ;
	}
}
/* ds.inquiry.info.MailTrackResultBean */
export class MailTrackResultBean {
	constructor() {
		this.mailTrackBean = new Array() ;
	}
}
/* ds.inquiry.info.MassPurchaseOrderMainteananceBean */
export class MassPurchaseOrderMainteananceBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderLineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.onOrderQuantity = 0 ;
		this.purchaseOrderStartDate = '' ;
		this.purchaseOrderStopDate = '' ;
		this.lineStatus = '' ;
		this.amount = 0 ;
		this.status = '' ;
	}
}
/* ds.inquiry.info.MassSalesOrderMainteananceBean */
export class MassSalesOrderMainteananceBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.salesOrderNumber = '' ;
		this.salesOrderLineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.onOrderQuantity = 0 ;
		this.salesOrderStartDate = '' ;
		this.salesOrderStopDate = '' ;
		this.lineStatus = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.amount = 0 ;
		this.status = '' ;
	}
}
/* ds.inquiry.info.MostRecentCustomerDetailsWithSalesInvoiceInfoBean */
export class MostRecentCustomerDetailsWithSalesInvoiceInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.invoiceNumber = '' ;
		this.customerPONumber = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleShortName = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.widthCode = '' ;
		this.orderUom = '' ;
		this.shippedQuantity = 0 ;
		this.grandTotalAmount = 0 ;
		this.discount = 0 ;
		this.paidAmount = 0 ;
		this.dueAmount = 0 ;
	}
}
/* ds.inquiry.info.MostRecentCustomerDetailsWithSalesOrderInfoBean */
export class MostRecentCustomerDetailsWithSalesOrderInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.salesOrderNumber = '' ;
		this.customerPONumber = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleShortName = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.widthCode = '' ;
		this.orderUom = '' ;
		this.orderQuantity = 0 ;
		this.discount = 0 ;
		this.grandTotalAmount = 0 ;
	}
}
/* ds.inquiry.info.MostRecentCustomerInfoBean */
export class MostRecentCustomerInfoBean {
	constructor() {
		this.customerCode = '' ;
		this.customerName = '' ;
		this.currencyCode = '' ;
		this.customerDeliveryTypeCode = '' ;
		this.customerTypeCode = '' ;
		this.locationCode = '' ;
		this.shipViaCode = '' ;
		this.address = null ;
		this.paymentTermsCode = '' ;
		this.paymentMethodCode = '' ;
		this.discountPercentage = 0 ;
		this.invoiceTemplateCode = '' ;
		this.billTo = null ;
		this.shipTo = null ;
		this.customerSalesRepresentativeCode = '' ;
		this.salesPersonCode = '' ;
		this.totalSalesOrderAmount = 0 ;
		this.totalSalesInvoiceAmount = 0 ;
		this.totalDueAmount = 0 ;
		this.salesOrderInfos = new Array() ;
		this.salesInvoiceInfos = new Array() ;
	}
}
/* ds.inquiry.info.MostRecentCustomerInfoResultBean */
export class MostRecentCustomerInfoResultBean {
	constructor() {
		this.count = 0 ;
		this.customerInfos = new Array() ;
	}
}
/* ds.inquiry.info.MostRecentFabricInfoBean */
export class MostRecentFabricInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.invoiceDate = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.price = 0 ;
		this.uomCode = '' ;
		this.shippedQuantity = 0 ;
		this.netLineAmount = 0 ;
		this.totalShippedquantity = 0 ;
		this.totalSoldAmount = 0 ;
	}
}
/* ds.inquiry.info.MostRecentFabricInfoResultBean */
export class MostRecentFabricInfoResultBean {
	constructor() {
		this.customerCode = '' ;
		this.allFabricTotalQuantity = 0 ;
		this.allFabricTotalSoldAmount = 0 ;
		this.fabricInfos = new Array() ;
	}
}
/* ds.inquiry.info.MostRecentFabricTotalInfoBean */
export class MostRecentFabricTotalInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.totalShippedQuantity = 0 ;
		this.totalSoldAmount = 0 ;
	}
}
/* ds.inquiry.info.MultiInfoCustomerDetailBean */
export class MultiInfoCustomerDetailBean {
	constructor() {
		this.customerCode = '' ;
		this.customerName = '' ;
		this.currencyCode = '' ;
		this.customerDeliveryTypeCode = '' ;
		this.customerTypeCode = '' ;
		this.locationCode = '' ;
		this.shipViaCode = '' ;
		this.address = null ;
		this.paymentTermsCode = '' ;
		this.paymentMethodCode = '' ;
		this.discountPercentage = 0 ;
		this.invoiceTemplateCode = '' ;
		this.billTo = null ;
		this.shipTo = null ;
		this.customerSalesRepresentativeCode = '' ;
		this.salesPersonCode = '' ;
	}
}
/* ds.inquiry.info.MultiInfoFabricDetailBean */
export class MultiInfoFabricDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricCode = '' ;
		this.fabricDescription = '' ;
		this.inventoryUomCode = '' ;
		this.productTypeCode = '' ;
		this.productTypeName = '' ;
		this.patternTypeCode = '' ;
		this.patternTypeName = '' ;
		this.makeTypeCode = '' ;
		this.makeTypeName = '' ;
		this.specialCode = '' ;
		this.defaultLocationCode = '' ;
		this.fabricCurrencyCode = '' ;
		this.retailPrice = 0 ;
		this.wholesalePrice = 0 ;
		this.seasonCode = '' ;
		this.cpmTemplateCode = '' ;
		this.weight = 0 ;
		this.width = '' ;
		this.customerCode = '' ;
		this.customerUserCode = '' ;
	}
}
/* ds.inquiry.info.MultiInfoVendorDetailBean */
export class MultiInfoVendorDetailBean {
	constructor() {
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.vendorAddress = null ;
		this.manufacturingCountryCode = '' ;
		this.buyingDiscount = 0 ;
		this.buyingTermsCode = '' ;
		this.shipmentTermsCode = '' ;
		this.fOBCity = '' ;
		this.vendorCurrencyCode = '' ;
		this.vendorShipViaCode = '' ;
		this.daysToFrightForwarding = 0 ;
		this.vendorLocationCode = '' ;
		this.vendorCategoryCode = '' ;
		this.bankCode = '' ;
		this.incoterm = '' ;
		this.accountNumber = '' ;
		this.vendorTypeCode = '' ;
		this.nickName = '' ;
	}
}
/* ds.inquiry.info.ObseleteInventoryInfoBean */
export class ObseleteInventoryInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.shippedQuantity = 0 ;
		this.receiptQuantity = 0 ;
		this.onHandQuantity = 0 ;
		this.soldAmount = 0 ;
		this.lastSalesDate = '' ;
		this.lastReceiptDate = '' ;
		this.obseleteInventoryQty = 0 ;
		this.locationCode = '' ;
	}
}
/* ds.inquiry.info.ObseleteInventoryResultBean */
export class ObseleteInventoryResultBean {
	constructor() {
		this.totalReceiptQuantity = 0 ;
		this.totalOnHandQuantity = 0 ;
		this.totalShippedQuantity = 0 ;
		this.totalSoldAmount = 0 ;
		this.infoBean = new Array() ;
	}
}
/* ds.inquiry.info.OnOrderSimpleInfoHolderBean */
export class OnOrderSimpleInfoHolderBean {
	constructor() {
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.onOrderQuantity = 0 ;
		this.salesOrderStartDate = '' ;
		this.salesOrderStopDate = '' ;
	}
}
/* ds.inquiry.info.OpenPickTicketBriefResultBean */
export class OpenPickTicketBriefResultBean {
	constructor() {
		this.summaryInfos = new Array() ;
	}
}
/* ds.inquiry.info.OpenPickTicketBriefSummaryInfoBean */
export class OpenPickTicketBriefSummaryInfoBean {
	constructor() {
		this.pickTicketNumber = '' ;
		this.salesOrderNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.pickTicketDate = '' ;
		this.toBePickedQuantity = 0 ;
		this.openPickTicketInfos = new Array() ;
	}
}
/* ds.inquiry.info.OpenPickTicketInfoBean */
export class OpenPickTicketInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.salesOrderNumber = '' ;
		this.pickTicketDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.toBePickedQuantity = 0 ;
		this.uomCode = '' ;
	}
}
/* ds.inquiry.info.OpenPickTicketResultBean */
export class OpenPickTicketResultBean {
	constructor() {
		this.summaryInfos = new Array() ;
	}
}
/* ds.inquiry.info.OpenPickTicketSummaryInfoBean */
export class OpenPickTicketSummaryInfoBean {
	constructor() {
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.toBePickedQuantity = 0 ;
		this.openPickTicketInfos = new Array() ;
	}
}
/* ds.inquiry.info.OpenVendorInvoiceAmountInfoBean */
export class OpenVendorInvoiceAmountInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.vendorInvoiceCode = '' ;
		this.vendorName = '' ;
		this.invoiceDate = '' ;
		this.invoiceDueDate = '' ;
		this.status = '' ;
		this.currencyCode = '' ;
		this.grandTotalAmount = 0 ;
		this.paidAmount = 0 ;
		this.openAmount = 0 ;
		this.checkReferenceNumber = '' ;
	}
}
/* ds.inquiry.info.OpenVendorInvoiceAmountInquireResultBean */
export class OpenVendorInvoiceAmountInquireResultBean {
	constructor() {
		this.infos = new Array() ;
		this.totalInvoiceOpenAmount = 0 ;
	}
}
/* ds.inquiry.info.OverPaymentCreditMemoBean */
export class OverPaymentCreditMemoBean {
	constructor() {
		this.companyCode = '' ;
		this.creditMemoNumber = '' ;
		this.creditMemoStatus = '' ;
		this.customerCode = '' ;
		this.createdSourceType = '' ;
		this.createdSourceEntityNumber = '' ;
		this.appliedAmount = 0 ;
		this.totalCreditAmount = 0 ;
		this.creditMemoDate = '' ;
	}
}
/* ds.inquiry.info.PastDueInvoicesBean */
export class PastDueInvoicesBean {
	constructor() {
		this.companyCode = '' ;
		this.currencyCode = '' ;
		this.invoiceNumber = '' ;
		this.paymentTerm = '' ;
		this.paymentMethod = '' ;
		this.invoiceDate = '' ;
		this.dueDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.grandTotalAmount = 0 ;
		this.netPaidAmount = 0 ;
		this.paymentDueAmount = 0 ;
		this.paidOtherAppliedAmount = 0 ;
	}
}
/* ds.inquiry.info.PastDueInvoicesWithCCPaymentBean */
export class PastDueInvoicesWithCCPaymentBean {
	constructor() {
		this.companyCode = '' ;
		this.currencyCode = '' ;
		this.invoiceNumber = '' ;
		this.paymentTerm = '' ;
		this.paymentMethod = '' ;
		this.invoiceDate = '' ;
		this.dueDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.grandTotalAmount = 0 ;
		this.netPaidAmount = 0 ;
		this.paymentDueAmount = 0 ;
		this.PaidCreditMemoAmount = 0 ;
		this.paidOtherAppliedAmount = 0 ;
	}
}
/* ds.inquiry.info.PastDueInvoicesWithCCPaymentResultBean */
export class PastDueInvoicesWithCCPaymentResultBean {
	constructor() {
		this.companyCode = '' ;
		this.ccPaymentInvocies = new Array() ;
		this.totalGrandTotalAmount = 0 ;
		this.totalNetPaidAmount = 0 ;
		this.totalPaymentDueAmount = 0 ;
		this.totalPaidCreditMemoAmount = 0 ;
		this.totalPaidOtherAppliedAmount = 0 ;
	}
}
/* ds.inquiry.info.PastDueInvoicesWithPaymentResultBean */
export class PastDueInvoicesWithPaymentResultBean {
	constructor() {
		this.companyCode = '' ;
		this.invocies = new Array() ;
		this.totalGrandTotalAmount = 0 ;
		this.totalNetPaidAmount = 0 ;
		this.totalPaymentDueAmount = 0 ;
		this.totalPaidCreditMemoAmount = 0 ;
		this.totalPaidOtherAppliedAmount = 0 ;
	}
}
/* ds.inquiry.info.PickedandShippedDetailsListInfo */
export class PickedandShippedDetailsListInfo {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.salesOrderNumber = '' ;
		this.pickTicketDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.status = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.salesRepresentativeCode = '' ;
		this.isShippedFlag = false ;
		this.itemInfos = new Array() ;
	}
}
/* ds.inquiry.info.PickedandShippedItemListInfos */
export class PickedandShippedItemListInfos {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.pickTicketLineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.lineStatus = '' ;
		this.pickedQuantity = 0 ;
		this.orderQuantity = 0 ;
	}
}
/* ds.inquiry.info.PickedandShippedListInquiryResultBean */
export class PickedandShippedListInquiryResultBean {
	constructor() {
		this.count = 0 ;
		this.pickticketInfoList = new Array() ;
	}
}
/* ds.inquiry.info.PickTicketNotInvoicedDetailsListInfo */
export class PickTicketNotInvoicedDetailsListInfo {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.salesOrderNumber = '' ;
		this.pickTicketDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.status = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.salesRepresentativeCode = '' ;
		this.itemInfos = new Array() ;
	}
}
/* ds.inquiry.info.PickTicketNotInvoicedResultBean */
export class PickTicketNotInvoicedResultBean {
	constructor() {
		this.invoiceListCount = 0 ;
		this.invoicesInfoList = new Array() ;
	}
}
/* ds.inquiry.info.PickTicketNotInvoicesItemInfos */
export class PickTicketNotInvoicesItemInfos {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.pickTicketLineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.lineStatus = '' ;
		this.pickedQuantity = 0 ;
		this.orderQuantity = 0 ;
	}
}
/* ds.inquiry.info.PickTicketPickerDetails */
export class PickTicketPickerDetails {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.salesOrderNumber = '' ;
		this.pickTicketDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.pickerName = '' ;
		this.invoiceNumber = '' ;
		this.logisticMethodCode = '' ;
	}
}
/* ds.inquiry.info.PickTicketPickerDetailsResultBean */
export class PickTicketPickerDetailsResultBean {
	constructor() {
		this.count = 0 ;
		this.pickerDetails = new Array() ;
	}
}
/* ds.inquiry.info.PostDatedChecksInfoBean */
export class PostDatedChecksInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.accountReceivableNumber = '' ;
		this.accountReceivableDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.checkAmount = 0 ;
		this.checkNumber = '' ;
		this.invoiceNumber = '' ;
		this.checkDate = '' ;
		this.paymentType = 0 ;
	}
}
/* ds.inquiry.info.PostDatedChecksResultBean */
export class PostDatedChecksResultBean {
	constructor() {
		this.count = 0 ;
		this.totalCheckAmount = 0 ;
		this.postDatedChecks = new Array() ;
	}
}
/* ds.inquiry.info.PostedAndBouncedChecksInquiryResultBean */
export class PostedAndBouncedChecksInquiryResultBean {
	constructor() {
		this.totalPostedCheckAmount = 0 ;
		this.totalBouncedCheckAmount = 0 ;
		this.bouncedChecksInfos = new Array() ;
		this.postDatedChecks = new Array() ;
	}
}
/* ds.inquiry.info.PostedARDDaySummaryInfo */
export class PostedARDDaySummaryInfo {
	constructor() {
		this.companyCode = '' ;
		this.currencyCode = '' ;
		this.accountReceivableDate = '' ;
		this.totalPaidAmount = 0 ;
		this.checkPaidAmount = 0 ;
		this.cashPaidAmount = 0 ;
		this.wirePaidAmount = 0 ;
		this.cardPaidAmount = 0 ;
		this.creditMemoPaidAmount = 0 ;
		this.achAmount = 0 ;
		this.detailsInfo = new Array() ;
	}
}
/* ds.inquiry.info.PostedARDetailInfo */
export class PostedARDetailInfo {
	constructor() {
		this.companyCode = '' ;
		this.currencyCode = '' ;
		this.accountReceivableNumber = '' ;
		this.accountReceivableDate = '' ;
		this.accountReceivablePostedDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.invoiceNumber = '' ;
		this.invoiceDate = '' ;
		this.invoiceShipmentDate = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.totalPaidAmount = 0 ;
		this.checkPaidAmount = 0 ;
		this.cashPaidAmount = 0 ;
		this.wirePaidAmount = 0 ;
		this.cardPaidAmount = 0 ;
		this.creditMemoPaidAmount = 0 ;
		this.paidCheckNumber = '' ;
		this.paidWireTransferReferenceNumber = '' ;
		this.paidCreditMemoNumber = '' ;
		this.paidCreditCardNumber = '' ;
		this.paidDebitCardNumber = '' ;
		this.salesPersonDetails = '' ;
		this.checkDate = '' ;
		this.wireTransferDate = '' ;
		this.tenderAmount = 0 ;
		this.isDeposited = false ;
		this.depositReferenceNumber = '' ;
		this.arStatus = '' ;
		this.isBouncedCheck = false ;
		this.cardType = '' ;
		this.autoClearingHouseAmount = 0 ;
		this.paidAutoClearingHouseReferenceNumber = '' ;
		this.achDate = '' ;
	}
}
/* ds.inquiry.info.PostedARPaymentRegisterResultBean */
export class PostedARPaymentRegisterResultBean {
	constructor() {
		this.companyCode = '' ;
		this.currencyCode = '' ;
		this.totalPaidAmount = 0 ;
		this.checkPaidAmount = 0 ;
		this.cashPaidAmount = 0 ;
		this.wirePaidAmount = 0 ;
		this.cardPaidAmount = 0 ;
		this.creditMemoPaidAmount = 0 ;
		this.achPaidAmount = 0 ;
		this.detailsInfo = new Array() ;
	}
}
/* ds.inquiry.info.PostedARRegisterResultBean */
export class PostedARRegisterResultBean {
	constructor() {
		this.companyCode = '' ;
		this.currencyCode = '' ;
		this.totalPaidAmount = 0 ;
		this.checkPaidAmount = 0 ;
		this.cashPaidAmount = 0 ;
		this.wirePaidAmount = 0 ;
		this.cardPaidAmount = 0 ;
		this.creditMemoPaidAmount = 0 ;
		this.achAmount = 0 ;
		this.summayInfos = new Array() ;
	}
}
/* ds.inquiry.info.PrintAmountsInfo */
export class PrintAmountsInfo {
	constructor() {
		this.lineNumber = 0 ;
		this.invoiceAmount = 0 ;
		this.balanceDueAmount = 0 ;
		this.creditMemoAmount = 0 ;
		this.appliedAmount = 0 ;
	}
}
/* ds.inquiry.info.PrintOutTrackResultBean */
export class PrintOutTrackResultBean {
	constructor() {
		this.count = 0 ;
		this.printOutTracks = new Array() ;
	}
}
/* ds.inquiry.info.PrintPickTicketInfoBean */
export class PrintPickTicketInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.salesOrderNumber = '' ;
		this.pickTicketDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.toBePickedQuantity = 0 ;
		this.pickedQuantity = 0 ;
		this.binLocation = '' ;
		this.wareHouseCode = '' ;
		this.onHandQuantity = 0 ;
		this.rollSkuNumber = 0 ;
		this.checked = false ;
		this.locationCode = '' ;
		this.inPickedQuantity = 0 ;
		this.rollNumber = '' ;
		this.purchaseorderNumber = '' ;
		this.purchaseorderReceiptNumber = '' ;
		this.widthCode = '' ;
		this.vendorBatchNumber = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.pickTicketLineNumber = 0 ;
	}
}
/* ds.inquiry.info.PullBulkPickTicketInfoBean */
export class PullBulkPickTicketInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.salesOrderNumber = '' ;
		this.pickTicketDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.toBePickedQuantity = 0 ;
		this.uomCode = '' ;
		this.skuNumber = 0 ;
		this.pickedUpBy = '' ;
		this.isPickSelectedFlag = false ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
	}
}
/* ds.inquiry.info.PullBulkPickTicketResultBean */
export class PullBulkPickTicketResultBean {
	constructor() {
		this.summaryInfos = new Array() ;
		this.summaryInfosCount = 0 ;
	}
}
/* ds.inquiry.info.PullBulkPickTicketSummaryInfoBean */
export class PullBulkPickTicketSummaryInfoBean {
	constructor() {
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.toBePickedQuantity = 0 ;
		this.binLocations = '' ;
		this.skuNumber = 0 ;
		this.openPickTicketInfos = new Array() ;
		this.isPickSelectedFlag = false ;
	}
}
/* ds.inquiry.info.PullBulkPickTicketSummaryResultBean */
export class PullBulkPickTicketSummaryResultBean {
	constructor() {
		this.companyCode = '' ;
		this.openPickTicketInfos = new Array() ;
	}
}
/* ds.inquiry.info.PurchaseAnalysisDashBoardResultBean */
export class PurchaseAnalysisDashBoardResultBean {
	constructor() {
		this.totalPurchaseOrderQuantity = 0 ;
		this.totalPurchaseReceivedQuantity = 0 ;
		this.totalPurchaseAmount = 0 ;
		this.fabricStylePurchaseInfos = new Array() ;
		this.vendorPurchaseInfos = new Array() ;
		this.skuPurchaseInfos = new Array() ;
		this.vendorSummaryPurchaseInfos = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inquiry.info.PurchaseInTransitSummaryDetailsResultBean */
export class PurchaseInTransitSummaryDetailsResultBean {
	constructor() {
		this.count = 0 ;
		this.inTransitSummaryDetails = new Array() ;
	}
}
/* ds.inquiry.info.PurchaseOrderInTransitInfoBean */
export class PurchaseOrderInTransitInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderStartDate = '' ;
		this.purchaseOrderStopDate = '' ;
		this.purchaseOrderInTransitNumber = '' ;
		this.purchaseOrderNumber = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColor = '' ;
		this.purchaseOrderQuantity = 0 ;
		this.purchaseOrderReceivedQuantity = 0 ;
		this.purchaseOrderInTransitQuantity = 0 ;
		this.openInTransitQuantity = 0 ;
		this.uomCode = '' ;
		this.skuNumber = 0 ;
	}
}
/* ds.inquiry.info.PurchaseOrderInTransitInquiryResultBean */
export class PurchaseOrderInTransitInquiryResultBean {
	constructor() {
		this.inTransitInfos = new Array() ;
	}
}
/* ds.inquiry.info.PurchaseOrderReceiptReceivedDataBean */
export class PurchaseOrderReceiptReceivedDataBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.receiptDate = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.purchaseOrderNumber = '' ;
		this.locationCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.uomCode = '' ;
		this.purchaseOrderQuantity = 0 ;
		this.receivedQuantity = 0 ;
	}
}
/* ds.inquiry.info.ReturnCreditSalesPersonCommissionInfoBean */
export class ReturnCreditSalesPersonCommissionInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.creditMemoNumber = '' ;
		this.creditMemoDate = '' ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.commissionStatus = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.commissionPercentage = 0 ;
		this.commissionAmount = 0 ;
		this.creditMemoAmount = 0 ;
	}
}
/* ds.inquiry.info.ReversedCheckPaymentDetailInfoBean */
export class ReversedCheckPaymentDetailInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.accountReceivableNumber = '' ;
		this.checkNumber = '' ;
		this.checkAmount = 0 ;
		this.invoiceNumber = '' ;
		this.invoiceDate = '' ;
		this.accountReceivableDate = '' ;
		this.status = '' ;
		this.date = '' ;
	}
}
/* ds.inquiry.info.RollingInventoryInfoBean */
export class RollingInventoryInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.itemCode = '' ;
		this.entityType = '' ;
		this.entityCode = '' ;
		this.containerNumber = '' ;
		this.date = '' ;
		this.startQuantity = 0 ;
		this.changeQuantity = 0 ;
		this.endQuantity = 0 ;
		this.minimumTrackNumber = 0 ;
		this.uomCode = '' ;
		this.locationCode = '' ;
	}
}
/* ds.inquiry.info.SalesAnalaysisActivityPeriodDataBean */
export class SalesAnalaysisActivityPeriodDataBean {
	constructor() {
		this.companyCode = '' ;
		this.yearlySalesAmount = 0 ;
		this.monthlySalesAmount = 0 ;
		this.daySalesAmount = 0 ;
		this.bookedOrdersAmount = 0 ;
		this.arCollectedAmount = 0 ;
		this.arBalanceAmount = 0 ;
		this.date = '' ;
		this.yearlyBookedOrdersAmount = 0 ;
		this.monthlyBookedOrdersAmount = 0 ;
		this.dayBookedOrdersAmount = 0 ;
	}
}
/* ds.inquiry.info.SalesAnalaysisBackOrderDataBean */
export class SalesAnalaysisBackOrderDataBean {
	constructor() {
		this.companyCode = '' ;
		this.backOrderAmount = 0 ;
		this.date = '' ;
		this.month = 0 ;
		this.monthName = '' ;
		this.year = 0 ;
		this.state = 0 ;
	}
}
/* ds.inquiry.info.SalesAnalaysisPeriodDataBean */
export class SalesAnalaysisPeriodDataBean {
	constructor() {
		this.companyCode = '' ;
		this.yearAmount1 = 0 ;
		this.yearAmount2 = 0 ;
		this.yearAmount3 = 0 ;
		this.yearAmount4 = 0 ;
		this.yearAmount5 = 0 ;
		this.yearAmount6 = 0 ;
		this.yearAmount7 = 0 ;
		this.date = '' ;
		this.month = 0 ;
		this.monthName = '' ;
		this.year = 0 ;
		this.state = 0 ;
		this.decreaseOrIncreaseValue1 = '' ;
		this.decreaseOrIncreaseValue2 = '' ;
	}
}
/* ds.inquiry.info.SalesAnalysisDashBoardResultBean */
export class SalesAnalysisDashBoardResultBean {
	constructor() {
		this.totalShippedQuantity = 0 ;
		this.totalSalesAmount = 0 ;
		this.fabricStyleSalesInfos = new Array() ;
		this.customerSalesInfos = new Array() ;
		this.skuSalesInfos = new Array() ;
		this.customerSummarySalesInfos = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inquiry.info.SalesAnalysisDataResultBean */
export class SalesAnalysisDataResultBean {
	constructor() {
		this.periodSalesData = new Array() ;
		this.salesActivityBean = null ;
		this.backOrders = new Array() ;
	}
}
/* ds.inquiry.info.SalesBackOrderDetailsResultBean */
export class SalesBackOrderDetailsResultBean {
	constructor() {
		this.count = 0 ;
		this.backOrders = new Array() ;
	}
}
/* ds.inquiry.info.SalesBackOrderLineDetailBean */
export class SalesBackOrderLineDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.grandTotalAmount = 0 ;
		this.backOrderAmount = 0 ;
		this.orderDate = '' ;
	}
}
/* ds.inquiry.info.SalesOrderCancelLineInfoBean */
export class SalesOrderCancelLineInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.salesOrderLineNumber = 0 ;
		this.adjustmentLineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleShortName = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.adjustmentReasonCode = '' ;
		this.adjustmentReasonDescription = '' ;
		this.adjustedQuantity = 0 ;
		this.adjustedUomCode = '' ;
		this.createdBy = '' ;
		this.createdDate = '' ;
		this.lineStatus = '' ;
		this.orderStatus = '' ;
		this.remarks = '' ;
		this.salesPersons = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.orderDate = '' ;
	}
}
/* ds.inquiry.info.SalesOrderListReportInfoBean */
export class SalesOrderListReportInfoBean {
	constructor() {
		this.companycode = '' ;
		this.salesOrderNumber = '' ;
		this.orderDate = '' ;
		this.createdDate = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.orderStatus = '' ;
		this.salesOrderCurrencyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.salesPersonCode = '' ;
		this.salesOrderQuantity = 0 ;
		this.adjustedQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.grandTotalAmount = 0 ;
		this.openQuantity = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.totalOpenQuantity = 0 ;
		this.price = 0 ;
		this.remainingAmount = 0 ;
		this.salesPersonName = '' ;
		this.remarks = '' ;
	}
}
/* ds.inquiry.info.SalesOrderStatusListInfoBean */
export class SalesOrderStatusListInfoBean {
	constructor() {
		this.SALES_ORDER_NO_STATUS = 0 ;
		this.SALES_ORDER_OPEN_STATUS = 0 ;
		this.SALES_ORDER_INVOICED_STATUS = 0 ;
		this.SALES_ORDER_CANCELLED_STATUS = 0 ;
		this.companycode = '' ;
		this.salesOrderNumber = '' ;
		this.orderDate = '' ;
		this.createdDate = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.orderStatus = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.salesOrderCurrencyCode = '' ;
		this.salesPersonCode = '' ;
		this.pickTicketNumber = '' ;
		this.invoiceNumber = '' ;
		this.salesOrderQuantity = 0 ;
		this.adjustedQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.openQuantity = 0 ;
		this.pickedQuantity = 0 ;
		this.grandTotalAmount = 0 ;
		this.currentStatus = 0 ;
		this.orderCancellationReason = '' ;
	}
}
/* ds.inquiry.info.SalesOrderstatusListReportInfoBean */
export class SalesOrderstatusListReportInfoBean {
	constructor() {
		this.reportDetails = new Array() ;
	}
}
/* ds.inquiry.info.SalesPriceInquiryInfoBean */
export class SalesPriceInquiryInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.quantity = 0 ;
		this.amount = 0 ;
		this.price = 0 ;
		this.uomCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.invoiceDate = '' ;
		this.invoiceNumber = '' ;
		this.currencyCode = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.paymentTerms = '' ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
	}
}
/* ds.inquiry.info.ServiceAnalysisDashBoardResultBean */
export class ServiceAnalysisDashBoardResultBean {
	constructor() {
		this.totalInBoundServiceAmount = 0 ;
		this.totalOutBoundServiceAmount = 0 ;
		this.inBoundInfos = new Array() ;
		this.outBoundInfos = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inquiry.info.ShippingReportDataBean */
export class ShippingReportDataBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleShortName = '' ;
		this.colorCode = '' ;
		this.salesInvoiceNumber = '' ;
		this.salesInvoiceDate = '' ;
		this.salesInvoiceStartDate = '' ;
		this.salesInvoiceStopDate = '' ;
		this.salesPerson = '' ;
		this.salesPersonName = '' ;
		this.amount = 0 ;
		this.quantity = 0 ;
		this.skuNumber = 0 ;
	}
}
/* ds.inquiry.info.ShippingReportInfoBean */
export class ShippingReportInfoBean {
	constructor() {
		this.totalQuantity = 0 ;
		this.totalAmount = 0 ;
		this.shippingInfoBean = new Array() ;
	}
}
/* ds.inquiry.info.ShipToDataExportDataBean */
export class ShipToDataExportDataBean {
	constructor() {
		this.companyCode = '' ;
		this.shipToCode = '' ;
		this.shipToName = '' ;
		this.status = '' ;
		this.dc = '' ;
		this.address1 = '' ;
		this.address2 = '' ;
		this.city = '' ;
		this.state = '' ;
		this.zip = '' ;
		this.country = '' ;
		this.shipVia = '' ;
		this.storeCode = '' ;
		this.phone1 = '' ;
		this.phone2 = '' ;
		this.mobileNumber = '' ;
		this.TelePhone = '' ;
		this.TeleExt = '' ;
		this.faxNumber = '' ;
		this.email = '' ;
	}
}
/* ds.inquiry.info.SKUInventoryDataExportInputBean */
export class SKUInventoryDataExportInputBean {
	constructor() {
		this.locationCode = '' ;
		this.skuNumber = 0 ;
		this.skuInventories = new Array() ;
		this.skuInventoryTrackSummaries = new Array() ;
	}
}
/* ds.inquiry.info.SKUInventoryTrackDataExportInputBean */
export class SKUInventoryTrackDataExportInputBean {
	constructor() {
		this.trackNumber = '' ;
		this.rollSkuNumber = '' ;
	}
}
/* ds.inquiry.info.SKU_InventoryPositionOnHandDetailBean */
export class SKU_InventoryPositionOnHandDetailBean {
	constructor() {
		this.locationCode = '' ;
		this.onHandQuantity = 0 ;
		this.inventoryPriceAmount = 0 ;
		this.inventoryCostAmount = 0 ;
	}
}
/* ds.inquiry.info.SKU_InventoryPositionVendorOnOrderDetailBean */
export class SKU_InventoryPositionVendorOnOrderDetailBean {
	constructor() {
		this.purchaseOrderNumber = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.purchaseOrderLineNumber = 0 ;
		this.purchaseOrderDate = '' ;
		this.orderStopDate = '' ;
		this.onOrderuomCode = '' ;
		this.vendorOnOrderQuantity = 0 ;
		this.vendorOnOrderQuantityTotalCostAmount = 0 ;
		this.vetVendorOnOrderQuantityTotalPriceAmount = 0 ;
	}
}
/* ds.inquiry.info.SKU_InventorySalesPurchasePositionInfoBean */
export class SKU_InventorySalesPurchasePositionInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.skuNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleShortName = '' ;
		this.colorCode = '' ;
		this.inventoryUOMCode = '' ;
		this.totalInventoryPriceAmount = 0 ;
		this.totalInventoryCostAmount = 0 ;
		this.totalOnHandQuantity = 0 ;
		this.totalVendorOnOrderQuantity = 0 ;
		this.totalVendorOnOrderQuantityTotalCostAmount = 0 ;
		this.totalVendorOnOrderQuantityTotalPriceAmount = 0 ;
		this.inventoryPositionOnHandDetails = new Array() ;
		this.inventoryPositionVendorOnOrderDetails = new Array() ;
	}
}
/* ds.inquiry.info.SummaryReportInfoBean */
export class SummaryReportInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.date = '' ;
		this.salesOrderNumber = '' ;
		this.pickTicketNumber = '' ;
		this.invoiceNumber = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColor = '' ;
		this.orderQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.pickedQuantity = 0 ;
		this.toBePickedQuantity = 0 ;
		this.invoiceQuantity = 0 ;
		this.returnQuantity = 0 ;
		this.price = 0 ;
		this.Extension = 0 ;
		this.totalQuantity = 0 ;
		this.totalAmount = 0 ;
		this.status = '' ;
		this.creditMemoNumber = '' ;
		this.shippedPickedQuantity = 0 ;
		this.invoicedPickedQuantity = 0 ;
		this.pickedNotShippedNotInvoicedQuantity = 0 ;
		this.stopDate = '' ;
	}
}
/* ds.inquiry.info.SummaryReportInfoResultBean */
export class SummaryReportInfoResultBean {
	constructor() {
		this.infoBeans = new Array() ;
		this.totalQuantity = 0 ;
		this.totalToBePickedQuantity = 0 ;
		this.totalAmount = 0 ;
		this.totalQuantity1 = 0 ;
		this.totalQuantity2 = 0 ;
		this.totalQuantity3 = 0 ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inquiry.info.TextResourceDetails */
export class TextResourceDetails {
	constructor() {
		this.companyCode = '' ;
		this.fabricLowerCaseCaption = '' ;
		this.fabricUpperCaseCaption = '' ;
		this.rollSkuCaption = '' ;
		this.rollNumberCaption = '' ;
	}
}
/* ds.inquiry.info.UnPostDatedChecksInfoBean */
export class UnPostDatedChecksInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.accountReceivableNumber = '' ;
		this.accountReceivableDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.checkAmount = 0 ;
		this.checkNumber = '' ;
		this.invoiceNumber = '' ;
		this.checkDate = '' ;
		this.paymentType = 0 ;
	}
}
/* ds.inquiry.info.UnPostedARInfoForInvoice */
export class UnPostedARInfoForInvoice {
	constructor() {
		this.companyCode = '' ;
		this.currencyCode = '' ;
		this.accountReceivableNumber = '' ;
		this.AccountReceivableStatus = '' ;
		this.accountReceivableDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.InvoiceNumber = '' ;
		this.PaymentType = 0 ;
		this.DocumentNumber = '' ;
		this.paymentAmount = 0 ;
		this.paymentDate = '' ;
	}
}
/* ds.inquiry.info.UnPostedARInvoiceInfo */
export class UnPostedARInvoiceInfo {
	constructor() {
		this.accountReceivableNumber = '' ;
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.invocieDate = '' ;
		this.totalPaidAmount = 0 ;
	}
}
/* ds.inquiry.info.UnPostedARListInfo */
export class UnPostedARListInfo {
	constructor() {
		this.companyCode = '' ;
		this.currencyCode = '' ;
		this.accountReceivableNumber = '' ;
		this.accountReceivableDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.checkPaidAmount = 0 ;
		this.cashPaidAmount = 0 ;
		this.wirePaidAmount = 0 ;
		this.cardPaidAmount = 0 ;
		this.creditMemoPaidAmount = 0 ;
		this.paidCheckNumber = '' ;
		this.paidWireTransferReferenceNumber = '' ;
		this.paidCreditMemoNumber = '' ;
		this.paidCreditCardNumber = '' ;
		this.paidDebitCardNumber = '' ;
		this.autoClearingHouseAmount = 0 ;
		this.paidAutoClearingHouseNumber = '' ;
		this.invoiceInfos = new Array() ;
	}
}
/* ds.inquiry.info.UnPostedARListResultBean */
export class UnPostedARListResultBean {
	constructor() {
		this.companyCode = '' ;
		this.arListInfo = new Array() ;
	}
}
/* ds.inquiry.info.UserDataExportDetailInfoBean */
export class UserDataExportDetailInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerCompanyName = '' ;
		this.currencyCode = '' ;
		this.divisionCode = '' ;
		this.customerTypeCode = '' ;
		this.soldToName = '' ;
		this.address1 = '' ;
		this.address2 = '' ;
		this.city = '' ;
		this.state = '' ;
		this.country = '' ;
		this.zip = '' ;
		this.phone1 = '' ;
		this.phone2 = '' ;
		this.mobileNumber = '' ;
		this.creditLimit = 0 ;
		this.TelePhone = '' ;
		this.TeleExt = '' ;
		this.faxNumber = '' ;
		this.contact = '' ;
		this.resaleNumber = '' ;
		this.paymentTerm = '' ;
		this.salesPerson = '' ;
		this.salesPersonName = '' ;
		this.email = '' ;
		this.webAddress = '' ;
		this.accountNumber = '' ;
		this.territory = '' ;
		this.status = '' ;
		this.dbaName = '' ;
		this.salesCommissionPercentage = 0 ;
		this.salesManager = '' ;
		this.parentAccountNumber = '' ;
		this.parentName = '' ;
		this.salesPerson2 = '' ;
		this.shipVia = '' ;
		this.userCode = '' ;
		this.userName = '' ;
	}
}
/* ds.inquiry.info.VendorOnOrderDetailsCustomerOnOrderOnATSInfoBean */
export class VendorOnOrderDetailsCustomerOnOrderOnATSInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleColorName = '' ;
		this.uomCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderDate = '' ;
		this.onOrderQuantity = 0 ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
	}
}
/* ds.inquiry.info.VendorPurchaseDashBoardInfoBean */
export class VendorPurchaseDashBoardInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.totalOrderQuantity = 0 ;
		this.totalReceivedQuantity = 0 ;
		this.totalAmount = 0 ;
	}
}
/* ds.inquiry.info.VendorPurchaseInTransitDetailsBean */
export class VendorPurchaseInTransitDetailsBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.vendorStyleCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleShortName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.orderUom = '' ;
		this.inTransitNumber = '' ;
		this.inTransitLineNumber = 0 ;
		this.inTransitDate = '' ;
		this.inTransitQuantity = 0 ;
		this.purchaseOrderNumber = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.locationCode = '' ;
		this.containerNumber = '' ;
		this.etaDate = '' ;
		this.rollNumber = '' ;
		this.millPieceNumber = '' ;
		this.binLocation = '' ;
		this.millName = '' ;
		this.millCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
	}
}
/* ds.inquiry.info.VendorPurchaseInTransitDetailsResultBean */
export class VendorPurchaseInTransitDetailsResultBean {
	constructor() {
		this.inTransitInfoDetails = new Array() ;
	}
}
/* ds.inquiry.info.VendorPurchaseInTransitSummaryDetailsBean */
export class VendorPurchaseInTransitSummaryDetailsBean {
	constructor() {
		this.companyCode = '' ;
		this.locationCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.totalNumberOfRolls = 0 ;
		this.totalYards = 0 ;
		this.containerNumber = '' ;
		this.etaDate = '' ;
	}
}
/* ds.inquiry.info.VendorPurchaseOnOrderDetailsBean */
export class VendorPurchaseOnOrderDetailsBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.vendorStyleCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleShortName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.onOrderQuantity = 0 ;
		this.orderUom = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderLineNumber = 0 ;
		this.purchaseOrderStartDate = '' ;
		this.purchaseOrderStopDate = '' ;
		this.xFactoryDate = '' ;
		this.inConsolidatorDCDate = '' ;
		this.inDCDate = '' ;
		this.etaDate = '' ;
		this.inTransitQuantity = 0 ;
		this.productionStatus = '' ;
		this.productionNotes = '' ;
		this.reserveCustomerCode = '' ;
		this.reserveCustomerName = '' ;
		this.vendorFactoryCode = '' ;
		this.cost = 0 ;
		this.landedCost = 0 ;
		this.fobCost = 0 ;
		this.locationCode = '' ;
		this.fobCity = '' ;
		this.orderType = '' ;
		this.orderDate = '' ;
		this.purchaseOrderDueDate = '' ;
		this.customerReservedQuantity = 0 ;
	}
}
/* ds.inquiry.info.VendorPurchaseOnOrderDetailsResultBean */
export class VendorPurchaseOnOrderDetailsResultBean {
	constructor() {
		this.onOrderInfoDetails = new Array() ;
		this.sourceOrderDetailLines = new Array() ;
		this.customerReservedDetailLines = new Array() ;
	}
}
/* ds.inquiry.info.VendorPurchaseOnOrderInfoBean */
export class VendorPurchaseOnOrderInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleShortName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.sizeCode = '' ;
		this.itemShortName = '' ;
		this.skuNumber = 0 ;
		this.onOrderQuantity = 0 ;
		this.orderUom = '' ;
		this.productionStatus = '' ;
		this.productionNotes = '' ;
	}
}
/* ds.inquiry.info.VendorPurchaseOnOrderInfoResultBean */
export class VendorPurchaseOnOrderInfoResultBean {
	constructor() {
		this.onOrderInfos = new Array() ;
	}
}
/* ds.inquiry.info.VendorPurchaseOrderDataBean */
export class VendorPurchaseOrderDataBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.orderDate = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.orderQuantity = 0 ;
		this.orderTotalAmount = 0 ;
		this.uomCode = '' ;
		this.cost = 0 ;
	}
}
/* ds.inquiry.info.VendorPurchaseOrderDataPageListBean */
export class VendorPurchaseOrderDataPageListBean {
	constructor() {
		this.vendorPurchaseOrders = new Array() ;
		this.totalOrderAmount = 0 ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inquiry.info.VendorPurchaseOrderInTransitDetailBean */
export class VendorPurchaseOrderInTransitDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderIntransitNumber = '' ;
		this.inTransitDate = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.purchaseOrderNumber = '' ;
		this.locationCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.uomCode = '' ;
		this.purchaseOrderQuantity = 0 ;
		this.inTransitQuantity = 0 ;
		this.receivedQuantity = 0 ;
	}
}
/* ds.inquiry.info.VendorSummaryPurchaseDashBoardInfoBean */
export class VendorSummaryPurchaseDashBoardInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.ordereDate = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.subTotalAmount = 0 ;
		this.taxAmount = 0 ;
		this.shipmentChargeAmount = 0 ;
		this.extraChargeAmount = 0 ;
		this.discountAmount = 0 ;
		this.totalAmount = 0 ;
	}
}
/* ds.inquiry.info.WebInventoryInfoBean */
export class WebInventoryInfoBean {
	constructor() {
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricColorCode = '' ;
		this.fabricColorName = '' ;
		this.inventoryQty = 0 ;
		this.minimumInventoryRollFlag = false ;
	}
}
/* ds.inquiry.info.WebOrderDownloadTrackPageListBean */
export class WebOrderDownloadTrackPageListBean {
	constructor() {
		this.webDownloadTrack = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inquiry.InventoryAdjustmentDataExportElectronicHeaderBean_texco */
export class InventoryAdjustmentDataExportElectronicHeaderBean_texco {
	constructor() {
		this.fabricStyle = '' ;
		this.fabricStyleDescription = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.lines = new Array() ;
	}
}
/* ds.inquiry.InventoryAdjustmentDataExportElectronicInputLineBean */
export class InventoryAdjustmentDataExportElectronicInputLineBean {
	constructor() {
		this.fabricStyle = '' ;
		this.fabricStyleDescription = '' ;
		this.preferredVendor = '' ;
		this.onHandQuantity = 0 ;
		this.skuNumber = 0 ;
		this.oldSystemSkuNumber = '' ;
		this.colorCode = '' ;
		this.warehouseCode = '' ;
		this.lotNumber = '' ;
		this.referenceCustomerCode = '' ;
		this.referenceCustomerName = '' ;
		this.fobCost = 0 ;
		this.landedCost = 0 ;
		this.containerNumber = '' ;
		this.etaDate = '' ;
		this.rollNumber = '' ;
		this.millPieceNumber = '' ;
		this.binLocation = '' ;
		this.millName = '' ;
		this.millCode = '' ;
		this.status = '' ;
		this.purchaseOrderNumber = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.rollSkuNumber = 0 ;
		this.vendorFactoryCode = '' ;
		this.businessDivision = '' ;
		this.billOfLading = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.receivedQuantity = 0 ;
	}
}
/* ds.inquiry.InventoryAdjustmentDataExportElectronicInputLineBeanV1 */
export class InventoryAdjustmentDataExportElectronicInputLineBeanV1 {
	constructor() {
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.receiptDate = '' ;
		this.orderDate = '' ;
		this.lineRemarks = '' ;
		this.lotNumber = '' ;
		this.rollNumber = '' ;
		this.boxNumber = '' ;
		this.locationCode = '' ;
		this.receivedQuantity = 0 ;
		this.serialNumber = '' ;
		this.fabricStyle = '' ;
		this.fabricStyleDescription = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.id = '' ;
	}
}
/* ds.inquiry.InventoryAdjustmentDataExportElectronicInputLineBean_texco */
export class InventoryAdjustmentDataExportElectronicInputLineBean_texco {
	constructor() {
		this.fabricStyle = '' ;
		this.fabricStyleDescription = '' ;
		this.colorCode = '' ;
		this.warehouseCode = '' ;
		this.lotNumber = '' ;
		this.boxNumber = '' ;
		this.receiptDate = '' ;
		this.rollNumber = '' ;
		this.serialNumber = '' ;
		this.status = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.vendorBatchNumber = '' ;
		this.rollSkuNumber = 0 ;
		this.skuNumber = 0 ;
		this.receivedQuantity = 0 ;
		this.id = '' ;
	}
}
/* ds.inquiry.InventoryAdjustmentHistoryDetailBean */
export class InventoryAdjustmentHistoryDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.adjustmentCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.createdBy = '' ;
		this.adjustmentDate = '' ;
		this.totalYardage = 0 ;
	}
}
/* ds.inquiry.InventoryAdjustmentHistoryResponseBean */
export class InventoryAdjustmentHistoryResponseBean {
	constructor() {
		this.count = 0 ;
		this.resultResponseInfos = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.InventoryDataBean */
export class InventoryDataBean {
	constructor() {
		this.companyCode = '' ;
		this.itemCode = '' ;
		this.itemName = '' ;
		this.colorCode = '' ;
		this.sizeCode = '' ;
		this.locationCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.quantity = 0 ;
		this.cost = 0 ;
		this.amount = 0 ;
		this.lastPurchaseOrderNumber = '' ;
	}
}
/* ds.inquiry.InvoiceDataExportElectronicInputHeaderBean */
export class InvoiceDataExportElectronicInputHeaderBean {
	constructor() {
		this.invoiceNumber = '' ;
		this.invoiceDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.lines = new Array() ;
	}
}
/* ds.inquiry.InvoiceDataExportElectronicInputHeaderBean_texco */
export class InvoiceDataExportElectronicInputHeaderBean_texco {
	constructor() {
		this.invoiceNumber = '' ;
		this.invoiceDate = '' ;
		this.dueDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.salesOrderNumber = '' ;
		this.pickTicketNumber = '' ;
		this.isPaid = false ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.comissionPercentage = 0 ;
		this.comissionAmount = 0 ;
		this.shipViaCode = '' ;
		this.shipViaDescription = '' ;
		this.paymentTermCode = '' ;
		this.customerPONumber = '' ;
		this.customerShipTo = '' ;
		this.customerShipToName = '' ;
		this.address1 = '' ;
		this.address2 = '' ;
		this.city = '' ;
		this.state = '' ;
		this.zip = '' ;
		this.country = '' ;
		this.locationCode = '' ;
		this.businessDivsion = '' ;
		this.freightChargeAmount = 0 ;
		this.miscChargeAmount = 0 ;
		this.taxAmount = 0 ;
		this.grandTotalAmount = 0 ;
		this.openAmount = 0 ;
		this.paidAmount = 0 ;
		this.lines = new Array() ;
	}
}
/* ds.inquiry.InvoiceDataExportElectronicInputHeaderBean_V2 */
export class InvoiceDataExportElectronicInputHeaderBean_V2 {
	constructor() {
		this.invoiceNumber = '' ;
		this.invoiceDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.salesOrderNumber = '' ;
		this.isPaid = false ;
		this.salesPersonCode = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.lines = new Array() ;
	}
}
/* ds.inquiry.InvoiceDataExportElectronicInputLineBean */
export class InvoiceDataExportElectronicInputLineBean {
	constructor() {
		this.type = '' ;
		this.invoiceDate = '' ;
		this.lineNumber = 0 ;
		this.invoiceNumber = '' ;
		this.description = '' ;
		this.customerName = '' ;
		this.itemReferenceName = '' ;
		this.quantity = 0 ;
		this.price = 0 ;
		this.amount = 0 ;
		this.customerCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabrciStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleColorName = '' ;
		this.skuNumber = '' ;
		this.isExtraChanrge = false ;
	}
}
/* ds.inquiry.InvoiceDataExportElectronicInputLineBean_texco */
export class InvoiceDataExportElectronicInputLineBean_texco {
	constructor() {
		this.type = '' ;
		this.invoiceDate = '' ;
		this.lineNumber = 0 ;
		this.invoiceNumber = '' ;
		this.customerPONumber = '' ;
		this.customerName = '' ;
		this.shipDate = '' ;
		this.paymentTerm = '' ;
		this.item = '' ;
		this.itemDescription = '' ;
		this.quantity = 0 ;
		this.uom = '' ;
		this.salesPrice = 0 ;
		this.totalAmount = 0 ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.comissionPercentage = 0 ;
		this.comissionAmount = 0 ;
		this.secondSalesPersonCode = '' ;
		this.customerCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabrciStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleColorName = '' ;
		this.skuNumber = 0 ;
		this.paidStatus = '' ;
		this.isExtraCharge = false ;
		this.isNonMerchandiseLine = false ;
		this.commissionPercentage = 0 ;
		this.commissionAmount = 0 ;
		this.totalQuantity = 0 ;
		this.grandTotalAmount = 0 ;
		this.subTotalAmount = 0 ;
		this.totalOpenUnit = 0 ;
		this.taxAmount = 0 ;
		this.totalLineAmount = 0 ;
		this.totalLineUnits = 0 ;
		this.status = '' ;
		this.division = '' ;
		this.freightChargeAmount = 0 ;
		this.miscChargeAmount = 0 ;
	}
}
/* ds.inquiry.InvoiceDataExportElectronicInputLineBean_V2 */
export class InvoiceDataExportElectronicInputLineBean_V2 {
	constructor() {
		this.type = '' ;
		this.invoiceDate = '' ;
		this.lineNumber = 0 ;
		this.invoiceNumber = '' ;
		this.description = '' ;
		this.customerPONumber = '' ;
		this.customerName = '' ;
		this.shipDate = '' ;
		this.fob = '' ;
		this.shipVia = '' ;
		this.paymentTerm = '' ;
		this.dueDate = '' ;
		this.item = '' ;
		this.itemDescription = '' ;
		this.salesRepresentative = '' ;
		this.paidType = '' ;
		this.quantity = 0 ;
		this.uom = '' ;
		this.salesPrice = 0 ;
		this.totalAmount = 0 ;
		this.salesOrderNumber = '' ;
		this.customerCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabrciStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.skuNumber = 0 ;
		this.paidStatus = '' ;
		this.isExtraCharge = false ;
		this.isNonMerchandiseLine = false ;
	}
}
/* ds.inquiry.NegativeAdjustmentDataBean */
export class NegativeAdjustmentDataBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyle = '' ;
		this.warehouseCode = '' ;
		this.rollSkuNumber = 0 ;
		this.onHandQuantity = 0 ;
	}
}
/* ds.inquiry.OrderPortalCustomerPageListBean */
export class OrderPortalCustomerPageListBean {
	constructor() {
		this.orderCustomers = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inquiry.pagelist.response.ApprovedSalesOrderForPickTicketPageListResponseBean */
export class ApprovedSalesOrderForPickTicketPageListResponseBean {
	constructor() {
		this.approvedSalesOrderPageListBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.pagelist.response.FabricStyleDetailInfoPageListResponseBean */
export class FabricStyleDetailInfoPageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.pagelist.response.FabricStyleSalesDataPageListResponseBean */
export class FabricStyleSalesDataPageListResponseBean {
	constructor() {
		this.salesDataPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.pagelist.response.InvoicePaymentHistoryPageListResponseBean */
export class InvoicePaymentHistoryPageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.pagelist.response.VendorPurchaseOrderDataPageListResponseBean */
export class VendorPurchaseOrderDataPageListResponseBean {
	constructor() {
		this.vendorPurchaseOrderDataPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.pagelist.response.WebOrderDownloadTrackDataPageListResponseBean */
export class WebOrderDownloadTrackDataPageListResponseBean {
	constructor() {
		this.webOrderDownLoadTrackPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.PaidInvoiceInputDataBean */
export class PaidInvoiceInputDataBean {
	constructor() {
		this.type = '' ;
		this.appliedInvoiceNumber = '' ;
		this.csvInvoiceNumber = '' ;
		this.disbNumber = '' ;
		this.disbAmount = 0 ;
		this.amount = 0 ;
		this.grandTotalAmount = 0 ;
		this.client = '' ;
		this.date = '' ;
		this.memo = '' ;
		this.sourceLineNumber = 0 ;
		this.checkNumber = '' ;
	}
}
/* ds.inquiry.PickTicketDataExportElectronicInputHeaderBean_texco */
export class PickTicketDataExportElectronicInputHeaderBean_texco {
	constructor() {
		this.pickTicketDate = '' ;
		this.dueDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.salesOrderNumber = '' ;
		this.pickTicketNumber = '' ;
		this.isPaid = false ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.comissionPercentage = 0 ;
		this.comissionAmount = 0 ;
		this.shipViaCode = '' ;
		this.shipViaDescription = '' ;
		this.paymentTermCode = '' ;
		this.customerPONumber = '' ;
		this.customerShipTo = '' ;
		this.customerShipToName = '' ;
		this.address1 = '' ;
		this.address2 = '' ;
		this.city = '' ;
		this.state = '' ;
		this.zip = '' ;
		this.country = '' ;
		this.locationCode = '' ;
		this.businessDivsion = '' ;
		this.status = '' ;
		this.shipDate = '' ;
		this.lines = new Array() ;
	}
}
/* ds.inquiry.PickTicketDataExportElectronicInputLineBean_texco */
export class PickTicketDataExportElectronicInputLineBean_texco {
	constructor() {
		this.type = '' ;
		this.invoiceDate = '' ;
		this.lineNumber = 0 ;
		this.pickTicketNumber = '' ;
		this.customerPONumber = '' ;
		this.customerName = '' ;
		this.shipDate = '' ;
		this.paymentTerm = '' ;
		this.item = '' ;
		this.itemDescription = '' ;
		this.quantity = 0 ;
		this.uom = '' ;
		this.salesPrice = 0 ;
		this.totalAmount = 0 ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.comissionPercentage = 0 ;
		this.comissionAmount = 0 ;
		this.secondSalesPersonCode = '' ;
		this.customerCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabrciStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleColorName = '' ;
		this.skuNumber = 0 ;
		this.commissionPercentage = 0 ;
		this.commissionAmount = 0 ;
		this.totalQuantity = 0 ;
		this.totalOpenUnit = 0 ;
		this.status = '' ;
		this.division = '' ;
		this.complete = '' ;
	}
}
/* ds.inquiry.ProductAvailabilityBean */
export class ProductAvailabilityBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleShortName = '' ;
		this.warehouseCode = '' ;
		this.openQuantity = 0 ;
		this.onHandQuantity = 0 ;
		this.rollSkuNumber = 0 ;
		this.skuNumber = 0 ;
		this.rollNumber = '' ;
		this.receivedQuantity = 0 ;
		this.lotNumber = '' ;
		this.widthSize = '' ;
		this.reserveCustomerNumber = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.sts = '' ;
		this.dueDate = '' ;
		this.orderDate = '' ;
		this.type = '' ;
		this.purchaseOrderQuantity = 0 ;
		this.customerPurchaseOrderNumber = '' ;
		this.customerCode = '' ;
		this.containerCode = '' ;
		this.stsDate = '' ;
		this.inhouseDate = '' ;
		this.countryOfOrigin = '' ;
		this.classCode = '' ;
		this.subClassCode = '' ;
		this.materialContent = '' ;
		this.abrasionCode = '' ;
		this.directionCode = '' ;
		this.backingCode = '' ;
		this.leadTime = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.binLocation = '' ;
		this.reserveCustomerCode = '' ;
		this.reserveCustomerName = '' ;
	}
}
/* ds.inquiry.ProductAvailabilityResultBean */
export class ProductAvailabilityResultBean {
	constructor() {
		this.count = 0 ;
		this.availabilityinfos = new Array() ;
		this.purchaseProductAvailabilityDetails = new Array() ;
		this.salesProductAvailabilityDetails = new Array() ;
		this.atsInfos = new Array() ;
	}
}
/* ds.inquiry.PurchaseOrderDataExportElectronicInputHeaderBean */
export class PurchaseOrderDataExportElectronicInputHeaderBean {
	constructor() {
		this.purchaseOrderNumber = '' ;
		this.orderDate = '' ;
		this.vendorName = '' ;
		this.deliveryDate = '' ;
		this.grandTotalAmount = 0 ;
		this.orderQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.dueDate = '' ;
		this.orderStopDate = '' ;
		this.xFactoryDate = '' ;
		this.inconsolidationDate = '' ;
		this.inDcDate = '' ;
		this.etaDate = '' ;
		this.purchaseOrderInputlines = new Array() ;
	}
}
/* ds.inquiry.PurchaseOrderDataExportElectronicInputLineBean */
export class PurchaseOrderDataExportElectronicInputLineBean {
	constructor() {
		this.OrderDate = '' ;
		this.lineNumber = 0 ;
		this.purchaseOrderNumber = '' ;
		this.sourceName = '' ;
		this.memo = '' ;
		this.deliveryDate = '' ;
		this.orderedQty = 0 ;
		this.receivedQty = 0 ;
		this.backOrderedQty = 0 ;
		this.salesPrice = 0 ;
		this.totalAmount = 0 ;
		this.fob = '' ;
		this.shipVia = '' ;
		this.paymentTerm = '' ;
		this.dueDate = '' ;
		this.item = '' ;
		this.itemDescription = '' ;
		this.colorCode = '' ;
		this.account = '' ;
		this.openBalance = 0 ;
		this.shipToCity = '' ;
		this.shipToAddress1 = '' ;
		this.shipToAddress2 = '' ;
		this.shipToState = '' ;
		this.shipToZip = '' ;
		this.skuNumber = 0 ;
		this.orderStopDate = '' ;
		this.xFactoryDate = '' ;
		this.inConsolidationDate = '' ;
		this.inDcDate = '' ;
		this.etaDate = '' ;
	}
}
/* ds.inquiry.PurchaseOrderDataExportHeaderBean_texco */
export class PurchaseOrderDataExportHeaderBean_texco {
	constructor() {
		this.purchaseOrderNumber = '' ;
		this.orderDate = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.deliveryDate = '' ;
		this.grandTotalAmount = 0 ;
		this.orderQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.dueDate = '' ;
		this.xFactoryDate = '' ;
		this.inconsolidationDate = '' ;
		this.inDcDate = '' ;
		this.etaDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.locationCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.openQuantity = 0 ;
		this.city = '' ;
		this.address1 = '' ;
		this.address2 = '' ;
		this.state = '' ;
		this.zip = '' ;
		this.country = '' ;
		this.shipToCity = '' ;
		this.shipToAddress1 = '' ;
		this.shipToAddress2 = '' ;
		this.shipToState = '' ;
		this.shipToZip = '' ;
		this.shipToCountry = '' ;
		this.fob = '' ;
		this.shipVia = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.estimatedShipDate = '' ;
		this.shipTo = '' ;
		this.purchaseDivisionCode = '' ;
		this.orderType = '' ;
		this.factoryCode = '' ;
		this.paymentTermCode = '' ;
		this.status = '' ;
		this.purchaseOrderInputlines = new Array() ;
	}
}
/* ds.inquiry.PurchaseOrderDataInputLineBean_texco */
export class PurchaseOrderDataInputLineBean_texco {
	constructor() {
		this.OrderDate = '' ;
		this.startDate = '' ;
		this.stopDate = '' ;
		this.estimatedShipDate = '' ;
		this.lineNumber = 0 ;
		this.purchaseOrderNumber = '' ;
		this.sourceName = '' ;
		this.memo = '' ;
		this.deliveryDate = '' ;
		this.orderedQty = 0 ;
		this.receivedQty = 0 ;
		this.backOrderedQty = 0 ;
		this.salesPrice = 0 ;
		this.totalAmount = 0 ;
		this.fob = '' ;
		this.shipVia = '' ;
		this.paymentTerm = '' ;
		this.dueDate = '' ;
		this.item = '' ;
		this.itemDescription = '' ;
		this.account = '' ;
		this.openBalance = 0 ;
		this.shipToCity = '' ;
		this.shipToAddress1 = '' ;
		this.shipToAddress2 = '' ;
		this.shipToState = '' ;
		this.shipToZip = '' ;
		this.shipToCountry = '' ;
		this.skuNumber = 0 ;
		this.xFactoryDate = '' ;
		this.inConsolidationDate = '' ;
		this.inDcDate = '' ;
		this.etaDate = '' ;
		this.oldSystemPurchaseOrderLineNumber = '' ;
		this.shipTo = '' ;
		this.purchaseDivisionCode = '' ;
		this.orderType = '' ;
		this.sts = '' ;
		this.sailDate = '' ;
		this.availableDate = '' ;
		this.user = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.factoryCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.locationCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.openQuantity = 0 ;
		this.city = '' ;
		this.address1 = '' ;
		this.address2 = '' ;
		this.state = '' ;
		this.zip = '' ;
		this.country = '' ;
		this.price = 0 ;
		this.fobCost = 0 ;
		this.landedCost = 0 ;
		this.purchaseOrderReceiptNumber = '' ;
		this.complete = '' ;
	}
}
/* ds.inquiry.PurchaseOrderReceiptDataExportElectronicInputHeaderBean */
export class PurchaseOrderReceiptDataExportElectronicInputHeaderBean {
	constructor() {
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.receiptDate = '' ;
		this.deliveryDate = '' ;
		this.dueDate = '' ;
		this.orderDate = '' ;
		this.grandTotalAmount = 0 ;
		this.receivedQuantity = 0 ;
		this.orderQuantity = 0 ;
		this.purchaseOrderReceiptInputlines = new Array() ;
	}
}
/* ds.inquiry.PurchaseOrderReceiptDataExportElectronicInputLineBean */
export class PurchaseOrderReceiptDataExportElectronicInputLineBean {
	constructor() {
		this.OrderDate = '' ;
		this.lineNumber = 0 ;
		this.purchaseOrderReceiptNumber = '' ;
		this.sourceName = '' ;
		this.memo = '' ;
		this.deliveryDate = '' ;
		this.orderedQty = 0 ;
		this.receivedQty = 0 ;
		this.backOrderedQty = 0 ;
		this.salesPrice = 0 ;
		this.totalAmount = 0 ;
		this.fob = '' ;
		this.shipVia = '' ;
		this.paymentTerm = '' ;
		this.dueDate = '' ;
		this.item = '' ;
		this.itemDescription = '' ;
		this.colorCode = '' ;
		this.account = '' ;
		this.openBalance = 0 ;
		this.shipToCity = '' ;
		this.shipToAddress1 = '' ;
		this.shipToAddress2 = '' ;
		this.shipToState = '' ;
		this.shipToZip = '' ;
		this.skuNumber = 0 ;
		this.orderStopDate = '' ;
		this.xFactoryDate = '' ;
		this.inConsolidationDate = '' ;
		this.inDcDate = '' ;
		this.etaDate = '' ;
	}
}
/* ds.inquiry.PurchaseOrderReceiptDataInputLineBean_texco */
export class PurchaseOrderReceiptDataInputLineBean_texco {
	constructor() {
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.divisionCode = '' ;
		this.type = '' ;
		this.model = '' ;
		this.receiptDate = '' ;
		this.stampedDate = '' ;
		this.complete = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.supplierInvoiceRef = '' ;
		this.amount = 0 ;
		this.qtyRotal = 0 ;
		this.qtyRemainingTotal = 0 ;
		this.remaingAmt = 0 ;
		this.percentOfTotalSold = 0 ;
		this.totalQtySold = 0 ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.fabricDesc = '' ;
		this.orderQuantity = 0 ;
		this.lnPcs = 0 ;
		this.cost = 0 ;
		this.lineAmount = 0 ;
		this.lnQtyRmg = 0 ;
		this.lnPcsRmg = 0 ;
		this.lineRmgAmount = 0 ;
		this.lineQtyOrdered = 0 ;
		this.lineAmtOrdered = 0 ;
		this.percentageOfLineQtySold = 0 ;
		this.lineQtySold = 0 ;
		this.parentType = '' ;
		this.parentModel = '' ;
		this.parentDate = '' ;
		this.parentQtyTotalOrdered = 0 ;
		this.parentTotalAmount = 0 ;
		this.parentQtyTotalInput = 0 ;
		this.receivedQty = 0 ;
		this.skuNumber = 0 ;
		this.vendorInvoiceNumber = '' ;
	}
}
/* ds.inquiry.PurchaseOrderVendorUpdateDataExportElectronicInputHeaderBean */
export class PurchaseOrderVendorUpdateDataExportElectronicInputHeaderBean {
	constructor() {
		this.purchaseOrderNumber = '' ;
		this.orderDate = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.xFactoryDate = '' ;
		this.inConsolidateDate = '' ;
		this.inDCDate = '' ;
		this.etaDate = '' ;
		this.existingVendorCode = '' ;
		this.newVendorCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.purchaseOrderInputlines = new Array() ;
	}
}
/* ds.inquiry.PurchaseOrderVendorUpdateDataExportElectronicInputLineBean */
export class PurchaseOrderVendorUpdateDataExportElectronicInputLineBean {
	constructor() {
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleDescription = '' ;
		this.colorCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.onOrderQty = 0 ;
		this.orderDate = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.xFactoryDate = '' ;
		this.inConsolidateDate = '' ;
		this.inDCDate = '' ;
		this.etaDate = '' ;
		this.existingVendor = '' ;
		this.newVendorCode = '' ;
		this.widthCode = '' ;
		this.uomCode = '' ;
	}
}
/* ds.inquiry.PurchaseProductAvailabilityDetails */
export class PurchaseProductAvailabilityDetails {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.reserveCustomerCode = '' ;
		this.reserveCustomerName = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.purchaseOrderQuantity = 0 ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.orderDate = '' ;
	}
}
/* ds.inquiry.PurchaseReceiptDataExportElectronicInputHeaderBean_texco */
export class PurchaseReceiptDataExportElectronicInputHeaderBean_texco {
	constructor() {
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.vendorInvoiceNumber = '' ;
		this.receiptDate = '' ;
		this.deliveryDate = '' ;
		this.dueDate = '' ;
		this.orderDate = '' ;
		this.grandTotalAmount = 0 ;
		this.receivedQuantity = 0 ;
		this.orderQuantity = 0 ;
		this.purchaseOrderReceiptInputlines = new Array() ;
	}
}
/* ds.inquiry.ReceivedBinDataBean */
export class ReceivedBinDataBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.numberOfRolls = 0 ;
		this.aisleInfoTexts = '' ;
		this.rollSkuNumber = 0 ;
	}
}
/* ds.inquiry.ReceivedRollDetailBean */
export class ReceivedRollDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.fabricStyleColorCode = '' ;
		this.quantity = 0 ;
		this.aisleInfoText = '' ;
		this.rollSkuNumber = 0 ;
	}
}
/* ds.inquiry.ResolvedReceiptInfoBean */
export class ResolvedReceiptInfoBean {
	constructor() {
		this.receiptNumbers = null ;
		this.receiptToPoMap = null ;
		this.joinedReceiptNumber = '' ;
		this.resolvedPoNumber = '' ;
	}
}
/* ds.inquiry.response.AllCustomerOnlineAgingResultResponseBean */
export class AllCustomerOnlineAgingResultResponseBean {
	constructor() {
		this.onLineAgingResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.ApprovedSalesOrderForPickTicketResponseBean */
export class ApprovedSalesOrderForPickTicketResponseBean {
	constructor() {
		this.approvedSalesOrderBean = new Array() ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.BankAccountBalanceHistoryTrackInquiryResultResponseBean */
export class BankAccountBalanceHistoryTrackInquiryResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.BookingReportResponseBean */
export class BookingReportResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.BouncedChecksResultResponseBean */
export class BouncedChecksResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.CashReceiptsActivityResponseBean */
export class CashReceiptsActivityResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.CheckPaymentHistoryResultResponseBean */
export class CheckPaymentHistoryResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.CPMDetailResultResponseBean */
export class CPMDetailResultResponseBean {
	constructor() {
		this.cpmDetail = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.CustomerAccountTransactionInquiryResponseBean */
export class CustomerAccountTransactionInquiryResponseBean {
	constructor() {
		this.accountSummaryResult = null ;
		this.inquiryResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.CustomerAllocationInTransitInquiryResultResponseBean */
export class CustomerAllocationInTransitInquiryResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.CustomerBalanceDetailHistoryInquiryResultResponseBean */
export class CustomerBalanceDetailHistoryInquiryResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.CustomerDetailsWithSalesInvoiceResultResponseBean */
export class CustomerDetailsWithSalesInvoiceResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.CustomerFabricStyleCurrentATSResultResponseBean */
export class CustomerFabricStyleCurrentATSResultResponseBean {
	constructor() {
		this.inquiryResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.CustomerLogisticOnOrderDetailsResponseBean */
export class CustomerLogisticOnOrderDetailsResponseBean {
	constructor() {
		this.orderDetailsResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.CustomerPaymentAgingHistoryInquiryResultResponseBean */
export class CustomerPaymentAgingHistoryInquiryResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.CustomerSalesBackOrderAgingHistoryResultResponseBean */
export class CustomerSalesBackOrderAgingHistoryResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.CustomerSalesOnOrderDetailsResponseBean */
export class CustomerSalesOnOrderDetailsResponseBean {
	constructor() {
		this.orderDetailsResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.CustomerSalesOnOrderInfoResponseBean */
export class CustomerSalesOnOrderInfoResponseBean {
	constructor() {
		this.orderInfoResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.CustomerServiceResultResponseBean */
export class CustomerServiceResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.CustomerServiceSalesOrderResultResponseBean */
export class CustomerServiceSalesOrderResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.CustomerStatementInquiryResultResponseBean */
export class CustomerStatementInquiryResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.CustomerStatisticsInquiryResultResponseBean */
export class CustomerStatisticsInquiryResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.CustomerTransactionInquiryResponseBean */
export class CustomerTransactionInquiryResponseBean {
	constructor() {
		this.inquiryResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.CustomerTransactiontSummaryResponseBean */
export class CustomerTransactiontSummaryResponseBean {
	constructor() {
		this.customerTransactiontSummaryResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.DailyInventoryAdjustedResultResponseBean */
export class DailyInventoryAdjustedResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.DailyInventoryProcessTrackInquiryResultResponseBean */
export class DailyInventoryProcessTrackInquiryResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.DailyInventoryReceivedResultResponseBean */
export class DailyInventoryReceivedResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.DailyInventoryShippedResultResponseBean */
export class DailyInventoryShippedResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.DailyInventoryTrackInquiryResultResponseBean */
export class DailyInventoryTrackInquiryResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricExportElectronicDataResponse */
export class FabricExportElectronicDataResponse {
	constructor() {
		this.eInput = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricSalesActivityResultResponseBean */
export class FabricSalesActivityResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleBackOrderResultResponseBean */
export class FabricStyleBackOrderResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleBarCodeResultResponseBean */
export class FabricStyleBarCodeResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleColorATSDetailResultResponseBean */
export class FabricStyleColorATSDetailResultResponseBean {
	constructor() {
		this.atsDetail = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleColorPriceInfoResponseBean */
export class FabricStyleColorPriceInfoResponseBean {
	constructor() {
		this.priceInfo = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleCurrentATSPageListResponseBean */
export class FabricStyleCurrentATSPageListResponseBean {
	constructor() {
		this.inquiryResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleCurrentATSResultResponseBean */
export class FabricStyleCurrentATSResultResponseBean {
	constructor() {
		this.inquiryResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleCustomerSalesSummaryDetailResultResponseBean */
export class FabricStyleCustomerSalesSummaryDetailResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleDashBoardResultResponseBean */
export class FabricStyleDashBoardResultResponseBean {
	constructor() {
		this.result = null ;
		this.inventoryResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleInAndOutStatisticsInquiryResultResponseBean */
export class FabricStyleInAndOutStatisticsInquiryResultResponseBean {
	constructor() {
		this.inquiryResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleInAndOutStatisticsPopUpResultResponseBean */
export class FabricStyleInAndOutStatisticsPopUpResultResponseBean {
	constructor() {
		this.inquiryResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleInquiryDataResponseBean */
export class FabricStyleInquiryDataResponseBean {
	constructor() {
		this.inquireData = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleInventoryValuationResultResponseBean */
export class FabricStyleInventoryValuationResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStylePurchaseOrderHistoryResultResponseBean */
export class FabricStylePurchaseOrderHistoryResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStylePurchaseReceiptHistoryInquiryResultResponseBean */
export class FabricStylePurchaseReceiptHistoryInquiryResultResponseBean {
	constructor() {
		this.inquiryResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleReceivedDetailResultResponseBean */
export class FabricStyleReceivedDetailResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleSalesAndPurchaseInquiryResultResponseBean */
export class FabricStyleSalesAndPurchaseInquiryResultResponseBean {
	constructor() {
		this.inquiryResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleSalesBackOrderAgingHistoryResultResponseBean */
export class FabricStyleSalesBackOrderAgingHistoryResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleSalesInquiryResultResponseBean */
export class FabricStyleSalesInquiryResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleSalesPersonSalesSummaryDetailResultResponseBean */
export class FabricStyleSalesPersonSalesSummaryDetailResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStylesColorStatisticsDetailsResponseBean */
export class FabricStylesColorStatisticsDetailsResponseBean {
	constructor() {
		this.fabricColorStatisticsDetailsResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleStatisticsInquiryResultResponseBean */
export class FabricStyleStatisticsInquiryResultResponseBean {
	constructor() {
		this.inquiryResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleStatisticsInquirySummaryDetailResultResponseBean */
export class FabricStyleStatisticsInquirySummaryDetailResultResponseBean {
	constructor() {
		this.summaryDetailBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleStatisticsInquirySummaryResultResponseBean */
export class FabricStyleStatisticsInquirySummaryResultResponseBean {
	constructor() {
		this.inquiryResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleWeeklyMonthlyATSResultResponseBean */
export class FabricStyleWeeklyMonthlyATSResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FabricStyleYearlySalesResultResponseBean */
export class FabricStyleYearlySalesResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.FiscalYearBookingReportResultResponseBean */
export class FiscalYearBookingReportResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.InboundOpenOrderNotReceivedResponseBean */
export class InboundOpenOrderNotReceivedResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.InboundReceiptNotInvoicedResultResponseBean */
export class InboundReceiptNotInvoicedResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.InfoResponseBean */
export class InfoResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.InventorySalesPurchasePositionInquiryResultResponseBean */
export class InventorySalesPurchasePositionInquiryResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.InvoiceCommodityInquiryResultResponseBean */
export class InvoiceCommodityInquiryResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.InvoicedNotApprovedResultResponseBean */
export class InvoicedNotApprovedResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.InvoiceFabricStylesYearlyDetailsResponseBean */
export class InvoiceFabricStylesYearlyDetailsResponseBean {
	constructor() {
		this.yearlyDetailsResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.InvoiceRegisterReportDetailResultResponseBean */
export class InvoiceRegisterReportDetailResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.InvoiceSalesPersonCommissionInquiryResultResponseBean */
export class InvoiceSalesPersonCommissionInquiryResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.InvoiceSalesPersonCommissionResultResponseBean */
export class InvoiceSalesPersonCommissionResultResponseBean {
	constructor() {
		this.commissionResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.InvoiceServiceInquiryResultResponseBean */
export class InvoiceServiceInquiryResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.LatePurchaseOrderResultResponseBean */
export class LatePurchaseOrderResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.MailTrackResultResponseBean */
export class MailTrackResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.MostRecentCustomerInfoResultResponseBean */
export class MostRecentCustomerInfoResultResponseBean {
	constructor() {
		this.count = 0 ;
		this.inquireResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.MostRecentCustomerSalesDetailResponseBean */
export class MostRecentCustomerSalesDetailResponseBean {
	constructor() {
		this.count = 0 ;
		this.salesOrderInfos = new Array() ;
		this.salesInvoiceInfos = new Array() ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.MostRecentFabricInfoResultResponseBean */
export class MostRecentFabricInfoResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.ObseleteInventoryResultResponseBean */
export class ObseleteInventoryResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.OpenPickTicketBriefResultResponseBean */
export class OpenPickTicketBriefResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.OpenPickTicketResultResponseBean */
export class OpenPickTicketResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.PastDueInvoiceWithCCPaymentResponseBean */
export class PastDueInvoiceWithCCPaymentResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.PickedandShippedListResponseBean */
export class PickedandShippedListResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.PickTicketNotInvoicedResponseBean */
export class PickTicketNotInvoicedResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.PickTicketPickerDetailsResponseBean */
export class PickTicketPickerDetailsResponseBean {
	constructor() {
		this.pickerDetailsResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.PostDatedAndBouncedChecksResultResponseBean */
export class PostDatedAndBouncedChecksResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.PostDatedChecksResultResponseBean */
export class PostDatedChecksResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.PostedARPaymentRegisterResponseBean */
export class PostedARPaymentRegisterResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.PostedARRegisterResponseBean */
export class PostedARRegisterResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.PrintOutTrackResultResponseBean */
export class PrintOutTrackResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.PrintPickticketDetailResponseBean */
export class PrintPickticketDetailResponseBean {
	constructor() {
		this.count = 0 ;
		this.pickTicketInfos = new Array() ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.ProductAvailabilityResultResponseBean */
export class ProductAvailabilityResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.PullBulkPickTicketResultResponseBean */
export class PullBulkPickTicketResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.PullBulkPickTicketSummaryResultResponseBean */
export class PullBulkPickTicketSummaryResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.PurchaseAnalysisDashBoardResultResponseBean */
export class PurchaseAnalysisDashBoardResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.PurchaseInTransitSummaryDetailsResponseBean */
export class PurchaseInTransitSummaryDetailsResponseBean {
	constructor() {
		this.inTransitSummaryDetailsResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.PurchaseOrderInTransitInquiryResultResponseBean */
export class PurchaseOrderInTransitInquiryResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.PurchaseOrderReceiptReceivedResultResponseBean */
export class PurchaseOrderReceiptReceivedResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.PurchaseOrderReceiptResultResponseBean */
export class PurchaseOrderReceiptResultResponseBean {
	constructor() {
		this.purchaseOrderReceiptResult = null ;
		this.count = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.ReceiptBinDetailsResponseBean */
export class ReceiptBinDetailsResponseBean {
	constructor() {
		this.binDetailsResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.ReturnSalesPersonCommissionInquiryResultResponseBean */
export class ReturnSalesPersonCommissionInquiryResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.RollingInquiryResultResponseBean */
export class RollingInquiryResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.SalesAnalysisDashBoardResultResponseBean */
export class SalesAnalysisDashBoardResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.SalesAndPurchaseInquiryResultResponseBean */
export class SalesAndPurchaseInquiryResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.SalesBackOrderDetailResultResponseBean */
export class SalesBackOrderDetailResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.SalesInquiryFabricStyleStyleResultResponseBean */
export class SalesInquiryFabricStyleStyleResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.SalesOrderCancelLineResultResponseBean */
export class SalesOrderCancelLineResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.SalesOrderInquiryResultResponseBean */
export class SalesOrderInquiryResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.SalesOrderListReportResultResponseBean */
export class SalesOrderListReportResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.SalesOrderStatusListReportResponseBean */
export class SalesOrderStatusListReportResponseBean {
	constructor() {
		this.reportInfoBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.SalesPriceInquiryResultResponseBean */
export class SalesPriceInquiryResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.SalesYearlyStatisticsResponseBean */
export class SalesYearlyStatisticsResponseBean {
	constructor() {
		this.resultResponseInfos = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.ServiceAnalysisDashBoardResultResponseBean */
export class ServiceAnalysisDashBoardResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.ShippingReportResponseBean */
export class ShippingReportResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.SKUResponseBean */
export class SKUResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.SummaryReportInfoResponseBean */
export class SummaryReportInfoResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.UnApprovedPurchaseOrderResponseBean */
export class UnApprovedPurchaseOrderResponseBean {
	constructor() {
		this.unApprovedPurchaseOrders = new Array() ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.UnPostedARInfoForInvoiceResultResponseBean */
export class UnPostedARInfoForInvoiceResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.UnPostedARListResponseBean */
export class UnPostedARListResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.VendorPurchaseInTransitDetailsResponseBean */
export class VendorPurchaseInTransitDetailsResponseBean {
	constructor() {
		this.inTransitDetailsResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.VendorPurchaseOnOrderDetailsResponseBean */
export class VendorPurchaseOnOrderDetailsResponseBean {
	constructor() {
		this.orderDetailsResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.VendorPurchaseOnOrderInfoResponseBean */
export class VendorPurchaseOnOrderInfoResponseBean {
	constructor() {
		this.orderInfoResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.VendorPurchaseOrderInTransitDetailResultResponseBean */
export class VendorPurchaseOrderInTransitDetailResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.VendorStatisticsInquiryResultResponseBean */
export class VendorStatisticsInquiryResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.response.WeightConversionInquiryResponseBean */
export class WeightConversionInquiryResponseBean {
	constructor() {
		this.results = new Array() ;
		this.criteria = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.result.BookingReportResultBean */
export class BookingReportResultBean {
	constructor() {
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.qty = 0 ;
		this.amount = 0 ;
		this.openQuantity = 0 ;
		this.bookingDataBean = new Array() ;
	}
}
/* ds.inquiry.result.CPMDetailResultBean */
export class CPMDetailResultBean {
	constructor() {
		this.companyCode = '' ;
		this.infos = new Array() ;
	}
}
/* ds.inquiry.result.CustomerDetailsWithSalesInvoiceResultBean */
export class CustomerDetailsWithSalesInvoiceResultBean {
	constructor() {
		this.companyCode = '' ;
		this.infos = new Array() ;
	}
}
/* ds.inquiry.result.CustomerOnOrderWithAtsResultBean */
export class CustomerOnOrderWithAtsResultBean {
	constructor() {
		this.count = 0 ;
		this.info = new Array() ;
	}
}
/* ds.inquiry.result.CustomerSalesInquiryResultBean */
export class CustomerSalesInquiryResultBean {
	constructor() {
		this.salesOrders = new Array() ;
		this.salesOrderLines = new Array() ;
		this.invoices = new Array() ;
		this.invoiceLines = new Array() ;
	}
}
/* ds.inquiry.result.CustomerServiceReportResultBean */
export class CustomerServiceReportResultBean {
	constructor() {
		this.reportInfos = new Array() ;
	}
}
/* ds.inquiry.result.CustomerStatisticsInquiryResultBean */
export class CustomerStatisticsInquiryResultBean {
	constructor() {
		this.lastThreeMonthsSalesAmount = 0 ;
		this.lastSixMonthsSalesAmount = 0 ;
		this.lastTwelveMonthsSalesAmount = 0 ;
		this.lastEighteenMonthsSalesAmount = 0 ;
		this.lastTwentyFourMonthsSalesAmount = 0 ;
		this.moreThenTwoYearsSalesAmount = 0 ;
		this.agingHistoryBean = null ;
		this.agingBucketGroupBean = null ;
		this.lastPaidAmount = 0 ;
		this.lastAccountReceivableNumber = '' ;
		this.lastPaidDate = '' ;
		this.totalDueAmount = 0 ;
		this.noOfBouncedCheck = 0 ;
		this.totalBouncedcheckAmount = 0 ;
		this.totalOpenCreditAmount = 0 ;
		this.openTenderCreditAmount = 0 ;
		this.openReturnCreditAmount = 0 ;
		this.openDiscountCreditAmount = 0 ;
		this.totalReturnsAmount = 0 ;
		this.salesDetails = new Array() ;
		this.onOrderInfoDetails = new Array() ;
		this.returnCreditMemos = new Array() ;
	}
}
/* ds.inquiry.result.DailyInventoryAdjustedTrackInquiryResultBean */
export class DailyInventoryAdjustedTrackInquiryResultBean {
	constructor() {
		this.companyCode = '' ;
		this.infos = new Array() ;
	}
}
/* ds.inquiry.result.DailyInventoryProcessTrackInquiryResultBean */
export class DailyInventoryProcessTrackInquiryResultBean {
	constructor() {
		this.companyCode = '' ;
		this.infos = new Array() ;
	}
}
/* ds.inquiry.result.DailyInventoryReceivedTrackInquiryResultBean */
export class DailyInventoryReceivedTrackInquiryResultBean {
	constructor() {
		this.companyCode = '' ;
		this.infos = new Array() ;
	}
}
/* ds.inquiry.result.DailyInventoryShippedTrackInquiryResultBean */
export class DailyInventoryShippedTrackInquiryResultBean {
	constructor() {
		this.companyCode = '' ;
		this.infos = new Array() ;
	}
}
/* ds.inquiry.result.DailyInventoryTrackInquiryResultBean */
export class DailyInventoryTrackInquiryResultBean {
	constructor() {
		this.companyCode = '' ;
		this.infos = new Array() ;
	}
}
/* ds.inquiry.result.DataElectronicResultInputBean */
export class DataElectronicResultInputBean {
	constructor() {
		this.count = 0 ;
		this.salesOrderInput = new Array() ;
		this.invoiceInput = new Array() ;
		this.purchaseOrderInput = new Array() ;
		this.receiptInput = new Array() ;
	}
}
/* ds.inquiry.result.FabricStyleCatalogResultBean */
export class FabricStyleCatalogResultBean {
	constructor() {
		this.count = 0 ;
		this.catalogDetails = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inquiry.result.FabricStyleCurrentATSPageListResultBean */
export class FabricStyleCurrentATSPageListResultBean {
	constructor() {
		this.count = 0 ;
		this.atsInfos = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inquiry.result.FabricStyleCurrentATSResultBean */
export class FabricStyleCurrentATSResultBean {
	constructor() {
		this.count = 0 ;
		this.totalOnHandQuantity = 0 ;
		this.totalCustomerOnOrderQuantity = 0 ;
		this.totalVendorOnOrderQuantity = 0 ;
		this.totalManualAllocatedQuantity = 0 ;
		this.totalLast3MonthsSalesQuantity = 0 ;
		this.totalLast6MonthsSalesQuantity = 0 ;
		this.totalLast12MonthsSalesQuantity = 0 ;
		this.totalLast18MonthsSalesQuantity = 0 ;
		this.totalLast24MonthsSalesQuantity = 0 ;
		this.totalLast36MonthsSalesQuantity = 0 ;
		this.totalInTransitQuantity = 0 ;
		this.totalMonthToDateQuantity = 0 ;
		this.totalSalesQuantity = 0 ;
		this.totalReceivedQuantity = 0 ;
		this.totalAtsYardage = 0 ;
		this.totalNumberOfRolls = 0 ;
		this.atsInfos = new Array() ;
		this.reportAtsInfos = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inquiry.result.FabricStyleInAndOutStatisticsInquiryResultBean */
export class FabricStyleInAndOutStatisticsInquiryResultBean {
	constructor() {
		this.count = 0 ;
		this.containerDatas = new Array() ;
		this.projectNumberDatas = new Array() ;
		this.lotNumberDatas = new Array() ;
	}
}
/* ds.inquiry.result.FabricStyleInAndOutStatisticsPopUpInquiryResultBean */
export class FabricStyleInAndOutStatisticsPopUpInquiryResultBean {
	constructor() {
		this.count = 0 ;
		this.receiptContainerDatas = new Array() ;
		this.receiptProjectNumberDatas = new Array() ;
		this.shippedContainerDatas = new Array() ;
		this.shippedProjectNumberDatas = new Array() ;
		this.receiptLotDatas = new Array() ;
		this.shippedLotDatas = new Array() ;
		this.pickedContainerDatas = new Array() ;
		this.pickedProjectNumberDatas = new Array() ;
		this.pickedLotDatas = new Array() ;
	}
}
/* ds.inquiry.result.FabricStyleInventoryValuationResultBean */
export class FabricStyleInventoryValuationResultBean {
	constructor() {
		this.valuationInfos = new Array() ;
		this.totalPurchaseValueAmount = 0 ;
		this.totalSalesValueAmount = 0 ;
		this.totalOnHandQuantity = 0 ;
		this.totalInventoryAmountNetCost = 0 ;
		this.totalLandedCostInventoryAmount = 0 ;
		this.totalFOBCostInventoryAmount = 0 ;
		this.totalAmountNetCost = 0 ;
		this.totalLastPurchaseValueAmount = 0 ;
	}
}
/* ds.inquiry.result.FabricStylePurchaseReceiptHistoryInquiryResultBean */
export class FabricStylePurchaseReceiptHistoryInquiryResultBean {
	constructor() {
		this.count = 0 ;
		this.infos = new Array() ;
	}
}
/* ds.inquiry.result.FabricStyleSalesAndPurchaseInquiryResultBean */
export class FabricStyleSalesAndPurchaseInquiryResultBean {
	constructor() {
		this.count = 0 ;
		this.totalOnHandQuantity = 0 ;
		this.totalShippedQuantity = 0 ;
		this.totalReceivedQuantity = 0 ;
		this.infos = new Array() ;
	}
}
/* ds.inquiry.result.FabricStyleSalesInquiryResultBean */
export class FabricStyleSalesInquiryResultBean {
	constructor() {
		this.count = 0 ;
		this.totalOrderQuantity = 0 ;
		this.totalOpenQuantity = 0 ;
		this.infos = new Array() ;
	}
}
/* ds.inquiry.result.FabricStyleStatisticsInquiryResultBean */
export class FabricStyleStatisticsInquiryResultBean {
	constructor() {
		this.summaryDatas = new Array() ;
	}
}
/* ds.inquiry.result.FabricStyleStatisticsInquirySummaryDetailResultBean */
export class FabricStyleStatisticsInquirySummaryDetailResultBean {
	constructor() {
		this.summaryDetails = new Array() ;
	}
}
/* ds.inquiry.result.FabricStyleStatisticsInquirySummaryResultBean */
export class FabricStyleStatisticsInquirySummaryResultBean {
	constructor() {
		this.summaryDatas = new Array() ;
	}
}
/* ds.inquiry.result.FiscalYearBookingSummaryResultBean */
export class FiscalYearBookingSummaryResultBean {
	constructor() {
		this.salesOrderQuantity = 0 ;
		this.invoiceQuantity = 0 ;
		this.totalAdjustedQuantity = 0 ;
		this.totalSalesOrderQuantity = 0 ;
		this.totalShippedQuantity = 0 ;
		this.totalOpenQuantity = 0 ;
		this.totalGrandTotalAmount = 0 ;
		this.totalRemainingAmount = 0 ;
		this.fiscalYearBookingBean = new Array() ;
	}
}
/* ds.inquiry.result.InventoryInquiryResultBean */
export class InventoryInquiryResultBean {
	constructor() {
		this.inquiryCriteria = null ;
		this.inventoryData = new Array() ;
		this.totalCost = 0 ;
	}
}
/* ds.inquiry.result.InvoiceCommodityInquiryResultBean */
export class InvoiceCommodityInquiryResultBean {
	constructor() {
		this.companyCode = '' ;
		this.totalGrandAmount = 0 ;
		this.totalSubTotalAmount = 0 ;
		this.totalServiceAmount = 0 ;
		this.infos = new Array() ;
	}
}
/* ds.inquiry.result.InvoiceSalesPersonCommissionInquiryResultBean */
export class InvoiceSalesPersonCommissionInquiryResultBean {
	constructor() {
		this.totalCommissionAmount = 0 ;
		this.netCommissionPercentage = 0 ;
		this.totalNetAmount = 0 ;
		this.lines = new Array() ;
	}
}
/* ds.inquiry.result.InvoiceServiceInquiryResultBean */
export class InvoiceServiceInquiryResultBean {
	constructor() {
		this.companyCode = '' ;
		this.totalAmount = 0 ;
		this.totalQuantity = 0 ;
		this.infos = new Array() ;
	}
}
/* ds.inquiry.result.LatePurchaseOrderResultBean */
export class LatePurchaseOrderResultBean {
	constructor() {
		this.latePurchaseOrderDetails = new Array() ;
	}
}
/* ds.inquiry.result.MonthlyPurchaseReceiptResultBean */
export class MonthlyPurchaseReceiptResultBean {
	constructor() {
		this.totalPurchaseReceiptAmount = 0 ;
	}
}
/* ds.inquiry.result.PurchaseOrderReceiptReceivedResultBean */
export class PurchaseOrderReceiptReceivedResultBean {
	constructor() {
		this.receivedDatas = new Array() ;
	}
}
/* ds.inquiry.result.PurchaseOrderReceiptResultBean */
export class PurchaseOrderReceiptResultBean {
	constructor() {
		this.resultCount = 0 ;
		this.purchaseOrderReceiptDetails = new Array() ;
	}
}
/* ds.inquiry.result.ReturnSalesPersonCommissionInquiryResultBean */
export class ReturnSalesPersonCommissionInquiryResultBean {
	constructor() {
		this.count = 0 ;
		this.lines = new Array() ;
	}
}
/* ds.inquiry.result.RollingInventoryInquiryResultBean */
export class RollingInventoryInquiryResultBean {
	constructor() {
		this.companyCode = '' ;
		this.infos = new Array() ;
	}
}
/* ds.inquiry.result.SalesAndPurchaseInquiryResultBean */
export class SalesAndPurchaseInquiryResultBean {
	constructor() {
		this.companyCode = '' ;
		this.infos = new Array() ;
	}
}
/* ds.inquiry.result.SalesOrderAdjustmentTrackInquiryResultBean */
export class SalesOrderAdjustmentTrackInquiryResultBean {
	constructor() {
		this.salesOrderBean = null ;
		this.adjustmentTracks = new Array() ;
	}
}
/* ds.inquiry.result.SalesOrderCancelLineResultBean */
export class SalesOrderCancelLineResultBean {
	constructor() {
		this.companyCode = '' ;
		this.cancelLineInfos = new Array() ;
	}
}
/* ds.inquiry.result.SalesOrderInquiryResultBean */
export class SalesOrderInquiryResultBean {
	constructor() {
		this.salesOrders = new Array() ;
		this.salesOrderLines = new Array() ;
	}
}
/* ds.inquiry.result.SalesOrderListReportResultBean */
export class SalesOrderListReportResultBean {
	constructor() {
		this.salesOrderQuantity = 0 ;
		this.invoiceQuantity = 0 ;
		this.salesOrderReportBean = new Array() ;
		this.totalAdjustedQuantity = 0 ;
		this.totalSalesOrderQuantity = 0 ;
		this.totalShippedQuantity = 0 ;
		this.totalOpenQuantity = 0 ;
		this.totalGrandTotalAmount = 0 ;
		this.totalRemainingAmount = 0 ;
	}
}
/* ds.inquiry.result.SalesPriceInquiryResultBean */
export class SalesPriceInquiryResultBean {
	constructor() {
		this.companyCode = '' ;
		this.infos = new Array() ;
	}
}
/* ds.inquiry.result.SalesYearlyStatisticsDetailResultBean */
export class SalesYearlyStatisticsDetailResultBean {
	constructor() {
		this.count = 0 ;
		this.statsDetails = new Array() ;
		this.fabricDetails = new Array() ;
		this.salesPersonDetails = new Array() ;
		this.customerSummaryDetails = new Array() ;
	}
}
/* ds.inquiry.result.ShippingReportResultBean */
export class ShippingReportResultBean {
	constructor() {
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.qty = 0 ;
		this.amount = 0 ;
		this.shippingDataBean = new Array() ;
	}
}
/* ds.inquiry.result.UnPostedARInfoForInvoiceResultBean */
export class UnPostedARInfoForInvoiceResultBean {
	constructor() {
		this.unpostedAr = new Array() ;
	}
}
/* ds.inquiry.result.UnPostedCheckForInvoiceResultBean */
export class UnPostedCheckForInvoiceResultBean {
	constructor() {
		this.unpostedChecKInfo = new Array() ;
	}
}
/* ds.inquiry.result.VendorPurchaseOrderInTransitDetailResultBean */
export class VendorPurchaseOrderInTransitDetailResultBean {
	constructor() {
		this.inTransitDetails = new Array() ;
	}
}
/* ds.inquiry.result.VendorStatisticsInquiryResultBean */
export class VendorStatisticsInquiryResultBean {
	constructor() {
		this.lastThreeMonthsPurchaseAmount = 0 ;
		this.lastSixMonthsPurchaseAmount = 0 ;
		this.lastTwelveMonthsPurchaseAmount = 0 ;
		this.lastEighteenMonthsPurchaseAmount = 0 ;
		this.lastTwentyFourMonthsPurchaseAmount = 0 ;
		this.onOrderDetailBean = null ;
		this.purchaseOrderReceipts = new Array() ;
	}
}
/* ds.inquiry.result.WeightConversionResultBean */
export class WeightConversionResultBean {
	constructor() {
		this.weightUOM = '' ;
		this.weightValue = 0 ;
	}
}
/* ds.inquiry.SalesAnalysisResponseBean */
export class SalesAnalysisResponseBean {
	constructor() {
		this.count = 0 ;
		this.resultsInfos = new Array() ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inquiry.SalesAnalysisResultBean */
export class SalesAnalysisResultBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.salesAmount = 0 ;
		this.invoiceDate = '' ;
		this.agingDate = '' ;
		this.totalCurrentYearToDateSalesAmount = 0 ;
		this.totalPreviousYearToDateSalesAmount = 0 ;
		this.totalPreviousYearSalesAmount = 0 ;
		this.totalDifferenceYearToDateSalesAmount = 0 ;
		this.salesPercentage = 0 ;
		this.amountToBeMatched = 0 ;
		this.totalYearSalesAmount = 0 ;
		this.expectedFirstMonthAmount = 0 ;
		this.totalMonthlySalesAmount = 0 ;
		this.expectedFirstMonthDate = '' ;
		this.week = 0 ;
		this.day = 0 ;
		this.month = 0 ;
		this.year = 0 ;
		this.salesPersonCode = '' ;
		this.totalMonthlyYear1SalesAmount = 0 ;
		this.totalMonthlyYear2SalesAmount = 0 ;
		this.monthlyDetails = new Array() ;
	}
}
/* ds.inquiry.SalesAndPurchaseDetailsBean */
export class SalesAndPurchaseDetailsBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.invoiceNumber = '' ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.uomCode = '' ;
		this.quantity = 0 ;
		this.orderQuantity = 0 ;
		this.invoiceDate = '' ;
		this.noOfRolls = 0 ;
		this.locationCode = '' ;
		this.customerShipToName = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.purchaseOrderNumber = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.factoryCode = '' ;
		this.vendorStyleCode = '' ;
		this.packingSlipNumber = '' ;
		this.openOrderQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.receiptDate = '' ;
		this.receiptStatus = '' ;
		this.purchaseOrderDate = '' ;
		this.price = 0 ;
		this.extension = 0 ;
		this.salesOrderNumber = '' ;
		this.pickTicketNumber = '' ;
		this.customerPurchaseOrderNumber = '' ;
	}
}
/* ds.inquiry.SalesCommissionTransactionDetailBean */
export class SalesCommissionTransactionDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.documentCode = '' ;
		this.documentType = '' ;
		this.colorCode = '' ;
		this.fabricStyleCode = '' ;
		this.quantity = 0 ;
		this.transactionDate = '' ;
		this.aprice = 0 ;
		this.bprice = 0 ;
		this.invoicePrice = 0 ;
		this.customerType = '' ;
		this.commissionAmount = 0 ;
		this.commissionPercentage = 0 ;
		this.logisticMethodCode = '' ;
		this.transactionAmount = 0 ;
		this.lineTotalAmount = 0 ;
		this.accountReceivbaleNumber = '' ;
	}
}
/* ds.inquiry.SalesOrderDataExportElectronicInputHeaderBean */
export class SalesOrderDataExportElectronicInputHeaderBean {
	constructor() {
		this.salesOrderNumber = '' ;
		this.orderDate = '' ;
		this.customerName = '' ;
		this.customerCode = '' ;
		this.deliveryDate = '' ;
		this.grandTotalAmount = 0 ;
		this.orderQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.dueDate = '' ;
		this.paymentTerm = '' ;
		this.shipViaCode = '' ;
		this.salesPersonCode = '' ;
		this.csrCode = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.orderType = '' ;
		this.model = '' ;
		this.salesOrderInputLines = new Array() ;
	}
}
/* ds.inquiry.SalesOrderDataExportElectronicInputLineBean */
export class SalesOrderDataExportElectronicInputLineBean {
	constructor() {
		this.lineNumber = 0 ;
		this.salesOrderNumber = '' ;
		this.orderType = '' ;
		this.OrderDate = '' ;
		this.shipDate = '' ;
		this.deliveryDate = '' ;
		this.fob = '' ;
		this.shipVia = '' ;
		this.paymentTerm = '' ;
		this.dueDate = '' ;
		this.customerName = '' ;
		this.orderedQty = 0 ;
		this.invoicedQty = 0 ;
		this.backOrderedQty = 0 ;
		this.totalAmount = 0 ;
		this.salesPrice = 0 ;
		this.item = '' ;
		this.itemDescription = '' ;
		this.colorCode = '' ;
		this.openBalance = 0 ;
		this.skuNumber = 0 ;
		this.salesPersonCode = '' ;
		this.csrCode = '' ;
		this.customerPONumber = '' ;
	}
}
/* ds.inquiry.SalesProductAvailabilityDetails */
export class SalesProductAvailabilityDetails {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.salesOrderNumber = '' ;
		this.salesOrderQuantity = 0 ;
		this.customerPurchaseOrderNumber = '' ;
	}
}
/* ds.inquiry.SalesYearlyStatisticsCustomerDetails */
export class SalesYearlyStatisticsCustomerDetails {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.salesAmount = 0 ;
		this.invoiceDate = '' ;
		this.agingDate = '' ;
		this.yearMonthCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricColorCode = '' ;
		this.week = 0 ;
		this.day = 0 ;
		this.month = 0 ;
		this.year = 0 ;
		this.salesPersonCode = '' ;
		this.customerDropDownAmount = 0 ;
		this.customerDropDownPercentage = 0 ;
		this.monthlyCustomertSalesDetails = new Array() ;
		this.fabricSalesDetails = new Array() ;
		this.summaryCustomerDetails = new Array() ;
		this.customerSummaryCaptionDetails = new Array() ;
	}
}
/* ds.inquiry.SalesYearlyStatisticsDetailBean */
export class SalesYearlyStatisticsDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.salesAmount = 0 ;
		this.invoiceDate = '' ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.quantity = 0 ;
		this.week = 0 ;
		this.day = 0 ;
		this.month = 0 ;
		this.year = 0 ;
		this.invoiceNumber = '' ;
	}
}
/* ds.inquiry.SalesYearlyStatisticsFabricColorDetails */
export class SalesYearlyStatisticsFabricColorDetails {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.salesAmount = 0 ;
		this.invoiceDate = '' ;
		this.agingDate = '' ;
		this.yearMonthCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricColorCode = '' ;
		this.week = 0 ;
		this.day = 0 ;
		this.month = 0 ;
		this.year = 0 ;
		this.salesPersonCode = '' ;
		this.colorCaptions = new Array() ;
		this.fabricColorDropDownAmount = 0 ;
		this.fabricColorDropDownPercentage = 0 ;
		this.monthlyFabricColorSalesDetails = new Array() ;
		this.summaryFabricColorDetails = new Array() ;
	}
}
/* ds.inquiry.SalesYearlyStatisticsFabricDetailBean */
export class SalesYearlyStatisticsFabricDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.salesAmount = 0 ;
		this.invoiceDate = '' ;
		this.agingDate = '' ;
		this.yearMonthCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.week = 0 ;
		this.day = 0 ;
		this.month = 0 ;
		this.year = 0 ;
		this.salesPersonCode = '' ;
		this.fabricDropDownAmount = 0 ;
		this.fabricDropDownPercentage = 0 ;
		this.captionDetails = new Array() ;
		this.monthlyFabricSalesDetails = new Array() ;
		this.summaryFabricDetails = new Array() ;
		this.colorSalesDetails = new Array() ;
		this.fabricSummaryCaptionDetails = new Array() ;
	}
}
/* ds.inquiry.SalesYearlyStatisticsSalesPersonDetailBean */
export class SalesYearlyStatisticsSalesPersonDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.salesAmount = 0 ;
		this.invoiceDate = '' ;
		this.agingDate = '' ;
		this.yearMonthCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.week = 0 ;
		this.day = 0 ;
		this.month = 0 ;
		this.year = 0 ;
		this.salesPersonCode = '' ;
		this.salesPersonDropDownAmount = 0 ;
		this.salesPersonDropDownPercentage = 0 ;
		this.monthlySalesPersonFabricSalesDetails = new Array() ;
		this.salesPersonCaptionDetails = new Array() ;
		this.customerSalesDetails = new Array() ;
		this.summarySalesPersonDetails = new Array() ;
	}
}
/* ds.inquiry.SampleFabricInventoryAdjustmentDataExportLineBean */
export class SampleFabricInventoryAdjustmentDataExportLineBean {
	constructor() {
		this.fabricStyle = '' ;
		this.fabricStyleDescription = '' ;
		this.colorCode = '' ;
		this.colorName = '' ;
		this.quantity = 0 ;
	}
}
/* ds.inquiry.ShopifyExcelInputFabricStyleBean */
export class ShopifyExcelInputFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.handle = '' ;
		this.option1Name = '' ;
		this.option1Value = '' ;
		this.variantSKU = '' ;
		this.newSKU = '' ;
	}
}
/* ds.inquiry.VendorDataExportElectronicInputLineBean */
export class VendorDataExportElectronicInputLineBean {
	constructor() {
		this.activeString = '' ;
		this.isActive = false ;
		this.vendorName = '' ;
		this.balance = 0 ;
		this.totalBalance = 0 ;
		this.companyName = '' ;
		this.firstName = '' ;
		this.lastName = '' ;
		this.billFrom1 = '' ;
		this.billFrom2 = '' ;
		this.billFrom3 = '' ;
		this.billFrom4 = '' ;
		this.billFrom5 = '' ;
		this.shipFrom1 = '' ;
		this.shipFrom2 = '' ;
		this.shipFrom3 = '' ;
		this.shipFrom4 = '' ;
		this.shipFrom5 = '' ;
		this.contactPerson = '' ;
		this.phone = '' ;
		this.fax = '' ;
		this.altPhone = '' ;
		this.altContact = '' ;
		this.email = '' ;
	}
}
/* ds.inquiry.YearlySalesStatisticsResultBean */
export class YearlySalesStatisticsResultBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.salesAmount = 0 ;
		this.invoiceDate = '' ;
		this.agingDate = '' ;
		this.totalCurrentYearToDateSalesAmount = 0 ;
		this.totalPreviousYearToDateSalesAmount = 0 ;
		this.totalPreviousYearSalesAmount = 0 ;
		this.totalDifferenceYearToDateSalesAmount = 0 ;
		this.salesPercentage = 0 ;
		this.amountToBeMatched = 0 ;
		this.totalYearSalesAmount = 0 ;
		this.expectedFirstMonthAmount = 0 ;
		this.totalMonthlySalesAmount = 0 ;
		this.expectedFirstMonthDate = '' ;
		this.week = 0 ;
		this.day = 0 ;
		this.month = 0 ;
		this.year = 0 ;
		this.salesPersonCode = '' ;
		this.totalMonthlyYear1SalesAmount = 0 ;
		this.totalMonthlyYear2SalesAmount = 0 ;
		this.monthlyDetails = new Array() ;
	}
}
/* ds.inquiry.YearlyStatisticsCaptionBean */
export class YearlyStatisticsCaptionBean {
	constructor() {
		this.order = 0 ;
		this.caption = '' ;
	}
}
/* ds.inquiry.YearlyStatisticsSummaryBean */
export class YearlyStatisticsSummaryBean {
	constructor() {
		this.yearlySalesAmount = 0 ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.week = 0 ;
		this.day = 0 ;
		this.month = 0 ;
		this.year = 0 ;
		this.salesPersonCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
	}
}
/* ds.inventory.criteria.FabricStyleInventoryAdjustmentSearchCriteria */
export class FabricStyleInventoryAdjustmentSearchCriteria {
	constructor() {
		this.documentType = '' ;
		this.wareHouseCode = '' ;
		this.adjustmentReason = '' ;
		this.adjustmentCode = '' ;
		this.companyCode = '' ;
		this.status = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.createdBy = '' ;
		this.adjustmentCodeStartsWith = '' ;
		this.adjustmentCodeContains = '' ;
	}
}
/* ds.inventory.criteria.FabricStyleInventoryForLotBasedSearchCriteria */
export class FabricStyleInventoryForLotBasedSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.lotNumber = '' ;
		this.skuNumber = 0 ;
		this.logisticCustomerCode = '' ;
		this.fabricStyleCodes = new Array() ;
		this.customerUserCode = '' ;
		this.isSummary = false ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.logisticsOrderNumber = '' ;
		this.logisticsOrderReceiptNumber = '' ;
		this.containerNumber = '' ;
		this.warehousePurchaseOrderNumber = '' ;
		this.imeiNumber = '' ;
		this.projectNumber = '' ;
	}
}
/* ds.inventory.criteria.FabricStyleInventorySearchCriteria */
export class FabricStyleInventorySearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.locationCode = '' ;
	}
}
/* ds.inventory.criteria.InventoryLocationTransferSearchCriteria */
export class InventoryLocationTransferSearchCriteria {
	constructor() {
		this.transferCode = '' ;
		this.documentType = '' ;
		this.companyCode = '' ;
		this.status = '' ;
		this.transferReason = '' ;
		this.toLocationCode = '' ;
		this.fromLocationCode = '' ;
	}
}
/* ds.inventory.criteria.ItemCatalogInputCriteria */
export class ItemCatalogInputCriteria {
	constructor() {
		this.companyCode = '' ;
		this.itemCatalogDetails = new Array() ;
	}
}
/* ds.inventory.criteria.PhysicalInventoryAdjustmentSearchCriteria */
export class PhysicalInventoryAdjustmentSearchCriteria {
	constructor() {
		this.physicalInventoryAdjustmentNumber = '' ;
		this.companyCode = '' ;
		this.inventoryAdjustmentNumber = '' ;
		this.createdDate = '' ;
		this.createdBy = '' ;
	}
}
/* ds.inventory.criteria.RollsSearchCriteria */
export class RollsSearchCriteria {
	constructor() {
		this.locationCode = '' ;
		this.companyCode = '' ;
		this.binLocationCode = '' ;
		this.binLocationStartsWith = '' ;
		this.isIncludeHoldingWareHouse = false ;
		this.showsRollOfEmptyBinLocation = false ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.logisticCustomerCode = '' ;
		this.fabricStyleCodes = new Array() ;
	}
}
/* ds.inventory.criteria.SKUBatchInventoryBinLocationSearchCriteria */
export class SKUBatchInventoryBinLocationSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.binLocation = '' ;
		this.wareHouseCode = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.includeHoldingWarehouse = false ;
	}
}
/* ds.inventory.criteria.SKUBatchInventoryPhysicalInventoryTrackSearchCriteria */
export class SKUBatchInventoryPhysicalInventoryTrackSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleCodes = new Array() ;
		this.fabricStyleColorCode = '' ;
		this.wareHouseCode = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.logisticCustomerCode = '' ;
	}
}
/* ds.inventory.criteria.SKUBatchInventoryPrintInputCriteria */
export class SKUBatchInventoryPrintInputCriteria {
	constructor() {
		this.companyCode = '' ;
		this.rollSkuList = new Array() ;
		this.noOfCopies = 0 ;
	}
}
/* ds.inventory.criteria.SKUBatchInventorySearchCriteria */
export class SKUBatchInventorySearchCriteria {
	constructor() {
		this.skuNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleCodes = new Array() ;
		this.colorCode = '' ;
		this.locationCode = '' ;
		this.vendorCode = '' ;
		this.vendorBatchNumber = '' ;
		this.fetchQuantityAvailableLinesOnly = false ;
		this.purchaseOrderNumber = '' ;
		this.purchaseReceitpNumber = '' ;
		this.inventoryAdjustmentNumber = '' ;
		this.cancelledPickTicketNumber = '' ;
		this.cancelledInvoiceNumber = '' ;
		this.pickTicketNumber = '' ;
		this.pickTicketLineNumber = 0 ;
		this.sortingOrderType = 0 ;
		this.binLocation = '' ;
		this.isExcludeNonWarehouseInventory = false ;
		this.reserveCustomerCode = '' ;
		this.reserveCustomerName = '' ;
		this.containerNumber = '' ;
		this.businessDivision = '' ;
		this.isExcludeReserveWarehouseInventory = false ;
		this.fromRollSkuNumber = 0 ;
		this.toRollSkuNumber = 0 ;
		this.isTransitOnly = false ;
		this.logisticCustomerCode = '' ;
		this.excludedLocationCodes = new Array() ;
		this.fabricStyleCodeStartsWith = '' ;
		this.fabricStyleCodeContains = '' ;
		this.colorCodeContains = '' ;
		this.customerUserCode = '' ;
		this.locationCodes = new Array() ;
		this.warehousePurchaseorderNumber = '' ;
		this.imeiNumber = '' ;
		this.projectNumber = '' ;
		this.rollSkuNumbers = new Array() ;
		this.purchaseOrderReceiptNumbers = new Array() ;
		this.holdingCustomerCode = '' ;
		this.holdingNumber = '' ;
	}
}
/* ds.inventory.criteria.SKUBatchInventoryTrackSearchCriteria */
export class SKUBatchInventoryTrackSearchCriteria {
	constructor() {
		this.fromCreatedDate = '' ;
		this.toCreatedDate = '' ;
		this.modificationTrackNumber = 0 ;
		this.trackNumber = 0 ;
		this.updateEntityCode = '' ;
		this.updateEntityType = '' ;
		this.skuNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleCodes = new Array() ;
		this.colorCode = '' ;
		this.locationCode = '' ;
		this.vendorCode = '' ;
		this.vendorBatchNumber = '' ;
		this.fetchQuantityAvailableLinesOnly = false ;
		this.purchaseOrderNumber = '' ;
		this.purchaseReceitpNumber = '' ;
		this.inventoryAdjustmentNumber = '' ;
		this.cancelledPickTicketNumber = '' ;
		this.cancelledInvoiceNumber = '' ;
		this.pickTicketNumber = '' ;
		this.pickTicketLineNumber = 0 ;
		this.sortingOrderType = 0 ;
		this.binLocation = '' ;
		this.isExcludeNonWarehouseInventory = false ;
		this.reserveCustomerCode = '' ;
		this.reserveCustomerName = '' ;
		this.containerNumber = '' ;
		this.businessDivision = '' ;
		this.isExcludeReserveWarehouseInventory = false ;
		this.fromRollSkuNumber = 0 ;
		this.toRollSkuNumber = 0 ;
		this.isTransitOnly = false ;
		this.logisticCustomerCode = '' ;
		this.excludedLocationCodes = new Array() ;
		this.fabricStyleCodeStartsWith = '' ;
		this.fabricStyleCodeContains = '' ;
		this.colorCodeContains = '' ;
		this.customerUserCode = '' ;
		this.locationCodes = new Array() ;
		this.warehousePurchaseorderNumber = '' ;
		this.imeiNumber = '' ;
		this.projectNumber = '' ;
		this.rollSkuNumbers = new Array() ;
		this.purchaseOrderReceiptNumbers = new Array() ;
		this.holdingCustomerCode = '' ;
		this.holdingNumber = '' ;
	}
}
/* ds.inventory.criteria.SKUInventorySearchCriteria */
export class SKUInventorySearchCriteria {
	constructor() {
		this.skuNumber = 0 ;
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.locationCode = '' ;
		this.uomCode = '' ;
		this.excludeReserveLocation = false ;
		this.fabricStyleCodeContains = '' ;
		this.containerNumber = '' ;
		this.warehousePurchaseOrderNumber = '' ;
		this.imeiNumber = '' ;
		this.projectNumber = '' ;
		this.itemCodes = new Array() ;
		this.logisticCustomerCode = '' ;
		this.customerUserCode = '' ;
		this.excludedLocationCodes = new Array() ;
	}
}
/* ds.inventory.criteria.SKUInventoryTrackSearchCriteria */
export class SKUInventoryTrackSearchCriteria {
	constructor() {
		this.fromCreatedDate = '' ;
		this.toCreatedDate = '' ;
		this.skuNumber = 0 ;
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.locationCode = '' ;
		this.uomCode = '' ;
		this.excludeReserveLocation = false ;
		this.fabricStyleCodeContains = '' ;
		this.containerNumber = '' ;
		this.warehousePurchaseOrderNumber = '' ;
		this.imeiNumber = '' ;
		this.projectNumber = '' ;
		this.itemCodes = new Array() ;
		this.logisticCustomerCode = '' ;
		this.customerUserCode = '' ;
		this.excludedLocationCodes = new Array() ;
	}
}
/* ds.inventory.criteria.SKUInventoryTrackSummaryProcessSearchCriteria */
export class SKUInventoryTrackSummaryProcessSearchCriteria {
	constructor() {
		this.fromCreatedDate = '' ;
		this.toCreatedDate = '' ;
		this.skuNumber = 0 ;
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.entityTypeCode = '' ;
		this.entityNumber = '' ;
		this.uomCode = '' ;
		this.trackNumber = '' ;
		this.locationCode = '' ;
	}
}
/* ds.inventory.criteria.WebInventorySearchCriteria */
export class WebInventorySearchCriteria {
	constructor() {
		this.warehouseCode = '' ;
		this.companyCode = '' ;
		this.logisticCustomerCode = '' ;
	}
}
/* ds.inventory.criteria.WebSkuInventorySearchCriteria */
export class WebSkuInventorySearchCriteria {
	constructor() {
		this.skuNumber = 0 ;
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleCodes = new Array() ;
		this.colorCode = '' ;
		this.locationCode = '' ;
	}
}
/* ds.inventory.DailyInventoryAdjustedDetailsTrackBean */
export class DailyInventoryAdjustedDetailsTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.closingBalance = 0 ;
		this.openingBalance = 0 ;
		this.receivedQuantity = 0 ;
		this.adjustedQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.remarks = '' ;
		this.updateProcess = '' ;
		this.updateEntityCode = '' ;
		this.updateEntityType = '' ;
		this.enteredBy = '' ;
		this.enteredDate = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.uomCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.logisticOrderNumber = '' ;
		this.logisticOrderReceiptNumber = '' ;
		this.purchaseOrderNumber = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.adjustedLineDetailsTrackBean = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.DailyInventoryAdjustedLineDetailsTrackBean */
export class DailyInventoryAdjustedLineDetailsTrackBean {
	constructor() {
		this.trackNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.remarks = '' ;
		this.updateProcess = '' ;
		this.updateEntityCode = '' ;
		this.updateEntityType = '' ;
		this.updateEntityLineNumber = 0 ;
		this.enteredBy = '' ;
		this.enteredDate = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.companyCode = '' ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.referenceEntityType = '' ;
		this.referenceEntityNumber = '' ;
		this.uomCode = '' ;
		this.currencyCode = '' ;
		this.onHandQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.cost = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.batchBarCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.rollBarCode = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.receivedDate = '' ;
		this.isPickedFlag = false ;
		this.cancelledPickTicketNumber = '' ;
		this.cancelledInvoiceNumber = '' ;
		this.isCloseOutInventory = false ;
		this.isNewlyAddedToInventory = false ;
		this.infoText = '' ;
		this.aisleInfoText = '' ;
		this.lastPhysicalInventoryVerificationDate = '' ;
		this.reserveCustomerCode = '' ;
		this.reserveCustomerName = '' ;
		this.fobCost = 0 ;
		this.landedCost = 0 ;
		this.vendorSkuNumber = '' ;
		this.containerNumber = '' ;
		this.etaDate = '' ;
		this.businessDivision = '' ;
		this.billOfLading = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.vendorFactoryCode = '' ;
		this.shade = '' ;
		this.displayRollNumber = '' ;
		this.logisticOrderNumber = '' ;
		this.logisticOrderReceiptNumber = '' ;
		this.totalArea = '' ;
		this.numberOfPallets = 0 ;
		this.upcNumberBarCode = '' ;
		this.oldSystemRollSkuNumber = '' ;
		this.warehousePurchaseOrderNumber = '' ;
		this.customerReferenceNumber = '' ;
		this.palletNumber = '' ;
		this.imeiNumber = '' ;
		this.projectNumber = '' ;
		this.holdingDate = '' ;
		this.expirationDate = '' ;
		this.holdingNumber = '' ;
		this.holdingCustomerCode = '' ;
		this.expirationTime = '' ;
		this.isHoldingInventory = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.DailyInventoryProcessTrackBean */
export class DailyInventoryProcessTrackBean {
	constructor() {
		this.transactionId = 0 ;
		this.rollSkuNumber = 0 ;
		this.remarks = '' ;
		this.updateProcess = '' ;
		this.updateEntityCode = '' ;
		this.updateEntityType = '' ;
		this.updateEntityLineNumber = 0 ;
		this.enteredBy = '' ;
		this.enteredDate = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.documentDate = '' ;
		this.transactionDate = '' ;
		this.upcCode = '' ;
		this.rollBarCode = '' ;
		this.companyCode = '' ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.referenceEntityType = '' ;
		this.referenceEntityNumber = '' ;
		this.uomCode = '' ;
		this.currencyCode = '' ;
		this.onHandQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.cost = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.batchBarCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.rollBarCode = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.receivedDate = '' ;
		this.isPickedFlag = false ;
		this.cancelledPickTicketNumber = '' ;
		this.cancelledInvoiceNumber = '' ;
		this.isCloseOutInventory = false ;
		this.isNewlyAddedToInventory = false ;
		this.infoText = '' ;
		this.aisleInfoText = '' ;
		this.lastPhysicalInventoryVerificationDate = '' ;
		this.reserveCustomerCode = '' ;
		this.reserveCustomerName = '' ;
		this.fobCost = 0 ;
		this.landedCost = 0 ;
		this.vendorSkuNumber = '' ;
		this.containerNumber = '' ;
		this.etaDate = '' ;
		this.businessDivision = '' ;
		this.billOfLading = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.vendorFactoryCode = '' ;
		this.shade = '' ;
		this.displayRollNumber = '' ;
		this.logisticOrderNumber = '' ;
		this.logisticOrderReceiptNumber = '' ;
		this.totalArea = '' ;
		this.numberOfPallets = 0 ;
		this.upcNumberBarCode = '' ;
		this.oldSystemRollSkuNumber = '' ;
		this.warehousePurchaseOrderNumber = '' ;
		this.customerReferenceNumber = '' ;
		this.palletNumber = '' ;
		this.imeiNumber = '' ;
		this.projectNumber = '' ;
		this.holdingDate = '' ;
		this.expirationDate = '' ;
		this.holdingNumber = '' ;
		this.holdingCustomerCode = '' ;
		this.expirationTime = '' ;
		this.isHoldingInventory = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.DailyInventoryReceivedDetailsTrackBean */
export class DailyInventoryReceivedDetailsTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.closingBalance = 0 ;
		this.openingBalance = 0 ;
		this.receivedQuantity = 0 ;
		this.adjustedQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.remarks = '' ;
		this.updateProcess = '' ;
		this.updateEntityCode = '' ;
		this.updateEntityType = '' ;
		this.enteredBy = '' ;
		this.enteredDate = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.uomCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.logisticOrderNumber = '' ;
		this.logisticOrderReceiptNumber = '' ;
		this.purchaseOrderNumber = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.receivedLineDetailsTrackBeans = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.DailyInventoryReceivedLineDetailsTrackBean */
export class DailyInventoryReceivedLineDetailsTrackBean {
	constructor() {
		this.trackNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.remarks = '' ;
		this.updateProcess = '' ;
		this.updateEntityCode = '' ;
		this.updateEntityType = '' ;
		this.updateEntityLineNumber = 0 ;
		this.enteredBy = '' ;
		this.enteredDate = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.companyCode = '' ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.referenceEntityType = '' ;
		this.referenceEntityNumber = '' ;
		this.uomCode = '' ;
		this.currencyCode = '' ;
		this.onHandQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.cost = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.batchBarCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.rollBarCode = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.receivedDate = '' ;
		this.isPickedFlag = false ;
		this.cancelledPickTicketNumber = '' ;
		this.cancelledInvoiceNumber = '' ;
		this.isCloseOutInventory = false ;
		this.isNewlyAddedToInventory = false ;
		this.infoText = '' ;
		this.aisleInfoText = '' ;
		this.lastPhysicalInventoryVerificationDate = '' ;
		this.reserveCustomerCode = '' ;
		this.reserveCustomerName = '' ;
		this.fobCost = 0 ;
		this.landedCost = 0 ;
		this.vendorSkuNumber = '' ;
		this.containerNumber = '' ;
		this.etaDate = '' ;
		this.businessDivision = '' ;
		this.billOfLading = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.vendorFactoryCode = '' ;
		this.shade = '' ;
		this.displayRollNumber = '' ;
		this.logisticOrderNumber = '' ;
		this.logisticOrderReceiptNumber = '' ;
		this.totalArea = '' ;
		this.numberOfPallets = 0 ;
		this.upcNumberBarCode = '' ;
		this.oldSystemRollSkuNumber = '' ;
		this.warehousePurchaseOrderNumber = '' ;
		this.customerReferenceNumber = '' ;
		this.palletNumber = '' ;
		this.imeiNumber = '' ;
		this.projectNumber = '' ;
		this.holdingDate = '' ;
		this.expirationDate = '' ;
		this.holdingNumber = '' ;
		this.holdingCustomerCode = '' ;
		this.expirationTime = '' ;
		this.isHoldingInventory = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.DailyInventoryShippedDetailsTrackBean */
export class DailyInventoryShippedDetailsTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.closingBalance = 0 ;
		this.openingBalance = 0 ;
		this.receivedQuantity = 0 ;
		this.adjustedQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.remarks = '' ;
		this.updateProcess = '' ;
		this.updateEntityCode = '' ;
		this.updateEntityType = '' ;
		this.enteredBy = '' ;
		this.enteredDate = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.uomCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.logisticOrderNumber = '' ;
		this.logisticOrderReceiptNumber = '' ;
		this.purchaseOrderNumber = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.shippedLineDetailsTrackBeans = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.DailyInventoryShippedLineDetailsTrackBean */
export class DailyInventoryShippedLineDetailsTrackBean {
	constructor() {
		this.trackNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.remarks = '' ;
		this.updateProcess = '' ;
		this.updateEntityCode = '' ;
		this.updateEntityType = '' ;
		this.updateEntityLineNumber = 0 ;
		this.enteredBy = '' ;
		this.enteredDate = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.companyCode = '' ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.referenceEntityType = '' ;
		this.referenceEntityNumber = '' ;
		this.uomCode = '' ;
		this.currencyCode = '' ;
		this.onHandQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.cost = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.batchBarCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.rollBarCode = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.receivedDate = '' ;
		this.isPickedFlag = false ;
		this.cancelledPickTicketNumber = '' ;
		this.cancelledInvoiceNumber = '' ;
		this.isCloseOutInventory = false ;
		this.isNewlyAddedToInventory = false ;
		this.infoText = '' ;
		this.aisleInfoText = '' ;
		this.lastPhysicalInventoryVerificationDate = '' ;
		this.reserveCustomerCode = '' ;
		this.reserveCustomerName = '' ;
		this.fobCost = 0 ;
		this.landedCost = 0 ;
		this.vendorSkuNumber = '' ;
		this.containerNumber = '' ;
		this.etaDate = '' ;
		this.businessDivision = '' ;
		this.billOfLading = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.vendorFactoryCode = '' ;
		this.shade = '' ;
		this.displayRollNumber = '' ;
		this.logisticOrderNumber = '' ;
		this.logisticOrderReceiptNumber = '' ;
		this.totalArea = '' ;
		this.numberOfPallets = 0 ;
		this.upcNumberBarCode = '' ;
		this.oldSystemRollSkuNumber = '' ;
		this.warehousePurchaseOrderNumber = '' ;
		this.customerReferenceNumber = '' ;
		this.palletNumber = '' ;
		this.imeiNumber = '' ;
		this.projectNumber = '' ;
		this.holdingDate = '' ;
		this.expirationDate = '' ;
		this.holdingNumber = '' ;
		this.holdingCustomerCode = '' ;
		this.expirationTime = '' ;
		this.isHoldingInventory = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.DailyInventoryTrackBean */
export class DailyInventoryTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.closingBalance = 0 ;
		this.openingBalance = 0 ;
		this.receivedQuantity = 0 ;
		this.adjustedQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.remarks = '' ;
		this.updateProcess = '' ;
		this.updateEntityCode = '' ;
		this.updateEntityType = '' ;
		this.enteredBy = '' ;
		this.enteredDate = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.uomCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.receivedDetailsTrackBeans = new Array() ;
		this.adjustedDetailsTrackBeans = new Array() ;
		this.shippedDetailsTrackBeans = new Array() ;
		this.processTrackBeans = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.FabricStyleInventoryAdjustmentBean */
export class FabricStyleInventoryAdjustmentBean {
	constructor() {
		this.companyCode = '' ;
		this.documentNumber = '' ;
		this.documentType = '' ;
		this.locationCode = '' ;
		this.remarks = '' ;
		this.adjustmentReason = '' ;
		this.status = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.adjustmentLines = new Array() ;
		this.adjustmentNewLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.FabricStyleInventoryAdjustmentLineBean */
export class FabricStyleInventoryAdjustmentLineBean {
	constructor() {
		this.companyCode = '' ;
		this.adjustmentCode = '' ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleShortName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.locationCode = '' ;
		this.quantity = 0 ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.binLocation = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.rollSkuOnHandQuantity = 0 ;
		this.originalPurchaseOrderNumber = '' ;
		this.originalPurchaseReceiptNumber = '' ;
		this.originalReceivedQuantity = 0 ;
		this.originalReceivedDate = '' ;
		this.isCloseOutInventory = false ;
		this.reserveCustomerCode = '' ;
		this.reserveCustomerName = '' ;
		this.serialNumber = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.FabricStyleInventoryAdjustmentNewLineBean */
export class FabricStyleInventoryAdjustmentNewLineBean {
	constructor() {
		this.companyCode = '' ;
		this.adjustmentCode = '' ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleShortName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.locationCode = '' ;
		this.quantity = 0 ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.rollSkuOnHandQuantity = 0 ;
		this.originalPurchaseOrderNumber = '' ;
		this.originalPurchaseReceiptNumber = '' ;
		this.originalReceivedQuantity = 0 ;
		this.originalReceivedDate = '' ;
		this.binLocation = '' ;
		this.infoText = '' ;
		this.oldSystemSkuNumber = '' ;
		this.reserveCustomerCode = '' ;
		this.reserveCustomerName = '' ;
		this.serialNumber = '' ;
		this.isCloseOutInventory = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.FabricStyleInventoryDataBean */
export class FabricStyleInventoryDataBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.totalOnHandQuantity = 0 ;
		this.containerNumber = '' ;
		this.warehousePurchaseOrderNumber = '' ;
		this.customerReferenceNumber = '' ;
		this.palletNumber = '' ;
		this.imeiNumber = '' ;
		this.projectNumber = '' ;
		this.inventoryDataDetails = new Array() ;
	}
}
/* ds.inventory.FabricStyleInventoryDataDetailBean */
export class FabricStyleInventoryDataDetailBean {
	constructor() {
		this.locationCode = '' ;
		this.onHandQuantity = 0 ;
	}
}
/* ds.inventory.FabricStyleInventoryForLotBasedDataBean */
export class FabricStyleInventoryForLotBasedDataBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.lotNumber = '' ;
		this.uomCode = '' ;
		this.totalOnHandQuantity = 0 ;
		this.locationCode = '' ;
		this.upcNumber = '' ;
		this.customerCode = '' ;
		this.totalArea = '' ;
		this.numberOfPallets = 0 ;
		this.numberOfRolls = 0 ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.inventoryDataDetails = new Array() ;
	}
}
/* ds.inventory.FabricStyleInventoryForLotBasedDataDetailBean */
export class FabricStyleInventoryForLotBasedDataDetailBean {
	constructor() {
		this.rollSkuNumber = 0 ;
		this.binLocation = '' ;
		this.rollNumber = '' ;
		this.batchNumber = '' ;
		this.locationCode = '' ;
		this.onHandQuantity = 0 ;
		this.upcNumber = '' ;
		this.containerNumber = '' ;
		this.warehousePurchaseOrderNumber = '' ;
		this.customerReferenceNumber = '' ;
		this.palletNumber = '' ;
		this.imeiNumber = '' ;
		this.projectNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.receivedDate = '' ;
	}
}
/* ds.inventory.FabricStyleInventoryForLotBasedResultBean */
export class FabricStyleInventoryForLotBasedResultBean {
	constructor() {
		this.skuInventoryDataDetails = new Array() ;
	}
}
/* ds.inventory.FabricStyleInventoryResultBean */
export class FabricStyleInventoryResultBean {
	constructor() {
		this.skuInventoryDataDetails = new Array() ;
	}
}
/* ds.inventory.FabricStyleSkuBatchInventoryDataBean */
export class FabricStyleSkuBatchInventoryDataBean {
	constructor() {
		this.companyCode = '' ;
		this.locationCode = '' ;
		this.totalOnHandQuantity = 0 ;
		this.totalNoOfRolls = 0 ;
	}
}
/* ds.inventory.FabricStyleSkuBatchInventoryDataDetailBean */
export class FabricStyleSkuBatchInventoryDataDetailBean {
	constructor() {
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.onHandQuantity = 0 ;
		this.noOfRolls = 0 ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.vendorBatchNumber = '' ;
	}
}
/* ds.inventory.FabricStyleSkuBatchInventoryDataResultBean */
export class FabricStyleSkuBatchInventoryDataResultBean {
	constructor() {
		this.batchInventoryDatas = new Array() ;
	}
}
/* ds.inventory.FabricStyleSkuInventoryDataBean */
export class FabricStyleSkuInventoryDataBean {
	constructor() {
		this.locationCode = '' ;
		this.skuInventoryDataDetails = new Array() ;
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.totalOnHandQuantity = 0 ;
		this.containerNumber = '' ;
		this.warehousePurchaseOrderNumber = '' ;
		this.customerReferenceNumber = '' ;
		this.palletNumber = '' ;
		this.imeiNumber = '' ;
		this.projectNumber = '' ;
		this.inventoryDataDetails = new Array() ;
	}
}
/* ds.inventory.FabricStyleSkuInventoryDataDetailBean */
export class FabricStyleSkuInventoryDataDetailBean {
	constructor() {
		this.rollNumber = '' ;
		this.locationCode = '' ;
		this.onHandQuantity = 0 ;
	}
}
/* ds.inventory.InventoryAdjustmentElectronicInputBean */
export class InventoryAdjustmentElectronicInputBean {
	constructor() {
		this.adjustmentCode = '' ;
		this.Lines = new Array() ;
	}
}
/* ds.inventory.InventoryElectronicLinesInputBean */
export class InventoryElectronicLinesInputBean {
	constructor() {
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.rollNumber = '' ;
		this.lotNumber = '' ;
		this.boxNumber = '' ;
		this.quantity = 0 ;
		this.uom = '' ;
		this.binLocation = '' ;
		this.warehouse = '' ;
		this.skuNumber = 0 ;
		this.widthCode = '' ;
		this.rollSkuNumber = 0 ;
		this.toWarehouse = '' ;
	}
}
/* ds.inventory.InventoryLocationTransferBean */
export class InventoryLocationTransferBean {
	constructor() {
		this.companyCode = '' ;
		this.documentNumber = '' ;
		this.documentType = '' ;
		this.remarks = '' ;
		this.transferReason = '' ;
		this.status = '' ;
		this.fromLocationCode = '' ;
		this.toLocationCode = '' ;
		this.transferLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.InventoryLocationTransferElectronicInputBean */
export class InventoryLocationTransferElectronicInputBean {
	constructor() {
		this.transferCode = '' ;
		this.Lines = new Array() ;
	}
}
/* ds.inventory.InventoryLocationTransferLineBean */
export class InventoryLocationTransferLineBean {
	constructor() {
		this.companyCode = '' ;
		this.transferCode = '' ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleShortName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.transferQuantity = 0 ;
		this.fromLocationCode = '' ;
		this.toLocationCode = '' ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.originalPurchaseOrderNumber = '' ;
		this.originalPurchaseReceiptNumber = '' ;
		this.originalReceivedQuantity = 0 ;
		this.originalReceivedDate = '' ;
		this.isCloseOutInventory = false ;
		this.reserveCustomerCode = '' ;
		this.reserveCustomerName = '' ;
		this.fobCost = 0 ;
		this.landedCost = 0 ;
		this.vendorSkuNumber = '' ;
		this.containerNumber = '' ;
		this.etaDate = '' ;
		this.aisleInfoText = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.InventorySummaryDataBean */
export class InventorySummaryDataBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.numberOfRolls = 0 ;
		this.numberOfBins = 0 ;
		this.aisleInfoText = '' ;
		this.binNumbers = '' ;
		this.rollSkuNumber = 0 ;
	}
}
/* ds.inventory.ItemCatalogInventoryPrintInputBean */
export class ItemCatalogInventoryPrintInputBean {
	constructor() {
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleImagePath = '' ;
		this.fabricStyleColorImagePath = '' ;
		this.atsQuantity = 0 ;
		this.uomCode = '' ;
	}
}
/* ds.inventory.MassInventoryLocationTransferBean */
export class MassInventoryLocationTransferBean {
	constructor() {
		this.count = 0 ;
		this.transferList = new Array() ;
	}
}
/* ds.inventory.merge.response.FabricStyleInventoryAdjustmentModuleMergeResponseBean */
export class FabricStyleInventoryAdjustmentModuleMergeResponseBean {
	constructor() {
		this.inventoryAdjustmentResponseBean = null ;
		this.lockResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.merge.response.InventoryLocationTransferModuleMergeResponseBean */
export class InventoryLocationTransferModuleMergeResponseBean {
	constructor() {
		this.inventoryLocationTransferResponseBean = null ;
		this.lockResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.MonthlySKUBatchInventoryHistoryBean */
export class MonthlySKUBatchInventoryHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.date = '' ;
		this.month = '' ;
		this.year = '' ;
		this.valuationCurrencyCode = '' ;
		this.valuationCost = 0 ;
		this.referenceEntityType = '' ;
		this.referenceEntityNumber = '' ;
		this.uomCode = '' ;
		this.currencyCode = '' ;
		this.onHandQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.cost = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.batchBarCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.rollBarCode = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.receivedDate = '' ;
		this.isPickedFlag = false ;
		this.cancelledPickTicketNumber = '' ;
		this.cancelledInvoiceNumber = '' ;
		this.isCloseOutInventory = false ;
		this.isNewlyAddedToInventory = false ;
		this.infoText = '' ;
		this.aisleInfoText = '' ;
		this.lastPhysicalInventoryVerificationDate = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.MonthlySKUInventoryHistoryBean */
export class MonthlySKUInventoryHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.onHandQuantity = 0 ;
		this.uomCode = '' ;
		this.date = '' ;
		this.month = '' ;
		this.year = '' ;
		this.valuationCurrencyCode = '' ;
		this.valuationCost = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.pagelist.FabricStyleInventoryAdjustmentPageListBean */
export class FabricStyleInventoryAdjustmentPageListBean {
	constructor() {
		this.fabricStyleInventoryAdjustments = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inventory.pagelist.FabricStyleInventoryDataPageListBean */
export class FabricStyleInventoryDataPageListBean {
	constructor() {
		this.fabricStyleInventoryDatas = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inventory.pagelist.InventoryLocationTransferPageListBean */
export class InventoryLocationTransferPageListBean {
	constructor() {
		this.inventoryLocationTransfers = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inventory.pagelist.PhysicalInventoryAdjustmentPageListBean */
export class PhysicalInventoryAdjustmentPageListBean {
	constructor() {
		this.physicalInventoryAdjustments = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inventory.pagelist.response.FabricStyleInventoryAdjustmentPageListResponseBean */
export class FabricStyleInventoryAdjustmentPageListResponseBean {
	constructor() {
		this.fabricStyleInventoryAdjustmentPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.pagelist.response.FabricStyleInventoryDataPageListResponseBean */
export class FabricStyleInventoryDataPageListResponseBean {
	constructor() {
		this.fabricStyleInventoryDataPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.pagelist.response.InventoryLocationTransferPageListResponseBean */
export class InventoryLocationTransferPageListResponseBean {
	constructor() {
		this.inventoryLocationTransferPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.pagelist.response.PhysicalInventoryAdjustmentPageListResponseBean */
export class PhysicalInventoryAdjustmentPageListResponseBean {
	constructor() {
		this.physicalInventoryAdjustmentPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.pagelist.response.SkuBatchInventoryDataPageListResponseBean */
export class SkuBatchInventoryDataPageListResponseBean {
	constructor() {
		this.batchInventoryDataPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.pagelist.response.SKUBatchInventoryPageListResponseBean */
export class SKUBatchInventoryPageListResponseBean {
	constructor() {
		this.skuBatchInventoryPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.pagelist.response.SKUBatchInventoryTrackPageListResponseBean */
export class SKUBatchInventoryTrackPageListResponseBean {
	constructor() {
		this.inventoryTrackPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.pagelist.response.SKUInventoryPageListResponseBean */
export class SKUInventoryPageListResponseBean {
	constructor() {
		this.inventoryPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.pagelist.response.SKUInventoryTrackPageListResponseBean */
export class SKUInventoryTrackPageListResponseBean {
	constructor() {
		this.inventoryTrackPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.pagelist.response.SKUInventoryTrackSummaryProcessPageListResponseBean */
export class SKUInventoryTrackSummaryProcessPageListResponseBean {
	constructor() {
		this.skuBatchTrackSummaryProcessPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.pagelist.response.WebSkuInventoryPageListResponseBean */
export class WebSkuInventoryPageListResponseBean {
	constructor() {
		this.inventoryPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.pagelist.SkuBatchInventoryDataPageListBean */
export class SkuBatchInventoryDataPageListBean {
	constructor() {
		this.batchInventoryDatas = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inventory.pagelist.SKUBatchInventoryPageListBean */
export class SKUBatchInventoryPageListBean {
	constructor() {
		this.skuBatchInventories = new Array() ;
		this.totalNumberOfpallets = 0 ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inventory.pagelist.SKUBatchInventoryPhysicalVerificationTrackPageListBean */
export class SKUBatchInventoryPhysicalVerificationTrackPageListBean {
	constructor() {
		this.physicalVerificationTracks = new Array() ;
	}
}
/* ds.inventory.pagelist.SKUBatchInventoryTrackPageListBean */
export class SKUBatchInventoryTrackPageListBean {
	constructor() {
		this.skuBatchInventoryTracks = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inventory.pagelist.SKUInventoryPageListBean */
export class SKUInventoryPageListBean {
	constructor() {
		this.skuInventories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inventory.pagelist.SKUInventoryTrackPageListBean */
export class SKUInventoryTrackPageListBean {
	constructor() {
		this.skuInventoryTracks = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inventory.pagelist.SKUInventoryTrackSummaryProcessPageListBean */
export class SKUInventoryTrackSummaryProcessPageListBean {
	constructor() {
		this.skuInventoryTrackSummaryProcesses = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inventory.pagelist.WebSkuInventoryPageListBean */
export class WebSkuInventoryPageListBean {
	constructor() {
		this.count = 0 ;
		this.webSkuInventories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.inventory.PhysicalInventoryAdjustmentBean */
export class PhysicalInventoryAdjustmentBean {
	constructor() {
		this.companyCode = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.remarks = '' ;
		this.notes = '' ;
		this.inventoryAdjustmentNumber = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.includeHoldingWarehouse = false ;
		this.binLocations = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.PhysicalInventoryAdjustmentBinLocationBean */
export class PhysicalInventoryAdjustmentBinLocationBean {
	constructor() {
		this.companyCode = '' ;
		this.physicalInventoryAdjustmentNumber = '' ;
		this.lineNumber = 0 ;
		this.physicalInventoryQuantity = 0 ;
		this.missingInventoryQuantity = 0 ;
		this.binLocation = '' ;
		this.totalPhysicalInventoryRolls = 0 ;
		this.totalMissingInventoryRolls = 0 ;
		this.totalInventoryRolls = 0 ;
		this.totalInventoryQuantity = 0 ;
		this.isAdjustUnAvailable = false ;
		this.uomCode = '' ;
		this.physicalInventories = new Array() ;
		this.missingInventories = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.PhysicalInventoryAdjustmentMissingInventoryBean */
export class PhysicalInventoryAdjustmentMissingInventoryBean {
	constructor() {
		this.companyCode = '' ;
		this.physicalInventoryAdjustmentNumber = '' ;
		this.binLocationLineNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.uomCode = '' ;
		this.currencyCode = '' ;
		this.onHandQuantity = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.batchBarCode = '' ;
		this.rollBarCode = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.binLocation = '' ;
		this.lastPhysicalInventoryVerificationDate = '' ;
		this.isAdjustUnAvailable = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.PhysicalInventoryAdjustmentPhysicalInventoryBean */
export class PhysicalInventoryAdjustmentPhysicalInventoryBean {
	constructor() {
		this.companyCode = '' ;
		this.physicalInventoryAdjustmentNumber = '' ;
		this.rollSkuNumber = 0 ;
		this.binLocationLineNumber = 0 ;
		this.rollNumber = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.uomCode = '' ;
		this.currencyCode = '' ;
		this.onHandQuantity = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.batchBarCode = '' ;
		this.rollBarCode = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.binLocation = '' ;
		this.lastPhysicalInventoryVerificationDate = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.PickTicketRollSkuLabelPrintInputBean */
export class PickTicketRollSkuLabelPrintInputBean {
	constructor() {
		this.rollLines = new Array() ;
		this.skuInventories = new Array() ;
	}
}
/* ds.inventory.ReceiptBinSummaryDataResultBean */
export class ReceiptBinSummaryDataResultBean {
	constructor() {
		this.count = 0 ;
		this.receivedBinDataBean = new Array() ;
		this.rollDetails = new Array() ;
	}
}
/* ds.inventory.response.BinDataResponseBean */
export class BinDataResponseBean {
	constructor() {
		this.binInfoBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.response.FabricStyleInventoryAdjustmentResponseBean */
export class FabricStyleInventoryAdjustmentResponseBean {
	constructor() {
		this.inventoryAdjustmentBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.response.FabricStyleInventoryForLotBasedResultResponseBean */
export class FabricStyleInventoryForLotBasedResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.response.FabricStyleInventoryResultResponseBean */
export class FabricStyleInventoryResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.response.FabricStyleSkuBatchInventoryDataResultResponseBean */
export class FabricStyleSkuBatchInventoryDataResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.response.InventoryElectronicDataResponse */
export class InventoryElectronicDataResponse {
	constructor() {
		this.eInput = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.response.InventoryLocationTransferResponseBean */
export class InventoryLocationTransferResponseBean {
	constructor() {
		this.inventoryLocationTransferBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.response.InventoryTransferElectronicDataResponse */
export class InventoryTransferElectronicDataResponse {
	constructor() {
		this.eInput = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.response.MassInventoryLocationTransferResponseBean */
export class MassInventoryLocationTransferResponseBean {
	constructor() {
		this.count = 0 ;
		this.inventoryLocationTransferBean = new Array() ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.response.PhysicalInventoryAdjustmentMergeResponseBean */
export class PhysicalInventoryAdjustmentMergeResponseBean {
	constructor() {
		this.lockResponse = null ;
		this.physicalInventoryResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.response.PhysicalInventoryAdjustmentResponseBean */
export class PhysicalInventoryAdjustmentResponseBean {
	constructor() {
		this.physicalInventoryAdjustment = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.response.SkuBatchInventoryDataResultResponseBean */
export class SkuBatchInventoryDataResultResponseBean {
	constructor() {
		this.batchInventoryDataResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.response.SKUBatchInventoryPhysicalVerificationTrackResponseBean */
export class SKUBatchInventoryPhysicalVerificationTrackResponseBean {
	constructor() {
		this.physicalVerificationPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.response.SKUBatchInventoryResponseBean */
export class SKUBatchInventoryResponseBean {
	constructor() {
		this.skuBatchInventoryBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.response.SKUBatchInventoryResultListResponseBean */
export class SKUBatchInventoryResultListResponseBean {
	constructor() {
		this.skuBatchInventories = new Array() ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.response.SkuBatchInventorySummaryResultResponseBean */
export class SkuBatchInventorySummaryResultResponseBean {
	constructor() {
		this.skuBatchSummaryResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.response.SKUInventoryResponseBean */
export class SKUInventoryResponseBean {
	constructor() {
		this.skuInventoryBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.inventory.SKUBatchInventoryBean */
export class SKUBatchInventoryBean {
	constructor() {
		this.companyCode = '' ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.referenceEntityType = '' ;
		this.referenceEntityNumber = '' ;
		this.uomCode = '' ;
		this.currencyCode = '' ;
		this.onHandQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.cost = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.batchBarCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.rollBarCode = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.receivedDate = '' ;
		this.isPickedFlag = false ;
		this.cancelledPickTicketNumber = '' ;
		this.cancelledInvoiceNumber = '' ;
		this.isCloseOutInventory = false ;
		this.isNewlyAddedToInventory = false ;
		this.infoText = '' ;
		this.aisleInfoText = '' ;
		this.lastPhysicalInventoryVerificationDate = '' ;
		this.reserveCustomerCode = '' ;
		this.reserveCustomerName = '' ;
		this.fobCost = 0 ;
		this.landedCost = 0 ;
		this.vendorSkuNumber = '' ;
		this.containerNumber = '' ;
		this.etaDate = '' ;
		this.businessDivision = '' ;
		this.billOfLading = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.vendorFactoryCode = '' ;
		this.shade = '' ;
		this.displayRollNumber = '' ;
		this.logisticOrderNumber = '' ;
		this.logisticOrderReceiptNumber = '' ;
		this.totalArea = '' ;
		this.numberOfPallets = 0 ;
		this.upcNumberBarCode = '' ;
		this.oldSystemRollSkuNumber = '' ;
		this.warehousePurchaseOrderNumber = '' ;
		this.customerReferenceNumber = '' ;
		this.palletNumber = '' ;
		this.imeiNumber = '' ;
		this.projectNumber = '' ;
		this.holdingDate = '' ;
		this.expirationDate = '' ;
		this.holdingNumber = '' ;
		this.holdingCustomerCode = '' ;
		this.expirationTime = '' ;
		this.isHoldingInventory = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.SkuBatchInventoryDataBean */
export class SkuBatchInventoryDataBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.totalOnHandQuantity = 0 ;
		this.totalNumberOfRolls = 0 ;
		this.inventoryDataDetails = new Array() ;
	}
}
/* ds.inventory.SkuBatchInventoryDataDetailBean */
export class SkuBatchInventoryDataDetailBean {
	constructor() {
		this.locationCode = '' ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.onHandQuantity = 0 ;
		this.totalReceivedQuantity = 0 ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.aisleInfoText = '' ;
	}
}
/* ds.inventory.SkuBatchInventoryDataResultBean */
export class SkuBatchInventoryDataResultBean {
	constructor() {
		this.batchInventoryDataBean = null ;
	}
}
/* ds.inventory.SKUBatchInventoryPhysicalVerificationTrackBean */
export class SKUBatchInventoryPhysicalVerificationTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.locationCode = '' ;
		this.physicalVerificationLocationCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.onHandQuantity = 0 ;
		this.aisleInfoText = '' ;
		this.physicalInventoryVerificationDate = '' ;
		this.rollNumber = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.enteredBy = '' ;
		this.enteredDate = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.SKUBatchInventoryPrintInputBean */
export class SKUBatchInventoryPrintInputBean {
	constructor() {
		this.rollSkuNumber = 0 ;
		this.locationCode = '' ;
	}
}
/* ds.inventory.SKUBatchInventorySummaryBean */
export class SKUBatchInventorySummaryBean {
	constructor() {
		this.companyCode = '' ;
		this.locationCode = '' ;
		this.reserveCustomerCode = '' ;
		this.reserveCustomerName = '' ;
		this.totalNumberOfRolls = 0 ;
		this.totalYardage = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.SkuBatchInventorySummaryDataResultBean */
export class SkuBatchInventorySummaryDataResultBean {
	constructor() {
		this.count = 0 ;
		this.inventorySummaryBean = new Array() ;
		this.inventoryBinSummaryDatas = new Array() ;
	}
}
/* ds.inventory.SKUBatchInventoryTrackBean */
export class SKUBatchInventoryTrackBean {
	constructor() {
		this.trackNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.changeOnHandQuantity = 0 ;
		this.changeOnReceivedQuantity = 0 ;
		this.previousOnHandQuantity = 0 ;
		this.previousOnReceivedQuantity = 0 ;
		this.remarks = '' ;
		this.updateProcess = '' ;
		this.updateEntityCode = '' ;
		this.updateEntityType = '' ;
		this.updateEntityLineNumber = 0 ;
		this.enteredBy = '' ;
		this.enteredDate = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.companyCode = '' ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.referenceEntityType = '' ;
		this.referenceEntityNumber = '' ;
		this.uomCode = '' ;
		this.currencyCode = '' ;
		this.onHandQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.cost = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.batchBarCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.rollBarCode = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.receivedDate = '' ;
		this.isPickedFlag = false ;
		this.cancelledPickTicketNumber = '' ;
		this.cancelledInvoiceNumber = '' ;
		this.isCloseOutInventory = false ;
		this.isNewlyAddedToInventory = false ;
		this.infoText = '' ;
		this.aisleInfoText = '' ;
		this.lastPhysicalInventoryVerificationDate = '' ;
		this.reserveCustomerCode = '' ;
		this.reserveCustomerName = '' ;
		this.fobCost = 0 ;
		this.landedCost = 0 ;
		this.vendorSkuNumber = '' ;
		this.containerNumber = '' ;
		this.etaDate = '' ;
		this.businessDivision = '' ;
		this.billOfLading = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.vendorFactoryCode = '' ;
		this.shade = '' ;
		this.displayRollNumber = '' ;
		this.logisticOrderNumber = '' ;
		this.logisticOrderReceiptNumber = '' ;
		this.totalArea = '' ;
		this.numberOfPallets = 0 ;
		this.upcNumberBarCode = '' ;
		this.oldSystemRollSkuNumber = '' ;
		this.warehousePurchaseOrderNumber = '' ;
		this.customerReferenceNumber = '' ;
		this.palletNumber = '' ;
		this.imeiNumber = '' ;
		this.projectNumber = '' ;
		this.holdingDate = '' ;
		this.expirationDate = '' ;
		this.holdingNumber = '' ;
		this.holdingCustomerCode = '' ;
		this.expirationTime = '' ;
		this.isHoldingInventory = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.SKUInventoryBean */
export class SKUInventoryBean {
	constructor() {
		this.companyCode = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.onHandQuantity = 0 ;
		this.uomCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.SKUInventoryTrackBean */
export class SKUInventoryTrackBean {
	constructor() {
		this.trackNumber = 0 ;
		this.changeOnHandQuantity = 0 ;
		this.previousOnHandQuantity = 0 ;
		this.remarks = '' ;
		this.updateProcess = '' ;
		this.updateEntityCode = '' ;
		this.updateEntityType = '' ;
		this.updateEntityLineNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.enteredBy = '' ;
		this.enteredDate = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.companyCode = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.onHandQuantity = 0 ;
		this.uomCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.SKUInventoryTrackSummaryProcessBean */
export class SKUInventoryTrackSummaryProcessBean {
	constructor() {
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.skuNumber = 0 ;
		this.entityTypeCode = '' ;
		this.entityNumber = '' ;
		this.entityName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.uomCode = '' ;
		this.previousOnHandQuantity = 0 ;
		this.currentProcessedQuantity = 0 ;
		this.changeOnHandQuantity = 0 ;
		this.enteredBy = '' ;
		this.enteredDate = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.remarks = '' ;
		this.locationCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.inventory.WebSKUInventoryBean */
export class WebSKUInventoryBean {
	constructor() {
		this.companyCode = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.webOnHandQuantity = 0 ;
		this.uomCode = '' ;
		this.externalItemCode = '' ;
		this.externalItemSku = '' ;
		this.updatedFlag = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.LogicConstants */
export class LogicConstants {
	constructor() {
	}
}
/* ds.login.PortalCustomerLoginResponseBean */
export class PortalCustomerLoginResponseBean {
	constructor() {
		this.sessionBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.logistic.criteria.LogisticOrderLineAdjustmentTrackInquiryCriteriaBean */
export class LogisticOrderLineAdjustmentTrackInquiryCriteriaBean {
	constructor() {
		this.logisticOrderNumber = '' ;
		this.companyCode = '' ;
	}
}
/* ds.logistic.criteria.LogisticOrderLineSearchCriteria */
export class LogisticOrderLineSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderNumber = '' ;
		this.fromOrderStopDate = '' ;
		this.toOrderStopDate = '' ;
		this.customerCode = '' ;
		this.fabricStyleCode = '' ;
		this.lineStatus = '' ;
		this.orderStatus = '' ;
		this.orderDate = '' ;
		this.fromOrderStartDate = '' ;
		this.toOrderStartDate = '' ;
		this.lineNumber = 0 ;
	}
}
/* ds.logistic.criteria.LogisticOrderSearchCriteria */
export class LogisticOrderSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderNumber = '' ;
		this.createdDate = '' ;
		this.orderDate = '' ;
		this.customerCode = '' ;
		this.orderStatus = '' ;
		this.orderStatusList = new Array() ;
		this.incoterm = '' ;
		this.orderStopDateFrom = '' ;
		this.orderStopDateTo = '' ;
		this.logisticOrderNumberContains = '' ;
		this.logisticOrderNumberStartsWith = '' ;
		this.fabricStyleCode = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.customerName = '' ;
		this.etaDate = '' ;
		this.locationCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.logisticOrderNumbers = new Array() ;
		this.customerList = new Array() ;
		this.searchName = '' ;
		this.containerNumber = '' ;
	}
}
/* ds.logistic.deps.LogisticOrderModuleDependenciesBean */
export class LogisticOrderModuleDependenciesBean {
	constructor() {
		this.adjustmentTracks = new Array() ;
		this.fabricStyles = new Array() ;
	}
}
/* ds.logistic.deps.response.LogisticOrderModuleDependenciesResponseBean */
export class LogisticOrderModuleDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.logistic.history.LogisticOrderDateHistoryTrackBean */
export class LogisticOrderDateHistoryTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderNumber = '' ;
		this.dateType = '' ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.logistic.history.LogisticOrderElementHistoryBean */
export class LogisticOrderElementHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderNumber = '' ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.logistic.history.LogisticOrderLineElementHistoryBean */
export class LogisticOrderLineElementHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderNumber = '' ;
		this.lineNumber = 0 ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.logistic.history.pagelist.LogisticOrderElementHistoryPageListBean */
export class LogisticOrderElementHistoryPageListBean {
	constructor() {
		this.histories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.logistic.history.pagelist.LogisticOrderLineElementHistoryPageListBean */
export class LogisticOrderLineElementHistoryPageListBean {
	constructor() {
		this.histories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.logistic.LogisticOrderBean */
export class LogisticOrderBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.currencyCode = '' ;
		this.orderDate = '' ;
		this.orderStatus = '' ;
		this.address = null ;
		this.locationCode = '' ;
		this.logisticOrderTotalQuantity = 0 ;
		this.businessDivision = '' ;
		this.customerReferenceNumber = '' ;
		this.containerNumber = '' ;
		this.uomCode = '' ;
		this.expectedReceivedDate = '' ;
		this.expectedReceivedTime = '' ;
		this.totalNumberOfPallets = 0 ;
		this.warehousePurchaseOrderNumber = '' ;
		this.projectNumber = '' ;
		this.lines = new Array() ;
		this.statusTracks = new Array() ;
		this.changeHistoryTracks = new Array() ;
		this.communicationNotes = new Array() ;
		this.logisticOrderDocuments = new Array() ;
		this.orderImages = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.logistic.LogisticOrderChangeHistoryBean */
export class LogisticOrderChangeHistoryBean {
	constructor() {
		this.logisticOrderNumber = '' ;
		this.trackNumber = 0 ;
		this.companyCode = '' ;
		this.workStationCode = '' ;
		this.workStationIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.logistic.LogisticOrderCommunicationNotesBean */
export class LogisticOrderCommunicationNotesBean {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderNumber = '' ;
		this.lineNumber = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.logistic.LogisticOrderDocumentBean */
export class LogisticOrderDocumentBean {
	constructor() {
		this.logisticOrderNumber = '' ;
		this.companyCode = '' ;
		this.documentOriginalName = '' ;
		this.documentNumber = 0 ;
		this.documentCode = '' ;
		this.documentPath = '' ;
		this.documentName = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.logistic.LogisticOrderImageBean */
export class LogisticOrderImageBean {
	constructor() {
		this.logisticOrderNumber = '' ;
		this.imageCode = '' ;
		this.imagePart = '' ;
		this.imagePath = '' ;
		this.imageName = '' ;
		this.companyCode = '' ;
		this.imageOritinalname = '' ;
		this.tags = '' ;
		this.notesCommunication = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.logistic.LogisticOrderLineAdjustmentBean */
export class LogisticOrderLineAdjustmentBean {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderNumber = '' ;
		this.lineNumber = 0 ;
		this.adjustmentLineNumber = 0 ;
		this.adjustedQuantity = 0 ;
		this.adjustmentType = '' ;
		this.uomCode = '' ;
		this.lineStatus = '' ;
		this.remarks = '' ;
		this.orderStatus = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.logistic.LogisticOrderLineAdjustmentTrackBean */
export class LogisticOrderLineAdjustmentTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderNumber = '' ;
		this.lineNumber = 0 ;
		this.adjustmentLineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.upcCode = '' ;
		this.uomCode = '' ;
		this.orderStatus = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.openBalance = 0 ;
		this.changedUnits = 0 ;
		this.closeBalance = 0 ;
		this.trackType = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.logistic.LogisticOrderLineBean */
export class LogisticOrderLineBean {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderNumber = '' ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.lineStatus = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.upcCode = '' ;
		this.uomCode = '' ;
		this.openQuantity = 0 ;
		this.orderQuantity = 0 ;
		this.adjustedQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.receivedAdjustedQuantity = 0 ;
		this.locationCode = '' ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = 0 ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.numberOfPallets = 0 ;
		this.adjustmentLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.logistic.LogisticOrderStatusTrackBean */
export class LogisticOrderStatusTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderNumber = '' ;
		this.totalOrderQuantity = 0 ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.logistic.merge.response.LogisticOrderMergeOperationsResponseBean */
export class LogisticOrderMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.lockResponse = null ;
		this.reportResult = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.logistic.merge.response.LogisticOrderModuleMergeResponseBean */
export class LogisticOrderModuleMergeResponseBean {
	constructor() {
		this.logisticOrderResponse = null ;
		this.lockResponse = null ;
		this.dependenciesResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.logistic.pagelist.LogisticOrderLineAdjustmentTrackPageListBean */
export class LogisticOrderLineAdjustmentTrackPageListBean {
	constructor() {
		this.adjustmentTracks = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.logistic.pagelist.LogisticOrderLinePageListBean */
export class LogisticOrderLinePageListBean {
	constructor() {
		this.logisticOrderLines = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.logistic.pagelist.LogisticOrderPageListBean */
export class LogisticOrderPageListBean {
	constructor() {
		this.logisticOrders = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.logistic.pagelist.response.LogisticOrderLinePageListResponseBean */
export class LogisticOrderLinePageListResponseBean {
	constructor() {
		this.logisticOrderLinePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.logistic.pagelist.response.LogisticOrderPageListResponseBean */
export class LogisticOrderPageListResponseBean {
	constructor() {
		this.logisticOrderPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.logistic.receipt.criteria.LogisticOrderReceiptLineSearchCriteria */
export class LogisticOrderReceiptLineSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderNumber = '' ;
		this.logisticOrderLineNumber = 0 ;
		this.isApproved = false ;
		this.logisticOrderReceiptNumber = '' ;
		this.logisticOrderReceiptLineNumber = 0 ;
	}
}
/* ds.logistic.receipt.criteria.LogisticOrderReceiptSearchCriteria */
export class LogisticOrderReceiptSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderReceiptNumber = '' ;
		this.logisticOrderNumber = '' ;
		this.createdDate = '' ;
		this.receiptDate = '' ;
		this.customerCode = '' ;
		this.receiptStatus = '' ;
		this.receiptDateFrom = '' ;
		this.receiptDateTo = '' ;
		this.logisticOrderReceiptNumberStartsWith = '' ;
		this.logisticOrderReceiptNumberContains = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.searchName = '' ;
		this.containerNumber = '' ;
		this.customerList = new Array() ;
	}
}
/* ds.logistic.receipt.deps.LogisticOrderReceiptModuleDependenciesBean */
export class LogisticOrderReceiptModuleDependenciesBean {
	constructor() {
		this.logisticOrder = null ;
		this.fabricStyles = new Array() ;
		this.invoices = new Array() ;
	}
}
/* ds.logistic.receipt.deps.response.LogisticOrderReceiptModuleDependenciesResponseBean */
export class LogisticOrderReceiptModuleDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.logistic.receipt.history.LogisticOrderReceiptElementHistoryBean */
export class LogisticOrderReceiptElementHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderReceiptNumber = '' ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.logistic.receipt.history.LogisticOrderReceiptLineElementHistoryBean */
export class LogisticOrderReceiptLineElementHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderReceiptNumber = '' ;
		this.lineGroupNumber = 0 ;
		this.lineNumber = 0 ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.logistic.receipt.history.pagelist.LogisticOrderReceiptElementHistoryPageListBean */
export class LogisticOrderReceiptElementHistoryPageListBean {
	constructor() {
		this.histories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.logistic.receipt.history.pagelist.LogisticOrderReceiptLineElementHistoryPageListBean */
export class LogisticOrderReceiptLineElementHistoryPageListBean {
	constructor() {
		this.histories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.logistic.receipt.history.response.LogisticOrderReceiptElementHistoryPageListResponseBean */
export class LogisticOrderReceiptElementHistoryPageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.logistic.receipt.history.response.LogisticOrderReceiptLineElementHistoryPageListResponseBean */
export class LogisticOrderReceiptLineElementHistoryPageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.logistic.receipt.LogisticOrderReceiptBean */
export class LogisticOrderReceiptBean {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.receiptDate = '' ;
		this.receiptStatus = '' ;
		this.locationCode = '' ;
		this.badQualityLocationCode = '' ;
		this.containerNumber = '' ;
		this.billOfLading = '' ;
		this.comments = '' ;
		this.customerReferenceNumber = '' ;
		this.warehousePurchaseOrderNumber = '' ;
		this.projectNumber = '' ;
		this.dateOfManufacturing = '' ;
		this.expirationDate = '' ;
		this.lines = new Array() ;
		this.statusTracks = new Array() ;
		this.changeHistoryTracks = new Array() ;
		this.imageName = '' ;
		this.imageFilePath = '' ;
		this.documentName = '' ;
		this.documentFilePath = '' ;
		this.totalNumberOfPallets = 0 ;
		this.receiptImages = new Array() ;
		this.logisticOrderReceiptDocuments = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.logistic.receipt.LogisticOrderReceiptChangeHistoryBean */
export class LogisticOrderReceiptChangeHistoryBean {
	constructor() {
		this.logisticOrderReceiptNumber = '' ;
		this.trackNumber = 0 ;
		this.companyCode = '' ;
		this.workStationCode = '' ;
		this.workStationIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.logistic.receipt.LogisticOrderReceiptDetailInfoBean */
export class LogisticOrderReceiptDetailInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.purchaseOrderNumber = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.factoryCode = '' ;
		this.vendorStyleCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.locationCode = '' ;
		this.uomCode = '' ;
		this.packingSlipNumber = '' ;
		this.openOrderQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.receiptDate = '' ;
		this.receiptStatus = '' ;
		this.purchaseOrderDate = '' ;
	}
}
/* ds.logistic.receipt.LogisticOrderReceiptDocumentBean */
export class LogisticOrderReceiptDocumentBean {
	constructor() {
		this.logisticOrderReceiptNumber = '' ;
		this.companyCode = '' ;
		this.documentOriginalName = '' ;
		this.documentNumber = 0 ;
		this.documentCode = '' ;
		this.documentPath = '' ;
		this.documentName = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.logistic.receipt.LogisticOrderReceiptElectronicInputBean */
export class LogisticOrderReceiptElectronicInputBean {
	constructor() {
		this.logisticOrderNumber = '' ;
		this.receivedDate = '' ;
		this.totalQuantityText = '' ;
		this.rollLines = new Array() ;
	}
}
/* ds.logistic.receipt.LogisticOrderReceiptElectronicRollInputBean */
export class LogisticOrderReceiptElectronicRollInputBean {
	constructor() {
		this.inboundOrderNumber = '' ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.rollNumber = '' ;
		this.lotNumber = '' ;
		this.boxNumber = '' ;
		this.quantity = 0 ;
		this.infoText = '' ;
		this.aisleInfoText = '' ;
		this.upcCode = '' ;
		this.palletNumber = '' ;
		this.imeiNumber = '' ;
		this.projectNumber = '' ;
	}
}
/* ds.logistic.receipt.LogisticOrderReceiptImageBean */
export class LogisticOrderReceiptImageBean {
	constructor() {
		this.logisticOrderReceiptNumber = '' ;
		this.imageCode = '' ;
		this.imagePart = '' ;
		this.imagePath = '' ;
		this.imageName = '' ;
		this.companyCode = '' ;
		this.imageOritinalname = '' ;
		this.tags = '' ;
		this.notesCommunication = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.logistic.receipt.LogisticOrderReceiptLineBean */
export class LogisticOrderReceiptLineBean {
	constructor() {
		this.logisticOrderNumber = '' ;
		this.logisticOrderLineNumber = 0 ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.lineStatus = '' ;
		this.widthCode = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.upcCode = '' ;
		this.uomCode = '' ;
		this.companyCode = '' ;
		this.logisticOrderReceiptNumber = '' ;
		this.openOrderQuantity = 0 ;
		this.logisticOrderQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.receivedQuantityToDate = 0 ;
		this.goodQualityReceivedQuantity = 0 ;
		this.badQualityReceivedQuantity = 0 ;
		this.locationCode = '' ;
		this.comments = '' ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = 0 ;
		this.dateOfManufacturing = '' ;
		this.expirationDate = '' ;
		this.numberOfPallets = 0 ;
		this.receiptRollLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.logistic.receipt.LogisticOrderReceiptRollLineBean */
export class LogisticOrderReceiptRollLineBean {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderReceiptNumber = '' ;
		this.logisticRollLineNumber = 0 ;
		this.logisticLineNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.locationCode = '' ;
		this.locationType = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.widthCode = '' ;
		this.uomCode = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.receivedQuantity = 0 ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = 0 ;
		this.inventoryReceivedQuantity = 0 ;
		this.boxNumber = '' ;
		this.customerLotNumber = '' ;
		this.infoText = '' ;
		this.aisleInfoText = '' ;
		this.upcNumber = '' ;
		this.palletNumber = '' ;
		this.imeiNumber = '' ;
		this.projectNumber = '' ;
		this.containerNumber = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.logistic.receipt.LogisticOrderReceiptStatusTrackBean */
export class LogisticOrderReceiptStatusTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderReceiptNumber = '' ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.logistic.receipt.LogisticReceiptToInvoiceInputBean */
export class LogisticReceiptToInvoiceInputBean {
	constructor() {
		this.logisticReceipts = null ;
		this.serviceLines = new Array() ;
	}
}
/* ds.logistic.receipt.merge.response.LogisticOrderReceiptMergeOperationsResponseBean */
export class LogisticOrderReceiptMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.lockResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.logistic.receipt.merge.response.LogisticOrderReceiptModuleMergeResponseBean */
export class LogisticOrderReceiptModuleMergeResponseBean {
	constructor() {
		this.logisticOrderReceiptResponse = null ;
		this.lockResponse = null ;
		this.dependenciesResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.logistic.receipt.pagelist.LogisticOrderReceiptLinePageListBean */
export class LogisticOrderReceiptLinePageListBean {
	constructor() {
		this.logisticOrderReceiptLines = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.logistic.receipt.pagelist.LogisticOrderReceiptPageListBean */
export class LogisticOrderReceiptPageListBean {
	constructor() {
		this.logisticOrderReceipts = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.logistic.receipt.pagelist.response.LogisticOrderReceiptLinePageListResponseBean */
export class LogisticOrderReceiptLinePageListResponseBean {
	constructor() {
		this.logisticOrderReceiptLinePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.logistic.receipt.pagelist.response.LogisticOrderReceiptPageListResponseBean */
export class LogisticOrderReceiptPageListResponseBean {
	constructor() {
		this.logisticOrderReceiptPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.logistic.receipt.response.LogisticOrderReceiptElectronicInputResponseBean */
export class LogisticOrderReceiptElectronicInputResponseBean {
	constructor() {
		this.eInput = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.logistic.receipt.response.LogisticOrderReceiptInvoiceListResponseBean */
export class LogisticOrderReceiptInvoiceListResponseBean {
	constructor() {
		this.invoices = new Array() ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.logistic.receipt.response.LogisticOrderReceiptResponseBean */
export class LogisticOrderReceiptResponseBean {
	constructor() {
		this.logisticOrderReceipt = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.logistic.response.LogisticOrderResponseBean */
export class LogisticOrderResponseBean {
	constructor() {
		this.logisticOrder = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.BaseCustomerTypePriceBean */
export class BaseCustomerTypePriceBean {
	constructor() {
		this.customerTypeCode = '' ;
		this.uomCode = '' ;
		this.currencyCode = '' ;
		this.samplePrice = 0 ;
		this.price = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.BaseStatusTrackBean */
export class BaseStatusTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.CompanyBean */
export class CompanyBean {
	constructor() {
		this.address = null ;
		this.dbaName = '' ;
		this.legalName = '' ;
		this.status = '' ;
		this.comments = '' ;
		this.currencyCode = '' ;
		this.salesTaxPercentage = 0 ;
		this.retailMarkupPercentage = 0 ;
		this.wholesaleMarkupPercentage = 0 ;
		this.smtpInfo = null ;
		this.attributeModuleEntities = new Array() ;
		this.configs = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.CostDetailLineBean */
export class CostDetailLineBean {
	constructor() {
		this.companyCode = '' ;
		this.costTemplateCode = '' ;
		this.lineNumber = 0 ;
		this.amount = 0 ;
		this.percentage = 0 ;
		this.appliedAmount = 0 ;
		this.costType = '' ;
		this.includeInPurchaseOrderCost = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.CostMaintenanceChangeHistoryBean */
export class CostMaintenanceChangeHistoryBean {
	constructor() {
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.skuNumber = 0 ;
		this.trackNumber = 0 ;
		this.companyCode = '' ;
		this.workStationCode = '' ;
		this.workStationIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.criteria.CompanySearchCriteria */
export class CompanySearchCriteria {
	constructor() {
		this.companyCode = '' ;
	}
}
/* ds.master.criteria.CustomerAccountSummarySearchCriteria */
export class CustomerAccountSummarySearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerCodesList = new Array() ;
		this.customerCodeStartsWith = '' ;
		this.customerCodeContains = '' ;
		this.customerNameContains = '' ;
		this.customerName = '' ;
		this.currencyCode = '' ;
	}
}
/* ds.master.criteria.CustomerBillToSearchCriteria */
export class CustomerBillToSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerBilltoCode = '' ;
		this.customerBillToName = '' ;
		this.status = '' ;
	}
}
/* ds.master.criteria.CustomerCreditCardSearchCriteria */
export class CustomerCreditCardSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.cardID = '' ;
		this.cardStatus = '' ;
		this.cardType = '' ;
		this.cardNumber = '' ;
	}
}
/* ds.master.criteria.CustomerDistributionCenterSearchCriteria */
export class CustomerDistributionCenterSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerDistributionCenterCode = '' ;
		this.customerDistributionCenterName = '' ;
		this.status = '' ;
	}
}
/* ds.master.criteria.CustomerDuplicateSearchCriteria */
export class CustomerDuplicateSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerName = '' ;
		this.email = '' ;
		this.phoneNumber = '' ;
		this.phoneNumber1 = '' ;
		this.mobilePhoneNumber = '' ;
		this.faxNumber = '' ;
		this.contactPerson = '' ;
		this.resaleNumber = '' ;
	}
}
/* ds.master.criteria.CustomerSalesPersonCommissionSearchCriteria */
export class CustomerSalesPersonCommissionSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.salesPersonCode = '' ;
		this.productDivisionCode = '' ;
		this.status = '' ;
	}
}
/* ds.master.criteria.CustomerSearchCriteria */
export class CustomerSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerFirstNameStartsWith = '' ;
		this.customerLastNameStartsWith = '' ;
		this.status = '' ;
		this.city = '' ;
		this.stateCode = '' ;
		this.country = '' ;
		this.contactName = '' ;
		this.dbaName = '' ;
		this.currencyCode = '' ;
		this.customerTypeCode = '' ;
		this.customerDeliveryTypeCode = '' ;
		this.shipViaCode = '' ;
		this.paymentMethodCode = '' ;
		this.arTypeCode = '' ;
		this.financialTypeCode = '' ;
		this.divisionCode = '' ;
		this.customerCodeStartsWith = '' ;
		this.customerCodeContains = '' ;
		this.customerNameContains = '' ;
		this.zip = '' ;
		this.phoneNumber = '' ;
		this.salesPersonCode = '' ;
		this.searchName = '' ;
		this.isMasterCustomer = false ;
	}
}
/* ds.master.criteria.CustomerShipToSearchCriteria */
export class CustomerShipToSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerShipToCode = '' ;
		this.customerShipToName = '' ;
		this.status = '' ;
	}
}
/* ds.master.criteria.EmployeeSearchCriteria */
export class EmployeeSearchCriteria {
	constructor() {
		this.employeeCode = '' ;
		this.companyCode = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.criteria.FabricStyleCostMaintenanceSearchCriteria */
export class FabricStyleCostMaintenanceSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.costMaintenanceNumber = '' ;
		this.costMaintenanceNumberContains = '' ;
		this.costMaintenanceNumberStartsWith = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.productTypeCode = '' ;
		this.patternTypeCode = '' ;
		this.makeTypeCode = '' ;
		this.patternTypeCategoryCode = '' ;
	}
}
/* ds.master.criteria.FabricStyleImageSearchCriteria */
export class FabricStyleImageSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.imageCode = '' ;
		this.imagePart = '' ;
		this.imageName = '' ;
	}
}
/* ds.master.criteria.FabricStyleSearchCriteria */
export class FabricStyleSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleCodeContainingText = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleNameContainingText = '' ;
		this.fabricStyleNameStartsWith = '' ;
		this.fabricStatus = '' ;
		this.divisionCode = '' ;
		this.departmentCode = '' ;
		this.classCode = '' ;
		this.subClassCode = '' ;
		this.defaultWareHouseCode = '' ;
		this.inventoryUomCode = '' ;
		this.fabricStyleCodeStartsWith = '' ;
		this.fabricStyleCodesList = new Array() ;
		this.productTypeCode = '' ;
		this.patternTypeCode = '' ;
		this.makeTypeCode = '' ;
		this.specialCode = '' ;
		this.logisticCustomerCode = '' ;
		this.searchName = '' ;
		this.customerUserCode = '' ;
		this.isActive = false ;
		this.logisticCustomerCodesList = new Array() ;
	}
}
/* ds.master.criteria.FabricStyleSKUCriteriaBean */
export class FabricStyleSKUCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.skuNumber = 0 ;
		this.customerCode = '' ;
		this.vendorCode = '' ;
		this.uomCode = '' ;
		this.skuNumberList = null ;
	}
}
/* ds.master.criteria.HoldingInventoryFabricStyleSearchCriteria */
export class HoldingInventoryFabricStyleSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleCodeContainingText = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleNameContainingText = '' ;
		this.fabricStyleNameStartsWith = '' ;
		this.fabricStyleCodeStartsWith = '' ;
		this.searchName = '' ;
		this.customerCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.holdingNumber = '' ;
		this.expirationDateOnOrBefore = '' ;
	}
}
/* ds.master.criteria.VendorContactSearchCriteria */
export class VendorContactSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.contactName = '' ;
	}
}
/* ds.master.criteria.VendorFactorySearchCriteria */
export class VendorFactorySearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.vendorFactoryCode = '' ;
		this.vendorFactoryName = '' ;
		this.status = '' ;
	}
}
/* ds.master.criteria.VendorSearchCriteria */
export class VendorSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.status = '' ;
		this.city = '' ;
		this.country = '' ;
		this.contactName = '' ;
		this.vendorCategoryCode = '' ;
		this.warehouseCode = '' ;
		this.buyingTermsCode = '' ;
		this.shipViaCode = '' ;
		this.fOBCity = '' ;
		this.incoterm = '' ;
		this.vendorCodeContains = '' ;
		this.vendorCodeStartsWith = '' ;
		this.vendorNameContains = '' ;
		this.currencyCode = '' ;
	}
}
/* ds.master.CustomerAccountSummaryBean */
export class CustomerAccountSummaryBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.closingBalanceAmount = 0 ;
		this.accountReceivableNumber = '' ;
		this.accountReceivableDate = '' ;
		this.checkAmount = 0 ;
		this.cardAmount = 0 ;
		this.cashAmount = 0 ;
		this.remarks = '' ;
		this.standardClosingBalanceAmount = 0 ;
		this.customerCurrencyCode = '' ;
		this.companyCurrencyCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.CustomerBean */
export class CustomerBean {
	constructor() {
		this.companyCode = '' ;
		this.status = '' ;
		this.dbaName = '' ;
		this.legalName = '' ;
		this.currencyCode = '' ;
		this.divisionCode = '' ;
		this.departmentCode = '' ;
		this.classCode = '' ;
		this.subClassCode = '' ;
		this.privateLabelPrefix = '' ;
		this.privateLabelCaption = '' ;
		this.customerTypeCode = '' ;
		this.allocationPriority = 0 ;
		this.locationCode = '' ;
		this.shipViaCode = '' ;
		this.stopShipDays = 0 ;
		this.address = null ;
		this.creditLimit = 0 ;
		this.factorCode = '' ;
		this.arTypeCode = '' ;
		this.financialTypeCode = '' ;
		this.buyingOffice = '' ;
		this.legalEntity = '' ;
		this.resaleNumber = '' ;
		this.accountRepresentative = '' ;
		this.customerSalesRepresentativeCode = '' ;
		this.ediId = '' ;
		this.federalId = '' ;
		this.paymentTermsCode = '' ;
		this.paymentMethodCode = '' ;
		this.priceLevel = 0 ;
		this.discountPercentage = 0 ;
		this.damageAllowancePercentage = 0 ;
		this.noOfBackOrders = 0 ;
		this.nationalId = '' ;
		this.invoiceTemplateCode = '' ;
		this.poRequiredFlag = false ;
		this.freightChageFlag = false ;
		this.packingSlipRequiredFlag = false ;
		this.salesTaxRequiredFlag = false ;
		this.cityTaxRequiredFlag = false ;
		this.bulkInvoiceFlag = false ;
		this.invoiceEditFlag = false ;
		this.interCompanyFlag = false ;
		this.allocationHeldFlag = false ;
		this.onlineCustomerFlag = false ;
		this.sellSecondsFlag = false ;
		this.cancelBackOrderFlag = false ;
		this.priceAtCostFlag = false ;
		this.ediCustomerFlag = false ;
		this.sampleSalesFlag = false ;
		this.internationalFlag = false ;
		this.acceptReturnsFlag = false ;
		this.shipCompleteFlag = false ;
		this.sellSoldOutFlag = false ;
		this.coordinationFlag = false ;
		this.comments = '' ;
		this.instructions = '' ;
		this.zoneCode = '' ;
		this.regionCode = '' ;
		this.districtCode = '' ;
		this.territoryCode = '' ;
		this.markUpDownPercentage = 0 ;
		this.accountNumber = '' ;
		this.shipmentTime = 0 ;
		this.shipmentLeadTime = 0 ;
		this.firstName = '' ;
		this.lastName = '' ;
		this.middleName = '' ;
		this.creditCustomerFlag = false ;
		this.customerCompanyName = '' ;
		this.isForcePayRequired = false ;
		this.isFaxInvoiceRequired = false ;
		this.isEmailInvoiceRequired = false ;
		this.interestInvoiceRequired = false ;
		this.billTo = null ;
		this.shipTo = null ;
		this.upsShippingAccountUserId = '' ;
		this.upsShippingAccountPassword = '' ;
		this.fedexShippingAccountUserId = '' ;
		this.fedexShippingAccountPassword = '' ;
		this.uspsShippingAccountUserId = '' ;
		this.uspsShippingAccountPassword = '' ;
		this.customerAddressNotes = '' ;
		this.shippingAccountCountryCode = '' ;
		this.shippingAccountPostalCode = '' ;
		this.warningNotes = '' ;
		this.customerDeliveryTypeCode = '' ;
		this.payableEmail = '' ;
		this.purchasingEmail = '' ;
		this.adminEmail = '' ;
		this.generalEmail = '' ;
		this.incotermCode = '' ;
		this.establishedDate = '' ;
		this.customerSpecialTypeCode = '' ;
		this.businessDivision = '' ;
		this.customerRemarks = '' ;
		this.isPaidForceFlag = false ;
		this.referrelCode = '' ;
		this.masterCustomerCode = '' ;
		this.isMasterCustomer = false ;
		this.salesManager = '' ;
		this.parentAccountNumber = '' ;
		this.parentName = '' ;
		this.productDivisions = new Array() ;
		this.accountSummary = null ;
		this.billTos = new Array() ;
		this.shipTos = new Array() ;
		this.distributionCenters = new Array() ;
		this.salesCommissions = new Array() ;
		this.customerServices = new Array() ;
		this.customerCreditCards = new Array() ;
		this.changeHistories = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.CustomerBillToBean */
export class CustomerBillToBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.status = '' ;
		this.currencyCode = '' ;
		this.address = null ;
		this.shipViaCode = '' ;
		this.invoiceTemplateCode = '' ;
		this.paymentTermsCode = '' ;
		this.paymentMethodCode = '' ;
		this.freightChageFlag = false ;
		this.packingSlipRequiredFlag = false ;
		this.salesTaxRequiredFlag = false ;
		this.cityTaxRequiredFlag = false ;
		this.bulkInvoiceFlag = false ;
		this.invoiceEditFlag = false ;
		this.comments = '' ;
		this.instructions = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.CustomerChangeHistoryBean */
export class CustomerChangeHistoryBean {
	constructor() {
		this.customerCode = '' ;
		this.customerName = '' ;
		this.trackNumber = 0 ;
		this.companyCode = '' ;
		this.workStationCode = '' ;
		this.workStationIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.CustomerCreditCardBean */
export class CustomerCreditCardBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.cardID = '' ;
		this.cardStatus = '' ;
		this.cardType = '' ;
		this.cardNumber = '' ;
		this.cvvNumber = '' ;
		this.expiryMonth = '' ;
		this.expiryYear = '' ;
		this.cardHolderFirstName = '' ;
		this.cardHolderLastName = '' ;
		this.address = null ;
		this.isDefaultFlag = false ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.CustomerDistributionCenterBean */
export class CustomerDistributionCenterBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.status = '' ;
		this.locationCode = '' ;
		this.shipViaCode = '' ;
		this.stopShipDays = 0 ;
		this.address = null ;
		this.comments = '' ;
		this.instructions = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.CustomerFabricStyleColorReferenceBean */
export class CustomerFabricStyleColorReferenceBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleColorName = '' ;
		this.customerCode = '' ;
		this.customerStyleColorReferenceCode = '' ;
		this.customerStyleColorReferenceName = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.CustomerFabricStyleReferenceBean */
export class CustomerFabricStyleReferenceBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerStyleReferenceCode = '' ;
		this.customerStyleReferenceName = '' ;
		this.notes = '' ;
		this.customerFabricStyleColorReferences = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.CustomerFabricStyleReferenceResultBean */
export class CustomerFabricStyleReferenceResultBean {
	constructor() {
		this.companyCode = '' ;
		this.customerFabricStyleReferences = new Array() ;
	}
}
/* ds.master.CustomerProductDivisionBean */
export class CustomerProductDivisionBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.productDivisionCode = '' ;
		this.productDivisionName = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.CustomerSalesPersonCommissionBean */
export class CustomerSalesPersonCommissionBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.productDivisionCode = '' ;
		this.commissionPercentage = 0 ;
		this.commissionTypeCode = '' ;
		this.status = '' ;
		this.comments = '' ;
		this.isPrimary = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.CustomerServiceBean */
export class CustomerServiceBean {
	constructor() {
		this.price = 0 ;
		this.quantity = 0 ;
		this.uomCode = '' ;
		this.customerCode = '' ;
		this.companyCode = '' ;
		this.amount = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.CustomerShipToBean */
export class CustomerShipToBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.status = '' ;
		this.billToCode = '' ;
		this.distributionCenterCode = '' ;
		this.zoneCode = '' ;
		this.regionCode = '' ;
		this.districtCode = '' ;
		this.territoryCode = '' ;
		this.address = null ;
		this.shipViaCode = '' ;
		this.stopShipDays = 0 ;
		this.locationCode = '' ;
		this.comments = '' ;
		this.instructions = '' ;
		this.addressNotes = '' ;
		this.shipToType = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.deps.CompanySetupModuleDependenciesBean */
export class CompanySetupModuleDependenciesBean {
	constructor() {
		this.currencies = new Array() ;
		this.cities = new Array() ;
		this.states = new Array() ;
		this.countries = new Array() ;
		this.paymentTerms = new Array() ;
		this.paymentMethods = new Array() ;
		this.uoms = new Array() ;
		this.warehouses = new Array() ;
		this.configs = new Array() ;
		this.attributeModuleEntities = new Array() ;
	}
}
/* ds.master.deps.CustomerModuleDependenciesBean */
export class CustomerModuleDependenciesBean {
	constructor() {
		this.billTos = new Array() ;
		this.distributionCenters = new Array() ;
		this.isCurrencyEditableFlag = false ;
	}
}
/* ds.master.deps.FabricStyleModuleDependenciesBean */
export class FabricStyleModuleDependenciesBean {
	constructor() {
		this.uoms = new Array() ;
		this.warehouses = new Array() ;
	}
}
/* ds.master.deps.response.CompanySetupModuleDependenciesResponseBean */
export class CompanySetupModuleDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.deps.response.CustomerModuleDependenciesResponseBean */
export class CustomerModuleDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.deps.response.FabricStyleModuleDependenciesResponseBean */
export class FabricStyleModuleDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.deps.response.VendorModuleDependenciesResponseBean */
export class VendorModuleDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.deps.VendorModuleDependenciesBean */
export class VendorModuleDependenciesBean {
	constructor() {
		this.paymentTerms = new Array() ;
		this.shipVias = new Array() ;
		this.countries = new Array() ;
		this.fOBcities = new Array() ;
		this.shipmentTerms = new Array() ;
		this.categories = new Array() ;
		this.warehouses = new Array() ;
		this.incoTerms = new Array() ;
		this.vendorShipVias = new Array() ;
		this.vendorTerms = new Array() ;
	}
}
/* ds.master.EmployeeBean */
export class EmployeeBean {
	constructor() {
		this.companyCode = '' ;
		this.status = '' ;
		this.comments = '' ;
		this.address = null ;
		this.dateOfBirth = '' ;
		this.dateOfJoining = '' ;
		this.firstName = '' ;
		this.lastName = '' ;
		this.socialSecurityNumber = '' ;
		this.jobTitle = '' ;
		this.designation = '' ;
		this.isSalesPerson = false ;
		this.isAccountRepresentative = false ;
		this.isSalesClerk = false ;
		this.userCode = '' ;
		this.password = '' ;
		this.isUserCreated = false ;
		this.isPortalUser = false ;
		this.commissionPercentage = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.ExternalCustomerBean */
export class ExternalCustomerBean {
	constructor() {
		this.companyCode = '' ;
		this.status = '' ;
		this.dbaName = '' ;
		this.legalName = '' ;
		this.currencyCode = '' ;
		this.divisionCode = '' ;
		this.departmentCode = '' ;
		this.classCode = '' ;
		this.subClassCode = '' ;
		this.privateLabelPrefix = '' ;
		this.privateLabelCaption = '' ;
		this.customerTypeCode = '' ;
		this.allocationPriority = 0 ;
		this.locationCode = '' ;
		this.shipViaCode = '' ;
		this.stopShipDays = 0 ;
		this.address = null ;
		this.creditLimit = 0 ;
		this.factorCode = '' ;
		this.arTypeCode = '' ;
		this.financialTypeCode = '' ;
		this.buyingOffice = '' ;
		this.legalEntity = '' ;
		this.resaleNumber = '' ;
		this.accountRepresentative = '' ;
		this.customerSalesRepresentativeCode = '' ;
		this.ediId = '' ;
		this.federalId = '' ;
		this.paymentTermsCode = '' ;
		this.paymentMethodCode = '' ;
		this.priceLevel = 0 ;
		this.discountPercentage = 0 ;
		this.damageAllowancePercentage = 0 ;
		this.noOfBackOrders = 0 ;
		this.nationalId = '' ;
		this.invoiceTemplateCode = '' ;
		this.poRequiredFlag = false ;
		this.freightChageFlag = false ;
		this.packingSlipRequiredFlag = false ;
		this.salesTaxRequiredFlag = false ;
		this.cityTaxRequiredFlag = false ;
		this.bulkInvoiceFlag = false ;
		this.invoiceEditFlag = false ;
		this.interCompanyFlag = false ;
		this.allocationHeldFlag = false ;
		this.onlineCustomerFlag = false ;
		this.sellSecondsFlag = false ;
		this.cancelBackOrderFlag = false ;
		this.priceAtCostFlag = false ;
		this.ediCustomerFlag = false ;
		this.sampleSalesFlag = false ;
		this.internationalFlag = false ;
		this.acceptReturnsFlag = false ;
		this.shipCompleteFlag = false ;
		this.sellSoldOutFlag = false ;
		this.coordinationFlag = false ;
		this.comments = '' ;
		this.instructions = '' ;
		this.zoneCode = '' ;
		this.regionCode = '' ;
		this.districtCode = '' ;
		this.territoryCode = '' ;
		this.markUpDownPercentage = 0 ;
		this.accountNumber = '' ;
		this.shipmentTime = 0 ;
		this.shipmentLeadTime = 0 ;
		this.firstName = '' ;
		this.lastName = '' ;
		this.middleName = '' ;
		this.creditCustomerFlag = false ;
		this.customerCompanyName = '' ;
		this.isForcePayRequired = false ;
		this.isFaxInvoiceRequired = false ;
		this.isEmailInvoiceRequired = false ;
		this.interestInvoiceRequired = false ;
		this.billTo = null ;
		this.shipTo = null ;
		this.upsShippingAccountUserId = '' ;
		this.upsShippingAccountPassword = '' ;
		this.fedexShippingAccountUserId = '' ;
		this.fedexShippingAccountPassword = '' ;
		this.uspsShippingAccountUserId = '' ;
		this.uspsShippingAccountPassword = '' ;
		this.customerAddressNotes = '' ;
		this.shippingAccountCountryCode = '' ;
		this.shippingAccountPostalCode = '' ;
		this.warningNotes = '' ;
		this.customerDeliveryTypeCode = '' ;
		this.payableEmail = '' ;
		this.purchasingEmail = '' ;
		this.adminEmail = '' ;
		this.generalEmail = '' ;
		this.isPaidForceFlag = false ;
		this.changeHistories = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleBean */
export class FabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fullDescription = '' ;
		this.ediDescription = '' ;
		this.inventoryUomCode = '' ;
		this.salesTaxRequiredFlag = false ;
		this.divisionCode = '' ;
		this.departmentCode = '' ;
		this.classCode = '' ;
		this.subClassCode = '' ;
		this.defaultLocationCode = '' ;
		this.currencyCode = '' ;
		this.retailPrice = 0 ;
		this.wholesalePrice = 0 ;
		this.samplePrice = 0 ;
		this.webRetailPrice = 0 ;
		this.cost = 0 ;
		this.standardCost = 0 ;
		this.closeOutFlag = false ;
		this.closeOutPrice = 0 ;
		this.seasonCode = '' ;
		this.cpmTemplateCode = '' ;
		this.copyrightNumber = '' ;
		this.upcLevel = 0 ;
		this.weight = 0 ;
		this.weightUomCode = '' ;
		this.width = '' ;
		this.widthUomCode = '' ;
		this.productTypeCode = '' ;
		this.patternTypeCode = '' ;
		this.makeTypeCode = '' ;
		this.specialCode = '' ;
		this.productTypeName = '' ;
		this.patternTypeName = '' ;
		this.makeTypeName = '' ;
		this.countryOfOrgin = '' ;
		this.isPrepack = false ;
		this.unitsPerBox = 0 ;
		this.boxWidth = 0 ;
		this.boxHeight = 0 ;
		this.boxLength = 0 ;
		this.boxDimentionUomCode = '' ;
		this.boxWeight = 0 ;
		this.boxWeightUomCode = '' ;
		this.boxVolume = 0 ;
		this.availableFromDate = '' ;
		this.availableToDate = '' ;
		this.designerDetail = '' ;
		this.reorderStockLevel = 0 ;
		this.reorderDefaultQuantity = 0 ;
		this.categoryCode = '' ;
		this.subCategoryCode = '' ;
		this.notes = '' ;
		this.yarnDetails = '' ;
		this.filamentDetails = '' ;
		this.fibreDetail = '' ;
		this.usageDetails = '' ;
		this.createdStationCode = '' ;
		this.updatedStationCode = '' ;
		this.patternTypeCategoryCode = '' ;
		this.patternTypeCategoryName = '' ;
		this.isUPCGenerated = false ;
		this.division = null ;
		this.stretchWrapWeftDetails = '' ;
		this.colorFitnessDetails = '' ;
		this.oldSystemCode = '' ;
		this.leadTime = 0 ;
		this.minimumOrderQuantity = 0 ;
		this.cleanCode = '' ;
		this.directionCode = '' ;
		this.abrasionCode = '' ;
		this.contentCode = '' ;
		this.backingCode = '' ;
		this.hts = '' ;
		this.stats = '' ;
		this.styleItemType = '' ;
		this.styleItemTypeName = '' ;
		this.parentProductCode = '' ;
		this.tariffFlag = false ;
		this.businessDivision = '' ;
		this.tariffPercentage = 0 ;
		this.fabricWidth = '' ;
		this.fabricContent = '' ;
		this.fabricRepeat = '' ;
		this.fabricDirection = '' ;
		this.fabricWeight = '' ;
		this.fabricCountryOfOrigin = '' ;
		this.fabricCleaningCode = '' ;
		this.fabricAbrasion = '' ;
		this.fabricStyleType = '' ;
		this.warpYarn = false ;
		this.fillingYarn = false ;
		this.warpYarnSizes = '' ;
		this.fillingYarnSizes = '' ;
		this.warpYarnPerInch = '' ;
		this.fillingYarnPerInch = '' ;
		this.fillingYarnPerCentimeter = '' ;
		this.warpYarnPerCentimeter = '' ;
		this.warpYarnTwisted = false ;
		this.fillingYarnTwisted = false ;
		this.warpYarnTextured = false ;
		this.fillingYarnTextured = false ;
		this.fillingYarnCombed = false ;
		this.fillingYarnCarded = false ;
		this.napped = false ;
		this.printed = false ;
		this.washed = false ;
		this.needlePunched = false ;
		this.backed = false ;
		this.backingType = '' ;
		this.bondedBackingType = '' ;
		this.fibreContentBackingType = '' ;
		this.backingWeightKilo = '' ;
		this.backingWeightPound = '' ;
		this.latexWeightKilo = '' ;
		this.latexWeightPound = '' ;
		this.standardTesting1 = '' ;
		this.standardTesting2 = '' ;
		this.standardTesting3 = '' ;
		this.standardTesting4 = '' ;
		this.standardTesting5 = '' ;
		this.standardTesting6 = '' ;
		this.standardTesting7 = '' ;
		this.standardTesting8 = '' ;
		this.standardTesting9 = '' ;
		this.backingAndFinishingDetails = '' ;
		this.standardTestingDetails = '' ;
		this.contentDetails = '' ;
		this.dutyCharge = 0 ;
		this.fabricSurgeCharge = 0 ;
		this.sampleItemFlag = false ;
		this.webSalesFlag = false ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fabricStyleLogisticPackageInfoCode = '' ;
		this.commissionPercentage = 0 ;
		this.dateOfManufacturing = '' ;
		this.dateOfExpiration = '' ;
		this.shrinkingDetails = '' ;
		this.cleaningInstruction = '' ;
		this.customerUserCode = '' ;
		this.fabricStatus = '' ;
		this.ecomAmazonDetails = new Array() ;
		this.ecomEbayDetails = new Array() ;
		this.ecomHouzzDetails = new Array() ;
		this.ecomItsyDetails = new Array() ;
		this.ecomShopifyDetails = new Array() ;
		this.ecomWalMartDetails = new Array() ;
		this.ecomWayFairDetails = new Array() ;
		this.fabricStyleSkus = new Array() ;
		this.buyingUoms = new Array() ;
		this.sellingUoms = new Array() ;
		this.fabricStyleImages = new Array() ;
		this.colors = new Array() ;
		this.compositions = new Array() ;
		this.vendorReferences = new Array() ;
		this.royaltyClientReferences = new Array() ;
		this.fabricStyleDocuments = new Array() ;
		this.customerTypePrices = new Array() ;
		this.changeHistories = new Array() ;
		this.fabricMiscDetails = new Array() ;
		this.fabricLogisticPackageInfosDetails = null ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleBuyingUOMBean */
export class FabricStyleBuyingUOMBean {
	constructor() {
		this.cost = 0 ;
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleInventoryUOMCode = '' ;
		this.uomCode = '' ;
		this.conversionRate = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleColorBean */
export class FabricStyleColorBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleColorName = '' ;
		this.baseColorCode = '' ;
		this.colorVersionNumber = '' ;
		this.nrfCode = '' ;
		this.imageName = '' ;
		this.imagePath = '' ;
		this.oldFabricStyleColorCode = '' ;
		this.altImageName = '' ;
		this.copyrightNumber = '' ;
		this.imageSize = 0 ;
		this.status = '' ;
		this.customerTypePrices = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleColorCustomerTypePriceBean */
export class FabricStyleColorCustomerTypePriceBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.customerTypeCode = '' ;
		this.uomCode = '' ;
		this.currencyCode = '' ;
		this.samplePrice = 0 ;
		this.price = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleColorMiscellaneousDetailBean */
export class FabricStyleColorMiscellaneousDetailBean {
	constructor() {
		this.lineNumber = 0 ;
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.miscellaneousCost = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleColorRemovableBean */
export class FabricStyleColorRemovableBean {
	constructor() {
		this.isCheckItemColorRemovable = false ;
		this.errorList = null ;
	}
}
/* ds.master.FabricStyleColorVendorReferenceBean */
export class FabricStyleColorVendorReferenceBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleColorName = '' ;
		this.vendorCode = '' ;
		this.vendorStyleColorReferenceCode = '' ;
		this.vendorStyleColorReferenceName = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleCompositionBean */
export class FabricStyleCompositionBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.compositionElementCode = '' ;
		this.compositionElementName = '' ;
		this.compostionPercentageValue = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleCostAndPriceMaintenanceBean */
export class FabricStyleCostAndPriceMaintenanceBean {
	constructor() {
		this.companyCode = '' ;
		this.remarks = '' ;
		this.costPriceLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleCostAndPriceMaintenanceLineBean */
export class FabricStyleCostAndPriceMaintenanceLineBean {
	constructor() {
		this.costMaintenanceNumber = '' ;
		this.lineNumber = 0 ;
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.uomCode = '' ;
		this.skuNumber = 0 ;
		this.cost = 0 ;
		this.price = 0 ;
		this.isCostUpdated = false ;
		this.widthCode = '' ;
		this.productTypeCode = '' ;
		this.patternTypeCode = '' ;
		this.makeTypeCode = '' ;
		this.patternTypeCategoryCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleCostPriceChangeHistoryBean */
export class FabricStyleCostPriceChangeHistoryBean {
	constructor() {
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.skuNumber = 0 ;
		this.previousCost = 0 ;
		this.previousPrice = 0 ;
		this.processedBeanInfo = '' ;
		this.trackNumber = 0 ;
		this.companyCode = '' ;
		this.workStationCode = '' ;
		this.workStationIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleCustomerTypePriceBean */
export class FabricStyleCustomerTypePriceBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.customerTypeCode = '' ;
		this.uomCode = '' ;
		this.currencyCode = '' ;
		this.samplePrice = 0 ;
		this.price = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleDocumentBean */
export class FabricStyleDocumentBean {
	constructor() {
		this.fabricStyleCode = '' ;
		this.companyCode = '' ;
		this.documentOriginalName = '' ;
		this.documentNumber = 0 ;
		this.documentCode = '' ;
		this.documentPath = '' ;
		this.documentName = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleElementHistoryBean */
export class FabricStyleElementHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleImageBean */
export class FabricStyleImageBean {
	constructor() {
		this.fabricStyleCode = '' ;
		this.imageCode = '' ;
		this.imagePart = '' ;
		this.imagePath = '' ;
		this.imageName = '' ;
		this.companyCode = '' ;
		this.imageOritinalname = '' ;
		this.tags = '' ;
		this.notesCommunication = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleInAndOutStatisticsBean */
export class FabricStyleInAndOutStatisticsBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.containerNumber = '' ;
		this.projectNumber = '' ;
		this.lotNumber = '' ;
		this.receivedDate = '' ;
		this.receivedQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.differnceQuantity = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleMiscellaneousDetailBean */
export class FabricStyleMiscellaneousDetailBean {
	constructor() {
		this.lineNumber = 0 ;
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.miscellaneousCost = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStylePurchaseCostBean */
export class FabricStylePurchaseCostBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.sizeCode = '' ;
		this.skuNumber = 0 ;
		this.cost = 0 ;
	}
}
/* ds.master.FabricStylePurchaseCostResultBean */
export class FabricStylePurchaseCostResultBean {
	constructor() {
		this.costBean = new Array() ;
	}
}
/* ds.master.FabricStyleRoyaltyClientReferenceBean */
export class FabricStyleRoyaltyClientReferenceBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.royaltyClientcode = '' ;
		this.royaltyClientName = '' ;
		this.royaltyPercentage = 0 ;
		this.notes = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleSalesPriceBean */
export class FabricStyleSalesPriceBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.skuNumber = 0 ;
		this.price = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleSalesPriceResultBean */
export class FabricStyleSalesPriceResultBean {
	constructor() {
		this.priceBean = new Array() ;
	}
}
/* ds.master.FabricStyleSellingUOMBean */
export class FabricStyleSellingUOMBean {
	constructor() {
		this.wholeSalePrice = 0 ;
		this.retailPrice = 0 ;
		this.weightUomCode = '' ;
		this.weight = 0 ;
		this.width = 0 ;
		this.height = 0 ;
		this.length = 0 ;
		this.dimensionUomCode = '' ;
		this.palletDimensionUomCode = '' ;
		this.numberOfItemsPerPallet = 0 ;
		this.palletWidth = 0 ;
		this.palletHeight = 0 ;
		this.palletLength = 0 ;
		this.stackableFlag = false ;
		this.stackableQuantity = 0 ;
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleInventoryUOMCode = '' ;
		this.uomCode = '' ;
		this.conversionRate = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleSimpleBean */
export class FabricStyleSimpleBean {
	constructor() {
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.customerCode = '' ;
		this.isActive = false ;
	}
}
/* ds.master.FabricStyleSKUBean */
export class FabricStyleSKUBean {
	constructor() {
		this.companyCode = '' ;
		this.skuNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.uomCode = '' ;
		this.currencyCode = '' ;
		this.imageName = '' ;
		this.imagePath = '' ;
		this.samplePrice = 0 ;
		this.wholesalePrice = 0 ;
		this.retailPrice = 0 ;
		this.webRetailPrice = 0 ;
		this.cost = 0 ;
		this.rmbCost = 0 ;
		this.standardCost = 0 ;
		this.landingCost = 0 ;
		this.upcCode = '' ;
		this.metalWeight = 0 ;
		this.metalUomCode = '' ;
		this.oldSystemSkuNumber = '' ;
		this.webSalesFlag = false ;
		this.skuCostBean = null ;
		this.skuPriceBean = null ;
		this.lastSKUCostLineNumber = 0 ;
		this.lastSKUPriceLineNumber = 0 ;
		this.fabricMiscColorDetails = new Array() ;
		this.amazonSkuLines = new Array() ;
		this.ebaySkuLines = new Array() ;
		this.shopifySkuLines = new Array() ;
		this.walmartSkuLines = new Array() ;
		this.wayfairSkuLines = new Array() ;
		this.itsySkuLines = new Array() ;
		this.houzzSkuLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleSKUCostBean */
export class FabricStyleSKUCostBean {
	constructor() {
		this.companyCode = '' ;
		this.skuNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.uomCode = '' ;
		this.cost = 0 ;
		this.effectiveDate = '' ;
		this.currencyCode = '' ;
		this.skuVendorCosts = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleSKUCustomerPriceBean */
export class FabricStyleSKUCustomerPriceBean {
	constructor() {
		this.companyCode = '' ;
		this.skuNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.lineNumber = 0 ;
		this.uomCode = '' ;
		this.effectiveDate = '' ;
		this.price = 0 ;
		this.samplePrice = 0 ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerTypeCode = '' ;
		this.customerTypeName = '' ;
		this.systemRemarks = '' ;
		this.discountPercentage = 0 ;
		this.updatedBatchCode = '' ;
		this.updateBatchLineNumber = 0 ;
		this.currencyCode = '' ;
		this.fromDate = '' ;
		this.toDate = '' ;
		this.customerShipToCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleSkuCustomerPriceElementHistoryBean */
export class FabricStyleSkuCustomerPriceElementHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.skuNumber = 0 ;
		this.lineNumber = 0 ;
		this.customerCode = '' ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleSkuElementHistoryBean */
export class FabricStyleSkuElementHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.skuNumber = 0 ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleSKUPriceBean */
export class FabricStyleSKUPriceBean {
	constructor() {
		this.companyCode = '' ;
		this.skuNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.uomCode = '' ;
		this.effectiveDate = '' ;
		this.currencyCode = '' ;
		this.defaultPrice = 0 ;
		this.samplePrice = 0 ;
		this.skuCustomerPrices = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleSKUVendorCostBean */
export class FabricStyleSKUVendorCostBean {
	constructor() {
		this.companyCode = '' ;
		this.skuNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.lineNumber = 0 ;
		this.uomCode = '' ;
		this.effectiveDate = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.cost = 0 ;
		this.currencyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.isDefaultCost = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleSkuVendorCostElementHistoryBean */
export class FabricStyleSkuVendorCostElementHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.skuNumber = 0 ;
		this.lineNumber = 0 ;
		this.vendorCode = '' ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleUOMBean */
export class FabricStyleUOMBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleInventoryUOMCode = '' ;
		this.uomCode = '' ;
		this.conversionRate = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleVendorReferenceBean */
export class FabricStyleVendorReferenceBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.vendorStyleReferenceCode = '' ;
		this.vendorStyleReferenceName = '' ;
		this.notes = '' ;
		this.isPrimaryVendorFlag = false ;
		this.fabricStyleColorVendorReferences = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.FabricStyleWithInventoryResultBean */
export class FabricStyleWithInventoryResultBean {
	constructor() {
		this.fabricStyle = null ;
		this.inventoryDatas = new Array() ;
		this.skuBatchInventoryDatas = new Array() ;
	}
}
/* ds.master.HoldingFabricInventoryDetailBean */
export class HoldingFabricInventoryDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.holdingNumber = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.inventoryUomCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.locationCode = '' ;
		this.expirationTime = '' ;
		this.holdingDate = '' ;
		this.expirationDate = '' ;
		this.holdingLotDetails = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.HoldingFabricLotInventoryDetailBean */
export class HoldingFabricLotInventoryDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.holdingNumber = '' ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.totalNumberOfRolls = 0 ;
		this.holdingQuantity = 0 ;
		this.vendorBatchNumber = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.merge.response.CompanySetupModuleMergeResponseBean */
export class CompanySetupModuleMergeResponseBean {
	constructor() {
		this.companyResponse = null ;
		this.lockResponse = null ;
		this.dependenciesResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.merge.response.CustomerModuleMergeResponseBean */
export class CustomerModuleMergeResponseBean {
	constructor() {
		this.customerResponse = null ;
		this.lockResponse = null ;
		this.dependenciesResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.merge.response.ExternalCustomerModuleMergeResponseBean */
export class ExternalCustomerModuleMergeResponseBean {
	constructor() {
		this.externalCustomerResponse = null ;
		this.lockResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.merge.response.FabricStyleCostMaintenanceModuleMergeResponseBean */
export class FabricStyleCostMaintenanceModuleMergeResponseBean {
	constructor() {
		this.costMaintenanceResponse = null ;
		this.lockResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.merge.response.FabricStyleModuleMergeResponseBean */
export class FabricStyleModuleMergeResponseBean {
	constructor() {
		this.fabricStyleResponse = null ;
		this.lockResponse = null ;
		this.dependenciesResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.merge.response.VendorModuleMergeResponseBean */
export class VendorModuleMergeResponseBean {
	constructor() {
		this.vendorResponse = null ;
		this.lockResponse = null ;
		this.dependenciesResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.pagelist.CompanyPageListBean */
export class CompanyPageListBean {
	constructor() {
		this.companies = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.master.pagelist.CustomerAccountSummaryPageListBean */
export class CustomerAccountSummaryPageListBean {
	constructor() {
		this.accountSummaryList = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.master.pagelist.CustomerBillToPageListBean */
export class CustomerBillToPageListBean {
	constructor() {
		this.customerBillTos = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.master.pagelist.CustomerCreditCardPageListBean */
export class CustomerCreditCardPageListBean {
	constructor() {
		this.customerCreditCards = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.master.pagelist.CustomerDistributionCenterPageListBean */
export class CustomerDistributionCenterPageListBean {
	constructor() {
		this.customerDistributionCenters = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.master.pagelist.CustomerPageListBean */
export class CustomerPageListBean {
	constructor() {
		this.customers = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.master.pagelist.CustomerSalesPersonCommissionPageListBean */
export class CustomerSalesPersonCommissionPageListBean {
	constructor() {
		this.customerSalesPersonCommissions = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.master.pagelist.CustomerShipToPageListBean */
export class CustomerShipToPageListBean {
	constructor() {
		this.customerShipTos = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.master.pagelist.EmployeePageListBean */
export class EmployeePageListBean {
	constructor() {
		this.employees = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.master.pagelist.ExternalCustomerPageListBean */
export class ExternalCustomerPageListBean {
	constructor() {
		this.customers = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.master.pagelist.FabricStyleCostMaintenancePageListBean */
export class FabricStyleCostMaintenancePageListBean {
	constructor() {
		this.fabricStyleCostMaintenanceBeans = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.master.pagelist.FabricStyleElementHistoryPageListBean */
export class FabricStyleElementHistoryPageListBean {
	constructor() {
		this.elementHistories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.master.pagelist.FabricStylePageListBean */
export class FabricStylePageListBean {
	constructor() {
		this.fabricStyles = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.master.pagelist.FabricStyleSkuCustomerPriceElementHistoryPageListBean */
export class FabricStyleSkuCustomerPriceElementHistoryPageListBean {
	constructor() {
		this.customerPriceElementHistories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.master.pagelist.FabricStyleSkuElementHistoryPageListBean */
export class FabricStyleSkuElementHistoryPageListBean {
	constructor() {
		this.skuElementHistories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.master.pagelist.FabricStyleSKUPageListBean */
export class FabricStyleSKUPageListBean {
	constructor() {
		this.fabricStylesSKU = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.master.pagelist.FabricStyleSkuVendorCostElementHistoryPageListBean */
export class FabricStyleSkuVendorCostElementHistoryPageListBean {
	constructor() {
		this.vendorCostElementHistories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.master.pagelist.HoldingInventoryFabricStylePageListBean */
export class HoldingInventoryFabricStylePageListBean {
	constructor() {
		this.holdingInventoryDetails = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.master.pagelist.response.CompanyPageListResponseBean */
export class CompanyPageListResponseBean {
	constructor() {
		this.companyPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.pagelist.response.CustomerAccountSummaryPageListResponseBean */
export class CustomerAccountSummaryPageListResponseBean {
	constructor() {
		this.customerAccountSummaryPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.pagelist.response.CustomerBillToPageListResponseBean */
export class CustomerBillToPageListResponseBean {
	constructor() {
		this.customerBillToPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.pagelist.response.CustomerCreditCardPageListResponseBean */
export class CustomerCreditCardPageListResponseBean {
	constructor() {
		this.creditCardPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.pagelist.response.CustomerDistributionCenterPageListResponseBean */
export class CustomerDistributionCenterPageListResponseBean {
	constructor() {
		this.customerDistributionCenterPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.pagelist.response.CustomerPageListResponseBean */
export class CustomerPageListResponseBean {
	constructor() {
		this.customerPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.pagelist.response.CustomerSalesPersonCommissionPageListResponseBean */
export class CustomerSalesPersonCommissionPageListResponseBean {
	constructor() {
		this.customerSalesPersonCommissionPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.pagelist.response.CustomerShipToPageListResponseBean */
export class CustomerShipToPageListResponseBean {
	constructor() {
		this.customerShipToPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.pagelist.response.EmployeePageListResponseBean */
export class EmployeePageListResponseBean {
	constructor() {
		this.employeePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.pagelist.response.ExternalCustomerPageListResponseBean */
export class ExternalCustomerPageListResponseBean {
	constructor() {
		this.customerPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.pagelist.response.FabricStyleCostMaintenancePageListResponseBean */
export class FabricStyleCostMaintenancePageListResponseBean {
	constructor() {
		this.fabricStyleCostMaintenancePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.pagelist.response.FabricStyleElementHistoryPageListResponseBean */
export class FabricStyleElementHistoryPageListResponseBean {
	constructor() {
		this.fabricStyleElementHistoryPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.pagelist.response.FabricStylePageListResponseBean */
export class FabricStylePageListResponseBean {
	constructor() {
		this.fabricStylePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.pagelist.response.FabricStyleSkuCustomerPriceElementHistoryPageListResponseBean */
export class FabricStyleSkuCustomerPriceElementHistoryPageListResponseBean {
	constructor() {
		this.fabricStyleSkuCustomerPriceElementHistoryPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.pagelist.response.FabricStyleSkuElementHistoryPageListResponseBean */
export class FabricStyleSkuElementHistoryPageListResponseBean {
	constructor() {
		this.fabricStyleSkuElementHistoryPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.pagelist.response.FabricStyleSkuVendorCostElementHistoryPageListResponseBean */
export class FabricStyleSkuVendorCostElementHistoryPageListResponseBean {
	constructor() {
		this.fabricStyleSkuVendorCostElementHistoryPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.pagelist.response.HoldingInventoryFabricStylePageListResponseBean */
export class HoldingInventoryFabricStylePageListResponseBean {
	constructor() {
		this.holdingInventoryFabricStylePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.pagelist.response.SimpleFabricStylePageListResponseBean */
export class SimpleFabricStylePageListResponseBean {
	constructor() {
		this.fabricStylePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.pagelist.response.VendorFactoryPageListResponseBean */
export class VendorFactoryPageListResponseBean {
	constructor() {
		this.vendorFactoryPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.pagelist.response.VendorPageListResponseBean */
export class VendorPageListResponseBean {
	constructor() {
		this.vendorPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.pagelist.SimpleFabricStylePageListBean */
export class SimpleFabricStylePageListBean {
	constructor() {
		this.fabricStyles = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.master.pagelist.VendorFactoryPageListBean */
export class VendorFactoryPageListBean {
	constructor() {
		this.vendorFactories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.master.pagelist.VendorPageListBean */
export class VendorPageListBean {
	constructor() {
		this.vendors = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.master.response.CompanyResponseBean */
export class CompanyResponseBean {
	constructor() {
		this.company = null ;
		this.defaultCompanyCode = '' ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.CustomerBillToResponseBean */
export class CustomerBillToResponseBean {
	constructor() {
		this.customerBillTo = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.CustomerCreditCardResponseBean */
export class CustomerCreditCardResponseBean {
	constructor() {
		this.creditCardBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.CustomerDistributionCenterResponseBean */
export class CustomerDistributionCenterResponseBean {
	constructor() {
		this.customerDistributionCenter = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.CustomerFabricStyleReferenceResponseBean */
export class CustomerFabricStyleReferenceResponseBean {
	constructor() {
		this.customerFabricStyleReferenceResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.CustomerFabricStyleReferenceSyncResponseBean */
export class CustomerFabricStyleReferenceSyncResponseBean {
	constructor() {
		this.customerFabricStyleReference = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.CustomerResponseBean */
export class CustomerResponseBean {
	constructor() {
		this.customer = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.CustomerSalesOrdersForCustomerPurchaseOrderNumberResponseBean */
export class CustomerSalesOrdersForCustomerPurchaseOrderNumberResponseBean {
	constructor() {
		this.salesOrderBean = new Array() ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.CustomerSalesPersonCommissionResponseBean */
export class CustomerSalesPersonCommissionResponseBean {
	constructor() {
		this.customerSalesPersonCommission = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.CustomerServiceResponseBean */
export class CustomerServiceResponseBean {
	constructor() {
		this.service = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.CustomerServicesResponseBean */
export class CustomerServicesResponseBean {
	constructor() {
		this.services = new Array() ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.CustomerShipToResponseBean */
export class CustomerShipToResponseBean {
	constructor() {
		this.customerShipTo = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.EmployeeResponseBean */
export class EmployeeResponseBean {
	constructor() {
		this.employee = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.ExternalCustomerResponseBean */
export class ExternalCustomerResponseBean {
	constructor() {
		this.externalCustomer = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.FabricStyleCostAndPriceResponseBean */
export class FabricStyleCostAndPriceResponseBean {
	constructor() {
		this.priceResponse = null ;
		this.costResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.FabricStyleCostMaintenanceResponseBean */
export class FabricStyleCostMaintenanceResponseBean {
	constructor() {
		this.costPriceMaintenanceBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.FabricStyleResponseBean */
export class FabricStyleResponseBean {
	constructor() {
		this.fabricStyle = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.FabricStyleVendorReferenceResponseBean */
export class FabricStyleVendorReferenceResponseBean {
	constructor() {
		this.vendorReference = new Array() ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.FabricStyleWithInventoryResultResponseBean */
export class FabricStyleWithInventoryResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.HoldingFabricInventoryDetailResponseBean */
export class HoldingFabricInventoryDetailResponseBean {
	constructor() {
		this.holdingFabricInventoryDetail = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.HoldingFabricLotInventoryResponseBean */
export class HoldingFabricLotInventoryResponseBean {
	constructor() {
		this.count = 0 ;
		this.lotInventoryDetails = new Array() ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.JsonResponseBean */
export class JsonResponseBean {
	constructor() {
		this.jsonString = '' ;
		this.dataBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.MassMaintainanacePurchaseOrderResponseBean */
export class MassMaintainanacePurchaseOrderResponseBean {
	constructor() {
		this.massPurchaseOrderBean = new Array() ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.MassMaintainanaceSalesOrderResponseBean */
export class MassMaintainanaceSalesOrderResponseBean {
	constructor() {
		this.massSalesOrderBean = new Array() ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.VendorFactoryResponseBean */
export class VendorFactoryResponseBean {
	constructor() {
		this.vendorFactory = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.response.VendorResponseBean */
export class VendorResponseBean {
	constructor() {
		this.vendor = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.master.ShopifyBodyDataBean */
export class ShopifyBodyDataBean {
	constructor() {
		this.metaDescription = '' ;
		this.headerDescription = '' ;
		this.topDescriptionLineDatas = new Array() ;
		this.bulletinLineDatas = new Array() ;
		this.bottomDescriptionLineDatas = new Array() ;
	}
}
/* ds.master.ShopifyBodyLineData */
export class ShopifyBodyLineData {
	constructor() {
		this.lineNumber = 0 ;
		this.description = '' ;
	}
}
/* ds.master.VendorBean */
export class VendorBean {
	constructor() {
		this.companyCode = '' ;
		this.status = '' ;
		this.legalName = '' ;
		this.address = null ;
		this.manufacturingCountryCode = '' ;
		this.letterOfCreditTerms = '' ;
		this.taxId = '' ;
		this.buyingDiscount = 0 ;
		this.isContractor = false ;
		this.isTicketVendor = false ;
		this.agentCode = '' ;
		this.buyingTermsCode = '' ;
		this.shipmentTermsCode = '' ;
		this.fOBCity = '' ;
		this.currencyCode = '' ;
		this.shipViaCode = '' ;
		this.daysToFrightForwarding = 0 ;
		this.locationCode = '' ;
		this.ticketVendorCode = '' ;
		this.vendorCategoryCode = '' ;
		this.pullSheetNumber = '' ;
		this.bankCode = '' ;
		this.incoterm = '' ;
		this.accountNumber = '' ;
		this.toleranceForMatchingPercentage = 0 ;
		this.comments = '' ;
		this.vendorTypeCode = '' ;
		this.memoText = '' ;
		this.businessDivision = '' ;
		this.vendorContacts = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.VendorContactBean */
export class VendorContactBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.contactId = 0 ;
		this.contactName = '' ;
		this.mailId = '' ;
		this.phoneNumber = '' ;
		this.mobileNumber = '' ;
		this.comments = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.master.VendorFactoryBean */
export class VendorFactoryBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.status = '' ;
		this.address = null ;
		this.currencyCode = '' ;
		this.shipViaCode = '' ;
		this.buyingTermsCode = '' ;
		this.shipmentTermsCode = '' ;
		this.fOBCity = '' ;
		this.manufacturingCountryCode = '' ;
		this.daysToFrightForwarding = 0 ;
		this.comments = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.portal.criteria.PortalSalesOrderSearchCriteria */
export class PortalSalesOrderSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.salesPersonCode = '' ;
		this.customerCode = '' ;
		this.orderDateFrom = '' ;
		this.orderDateTo = '' ;
		this.showConfirmedOrders = false ;
	}
}
/* ds.portal.datasync.OrderPortalCustomerBean */
export class OrderPortalCustomerBean {
	constructor() {
		this.customerId = 0 ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.status = '' ;
		this.statusString = '' ;
		this.dbaName = '' ;
		this.legalName = '' ;
		this.currencyCode = '' ;
		this.divisionCode = '' ;
		this.departmentCode = '' ;
		this.classCode = '' ;
		this.subClassCode = '' ;
		this.customerTypeCode = '' ;
		this.warehouseCode = '' ;
		this.shipViaCode = '' ;
		this.address1 = '' ;
		this.address2 = '' ;
		this.address3 = '' ;
		this.address4 = '' ;
		this.address5 = '' ;
		this.address6 = '' ;
		this.address7 = '' ;
		this.city = '' ;
		this.state = '' ;
		this.country = '' ;
		this.zip = '' ;
		this.email = '' ;
		this.mobilePhone = '' ;
		this.phone1 = '' ;
		this.phone2 = '' ;
		this.fax = '' ;
		this.fax2 = '' ;
		this.website = '' ;
		this.contactPerson = '' ;
		this.ccEmail = '' ;
		this.freightMethodCode = '' ;
		this.accountRepresentative = '' ;
		this.paymentTermsCode = '' ;
		this.paymentMethodCode = '' ;
		this.remarks = '' ;
		this.approvedBy = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.portal.datasync.PortalAsnModuleBean */
export class PortalAsnModuleBean {
	constructor() {
		this.asnId = 0 ;
		this.companyCode = '' ;
		this.containerNumber = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.billOfLading = '' ;
		this.erpCreatedDate = '' ;
		this.lastUpdatedDate = '' ;
		this.lines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.portal.datasync.PortalAsnModuleLineBean */
export class PortalAsnModuleLineBean {
	constructor() {
		this.asnId = 0 ;
		this.asnLineId = 0 ;
		this.companyCode = '' ;
		this.asnOrderNumber = '' ;
		this.asnOrderLineNumber = 0 ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderLineNumber = 0 ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.totalAsnQuantity = 0 ;
		this.weight = 0 ;
		this.length = 0 ;
		this.erpCreatedDate = '' ;
		this.lastUpdatedDate = '' ;
		this.rollLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.portal.datasync.PortalAsnModuleRollLineBean */
export class PortalAsnModuleRollLineBean {
	constructor() {
		this.asnId = 0 ;
		this.rollLineId = 0 ;
		this.asnLineId = 0 ;
		this.companyCode = '' ;
		this.asnOrderNumber = '' ;
		this.asnOrderLineNumber = 0 ;
		this.asnOrderRollLineNumber = 0 ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderLineNumber = 0 ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.uomCode = '' ;
		this.vendorBatchNumber = '' ;
		this.asnQuantity = 0 ;
		this.weight = 0 ;
		this.length = 0 ;
		this.erpCreatedDate = '' ;
		this.lastUpdatedDate = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.portal.datasync.PortalDataSynchronizationTrackBean */
export class PortalDataSynchronizationTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.entityType = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.portal.pagelist.PortalSalesOrderPageListBean */
export class PortalSalesOrderPageListBean {
	constructor() {
		this.portalSalesOrders = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.portal.pagelist.response.PortalSalesOrderPageListResponseBean */
export class PortalSalesOrderPageListResponseBean {
	constructor() {
		this.portalSalesOrderPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.portal.PortalSalesOrderBean */
export class PortalSalesOrderBean {
	constructor() {
		this.companyCode = '' ;
		this.customerOrder = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.customerTypeCode = '' ;
		this.orderDate = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.paymentTermCode = '' ;
		this.paymentMethodCode = '' ;
		this.shipViaCode = '' ;
		this.lineDetails = '' ;
		this.syncStatus = '' ;
		this.erpOrderNumber = '' ;
		this.errorMessage = '' ;
		this.syncAttemptTime = '' ;
		this.syncCompletedTime = '' ;
		this.retryCount = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.portal.PortalSalesOrderLineJson */
export class PortalSalesOrderLineJson {
	constructor() {
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.orderQuantity = 0 ;
		this.uomCode = '' ;
		this.price = 0 ;
	}
}
/* ds.portal.PortalSalesOrderSyncStatus */
export class PortalSalesOrderSyncStatus {
	constructor() {
	}
}
/* ds.portal.response.PortalSalesOrderResponseBean */
export class PortalSalesOrderResponseBean {
	constructor() {
		this.portalSalesOrder = null ;
		this.alreadySynced = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.portal.SyncResponse */
export class SyncResponse {
	constructor() {
		this.success = false ;
		this.portalOrderRef = '' ;
		this.erpOrderNumber = '' ;
		this.status = '' ;
		this.message = '' ;
		this.alreadySynced = false ;
	}
}
/* ds.preproduction.PreProductionBean */
export class PreProductionBean {
	constructor() {
		this.companyCode = '' ;
		this.preProductionDate = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.status = '' ;
		this.planStartDate = '' ;
		this.planStopDate = '' ;
		this.actualStartDate = '' ;
		this.actualStopDate = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerTypeCode = '' ;
		this.customerDivision = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.address = null ;
		this.sampleFabricStyle = '' ;
		this.sampleFabricStyleName = '' ;
		this.colorCode = '' ;
		this.colorName = '' ;
		this.productType = '' ;
		this.productTypeName = '' ;
		this.patternType = '' ;
		this.patternTypeName = '' ;
		this.makeType = '' ;
		this.makeTypeName = '' ;
		this.width = '' ;
		this.widthUomCode = '' ;
		this.weight = 0 ;
		this.weightUomCode = '' ;
		this.notes = '' ;
		this.yarnDetails = '' ;
		this.filamentDetails = '' ;
		this.fibreDetails = '' ;
		this.usageDetails = '' ;
		this.stretchWrapWeftDetails = '' ;
		this.colorFitnessDetails = '' ;
		this.designerDetails = '' ;
		this.additionalTrails = '' ;
		this.productionRequirements = '' ;
		this.reasonCode = '' ;
		this.reasonDescription = '' ;
		this.compositionElementCode = '' ;
		this.compositionElementName = '' ;
		this.compostionPercentageValue = 0 ;
		this.stageCollectionCode = '' ;
		this.vendorStyle = '' ;
		this.erpStyle = '' ;
		this.designerStyle = '' ;
		this.designerDescription = '' ;
		this.designerColorName = '' ;
		this.leadTime = 0 ;
		this.minimumOrderQuantity = 0 ;
		this.usdCost = 0 ;
		this.rmbCost = 0 ;
		this.classCode = '' ;
		this.subClassCode = '' ;
		this.cleanCode = '' ;
		this.directionCode = '' ;
		this.abrasionCode = '' ;
		this.contentCode = '' ;
		this.backingCode = '' ;
		this.dateChanges = new Array() ;
		this.documents = new Array() ;
		this.preProductionCycles = new Array() ;
		this.customerDetails = new Array() ;
		this.colorDetails = new Array() ;
		this.changeHistories = new Array() ;
		this.statusTracks = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.preproduction.PreProductionChangeHistoryBean */
export class PreProductionChangeHistoryBean {
	constructor() {
		this.preProductionNumber = '' ;
		this.trackNumber = 0 ;
		this.companyCode = '' ;
		this.workStationCode = '' ;
		this.workStationIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.preproduction.PreProductionColorDetailBean */
export class PreProductionColorDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.preProductionNumber = '' ;
		this.lineNumber = 0 ;
		this.fabricStyleColorCode = '' ;
		this.vendorColorCode = '' ;
		this.orderQuantity = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.preproduction.PreProductionCycleBean */
export class PreProductionCycleBean {
	constructor() {
		this.preProductionNumber = '' ;
		this.companyCode = '' ;
		this.iteration = 0 ;
		this.submittedDate = '' ;
		this.reSubmittedDate = '' ;
		this.cycleStatus = '' ;
		this.planSampleReceivedDate = '' ;
		this.actualSampleReceivedDate = '' ;
		this.remarks = '' ;
		this.comments = '' ;
		this.reason = '' ;
		this.reasonDescription = '' ;
		this.preProductionstages = new Array() ;
		this.dateChanges = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.preproduction.PreProductionCycleDateChangeBean */
export class PreProductionCycleDateChangeBean {
	constructor() {
		this.companyCode = '' ;
		this.preProductionNumber = '' ;
		this.iteration = 0 ;
		this.trackNumber = 0 ;
		this.previousDate = '' ;
		this.currentDate = '' ;
		this.elementValue = 0 ;
		this.remarks = '' ;
		this.reasonCode = '' ;
		this.reasonDescription = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.preproduction.PreProductionCycleElementTrackHistoryBean */
export class PreProductionCycleElementTrackHistoryBean {
	constructor() {
		this.preProductionNumber = '' ;
		this.companyCode = '' ;
		this.iterationNumber = 0 ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.preproduction.PreProductionCycleElementTrackHistoryPageListBean */
export class PreProductionCycleElementTrackHistoryPageListBean {
	constructor() {
		this.histories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.preproduction.PreProductionDateChangeBean */
export class PreProductionDateChangeBean {
	constructor() {
		this.companyCode = '' ;
		this.preProductionNumber = '' ;
		this.trackNumber = 0 ;
		this.previousDate = '' ;
		this.currentDate = '' ;
		this.elementValue = 0 ;
		this.remarks = '' ;
		this.reasonCode = '' ;
		this.reasonDescription = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.preproduction.PreProductionDocumentBean */
export class PreProductionDocumentBean {
	constructor() {
		this.companyCode = '' ;
		this.preProductionNumber = '' ;
		this.documentCode = '' ;
		this.documentName = '' ;
		this.documentFilePath = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.preproduction.PreProductionElementTrackHistoryBean */
export class PreProductionElementTrackHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.preProductionNumber = '' ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.preproduction.PreProductionElementTrackHistoryPageListBean */
export class PreProductionElementTrackHistoryPageListBean {
	constructor() {
		this.histories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.preproduction.PreProductionPageListBean */
export class PreProductionPageListBean {
	constructor() {
		this.preProductions = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.preproduction.PreProductionSearchCriteria */
export class PreProductionSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.preProductionNumber = '' ;
		this.preProductionNumberStartsWith = '' ;
		this.preProductionNumberContains = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.status = '' ;
		this.customerCode = '' ;
		this.preProductionDateFrom = '' ;
		this.preProductionDateTo = '' ;
		this.planStartDateFrom = '' ;
		this.planStartDateTo = '' ;
		this.planStopDateFrom = '' ;
		this.planStopDateTo = '' ;
		this.actualStartDateFrom = '' ;
		this.actualStartDateTo = '' ;
		this.actualStopDateFrom = '' ;
		this.actualStopDateTo = '' ;
		this.sampleFabricStyle = '' ;
		this.sampleFabricStyleName = '' ;
		this.colorCode = '' ;
		this.stageCollectionCode = '' ;
		this.designerStyle = '' ;
		this.erpStyle = '' ;
	}
}
/* ds.preproduction.PreProductionStageBean */
export class PreProductionStageBean {
	constructor() {
		this.companyCode = '' ;
		this.preProductionNumber = '' ;
		this.iteration = 0 ;
		this.stageCollectionCode = '' ;
		this.stageCode = '' ;
		this.stageName = '' ;
		this.planStartReceivedDate = '' ;
		this.planStopReceivedDate = '' ;
		this.actualSampleReceivedDate = '' ;
		this.orderSequence = 0 ;
		this.duration = 0 ;
		this.leadTime = 0 ;
		this.stageStatus = '' ;
		this.remarks = '' ;
		this.comments = '' ;
		this.reason = '' ;
		this.reasonDescription = '' ;
		this.actualStartDate = '' ;
		this.actualStopDate = '' ;
		this.taskAlarmStatus = '' ;
		this.isExcludeFlag = false ;
		this.isLineLockFlag = false ;
		this.dateChanges = new Array() ;
		this.preproductionStageDocuments = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.preproduction.PreProductionStageDateChangeBean */
export class PreProductionStageDateChangeBean {
	constructor() {
		this.companyCode = '' ;
		this.preProductionNumber = '' ;
		this.iteration = 0 ;
		this.stageCollectionCode = '' ;
		this.stageCode = '' ;
		this.trackNumber = 0 ;
		this.previousDate = '' ;
		this.currentDate = '' ;
		this.elementValue = 0 ;
		this.remarks = '' ;
		this.reasonCode = '' ;
		this.reasonDescription = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.preproduction.PreProductionStageDocumentBean */
export class PreProductionStageDocumentBean {
	constructor() {
		this.companyCode = '' ;
		this.preProductionNumber = '' ;
		this.stageCollectionCode = '' ;
		this.stageCode = '' ;
		this.documentCode = '' ;
		this.iteration = 0 ;
		this.documentName = '' ;
		this.documentFilePath = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.preproduction.PreProductionStageElementTrackHistoryBean */
export class PreProductionStageElementTrackHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.preProductionNumber = '' ;
		this.iterationNumber = 0 ;
		this.stageCollectionCode = '' ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.preproduction.PreProductionStageElementTrackHistoryPageListBean */
export class PreProductionStageElementTrackHistoryPageListBean {
	constructor() {
		this.histories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.preproduction.PreProductionStatusTrackBean */
export class PreProductionStatusTrackBean {
	constructor() {
		this.preProductionNumber = '' ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.preproduction.PreProductionTargetCustomerDetailBean */
export class PreProductionTargetCustomerDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.preProductionNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerTypeCode = '' ;
		this.customerDivision = '' ;
		this.customerPONumber = '' ;
		this.address = null ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.preproduction.PreProductionTrackBean */
export class PreProductionTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.preProductionDate = '' ;
		this.status = '' ;
		this.planStartDate = '' ;
		this.planStopDate = '' ;
		this.actualStartDate = '' ;
		this.actualStopDate = '' ;
		this.sampleFabricStyle = '' ;
		this.sampleFabricStyleName = '' ;
		this.colorCode = '' ;
		this.productType = '' ;
		this.patternType = '' ;
		this.makeType = '' ;
		this.width = '' ;
		this.reasonCode = '' ;
		this.reasonDescription = '' ;
		this.remarks = '' ;
		this.iteration = 0 ;
		this.submittedDate = '' ;
		this.reSubmittedDate = '' ;
		this.cycleStatus = '' ;
		this.planSampleReceivedDate = '' ;
		this.actualSampleReceivedDate = '' ;
		this.stageCollectionCode = '' ;
		this.stageCollectionName = '' ;
		this.stageStatus = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.preproduction.response.PreProductionCycleElementHistoryPageListResponseBean */
export class PreProductionCycleElementHistoryPageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.preproduction.response.PreProductionElementHistoryPageListResponseBean */
export class PreProductionElementHistoryPageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.preproduction.response.PreProductionMergeOperationsResponseBean */
export class PreProductionMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.lockResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.preproduction.response.PreProductionModuleMergeResponseBean */
export class PreProductionModuleMergeResponseBean {
	constructor() {
		this.preProductionResponse = null ;
		this.lockResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.preproduction.response.PreProductionPageListResponseBean */
export class PreProductionPageListResponseBean {
	constructor() {
		this.preProductionPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.preproduction.response.PreProductionResponseBean */
export class PreProductionResponseBean {
	constructor() {
		this.preProductionBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.preproduction.response.PreProductionStageElementHistoryPageListResponseBean */
export class PreProductionStageElementHistoryPageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.criteria.FabricStyleAdvancedPurchaseCostInputCriteriaBean */
export class FabricStyleAdvancedPurchaseCostInputCriteriaBean {
	constructor() {
		this.skuNumberList = null ;
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.fabricStyleCode = '' ;
		this.uomCode = '' ;
		this.colorCode = '' ;
		this.orderDate = '' ;
		this.incoTermCode = '' ;
		this.currencyCode = '' ;
		this.skuNumber = 0 ;
	}
}
/* ds.purchase.criteria.FabricStylePurchaseCostInputCriteriaBean */
export class FabricStylePurchaseCostInputCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.fabricStyleCode = '' ;
		this.uomCode = '' ;
		this.colorCode = '' ;
		this.orderDate = '' ;
		this.incoTermCode = '' ;
		this.currencyCode = '' ;
		this.skuNumber = 0 ;
	}
}
/* ds.purchase.criteria.GroupPurchaseOrderSearchCriteria */
export class GroupPurchaseOrderSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.groupPurchaseOrderNumber = '' ;
		this.vendorCode = '' ;
		this.orderStatus = '' ;
		this.createdDate = '' ;
		this.orderDate = '' ;
	}
}
/* ds.purchase.criteria.PurchaseOrderLineAdjustmentTrackInquiryCriteriaBean */
export class PurchaseOrderLineAdjustmentTrackInquiryCriteriaBean {
	constructor() {
		this.purchaseOrderNumber = '' ;
		this.companyCode = '' ;
	}
}
/* ds.purchase.criteria.PurchaseOrderLinePurchaseCostSearchCriteria */
export class PurchaseOrderLinePurchaseCostSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.fromOrderStopDate = '' ;
		this.toOrderStopDate = '' ;
		this.vendorCode = '' ;
		this.fabricStyleCode = '' ;
	}
}
/* ds.purchase.criteria.PurchaseOrderLineSearchCriteria */
export class PurchaseOrderLineSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.fromOrderStopDate = '' ;
		this.toOrderStopDate = '' ;
		this.vendorCode = '' ;
		this.fabricStyleCode = '' ;
		this.lineStatus = '' ;
		this.orderStatus = '' ;
		this.orderDate = '' ;
		this.fromOrderStartDate = '' ;
		this.toOrderStartDate = '' ;
		this.lineNumber = 0 ;
	}
}
/* ds.purchase.criteria.PurchaseOrderSearchCriteria */
export class PurchaseOrderSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.createdDate = '' ;
		this.orderDate = '' ;
		this.vendorCode = '' ;
		this.orderStatus = '' ;
		this.orderStatusList = new Array() ;
		this.incoterm = '' ;
		this.orderStopDateFrom = '' ;
		this.orderStopDateTo = '' ;
		this.purchaseOrderNumberContains = '' ;
		this.purchaseOrderNumberStartsWith = '' ;
		this.fabricStyleCode = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.vendorName = '' ;
		this.etaDate = '' ;
		this.locationCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.customerCode = '' ;
		this.searchName = '' ;
		this.purchaseOrderNumbers = new Array() ;
	}
}
/* ds.purchase.criteria.PurchaseSourceSalesOrderLineDetailSearchCriteria */
export class PurchaseSourceSalesOrderLineDetailSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.skuNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.salesOrderNumber = '' ;
	}
}
/* ds.purchase.criteria.VendorPurchaseTrackSearchCriteria */
export class VendorPurchaseTrackSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.fromOrderStopDate = '' ;
		this.toOrderStopDate = '' ;
		this.vendorCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.sortByField = 0 ;
	}
}
/* ds.purchase.deps.GroupPurchaseOrderModuleDependenciesBean */
export class GroupPurchaseOrderModuleDependenciesBean {
	constructor() {
		this.groupPurchaseOrderBean = null ;
	}
}
/* ds.purchase.deps.PurchaseOrderModuleDependenciesBean */
export class PurchaseOrderModuleDependenciesBean {
	constructor() {
		this.adjustmentTracks = new Array() ;
		this.fabricStyles = new Array() ;
		this.receipts = new Array() ;
		this.dateConfigurationBean = null ;
	}
}
/* ds.purchase.deps.response.GroupPurchaseOrderModuleDependenciesResponseBean */
export class GroupPurchaseOrderModuleDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.deps.response.PurchaseOrderModuleDependenciesResponseBean */
export class PurchaseOrderModuleDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.GroupPurchaseOrderBean */
export class GroupPurchaseOrderBean {
	constructor() {
		this.companyCode = '' ;
		this.orderStatus = '' ;
		this.createdDate = '' ;
		this.orderDate = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.earliestOrderStartDate = '' ;
		this.latestOrderStopDate = '' ;
		this.remarks = '' ;
		this.orderLines = new Array() ;
		this.statusTracks = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.GroupPurchaseOrderLineBean */
export class GroupPurchaseOrderLineBean {
	constructor() {
		this.groupPurchaseOrderNumber = '' ;
		this.compannyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.vendorCode = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.currencyCode = '' ;
		this.totalAmount = 0 ;
	}
}
/* ds.purchase.GroupPurchaseOrderStatusTrackBean */
export class GroupPurchaseOrderStatusTrackBean {
	constructor() {
		this.orderNumber = '' ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.history.pagelist.PurchaseOrderElementHistoryPageListBean */
export class PurchaseOrderElementHistoryPageListBean {
	constructor() {
		this.histories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.purchase.history.pagelist.PurchaseOrderLineElementHistoryPageListBean */
export class PurchaseOrderLineElementHistoryPageListBean {
	constructor() {
		this.histories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.purchase.history.PurchaseOrderDateHistoryTrackBean */
export class PurchaseOrderDateHistoryTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.dateType = '' ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.history.PurchaseOrderElementHistoryBean */
export class PurchaseOrderElementHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.history.PurchaseOrderLineElementHistoryBean */
export class PurchaseOrderLineElementHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.lineNumber = 0 ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.history.response.PurchaseOrderElementHistoryPageListResponseBean */
export class PurchaseOrderElementHistoryPageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.history.response.PurchaseOrderLineElementHistoryPageListResponseBean */
export class PurchaseOrderLineElementHistoryPageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.intransit.criteria.InTransitInventoryCustomerAllocationSearchCriteria */
export class InTransitInventoryCustomerAllocationSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.inTransitCustomerAllocationCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.startDate = '' ;
		this.stopDate = '' ;
		this.status = '' ;
		this.excludedLocationCodes = new Array() ;
		this.locationCode = '' ;
	}
}
/* ds.purchase.intransit.criteria.InTransitRollSkuPrintInputBean */
export class InTransitRollSkuPrintInputBean {
	constructor() {
		this.rollSkuNumber = 0 ;
		this.inTransitNumber = '' ;
	}
}
/* ds.purchase.intransit.criteria.InTransitRollSkuPrintInputCriteria */
export class InTransitRollSkuPrintInputCriteria {
	constructor() {
		this.companyCode = '' ;
		this.rollSkuList = new Array() ;
		this.noOfCopies = 0 ;
	}
}
/* ds.purchase.intransit.criteria.PurchaseOrderInTransitForPurchaseOrderSearchCriteria */
export class PurchaseOrderInTransitForPurchaseOrderSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
	}
}
/* ds.purchase.intransit.criteria.PurchaseOrderInTransitLineSearchCriteria */
export class PurchaseOrderInTransitLineSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderLineNumber = 0 ;
		this.isApproved = false ;
		this.purchaseOrderInTransitNumber = '' ;
		this.purchaseOrderInTransitLineNumber = 0 ;
		this.purchaseOrderInTransitRollLineNumber = 0 ;
	}
}
/* ds.purchase.intransit.criteria.PurchaseOrderInTransitRollLineSearchCriteria */
export class PurchaseOrderInTransitRollLineSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderInTransitNumber = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.vendorLotNumber = '' ;
		this.rollSkuNumber = 0 ;
		this.purchaseOrderInTransitLineNumber = 0 ;
		this.purchaseOrderInTransitRollLineNumber = 0 ;
	}
}
/* ds.purchase.intransit.criteria.PurchaseOrderInTransitSearchCriteria */
export class PurchaseOrderInTransitSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderInTransitNumber = '' ;
		this.purchaseOrderNumber = '' ;
		this.createdDate = '' ;
		this.inTransitDate = '' ;
		this.vendorCode = '' ;
		this.inTransitStatus = '' ;
		this.inTransitDateFrom = '' ;
		this.inTransitDateTo = '' ;
		this.purchaseOrderInTransitNumberStartsWith = '' ;
		this.purchaseOrderInTransitNumberContains = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.vendorName = '' ;
		this.searchName = '' ;
	}
}
/* ds.purchase.intransit.deps.PurchaseOrderInTransitModuleDependenciesBean */
export class PurchaseOrderInTransitModuleDependenciesBean {
	constructor() {
		this.purchaseOrder = null ;
		this.fabricStyles = new Array() ;
	}
}
/* ds.purchase.intransit.deps.response.PurchaseOrderInTransitModuleDependenciesResponseBean */
export class PurchaseOrderInTransitModuleDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.intransit.history.pagelist.PurchaseOrderInTransitElementHistoryPageListBean */
export class PurchaseOrderInTransitElementHistoryPageListBean {
	constructor() {
		this.histories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.purchase.intransit.history.pagelist.PurchaseOrderInTransitLineElementHistoryPageListBean */
export class PurchaseOrderInTransitLineElementHistoryPageListBean {
	constructor() {
		this.histories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.purchase.intransit.history.PurchaseOrderInTransitElementHistoryBean */
export class PurchaseOrderInTransitElementHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderInTransitNumber = '' ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.intransit.history.PurchaseOrderInTransitLineElementHistoryBean */
export class PurchaseOrderInTransitLineElementHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderInTransitNumber = '' ;
		this.lineGroupNumber = 0 ;
		this.lineNumber = 0 ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.intransit.history.response.PurchaseOrderInTransitElementHistoryPageListResponseBean */
export class PurchaseOrderInTransitElementHistoryPageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.intransit.history.response.PurchaseOrderInTransitLineElementHistoryPageListResponseBean */
export class PurchaseOrderInTransitLineElementHistoryPageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.intransit.InTransitInventoryCustomerAllocationBean */
export class InTransitInventoryCustomerAllocationBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.startDate = '' ;
		this.stopDate = '' ;
		this.status = '' ;
		this.inTransitQuantity = 0 ;
		this.isCancelAllocation = false ;
		this.widthCode = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.locationCode = '' ;
		this.remarks = '' ;
		this.fobCost = 0 ;
		this.landedCost = 0 ;
		this.containerNumber = '' ;
		this.etaDate = '' ;
		this.rollNumber = '' ;
		this.millPieceNumber = '' ;
		this.binLocation = '' ;
		this.millName = '' ;
		this.millCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.intransit.InTransitInventoryCustomerAllocationPageListBean */
export class InTransitInventoryCustomerAllocationPageListBean {
	constructor() {
		this.inTransitInventoryAllocations = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.purchase.intransit.IntransitInventoryCustomerAllocationPageListResponseBean */
export class IntransitInventoryCustomerAllocationPageListResponseBean {
	constructor() {
		this.inTransitCustomerAllocationPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.intransit.merge.response.PurchaseOrderInTransitMergeOperationsResponseBean */
export class PurchaseOrderInTransitMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.lockResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.intransit.merge.response.PurchaseOrderInTransitModuleMergeResponseBean */
export class PurchaseOrderInTransitModuleMergeResponseBean {
	constructor() {
		this.purchaseOrderInTransitResponse = null ;
		this.lockResponse = null ;
		this.dependenciesResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.intransit.pagelist.PurchaseOrderInTransitLinePageListBean */
export class PurchaseOrderInTransitLinePageListBean {
	constructor() {
		this.purchaseOrderInTransitLines = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.purchase.intransit.pagelist.PurchaseOrderInTransitPageListBean */
export class PurchaseOrderInTransitPageListBean {
	constructor() {
		this.purchaseOrderinTransits = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.purchase.intransit.pagelist.PurchaseOrderInTransitRollLinePageListBean */
export class PurchaseOrderInTransitRollLinePageListBean {
	constructor() {
		this.purchaseOrderInTransitRollLines = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.purchase.intransit.pagelist.response.PurchaseOrderInTransitLinePageListResponseBean */
export class PurchaseOrderInTransitLinePageListResponseBean {
	constructor() {
		this.purchaseOrderInTransitLinePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.intransit.pagelist.response.PurchaseOrderInTransitPageListResponseBean */
export class PurchaseOrderInTransitPageListResponseBean {
	constructor() {
		this.inTransitPageListBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.intransit.pagelist.response.PurchaseOrderInTransitRollLinePageListResponseBean */
export class PurchaseOrderInTransitRollLinePageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.intransit.PurchaseOrderInTransitBean */
export class PurchaseOrderInTransitBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.factoryCode = '' ;
		this.inTransitDate = '' ;
		this.inTransitStatus = '' ;
		this.shipmentTermsCode = '' ;
		this.fOBCity = '' ;
		this.shipViaCode = '' ;
		this.locationCode = '' ;
		this.packingSlipNumber = '' ;
		this.badQualityLocationCode = '' ;
		this.comments = '' ;
		this.etaDate = '' ;
		this.containerNumber = '' ;
		this.containerDetail = '' ;
		this.billOfLading = '' ;
		this.businessDivision = '' ;
		this.customerCode = '' ;
		this.customerReferenceNumber = '' ;
		this.fabricStyleCode = '' ;
		this.etdDate = '' ;
		this.vendorInvoiceNumber = '' ;
		this.lines = new Array() ;
		this.statusTracks = new Array() ;
		this.changeHistoryTracks = new Array() ;
		this.purchaseOrderInTransitImages = new Array() ;
		this.purchaseOrderInTransitDocuments = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.intransit.PurchaseOrderInTransitChangeHistoryBean */
export class PurchaseOrderInTransitChangeHistoryBean {
	constructor() {
		this.purchaseOrderInTransitNumber = '' ;
		this.trackNumber = 0 ;
		this.companyCode = '' ;
		this.workStationCode = '' ;
		this.workStationIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.intransit.PurchaseOrderInTransitDetailInfoBean */
export class PurchaseOrderInTransitDetailInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.purchaseOrderNumber = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.factoryCode = '' ;
		this.vendorStyleCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.locationCode = '' ;
		this.uomCode = '' ;
		this.packingSlipNumber = '' ;
		this.openOrderQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.receiptDate = '' ;
		this.receiptStatus = '' ;
	}
}
/* ds.purchase.intransit.PurchaseOrderInTransitDocumentBean */
export class PurchaseOrderInTransitDocumentBean {
	constructor() {
		this.purchaseOrderInTransitNumber = '' ;
		this.companyCode = '' ;
		this.documentOriginalName = '' ;
		this.documentNumber = 0 ;
		this.documentCode = '' ;
		this.documentPath = '' ;
		this.documentName = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.intransit.PurchaseOrderInTransitElectronicInputBean */
export class PurchaseOrderInTransitElectronicInputBean {
	constructor() {
		this.purchaseOrderNumber = '' ;
		this.receivedDate = '' ;
		this.totalQuantityText = '' ;
		this.rollLines = new Array() ;
	}
}
/* ds.purchase.intransit.PurchaseOrderInTransitElectronicRollInputBean */
export class PurchaseOrderInTransitElectronicRollInputBean {
	constructor() {
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.rollNumber = '' ;
		this.lotNumber = '' ;
		this.boxNumber = '' ;
		this.quantity = 0 ;
		this.infoText = '' ;
		this.aisleInfoText = '' ;
	}
}
/* ds.purchase.intransit.PurchaseOrderInTransitImageBean */
export class PurchaseOrderInTransitImageBean {
	constructor() {
		this.purchaseOrderInTransitNumber = '' ;
		this.imageCode = '' ;
		this.imagePart = '' ;
		this.imagePath = '' ;
		this.imageName = '' ;
		this.companyCode = '' ;
		this.imageOritinalname = '' ;
		this.tags = '' ;
		this.notesCommunication = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.intransit.PurchaseOrderInTransitLineBean */
export class PurchaseOrderInTransitLineBean {
	constructor() {
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderLineNumber = 0 ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.lineStatus = '' ;
		this.widthCode = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.upcCode = '' ;
		this.uomCode = '' ;
		this.companyCode = '' ;
		this.purchaseOrderInTransitNumber = '' ;
		this.openOrderQuantity = 0 ;
		this.purchaseOrderQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.receivedQuantityToDate = 0 ;
		this.inTransitQuantity = 0 ;
		this.inTransitQuantityToDate = 0 ;
		this.goodQualityInTransitQuantity = 0 ;
		this.badQualityInTransitQuantity = 0 ;
		this.locationCode = '' ;
		this.comments = '' ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = 0 ;
		this.vendorStyleCode = '' ;
		this.vendorStyleColorCode = '' ;
		this.adjustedTransitQuantity = 0 ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.externalCustomerCode = '' ;
		this.externalCustomerName = '' ;
		this.fobCost = 0 ;
		this.landedCost = 0 ;
		this.inTransitRollLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.intransit.PurchaseOrderInTransitResultBean */
export class PurchaseOrderInTransitResultBean {
	constructor() {
		this.purchaseOrderInTransits = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.intransit.PurchaseOrderInTransitRollLineBean */
export class PurchaseOrderInTransitRollLineBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderInTransitNumber = '' ;
		this.inTransitRollLineNumber = 0 ;
		this.inTransitLineNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.locationCode = '' ;
		this.locationType = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.widthCode = '' ;
		this.uomCode = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.receivedQuantity = 0 ;
		this.inTransitQuantity = 0 ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = 0 ;
		this.boxNumber = '' ;
		this.vendorLotNumber = '' ;
		this.infoText = '' ;
		this.aisleInfoText = '' ;
		this.purchaseOrderNumber = '' ;
		this.adjustedTransitQuantity = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.intransit.PurchaseOrderInTransitStatusTrackBean */
export class PurchaseOrderInTransitStatusTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderInTransitNumber = '' ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.intransit.PurchaseOrderInTransitUpdateInfo */
export class PurchaseOrderInTransitUpdateInfo {
	constructor() {
		this.purchaseOrderList = null ;
		this.lineList = null ;
	}
}
/* ds.purchase.intransit.response.PurchaseOrderInTransitElectronicInputResponseBean */
export class PurchaseOrderInTransitElectronicInputResponseBean {
	constructor() {
		this.eInput = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.intransit.response.PurchaseOrderInTransitResponseBean */
export class PurchaseOrderInTransitResponseBean {
	constructor() {
		this.purchaseOrderinTransit = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.intransit.response.PurchaseOrderInTransitResultResponseBean */
export class PurchaseOrderInTransitResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.merge.response.GroupPurchaseOrderModuleMergeResponseBean */
export class GroupPurchaseOrderModuleMergeResponseBean {
	constructor() {
		this.groupPurchaseOrderResponse = null ;
		this.lockResponse = null ;
		this.dependenciesResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.merge.response.PurchaseOrderMergeOperationsResponseBean */
export class PurchaseOrderMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.lockResponse = null ;
		this.reportResult = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.merge.response.PurchaseOrderModuleMergeResponseBean */
export class PurchaseOrderModuleMergeResponseBean {
	constructor() {
		this.purchaseOrderResponse = null ;
		this.lockResponse = null ;
		this.dependenciesResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.pagelist.GroupPurchaseOrderPageListBean */
export class GroupPurchaseOrderPageListBean {
	constructor() {
		this.groupPurchaseOrders = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.purchase.pagelist.PurchaseOrderLineAdjustmentTrackPageListBean */
export class PurchaseOrderLineAdjustmentTrackPageListBean {
	constructor() {
		this.adjustmentTracks = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.purchase.pagelist.PurchaseOrderLinePageListBean */
export class PurchaseOrderLinePageListBean {
	constructor() {
		this.purchaseOrderLines = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.purchase.pagelist.PurchaseOrderPageListBean */
export class PurchaseOrderPageListBean {
	constructor() {
		this.purchaseOrders = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.purchase.pagelist.response.GroupPurchaseOrderPageListResponseBean */
export class GroupPurchaseOrderPageListResponseBean {
	constructor() {
		this.groupPurchaseOrderPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.pagelist.response.PurchaseLineAdjustmentTrackInquiryPageListResponseBean */
export class PurchaseLineAdjustmentTrackInquiryPageListResponseBean {
	constructor() {
		this.inquiryResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.pagelist.response.PurchaseOrderLinePageListResponseBean */
export class PurchaseOrderLinePageListResponseBean {
	constructor() {
		this.purchaseOrderLinePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.pagelist.response.PurchaseOrderPageListResponseBean */
export class PurchaseOrderPageListResponseBean {
	constructor() {
		this.purchaseOrderPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.PurchaseOrderBean */
export class PurchaseOrderBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.groupPurchaseOrderNumber = '' ;
		this.factoryCode = '' ;
		this.orderStatus = '' ;
		this.orderDate = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.etaDate = '' ;
		this.shipppingInstructions = '' ;
		this.buyingTermsCode = '' ;
		this.shipmentTermsCode = '' ;
		this.fOBCity = '' ;
		this.currencyCode = '' ;
		this.shipViaCode = '' ;
		this.daysToFrightForwarding = 0 ;
		this.approvalNumber = '' ;
		this.address = null ;
		this.shipToCode = '' ;
		this.shipToName = '' ;
		this.shippingAddress = null ;
		this.orderSubTotal = 0 ;
		this.taxAmount = 0 ;
		this.discountAmount = 0 ;
		this.shipmentChargesAmount = 0 ;
		this.extraCharge = 0 ;
		this.miscellaneousCharge = 0 ;
		this.grandTotalAmount = 0 ;
		this.adjustedQuantityAmount = 0 ;
		this.receivedQuantityAmount = 0 ;
		this.extraChargeReasonCode = '' ;
		this.miscellaneousChargeReasonCode = '' ;
		this.comments = '' ;
		this.locationCode = '' ;
		this.receiptTolerancePercentage = 0 ;
		this.incoterm = '' ;
		this.lCNumber = '' ;
		this.generateCpm = false ;
		this.fabricStyleCode = '' ;
		this.shippingInstructions = '' ;
		this.oldSystemPurchaseOrderNumber = '' ;
		this.purchaseOrderTotalQuantity = 0 ;
		this.purchseOrderDetailCount = 0 ;
		this.startDateChangeReasonCode = '' ;
		this.stopDateChangeReasonCode = '' ;
		this.xFactoryDateChangeReasonCode = '' ;
		this.inConsolidationDateChangeReasonCode = '' ;
		this.inDcDateChangeReasonCode = '' ;
		this.etaDateChangeReasonCode = '' ;
		this.startDateChangeReason = '' ;
		this.stopDateChangeReason = '' ;
		this.xFactoryDateChangeReason = '' ;
		this.inConsolidationDateChangeReason = '' ;
		this.inDcDateChangeReason = '' ;
		this.etaDateChangeReason = '' ;
		this.purchaseOrderModel = '' ;
		this.isAllowZeroCostFlag = false ;
		this.orderType = '' ;
		this.purchaseDivisionCode = '' ;
		this.destination = '' ;
		this.businessDivision = '' ;
		this.customerCode = '' ;
		this.customerReferenceNumber = '' ;
		this.containerNumber = '' ;
		this.vendorInvoiceNumber = '' ;
		this.etdDate = '' ;
		this.paymentStatus = '' ;
		this.purchaseOrderReceiptIndex = 0 ;
		this.lines = new Array() ;
		this.statusTracks = new Array() ;
		this.changeHistoryTracks = new Array() ;
		this.communicationNotes = new Array() ;
		this.logisticsPlanUpdates = new Array() ;
		this.currentLogisticsPlanUpdate = null ;
		this.orderDateHistoryTracks = new Array() ;
		this.purchaseOrderDocuments = new Array() ;
		this.orderImages = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.PurchaseOrderChangeHistoryBean */
export class PurchaseOrderChangeHistoryBean {
	constructor() {
		this.purchaseOrderNumber = '' ;
		this.trackNumber = 0 ;
		this.companyCode = '' ;
		this.workStationCode = '' ;
		this.workStationIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.PurchaseOrderCommunicationNotesBean */
export class PurchaseOrderCommunicationNotesBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.lineNumber = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.PurchaseOrderCustomerReservationDetailBean */
export class PurchaseOrderCustomerReservationDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderLineNumber = 0 ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.orderQuantity = 0 ;
		this.openQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.remarks = '' ;
		this.locationCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.PurchaseOrderDocumentBean */
export class PurchaseOrderDocumentBean {
	constructor() {
		this.purchaseOrderNumber = '' ;
		this.companyCode = '' ;
		this.documentOriginalName = '' ;
		this.documentNumber = 0 ;
		this.documentCode = '' ;
		this.documentPath = '' ;
		this.documentName = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.PurchaseOrderImageBean */
export class PurchaseOrderImageBean {
	constructor() {
		this.purchaseOrderNumber = '' ;
		this.imageCode = '' ;
		this.imagePart = '' ;
		this.imagePath = '' ;
		this.imageName = '' ;
		this.companyCode = '' ;
		this.imageOritinalname = '' ;
		this.tags = '' ;
		this.notesCommunication = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.PurchaseOrderInquiryResultBean */
export class PurchaseOrderInquiryResultBean {
	constructor() {
		this.purchaseOrders = new Array() ;
		this.purchaseOrderLines = new Array() ;
		this.purchaseOrderReceipts = new Array() ;
		this.purchaseOrderReceiptLines = new Array() ;
	}
}
/* ds.purchase.PurchaseOrderLineAdjustmentBean */
export class PurchaseOrderLineAdjustmentBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.lineNumber = 0 ;
		this.adjustmentLineNumber = 0 ;
		this.adjustedQuantity = 0 ;
		this.adjustmentType = '' ;
		this.uomCode = '' ;
		this.lineStatus = '' ;
		this.remarks = '' ;
		this.orderStatus = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.PurchaseOrderLineAdjustmentTrackBean */
export class PurchaseOrderLineAdjustmentTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.lineNumber = 0 ;
		this.adjustmentLineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.upcCode = '' ;
		this.uomCode = '' ;
		this.orderStatus = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.openBalance = 0 ;
		this.changedUnits = 0 ;
		this.closeBalance = 0 ;
		this.trackType = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.PurchaseOrderLineBean */
export class PurchaseOrderLineBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.lineStatus = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.upcCode = '' ;
		this.uomCode = '' ;
		this.price = 0 ;
		this.cost = 0 ;
		this.landedCost = 0 ;
		this.fobCost = 0 ;
		this.openQuantity = 0 ;
		this.orderQuantity = 0 ;
		this.adjustedQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.receivedAdjustedQuantity = 0 ;
		this.lineTotalAmount = 0 ;
		this.locationCode = '' ;
		this.inDCDate = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.productDivisionCode = '' ;
		this.productDepartmentCode = '' ;
		this.productClassCode = '' ;
		this.productSubClassCode = '' ;
		this.purchaseOrderScheduleNumber = '' ;
		this.techDesigner = '' ;
		this.cpmTemplateCode = '' ;
		this.extraCharge = 0 ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = 0 ;
		this.vendorStyleCode = '' ;
		this.vendorStyleColorCode = '' ;
		this.currencyCode = '' ;
		this.oldSystemPurchaseOrderLineNumber = '' ;
		this.extraInfo = '' ;
		this.weightInfo = '' ;
		this.inTransitQuantity = 0 ;
		this.inTransitAdjustedQuantity = 0 ;
		this.productionStatus = '' ;
		this.productionNotes = '' ;
		this.sts = '' ;
		this.availableDate = '' ;
		this.sailDate = '' ;
		this.estimatedShipDate = '' ;
		this.contentInfo = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.externalCustomerCode = '' ;
		this.externalCustomerName = '' ;
		this.commentCode = '' ;
		this.comments = '' ;
		this.isAllowZeroQuantity = false ;
		this.adjustmentLines = new Array() ;
		this.logisticsPlanUpdates = new Array() ;
		this.currentLogisticsPlanUpdate = null ;
		this.sourceSalesOrderLines = new Array() ;
		this.customerReservationLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.PurchaseOrderLineDatasElectronicInputBean */
export class PurchaseOrderLineDatasElectronicInputBean {
	constructor() {
		this.companyCode = '' ;
		this.poLines = new Array() ;
		this.fabricImages = new Array() ;
	}
}
/* ds.purchase.PurchaseOrderLineLogisticsPlanUpdateBean */
export class PurchaseOrderLineLogisticsPlanUpdateBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderLineNumber = 0 ;
		this.changeTrackNumber = 0 ;
		this.xFactoryDate = '' ;
		this.inConsolidatorDCDate = '' ;
		this.inDCDate = '' ;
		this.comments = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.PurchaseOrderLogisticsPlanDatesConfigurationBean */
export class PurchaseOrderLogisticsPlanDatesConfigurationBean {
	constructor() {
		this.millReadyDays = 0 ;
		this.sailTransportDays = 0 ;
		this.inPortDays = 0 ;
		this.portToStoreTransportDays = 0 ;
	}
}
/* ds.purchase.PurchaseOrderLogisticsPlanUpdateBean */
export class PurchaseOrderLogisticsPlanUpdateBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.changeTrackNumber = 0 ;
		this.xFactoryDate = '' ;
		this.inConsolidatorDCDate = '' ;
		this.inDCDate = '' ;
		this.comments = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.PurchaseOrderStatusTrackBean */
export class PurchaseOrderStatusTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.totalOrderAmount = 0 ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.PurchaseSourceSalesOrderDetailLineBean */
export class PurchaseSourceSalesOrderDetailLineBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderLineNumber = 0 ;
		this.salesOrderNumber = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.orderQuantity = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.PurchaseSourceSalesOrderLineDetailResultBean */
export class PurchaseSourceSalesOrderLineDetailResultBean {
	constructor() {
		this.companyCode = '' ;
		this.sourceSalesOrderDetailLines = new Array() ;
	}
}
/* ds.purchase.receipt.criteria.PurchaseOrderReceiptApprovalCriteriaBean */
export class PurchaseOrderReceiptApprovalCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.purchaseOrderReceiptApprovalNumber = '' ;
		this.purchaseOrderNumber = '' ;
		this.vendorCode = '' ;
		this.isExcludePaidFlag = false ;
	}
}
/* ds.purchase.receipt.criteria.PurchaseOrderReceiptLineSearchCriteria */
export class PurchaseOrderReceiptLineSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderLineNumber = 0 ;
		this.isApproved = false ;
		this.purchaseOrderReceiptNumber = '' ;
		this.purchaseOrderReceiptLineNumber = 0 ;
	}
}
/* ds.purchase.receipt.criteria.PurchaseOrderReceiptSearchCriteria */
export class PurchaseOrderReceiptSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.purchaseOrderNumber = '' ;
		this.createdDate = '' ;
		this.receiptDate = '' ;
		this.vendorCode = '' ;
		this.receiptStatus = '' ;
		this.receiptDateFrom = '' ;
		this.receiptDateTo = '' ;
		this.purchaseOrderReceiptNumberStartsWith = '' ;
		this.purchaseOrderReceiptNumberContains = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.vendorName = '' ;
		this.searchName = '' ;
	}
}
/* ds.purchase.receipt.deps.PurchaseOrderReceiptModuleDependenciesBean */
export class PurchaseOrderReceiptModuleDependenciesBean {
	constructor() {
		this.purchaseOrder = null ;
		this.fabricStyles = new Array() ;
	}
}
/* ds.purchase.receipt.deps.response.PurchaseOrderReceiptModuleDependenciesResponseBean */
export class PurchaseOrderReceiptModuleDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.receipt.history.pagelist.PurchaseOrderReceiptElementHistoryPageListBean */
export class PurchaseOrderReceiptElementHistoryPageListBean {
	constructor() {
		this.histories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.purchase.receipt.history.pagelist.PurchaseOrderReceiptLineElementHistoryPageListBean */
export class PurchaseOrderReceiptLineElementHistoryPageListBean {
	constructor() {
		this.histories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.purchase.receipt.history.PurchaseOrderReceiptElementHistoryBean */
export class PurchaseOrderReceiptElementHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.receipt.history.PurchaseOrderReceiptLineElementHistoryBean */
export class PurchaseOrderReceiptLineElementHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.lineGroupNumber = 0 ;
		this.lineNumber = 0 ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.receipt.history.response.PurchaseOrderReceiptElementHistoryPageListResponseBean */
export class PurchaseOrderReceiptElementHistoryPageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.receipt.history.response.PurchaseOrderReceiptLineElementHistoryPageListResponseBean */
export class PurchaseOrderReceiptLineElementHistoryPageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.receipt.merge.response.PurchaseOrderReceiptMergeOperationsResponseBean */
export class PurchaseOrderReceiptMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.lockResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.receipt.merge.response.PurchaseOrderReceiptModuleMergeResponseBean */
export class PurchaseOrderReceiptModuleMergeResponseBean {
	constructor() {
		this.purchaseOrderReceiptResponse = null ;
		this.lockResponse = null ;
		this.dependenciesResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.receipt.pagelist.PurchaseOrderReceiptApprovalPageListBean */
export class PurchaseOrderReceiptApprovalPageListBean {
	constructor() {
		this.purchaseOrderApprovalReceipts = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.purchase.receipt.pagelist.PurchaseOrderReceiptLinePageListBean */
export class PurchaseOrderReceiptLinePageListBean {
	constructor() {
		this.purchaseOrderReceiptLines = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.purchase.receipt.pagelist.PurchaseOrderReceiptPageListBean */
export class PurchaseOrderReceiptPageListBean {
	constructor() {
		this.purchaseOrderReceipts = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.purchase.receipt.pagelist.PurchaseReceiptDetailsPageListBean */
export class PurchaseReceiptDetailsPageListBean {
	constructor() {
		this.infos = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.purchase.receipt.pagelist.response.PurchaseOrderReceiptApprovalPageListResponseBean */
export class PurchaseOrderReceiptApprovalPageListResponseBean {
	constructor() {
		this.purchaseOrderReceiptApprovalPageListBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.receipt.pagelist.response.PurchaseOrderReceiptLinePageListResponseBean */
export class PurchaseOrderReceiptLinePageListResponseBean {
	constructor() {
		this.purchaseOrderReceiptLinePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.receipt.pagelist.response.PurchaseOrderReceiptPageListResponseBean */
export class PurchaseOrderReceiptPageListResponseBean {
	constructor() {
		this.purchaseOrderReceiptPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.receipt.pagelist.response.PurchaseReceiptDetailsPageListResponseBean */
export class PurchaseReceiptDetailsPageListResponseBean {
	constructor() {
		this.receivedInventoryPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.receipt.PurchaseOrderReceiptApprovalBean */
export class PurchaseOrderReceiptApprovalBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.totalQuantity = 0 ;
		this.receiptAmount = 0 ;
		this.approvedAmount = 0 ;
		this.appliedAmount = 0 ;
		this.paidAmount = 0 ;
		this.openApprovedAmount = 0 ;
		this.status = '' ;
		this.receiptApprovalLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.receipt.PurchaseOrderReceiptApprovalLineBean */
export class PurchaseOrderReceiptApprovalLineBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.approvalLineNumber = 0 ;
		this.amount = 0 ;
		this.receiptLineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.approvalNumber = '' ;
		this.locationCode = '' ;
		this.skuNumber = 0 ;
		this.cost = 0 ;
		this.quantity = 0 ;
		this.fabricStyleColorCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.receipt.PurchaseOrderReceiptBean */
export class PurchaseOrderReceiptBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.factoryCode = '' ;
		this.receiptDate = '' ;
		this.receiptStatus = '' ;
		this.shipmentTermsCode = '' ;
		this.fOBCity = '' ;
		this.shipViaCode = '' ;
		this.locationCode = '' ;
		this.packingSlipNumber = '' ;
		this.badQualityLocationCode = '' ;
		this.containerNumber = '' ;
		this.billOfLading = '' ;
		this.comments = '' ;
		this.purchaseOrderInTransitNumber = '' ;
		this.customerCode = '' ;
		this.customerReferenceNumber = '' ;
		this.fabricStyleCode = '' ;
		this.vendorInvoiceNumber = '' ;
		this.etaDate = '' ;
		this.etdDate = '' ;
		this.lines = new Array() ;
		this.statusTracks = new Array() ;
		this.changeHistoryTracks = new Array() ;
		this.imageName = '' ;
		this.imageFilePath = '' ;
		this.documentName = '' ;
		this.documentFilePath = '' ;
		this.allowZeroReceivedQty = false ;
		this.paymentStatus = '' ;
		this.receiptImages = new Array() ;
		this.receiptDocuments = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.receipt.PurchaseOrderReceiptChangeHistoryBean */
export class PurchaseOrderReceiptChangeHistoryBean {
	constructor() {
		this.purchaseOrderReceiptNumber = '' ;
		this.trackNumber = 0 ;
		this.companyCode = '' ;
		this.workStationCode = '' ;
		this.workStationIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.receipt.PurchaseOrderReceiptDetailInfoBean */
export class PurchaseOrderReceiptDetailInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.purchaseOrderNumber = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.factoryCode = '' ;
		this.vendorStyleCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.locationCode = '' ;
		this.uomCode = '' ;
		this.packingSlipNumber = '' ;
		this.openOrderQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.receiptDate = '' ;
		this.receiptStatus = '' ;
		this.purchaseOrderDate = '' ;
	}
}
/* ds.purchase.receipt.PurchaseOrderReceiptDocumentBean */
export class PurchaseOrderReceiptDocumentBean {
	constructor() {
		this.purchaseOrderReceiptNumber = '' ;
		this.companyCode = '' ;
		this.documentOriginalName = '' ;
		this.documentNumber = 0 ;
		this.documentCode = '' ;
		this.documentPath = '' ;
		this.documentName = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.receipt.PurchaseOrderReceiptElectronicInputBean */
export class PurchaseOrderReceiptElectronicInputBean {
	constructor() {
		this.purchaseOrderNumber = '' ;
		this.receivedDate = '' ;
		this.totalQuantityText = '' ;
		this.rollLines = new Array() ;
	}
}
/* ds.purchase.receipt.PurchaseOrderReceiptElectronicRollInputBean */
export class PurchaseOrderReceiptElectronicRollInputBean {
	constructor() {
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.rollNumber = '' ;
		this.lotNumber = '' ;
		this.boxNumber = '' ;
		this.quantity = 0 ;
		this.infoText = '' ;
		this.aisleInfoText = '' ;
	}
}
/* ds.purchase.receipt.PurchaseOrderReceiptImageBean */
export class PurchaseOrderReceiptImageBean {
	constructor() {
		this.purchaseOrderReceiptNumber = '' ;
		this.imageCode = '' ;
		this.imagePart = '' ;
		this.imagePath = '' ;
		this.imageName = '' ;
		this.companyCode = '' ;
		this.imageOritinalname = '' ;
		this.tags = '' ;
		this.notesCommunication = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.receipt.PurchaseOrderReceiptLineBean */
export class PurchaseOrderReceiptLineBean {
	constructor() {
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderLineNumber = 0 ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.lineStatus = '' ;
		this.widthCode = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.upcCode = '' ;
		this.uomCode = '' ;
		this.companyCode = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.openOrderQuantity = 0 ;
		this.purchaseOrderQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.receivedQuantityToDate = 0 ;
		this.goodQualityReceivedQuantity = 0 ;
		this.badQualityReceivedQuantity = 0 ;
		this.locationCode = '' ;
		this.comments = '' ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = 0 ;
		this.vendorStyleCode = '' ;
		this.vendorStyleColorCode = '' ;
		this.inTransitQuantity = 0 ;
		this.openInTransistQuantity = 0 ;
		this.purchaseOrderInTransitLineNumber = 0 ;
		this.purchaseOrderInTransitNumber = '' ;
		this.linePiecesReceived = 0 ;
		this.lineCostPrice = 0 ;
		this.lineTotalAmountReceived = 0 ;
		this.lineQuantityRemaining = 0 ;
		this.linePiecesRemaining = 0 ;
		this.lineRemainingAmount = 0 ;
		this.lineAmountOrdered = 0 ;
		this.linePercentSold = 0 ;
		this.lineQuantitySold = 0 ;
		this.receiptRollLines = new Array() ;
		this.isApproved = false ;
		this.approvedNumber = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.receipt.PurchaseOrderReceiptRollLineBean */
export class PurchaseOrderReceiptRollLineBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.receiptRollLineNumber = 0 ;
		this.receiptLineNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.locationCode = '' ;
		this.locationType = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.widthCode = '' ;
		this.uomCode = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.receivedQuantity = 0 ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = 0 ;
		this.inventoryReceivedQuantity = 0 ;
		this.boxNumber = '' ;
		this.vendorLotNumber = '' ;
		this.infoText = '' ;
		this.aisleInfoText = '' ;
		this.serialNumber = '' ;
		this.inTransitQuantity = 0 ;
		this.purchaseOrderInTransitLineNumber = 0 ;
		this.purchaseOrderInTransitRollLineNumber = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.receipt.PurchaseOrderReceiptStatusTrackBean */
export class PurchaseOrderReceiptStatusTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.receipt.PurchaseOrderReceiptUpdateInfo */
export class PurchaseOrderReceiptUpdateInfo {
	constructor() {
		this.purchaseOrderList = null ;
		this.lineList = null ;
	}
}
/* ds.purchase.receipt.PurchaseReceiptForFabricStyleStatisticsBean */
export class PurchaseReceiptForFabricStyleStatisticsBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.purchaseOrderNumber = '' ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.uomCode = '' ;
		this.quantity = 0 ;
		this.purchaseReceiptDate = '' ;
		this.noOfRolls = 0 ;
	}
}
/* ds.purchase.receipt.PurchaseReceiptForFabricStyleStatisticsResultBean */
export class PurchaseReceiptForFabricStyleStatisticsResultBean {
	constructor() {
		this.purchaseReceipts = new Array() ;
	}
}
/* ds.purchase.receipt.PurchaseReceiptToInvoiceInputBean */
export class PurchaseReceiptToInvoiceInputBean {
	constructor() {
		this.purchaseReceipts = null ;
		this.serviceLines = new Array() ;
	}
}
/* ds.purchase.receipt.response.PurchaseOrderReceiptApprovalResponseBean */
export class PurchaseOrderReceiptApprovalResponseBean {
	constructor() {
		this.purchaseOrderReceiptApprovalBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.receipt.response.PurchaseOrderReceiptElectronicInputResponseBean */
export class PurchaseOrderReceiptElectronicInputResponseBean {
	constructor() {
		this.eInput = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.receipt.response.PurchaseOrderReceiptResponseBean */
export class PurchaseOrderReceiptResponseBean {
	constructor() {
		this.purchaseOrderReceipt = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.receipt.response.PurchaseReceiptForFabricStyleStatisticsResultResponseBean */
export class PurchaseReceiptForFabricStyleStatisticsResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.response.FabricStyleAdvancedPurchaseCostResponseBean */
export class FabricStyleAdvancedPurchaseCostResponseBean {
	constructor() {
		this.advancedCostCriteria = null ;
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.response.FabricStylePurchaseCostResponseBean */
export class FabricStylePurchaseCostResponseBean {
	constructor() {
		this.fabricStyleCost = 0 ;
		this.costCriteria = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.response.GroupPurchaseOrderResponseBean */
export class GroupPurchaseOrderResponseBean {
	constructor() {
		this.groupPurchaseOrder = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.response.PurchaseOrderInquiryResultResponseBean */
export class PurchaseOrderInquiryResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.response.PurchaseOrderResponseBean */
export class PurchaseOrderResponseBean {
	constructor() {
		this.purchaseOrder = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.response.PurchaseSourceSalesOrderLineDetailResponseBean */
export class PurchaseSourceSalesOrderLineDetailResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.response.SalesOrderDependentPurchaseOrderDetailResponseBean */
export class SalesOrderDependentPurchaseOrderDetailResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.purchase.SalesOrderDependentPurchaseOrderDetailBean */
export class SalesOrderDependentPurchaseOrderDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderLineNumber = 0 ;
		this.salesOrderNumber = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.orderQuantity = 0 ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.allocatedQuantity = 0 ;
		this.openQuantity = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.purchase.SalesOrderDependentPurchaseOrderDetailResultBean */
export class SalesOrderDependentPurchaseOrderDetailResultBean {
	constructor() {
		this.companyCode = '' ;
		this.sourceSalesOrderDetailLines = new Array() ;
	}
}
/* ds.report.FabricStyleBarCodeInfoBean */
export class FabricStyleBarCodeInfoBean {
	constructor() {
		this.sequenceNumber = 0 ;
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.numberOfBoxes = 0 ;
		this.lotNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.skuNumber = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.report.FabricStyleCurrentReportATSInfoBean */
export class FabricStyleCurrentReportATSInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.reportSequenceNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleColorName = '' ;
		this.width = '' ;
		this.uomCode = '' ;
		this.onHandQuantity = 0 ;
		this.customerOnOrderQuantity = 0 ;
		this.vendorOnOrderQuantity = 0 ;
		this.manualAllocatedQuantity = 0 ;
		this.availableToSaleQuantity = 0 ;
		this.isShortage = 0 ;
		this.salesQuantityToDate = 0 ;
		this.last3MonthsSalesQuantity = 0 ;
		this.last6MonthsSalesQuantity = 0 ;
		this.last12MonthsSalesQuantity = 0 ;
		this.last18MonthsSalesQuantity = 0 ;
		this.last24MonthsSalesQuantity = 0 ;
		this.last36MonthsSalesQuantity = 0 ;
		this.monthToDateQuantity = 0 ;
		this.yearToDateQuantity = 0 ;
		this.atsYardage = 0 ;
		this.numberOfRolls = 0 ;
		this.lastSalesDate = '' ;
		this.lastPurchaseReceiptDate = '' ;
		this.inTransitQuantity = 0 ;
		this.riskValue = 0 ;
		this.checked = false ;
		this.fabricStyleImagePath = '' ;
		this.fabricStyleColorImagePath = '' ;
		this.parentProductCode = '' ;
		this.businessDivisionCode = '' ;
		this.vendorCode = '' ;
		this.skuNumber = 0 ;
		this.logisticOnOrderQuantity = 0 ;
		this.etaDate = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.report.FabricStyleCurrentReportHistoryATSInfoBean */
export class FabricStyleCurrentReportHistoryATSInfoBean {
	constructor() {
		this.companyCode = '' ;
		this.reportSequenceNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleColorName = '' ;
		this.width = '' ;
		this.uomCode = '' ;
		this.onHandQuantity = 0 ;
		this.customerOnOrderQuantity = 0 ;
		this.vendorOnOrderQuantity = 0 ;
		this.manualAllocatedQuantity = 0 ;
		this.availableToSaleQuantity = 0 ;
		this.isShortage = 0 ;
		this.salesQuantityToDate = 0 ;
		this.last3MonthsSalesQuantity = 0 ;
		this.last6MonthsSalesQuantity = 0 ;
		this.last12MonthsSalesQuantity = 0 ;
		this.last18MonthsSalesQuantity = 0 ;
		this.last24MonthsSalesQuantity = 0 ;
		this.last36MonthsSalesQuantity = 0 ;
		this.monthToDateQuantity = 0 ;
		this.yearToDateQuantity = 0 ;
		this.atsYardage = 0 ;
		this.numberOfRolls = 0 ;
		this.lastSalesDate = '' ;
		this.lastPurchaseReceiptDate = '' ;
		this.inTransitQuantity = 0 ;
		this.riskValue = 0 ;
		this.checked = false ;
		this.fabricStyleImagePath = '' ;
		this.fabricStyleColorImagePath = '' ;
		this.parentProductCode = '' ;
		this.businessDivisionCode = '' ;
		this.vendorCode = '' ;
		this.skuNumber = 0 ;
		this.logisticOnOrderQuantity = 0 ;
		this.etaDate = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.response.OrderPortalCustomerResponseBean */
export class OrderPortalCustomerResponseBean {
	constructor() {
		this.orderPortalCustomer = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.PortalOrderCustomerPageListResponseBean */
export class PortalOrderCustomerPageListResponseBean {
	constructor() {
		this.orderCustomerPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.response.PurchaseOrderLinesDataResponseBean */
export class PurchaseOrderLinesDataResponseBean {
	constructor() {
		this.companyCode = '' ;
		this.eInputBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.attributes.RestAccountReceivableDiscountListRequest */
export class RestAccountReceivableDiscountListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestAccountReceivableReversalReasonListRequest */
export class RestAccountReceivableReversalReasonListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestAttributeCacheInputBean */
export class RestAttributeCacheInputBean {
	constructor() {
		this.companyCode = '' ;
	}
}
/* ds.rest.attributes.RestBankAccountListRequest */
export class RestBankAccountListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestBankAdjustmentReasonListRequest */
export class RestBankAdjustmentReasonListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestBinLocationListRequest */
export class RestBinLocationListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestBoxTypeListRequest */
export class RestBoxTypeListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestBusinessDivisionListRequest */
export class RestBusinessDivisionListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestCityListRequest */
export class RestCityListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestColorListRequest */
export class RestColorListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestCommentListRequest */
export class RestCommentListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestCompositionTypeListRequest */
export class RestCompositionTypeListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestCountryListRequest */
export class RestCountryListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestCurrencyExchangeRateListRequest */
export class RestCurrencyExchangeRateListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestCurrencyListRequest */
export class RestCurrencyListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestCustomerDeliveryListRequest */
export class RestCustomerDeliveryListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestCustomerDivisionListRequest */
export class RestCustomerDivisionListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestCustomerSalesZoneListRequest */
export class RestCustomerSalesZoneListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestCustomerSpecialTypeListRequest */
export class RestCustomerSpecialTypeListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestCustomerTenderCancelReasonListRequest */
export class RestCustomerTenderCancelReasonListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestCustomerTenderReasonListRequest */
export class RestCustomerTenderReasonListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestCustomerTenderUnApprovalReasonListRequest */
export class RestCustomerTenderUnApprovalReasonListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestCustomerTypeListRequest */
export class RestCustomerTypeListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestDepositCancelReasonListRequest */
export class RestDepositCancelReasonListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestDepositReversalReasonListRequest */
export class RestDepositReversalReasonListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestEmployeeListRequest */
export class RestEmployeeListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestExpenseSubTypeListRequest */
export class RestExpenseSubTypeListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestExpenseTypeListRequest */
export class RestExpenseTypeListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestFabricDetailListRequest */
export class RestFabricDetailListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestFabricVendorMiscellaneousCostDetailReasonListRequest */
export class RestFabricVendorMiscellaneousCostDetailReasonListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestFiscalYearListRequest */
export class RestFiscalYearListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestFobCityListRequest */
export class RestFobCityListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestFreightMethodListRequest */
export class RestFreightMethodListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestGeneralLedgerAccountListRequest */
export class RestGeneralLedgerAccountListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestGeneralLedgerAccountTypeListRequest */
export class RestGeneralLedgerAccountTypeListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestHarmonizedTariffScheduleListRequest */
export class RestHarmonizedTariffScheduleListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestIncoTermListRequest */
export class RestIncoTermListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestInventoryAdjustmentReasonListRequest */
export class RestInventoryAdjustmentReasonListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestInvoiceCancelReasonListRequest */
export class RestInvoiceCancelReasonListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestInvoiceModelListRequest */
export class RestInvoiceModelListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestInvoiceNonMerchandiseReasonListRequest */
export class RestInvoiceNonMerchandiseReasonListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestInvoicePrintoutTypeListRequest */
export class RestInvoicePrintoutTypeListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestInvoiceTemplateListRequest */
export class RestInvoiceTemplateListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestInvoiceUnApprovalReasonListRequest */
export class RestInvoiceUnApprovalReasonListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestLogisticsMethodListRequest */
export class RestLogisticsMethodListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestMakeTypeListRequest */
export class RestMakeTypeListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestMiscellaneousChargeReasonListRequest */
export class RestMiscellaneousChargeReasonListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestPatternTypeCategoryListRequest */
export class RestPatternTypeCategoryListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestPatternTypeListRequest */
export class RestPatternTypeListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestPaymentMethodListRequest */
export class RestPaymentMethodListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestPaymentTermListRequest */
export class RestPaymentTermListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestPeriodSalesCommissionAdjustmentReasonListRequest */
export class RestPeriodSalesCommissionAdjustmentReasonListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestPickTicketCancelReasonListRequest */
export class RestPickTicketCancelReasonListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestPreProductionChangeReasonListRequest */
export class RestPreProductionChangeReasonListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestProductDivisionListRequest */
export class RestProductDivisionListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestProductStatusListRequest */
export class RestProductStatusListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestProductTypeListRequest */
export class RestProductTypeListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestPurchaseOrderCancelListRequest */
export class RestPurchaseOrderCancelListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestPurchaseOrderModelListRequest */
export class RestPurchaseOrderModelListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestPurchaseOrderUnApprovalReasonListRequest */
export class RestPurchaseOrderUnApprovalReasonListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestRoyaltyClientListRequest */
export class RestRoyaltyClientListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestSeasonListRequest */
export class RestSeasonListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestServiceListRequest */
export class RestServiceListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestShipmentTermListRequest */
export class RestShipmentTermListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestShipToListRequest */
export class RestShipToListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestShipViaListRequest */
export class RestShipViaListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestStageCollectionListRequest */
export class RestStageCollectionListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestStateListRequest */
export class RestStateListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestStyleItemTypeListRequest */
export class RestStyleItemTypeListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestTargetWebSiteListRequest */
export class RestTargetWebSiteListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestUOMListRequest */
export class RestUOMListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestVendorCategoryListRequest */
export class RestVendorCategoryListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestVendorShipViaListRequest */
export class RestVendorShipViaListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestVendorTermListRequest */
export class RestVendorTermListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestVendorTypeListRequest */
export class RestVendorTypeListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.attributes.RestWarehouseListRequest */
export class RestWarehouseListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.master.response.RestCompanyResponseBean */
export class RestCompanyResponseBean {
	constructor() {
		this.company = null ;
		this.defaultCompanyCode = '' ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.master.RestCompanyBean */
export class RestCompanyBean {
	constructor() {
		this.address = null ;
		this.dbaName = '' ;
		this.legalName = '' ;
		this.status = '' ;
		this.comments = '' ;
		this.currencyCode = '' ;
		this.salesTaxPercentage = 0 ;
		this.retailMarkupPercentage = 0 ;
		this.wholesaleMarkupPercentage = 0 ;
		this.smtpInfo = null ;
		this.attributeModuleEntities = new Array() ;
		this.configs = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.rest.pagelist.response.RestCustomerPortalInvoicePageListResponseBean */
export class RestCustomerPortalInvoicePageListResponseBean {
	constructor() {
		this.invoicePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.pagelist.RestCustomerPortalInvoicePageListBean */
export class RestCustomerPortalInvoicePageListBean {
	constructor() {
		this.invoices = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.rest.request.AccountReceivablePaymentHistoryPrintRequest */
export class AccountReceivablePaymentHistoryPrintRequest {
	constructor() {
		this.companyCode = '' ;
		this.accountReceivableNumber = '' ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.AccountReceivablePrintRequest */
export class AccountReceivablePrintRequest {
	constructor() {
		this.companyCode = '' ;
		this.arNumber = '' ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.AllCustomerOnlineAgingRequest */
export class AllCustomerOnlineAgingRequest {
	constructor() {
		this.companyCode = '' ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.AllCustomerPaymentCurrentAgingHistoryRequest */
export class AllCustomerPaymentCurrentAgingHistoryRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.AllCustomersSalesBackOrderAgingHistoryPrintRequest */
export class AllCustomersSalesBackOrderAgingHistoryPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.AllCustomerTransactionDataRequest */
export class AllCustomerTransactionDataRequest {
	constructor() {
		this.criteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.AllCustomerTransactionGeneralRequest */
export class AllCustomerTransactionGeneralRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.AllFabricStyleATSInfoDetailsPrintRequest */
export class AllFabricStyleATSInfoDetailsPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.AllFabricStyleCustomerATSInfoDetailsPrintRequest */
export class AllFabricStyleCustomerATSInfoDetailsPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.AllFabricStyleSalesBackOrderAgingHistoryPrintRequest */
export class AllFabricStyleSalesBackOrderAgingHistoryPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.BankAccountBalanceHistoryTrackPrintRequest */
export class BankAccountBalanceHistoryTrackPrintRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.BatchInventorySummaryDataPrintRequest */
export class BatchInventorySummaryDataPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.BinInventoryForInventoryAdjustmentPrintRequest */
export class BinInventoryForInventoryAdjustmentPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.BinInventoryPageListPrintRequest */
export class BinInventoryPageListPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.BookingPrintRequest */
export class BookingPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.BouncedChecksPrintRequest */
export class BouncedChecksPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CashPaymentActivityPrintRequest */
export class CashPaymentActivityPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CertificateOfOriginInvoicePrintRequest */
export class CertificateOfOriginInvoicePrintRequest {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.isDirectPrint = false ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CheckDetailsPrintRequest */
export class CheckDetailsPrintRequest {
	constructor() {
		this.checkDataBean = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CheckPaymentHistoryPrintRequest */
export class CheckPaymentHistoryPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CheckTransactionPrintOutRequest */
export class CheckTransactionPrintOutRequest {
	constructor() {
		this.companyCode = '' ;
		this.checkTransactionNumber = '' ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CommercialInvoiceForMultiplePrintOutRequest */
export class CommercialInvoiceForMultiplePrintOutRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CommercialInvoicePrintRequest */
export class CommercialInvoicePrintRequest {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.isDirectPrint = false ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CreditMemoDetailsRequest */
export class CreditMemoDetailsRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CreditMemoPrintRequest */
export class CreditMemoPrintRequest {
	constructor() {
		this.companyCode = '' ;
		this.creditMemoNumber = '' ;
		this.isDirectPrint = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CustomerAgingOpenInvoicesPrintRequest */
export class CustomerAgingOpenInvoicesPrintRequest {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CustomerAllocationInTransitInfosPrintRequest */
export class CustomerAllocationInTransitInfosPrintRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CustomerAndFabricSalesDetailPrintRequest */
export class CustomerAndFabricSalesDetailPrintRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CustomerBalanceDetailsRequest */
export class CustomerBalanceDetailsRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CustomerBalanceHistoryReportDetailRequest */
export class CustomerBalanceHistoryReportDetailRequest {
	constructor() {
		this.companyCode = '' ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CustomerCurrentAgingMailRequest */
export class CustomerCurrentAgingMailRequest {
	constructor() {
		this.criteria = null ;
		this.infoBean = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CustomerDetailsWithSalesInvoiceRequest */
export class CustomerDetailsWithSalesInvoiceRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CustomerFabricStyleATSInfoDetailsPrintRequest */
export class CustomerFabricStyleATSInfoDetailsPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CustomerOnOrderATSSummaryDetailsRequest */
export class CustomerOnOrderATSSummaryDetailsRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CustomerPaymentAgingHistoryRequest */
export class CustomerPaymentAgingHistoryRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CustomerPaymentCurrentAgingHistoryRequest */
export class CustomerPaymentCurrentAgingHistoryRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CustomerSalesAnalysisRequest */
export class CustomerSalesAnalysisRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CustomerSalesDataRequest */
export class CustomerSalesDataRequest {
	constructor() {
		this.criteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CustomerSalesOnOrderDetailsPrintRequest */
export class CustomerSalesOnOrderDetailsPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CustomerServicePrintRequest */
export class CustomerServicePrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CustomerServiceSalesOrderPrintOutRequest */
export class CustomerServiceSalesOrderPrintOutRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CustomerShortInfoListPrintRequest */
export class CustomerShortInfoListPrintRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CustomerStatementInquiryPrintRequest */
export class CustomerStatementInquiryPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CustomerStatisticsPrintRequest */
export class CustomerStatisticsPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CustomerTransactionDataRequest */
export class CustomerTransactionDataRequest {
	constructor() {
		this.criteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.CustomerTransactionSummaryDataRequest */
export class CustomerTransactionSummaryDataRequest {
	constructor() {
		this.criteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.DepositPrintOutRequest */
export class DepositPrintOutRequest {
	constructor() {
		this.companyCode = '' ;
		this.depositNumber = '' ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FabricOnOrderDetailsPrintRequest */
export class FabricOnOrderDetailsPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FabricSalesActivityPrintRequest */
export class FabricSalesActivityPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FabricStyleColorStatisticsPrintRequest */
export class FabricStyleColorStatisticsPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FabricStyleColorStatisticsReceiptListRequest */
export class FabricStyleColorStatisticsReceiptListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FabricStyleDashBoardPrintRequest */
export class FabricStyleDashBoardPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FabricStyleFabricStyleBarCodeListRequest */
export class FabricStyleFabricStyleBarCodeListRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FabricStyleInventoryForLotBasedListRequest */
export class FabricStyleInventoryForLotBasedListRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FabricStyleInventoryValuationPrintRequest */
export class FabricStyleInventoryValuationPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FabricStyleListWithPriceAndCostPrintRequest */
export class FabricStyleListWithPriceAndCostPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FabricStyleOtherInfoDetailsRequest */
export class FabricStyleOtherInfoDetailsRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FabricStyleOtherInfoDetails_oldRequest */
export class FabricStyleOtherInfoDetails_oldRequest {
	constructor() {
		this.criteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FabricStylePurchaseOrderHistoryPrintRequest */
export class FabricStylePurchaseOrderHistoryPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FabricStyleReceivedInquiryPrintRequest */
export class FabricStyleReceivedInquiryPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FabricStyleSKUDetailsPageListRequest */
export class FabricStyleSKUDetailsPageListRequest {
	constructor() {
		this.criteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FabricStyleSKUDetailsPrintRequest */
export class FabricStyleSKUDetailsPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FabricStyleSoldPrintRequest */
export class FabricStyleSoldPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FabricStyleSoldToCustomerPrintRequest */
export class FabricStyleSoldToCustomerPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FabricStyleStatisticsSummaryDetailPrintRequest */
export class FabricStyleStatisticsSummaryDetailPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FabricStyleWeeklyMonthlyATSResultRequest */
export class FabricStyleWeeklyMonthlyATSResultRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FabricStyleYearlySalesPrintRequest */
export class FabricStyleYearlySalesPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FinalPullBulkPickTicketDetailRequest */
export class FinalPullBulkPickTicketDetailRequest {
	constructor() {
		this.resultBean = null ;
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.FiscalYearBookingPrintOutRequest */
export class FiscalYearBookingPrintOutRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.getMostRecentCustomerSalesinvoiceDetailsPrintRequest */
export class getMostRecentCustomerSalesinvoiceDetailsPrintRequest {
	constructor() {
		this.comapanyCode = '' ;
		this.customerCode = '' ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.InfoListPrintRequest */
export class InfoListPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.InTransitPackingListPrintRequest */
export class InTransitPackingListPrintRequest {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderInTransitNumber = '' ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.InTransitRollSkuEntityPrintRequest */
export class InTransitRollSkuEntityPrintRequest {
	constructor() {
		this.companyCode = '' ;
		this.rollSkuNumber = 0 ;
		this.inTransitNumber = '' ;
		this.noOfCopies = 0 ;
		this.input = null ;
		this.isDirectPrint = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.InventoryAdjustmentHistoryDetailsRequest */
export class InventoryAdjustmentHistoryDetailsRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.InvoicedNotApprovedListRequest */
export class InvoicedNotApprovedListRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.InvoiceFabricStyleSoldYearlyInquiryDetailsRequest */
export class InvoiceFabricStyleSoldYearlyInquiryDetailsRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.InvoicePaymentHistoryPrintOutRequest */
export class InvoicePaymentHistoryPrintOutRequest {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.InvoiceRegisterPrintRequest */
export class InvoiceRegisterPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.InvoiceSalesPersonCommissionPrintRequest */
export class InvoiceSalesPersonCommissionPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.ItemCatalogInquiryDetailsRequest */
export class ItemCatalogInquiryDetailsRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.LatePurchaseOrderListRequest */
export class LatePurchaseOrderListRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
	}
}
/* ds.rest.request.MissingCalculationInvoicesPrintRequest */
export class MissingCalculationInvoicesPrintRequest {
	constructor() {
		this.companyCode = '' ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.MostRecentCustomerDetailsPrintRequest */
export class MostRecentCustomerDetailsPrintRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.MostRecentCustomerSalesInvoiceRequest */
export class MostRecentCustomerSalesInvoiceRequest {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.MostRecentCustomerSalesOrderDetailsPrintRequest */
export class MostRecentCustomerSalesOrderDetailsPrintRequest {
	constructor() {
		this.comapanyCode = '' ;
		this.customerCode = '' ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.MostRecentCustomerSalesOrderInfoRequest */
export class MostRecentCustomerSalesOrderInfoRequest {
	constructor() {
		this.comapanyCode = '' ;
		this.customerCode = '' ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.MultiCustomersOnlineAgingPrintRequest */
export class MultiCustomersOnlineAgingPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.MultiInTransitRollSkuEntityPrintRequest */
export class MultiInTransitRollSkuEntityPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.isDirectPrint = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.MultiRollSkuEntityPrintRequest */
export class MultiRollSkuEntityPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.ObseleteInventoriesPrintRequest */
export class ObseleteInventoriesPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.OpenPickTicketBriefDetailsRequest */
export class OpenPickTicketBriefDetailsRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.OpenPickTicketPrintRequest */
export class OpenPickTicketPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.OpenSalesOrderLinesPrintRequest */
export class OpenSalesOrderLinesPrintRequest {
	constructor() {
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.isDirectPrint = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PackingListPrintRequest */
export class PackingListPrintRequest {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.reportBean = null ;
		this.isDirectPrint = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PastDueInvoiceWithCCPaymentMailRequest */
export class PastDueInvoiceWithCCPaymentMailRequest {
	constructor() {
		this.criteria = null ;
		this.infoBean = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PastDueInvoiceWithCCPaymentRequest */
export class PastDueInvoiceWithCCPaymentRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PeriodSalesCommissionPrintRequest */
export class PeriodSalesCommissionPrintRequest {
	constructor() {
		this.companyCode = '' ;
		this.periodSalescommissionNumber = '' ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PickedandShippedListRequest */
export class PickedandShippedListRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PickedNotInvoicedListRequest */
export class PickedNotInvoicedListRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PickedPickticketLineLabelRequest */
export class PickedPickticketLineLabelRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PickTicketPickerDetailsPrintRequest */
export class PickTicketPickerDetailsPrintRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PickTicketRollAndRollSkuLabelsRequest */
export class PickTicketRollAndRollSkuLabelsRequest {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PickupSummaryPrintRequest */
export class PickupSummaryPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PopupAllCustomerCreditMemoDetailsPrintRequest */
export class PopupAllCustomerCreditMemoDetailsPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PopupAllCustomerDueDetailsPrintRequest */
export class PopupAllCustomerDueDetailsPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PopupCustomerSalesDetailPrintRequest */
export class PopupCustomerSalesDetailPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PopupCustomerTransactionCreditMemoDetailsPrintRequest */
export class PopupCustomerTransactionCreditMemoDetailsPrintRequest {
	constructor() {
		this.companyCode = '' ;
		this.creditNumber = '' ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PopupCustomerTransactionInvoiceDetailsPrintRequest */
export class PopupCustomerTransactionInvoiceDetailsPrintRequest {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.type = 0 ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PopupFabricStylePurchaseOrderHistoryPrintRequest */
export class PopupFabricStylePurchaseOrderHistoryPrintRequest {
	constructor() {
		this.criteria = null ;
		this.type = 0 ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PopupMostRecentFabricPrintRequest */
export class PopupMostRecentFabricPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PopupVendorOnOrderPrintReport_DorellRequest */
export class PopupVendorOnOrderPrintReport_DorellRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PopupVendorOpenOrderSalesDetailPrintRequest */
export class PopupVendorOpenOrderSalesDetailPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PostDatedAndBouncedCheckPrintRequest */
export class PostDatedAndBouncedCheckPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PostDatedChecksDetailPrintRequest */
export class PostDatedChecksDetailPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PostedARPaymentRegisterPrintRequest */
export class PostedARPaymentRegisterPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PostedARRegisterPrintRequest */
export class PostedARRegisterPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.ProductAvailabilityDetailsRequest */
export class ProductAvailabilityDetailsRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.ProductCatalogPrintRequest */
export class ProductCatalogPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.pageListBean = null ;
	}
}
/* ds.rest.request.PullBulkPickTicketDetailRequest */
export class PullBulkPickTicketDetailRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PullBulkPickTicketSummaryInquiryDetailRequest */
export class PullBulkPickTicketSummaryInquiryDetailRequest {
	constructor() {
		this.resultBean = null ;
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PurchaseOrderInTransitInfosPrintRequest */
export class PurchaseOrderInTransitInfosPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PurchaseOrderPrintRequest */
export class PurchaseOrderPrintRequest {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.isDirectPrint = false ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PurchaseOrderReceiptInputFormatRequest */
export class PurchaseOrderReceiptInputFormatRequest {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.lineNumber = 0 ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PurchaseOrderReceiptInquiryRequest */
export class PurchaseOrderReceiptInquiryRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.PurchaseOrderReceiptPrintRequest */
export class PurchaseOrderReceiptPrintRequest {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.ReceiptBinRollsBinLocationSummaryRequest */
export class ReceiptBinRollsBinLocationSummaryRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RemainingPickticketLineLabelRequest */
export class RemainingPickticketLineLabelRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestAccountPayableBeanRequest */
export class RestAccountPayableBeanRequest {
	constructor() {
		this.accountPayable = null ;
		this.pageInput = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestAccountPayableListRequest */
export class RestAccountPayableListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestAccountReceivableBeanInputBeanRequest */
export class RestAccountReceivableBeanInputBeanRequest {
	constructor() {
		this.accountReceivableInputBean = null ;
		this.isWarningAcceptedForCreditMemoGenerationForOverPayment = false ;
		this.creditMemoBean = null ;
		this.specialReason = '' ;
		this.reason = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestAccountReceivableBeanRequest */
export class RestAccountReceivableBeanRequest {
	constructor() {
		this.accountReceivableBean = null ;
		this.isWarningAcceptedForCreditMemoGenerationForOverPayment = false ;
		this.creditMemoBean = null ;
		this.specialReason = '' ;
		this.reason = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestAccountReceivableListRequest */
export class RestAccountReceivableListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestAccountReceivableMailInfoBeanRequest */
export class RestAccountReceivableMailInfoBeanRequest {
	constructor() {
		this.invoiceBean = null ;
		this.infoBean = null ;
		this.reason = null ;
		this.isDirectPrint = false ;
		this.inputReportBean = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestAllFabricAtsListRequest */
export class RestAllFabricAtsListRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestBankAdjustmentBeanRequest */
export class RestBankAdjustmentBeanRequest {
	constructor() {
		this.searchCriteria = null ;
		this.bankAdjustment = null ;
		this.pageInput = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestBatchCheckTransactionBeanRequest */
export class RestBatchCheckTransactionBeanRequest {
	constructor() {
		this.batchPrintCheck = null ;
		this.checkTransaction = null ;
		this.pageInput = null ;
		this.checkNumber = 0 ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestBatchCheckTransactionListRequest */
export class RestBatchCheckTransactionListRequest {
	constructor() {
		this.batchCheckTransaction = null ;
		this.checkNumber = 0 ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestBulkSalesOrderListRequest */
export class RestBulkSalesOrderListRequest {
	constructor() {
		this.Criteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCheckBounceDetailsBeanRequest */
export class RestCheckBounceDetailsBeanRequest {
	constructor() {
		this.customerCode = '' ;
		this.checkNumber = '' ;
		this.billToCode = '' ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCheckBounceProcessListRequest */
export class RestCheckBounceProcessListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.checkBounceProcess = null ;
		this.pageInput = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCheckCancelProcessCriteriaBeanRequest */
export class RestCheckCancelProcessCriteriaBeanRequest {
	constructor() {
		this.searchCriteria = null ;
		this.checkCancelProcess = null ;
		this.pageInput = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCheckDataCriteriaBeanRequest */
export class RestCheckDataCriteriaBeanRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCheckTransactionBeanRequest */
export class RestCheckTransactionBeanRequest {
	constructor() {
		this.searchCriteria = null ;
		this.checkTransaction = null ;
		this.pageInput = null ;
		this.checkNumber = 0 ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCheckTransactionListRequest */
export class RestCheckTransactionListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCheckTransactionPrintListRequest */
export class RestCheckTransactionPrintListRequest {
	constructor() {
		this.chkTransactionData = null ;
		this.checkNumber = '' ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCheckTransactionRequest */
export class RestCheckTransactionRequest {
	constructor() {
		this.checkTransactionBean = null ;
		this.reason = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCompanyPageListRequest */
export class RestCompanyPageListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCpmReportDetailsListRequest */
export class RestCpmReportDetailsListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.reportBean = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.request.RestCreditMemoBeanRequest */
export class RestCreditMemoBeanRequest {
	constructor() {
		this.searchCriteria = null ;
		this.creditMemoBean = null ;
		this.specialReason = '' ;
		this.pageInput = null ;
		this.isDirectPrint = false ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCreditMemoMailInfoBeanRequest */
export class RestCreditMemoMailInfoBeanRequest {
	constructor() {
		this.infoBean = null ;
		this.reason = null ;
		this.inputReportBean = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCriticalPathManagementListRequest */
export class RestCriticalPathManagementListRequest {
	constructor() {
		this.criteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCriticalPathManagementOperationRequest */
export class RestCriticalPathManagementOperationRequest {
	constructor() {
		this.cpmBean = null ;
		this.isLockReleaseRequired = false ;
		this.reasonBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCriticalPathManagementTemplateListRequest */
export class RestCriticalPathManagementTemplateListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCustomerAccountSummaryListRequest */
export class RestCustomerAccountSummaryListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCustomerBillToListRequest */
export class RestCustomerBillToListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCustomerCreditCardsListRequest */
export class RestCustomerCreditCardsListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCustomerDistributionCenterListRequest */
export class RestCustomerDistributionCenterListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCustomerEntityRequest */
export class RestCustomerEntityRequest {
	constructor() {
		this.companyCode = '' ;
		this.entityCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCustomerListRequest */
export class RestCustomerListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCustomerModuleInitRequest */
export class RestCustomerModuleInitRequest {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.isLockRequired = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCustomerReturnBeanRequest */
export class RestCustomerReturnBeanRequest {
	constructor() {
		this.customerReturnBean = null ;
		this.specialReason = '' ;
		this.reason = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCustomerReturnListRequest */
export class RestCustomerReturnListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCustomerSalesCommissionReadRequest */
export class RestCustomerSalesCommissionReadRequest {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.salesPersonCommissionCode = '' ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCustomerSalesOnOrderListRequest */
export class RestCustomerSalesOnOrderListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.isStartDateBased = false ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCustomerSalesOrdersForCustomerPurchaseOrderNumberRequest */
export class RestCustomerSalesOrdersForCustomerPurchaseOrderNumberRequest {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerPo = '' ;
		this.excludeSalesOrderNumber = '' ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCustomerSalesPersonCommissionListRequest */
export class RestCustomerSalesPersonCommissionListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCustomerShipToListRequest */
export class RestCustomerShipToListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCustomerTenderBeanRequest */
export class RestCustomerTenderBeanRequest {
	constructor() {
		this.criteria = null ;
		this.customerTenderBean = null ;
		this.pageInput = null ;
		this.reasonBean = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestCustomerUserRequest */
export class RestCustomerUserRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.request.RestDailyInventoryProcessTrackListRequest */
export class RestDailyInventoryProcessTrackListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.reportBean = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.request.RestDailyInventoryTrackListRequest */
export class RestDailyInventoryTrackListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.reportBean = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestDebitMemoBeanRequest */
export class RestDebitMemoBeanRequest {
	constructor() {
		this.searchCriteria = null ;
		this.debitMemoBean = null ;
		this.specialReason = null ;
		this.pageInput = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestDepositBeanRequest */
export class RestDepositBeanRequest {
	constructor() {
		this.searchCriteria = null ;
		this.deposit = null ;
		this.pageInput = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestDuplicateCustomerListRequest */
export class RestDuplicateCustomerListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestEComJobStatusDetailsRequest */
export class RestEComJobStatusDetailsRequest {
	constructor() {
		this.criteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.request.RestEComOrderStatusDetailsRequest */
export class RestEComOrderStatusDetailsRequest {
	constructor() {
		this.criteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.request.RestEntityPrintRequest */
export class RestEntityPrintRequest {
	constructor() {
		this.companyCode = '' ;
		this.entityCode = '' ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestEntityUnLockRequest */
export class RestEntityUnLockRequest {
	constructor() {
		this.companyCode = '' ;
		this.entityCode = '' ;
		this.isNew = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestFabricStyleATSListRequest */
export class RestFabricStyleATSListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestFabricStyleColorATSDetailReadRequest */
export class RestFabricStyleColorATSDetailReadRequest {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestFabricStyleCostMaintenanceListRequest */
export class RestFabricStyleCostMaintenanceListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestFabricStyleEntityRequest */
export class RestFabricStyleEntityRequest {
	constructor() {
		this.companyCode = '' ;
		this.entityCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestFabricStyleInventoryAdjustmentListRequest */
export class RestFabricStyleInventoryAdjustmentListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestFabricStyleInventoryListBeanRequest */
export class RestFabricStyleInventoryListBeanRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestFabricStyleInventoryListRequest */
export class RestFabricStyleInventoryListRequest {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.loadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestFabricStyleListBeanRequest */
export class RestFabricStyleListBeanRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestFabricStyleListRequest */
export class RestFabricStyleListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestFabricStyleRequest */
export class RestFabricStyleRequest {
	constructor() {
		this.fabricStyleBean = null ;
		this.reason = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestFabricStyleStatisticsInquiryListRequest */
export class RestFabricStyleStatisticsInquiryListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.reportBean = null ;
		this.numberOfMonthsFrom = 0 ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestGetFabricPriceAndCostRequest */
export class RestGetFabricPriceAndCostRequest {
	constructor() {
		this.priceCriteria = null ;
		this.costCriteria = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestGroupPurchaseOrderListRequest */
export class RestGroupPurchaseOrderListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestGroupPurchaseOrderReasonRequest */
export class RestGroupPurchaseOrderReasonRequest {
	constructor() {
		this.groupPurchaseOrderBean = null ;
		this.reason = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestGroupSalesOrderListRequest */
export class RestGroupSalesOrderListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestGroupSalesOrderRequest */
export class RestGroupSalesOrderRequest {
	constructor() {
		this.salesOrderBean = null ;
		this.reason = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestHoldingFabricStyleListRequest */
export class RestHoldingFabricStyleListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestInventoryAdjustmentListRequest */
export class RestInventoryAdjustmentListRequest {
	constructor() {
		this.invBean = null ;
		this.reasonBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestInventoryEntityRequest */
export class RestInventoryEntityRequest {
	constructor() {
		this.companyCode = '' ;
		this.EntityCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestInventoryRollListRequest */
export class RestInventoryRollListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestInventoryTransferListRequest */
export class RestInventoryTransferListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestInvoiceaccountReceivableBeanRequest */
export class RestInvoiceaccountReceivableBeanRequest {
	constructor() {
		this.invoiceBean = null ;
		this.accountReceivableBean = null ;
		this.reason = null ;
		this.isDirectPrint = false ;
		this.inputReportBean = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestInvoiceBatchApprovalSearchCriteriaBeanRequest */
export class RestInvoiceBatchApprovalSearchCriteriaBeanRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.selectedInvoices = new Array() ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestInvoiceBeanRequest */
export class RestInvoiceBeanRequest {
	constructor() {
		this.invoiceBean = null ;
		this.reason = null ;
		this.isDirectPrint = false ;
		this.inputReportBean = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestInvoiceCommodityListRequest */
export class RestInvoiceCommodityListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.reportBean = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestInvoiceListRequest */
export class RestInvoiceListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestInvoiceMailInfoBeanRequest */
export class RestInvoiceMailInfoBeanRequest {
	constructor() {
		this.invoiceBean = null ;
		this.infoBean = null ;
		this.reason = null ;
		this.isDirectPrint = false ;
		this.inputReportBean = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestInvoicePaymentInputBean */
export class RestInvoicePaymentInputBean {
	constructor() {
		this.invoiceBean = null ;
		this.accountReceivableBean = null ;
	}
}
/* ds.rest.request.RestInvoicePeriodSalesCommissionListRequest */
export class RestInvoicePeriodSalesCommissionListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.companyCode = '' ;
		this.salesPersonCode = '' ;
		this.startDate = '' ;
		this.stopDate = '' ;
		this.methodType = 0 ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestInvoicePeriodSalesCommissionRequest */
export class RestInvoicePeriodSalesCommissionRequest {
	constructor() {
		this.periodSalesCommisionBean = null ;
		this.reason = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestInvoiceRequest */
export class RestInvoiceRequest {
	constructor() {
		this.invoiceBean = null ;
		this.reason = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestInvoiceSalesMultiInvoiceMailBeanRequest */
export class RestInvoiceSalesMultiInvoiceMailBeanRequest {
	constructor() {
		this.infoBean = null ;
		this.inputReportBean = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestInvoiceServiceLineCancelRequest */
export class RestInvoiceServiceLineCancelRequest {
	constructor() {
		this.searchCriteria = null ;
		this.reasonBean = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestInvoiceServiceListRequest */
export class RestInvoiceServiceListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.reportBean = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestLetterOfCreditListRequest */
export class RestLetterOfCreditListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestLogisticOrderLineListRequest */
export class RestLogisticOrderLineListRequest {
	constructor() {
		this.criteria = null ;
		this.pageInput = null ;
		this.reason = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestLogisticOrderListRequest */
export class RestLogisticOrderListRequest {
	constructor() {
		this.criteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestLogisticOrderReceiptLineListRequest */
export class RestLogisticOrderReceiptLineListRequest {
	constructor() {
		this.criteria = null ;
		this.reason = null ;
	}
}
/* ds.rest.request.RestLogisticOrderReceiptLineRequest */
export class RestLogisticOrderReceiptLineRequest {
	constructor() {
		this.lineSearchCriteria = null ;
		this.reason = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestLogisticOrderReceiptListRequest */
export class RestLogisticOrderReceiptListRequest {
	constructor() {
		this.criteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestLogisticOrderReceiptRequest */
export class RestLogisticOrderReceiptRequest {
	constructor() {
		this.orderReceipt = null ;
		this.reason = null ;
		this.isLockRequired = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestLogisticOrderRequest */
export class RestLogisticOrderRequest {
	constructor() {
		this.order = null ;
		this.isDirectPrint = false ;
		this.isLockRequired = false ;
		this.report = null ;
		this.isLoadChildren = false ;
		this.reason = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestLogisticReceiptRollLineExcelImportRequest */
export class RestLogisticReceiptRollLineExcelImportRequest {
	constructor() {
		this.companyCode = '' ;
		this.logisticOrderNumber = '' ;
		this.excelFileName = '' ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestManualInventoryCustomerAllocationListRequest */
export class RestManualInventoryCustomerAllocationListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestMassSalesOrderPickTicketGenerationRequest */
export class RestMassSalesOrderPickTicketGenerationRequest {
	constructor() {
		this.criteria = null ;
		this.pageInput = null ;
	}
}
/* ds.rest.request.RestMultiInvoiceMailBeanRequest */
export class RestMultiInvoiceMailBeanRequest {
	constructor() {
		this.invoiceBean = null ;
		this.infoBean = null ;
		this.reason = null ;
		this.isDirectPrint = false ;
		this.inputReportBean = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPackingListMailRequest */
export class RestPackingListMailRequest {
	constructor() {
		this.companyCode = '' ;
		this.entityCode = '' ;
		this.infoBean = null ;
		this.isNew = false ;
		this.inputReportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPhysicalInventoryAdjustmentListRequest */
export class RestPhysicalInventoryAdjustmentListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPickTicketListRequest */
export class RestPickTicketListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPickTicketRequest */
export class RestPickTicketRequest {
	constructor() {
		this.pickTicketBean = null ;
		this.reason = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPickTicketShipmentLabelPrintRequest */
export class RestPickTicketShipmentLabelPrintRequest {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.boxLineNumber = 0 ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPickTicketShipmentRateRequest */
export class RestPickTicketShipmentRateRequest {
	constructor() {
		this.companyCode = '' ;
		this.pickTicket = null ;
		this.criteria = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPickTicketVoidShipmentRequest */
export class RestPickTicketVoidShipmentRequest {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.isManualVoid = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPickTicket_v1Request */
export class RestPickTicket_v1Request {
	constructor() {
		this.pickTicketBean = null ;
		this.salesOrderBean = null ;
		this.reason = null ;
		this.islabelPrintAllowed = false ;
		this.isManualVoid = false ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPortalOrderRequest */
export class RestPortalOrderRequest {
	constructor() {
		this.companyCode = '' ;
		this.customerOrder = '' ;
		this.lineDetailsJson = '' ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPortalSalesOrderRequest */
export class RestPortalSalesOrderRequest {
	constructor() {
		this.criteria = null ;
		this.pageList = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPostDatedCheckEntryBeanRequest */
export class RestPostDatedCheckEntryBeanRequest {
	constructor() {
		this.criteria = null ;
		this.postDatedCheckEntry = null ;
		this.specialReason = '' ;
		this.pageInput = null ;
		this.reasonBean = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPreProductionListRequest */
export class RestPreProductionListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.preProductionProcess = null ;
		this.pageInput = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPrinterListRequest */
export class RestPrinterListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPrintInputRequest */
export class RestPrintInputRequest {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.isDirectPrint = false ;
		this.report = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPrintRequestListRequest */
export class RestPrintRequestListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPurchaseOrderBeanRequest */
export class RestPurchaseOrderBeanRequest {
	constructor() {
		this.purchaseOrderBean = null ;
		this.isDirectPrint = false ;
		this.isLockReleaseRequired = false ;
		this.inputReportBean = null ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPurchaseorderForSalesOrderRequest */
export class RestPurchaseorderForSalesOrderRequest {
	constructor() {
		this.criteria = null ;
		this.salesOrderBean = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPurchaseOrderInTransitBeanRequest */
export class RestPurchaseOrderInTransitBeanRequest {
	constructor() {
		this.searchCriteria = null ;
		this.purchaseOrderInTransitBean = null ;
		this.reason = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPurchaseOrderInTransitExcelImportRequest */
export class RestPurchaseOrderInTransitExcelImportRequest {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.excelFileName = '' ;
		this.purchaseOrderInTransitNumber = '' ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPurchaseOrderInTransitListRequest */
export class RestPurchaseOrderInTransitListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPurchaseOrderInTransitReasonRequest */
export class RestPurchaseOrderInTransitReasonRequest {
	constructor() {
		this.purchaseOrderInTransitBean = null ;
		this.reason = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPurchaseOrderInTransitRollLineRequest */
export class RestPurchaseOrderInTransitRollLineRequest {
	constructor() {
		this.searchCriteria = null ;
		this.purchaseOrderInTransitBean = null ;
		this.reason = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPurchaseOrderLineAdjustmentCriteriaRequest */
export class RestPurchaseOrderLineAdjustmentCriteriaRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPurchaseOrderLinePageListRequest */
export class RestPurchaseOrderLinePageListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPurchaseOrderLineReasonRequest */
export class RestPurchaseOrderLineReasonRequest {
	constructor() {
		this.searchCriteria = null ;
		this.reason = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPurchaseOrderLinesDataRequest */
export class RestPurchaseOrderLinesDataRequest {
	constructor() {
		this.companyCode = '' ;
		this.excelFileName = '' ;
		this.vendorCode = '' ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPurchaseOrderListRequest */
export class RestPurchaseOrderListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPurchaseOrderNumberRequest */
export class RestPurchaseOrderNumberRequest {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.isNew = false ;
		this.infoBean = null ;
		this.inputReportBean = null ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPurchaseOrderReasonRequest */
export class RestPurchaseOrderReasonRequest {
	constructor() {
		this.purchaseOrderBean = null ;
		this.reason = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPurchaseOrderReceiptApprovalListRequest */
export class RestPurchaseOrderReceiptApprovalListRequest {
	constructor() {
		this.criteriaBean = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPurchaseOrderReceiptBeanRequest */
export class RestPurchaseOrderReceiptBeanRequest {
	constructor() {
		this.purchaseOrderReceiptBean = null ;
		this.reason = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPurchaseOrderReceiptExcelImportRequest */
export class RestPurchaseOrderReceiptExcelImportRequest {
	constructor() {
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.excelFileName = '' ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPurchaseOrderReceiptLineRequest */
export class RestPurchaseOrderReceiptLineRequest {
	constructor() {
		this.lineSearchCriteria = null ;
		this.reason = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPurchaseOrderReceiptListRequest */
export class RestPurchaseOrderReceiptListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestPurchaseOrderReceiptRequest */
export class RestPurchaseOrderReceiptRequest {
	constructor() {
		this.purchaseOrderReceiptBean = null ;
		this.reason = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestReadRequest */
export class RestReadRequest {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestRoleEntitlementListRequest */
export class RestRoleEntitlementListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestRoleListRequest */
export class RestRoleListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestSalesAndPurchaseInquiryListRequest */
export class RestSalesAndPurchaseInquiryListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.reportBean = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestSalesOrderLineAdjustmentRequest */
export class RestSalesOrderLineAdjustmentRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestSalesOrderLineCancelRequest */
export class RestSalesOrderLineCancelRequest {
	constructor() {
		this.searchCriteria = null ;
		this.reasonBean = null ;
		this.pageInput = null ;
		this.updateHeaderStatusFlag = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestSalesOrderListRequest */
export class RestSalesOrderListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestSalesOrderRequest */
export class RestSalesOrderRequest {
	constructor() {
		this.salesOrderBean = null ;
		this.reason = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestSalesPriceInquiryListRequest */
export class RestSalesPriceInquiryListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.reportBean = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestShipmentRatesForPickTicketRequest */
export class RestShipmentRatesForPickTicketRequest {
	constructor() {
		this.criteria = null ;
		this.pickTicketBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestSimpleItemBeanRequest */
export class RestSimpleItemBeanRequest {
	constructor() {
		this.companyCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.detailDescription = '' ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestSkuBatchInventoryListRequest */
export class RestSkuBatchInventoryListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestSKUBatchInventoryTrackListRequest */
export class RestSKUBatchInventoryTrackListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestSkuInventoriesListRequest */
export class RestSkuInventoriesListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestSkuInventoryListRequest */
export class RestSkuInventoryListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestSKUInventoryTrackListRequest */
export class RestSKUInventoryTrackListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.reportBean = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestSkuInventoryTrackSummaryProcessListRequest */
export class RestSkuInventoryTrackSummaryProcessListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestspecialApproveSalesOrderRequest */
export class RestspecialApproveSalesOrderRequest {
	constructor() {
		this.salesOrderBean = null ;
		this.reason = null ;
		this.byPassDueAmountChecking = false ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestUserListRequest */
export class RestUserListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestUserPrinterListRequest */
export class RestUserPrinterListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.entityCode = '' ;
		this.printEntityType = 0 ;
		this.pageInput = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestUserRoleListRequest */
export class RestUserRoleListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestVendorFactoryListRequest */
export class RestVendorFactoryListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestVendorFactoryReadRequest */
export class RestVendorFactoryReadRequest {
	constructor() {
		this.vendorCode = '' ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestVendorInvoiceListRequest */
export class RestVendorInvoiceListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestVendorInvoicePaymentListRequest */
export class RestVendorInvoicePaymentListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestVendorInvoiceRequest */
export class RestVendorInvoiceRequest {
	constructor() {
		this.vendorInvoiceBean = null ;
		this.reason = null ;
		this.companyCode = '' ;
		this.code = '' ;
		this.isLockRequired = false ;
		this.isLoadChildren = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestVendorListRequest */
export class RestVendorListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestVendorModuleInitRequest */
export class RestVendorModuleInitRequest {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.isLockRequired = false ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestVendorPurchaseInTransitCustomerAllocationListRequest */
export class RestVendorPurchaseInTransitCustomerAllocationListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.isStartDateBased = false ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RestVendorPurchaseOnOrderListRequest */
export class RestVendorPurchaseOnOrderListRequest {
	constructor() {
		this.searchCriteria = null ;
		this.pageInput = null ;
		this.isStartDateBased = false ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.ReturnSalesPersonCommissionDetailsPrintRequest */
export class ReturnSalesPersonCommissionDetailsPrintRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.RollSkuEntityPrintRequest */
export class RollSkuEntityPrintRequest {
	constructor() {
		this.companyCode = '' ;
		this.rollSkuNumber = 0 ;
		this.locationCode = '' ;
		this.noOfCopies = 0 ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.SalesBackOrderPrintOutRequest */
export class SalesBackOrderPrintOutRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.SalesCommissionTransactionForInputPrintRequest */
export class SalesCommissionTransactionForInputPrintRequest {
	constructor() {
		this.input = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.SalesCommissionTransactionPrintRequest */
export class SalesCommissionTransactionPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.SalesOrderCancelLineDetailsRequest */
export class SalesOrderCancelLineDetailsRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.SalesOrderListDetailsRequest */
export class SalesOrderListDetailsRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.SalesOrderRegisterDetailInfosRequest */
export class SalesOrderRegisterDetailInfosRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.SalesOrderStatusListDetailRequest */
export class SalesOrderStatusListDetailRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.SalesPersonCommissionDetailsPrintRequest */
export class SalesPersonCommissionDetailsPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.SalesPurchasePositionCriteriaBeanRequest */
export class SalesPurchasePositionCriteriaBeanRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.sendLateSalesOrderMailRequest */
export class sendLateSalesOrderMailRequest {
	constructor() {
		this.criteria = null ;
		this.infoBean = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.ShippingPrintRequest */
export class ShippingPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.SkuBatchHoldLocationForInventoryAdjustmentPrintRequest */
export class SkuBatchHoldLocationForInventoryAdjustmentPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.SkuBatchHoldLocationForInventoryTransferPrintRequest */
export class SkuBatchHoldLocationForInventoryTransferPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.SkuBatchHoldLocationInventoryPrintRequest */
export class SkuBatchHoldLocationInventoryPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.SkuBatchInventoryPageListPrintRequest */
export class SkuBatchInventoryPageListPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.SKUBatchInventoryPhysicalVerificationTrackRequest */
export class SKUBatchInventoryPhysicalVerificationTrackRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.SkuBatchInventorySummaryDetailsPrintRequest */
export class SkuBatchInventorySummaryDetailsPrintRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.SkuBatchInventorySummaryMailRequest */
export class SkuBatchInventorySummaryMailRequest {
	constructor() {
		this.criteria = null ;
		this.infoBean = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.SkubatchInventoryTrackPrintOutRequest */
export class SkubatchInventoryTrackPrintOutRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.SKUInventoryBinSummaryRequest */
export class SKUInventoryBinSummaryRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.SKUInventoryResultForSKUBasedPrintRequest */
export class SKUInventoryResultForSKUBasedPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.SKUInventoryTrackSummaryProcessPrintRequest */
export class SKUInventoryTrackSummaryProcessPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.SummaryReportInfoPrintRequest */
export class SummaryReportInfoPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
	}
}
/* ds.rest.request.unApprovedPurchaseOrderPrintRequest */
export class unApprovedPurchaseOrderPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.UnPostedARListPrintRequest */
export class UnPostedARListPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.VendorOnOrderPrintReport_dorellRequest */
export class VendorOnOrderPrintReport_dorellRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.VendorOnOrderPrintRequest */
export class VendorOnOrderPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.VendorPurchaseOnOrderDetailsPrintReport_StandardRequest */
export class VendorPurchaseOnOrderDetailsPrintReport_StandardRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.VendorPurchaseOnOrderDetailsPrintRequest */
export class VendorPurchaseOnOrderDetailsPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.VendorPurchaseOrderDataRequest */
export class VendorPurchaseOrderDataRequest {
	constructor() {
		this.criteria = null ;
		this.pageInput = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.VendorStatisticsPrintRequest */
export class VendorStatisticsPrintRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.VendorSummaryOnOrderATSDetailsRequest */
export class VendorSummaryOnOrderATSDetailsRequest {
	constructor() {
		this.criteria = null ;
		this.reportBean = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.WebInventoryRequest */
export class WebInventoryRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.request.YearlyStasticsSalesAnalysisRequest */
export class YearlyStasticsSalesAnalysisRequest {
	constructor() {
		this.criteria = null ;
		this.input = null ;
		this.requestToken = '' ;
		this.requestStationCode = '' ;
	}
}
/* ds.rest.response.RestInventoryStatusResultBean */
export class RestInventoryStatusResultBean {
	constructor() {
		this.restInventorydetails = new Array() ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.response.RestInventoryStatusResultResponseBean */
export class RestInventoryStatusResultResponseBean {
	constructor() {
		this.resultResponseInfos = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.RestBinInventoryDetailResponseBean */
export class RestBinInventoryDetailResponseBean {
	constructor() {
		this.binInventories = new Array() ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.RestBinInventoryDetailsInputBean */
export class RestBinInventoryDetailsInputBean {
	constructor() {
		this.companyCode = '' ;
		this.rollSkuNumber = 0 ;
		this.locationCode = '' ;
		this.binLocationCode = '' ;
	}
}
/* ds.rest.RestCustomerPortalInvoiceBean */
export class RestCustomerPortalInvoiceBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.invoiceStatus = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerCompanyName = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.billToCode = '' ;
		this.shipToCode = '' ;
		this.shipToName = '' ;
		this.shipViaCode = '' ;
		this.freightMethodCode = '' ;
		this.paymentMethodCode = '' ;
		this.paymentTermCode = '' ;
		this.subTotalAmount = 0 ;
		this.grandTotalAmount = 0 ;
		this.customerType = '' ;
		this.deliveryDate = '' ;
		this.invoiceDate = '' ;
		this.companyCurrencyCode = '' ;
		this.invoiceCurrencyCode = '' ;
		this.standardSubTotalAmount = 0 ;
		this.standardGrandTotalAmount = 0 ;
		this.totalInvoiceQuantity = 0 ;
		this.pickTicketNumber = '' ;
		this.salesOrderNumber = '' ;
		this.shipmentInstructions = '' ;
		this.carrierDetails = '' ;
		this.shippedBY = '' ;
		this.shippedDate = '' ;
		this.locationCode = '' ;
		this.businessDivision = '' ;
		this.logisticMethodCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.totalServiceAmount = 0 ;
		this.standardTotalServiceAmount = 0 ;
	}
}
/* ds.rest.RestInventoryReportSearchCriteria */
export class RestInventoryReportSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
	}
}
/* ds.rest.RestInventoryStatusReport */
export class RestInventoryStatusReport {
	constructor() {
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.uomCode = '' ;
		this.noOfPallets = 0 ;
		this.unitArea = 0 ;
		this.receivedQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.balanceQuantity = 0 ;
		this.totalArea = 0 ;
		this.casesPerPallets = 0 ;
		this.customerCode = '' ;
		this.customerName = '' ;
	}
}
/* ds.rest.RestInvoiceBean */
export class RestInvoiceBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.pickTicketNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.salesOrderNumber = '' ;
		this.customerShipToCode = '' ;
		this.customerShipToName = '' ;
		this.invoiceCreatedDate = '' ;
		this.invoiceStatus = '' ;
		this.customerPONumber = '' ;
		this.invoiceDueDate = '' ;
		this.shipped = false ;
		this.invoiceLines = new Array() ;
	}
}
/* ds.rest.RestInvoiceInputBean */
export class RestInvoiceInputBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
	}
}
/* ds.rest.RestInvoiceLineBean */
export class RestInvoiceLineBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.pickTicketNumber = '' ;
		this.invoiceLineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.skuNumber = 0 ;
		this.orderQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.numberOfRollsPicked = 0 ;
		this.rollLines = new Array() ;
	}
}
/* ds.rest.RestInvoiceResponseBean */
export class RestInvoiceResponseBean {
	constructor() {
		this.invoiceBean = null ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.RestInvoiceRollLineBean */
export class RestInvoiceRollLineBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.invoiceLineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.skuNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.pickedQuantity = 0 ;
		this.onHandQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.warehouseCode = '' ;
		this.rollNumber = '' ;
		this.boxNumber = '' ;
		this.vendorBatchNumber = '' ;
		this.vendorCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
	}
}
/* ds.rest.RestPickTicketBean */
export class RestPickTicketBean {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.salesOrderNumber = '' ;
		this.customerShipToCode = '' ;
		this.customerShipToName = '' ;
		this.pickTicketCreatedDate = '' ;
		this.pickTicketStatus = '' ;
		this.pickTicketLines = new Array() ;
	}
}
/* ds.rest.RestPickTicketInputBean */
export class RestPickTicketInputBean {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
	}
}
/* ds.rest.RestPickTicketLineBean */
export class RestPickTicketLineBean {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.pickTicketLineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.skuNumber = 0 ;
		this.orderQuantity = 0 ;
		this.pickedQuantity = 0 ;
		this.currentlyPickedQuantity = 0 ;
		this.toBePickedQuantity = 0 ;
		this.onHandQuantity = 0 ;
		this.numberOfRollsPicked = 0 ;
		this.rollLines = new Array() ;
	}
}
/* ds.rest.RestPickTicketResponseBean */
export class RestPickTicketResponseBean {
	constructor() {
		this.pickTicketBean = null ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.RestPickTicketRollLineBean */
export class RestPickTicketRollLineBean {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.pickTicketLineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.skuNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.pickedQuantity = 0 ;
		this.onHandQuantity = 0 ;
		this.currentlyPickedQuantity = 0 ;
		this.warehouseCode = '' ;
		this.rollNumber = '' ;
		this.boxNumber = '' ;
		this.vendorBatchNumber = '' ;
		this.vendorCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
	}
}
/* ds.rest.RestRollSKUBatchInventoryResponseBean */
export class RestRollSKUBatchInventoryResponseBean {
	constructor() {
		this.skuBatchInventoryBean = null ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.RestRollSKUInputBean */
export class RestRollSKUInputBean {
	constructor() {
		this.companyCode = '' ;
		this.rollSkuNumber = '' ;
		this.locationCode = '' ;
	}
}
/* ds.rest.RestSKUBatchesResponseBean */
export class RestSKUBatchesResponseBean {
	constructor() {
		this.skuBatches = new Array() ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.RestSKUBatchInventoryBean */
export class RestSKUBatchInventoryBean {
	constructor() {
		this.companyCode = '' ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.aisleInfoText = '' ;
		this.referenceEntityType = '' ;
		this.referenceEntityNumber = '' ;
		this.uomCode = '' ;
		this.currencyCode = '' ;
		this.onHandQuantity = 0 ;
		this.receivedQuantity = 0 ;
		this.cost = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.batchBarCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.rollBarCode = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.receivedDate = '' ;
		this.isPickedFlag = false ;
		this.isCloseOutInventory = false ;
		this.isNewlyAddedToInventory = false ;
		this.infoText = '' ;
		this.lastPhysicalInventoryVerificationDate = '' ;
	}
}
/* ds.rest.RestUpdateRollSKUBatchesInputBean */
export class RestUpdateRollSKUBatchesInputBean {
	constructor() {
		this.skuBatches = new Array() ;
		this.isSuccess = false ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.infoMessage = '' ;
		this.errorMessage = '' ;
		this.isSessionExpired = false ;
	}
}
/* ds.rest.RestUpdateRollSKUBean */
export class RestUpdateRollSKUBean {
	constructor() {
		this.companyCode = '' ;
		this.rollSkuNumber = 0 ;
		this.locationCode = '' ;
		this.aisleInfoText = '' ;
		this.physicalVerificationLocationCode = '' ;
	}
}
/* ds.sales.BaseCommissionBean */
export class BaseCommissionBean {
	constructor() {
		this.companyCode = '' ;
		this.lineNumber = 0 ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.productDivisionCode = '' ;
		this.commissionSalesAmount = 0 ;
		this.commissionPercentage = 0 ;
		this.commissionAmount = 0 ;
		this.commissionStatus = '' ;
		this.comments = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.CCPaymentInputDetailsBean */
export class CCPaymentInputDetailsBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.cardNumber = '' ;
		this.cardAmount = 0 ;
		this.currencyCode = '' ;
		this.cardType = '' ;
		this.expiryMonth = '' ;
		this.expiryYear = '' ;
		this.isDebitCard = false ;
		this.cardHolderFirstName = '' ;
		this.cardHolderLastName = '' ;
		this.cardIssuedDate = '' ;
		this.comments = '' ;
	}
}
/* ds.sales.CreateInvoiceResult */
export class CreateInvoiceResult {
	constructor() {
		this.invoice = null ;
	}
}
/* ds.sales.criteria.AdvancedMassSalesOrderLineSearchCriteria */
export class AdvancedMassSalesOrderLineSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
	}
}
/* ds.sales.criteria.AdvancedMassSalesOrderSearchCriteria */
export class AdvancedMassSalesOrderSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.lineSearchCriteria = new Array() ;
	}
}
/* ds.sales.criteria.BulkSalesOrderSearchCriteria */
export class BulkSalesOrderSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.customerCode = '' ;
		this.createdDate = '' ;
		this.orderDate = '' ;
		this.orderStatus = '' ;
		this.orderTypeCode = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.paymentTermCode = '' ;
		this.paymentMethodCode = '' ;
		this.shipViaCode = '' ;
		this.wareHouseCode = '' ;
		this.salesOrderNumberContains = '' ;
		this.salesOrderNumberStartsWith = '' ;
		this.regularOrder = false ;
		this.isBulkOrder = false ;
		this.isDistroOrder = false ;
		this.orderStopDatefrom = '' ;
		this.orderStopDateTo = '' ;
		this.customerPurchaseOrderNumberStartsWith = '' ;
		this.customerPurchaseOrderNumberContains = '' ;
	}
}
/* ds.sales.criteria.CommercialInvoiceSearchCriteria */
export class CommercialInvoiceSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.invoiceNumbers = new Array() ;
	}
}
/* ds.sales.criteria.CustomerSalesTrackSearchCriteria */
export class CustomerSalesTrackSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.salesOrderNumber = '' ;
		this.itemCode = '' ;
		this.fromOrderStopDate = '' ;
		this.toOrderStopDate = '' ;
	}
}
/* ds.sales.criteria.DeliveryPickTicketSearchCriteria */
export class DeliveryPickTicketSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.salesOrderNumber = '' ;
		this.pickTicketNumber = '' ;
	}
}
/* ds.sales.criteria.FabricStyleSalePriceInputCriteriaBean */
export class FabricStyleSalePriceInputCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.uomCode = '' ;
		this.widthCode = '' ;
		this.customerCode = '' ;
		this.customerTypeCode = '' ;
		this.customerShipToCode = '' ;
		this.orderDate = '' ;
		this.currencyCode = '' ;
		this.skuNumber = 0 ;
		this.samplePriceFlag = false ;
	}
}
/* ds.sales.criteria.GroupSalesOrderSearchCriteria */
export class GroupSalesOrderSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.groupSalesOrderNumber = '' ;
		this.customerCode = '' ;
		this.orderStatus = '' ;
		this.createdDate = '' ;
		this.orderDate = '' ;
		this.customerPurchaseOrderNumber = '' ;
	}
}
/* ds.sales.criteria.InvoiceBatchApprovalSearchCriteriaBean */
export class InvoiceBatchApprovalSearchCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.createdDate = '' ;
		this.fabricStyleCode = '' ;
		this.paymentDueDate = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.salesOrderNumber = '' ;
		this.pickTicketNumber = '' ;
	}
}
/* ds.sales.criteria.InvoiceCommissionSearchCriteria */
export class InvoiceCommissionSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.invoiceNumberList = null ;
		this.salesPersonCode = '' ;
		this.salesPersonCodeList = null ;
		this.salesPersonName = '' ;
	}
}
/* ds.sales.criteria.InvoiceLineSearchCriteria */
export class InvoiceLineSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.customerCode = '' ;
		this.itemCode = '' ;
		this.lineStatus = '' ;
		this.invoiceStatus = '' ;
		this.lineNumber = 0 ;
	}
}
/* ds.sales.criteria.InvoiceSearchCriteria */
export class InvoiceSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.customerCode = '' ;
		this.createdDate = '' ;
		this.invoiceStatus = '' ;
		this.fabricStyleCode = '' ;
		this.paymentDueDate = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.trackingNumber = '' ;
		this.paymentDueDateFrom = '' ;
		this.paymentDueDateTo = '' ;
		this.invoiceNumberStartsWith = '' ;
		this.invoiceNumberContains = '' ;
		this.salesOrderNumber = '' ;
		this.pickTicketNumber = '' ;
		this.colorCode = '' ;
		this.invoiceFromCreatedDate = '' ;
		this.invoiceToCreatedDate = '' ;
		this.invoiceDate = '' ;
		this.invoiceGrandTotalAmount = 0 ;
		this.invoiceFromDate = '' ;
		this.invoiceToDate = '' ;
		this.latestInvoiceDate = '' ;
		this.displayOption = 0 ;
		this.searchName = '' ;
		this.containerNumber = '' ;
	}
}
/* ds.sales.criteria.ItemSalePriceInputCriteriaBean */
export class ItemSalePriceInputCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.itemCode = '' ;
		this.uomCode = '' ;
		this.sizeCode = '' ;
		this.skuNumber = 0 ;
		this.customerCode = '' ;
		this.orderDate = '' ;
		this.customerTypeCode = '' ;
		this.invoiceCurrencyCode = '' ;
	}
}
/* ds.sales.criteria.MassSalesOrderSearchCriteria */
export class MassSalesOrderSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.headerSearchCriteriaList = new Array() ;
	}
}
/* ds.sales.criteria.MultiplePickTicketSearchCriteria */
export class MultiplePickTicketSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.salesOrderNumber = '' ;
		this.fromPickedDate = '' ;
		this.toPickedDate = '' ;
		this.pickTicketNumber = new Array() ;
	}
}
/* ds.sales.criteria.PeriodSalesCommissionSearchCriteria */
export class PeriodSalesCommissionSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.periodSalesCommissionCode = '' ;
		this.salesPersonCode = '' ;
		this.periodStartDate = '' ;
		this.periodStopDate = '' ;
		this.checkNumber = '' ;
		this.currencyCode = '' ;
		this.status = '' ;
		this.commisionCalculationMethod = 0 ;
		this.fromCreatedDate = '' ;
		this.toCreatedDate = '' ;
	}
}
/* ds.sales.criteria.PickTicketSearchCriteria */
export class PickTicketSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketCode = '' ;
		this.pickTicketContains = '' ;
		this.pickTicketStartsWith = '' ;
		this.createdDate = '' ;
		this.salesOrderNumber = '' ;
		this.salesOrderLineNumber = 0 ;
		this.salesOrderBarCode = '' ;
		this.customerCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.status = '' ;
		this.pickTicketFromCreatedDate = '' ;
		this.pickTicketToCreatedDate = '' ;
		this.searchName = '' ;
	}
}
/* ds.sales.criteria.SalesCommisionTransactionCriteria */
export class SalesCommisionTransactionCriteria {
	constructor() {
		this.companyCode = '' ;
		this.salesPersonCode = '' ;
		this.startDate = '' ;
		this.stopDate = '' ;
		this.status = '' ;
		this.commissionPaidDate = '' ;
		this.checkDate = '' ;
		this.checkNumber = '' ;
		this.documentNumber = '' ;
		this.documentNumbers = new Array() ;
	}
}
/* ds.sales.criteria.SalesOrderLineSalesPriceSearchCriteria */
export class SalesOrderLineSalesPriceSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.fromOrderStopDate = '' ;
		this.toOrderStopDate = '' ;
		this.customerCode = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
	}
}
/* ds.sales.criteria.SalesOrderLineSearchCriteria */
export class SalesOrderLineSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.fromOrderStopDate = '' ;
		this.toOrderStopDate = '' ;
		this.customerCode = '' ;
		this.itemCode = '' ;
		this.orderDate = '' ;
		this.lineStatus = '' ;
		this.orderStatus = '' ;
		this.orderLineBarCode = '' ;
		this.isProcessedItem = false ;
		this.lineNumber = 0 ;
	}
}
/* ds.sales.criteria.SalesOrderReportCriteriaBean */
export class SalesOrderReportCriteriaBean {
	constructor() {
		this.salesOrderNumber = '' ;
	}
}
/* ds.sales.criteria.SalesOrderSearchCriteria */
export class SalesOrderSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.customerCode = '' ;
		this.createdDate = '' ;
		this.orderDate = '' ;
		this.orderStatus = '' ;
		this.orderTypeCode = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.paymentTermCode = '' ;
		this.paymentMethodCode = '' ;
		this.shipViaCode = '' ;
		this.salesOrderNumberContains = '' ;
		this.salesOrderNumberStartsWith = '' ;
		this.orderStopDatefrom = '' ;
		this.orderStopDateTo = '' ;
		this.fabricStyleCode = '' ;
		this.customerPurchaseOrderNumberStartsWith = '' ;
		this.customerPurchaseOrderNumberContains = '' ;
		this.isOpenSalesOrderFlag = false ;
		this.backOrderInclusionState = 0 ;
		this.fabricStyleColorCode = '' ;
		this.isWebOrderFlag = false ;
		this.searchName = '' ;
		this.salesOrderNumbers = new Array() ;
	}
}
/* ds.sales.criteria.ShipmentRateCriteria */
export class ShipmentRateCriteria {
	constructor() {
		this.carrierCode = '' ;
		this.carrierMethod = '' ;
		this.useCustomerAccountForShippingFlag = false ;
	}
}
/* ds.sales.criteria.UpsSummaryCriteria */
export class UpsSummaryCriteria {
	constructor() {
		this.companyCode = '' ;
		this.shipDate = '' ;
	}
}
/* ds.sales.DeliveryPickTicketBean */
export class DeliveryPickTicketBean {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.receivedBy = '' ;
		this.deliveredBy = '' ;
		this.receivedDate = '' ;
		this.deliveredDate = '' ;
		this.signatureImageName = '' ;
		this.signatureImageCode = '' ;
		this.signatureImagePart = '' ;
		this.signatureImagePath = '' ;
		this.signatureVerifyImageName = '' ;
		this.signatureVerifyImageCode = '' ;
		this.signatureVerifyImagePart = '' ;
		this.signatureVerifyImagePath = '' ;
		this.signatureVerifyImageName2 = '' ;
		this.signatureVerifyImageCode2 = '' ;
		this.signatureVerifyImagePart2 = '' ;
		this.signatureVerifyImagePath2 = '' ;
		this.signatureVerifyImageName3 = '' ;
		this.signatureVerifyImageCode3 = '' ;
		this.signatureVerifyImagePart3 = '' ;
		this.signatureVerifyImagePath3 = '' ;
		this.signatureVerifyImageName4 = '' ;
		this.signatureVerifyImageCode4 = '' ;
		this.signatureVerifyImagePart4 = '' ;
		this.signatureVerifyImagePath4 = '' ;
		this.signatureVerifyImageName5 = '' ;
		this.signatureVerifyImageCode5 = '' ;
		this.signatureVerifyImagePart5 = '' ;
		this.signatureVerifyImagePath5 = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.deps.GroupSalesOrderModuleDependenciesBean */
export class GroupSalesOrderModuleDependenciesBean {
	constructor() {
		this.groupSalesOrderBean = null ;
	}
}
/* ds.sales.deps.InvoiceModuleDependenciesBean */
export class InvoiceModuleDependenciesBean {
	constructor() {
		this.salesOrders = new Array() ;
		this.pickTickets = new Array() ;
		this.fabricStyles = new Array() ;
		this.customer = null ;
	}
}
/* ds.sales.deps.PeriodSalesCommissionDependenciesBean */
export class PeriodSalesCommissionDependenciesBean {
	constructor() {
	}
}
/* ds.sales.deps.PickTicketModuleDependenciesBean */
export class PickTicketModuleDependenciesBean {
	constructor() {
		this.remarks = '' ;
		this.invoices = new Array() ;
		this.customer = null ;
	}
}
/* ds.sales.deps.response.GroupSalesOrderModuleDependenciesResponseBean */
export class GroupSalesOrderModuleDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.deps.response.InvoiceModuleDependenciesResponseBean */
export class InvoiceModuleDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.deps.response.PeriodSalesCommissionDependenciesResponseBean */
export class PeriodSalesCommissionDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.deps.response.PickTicketModuleDependenciesResponseBean */
export class PickTicketModuleDependenciesResponseBean {
	constructor() {
		this.pickTicketModuleDependencyBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.deps.response.SalesOrderModuleDependenciesResponseBean */
export class SalesOrderModuleDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.deps.SalesOrderModuleDependenciesBean */
export class SalesOrderModuleDependenciesBean {
	constructor() {
		this.customer = null ;
		this.adjustmentTracks = new Array() ;
		this.fabricStyles = new Array() ;
		this.invoices = new Array() ;
		this.pickTickets = new Array() ;
		this.isInvoiceAvailable = false ;
	}
}
/* ds.sales.GroupSalesOrderBean */
export class GroupSalesOrderBean {
	constructor() {
		this.companyCode = '' ;
		this.orderStatus = '' ;
		this.createdDate = '' ;
		this.orderDate = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.earliestOrderStartDate = '' ;
		this.latestOrderStopDate = '' ;
		this.remarks = '' ;
		this.orderLines = new Array() ;
		this.statusTracks = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.GroupSalesOrderLineBean */
export class GroupSalesOrderLineBean {
	constructor() {
		this.groupSalesOrderNumber = '' ;
		this.compannyCode = '' ;
		this.salesOrderNumber = '' ;
		this.customerCode = '' ;
		this.billToCode = '' ;
		this.shipToCode = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.currencyCode = '' ;
		this.totalAmount = 0 ;
	}
}
/* ds.sales.GroupSalesOrderStatusTrackBean */
export class GroupSalesOrderStatusTrackBean {
	constructor() {
		this.orderNumber = '' ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.history.InvoiceElementHistoryBean */
export class InvoiceElementHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.history.InvoiceElementHistoryPageListBean */
export class InvoiceElementHistoryPageListBean {
	constructor() {
		this.histories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.sales.history.InvoiceLineElementHistoryBean */
export class InvoiceLineElementHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.lineNumber = 0 ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.history.InvoiceLineElementHistoryPageListBean */
export class InvoiceLineElementHistoryPageListBean {
	constructor() {
		this.histories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.sales.history.SalesOrderElementHistoryBean */
export class SalesOrderElementHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.history.SalesOrderElementHistoryPageListBean */
export class SalesOrderElementHistoryPageListBean {
	constructor() {
		this.histories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.sales.history.SalesOrderLineElementHistoryBean */
export class SalesOrderLineElementHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.salesOrderLineNumber = 0 ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.history.SalesOrderLineElementHistoryPageListBean */
export class SalesOrderLineElementHistoryPageListBean {
	constructor() {
		this.histories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.sales.history.SalesOrderLineGroupElementHistoryBean */
export class SalesOrderLineGroupElementHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.lineNumber = 0 ;
		this.trackNumber = 0 ;
		this.trackElementNumber = 0 ;
		this.elementValueType = 0 ;
		this.previousValue = '' ;
		this.newValue = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.history.SalesOrderLineGroupElementHistoryPageListBean */
export class SalesOrderLineGroupElementHistoryPageListBean {
	constructor() {
		this.histories = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.sales.inquiry.InvoiceDetailForCommercialInvoiceResultBean */
export class InvoiceDetailForCommercialInvoiceResultBean {
	constructor() {
		this.count = 0 ;
		this.invoicesDetail = new Array() ;
	}
}
/* ds.sales.inquiry.MonthlySalesInvoiceResultBean */
export class MonthlySalesInvoiceResultBean {
	constructor() {
		this.totalSalesInvoiceAmount = 0 ;
	}
}
/* ds.sales.inquiry.SalesInvoiceForFabricStyleStatisticsResultBean */
export class SalesInvoiceForFabricStyleStatisticsResultBean {
	constructor() {
		this.invoices = new Array() ;
	}
}
/* ds.sales.inquiry.SalesOrderLineResult */
export class SalesOrderLineResult {
	constructor() {
		this.salesOrder = null ;
		this.salesOrderLines = new Array() ;
	}
}
/* ds.sales.inquiry.SalesOrderLineResultPageListBean */
export class SalesOrderLineResultPageListBean {
	constructor() {
		this.lineResults = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.sales.InvoiceBatchApprovalBean */
export class InvoiceBatchApprovalBean {
	constructor() {
		this.companyCode = '' ;
		this.batchDate = '' ;
		this.approvalDetails = new Array() ;
		this.inputCriteria = null ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.InvoiceBatchApprovalDetailBean */
export class InvoiceBatchApprovalDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.batchReferenceNumber = '' ;
		this.invoiceNumber = '' ;
		this.customerCode = '' ;
		this.customerCurrencyCode = '' ;
		this.invoiceAmount = 0 ;
		this.selectedForApproval = false ;
		this.batchApprovalStatus = '' ;
		this.remarks = '' ;
		this.batchDate = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.InvoiceBatchApprovalInputCriteriaBean */
export class InvoiceBatchApprovalInputCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.batchReferenceNumber = '' ;
		this.customerCode = '' ;
		this.createdDate = '' ;
		this.fabricStyleCode = '' ;
		this.paymentDueDate = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.salesOrderNumber = '' ;
		this.pickTicketNumber = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.InvoiceBean */
export class InvoiceBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceStatus = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerCompanyName = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.billToCode = '' ;
		this.shipToCode = '' ;
		this.shipToName = '' ;
		this.shipViaCode = '' ;
		this.freightMethodCode = '' ;
		this.paymentMethodCode = '' ;
		this.paymentTermCode = '' ;
		this.projectNumber = '' ;
		this.paymentDueDate = '' ;
		this.address = null ;
		this.taxRequiredFlag = false ;
		this.taxPercentage = 0 ;
		this.subTotalAmount = 0 ;
		this.totalTaxAmount = 0 ;
		this.discountAmount = 0 ;
		this.extraChargesAmount = 0 ;
		this.shipmentChargesAmount = 0 ;
		this.nonMerchandiseTotalAmount = 0 ;
		this.grandTotalAmount = 0 ;
		this.provisionalPaymentAmount = 0 ;
		this.provisionalChargeBackAmount = 0 ;
		this.provisionalCreditMemoAmount = 0 ;
		this.provisionalOtherAppliedAmount = 0 ;
		this.paidAmount = 0 ;
		this.paidChargeBackAmount = 0 ;
		this.paidCreditMemoAmount = 0 ;
		this.paidOtherAppliedAmount = 0 ;
		this.adjustedPaidAmount = 0 ;
		this.netPaidAmount = 0 ;
		this.comments = '' ;
		this.instructions = '' ;
		this.specialOperationReason = '' ;
		this.invoicePrintOutTypeCode = '' ;
		this.customerType = '' ;
		this.salesOrderNumber = '' ;
		this.salesRepresentativeCode = '' ;
		this.salesClerkCode = '' ;
		this.invoiceType = '' ;
		this.stationCode = '' ;
		this.invoiceNotes = '' ;
		this.deliveryDate = '' ;
		this.invoiceDate = '' ;
		this.checkBounceAdjustedAmount = 0 ;
		this.companyCurrencyCode = '' ;
		this.invoiceCurrencyCode = '' ;
		this.actualExchangeRate = 0 ;
		this.adjustedExchangeRate = 0 ;
		this.standardSubTotalAmount = 0 ;
		this.standardTotalTaxAmount = 0 ;
		this.standardDiscountAmount = 0 ;
		this.standardShipmentChargesAmount = 0 ;
		this.standardExtraChargesAmount = 0 ;
		this.standardNonMerchandiseTotalAmount = 0 ;
		this.standardGrandTotalAmount = 0 ;
		this.standardPaidAmount = 0 ;
		this.standardPaidChargeBackAmount = 0 ;
		this.standardPaidCreditMemoAmount = 0 ;
		this.standardPaidOtherAppliedAmount = 0 ;
		this.standardAdjustedPaidAmount = 0 ;
		this.standardNetPaidAmount = 0 ;
		this.createdSource = '' ;
		this.createdSourceDate = '' ;
		this.createdSourceEntityNumber = '' ;
		this.trackingNumber = '' ;
		this.trackingRemarks = '' ;
		this.customerComments = '' ;
		this.currencyExchangeRateCode = '' ;
		this.approvalBatchReferenceNumber = '' ;
		this.fabricStyles = '' ;
		this.oldSystemInvoiceNumber = '' ;
		this.paymentDueDays = 0 ;
		this.totalInvoiceQuantity = 0 ;
		this.totalNumberInvoiceLines = 0 ;
		this.profitAmount = 0 ;
		this.pickTicketNumber = '' ;
		this.shipmentInstructions = '' ;
		this.carrierDetails = '' ;
		this.preferredCreditCardNumber = '' ;
		this.isBackOrderFlag = false ;
		this.isPaidForceFlag = false ;
		this.commissionPaidFlag = false ;
		this.ShippedFlag = false ;
		this.shippedBY = '' ;
		this.shippedDate = '' ;
		this.tariffPercentage = 0 ;
		this.tariffAmount = 0 ;
		this.standardTariffAmount = 0 ;
		this.salesPersonCodes = '' ;
		this.salesPersonNames = '' ;
		this.numberOfRolls = 0 ;
		this.closeSalesOrderFlagAfterInvoiceApproval = false ;
		this.locationCode = '' ;
		this.businessDivision = '' ;
		this.logisticMethodCode = '' ;
		this.isWebOrderFlag = false ;
		this.isPaymentFlag = false ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.totalServiceAmount = 0 ;
		this.standardTotalServiceAmount = 0 ;
		this.isSurChargeIncludeFlag = false ;
		this.billToAddress = null ;
		this.billToName = '' ;
		this.sealNumber = '' ;
		this.serviceLines = new Array() ;
		this.lines = new Array() ;
		this.nonMerchandiseLines = new Array() ;
		this.statusTracks = new Array() ;
		this.invoiceCommissions = new Array() ;
		this.extraCharges = new Array() ;
		this.boxDetails = new Array() ;
		this.paidAmountAdjustments = new Array() ;
		this.changeHistoryTracks = new Array() ;
		this.imageName = '' ;
		this.imageFilePath = '' ;
		this.logisticOrderNumber = '' ;
		this.logisticOrderReceiptNumber = '' ;
		this.documentName = '' ;
		this.documentFilePath = '' ;
		this.isInBoundReceiptFlag = false ;
		this.totalNumberOfPallets = 0 ;
		this.isManualEntry = false ;
		this.containerNumber = '' ;
		this.commoditiesDescription = '' ;
		this.warehousePurchaseOrderNumber = '' ;
		this.commodityCode = '' ;
		this.invoiceImages = new Array() ;
		this.invoiceDocuments = new Array() ;
		this.invoiceModel = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.InvoiceChangeHistoryBean */
export class InvoiceChangeHistoryBean {
	constructor() {
		this.invoiceNumber = '' ;
		this.trackNumber = 0 ;
		this.companyCode = '' ;
		this.workStationCode = '' ;
		this.workStationIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.InvoiceCloseOutRollDetailLineBean */
export class InvoiceCloseOutRollDetailLineBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.invoiceLineNumber = 0 ;
		this.invoiceRollLineNumber = 0 ;
		this.closeOutLineNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.shippedQuantity = 0 ;
		this.rollDetails = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.InvoiceCommissionBean */
export class InvoiceCommissionBean {
	constructor() {
		this.invoiceNumber = '' ;
		this.salesCommissionTransactionNumber = 0 ;
		this.companyCode = '' ;
		this.lineNumber = 0 ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.productDivisionCode = '' ;
		this.commissionSalesAmount = 0 ;
		this.commissionPercentage = 0 ;
		this.commissionAmount = 0 ;
		this.commissionStatus = '' ;
		this.comments = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.InvoiceDocumentBean */
export class InvoiceDocumentBean {
	constructor() {
		this.invoiceNumber = '' ;
		this.companyCode = '' ;
		this.documentOriginalName = '' ;
		this.documentNumber = 0 ;
		this.documentCode = '' ;
		this.documentPath = '' ;
		this.documentName = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.InvoiceExtraChargesBean */
export class InvoiceExtraChargesBean {
	constructor() {
		this.companyCode = '' ;
		this.lineNumber = 0 ;
		this.invoiceNumber = '' ;
		this.extraChargesAmount = 0 ;
		this.extraChargeReasonCode = '' ;
		this.extraChargeReasonName = '' ;
		this.currencyCode = '' ;
		this.comments = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.InvoiceImageBean */
export class InvoiceImageBean {
	constructor() {
		this.invoiceNumber = '' ;
		this.imageCode = '' ;
		this.imagePart = '' ;
		this.imagePath = '' ;
		this.imageName = '' ;
		this.companyCode = '' ;
		this.imageOritinalname = '' ;
		this.tags = '' ;
		this.notesCommunication = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.InvoiceLineBean */
export class InvoiceLineBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.lineNumber = 0 ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.upcCode = '' ;
		this.uomCode = '' ;
		this.price = 0 ;
		this.originalPrice = 0 ;
		this.discountPercentage = 0 ;
		this.onHandQuantity = 0 ;
		this.onOrderQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.returnQuantity = 0 ;
		this.lineTotalAmount = 0 ;
		this.lineNetAmount = 0 ;
		this.lineDiscountAmount = 0 ;
		this.cost = 0 ;
		this.locationCode = '' ;
		this.remarks = '' ;
		this.lineStatus = '' ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = 0 ;
		this.currencyCode = '' ;
		this.isItemTaxableFlag = false ;
		this.taxPercentage = 0 ;
		this.taxAmount = 0 ;
		this.sourceSalesOrderNumber = '' ;
		this.sourceSalesOrderLineNumber = 0 ;
		this.sourcePickTicketNumber = '' ;
		this.sourcePickTicketLineNumber = 0 ;
		this.adjustedQuantity = 0 ;
		this.standardPrice = 0 ;
		this.standardLineCost = 0 ;
		this.standardLineTotalAmount = 0 ;
		this.standardLineNetAmount = 0 ;
		this.oldSystemInvoiceLineNumber = '' ;
		this.comments = '' ;
		this.tariffPercentage = 0 ;
		this.tariffAmount = 0 ;
		this.aprice = 0 ;
		this.bprice = 0 ;
		this.numberOfPallets = 0 ;
		this.vendorBatchNumber = '' ;
		this.weight = 0 ;
		this.weightUomCode = '' ;
		this.adjustmentLines = new Array() ;
		this.rollLines = new Array() ;
		this.invoiceLineCommissions = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.InvoiceLineCommissionBean */
export class InvoiceLineCommissionBean {
	constructor() {
		this.invoiceNumber = '' ;
		this.invoiceLineNumber = 0 ;
		this.companyCode = '' ;
		this.lineNumber = 0 ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.productDivisionCode = '' ;
		this.commissionSalesAmount = 0 ;
		this.commissionPercentage = 0 ;
		this.commissionAmount = 0 ;
		this.commissionStatus = '' ;
		this.comments = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.InvoiceLineQuantityAdjustmentLineBean */
export class InvoiceLineQuantityAdjustmentLineBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.invoiceLineNumber = 0 ;
		this.adjustmentLineNumber = 0 ;
		this.adjustmentReasonCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.uomCode = '' ;
		this.adjustedQuantity = 0 ;
		this.adjustedUomCode = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.InvoiceLineShippedQuantityAdjustmentLineBean */
export class InvoiceLineShippedQuantityAdjustmentLineBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.invoiceLineNumber = 0 ;
		this.adjustmentLineNumber = 0 ;
		this.itemCode = '' ;
		this.itemDescription = '' ;
		this.colorCode = '' ;
		this.dimensionCode = '' ;
		this.sizeCode = '' ;
		this.skuNumber = 0 ;
		this.warehouseCode = '' ;
		this.uomCode = '' ;
		this.adjustedQuantity = 0 ;
		this.adjustedWeight = 0 ;
		this.adjustedUomCode = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.InvoiceNonMerchandiseLineBean */
export class InvoiceNonMerchandiseLineBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.lineNumber = 0 ;
		this.lineStatus = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.reasonCode = '' ;
		this.reasonName = '' ;
		this.lineTotalAmount = 0 ;
		this.remarks = '' ;
		this.currencyCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.InvoicePaidAmountAdjustmentHistoryBean */
export class InvoicePaidAmountAdjustmentHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.trackNumber = 0 ;
		this.adjustedAmount = 0 ;
		this.adjustedEntityType = 0 ;
		this.adjustedEntityNumber = '' ;
		this.adjustedBy = '' ;
		this.adjustedDate = '' ;
		this.paymentType = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.InvoiceResultBean */
export class InvoiceResultBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.invoiceStatus = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.invoiceDate = '' ;
		this.createdDate = '' ;
		this.companyCurrencyCode = '' ;
		this.invoiceCurrencyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.price = 0 ;
		this.cost = 0 ;
		this.shippedQuantity = 0 ;
		this.locationCode = '' ;
		this.lineStatus = '' ;
		this.inventoryUomCode = '' ;
		this.rollSkuNumber = 0 ;
	}
}
/* ds.sales.InvoiceRollLineBean */
export class InvoiceRollLineBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.invoiceLineNumber = 0 ;
		this.invoiceRollLineNumber = 0 ;
		this.sourcePickTicketNumber = '' ;
		this.sourcePickTicketLineNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.invoiceUomCode = '' ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = 0 ;
		this.boxNumber = '' ;
		this.vendorCode = '' ;
		this.vendorBatchNumber = '' ;
		this.purchasOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.availableQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.shippedAdjustedQuantity = 0 ;
		this.locationCode = '' ;
		this.sourceLocationCode = '' ;
		this.isCloseOutInventory = false ;
		this.isRollPartialInventoryFlag = false ;
		this.price = 0 ;
		this.logisticOrderReceiptNumber = '' ;
		this.containerNumber = '' ;
		this.warehousePurchaseOrderNumber = '' ;
		this.projectNumber = '' ;
		this.closeOutRollDetails = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.InvoiceRollLinesWithPriceResultBean */
export class InvoiceRollLinesWithPriceResultBean {
	constructor() {
		this.invoiceRollLinesWithPrice = new Array() ;
	}
}
/* ds.sales.InvoiceServiceLineBean */
export class InvoiceServiceLineBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.lineNumber = 0 ;
		this.serviceCode = '' ;
		this.serviceName = '' ;
		this.lineStatus = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.uomCode = '' ;
		this.unitPrice = 0 ;
		this.quantity = 0 ;
		this.amount = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.InvoiceShipmentBoxDetailBean */
export class InvoiceShipmentBoxDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.boxLineNumber = 0 ;
		this.boxNumber = '' ;
		this.weightInLbs = 0 ;
		this.widthInInces = 0 ;
		this.heightInInces = 0 ;
		this.lengthInInces = 0 ;
		this.codValue = 0 ;
		this.insuredValue = 0 ;
		this.trackingNumber = '' ;
		this.isResidentialDelivery = false ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.InvoiceStatusTrackBean */
export class InvoiceStatusTrackBean {
	constructor() {
		this.invoiceNumber = '' ;
		this.invoiceTotalAmount = 0 ;
		this.currencyCode = '' ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.merge.response.GroupSalesOrderModuleMergeResponseBean */
export class GroupSalesOrderModuleMergeResponseBean {
	constructor() {
		this.groupSalesOrderResponse = null ;
		this.lockResponse = null ;
		this.dependenciesResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.merge.response.InvoiceApprovalOperationsResponseBean */
export class InvoiceApprovalOperationsResponseBean {
	constructor() {
		this.approveOperationResponse = null ;
		this.printReportResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.merge.response.InvoiceApproveAndARApproveMergeOperationsResponseBean */
export class InvoiceApproveAndARApproveMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.printReportResponse = null ;
		this.lockResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.merge.response.InvoiceMergeOperationsResponseBean */
export class InvoiceMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.printReportResponse = null ;
		this.lockResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.merge.response.InvoiceModuleMergeResponseBean */
export class InvoiceModuleMergeResponseBean {
	constructor() {
		this.printReportResponse = null ;
		this.lockResponse = null ;
		this.dependenciesResponse = null ;
		this.invoiceResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.merge.response.PeriodSalesCommissionMergeOperationResponseBean */
export class PeriodSalesCommissionMergeOperationResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.lockResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.merge.response.PeriodSalesCommissionMergeResponseBean */
export class PeriodSalesCommissionMergeResponseBean {
	constructor() {
		this.periodSalesCommissioinResponseBean = null ;
		this.lockResponse = null ;
		this.dependenciesResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.merge.response.PickTicketMergeOperationsResponseBean */
export class PickTicketMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.lockResponse = null ;
		this.reportResultResponse = null ;
		this.pickTicketDependencyResponse = null ;
		this.invoiceResponse = null ;
		this.accountReceivableResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.merge.response.PickTicketModuleMergeResponseBean */
export class PickTicketModuleMergeResponseBean {
	constructor() {
		this.dependencyResponse = null ;
		this.invoiceResponse = null ;
		this.pickTicketDependencyResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.merge.response.SalesOrderMergeOperationsResponseBean */
export class SalesOrderMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.lockResponse = null ;
		this.pickTicketPrintReportResponse = null ;
		this.pickTicketResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.merge.response.SalesOrderModuleMergeResponseBean */
export class SalesOrderModuleMergeResponseBean {
	constructor() {
		this.salesOrderResponse = null ;
		this.lockResponse = null ;
		this.dependenciesResponse = null ;
		this.pickTicketPrintReportResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.merge.response.SalesOrderTotalOperationsResponseBean */
export class SalesOrderTotalOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.approveOperationResponse = null ;
		this.lockResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.MultiDocumentMailInputInfo */
export class MultiDocumentMailInputInfo {
	constructor() {
		this.companyCode = '' ;
		this.from = '' ;
		this.tos = '' ;
		this.ccs = '' ;
		this.customerCode = '' ;
		this.invoiceNumbers = new Array() ;
		this.title = '' ;
		this.message = '' ;
	}
}
/* ds.sales.pagelist.GroupSalesOrderPageListBean */
export class GroupSalesOrderPageListBean {
	constructor() {
		this.groupSalesOrders = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.sales.pagelist.InvoicePageListBean */
export class InvoicePageListBean {
	constructor() {
		this.invoices = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.sales.pagelist.InvoiceResultPageListBean */
export class InvoiceResultPageListBean {
	constructor() {
		this.invoiceResults = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.sales.pagelist.PeriodSalesCommisionPageListBean */
export class PeriodSalesCommisionPageListBean {
	constructor() {
		this.periodSalesCommissionPageList = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.sales.pagelist.PickTicketPageListBean */
export class PickTicketPageListBean {
	constructor() {
		this.pickTickets = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.sales.pagelist.response.GroupSalesOrderPageListResponseBean */
export class GroupSalesOrderPageListResponseBean {
	constructor() {
		this.groupSalesOrderPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.pagelist.response.InvoicePageListResponseBean */
export class InvoicePageListResponseBean {
	constructor() {
		this.invoicePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.pagelist.response.InvoiceResultPageListResponseBean */
export class InvoiceResultPageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.pagelist.response.PeriodSalesCommisionPageListResponseBean */
export class PeriodSalesCommisionPageListResponseBean {
	constructor() {
		this.pageListBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.pagelist.response.PickTicketPageListResponseBean */
export class PickTicketPageListResponseBean {
	constructor() {
		this.pickTicketPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.pagelist.response.SalesOrderElementHistoryPageListResponseBean */
export class SalesOrderElementHistoryPageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.pagelist.response.SalesOrderLineAdjustmentTrackInquiryPageListResponseBean */
export class SalesOrderLineAdjustmentTrackInquiryPageListResponseBean {
	constructor() {
		this.inquiryResponse = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.pagelist.response.SalesOrderLineElementHistoryPageListResponseBean */
export class SalesOrderLineElementHistoryPageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.pagelist.response.SalesOrderLineGroupElementHistoryPageListResponseBean */
export class SalesOrderLineGroupElementHistoryPageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.pagelist.response.SalesOrderLinePageListResponseBean */
export class SalesOrderLinePageListResponseBean {
	constructor() {
		this.salesOrderLinePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.pagelist.response.SalesOrderLineWithOrderInfoPageListResponseBean */
export class SalesOrderLineWithOrderInfoPageListResponseBean {
	constructor() {
		this.salesOrderLinePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.pagelist.response.SalesOrderPageListResponseBean */
export class SalesOrderPageListResponseBean {
	constructor() {
		this.salesOrderPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.pagelist.SalesOrderLinePageListBean */
export class SalesOrderLinePageListBean {
	constructor() {
		this.salesOrderLines = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.sales.pagelist.SalesOrderPageListBean */
export class SalesOrderPageListBean {
	constructor() {
		this.salesOrders = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.sales.PeriodSalesCommisionBean */
export class PeriodSalesCommisionBean {
	constructor() {
		this.companyCode = '' ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.periodStartDate = '' ;
		this.periodStopDate = '' ;
		this.isApproved = false ;
		this.status = '' ;
		this.commisionCalculationMethod = 0 ;
		this.totalCommissionAmount = 0 ;
		this.currencyCode = '' ;
		this.isCheckIssued = false ;
		this.checkNumber = '' ;
		this.checkDetails = '' ;
		this.checkDate = '' ;
		this.totalAdjustmentAmount = 0 ;
		this.grandCommissionAmount = 0 ;
		this.commissionDetails = new Array() ;
		this.statusTrckBean = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.PeriodSalesCommisionLineBean */
export class PeriodSalesCommisionLineBean {
	constructor() {
		this.companyCode = '' ;
		this.periodSalesCommissionCode = '' ;
		this.commissionLineNumber = 0 ;
		this.invoiceNumber = '' ;
		this.invoiceDate = '' ;
		this.paymentTermCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.invoiceAmount = 0 ;
		this.invoiceSubTotal = 0 ;
		this.dueAmount = 0 ;
		this.periodPaidAmount = 0 ;
		this.commisssionPercentage = 0 ;
		this.commissionAmount = 0 ;
		this.adjustmentAmount = 0 ;
		this.netCommissionAmount = 0 ;
		this.adjustmentReasonCode = '' ;
		this.adjustmentReason = '' ;
		this.isPaidToSalesPerson = false ;
		this.salesCommissionTransactionNumber = 0 ;
		this.documentType = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.PeriodSalesCommisionStatusTrackBean */
export class PeriodSalesCommisionStatusTrackBean {
	constructor() {
		this.totalCommissionAmount = 0 ;
		this.periodSalesCommissionCode = '' ;
		this.currencyCode = '' ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.PickTicketAllocatedRollLineBean */
export class PickTicketAllocatedRollLineBean {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.pickTicketLineNumber = 0 ;
		this.pickTicketAllocatedRollLineNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.orderUomCode = '' ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = 0 ;
		this.boxNumber = '' ;
		this.vendorCode = '' ;
		this.vendorBatchNumber = '' ;
		this.purchasOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.availableQuantity = 0 ;
		this.pickedQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.currentlyPickedQuantity = 0 ;
		this.locationCode = '' ;
		this.pickedLocationCode = '' ;
		this.binLocation = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.inventoryUpdatedQuantity = 0 ;
		this.batchBarCode = '' ;
		this.isRollPartialInventoryFlag = false ;
		this.isCloseOutInventory = false ;
		this.isSelected = false ;
		this.upcNumber = '' ;
		this.palletNumber = '' ;
		this.imeiNumber = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.PickTicketBean */
export class PickTicketBean {
	constructor() {
		this.companyCode = '' ;
		this.comments = '' ;
		this.status = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.salesOrderNumber = '' ;
		this.currencyCode = '' ;
		this.shipmentCharges = 0 ;
		this.shipmentInstructions = '' ;
		this.carrierDetails = '' ;
		this.trackingNumber = '' ;
		this.businessDivision = '' ;
		this.projectNumber = '' ;
		this.shipToCode = '' ;
		this.shipToName = '' ;
		this.shipToAddress = null ;
		this.shipViaCode = '' ;
		this.freightMethodCode = '' ;
		this.isShippedFlag = false ;
		this.isBackOrderFlag = false ;
		this.isPackedFlag = false ;
		this.useCustomerAccountForShippingFlag = false ;
		this.shipConfirmProcessCompletedFlag = false ;
		this.customerShippingAccountNumber = '' ;
		this.customerShippingAccountCountryCode = '' ;
		this.customerShippingAccountPostalCode = '' ;
		this.shipmentCarrier = '' ;
		this.shipmentCarrierMethod = '' ;
		this.shipmentCarrierMethodName = '' ;
		this.totalCarrierShipmentCharges = 0 ;
		this.shipmentCarrierReferenceNumber = '' ;
		this.shipmentDigestFileName = '' ;
		this.shipmentDigestFilePath = '' ;
		this.shipmentDisclaimerText = '' ;
		this.shipConfirmedBy = '' ;
		this.shipConfirmedDate = '' ;
		this.shippingAdditionalHandlingIndicatorFlag = false ;
		this.shippingDeliveryConfirmationFlag = false ;
		this.closeSalesOrderFlagAfterInvoiceApproval = false ;
		this.pickedUpBy = '' ;
		this.pickedUpDate = '' ;
		this.notes = '' ;
		this.shipmentIdentificationNumber = '' ;
		this.isPrintedPickTicketFlag = false ;
		this.billOfLading = '' ;
		this.fabricStyleCode = '' ;
		this.salesInvoiceNumber = '' ;
		this.prefferedLocationCode = '' ;
		this.logisticMethodCode = '' ;
		this.isWebOrderFlag = false ;
		this.isPaymentFlag = false ;
		this.packedUpBy = '' ;
		this.packedUpDate = '' ;
		this.shippedBy = '' ;
		this.shippedDate = '' ;
		this.isSurChargeIncludeFlag = false ;
		this.freightCharges = 0 ;
		this.packingNotes = '' ;
		this.pickTicketLines = new Array() ;
		this.statusTracks = new Array() ;
		this.boxDetails = new Array() ;
		this.changeHistoryTracks = new Array() ;
		this.imageName = '' ;
		this.imageFilePath = '' ;
		this.documentName = '' ;
		this.documentFilePath = '' ;
		this.totalNumberOfPallets = 0 ;
		this.printOutTypeCode = '' ;
		this.isHazardousFlag = false ;
		this.receivedBy = '' ;
		this.deliveredBy = '' ;
		this.receivedDate = '' ;
		this.deliveredDate = '' ;
		this.orderTypeCode = '' ;
		this.signatureImageName = '' ;
		this.signatureImageCode = '' ;
		this.signatureImagePart = '' ;
		this.signatureImagePath = '' ;
		this.signatureVerifyImageName = '' ;
		this.signatureVerifyImageCode = '' ;
		this.signatureVerifyImagePart = '' ;
		this.signatureVerifyImagePath = '' ;
		this.signatureVerifyImageName2 = '' ;
		this.signatureVerifyImageCode2 = '' ;
		this.signatureVerifyImagePart2 = '' ;
		this.signatureVerifyImagePath2 = '' ;
		this.signatureVerifyImageName3 = '' ;
		this.signatureVerifyImageCode3 = '' ;
		this.signatureVerifyImagePart3 = '' ;
		this.signatureVerifyImagePath3 = '' ;
		this.signatureVerifyImageName4 = '' ;
		this.signatureVerifyImageCode4 = '' ;
		this.signatureVerifyImagePart4 = '' ;
		this.signatureVerifyImagePath4 = '' ;
		this.signatureVerifyImageName5 = '' ;
		this.signatureVerifyImageCode5 = '' ;
		this.signatureVerifyImagePart5 = '' ;
		this.signatureVerifyImagePath5 = '' ;
		this.printDate = '' ;
		this.printedBy = '' ;
		this.packingListPrintDate = '' ;
		this.packingListPrintedBy = '' ;
		this.isPrintedPackingListFlag = false ;
		this.pickTicketImages = new Array() ;
		this.pickTicketDocuments = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.PickTicketBoxPalletLineDetailBean */
export class PickTicketBoxPalletLineDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.pickTicketLineNumber = 0 ;
		this.palletLineNumber = 0 ;
		this.boxLineNumber = 0 ;
		this.palletNumber = '' ;
		this.boxNumber = '' ;
		this.palletQuantity = 0 ;
		this.skuNumber = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.PickTicketChangeHistoryBean */
export class PickTicketChangeHistoryBean {
	constructor() {
		this.pickTicketNumber = '' ;
		this.trackNumber = 0 ;
		this.companyCode = '' ;
		this.workStationCode = '' ;
		this.workStationIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.PickTicketCloseOutRollDetailLineBean */
export class PickTicketCloseOutRollDetailLineBean {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.pickTicketLineNumber = 0 ;
		this.pickTicketRollLineNumber = 0 ;
		this.closeOutLineNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.pickedQuantity = 0 ;
		this.rollDetails = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.PickTicketDocumentBean */
export class PickTicketDocumentBean {
	constructor() {
		this.pickTicketNumber = '' ;
		this.companyCode = '' ;
		this.documentOriginalName = '' ;
		this.documentNumber = 0 ;
		this.documentCode = '' ;
		this.documentPath = '' ;
		this.documentName = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.PickTicketImageBean */
export class PickTicketImageBean {
	constructor() {
		this.pickTicketNumber = '' ;
		this.imageCode = '' ;
		this.imagePart = '' ;
		this.imagePath = '' ;
		this.imageName = '' ;
		this.companyCode = '' ;
		this.imageOritinalname = '' ;
		this.tags = '' ;
		this.notesCommunication = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.PickTicketLineBean */
export class PickTicketLineBean {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.pickTicketLineNumber = 0 ;
		this.salesOrderBarCode = '' ;
		this.salesOrderNumber = '' ;
		this.salesOrderLineNumber = 0 ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.price = 0 ;
		this.currencyCode = '' ;
		this.orderUomCode = '' ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = 0 ;
		this.lineStatus = '' ;
		this.orderQuantity = 0 ;
		this.toBePickedQuantity = 0 ;
		this.pickedQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.currentlyPickedQuantity = 0 ;
		this.sourceLocationCode = '' ;
		this.onHandQuantity = 0 ;
		this.comments = '' ;
		this.remarks = '' ;
		this.numberOfPallets = 0 ;
		this.lotNumber = '' ;
		this.weight = 0 ;
		this.weightUomCode = '' ;
		this.packageType = '' ;
		this.isInventoryUpdated = false ;
		this.suggestedBinLocations = new Array() ;
		this.rollLines = new Array() ;
		this.allocatedRollLines = new Array() ;
		this.palletLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.PickTicketLinePalletDetailBean */
export class PickTicketLinePalletDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.pickTicketLineNumber = 0 ;
		this.palletNumber = '' ;
		this.dimensionUomCode = '' ;
		this.palletDimension = 0 ;
		this.numberOfItemsPerPallet = 0 ;
		this.weight = 0 ;
		this.weightUomCode = '' ;
		this.skuNumber = 0 ;
		this.palletLineNumber = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.PickTicketRollLineBean */
export class PickTicketRollLineBean {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.pickTicketLineNumber = 0 ;
		this.pickTicketRollLineNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.orderUomCode = '' ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = 0 ;
		this.boxNumber = '' ;
		this.vendorCode = '' ;
		this.vendorBatchNumber = '' ;
		this.purchasOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.availableQuantity = 0 ;
		this.pickedQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.currentlyPickedQuantity = 0 ;
		this.locationCode = '' ;
		this.pickedLocationCode = '' ;
		this.binLocation = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.inventoryUpdatedQuantity = 0 ;
		this.isRollPartialInventoryFlag = false ;
		this.isCloseOutInventory = false ;
		this.isSelected = false ;
		this.upcNumber = '' ;
		this.palletNumber = '' ;
		this.imeiNumber = '' ;
		this.logisticOrderReceiptNumber = '' ;
		this.containerNumber = '' ;
		this.warehousePurchaseOrderNumber = '' ;
		this.projectNumber = '' ;
		this.closeOutRollDetails = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.PickTicketShipmentBoxDetailBean */
export class PickTicketShipmentBoxDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.pickTicketNumber = '' ;
		this.boxLineNumber = 0 ;
		this.boxNumber = '' ;
		this.weightInLbs = 0 ;
		this.widthInInces = 0 ;
		this.heightInInces = 0 ;
		this.lengthInInces = 0 ;
		this.codValue = 0 ;
		this.insuredValue = 0 ;
		this.declaredValue = 0 ;
		this.trackingNumber = '' ;
		this.isResidentialDelivery = false ;
		this.shipmentCharges = 0 ;
		this.labelImageName = '' ;
		this.labelImagePath = '' ;
		this.remarks = '' ;
		this.codFundsCode = '' ;
		this.billOfLading = '' ;
		this.boxType = '' ;
		this.boxPalletLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.PickTicketStatusTrackBean */
export class PickTicketStatusTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.pickTicketNumber = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.response.DeliveryPickTicketResponseBean */
export class DeliveryPickTicketResponseBean {
	constructor() {
		this.pickTicket = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.FabricStyleSalesPriceResponseBean */
export class FabricStyleSalesPriceResponseBean {
	constructor() {
		this.itemPrice = 0 ;
		this.priceCriteria = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.GroupSalesOrderResponseBean */
export class GroupSalesOrderResponseBean {
	constructor() {
		this.groupSalesOrder = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.InvoiceBatchApprovalResponseBean */
export class InvoiceBatchApprovalResponseBean {
	constructor() {
		this.batchApprovalBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.InvoiceDetailForCommercialInvoiceResultResponseBean */
export class InvoiceDetailForCommercialInvoiceResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.InvoiceElementHistoryPageListResponseBean */
export class InvoiceElementHistoryPageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.InvoiceLineElementHistoryPageListResponseBean */
export class InvoiceLineElementHistoryPageListResponseBean {
	constructor() {
		this.pageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.InvoiceLinesResponseBean */
export class InvoiceLinesResponseBean {
	constructor() {
		this.invoiceLines = new Array() ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.InvoiceResponseBean */
export class InvoiceResponseBean {
	constructor() {
		this.invoice = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.InvoiceUnApprovedResponseBean */
export class InvoiceUnApprovedResponseBean {
	constructor() {
		this.invoice = new Array() ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.MassPurchaseOrderResponseBean */
export class MassPurchaseOrderResponseBean {
	constructor() {
		this.massPurchaseOrder = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.MassSalesOrderResponseBean */
export class MassSalesOrderResponseBean {
	constructor() {
		this.massSalesOrder = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.MonthlySalesInvoiceResultResponseBean */
export class MonthlySalesInvoiceResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.PeriodSalesCommissionResponseBean */
export class PeriodSalesCommissionResponseBean {
	constructor() {
		this.salesCommissionBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.PickTicketResponseBean */
export class PickTicketResponseBean {
	constructor() {
		this.pickTicket = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.SalesCommisionTransactionResultResponseBean */
export class SalesCommisionTransactionResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.SalesCommissionTransactionResponseBean */
export class SalesCommissionTransactionResponseBean {
	constructor() {
		this.salesCommissionBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.SalesInvoiceForFabricStyleStatisticsResultResponseBean */
export class SalesInvoiceForFabricStyleStatisticsResultResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.SalesOrderAdjustmentTrackInquiryResponseBean */
export class SalesOrderAdjustmentTrackInquiryResponseBean {
	constructor() {
		this.result = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.SalesOrderImageResponseBean */
export class SalesOrderImageResponseBean {
	constructor() {
		this.salesOrderImage = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.SalesOrderResponseBean */
export class SalesOrderResponseBean {
	constructor() {
		this.salesOrder = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.ShipmentRatesResponseBean */
export class ShipmentRatesResponseBean {
	constructor() {
		this.rateResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.response.ValidateCreditCardResultResponseBean */
export class ValidateCreditCardResultResponseBean {
	constructor() {
		this.validationResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.sales.SalesCommisionTransactionBean */
export class SalesCommisionTransactionBean {
	constructor() {
		this.companyCode = '' ;
		this.salesCommissionTransactionNumber = 0 ;
		this.transactionDate = '' ;
		this.entryDate = '' ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.currencyCode = '' ;
		this.status = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.documentNumber = '' ;
		this.documentType = '' ;
		this.transactionType = '' ;
		this.invoiceGrandTotalAmount = 0 ;
		this.invoiceSubTotal = 0 ;
		this.invoiceDiscountAmount = 0 ;
		this.invoiceDueAmount = 0 ;
		this.accountReceivbaleNumber = '' ;
		this.transactionAmount = 0 ;
		this.commissionPercentage = 0 ;
		this.commissionAmount = 0 ;
		this.adjustmentReasonCode = '' ;
		this.adjustmentRemarks = '' ;
		this.checkNumber = '' ;
		this.checkDate = '' ;
		this.commissionPaidDate = '' ;
		this.paymentNotes = '' ;
		this.logisticMethodCode = '' ;
		this.customerType = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.SalesCommisionTransactionResultBean */
export class SalesCommisionTransactionResultBean {
	constructor() {
		this.salesCommissionTransctionBean = new Array() ;
	}
}
/* ds.sales.SalesCommisionTransactionsInputBean */
export class SalesCommisionTransactionsInputBean {
	constructor() {
		this.salesCommissionTransctions = new Array() ;
		this.salesCommissionTransactionCount = 0 ;
		this.companyCode = '' ;
		this.remarks = '' ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.currencyCode = '' ;
		this.checkNumber = '' ;
		this.checkDate = '' ;
		this.periodStartDate = '' ;
		this.periodStopDate = '' ;
		this.totalCommissionAmount = 0 ;
	}
}
/* ds.sales.SalesInvoiceForFabricStyleStatisticsBean */
export class SalesInvoiceForFabricStyleStatisticsBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.invoiceNumber = '' ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.uomCode = '' ;
		this.quantity = 0 ;
		this.invoiceDate = '' ;
		this.noOfRolls = 0 ;
		this.locationCode = '' ;
		this.customerShipToName = '' ;
	}
}
/* ds.sales.SalesLineBaseBean */
export class SalesLineBaseBean {
	constructor() {
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.lineStatus = '' ;
		this.originalPrice = 0 ;
		this.price = 0 ;
		this.cost = 0 ;
		this.extraCharge = 0 ;
		this.extraPrice = 0 ;
		this.discountPercentage = 0 ;
		this.lineDiscountAmount = 0 ;
		this.lineNetAmount = 0 ;
		this.lineTotalAmount = 0 ;
		this.taxAmount = 0 ;
		this.isItemTaxableFlag = false ;
		this.taxPercentage = 0 ;
		this.standardPrice = 0 ;
		this.standardCost = 0 ;
		this.standardLineNetAmount = 0 ;
		this.standardLineTotalAmount = 0 ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = 0 ;
		this.productDivisionCode = '' ;
		this.productDepartmentCode = '' ;
		this.productClassCode = '' ;
		this.productSubClassCode = '' ;
		this.skuNumber = 0 ;
		this.upcCode = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.SalesOrderBean */
export class SalesOrderBean {
	constructor() {
		this.companyCode = '' ;
		this.groupOrderNumber = '' ;
		this.orderStatus = '' ;
		this.orderTypeCode = '' ;
		this.divisionCode = '' ;
		this.createdDate = '' ;
		this.orderDate = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.xDCDate = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.shipToCode = '' ;
		this.shipToName = '' ;
		this.billToCode = '' ;
		this.isOneTimeShipTo = false ;
		this.address = null ;
		this.coOrdinationCode = '' ;
		this.allocationPriority = 0 ;
		this.isSampleSales = false ;
		this.paymentTermCode = '' ;
		this.paymentMethodCode = '' ;
		this.shipViaCode = '' ;
		this.freightMethodCode = '' ;
		this.factorCode = '' ;
		this.isFactorApproved = false ;
		this.factorApprovedAmount = 0 ;
		this.factorApprovalNumber = '' ;
		this.factorCompany = '' ;
		this.subTotalAmount = 0 ;
		this.taxRequiredFlag = false ;
		this.taxPercentage = 0 ;
		this.totalTaxAmount = 0 ;
		this.discountAmount = 0 ;
		this.shipmentChargesAmount = 0 ;
		this.extraChargesAmount = 0 ;
		this.grandTotalAmount = 0 ;
		this.isApproved = false ;
		this.approvalNumber = '' ;
		this.confirmedBy = '' ;
		this.confirmedDate = '' ;
		this.isConfirmed = false ;
		this.customerDivisionCode = '' ;
		this.customerDepartmentCode = '' ;
		this.customerClassCode = '' ;
		this.customerSubClassCode = '' ;
		this.customerSalesZoneCode = '' ;
		this.customerSalesRegionCode = '' ;
		this.customerSalesDistrictCode = '' ;
		this.customerSalesTerritoryCode = '' ;
		this.isEdiOrder = false ;
		this.ediOrderReferenceNumber = '' ;
		this.comments = '' ;
		this.instructions = '' ;
		this.specialOperationReason = '' ;
		this.fabricStyleCode = '' ;
		this.customerCompanyName = '' ;
		this.customerType = '' ;
		this.invoicePrintOutTypeCode = '' ;
		this.salesClerkCode = '' ;
		this.salesRepresentativeCode = '' ;
		this.stationCode = '' ;
		this.companyCurrencyCode = '' ;
		this.currencyExchangeRateCode = '' ;
		this.salesOrderCurrencyCode = '' ;
		this.actualExchangeRate = 0 ;
		this.adjustedExchangeRate = 0 ;
		this.standardShipmentChargesAmount = 0 ;
		this.standardExtraChargesAmount = 0 ;
		this.standardDiscountAmount = 0 ;
		this.standardSubTotalAmount = 0 ;
		this.standardTotalTaxAmount = 0 ;
		this.standardGrandTotalAmount = 0 ;
		this.createdSource = '' ;
		this.createdSourceDate = '' ;
		this.createdSourceEntityNumber = '' ;
		this.trackingNumber = '' ;
		this.trackingRemarks = '' ;
		this.customerComments = '' ;
		this.isCancelled = false ;
		this.cancelledDate = '' ;
		this.cancelledBy = '' ;
		this.holdOrderFlag = false ;
		this.holdOrderDate = '' ;
		this.holdOrderBy = '' ;
		this.holdOrderReleaseDate = '' ;
		this.holdOrderReleaseBy = '' ;
		this.oldSystemSalesOrderNumber = '' ;
		this.totalOrderedQuantity = 0 ;
		this.paymentDueDays = 0 ;
		this.orderRequestedBy = '' ;
		this.isBackOrderFlag = false ;
		this.preferredCreditCardNumber = '' ;
		this.pickedUpBy = '' ;
		this.pickedUpDate = '' ;
		this.imageName = '' ;
		this.imageFilePath = '' ;
		this.documentName = '' ;
		this.documentFilePath = '' ;
		this.customerDeliveryTypeCode = '' ;
		this.isPaidForceFlag = false ;
		this.manualPickticketNumber = '' ;
		this.locationCode = '' ;
		this.pickNotes = '' ;
		this.invoiceNotes = '' ;
		this.internalNotes = '' ;
		this.customerNotes = '' ;
		this.warningNotes = '' ;
		this.businessDivision = '' ;
		this.tariffPercentage = 0 ;
		this.totalTariffAmount = 0 ;
		this.standardTotalTariffAmount = 0 ;
		this.sourceSalesOrderNumber = '' ;
		this.websiteType = '' ;
		this.targetWebsite = '' ;
		this.isWebOrderFlag = false ;
		this.isPaymentFlag = false ;
		this.originalOrderNumber = '' ;
		this.originalOrderType = '' ;
		this.revisedLatestShipDate = '' ;
		this.isSurChargeIncludeFlag = false ;
		this.expectedShipmentDate = '' ;
		this.expectedShipmentTime = '' ;
		this.isImportedFromOldSystem = false ;
		this.lines = new Array() ;
		this.commissions = new Array() ;
		this.statusTracks = new Array() ;
		this.orderImages = new Array() ;
		this.changeHistoryTracks = new Array() ;
		this.salesOrderDocument = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.SalesOrderChangeHistoryBean */
export class SalesOrderChangeHistoryBean {
	constructor() {
		this.salesOrderNumber = '' ;
		this.trackNumber = 0 ;
		this.companyCode = '' ;
		this.workStationCode = '' ;
		this.workStationIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.SalesOrderCommissionBean */
export class SalesOrderCommissionBean {
	constructor() {
		this.salesOrderNumber = '' ;
		this.companyCode = '' ;
		this.lineNumber = 0 ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.productDivisionCode = '' ;
		this.commissionSalesAmount = 0 ;
		this.commissionPercentage = 0 ;
		this.commissionAmount = 0 ;
		this.commissionStatus = '' ;
		this.comments = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.SalesOrderDocumentBean */
export class SalesOrderDocumentBean {
	constructor() {
		this.salesOrderNumber = '' ;
		this.companyCode = '' ;
		this.documentOriginalName = '' ;
		this.documentNumber = 0 ;
		this.documentCode = '' ;
		this.documentPath = '' ;
		this.documentName = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.SalesOrderImageBean */
export class SalesOrderImageBean {
	constructor() {
		this.salesOrderNumber = '' ;
		this.imageCode = '' ;
		this.imagePart = '' ;
		this.imagePath = '' ;
		this.imageName = '' ;
		this.companyCode = '' ;
		this.imageOritinalname = '' ;
		this.tags = '' ;
		this.notesCommunication = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.SalesOrderLineAdjustmentBean */
export class SalesOrderLineAdjustmentBean {
	constructor() {
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.salesOrderLineNumber = 0 ;
		this.adjustmentLineNumber = 0 ;
		this.adjustedQuantity = 0 ;
		this.adjustmentType = '' ;
		this.lineStatus = '' ;
		this.remarks = '' ;
		this.orderStatus = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.adjustedUomCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.SalesOrderLineAdjustmentTrackBean */
export class SalesOrderLineAdjustmentTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.salesOrderLineNumber = 0 ;
		this.adjustmentLineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.upcCode = '' ;
		this.orderUomCode = '' ;
		this.orderStatus = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.openBalance = 0 ;
		this.changedUnits = 0 ;
		this.closeBalance = 0 ;
		this.trackType = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.SalesOrderLineAdjustmentTrackPageListBean */
export class SalesOrderLineAdjustmentTrackPageListBean {
	constructor() {
		this.adjustmentTracks = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.sales.SalesOrderLineBean */
export class SalesOrderLineBean {
	constructor() {
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.salesOrderLineNumber = 0 ;
		this.orderUomCode = '' ;
		this.orderQuantity = 0 ;
		this.adjustedQuantity = 0 ;
		this.allocationPriority = 0 ;
		this.coOrdinationCode = '' ;
		this.allocatedQuantity = 0 ;
		this.pickedQuantity = 0 ;
		this.inPickQuantity = 0 ;
		this.packedQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.shippedAdjustedQuantity = 0 ;
		this.openQuantity = 0 ;
		this.lineTotalAmount = 0 ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.revisedLatestShipDate = '' ;
		this.startDateChangeReason = '' ;
		this.stopDateChangeReason = '' ;
		this.salesTaxRequiredFlag = false ;
		this.groupOrderNumber = '' ;
		this.itemBarCode = '' ;
		this.onHandQuantity = 0 ;
		this.numberOfRollsPreferred = 0 ;
		this.oldSystemSalesOrderLineNumber = '' ;
		this.comments = '' ;
		this.tariffPercentage = 0 ;
		this.tariffAmount = 0 ;
		this.lotNumber = '' ;
		this.commissions = new Array() ;
		this.adjustmentLines = new Array() ;
		this.shippedAdjustedQuantityLines = new Array() ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.lineStatus = '' ;
		this.originalPrice = 0 ;
		this.price = 0 ;
		this.cost = 0 ;
		this.extraCharge = 0 ;
		this.extraPrice = 0 ;
		this.discountPercentage = 0 ;
		this.lineDiscountAmount = 0 ;
		this.lineNetAmount = 0 ;
		this.lineTotalAmount = 0 ;
		this.taxAmount = 0 ;
		this.isItemTaxableFlag = false ;
		this.taxPercentage = 0 ;
		this.standardPrice = 0 ;
		this.standardCost = 0 ;
		this.standardLineNetAmount = 0 ;
		this.standardLineTotalAmount = 0 ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = 0 ;
		this.productDivisionCode = '' ;
		this.productDepartmentCode = '' ;
		this.productClassCode = '' ;
		this.productSubClassCode = '' ;
		this.skuNumber = 0 ;
		this.upcCode = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.SalesOrderLineCancelInfoBean */
export class SalesOrderLineCancelInfoBean {
	constructor() {
		this.adjustmentBean = null ;
		this.adjustmentTrackBean = null ;
		this.orderLine = null ;
	}
}
/* ds.sales.SalesOrderLineCommissionBean */
export class SalesOrderLineCommissionBean {
	constructor() {
		this.salesOrderLineNumber = 0 ;
		this.salesOrderNumber = '' ;
		this.companyCode = '' ;
		this.lineNumber = 0 ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.productDivisionCode = '' ;
		this.commissionSalesAmount = 0 ;
		this.commissionPercentage = 0 ;
		this.commissionAmount = 0 ;
		this.commissionStatus = '' ;
		this.comments = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.SalesOrderLineShippedAdjustedQuantityBean */
export class SalesOrderLineShippedAdjustedQuantityBean {
	constructor() {
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.lineNumber = 0 ;
		this.salesOrderLineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.rollBarCode = '' ;
		this.shippedQuantity = 0 ;
		this.adjustedQuantity = 0 ;
		this.inventoryUomCode = '' ;
		this.adjustedUomCode = '' ;
		this.adjustmentReason = '' ;
		this.invoiceNumber = '' ;
		this.locationCode = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.SalesOrderLineWithOrderInfoBean */
export class SalesOrderLineWithOrderInfoBean {
	constructor() {
		this.orderDate = '' ;
		this.orderCreatedDate = '' ;
		this.customerName = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.salesOrderLineNumber = 0 ;
		this.orderUomCode = '' ;
		this.orderQuantity = 0 ;
		this.adjustedQuantity = 0 ;
		this.allocationPriority = 0 ;
		this.coOrdinationCode = '' ;
		this.allocatedQuantity = 0 ;
		this.pickedQuantity = 0 ;
		this.inPickQuantity = 0 ;
		this.packedQuantity = 0 ;
		this.shippedQuantity = 0 ;
		this.shippedAdjustedQuantity = 0 ;
		this.openQuantity = 0 ;
		this.lineTotalAmount = 0 ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.revisedLatestShipDate = '' ;
		this.startDateChangeReason = '' ;
		this.stopDateChangeReason = '' ;
		this.salesTaxRequiredFlag = false ;
		this.groupOrderNumber = '' ;
		this.itemBarCode = '' ;
		this.onHandQuantity = 0 ;
		this.numberOfRollsPreferred = 0 ;
		this.oldSystemSalesOrderLineNumber = '' ;
		this.comments = '' ;
		this.tariffPercentage = 0 ;
		this.tariffAmount = 0 ;
		this.lotNumber = '' ;
		this.commissions = new Array() ;
		this.adjustmentLines = new Array() ;
		this.shippedAdjustedQuantityLines = new Array() ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.lineStatus = '' ;
		this.originalPrice = 0 ;
		this.price = 0 ;
		this.cost = 0 ;
		this.extraCharge = 0 ;
		this.extraPrice = 0 ;
		this.discountPercentage = 0 ;
		this.lineDiscountAmount = 0 ;
		this.lineNetAmount = 0 ;
		this.lineTotalAmount = 0 ;
		this.taxAmount = 0 ;
		this.isItemTaxableFlag = false ;
		this.taxPercentage = 0 ;
		this.standardPrice = 0 ;
		this.standardCost = 0 ;
		this.standardLineNetAmount = 0 ;
		this.standardLineTotalAmount = 0 ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = 0 ;
		this.productDivisionCode = '' ;
		this.productDepartmentCode = '' ;
		this.productClassCode = '' ;
		this.productSubClassCode = '' ;
		this.skuNumber = 0 ;
		this.upcCode = '' ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.SalesOrderLineWithOrderInfoPageListBean */
export class SalesOrderLineWithOrderInfoPageListBean {
	constructor() {
		this.salesOrderLines = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.sales.SalesOrderSampleInputBean */
export class SalesOrderSampleInputBean {
	constructor() {
		this.companyCode = '' ;
		this.sampleLines = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.SalesOrderSampleRollLineBean */
export class SalesOrderSampleRollLineBean {
	constructor() {
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.orderUomCode = '' ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = 0 ;
		this.boxNumber = '' ;
		this.vendorCode = '' ;
		this.vendorBatchNumber = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.sampleQuantity = 0 ;
		this.locationCode = '' ;
		this.binLocation = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.upcNumber = '' ;
		this.palletNumber = '' ;
		this.imeiNumber = '' ;
		this.containerNumber = '' ;
		this.warehousePurchaseOrderNumber = '' ;
		this.projectNumber = '' ;
		this.serialNumber = '' ;
		this.receiptDate = '' ;
		this.onHandQuantity = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.SalesOrderStatusTrackBean */
export class SalesOrderStatusTrackBean {
	constructor() {
		this.salesOrderNumber = '' ;
		this.totalOrderAmount = 0 ;
		this.currencyCode = '' ;
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.shipment.ShipmentBoxRateBean */
export class ShipmentBoxRateBean {
	constructor() {
		this.boxId = '' ;
		this.totalShipmentRate = 0 ;
		this.billingWeightInLbs = 0 ;
		this.weightInLbs = 0 ;
		this.currencyCode = '' ;
		this.boxLineNumber = 0 ;
		this.shipmentOptionalCharges = 0 ;
		this.transportationCharges = 0 ;
	}
}
/* ds.sales.shipment.ShipmentBoxShipBean */
export class ShipmentBoxShipBean {
	constructor() {
		this.boxId = '' ;
		this.boxLineNumber = 0 ;
		this.labelImageFormatType = '' ;
		this.labelImageData = new Array() ;
		this.trackingNumber = '' ;
	}
}
/* ds.sales.shipment.ShipmentRateBean */
export class ShipmentRateBean {
	constructor() {
		this.carrierCode = '' ;
		this.serviceMethodCode = '' ;
		this.serviceMethodName = '' ;
		this.orginAddress = null ;
		this.destinationAddress = null ;
		this.totalShipmentRate = 0 ;
		this.currencyCode = '' ;
		this.totalWeightInLbs = 0 ;
		this.rateDetails = '' ;
		this.boxRateDetail = new Array() ;
	}
}
/* ds.sales.shipment.ShipmentRateResultBean */
export class ShipmentRateResultBean {
	constructor() {
		this.noOfRates = 0 ;
		this.transactionIdentifier = '' ;
		this.rates = new Array() ;
	}
}
/* ds.sales.shipment.ShipmentShipBean */
export class ShipmentShipBean {
	constructor() {
		this.carrierCode = '' ;
		this.serviceMethodCode = '' ;
		this.serviceMethodName = '' ;
		this.totalShipmentRate = 0 ;
		this.currencyCode = '' ;
		this.totalWeightInLbs = 0 ;
		this.disclaimerText = '' ;
		this.shipmentDigest = new Array() ;
		this.boxShipDetail = new Array() ;
	}
}
/* ds.sales.shipment.ShipmentShipResultBean */
export class ShipmentShipResultBean {
	constructor() {
		this.transactionIdentifier = '' ;
		this.shipmentResult = null ;
		this.shipmentIdentificationNumber = '' ;
	}
}
/* ds.sales.shipment.VoidShipmentShipResultBean */
export class VoidShipmentShipResultBean {
	constructor() {
		this.transactionIdentifier = '' ;
		this.shipmentResult = null ;
	}
}
/* ds.sales.UPSShipmentChangeHistoryBean */
export class UPSShipmentChangeHistoryBean {
	constructor() {
		this.pickTicketNumber = '' ;
		this.upsTrackingNumber = '' ;
		this.userCode = '' ;
		this.shipmentIdentificationNumber = '' ;
		this.trackNumber = 0 ;
		this.companyCode = '' ;
		this.workStationCode = '' ;
		this.workStationIpAddress = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.sales.ValidateCreditCardBean */
export class ValidateCreditCardBean {
	constructor() {
		this.companyCode = '' ;
		this.referenceNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.cardNumber = '' ;
		this.transactionAmount = 0 ;
		this.currencyCode = '' ;
		this.cardType = '' ;
		this.expiryMonth = '' ;
		this.expiryYear = '' ;
		this.cardTransactionGatewayName = '' ;
		this.cardTransactionReferenceNumber = '' ;
		this.isPaymentProcessRequired = false ;
		this.isDebitCard = false ;
		this.cardHolderFirstName = '' ;
		this.cardHolderLastName = '' ;
		this.cardIssuedDate = '' ;
		this.comments = '' ;
	}
}
/* ds.sales.ValidateCreditCardResultBean */
export class ValidateCreditCardResultBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.isSuccess = false ;
		this.paymentResponseDescription = '' ;
		this.transactionRefereceNumber = '' ;
		this.transactionAmount = 0 ;
		this.currencyCode = '' ;
		this.comments = '' ;
		this.referenceNumber = '' ;
	}
}
/* ds.SKUInventoryKey */
export class SKUInventoryKey {
	constructor() {
		this.companyID = '' ;
		this.skuNumber = 0 ;
		this.wareHouse = '' ;
	}
}
/* ds.TextResourceBean */
export class TextResourceBean {
	constructor() {
		this.companyCode = '' ;
		this.resourceKey = 0 ;
		this.languageCode = '' ;
		this.textProperty = '' ;
		this.textPropertyValue = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.CustomerAccountsJournalBean */
export class CustomerAccountsJournalBean {
	constructor() {
		this.transactionNumber = 0 ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.billToCode = '' ;
		this.transactionDate = '' ;
		this.transactionType = 0 ;
		this.accountUpdateType = 0 ;
		this.documentNumber = '' ;
		this.currencyCode = '' ;
		this.invoiceAmount = 0 ;
		this.invoiceSubTotal = 0 ;
		this.invoiceTaxAmount = 0 ;
		this.invoiceDiscountAmount = 0 ;
		this.invoiceShipmentChargesAmount = 0 ;
		this.invoiceMiscellaneousChargesAmount = 0 ;
		this.invoiceCancelledAmount = 0 ;
		this.totalPaymentAppliedAmount = 0 ;
		this.generalPaymentAppliedAmount = 0 ;
		this.creditMemoPaymentAppliedAmount = 0 ;
		this.chargeBackPaymentAppliedAmount = 0 ;
		this.invoicePaymentCancelledAmount = 0 ;
		this.customerAccountNumber = '' ;
		this.invoiceReturnedAmount = 0 ;
		this.invoiceNetPayableAmount = 0 ;
		this.invoiceAdjustedAmount = 0 ;
		this.invoiceExtraChargesAmount = 0 ;
		this.standardInvoiceAmount = 0 ;
		this.standardInvoiceSubTotal = 0 ;
		this.standardInvoiceTaxAmount = 0 ;
		this.standardInvoiceExtraChargesAmount = 0 ;
		this.standardInvoiceShipmentChargesAmount = 0 ;
		this.standardInvoiceMiscellaneousChargesAmount = 0 ;
		this.standardInvoiceCancelledAmount = 0 ;
		this.standardTotalPaymentAppliedAmount = 0 ;
		this.standardGeneralPaymentAppliedAmount = 0 ;
		this.standardCreditMemoPaymentAppliedAmount = 0 ;
		this.standardChargeBackPaymentAppliedAmount = 0 ;
		this.standardInvoicePaymentCancelledAmount = 0 ;
		this.standardInvoiceDiscountAmount = 0 ;
		this.standardInvoiceReturnedAmount = 0 ;
		this.standardInvoiceNetPayableAmount = 0 ;
		this.standardInvoiceAdjustedAmount = 0 ;
		this.companyCurrencyCode = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.report.history.BankAccountBalanceHistoryTrackBean */
export class BankAccountBalanceHistoryTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.balanceHistoryTrackNumber = 0 ;
		this.bankCode = '' ;
		this.historyDate = '' ;
		this.bankAccountNumber = '' ;
		this.currencyCode = '' ;
		this.transactionType = 0 ;
		this.transactionEntityCode = '' ;
		this.openingBalanceAmount = 0 ;
		this.transactionAmount = 0 ;
		this.closingBalanceAmount = 0 ;
		this.sourceTransactionAmount = 0 ;
		this.sourceCurrencyCode = '' ;
		this.exchangeRate = 0 ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.report.history.BaseCustomerPaymentAgingHistoryBean */
export class BaseCustomerPaymentAgingHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.currencyCode = '' ;
		this.totalInvoiceDueAmount = 0 ;
		this.totalUnAppliedCreditMemoAmount = 0 ;
		this.totalUnAppliedChargeBackAmount = 0 ;
		this.totalProvisionalAppliedAmount = 0 ;
		this.currentAgeAmount = 0 ;
		this.ageAmount1 = 0 ;
		this.ageAmount2 = 0 ;
		this.ageAmount3 = 0 ;
		this.ageAmount4 = 0 ;
		this.ageAmount5 = 0 ;
		this.ageAmount6 = 0 ;
		this.ageAmount7 = 0 ;
		this.ageAmount8 = 0 ;
		this.ageAmount9 = 0 ;
		this.ageAmount10 = 0 ;
		this.customerDetails = null ;
		this.companyCurrencyCode = '' ;
		this.standardTotalInvoiceDueAmount = 0 ;
		this.standardCurrentAgeAmount = 0 ;
		this.standardAgeAmount1 = 0 ;
		this.standardAgeAmount2 = 0 ;
		this.standardAgeAmount3 = 0 ;
		this.standardAgeAmount4 = 0 ;
		this.standardAgeAmount5 = 0 ;
		this.standardAgeAmount6 = 0 ;
		this.standardAgeAmount7 = 0 ;
		this.standardAgeAmount8 = 0 ;
		this.standardAgeAmount9 = 0 ;
		this.standardAgeAmount10 = 0 ;
		this.remarks = '' ;
		this.invoiceDetails = new Array() ;
		this.creditMemoDetails = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.report.history.BaseCustomerSalesBackOrderHistoryBean */
export class BaseCustomerSalesBackOrderHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.currencyCode = '' ;
		this.currentQuantity = 0 ;
		this.ageQuantity1 = 0 ;
		this.ageQuantity2 = 0 ;
		this.ageQuantity3 = 0 ;
		this.ageQuantity4 = 0 ;
		this.ageQuantity5 = 0 ;
		this.ageQuantity6 = 0 ;
		this.ageQuantity7 = 0 ;
		this.ageQuantity8 = 0 ;
		this.ageQuantity9 = 0 ;
		this.ageQuantity10 = 0 ;
		this.customerDetails = null ;
		this.companyCurrencyCode = '' ;
		this.remarks = '' ;
		this.totalOpenQuantity = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.report.history.BaseFabricStyleBackOrderHistoryBean */
export class BaseFabricStyleBackOrderHistoryBean {
	constructor() {
		this.currentQuantity = 0 ;
		this.ageQuantity1 = 0 ;
		this.ageQuantity2 = 0 ;
		this.ageQuantity3 = 0 ;
		this.ageQuantity4 = 0 ;
		this.ageQuantity5 = 0 ;
		this.ageQuantity6 = 0 ;
		this.ageQuantity7 = 0 ;
		this.ageQuantity8 = 0 ;
		this.ageQuantity9 = 0 ;
		this.ageQuantity10 = 0 ;
		this.customerDetails = null ;
		this.remarks = '' ;
		this.totalOpenQuantity = 0 ;
		this.totalOnHandQty = 0 ;
		this.totalPurchaseOnOrderQty = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.report.history.CustomerBackOrderAgingBucketBean */
export class CustomerBackOrderAgingBucketBean {
	constructor() {
		this.startDay = 0 ;
		this.endDay = 0 ;
		this.bucketOrder = 0 ;
		this.startDate = '' ;
		this.stopDate = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.report.history.CustomerBackOrderAgingBucketGroupBean */
export class CustomerBackOrderAgingBucketGroupBean {
	constructor() {
		this.buckets = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.report.history.CustomerBalanceCreditMemoDetailsBean */
export class CustomerBalanceCreditMemoDetailsBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.historyDate = '' ;
		this.currencyCode = '' ;
		this.totalCreditAmount = 0 ;
		this.appliedCreditMemoAmount = 0 ;
		this.unAppliedCreditMemoAmount = 0 ;
		this.creditMemoDate = '' ;
		this.creditMemoCode = '' ;
		this.createdSourceType = '' ;
		this.createdSourceEntityNumber = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.report.history.CustomerDayBalanceHistoryBean */
export class CustomerDayBalanceHistoryBean {
	constructor() {
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.balanceDate = '' ;
		this.customerAccountNumber = '' ;
		this.currencyCode = '' ;
		this.openingBalanceAmount = 0 ;
		this.totalInvoiceAmount = 0 ;
		this.totalInvoiceCancelledAmount = 0 ;
		this.totalPaymentAppliedAmount = 0 ;
		this.totalPaymentCancelledAmount = 0 ;
		this.closingBalanceAmount = 0 ;
		this.totalInvoiceReturnedAmount = 0 ;
		this.standardTotalInvoiceAmount = 0 ;
		this.standardTotalInvoiceCancelledAmount = 0 ;
		this.standardClosingBalanceAmount = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.report.history.CustomerDayBalanceHistoryDetailBean */
export class CustomerDayBalanceHistoryDetailBean {
	constructor() {
		this.balanceDetailHistoryNumber = 0 ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.historyDate = '' ;
		this.currencyCode = '' ;
		this.transactionType = 0 ;
		this.accountUpdateType = 0 ;
		this.documentNumber = '' ;
		this.invoiceNumber = '' ;
		this.openingBalanceAmount = 0 ;
		this.transactionAmount = 0 ;
		this.closingBalanceAmount = 0 ;
		this.totalInvoiceReturnedAmount = 0 ;
		this.remarks = '' ;
		this.appliedPaymentType = 0 ;
		this.appliedPaymentDocumentNumber = '' ;
		this.appliedPaymentDetails = '' ;
		this.companyCurrencyCode = '' ;
		this.standardOpeningBalanceAmount = 0 ;
		this.standardTransactionAmount = 0 ;
		this.standardClosingBalanceAmount = 0 ;
		this.standardTotalInvoiceReturnedAmount = 0 ;
		this.currencyConversionRate = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.report.history.CustomerPaymentAgingBucketBean */
export class CustomerPaymentAgingBucketBean {
	constructor() {
		this.startDay = 0 ;
		this.endDay = 0 ;
		this.bucketOrder = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.report.history.CustomerPaymentAgingBucketGroupBean */
export class CustomerPaymentAgingBucketGroupBean {
	constructor() {
		this.buckets = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.report.history.CustomerPaymentAgingHistoryBean */
export class CustomerPaymentAgingHistoryBean {
	constructor() {
		this.agingHistoryNumber = 0 ;
		this.historyDate = '' ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.currencyCode = '' ;
		this.totalInvoiceDueAmount = 0 ;
		this.totalUnAppliedCreditMemoAmount = 0 ;
		this.totalUnAppliedChargeBackAmount = 0 ;
		this.totalProvisionalAppliedAmount = 0 ;
		this.currentAgeAmount = 0 ;
		this.ageAmount1 = 0 ;
		this.ageAmount2 = 0 ;
		this.ageAmount3 = 0 ;
		this.ageAmount4 = 0 ;
		this.ageAmount5 = 0 ;
		this.ageAmount6 = 0 ;
		this.ageAmount7 = 0 ;
		this.ageAmount8 = 0 ;
		this.ageAmount9 = 0 ;
		this.ageAmount10 = 0 ;
		this.customerDetails = null ;
		this.companyCurrencyCode = '' ;
		this.standardTotalInvoiceDueAmount = 0 ;
		this.standardCurrentAgeAmount = 0 ;
		this.standardAgeAmount1 = 0 ;
		this.standardAgeAmount2 = 0 ;
		this.standardAgeAmount3 = 0 ;
		this.standardAgeAmount4 = 0 ;
		this.standardAgeAmount5 = 0 ;
		this.standardAgeAmount6 = 0 ;
		this.standardAgeAmount7 = 0 ;
		this.standardAgeAmount8 = 0 ;
		this.standardAgeAmount9 = 0 ;
		this.standardAgeAmount10 = 0 ;
		this.remarks = '' ;
		this.invoiceDetails = new Array() ;
		this.creditMemoDetails = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.report.history.CustomerPaymentAgingHistoryCreditMemoDetailsBean */
export class CustomerPaymentAgingHistoryCreditMemoDetailsBean {
	constructor() {
		this.agingHistoryCreditMemoDetailsNumber = 0 ;
		this.agingHistoryNumber = 0 ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.historyDate = '' ;
		this.currencyCode = '' ;
		this.creditMemoNumber = '' ;
		this.creditMemoDate = '' ;
		this.creditMemoTotalAmount = 0 ;
		this.appliedAmount = 0 ;
		this.unAppliedAmount = 0 ;
		this.createdSourceType = '' ;
		this.createdSourceEntityNumber = '' ;
		this.companyCurrencyCode = '' ;
		this.standardAppliedAmount = 0 ;
		this.standardCreditMemoTotalAmount = 0 ;
		this.standardUnAppliedAmount = 0 ;
		this.currencyExchangeRate = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.report.history.CustomerPaymentAgingHistoryInvoiceDetailsBean */
export class CustomerPaymentAgingHistoryInvoiceDetailsBean {
	constructor() {
		this.agingHistoryInvoiceDetailsNumber = 0 ;
		this.agingHistoryNumber = 0 ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.customerName = '' ;
		this.historyDate = '' ;
		this.currencyCode = '' ;
		this.invoiceNumber = '' ;
		this.invoiceDate = '' ;
		this.invoiceAmount = 0 ;
		this.invoiceDueAmount = 0 ;
		this.invoicePaymentAppliedAmount = 0 ;
		this.invoicePaymentCancelledAmount = 0 ;
		this.invoiceReturnedAmount = 0 ;
		this.invoiceProvisionalPaidAmount = 0 ;
		this.invoicePaymentTermCode = '' ;
		this.invoicePaymentDueDate = '' ;
		this.companyCurrencyCode = '' ;
		this.standardInvoiceAmount = 0 ;
		this.standardInvoiceDueAmount = 0 ;
		this.standardInvoicePaymentAppliedAmount = 0 ;
		this.standardInvoicePaymentCancelledAmount = 0 ;
		this.standardInvoiceReturnedAmount = 0 ;
		this.salesPersonCodes = '' ;
		this.salesPersonNames = '' ;
		this.packingListNumber = '' ;
		this.checkDetails = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.report.history.CustomerPaymentAgingHistoryInvoicePostedCheckDetailsBean */
export class CustomerPaymentAgingHistoryInvoicePostedCheckDetailsBean {
	constructor() {
		this.companyCode = '' ;
		this.checkDate = '' ;
		this.checkNumber = '' ;
		this.checkAmount = 0 ;
		this.accountReceivableNumber = '' ;
		this.invoiceNumber = '' ;
		this.agingHistoryInvoiceDetailsNumber = 0 ;
		this.agingHistoryNumber = 0 ;
	}
}
/* ds.transaction.report.history.CustomerSalesBackOrderAgingHistoryBean */
export class CustomerSalesBackOrderAgingHistoryBean {
	constructor() {
		this.agingHistoryNumber = 0 ;
		this.historyDate = '' ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.currencyCode = '' ;
		this.currentQuantity = 0 ;
		this.ageQuantity1 = 0 ;
		this.ageQuantity2 = 0 ;
		this.ageQuantity3 = 0 ;
		this.ageQuantity4 = 0 ;
		this.ageQuantity5 = 0 ;
		this.ageQuantity6 = 0 ;
		this.ageQuantity7 = 0 ;
		this.ageQuantity8 = 0 ;
		this.ageQuantity9 = 0 ;
		this.ageQuantity10 = 0 ;
		this.customerDetails = null ;
		this.companyCurrencyCode = '' ;
		this.remarks = '' ;
		this.totalOpenQuantity = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.report.history.CustomerTransactionBean */
export class CustomerTransactionBean {
	constructor() {
		this.transactionNumber = 0 ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.billToCode = '' ;
		this.entityType = 0 ;
		this.entryEntityNumber = '' ;
		this.entityStatus = '' ;
		this.transactionDate = '' ;
		this.transactionType = 0 ;
		this.documentNumber = '' ;
		this.currencyCode = '' ;
		this.openAmount = 0 ;
		this.invoiceAmount = 0 ;
		this.invoiceAdjustedAmount = 0 ;
		this.creditMemoAmount = 0 ;
		this.creditMemoAppliedAmount = 0 ;
		this.remarks = '' ;
		this.generalPaidAmount = 0 ;
		this.creditPaidAmount = 0 ;
		this.adjustedPaidAmount = 0 ;
		this.customerPurchaseOrderNumber = '' ;
		this.paymentDueDate = '' ;
		this.companyCurrencyCode = '' ;
		this.standardOpenAmount = 0 ;
		this.standardInvoiceAmount = 0 ;
		this.standardInvoiceAdjustedAmount = 0 ;
		this.standardGeneralPaidAmount = 0 ;
		this.standardCreditPaidAmount = 0 ;
		this.standardAdjustedPaidAmount = 0 ;
		this.standardCreditMemoAmount = 0 ;
		this.standardCreditMemoAppliedAmount = 0 ;
		this.currencyConversionRate = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.report.history.FabricStyleBackOrderAgingBucketBean */
export class FabricStyleBackOrderAgingBucketBean {
	constructor() {
		this.startDay = 0 ;
		this.endDay = 0 ;
		this.bucketOrder = 0 ;
		this.startDate = '' ;
		this.stopDate = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.report.history.FabricStyleBackOrderAgingBucketGroupBean */
export class FabricStyleBackOrderAgingBucketGroupBean {
	constructor() {
		this.buckets = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.report.history.FabricStyleBackOrderAgingHistoryBean */
export class FabricStyleBackOrderAgingHistoryBean {
	constructor() {
		this.agingHistoryNumber = 0 ;
		this.historyDate = '' ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.currencyCode = '' ;
		this.currentQuantity = 0 ;
		this.ageQuantity1 = 0 ;
		this.ageQuantity2 = 0 ;
		this.ageQuantity3 = 0 ;
		this.ageQuantity4 = 0 ;
		this.ageQuantity5 = 0 ;
		this.ageQuantity6 = 0 ;
		this.ageQuantity7 = 0 ;
		this.ageQuantity8 = 0 ;
		this.ageQuantity9 = 0 ;
		this.ageQuantity10 = 0 ;
		this.customerDetails = null ;
		this.companyCurrencyCode = '' ;
		this.remarks = '' ;
		this.totalOpenQuantity = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.TransactionLogBean */
export class TransactionLogBean {
	constructor() {
		this.companyCode = '' ;
		this.transactionLogNumber = 0 ;
		this.status = '' ;
		this.transactionType = 0 ;
		this.transactionSubType = 0 ;
		this.transactionAppliedDate = '' ;
		this.entityType = 0 ;
		this.entryEntityNumber = '' ;
		this.entryEntityLineNumber = 0 ;
		this.entryEntitySubLineNumber = 0 ;
		this.entryEntityDate = '' ;
		this.entityStatusBefore = '' ;
		this.entityStatusAfter = '' ;
		this.affectedEntryEntityType = 0 ;
		this.affectedEntryEntityNumber = '' ;
		this.affectedEntryEntityLineNumber = 0 ;
		this.affectedEntryEntitySubLineNumber = 0 ;
		this.affectedEntryDate = '' ;
		this.affectedEntryEntityType1 = 0 ;
		this.affectedEntryEntityNumber1 = '' ;
		this.affectedEntryEntityLineNumber1 = 0 ;
		this.affectedEntryEntitySubLineNumber1 = 0 ;
		this.affectedEntryEntityType2 = 0 ;
		this.affectedEntryEntityNumber2 = '' ;
		this.affectedEntryEntityLineNumber2 = 0 ;
		this.affectedEntryEntitySubLineNumber2 = 0 ;
		this.entryDate = '' ;
		this.entryYear = 0 ;
		this.entryMonth = 0 ;
		this.entryWeek = 0 ;
		this.entryPeriod = '' ;
		this.entrySeasonCode = '' ;
		this.productDivisionCode = '' ;
		this.productDepartmentCode = '' ;
		this.productClassCode = '' ;
		this.productSubClassCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleDescription = '' ;
		this.fabricStyleColorCode = '' ;
		this.skuNumber = 0 ;
		this.customerDivisionCode = '' ;
		this.customerDepartmentCode = '' ;
		this.customerClassCode = '' ;
		this.customerSubClassCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerShipToZoneCode = '' ;
		this.customerShipToRegionCode = '' ;
		this.customerShipToDistrictCode = '' ;
		this.customerShipToTerritoryCode = '' ;
		this.customerShipToCode = '' ;
		this.customerBillToCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.salesPersonCode = '' ;
		this.location1 = '' ;
		this.location2 = '' ;
		this.entryUomCode = '' ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = 0 ;
		this.widthUomCode = '' ;
		this.entryCurrencyCode = '' ;
		this.companyCurrencyCode = '' ;
		this.currencyConversionRate = 0 ;
		this.unitsBefore = 0 ;
		this.unitsAfter = 0 ;
		this.unitsUpdated = 0 ;
		this.units1Before = 0 ;
		this.units1After = 0 ;
		this.units1Updated = 0 ;
		this.units2Before = 0 ;
		this.units2After = 0 ;
		this.units2Updated = 0 ;
		this.units3Before = 0 ;
		this.units3After = 0 ;
		this.units3Updated = 0 ;
		this.units4Before = 0 ;
		this.units4After = 0 ;
		this.units4Updated = 0 ;
		this.units5Before = 0 ;
		this.units5After = 0 ;
		this.units5Updated = 0 ;
		this.priceBefore = 0 ;
		this.priceAfter = 0 ;
		this.priceUpdated = 0 ;
		this.costBefore = 0 ;
		this.costAfter = 0 ;
		this.costUpdated = 0 ;
		this.amountBefore = 0 ;
		this.amountAfter = 0 ;
		this.amountUpdated = 0 ;
		this.discountAmountBefore = 0 ;
		this.discountAmountAfter = 0 ;
		this.discountAmountUpdated = 0 ;
		this.taxAmountBefore = 0 ;
		this.taxAmountAfter = 0 ;
		this.taxAmountUpdated = 0 ;
		this.shipmentChargesAmountBefore = 0 ;
		this.shipmentChargesAmountAfter = 0 ;
		this.shipmentChargesAmountUpdated = 0 ;
		this.miscellaniousChargesAmountBefore = 0 ;
		this.miscellaniousChargesAmountAfter = 0 ;
		this.miscellaniousChargesAmountUpdated = 0 ;
		this.subTotalAmountBefore = 0 ;
		this.subTotalAmountAfter = 0 ;
		this.subTotalAmountUpdated = 0 ;
		this.lineTotalPriceNetAmountBefore = 0 ;
		this.lineTotalPriceNetAmountAfter = 0 ;
		this.lineTotalPriceNetAmountUpdated = 0 ;
		this.lineTotalCostNetAmountBefore = 0 ;
		this.lineTotalCostNetAmountAfter = 0 ;
		this.lineTotalCostNetAmountUpdated = 0 ;
		this.amount1Before = 0 ;
		this.amount1After = 0 ;
		this.amount1Updated = 0 ;
		this.amount2Before = 0 ;
		this.amount2After = 0 ;
		this.amount2Updated = 0 ;
		this.amount3Before = 0 ;
		this.amount3After = 0 ;
		this.amount3Updated = 0 ;
		this.amount4Before = 0 ;
		this.amount4After = 0 ;
		this.amount4Updated = 0 ;
		this.amount5Before = 0 ;
		this.amount5After = 0 ;
		this.amount5Updated = 0 ;
		this.amount6Before = 0 ;
		this.amount6After = 0 ;
		this.amount6Updated = 0 ;
		this.amount7Before = 0 ;
		this.amount7After = 0 ;
		this.amount7Updated = 0 ;
		this.amount8Before = 0 ;
		this.amount8After = 0 ;
		this.amount8Updated = 0 ;
		this.amount9Before = 0 ;
		this.amount9After = 0 ;
		this.amount9Updated = 0 ;
		this.taxPercentage = 0 ;
		this.discountPercentage = 0 ;
		this.grandTotalAmountBefore = 0 ;
		this.grandTotalAmountAfter = 0 ;
		this.grandTotalAmountUpdated = 0 ;
		this.paidAmountBefore = 0 ;
		this.paidAmountAfter = 0 ;
		this.paidAmountUpdated = 0 ;
		this.extraChargesAmountBefore = 0 ;
		this.extraChargesAmountAfter = 0 ;
		this.extraChargesAmountUpdated = 0 ;
		this.barCode = '' ;
		this.barCode1 = '' ;
		this.barCode2 = '' ;
		this.barCode3 = '' ;
		this.widthCode = '' ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.boxNumber = '' ;
		this.vendorBatchNumber = '' ;
		this.batchNumber = '' ;
		this.manufacturerBatchNumber = '' ;
		this.remarks = '' ;
		this.documentNumber = '' ;
		this.documentType = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.shipVia = '' ;
		this.paymentMethodCode = '' ;
		this.paymentTermCode = '' ;
		this.dueDate = '' ;
		this.shipmentTermsCode = '' ;
		this.locationType = '' ;
		this.reasonCode = '' ;
		this.orderType = '' ;
		this.priority = 0 ;
		this.creditType = '' ;
		this.creditSubType = '' ;
		this.paymentType = 0 ;
		this.checkNumber = '' ;
		this.checkDate = '' ;
		this.bankName = '' ;
		this.bankAddress = '' ;
		this.accountNumber = '' ;
		this.cardType = '' ;
		this.cardExpiryYear = '' ;
		this.cardExpiryMonth = '' ;
		this.netPaidAmountBefore = 0 ;
		this.netPaidAmountAfter = 0 ;
		this.netPaidAmountUpdated = 0 ;
		this.sourceEntityType = '' ;
		this.sourceEntityNumber = '' ;
		this.salesRepresentativeCode = '' ;
		this.salesClerkCode = '' ;
		this.customerType = '' ;
		this.returnedAmountToCustomerBefore = 0 ;
		this.returnedAmountToCustomerAfter = 0 ;
		this.returnedAmountToCustomerUpdated = 0 ;
		this.returnedMerchandiseAmountBefore = 0 ;
		this.returnedMerchandiseAmountAfter = 0 ;
		this.returnedMerchandiseAmountUpdated = 0 ;
		this.deliveryDate = '' ;
		this.invoiceType = '' ;
		this.entityLineStatusBefore = '' ;
		this.entityLineStatusAfter = '' ;
		this.standardGrandTotalAmountBefore = 0 ;
		this.standardGrandTotalAmountAfter = 0 ;
		this.standardGrandTotalAmountUpdated = 0 ;
		this.standardSubTotalAmountBefore = 0 ;
		this.standardSubTotalAmountAfter = 0 ;
		this.standardSubTotalAmountUpdated = 0 ;
		this.standardShipmentChargesAmountBefore = 0 ;
		this.standardShipmentChargesAmountAfter = 0 ;
		this.standardShipmentChargesAmountUpdated = 0 ;
		this.standardExtraChargesAmountBefore = 0 ;
		this.standardExtraChargesAmountAfter = 0 ;
		this.standardExtraChargesAmountUpdated = 0 ;
		this.standardTotalTaxAmountBefore = 0 ;
		this.standardTotalTaxAmountAfter = 0 ;
		this.standardTotalTaxAmountUpdated = 0 ;
		this.standardDiscountAmountBefore = 0 ;
		this.standardDiscountAmountAfter = 0 ;
		this.standardDiscountAmountUpdated = 0 ;
		this.standardMiscellaniousChargesAmountBefore = 0 ;
		this.standardMiscellaniousChargesAmountAfter = 0 ;
		this.standardMiscellaniousChargesAmountUpdated = 0 ;
		this.standardPaidAmountBefore = 0 ;
		this.standardPaidAmountAfter = 0 ;
		this.standardPaidAmountUpdated = 0 ;
		this.standardNetPaidAmountBefore = 0 ;
		this.standardNetPaidAmountAfter = 0 ;
		this.standardNetPaidAmountUpdated = 0 ;
		this.standardPaidChargeBackAmountBefore = 0 ;
		this.standardPaidChargeBackAmountAfter = 0 ;
		this.standardPaidChargeBackAmountUpdated = 0 ;
		this.standardPaidCreditMemoAmountBefore = 0 ;
		this.standardPaidCreditMemoAmountAfter = 0 ;
		this.standardPaidCreditMemoAmountUpdated = 0 ;
		this.standardPaidOtherAppliedAmountBefore = 0 ;
		this.standardPaidOtherAppliedAmountAfter = 0 ;
		this.standardPaidOtherAppliedAmountUpdated = 0 ;
		this.standardAdjustedPaidAmountBefore = 0 ;
		this.standardAdjustedPaidAmountAfter = 0 ;
		this.standardAdjustedPaidAmountUpdated = 0 ;
		this.standardInvoiceCancelledAmountBefore = 0 ;
		this.standardInvoiceCancelledAmountAfter = 0 ;
		this.standardInvoiceCancelledAmountUpdated = 0 ;
		this.standardTotalPaymentAppliedAmountBefore = 0 ;
		this.standardTotalPaymentAppliedAmountAfter = 0 ;
		this.standardTotalPaymentAppliedAmountUpdated = 0 ;
		this.standardGeneralPaymentAppliedAmountBefore = 0 ;
		this.standardGeneralPaymentAppliedAmountAfter = 0 ;
		this.standardGeneralPaymentAppliedAmountUpdated = 0 ;
		this.standardCreditMemoPaymentAppliedAmountBefore = 0 ;
		this.standardCreditMemoPaymentAppliedAmountAfter = 0 ;
		this.standardCreditMemoPaymentAppliedAmountUpdated = 0 ;
		this.standardChargeBackPaymentAppliedAmountBefore = 0 ;
		this.standardChargeBackPaymentAppliedAmountAfter = 0 ;
		this.standardChargeBackPaymentAppliedAmountUpdated = 0 ;
		this.standardInvoicePaymentCancelledAmountBefore = 0 ;
		this.standardInvoicePaymentCancelledAmountAfter = 0 ;
		this.standardInvoicePaymentCancelledAmountUpdated = 0 ;
		this.standardInvoiceReturnedAmountBefore = 0 ;
		this.standardInvoiceReturnedAmountAfter = 0 ;
		this.standardInvoiceReturnedAmountUpdated = 0 ;
		this.standardInvoiceNetPayableAmountBefore = 0 ;
		this.standardInvoiceNetPayableAmountAfter = 0 ;
		this.standardInvoiceNetPayableAmountUpdated = 0 ;
		this.standardInvoiceAdjustedAmountBefore = 0 ;
		this.standardInvoiceAdjustedAmountAfter = 0 ;
		this.standardInvoiceAdjustedAmountUpdated = 0 ;
		this.originalPurchaseOrderNumber = '' ;
		this.originalPurchaseReceiptNumber = '' ;
		this.originalReceivedQuantity = 0 ;
		this.originalReceivedDate = '' ;
		this.isUpdateInventory = false ;
		this.isCloseOutInventory = false ;
		this.optionFlag = false ;
		this.enteredBy = '' ;
		this.enteredDate = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.reserveCustomerCode = '' ;
		this.reserveCustomerName = '' ;
		this.fobCost = 0 ;
		this.landedCost = 0 ;
		this.vendorSkuNumber = '' ;
		this.containerNumber = '' ;
		this.etaDate = '' ;
		this.aisleInfoText = '' ;
		this.billOfLading = '' ;
		this.masterCustomerCode = '' ;
		this.warehousePurchaseOrderNumber = '' ;
		this.customerReferenceNumber = '' ;
		this.palletNumber = '' ;
		this.imeiNumber = '' ;
		this.projectNumber = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.TransactionLogHistoryBean */
export class TransactionLogHistoryBean {
	constructor() {
		this.transactionLogHistoryNumber = 0 ;
		this.historyStatus = '' ;
		this.processedBy = '' ;
		this.processedDate = '' ;
		this.historyRemarks = '' ;
		this.projectNumber = '' ;
		this.companyCode = '' ;
		this.transactionLogNumber = 0 ;
		this.status = '' ;
		this.transactionType = 0 ;
		this.transactionSubType = 0 ;
		this.transactionAppliedDate = '' ;
		this.entityType = 0 ;
		this.entryEntityNumber = '' ;
		this.entryEntityLineNumber = 0 ;
		this.entryEntitySubLineNumber = 0 ;
		this.entryEntityDate = '' ;
		this.entityStatusBefore = '' ;
		this.entityStatusAfter = '' ;
		this.affectedEntryEntityType = 0 ;
		this.affectedEntryEntityNumber = '' ;
		this.affectedEntryEntityLineNumber = 0 ;
		this.affectedEntryEntitySubLineNumber = 0 ;
		this.affectedEntryDate = '' ;
		this.affectedEntryEntityType1 = 0 ;
		this.affectedEntryEntityNumber1 = '' ;
		this.affectedEntryEntityLineNumber1 = 0 ;
		this.affectedEntryEntitySubLineNumber1 = 0 ;
		this.affectedEntryEntityType2 = 0 ;
		this.affectedEntryEntityNumber2 = '' ;
		this.affectedEntryEntityLineNumber2 = 0 ;
		this.affectedEntryEntitySubLineNumber2 = 0 ;
		this.entryDate = '' ;
		this.entryYear = 0 ;
		this.entryMonth = 0 ;
		this.entryWeek = 0 ;
		this.entryPeriod = '' ;
		this.entrySeasonCode = '' ;
		this.productDivisionCode = '' ;
		this.productDepartmentCode = '' ;
		this.productClassCode = '' ;
		this.productSubClassCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleDescription = '' ;
		this.fabricStyleColorCode = '' ;
		this.skuNumber = 0 ;
		this.customerDivisionCode = '' ;
		this.customerDepartmentCode = '' ;
		this.customerClassCode = '' ;
		this.customerSubClassCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerShipToZoneCode = '' ;
		this.customerShipToRegionCode = '' ;
		this.customerShipToDistrictCode = '' ;
		this.customerShipToTerritoryCode = '' ;
		this.customerShipToCode = '' ;
		this.customerBillToCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.salesPersonCode = '' ;
		this.location1 = '' ;
		this.location2 = '' ;
		this.entryUomCode = '' ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = 0 ;
		this.widthUomCode = '' ;
		this.entryCurrencyCode = '' ;
		this.companyCurrencyCode = '' ;
		this.currencyConversionRate = 0 ;
		this.unitsBefore = 0 ;
		this.unitsAfter = 0 ;
		this.unitsUpdated = 0 ;
		this.units1Before = 0 ;
		this.units1After = 0 ;
		this.units1Updated = 0 ;
		this.units2Before = 0 ;
		this.units2After = 0 ;
		this.units2Updated = 0 ;
		this.units3Before = 0 ;
		this.units3After = 0 ;
		this.units3Updated = 0 ;
		this.units4Before = 0 ;
		this.units4After = 0 ;
		this.units4Updated = 0 ;
		this.units5Before = 0 ;
		this.units5After = 0 ;
		this.units5Updated = 0 ;
		this.priceBefore = 0 ;
		this.priceAfter = 0 ;
		this.priceUpdated = 0 ;
		this.costBefore = 0 ;
		this.costAfter = 0 ;
		this.costUpdated = 0 ;
		this.amountBefore = 0 ;
		this.amountAfter = 0 ;
		this.amountUpdated = 0 ;
		this.discountAmountBefore = 0 ;
		this.discountAmountAfter = 0 ;
		this.discountAmountUpdated = 0 ;
		this.taxAmountBefore = 0 ;
		this.taxAmountAfter = 0 ;
		this.taxAmountUpdated = 0 ;
		this.shipmentChargesAmountBefore = 0 ;
		this.shipmentChargesAmountAfter = 0 ;
		this.shipmentChargesAmountUpdated = 0 ;
		this.miscellaniousChargesAmountBefore = 0 ;
		this.miscellaniousChargesAmountAfter = 0 ;
		this.miscellaniousChargesAmountUpdated = 0 ;
		this.subTotalAmountBefore = 0 ;
		this.subTotalAmountAfter = 0 ;
		this.subTotalAmountUpdated = 0 ;
		this.lineTotalPriceNetAmountBefore = 0 ;
		this.lineTotalPriceNetAmountAfter = 0 ;
		this.lineTotalPriceNetAmountUpdated = 0 ;
		this.lineTotalCostNetAmountBefore = 0 ;
		this.lineTotalCostNetAmountAfter = 0 ;
		this.lineTotalCostNetAmountUpdated = 0 ;
		this.amount1Before = 0 ;
		this.amount1After = 0 ;
		this.amount1Updated = 0 ;
		this.amount2Before = 0 ;
		this.amount2After = 0 ;
		this.amount2Updated = 0 ;
		this.amount3Before = 0 ;
		this.amount3After = 0 ;
		this.amount3Updated = 0 ;
		this.amount4Before = 0 ;
		this.amount4After = 0 ;
		this.amount4Updated = 0 ;
		this.amount5Before = 0 ;
		this.amount5After = 0 ;
		this.amount5Updated = 0 ;
		this.amount6Before = 0 ;
		this.amount6After = 0 ;
		this.amount6Updated = 0 ;
		this.amount7Before = 0 ;
		this.amount7After = 0 ;
		this.amount7Updated = 0 ;
		this.amount8Before = 0 ;
		this.amount8After = 0 ;
		this.amount8Updated = 0 ;
		this.amount9Before = 0 ;
		this.amount9After = 0 ;
		this.amount9Updated = 0 ;
		this.taxPercentage = 0 ;
		this.discountPercentage = 0 ;
		this.grandTotalAmountBefore = 0 ;
		this.grandTotalAmountAfter = 0 ;
		this.grandTotalAmountUpdated = 0 ;
		this.paidAmountBefore = 0 ;
		this.paidAmountAfter = 0 ;
		this.paidAmountUpdated = 0 ;
		this.extraChargesAmountBefore = 0 ;
		this.extraChargesAmountAfter = 0 ;
		this.extraChargesAmountUpdated = 0 ;
		this.barCode = '' ;
		this.barCode1 = '' ;
		this.barCode2 = '' ;
		this.barCode3 = '' ;
		this.widthCode = '' ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.boxNumber = '' ;
		this.vendorBatchNumber = '' ;
		this.batchNumber = '' ;
		this.manufacturerBatchNumber = '' ;
		this.remarks = '' ;
		this.documentNumber = '' ;
		this.documentType = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.shipVia = '' ;
		this.paymentMethodCode = '' ;
		this.paymentTermCode = '' ;
		this.dueDate = '' ;
		this.shipmentTermsCode = '' ;
		this.locationType = '' ;
		this.reasonCode = '' ;
		this.orderType = '' ;
		this.priority = 0 ;
		this.creditType = '' ;
		this.creditSubType = '' ;
		this.paymentType = 0 ;
		this.checkNumber = '' ;
		this.checkDate = '' ;
		this.bankName = '' ;
		this.bankAddress = '' ;
		this.accountNumber = '' ;
		this.cardType = '' ;
		this.cardExpiryYear = '' ;
		this.cardExpiryMonth = '' ;
		this.netPaidAmountBefore = 0 ;
		this.netPaidAmountAfter = 0 ;
		this.netPaidAmountUpdated = 0 ;
		this.sourceEntityType = '' ;
		this.sourceEntityNumber = '' ;
		this.salesRepresentativeCode = '' ;
		this.salesClerkCode = '' ;
		this.customerType = '' ;
		this.returnedAmountToCustomerBefore = 0 ;
		this.returnedAmountToCustomerAfter = 0 ;
		this.returnedAmountToCustomerUpdated = 0 ;
		this.returnedMerchandiseAmountBefore = 0 ;
		this.returnedMerchandiseAmountAfter = 0 ;
		this.returnedMerchandiseAmountUpdated = 0 ;
		this.deliveryDate = '' ;
		this.invoiceType = '' ;
		this.entityLineStatusBefore = '' ;
		this.entityLineStatusAfter = '' ;
		this.standardGrandTotalAmountBefore = 0 ;
		this.standardGrandTotalAmountAfter = 0 ;
		this.standardGrandTotalAmountUpdated = 0 ;
		this.standardSubTotalAmountBefore = 0 ;
		this.standardSubTotalAmountAfter = 0 ;
		this.standardSubTotalAmountUpdated = 0 ;
		this.standardShipmentChargesAmountBefore = 0 ;
		this.standardShipmentChargesAmountAfter = 0 ;
		this.standardShipmentChargesAmountUpdated = 0 ;
		this.standardExtraChargesAmountBefore = 0 ;
		this.standardExtraChargesAmountAfter = 0 ;
		this.standardExtraChargesAmountUpdated = 0 ;
		this.standardTotalTaxAmountBefore = 0 ;
		this.standardTotalTaxAmountAfter = 0 ;
		this.standardTotalTaxAmountUpdated = 0 ;
		this.standardDiscountAmountBefore = 0 ;
		this.standardDiscountAmountAfter = 0 ;
		this.standardDiscountAmountUpdated = 0 ;
		this.standardMiscellaniousChargesAmountBefore = 0 ;
		this.standardMiscellaniousChargesAmountAfter = 0 ;
		this.standardMiscellaniousChargesAmountUpdated = 0 ;
		this.standardPaidAmountBefore = 0 ;
		this.standardPaidAmountAfter = 0 ;
		this.standardPaidAmountUpdated = 0 ;
		this.standardNetPaidAmountBefore = 0 ;
		this.standardNetPaidAmountAfter = 0 ;
		this.standardNetPaidAmountUpdated = 0 ;
		this.standardPaidChargeBackAmountBefore = 0 ;
		this.standardPaidChargeBackAmountAfter = 0 ;
		this.standardPaidChargeBackAmountUpdated = 0 ;
		this.standardPaidCreditMemoAmountBefore = 0 ;
		this.standardPaidCreditMemoAmountAfter = 0 ;
		this.standardPaidCreditMemoAmountUpdated = 0 ;
		this.standardPaidOtherAppliedAmountBefore = 0 ;
		this.standardPaidOtherAppliedAmountAfter = 0 ;
		this.standardPaidOtherAppliedAmountUpdated = 0 ;
		this.standardAdjustedPaidAmountBefore = 0 ;
		this.standardAdjustedPaidAmountAfter = 0 ;
		this.standardAdjustedPaidAmountUpdated = 0 ;
		this.standardInvoiceCancelledAmountBefore = 0 ;
		this.standardInvoiceCancelledAmountAfter = 0 ;
		this.standardInvoiceCancelledAmountUpdated = 0 ;
		this.standardTotalPaymentAppliedAmountBefore = 0 ;
		this.standardTotalPaymentAppliedAmountAfter = 0 ;
		this.standardTotalPaymentAppliedAmountUpdated = 0 ;
		this.standardGeneralPaymentAppliedAmountBefore = 0 ;
		this.standardGeneralPaymentAppliedAmountAfter = 0 ;
		this.standardGeneralPaymentAppliedAmountUpdated = 0 ;
		this.standardCreditMemoPaymentAppliedAmountBefore = 0 ;
		this.standardCreditMemoPaymentAppliedAmountAfter = 0 ;
		this.standardCreditMemoPaymentAppliedAmountUpdated = 0 ;
		this.standardChargeBackPaymentAppliedAmountBefore = 0 ;
		this.standardChargeBackPaymentAppliedAmountAfter = 0 ;
		this.standardChargeBackPaymentAppliedAmountUpdated = 0 ;
		this.standardInvoicePaymentCancelledAmountBefore = 0 ;
		this.standardInvoicePaymentCancelledAmountAfter = 0 ;
		this.standardInvoicePaymentCancelledAmountUpdated = 0 ;
		this.standardInvoiceReturnedAmountBefore = 0 ;
		this.standardInvoiceReturnedAmountAfter = 0 ;
		this.standardInvoiceReturnedAmountUpdated = 0 ;
		this.standardInvoiceNetPayableAmountBefore = 0 ;
		this.standardInvoiceNetPayableAmountAfter = 0 ;
		this.standardInvoiceNetPayableAmountUpdated = 0 ;
		this.standardInvoiceAdjustedAmountBefore = 0 ;
		this.standardInvoiceAdjustedAmountAfter = 0 ;
		this.standardInvoiceAdjustedAmountUpdated = 0 ;
		this.originalPurchaseOrderNumber = '' ;
		this.originalPurchaseReceiptNumber = '' ;
		this.originalReceivedQuantity = 0 ;
		this.originalReceivedDate = '' ;
		this.isUpdateInventory = false ;
		this.isCloseOutInventory = false ;
		this.optionFlag = false ;
		this.enteredBy = '' ;
		this.enteredDate = '' ;
		this.enteredStationCode = '' ;
		this.enteredIpAddress = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.reserveCustomerCode = '' ;
		this.reserveCustomerName = '' ;
		this.fobCost = 0 ;
		this.landedCost = 0 ;
		this.vendorSkuNumber = '' ;
		this.containerNumber = '' ;
		this.etaDate = '' ;
		this.aisleInfoText = '' ;
		this.billOfLading = '' ;
		this.masterCustomerCode = '' ;
		this.warehousePurchaseOrderNumber = '' ;
		this.customerReferenceNumber = '' ;
		this.palletNumber = '' ;
		this.imeiNumber = '' ;
		this.projectNumber = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.transaction.TransactionLogSearchCriteria */
export class TransactionLogSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.transactionLogNumber = 0 ;
		this.status = '' ;
	}
}
/* ds.vendorinvoice.criteria.VendorInvoiceLinesSearchCriteriaBean */
export class VendorInvoiceLinesSearchCriteriaBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.invoiceReceiptCodes = new Array() ;
	}
}
/* ds.vendorinvoice.criteria.VendorInvoicePaymentSearchCriteria */
export class VendorInvoicePaymentSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.vendorInvoiceCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
	}
}
/* ds.vendorinvoice.criteria.VendorInvoiceSearchCriteria */
export class VendorInvoiceSearchCriteria {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.vendorInvoiceCode = '' ;
		this.vendorInvoiceReferenceNumber = '' ;
		this.vendorName = '' ;
		this.vendorType = '' ;
		this.invoiceDate = '' ;
		this.invoiceDueDate = '' ;
		this.status = '' ;
		this.currencyCode = '' ;
		this.invoiceFromDate = '' ;
		this.invoiceToDate = '' ;
		this.statuses = new Array() ;
		this.searchName = '' ;
	}
}
/* ds.vendorinvoice.dep.response.VendorInvoiceModuleDependenciesResponseBean */
export class VendorInvoiceModuleDependenciesResponseBean {
	constructor() {
		this.dependenciesBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.vendorinvoice.dep.VendorInvoiceModuleDependenciesBean */
export class VendorInvoiceModuleDependenciesBean {
	constructor() {
		this.vendorShipVias = new Array() ;
		this.vendorTerms = new Array() ;
	}
}
/* ds.vendorinvoice.merge.response.VendorInvoiceModuleMergeOperationsResponseBean */
export class VendorInvoiceModuleMergeOperationsResponseBean {
	constructor() {
		this.mainOperationResponse = null ;
		this.additionalOperationResponse = null ;
		this.lockResponse = null ;
		this.dependenciesResponse = null ;
		this.totalNumberOfOperations = 0 ;
		this.executedOperations = 0 ;
		this.successOperations = 0 ;
		this.failureOperations = 0 ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.vendorinvoice.pagelist.response.VendorInvoicePageListResponseBean */
export class VendorInvoicePageListResponseBean {
	constructor() {
		this.vendorInvoicePageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.vendorinvoice.pagelist.response.VendorInvoicePaymentDetailPageListResponseBean */
export class VendorInvoicePaymentDetailPageListResponseBean {
	constructor() {
		this.vendorInvoicePaymentDetailPageList = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.vendorinvoice.pagelist.VendorInvoicePageListBean */
export class VendorInvoicePageListBean {
	constructor() {
		this.vendorInvoices = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.vendorinvoice.pagelist.VendorInvoicePaymentDetailPageListBean */
export class VendorInvoicePaymentDetailPageListBean {
	constructor() {
		this.vednorInvoicePaymentDetails = new Array() ;
		this.totalCount = 0 ;
		this.currentPage = 0 ;
		this.pageSize = 0 ;
	}
}
/* ds.vendorinvoice.response.VendorInvoiceLinesResultResponseBean */
export class VendorInvoiceLinesResultResponseBean {
	constructor() {
		this.invoiceLinesResult = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.vendorinvoice.response.VendorInvoiceResponseBean */
export class VendorInvoiceResponseBean {
	constructor() {
		this.vendorInvoice = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.vendorinvoice.VendorInvoiceAdjustmentAmountBean */
export class VendorInvoiceAdjustmentAmountBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorInvoiceCode = '' ;
		this.lineNumber = 0 ;
		this.adjustmentAmount = 0 ;
		this.adjustmentReason = '' ;
		this.includeIn3WayMatch = false ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.vendorinvoice.VendorInvoiceBean */
export class VendorInvoiceBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorCode = '' ;
		this.vendorInvoiceReferenceNumber = '' ;
		this.vendorName = '' ;
		this.vendorType = '' ;
		this.expenseSubType = '' ;
		this.originalVendorInvoiceAmount = 0 ;
		this.status = '' ;
		this.currencyCode = '' ;
		this.merchandiseAmount = 0 ;
		this.adjustmentAmount = 0 ;
		this.grandTotalAmount = 0 ;
		this.paidAmount = 0 ;
		this.openAmount = 0 ;
		this.checkAmount = 0 ;
		this.provisionPaidAmount = 0 ;
		this.advanceAmount = 0 ;
		this.purchaseOrderNumber = '' ;
		this.approvedBy = '' ;
		this.threeWayMatchStatus = '' ;
		this.toleranceForMatchingPercentage = 0 ;
		this.expenseType = '' ;
		this.checkTransactionReferenceNumber = '' ;
		this.appliedCheckReferenceNumber = '' ;
		this.comments = '' ;
		this.invoiceType = '' ;
		this.invoiceDate = '' ;
		this.invoiceDueDate = '' ;
		this.approvedDate = '' ;
		this.adjustmentAmounts = new Array() ;
		this.invoicePurchaseOrders = new Array() ;
		this.statusTracks = new Array() ;
		this.checkDetails = new Array() ;
		this.miscellaneousAmountDetails = new Array() ;
		this.invoiceLines = new Array() ;
		this.paymentDetails = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.vendorinvoice.VendorInvoiceCheckDetailBean */
export class VendorInvoiceCheckDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorInvoiceCode = '' ;
		this.lineNumber = 0 ;
		this.checkNumber = '' ;
		this.checkAmount = 0 ;
		this.currencyCode = '' ;
		this.checkDate = '' ;
		this.issuedBankName = '' ;
		this.issuedBankAddress = '' ;
		this.issuerAccountNumber = '' ;
		this.comments = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.vendorinvoice.VendorInvoiceGLAccountAppliedAmountBean */
export class VendorInvoiceGLAccountAppliedAmountBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorInvoiceCode = '' ;
		this.glAccountNumber = '' ;
		this.AppliedAmount = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.vendorinvoice.VendorInvoiceLineBean */
export class VendorInvoiceLineBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorInvoiceCode = '' ;
		this.currencyCode = '' ;
		this.receivedQuantity = 0 ;
		this.invoiceQuantity = 0 ;
		this.lineAmount = 0 ;
		this.skuNumber = 0 ;
		this.upcCode = '' ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.lineStatus = '' ;
		this.uomCode = '' ;
		this.price = 0 ;
		this.extraPrice = 0 ;
		this.discount = 0 ;
		this.cost = 0 ;
		this.extraCharge = 0 ;
		this.extraChargeAmount = 0 ;
		this.discountAmount = 0 ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = 0 ;
		this.productDivisionCode = '' ;
		this.productDepartmentCode = '' ;
		this.productClassCode = '' ;
		this.productSubClassCode = '' ;
		this.isActualSizePrepackSizeScale = false ;
		this.purchaseOrderNumber = '' ;
		this.purchaseReceiptNumber = '' ;
		this.purchaseOrderReceiptLineNumber = 0 ;
		this.remarks = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.vendorinvoice.VendorInvoiceLinesResultBean */
export class VendorInvoiceLinesResultBean {
	constructor() {
		this.count = 0 ;
		this.invoiceLines = new Array() ;
	}
}
/* ds.vendorinvoice.VendorInvoiceMiscellaneousAmountDetailsBean */
export class VendorInvoiceMiscellaneousAmountDetailsBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorInvoiceCode = '' ;
		this.lineNumber = 0 ;
		this.reasonCode = '' ;
		this.reasonDescription = '' ;
		this.miscellaneousAmount = 0 ;
		this.remarks = '' ;
		this.purchaseOrderNumber = '' ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.vendorinvoice.VendorInvoicePaymentDetailBean */
export class VendorInvoicePaymentDetailBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorInvoiceCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseReceiptNumber = '' ;
		this.approvalNumber = '' ;
		this.lineNumber = 0 ;
		this.currencyCode = '' ;
		this.paymentType = '' ;
		this.documentNumber = '' ;
		this.paymentAmount = 0 ;
		this.issuedBankName = '' ;
		this.issuedBankAddress = '' ;
		this.issuerAccountNumber = '' ;
		this.paymentDate = '' ;
		this.paymentPostDate = '' ;
		this.cardTransactionReferenceNumber = '' ;
		this.vendorCode = '' ;
		this.approvedAmount = 0 ;
		this.checkTransactionNumber = '' ;
		this.appliedAmount = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.vendorinvoice.VendorInvoicePurchaseOrderBean */
export class VendorInvoicePurchaseOrderBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorInvoiceCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderDate = '' ;
		this.purchaseOrderStopDate = '' ;
		this.lineNumber = 0 ;
		this.purchaseOrderReceiptApprovalNumber = '' ;
		this.approvalAmount = 0 ;
		this.purchaseOrderReceiptNumber = '' ;
		this.purchaseReceipts = new Array() ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.vendorinvoice.VendorInvoicePurchaseOrderReceiptBean */
export class VendorInvoicePurchaseOrderReceiptBean {
	constructor() {
		this.companyCode = '' ;
		this.vendorInvoiceCode = '' ;
		this.purchaseReceiptNumber = '' ;
		this.purchaseReceiptDate = '' ;
		this.purchaseOrderNumber = '' ;
		this.lineNumber = 0 ;
		this.vendorInvoicePOLineNumber = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.vendorinvoice.VendorInvoiceStatusTrackBean */
export class VendorInvoiceStatusTrackBean {
	constructor() {
		this.companyCode = '' ;
		this.trackNumber = 0 ;
		this.remarks = '' ;
		this.trackType = '' ;
		this.previousStatus = '' ;
		this.currentStatus = '' ;
		this.vendorInvoiceCode = '' ;
		this.grandTotalAmount = 0 ;
		this.code = '' ;
		this.description = '' ;
		this.isActive = false ;
		this.isFetched = false ;
		this.isDeleted = false ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.deletedBy = '' ;
		this.createdDate = '' ;
		this.updatedDate = '' ;
		this.deletedDate = '' ;
		this.isApplied = false ;
		this.notesCommunication = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.web.AmazonFabricStyleBean */
export class AmazonFabricStyleBean {
	constructor() {
		this.skuNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.uomCode = '' ;
		this.imageName = '' ;
		this.imagePath = '' ;
		this.companyCode = '' ;
		this.fullDescription = '' ;
		this.ediDescription = '' ;
		this.inventoryUomCode = '' ;
		this.salesTaxRequiredFlag = false ;
		this.divisionCode = '' ;
		this.departmentCode = '' ;
		this.classCode = '' ;
		this.subClassCode = '' ;
		this.defaultLocationCode = '' ;
		this.currencyCode = '' ;
		this.retailPrice = 0 ;
		this.wholesalePrice = 0 ;
		this.samplePrice = 0 ;
		this.webRetailPrice = 0 ;
		this.cost = 0 ;
		this.standardCost = 0 ;
		this.closeOutFlag = false ;
		this.closeOutPrice = 0 ;
		this.seasonCode = '' ;
		this.cpmTemplateCode = '' ;
		this.copyrightNumber = '' ;
		this.upcLevel = 0 ;
		this.weight = 0 ;
		this.weightUomCode = '' ;
		this.width = '' ;
		this.widthUomCode = '' ;
		this.productTypeCode = '' ;
		this.patternTypeCode = '' ;
		this.makeTypeCode = '' ;
		this.specialCode = '' ;
		this.productTypeName = '' ;
		this.patternTypeName = '' ;
		this.makeTypeName = '' ;
		this.countryOfOrgin = '' ;
		this.isPrepack = false ;
		this.unitsPerBox = 0 ;
		this.boxWidth = 0 ;
		this.boxHeight = 0 ;
		this.boxLength = 0 ;
		this.boxDimentionUomCode = '' ;
		this.boxWeight = 0 ;
		this.boxWeightUomCode = '' ;
		this.boxVolume = 0 ;
		this.availableFromDate = '' ;
		this.availableToDate = '' ;
		this.designerDetail = '' ;
		this.reorderStockLevel = 0 ;
		this.reorderDefaultQuantity = 0 ;
		this.categoryCode = '' ;
		this.subCategoryCode = '' ;
		this.notes = '' ;
		this.yarnDetails = '' ;
		this.filamentDetails = '' ;
		this.fibreDetail = '' ;
		this.usageDetails = '' ;
		this.createdStationCode = '' ;
		this.updatedStationCode = '' ;
		this.patternTypeCategoryCode = '' ;
		this.patternTypeCategoryName = '' ;
		this.isUPCGenerated = false ;
		this.division = null ;
		this.stretchWrapWeftDetails = '' ;
		this.colorFitnessDetails = '' ;
		this.oldSystemCode = '' ;
		this.leadTime = 0 ;
		this.minimumOrderQuantity = 0 ;
		this.cleanCode = '' ;
		this.directionCode = '' ;
		this.abrasionCode = '' ;
		this.contentCode = '' ;
		this.backingCode = '' ;
		this.hts = '' ;
		this.stats = '' ;
		this.styleItemType = '' ;
		this.styleItemTypeName = '' ;
		this.parentProductCode = '' ;
		this.tariffFlag = false ;
		this.businessDivision = '' ;
		this.tariffPercentage = 0 ;
		this.fabricWidth = '' ;
		this.fabricContent = '' ;
		this.fabricRepeat = '' ;
		this.fabricDirection = '' ;
		this.fabricWeight = '' ;
		this.fabricCountryOfOrigin = '' ;
		this.fabricCleaningCode = '' ;
		this.fabricAbrasion = '' ;
		this.fabricStyleType = '' ;
		this.warpYarn = false ;
		this.fillingYarn = false ;
		this.warpYarnSizes = '' ;
		this.fillingYarnSizes = '' ;
		this.warpYarnPerInch = '' ;
		this.fillingYarnPerInch = '' ;
		this.fillingYarnPerCentimeter = '' ;
		this.warpYarnPerCentimeter = '' ;
		this.warpYarnTwisted = false ;
		this.fillingYarnTwisted = false ;
		this.warpYarnTextured = false ;
		this.fillingYarnTextured = false ;
		this.fillingYarnCombed = false ;
		this.fillingYarnCarded = false ;
		this.napped = false ;
		this.printed = false ;
		this.washed = false ;
		this.needlePunched = false ;
		this.backed = false ;
		this.backingType = '' ;
		this.bondedBackingType = '' ;
		this.fibreContentBackingType = '' ;
		this.backingWeightKilo = '' ;
		this.backingWeightPound = '' ;
		this.latexWeightKilo = '' ;
		this.latexWeightPound = '' ;
		this.standardTesting1 = '' ;
		this.standardTesting2 = '' ;
		this.standardTesting3 = '' ;
		this.standardTesting4 = '' ;
		this.standardTesting5 = '' ;
		this.standardTesting6 = '' ;
		this.standardTesting7 = '' ;
		this.standardTesting8 = '' ;
		this.standardTesting9 = '' ;
		this.backingAndFinishingDetails = '' ;
		this.standardTestingDetails = '' ;
		this.contentDetails = '' ;
		this.dutyCharge = 0 ;
		this.fabricSurgeCharge = 0 ;
		this.sampleItemFlag = false ;
		this.rmbCost = 0 ;
		this.landingCost = 0 ;
		this.upcCode = '' ;
		this.metalWeight = 0 ;
		this.metalUomCode = '' ;
		this.oldSystemSkuNumber = '' ;
		this.skuCostBean = null ;
		this.skuPriceBean = null ;
		this.lastSKUCostLineNumber = 0 ;
		this.lastSKUPriceLineNumber = 0 ;
		this.amazonWebPrice = 0 ;
	}
}
/* ds.web.EbayFabricStyleBean */
export class EbayFabricStyleBean {
	constructor() {
		this.skuNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.uomCode = '' ;
		this.imageName = '' ;
		this.imagePath = '' ;
		this.companyCode = '' ;
		this.fullDescription = '' ;
		this.ediDescription = '' ;
		this.inventoryUomCode = '' ;
		this.salesTaxRequiredFlag = false ;
		this.divisionCode = '' ;
		this.departmentCode = '' ;
		this.classCode = '' ;
		this.subClassCode = '' ;
		this.defaultLocationCode = '' ;
		this.currencyCode = '' ;
		this.retailPrice = 0 ;
		this.wholesalePrice = 0 ;
		this.samplePrice = 0 ;
		this.webRetailPrice = 0 ;
		this.cost = 0 ;
		this.standardCost = 0 ;
		this.closeOutFlag = false ;
		this.closeOutPrice = 0 ;
		this.seasonCode = '' ;
		this.cpmTemplateCode = '' ;
		this.copyrightNumber = '' ;
		this.upcLevel = 0 ;
		this.weight = 0 ;
		this.weightUomCode = '' ;
		this.width = '' ;
		this.widthUomCode = '' ;
		this.productTypeCode = '' ;
		this.patternTypeCode = '' ;
		this.makeTypeCode = '' ;
		this.specialCode = '' ;
		this.productTypeName = '' ;
		this.patternTypeName = '' ;
		this.makeTypeName = '' ;
		this.countryOfOrgin = '' ;
		this.isPrepack = false ;
		this.unitsPerBox = 0 ;
		this.boxWidth = 0 ;
		this.boxHeight = 0 ;
		this.boxLength = 0 ;
		this.boxDimentionUomCode = '' ;
		this.boxWeight = 0 ;
		this.boxWeightUomCode = '' ;
		this.boxVolume = 0 ;
		this.availableFromDate = '' ;
		this.availableToDate = '' ;
		this.designerDetail = '' ;
		this.reorderStockLevel = 0 ;
		this.reorderDefaultQuantity = 0 ;
		this.categoryCode = '' ;
		this.subCategoryCode = '' ;
		this.notes = '' ;
		this.yarnDetails = '' ;
		this.filamentDetails = '' ;
		this.fibreDetail = '' ;
		this.usageDetails = '' ;
		this.createdStationCode = '' ;
		this.updatedStationCode = '' ;
		this.patternTypeCategoryCode = '' ;
		this.patternTypeCategoryName = '' ;
		this.isUPCGenerated = false ;
		this.division = null ;
		this.stretchWrapWeftDetails = '' ;
		this.colorFitnessDetails = '' ;
		this.oldSystemCode = '' ;
		this.leadTime = 0 ;
		this.minimumOrderQuantity = 0 ;
		this.cleanCode = '' ;
		this.directionCode = '' ;
		this.abrasionCode = '' ;
		this.contentCode = '' ;
		this.backingCode = '' ;
		this.hts = '' ;
		this.stats = '' ;
		this.styleItemType = '' ;
		this.styleItemTypeName = '' ;
		this.parentProductCode = '' ;
		this.tariffFlag = false ;
		this.businessDivision = '' ;
		this.tariffPercentage = 0 ;
		this.fabricWidth = '' ;
		this.fabricContent = '' ;
		this.fabricRepeat = '' ;
		this.fabricDirection = '' ;
		this.fabricWeight = '' ;
		this.fabricCountryOfOrigin = '' ;
		this.fabricCleaningCode = '' ;
		this.fabricAbrasion = '' ;
		this.fabricStyleType = '' ;
		this.warpYarn = false ;
		this.fillingYarn = false ;
		this.warpYarnSizes = '' ;
		this.fillingYarnSizes = '' ;
		this.warpYarnPerInch = '' ;
		this.fillingYarnPerInch = '' ;
		this.fillingYarnPerCentimeter = '' ;
		this.warpYarnPerCentimeter = '' ;
		this.warpYarnTwisted = false ;
		this.fillingYarnTwisted = false ;
		this.warpYarnTextured = false ;
		this.fillingYarnTextured = false ;
		this.fillingYarnCombed = false ;
		this.fillingYarnCarded = false ;
		this.napped = false ;
		this.printed = false ;
		this.washed = false ;
		this.needlePunched = false ;
		this.backed = false ;
		this.backingType = '' ;
		this.bondedBackingType = '' ;
		this.fibreContentBackingType = '' ;
		this.backingWeightKilo = '' ;
		this.backingWeightPound = '' ;
		this.latexWeightKilo = '' ;
		this.latexWeightPound = '' ;
		this.standardTesting1 = '' ;
		this.standardTesting2 = '' ;
		this.standardTesting3 = '' ;
		this.standardTesting4 = '' ;
		this.standardTesting5 = '' ;
		this.standardTesting6 = '' ;
		this.standardTesting7 = '' ;
		this.standardTesting8 = '' ;
		this.standardTesting9 = '' ;
		this.backingAndFinishingDetails = '' ;
		this.standardTestingDetails = '' ;
		this.contentDetails = '' ;
		this.dutyCharge = 0 ;
		this.fabricSurgeCharge = 0 ;
		this.sampleItemFlag = false ;
		this.rmbCost = 0 ;
		this.landingCost = 0 ;
		this.upcCode = '' ;
		this.metalWeight = 0 ;
		this.metalUomCode = '' ;
		this.oldSystemSkuNumber = '' ;
		this.skuCostBean = null ;
		this.skuPriceBean = null ;
		this.lastSKUCostLineNumber = 0 ;
		this.lastSKUPriceLineNumber = 0 ;
		this.ebayWebPrice = 0 ;
	}
}
/* ds.web.export.logging.ExportLogEntry$LogLevel */
export class LogLevel {
	constructor() {
	}
}
/* ds.web.export.logging.ExportLogEntry$RecordStatus */
export class RecordStatus {
	constructor() {
	}
}
/* ds.web.export.logging.ExportLogEntry */
export class ExportLogEntry {
	constructor() {
		this.level = null ;
		this.status = null ;
		this.fileName = '' ;
		this.lineNumber = 0 ;
		this.recordId = '' ;
		this.recordType = '' ;
		this.errorType = '' ;
		this.message = '' ;
		this.fieldName = '' ;
		this.fieldValue = '' ;
		this.timestamp = '' ;
		this.exportClass = '' ;
		this.companyCode = '' ;
	}
}
/* ds.web.export.logging.ExportProcessingSummary */
export class ExportProcessingSummary {
	constructor() {
		this.exportClass = '' ;
		this.fileName = '' ;
		this.companyCode = '' ;
		this.startTime = '' ;
		this.endTime = '' ;
		this.totalRows = 0 ;
		this.successRows = 0 ;
		this.failedRows = 0 ;
		this.skippedRows = 0 ;
		this.warnRows = 0 ;
		this.duplicateRows = 0 ;
		this.allEntries = null ;
		this.errorEntries = null ;
		this.skippedEntries = null ;
		this.warnEntries = null ;
	}
}
/* ds.web.FabricExcelToErpImportResultResponseBean */
export class FabricExcelToErpImportResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.web.FabricExportElectronicLinesInputBean */
export class FabricExportElectronicLinesInputBean {
	constructor() {
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
	}
}
/* ds.web.FabricImportResultResponseBean */
export class FabricImportResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.web.FabricStyleEcomWebErrorBean */
export class FabricStyleEcomWebErrorBean {
	constructor() {
		this.errorDescriptions = '' ;
	}
}
/* ds.web.FabricStyleEcomWebExcelToErpImportInputResultBean */
export class FabricStyleEcomWebExcelToErpImportInputResultBean {
	constructor() {
		this.shopifyFabricList = new Array() ;
	}
}
/* ds.web.FabricStyleEcomWebExportInputResultBean */
export class FabricStyleEcomWebExportInputResultBean {
	constructor() {
		this.webFabricList = new Array() ;
		this.amazonWebFabricStyleList = new Array() ;
		this.eBayWebFabricStyleList = new Array() ;
		this.shopifyWebFabricStyleList = new Array() ;
		this.walMartWebFabricStyleList = new Array() ;
		this.wayFairWebFabricStyleList = new Array() ;
		this.itsyWebFabricStyleList = new Array() ;
		this.houzzWebFabricStyleList = new Array() ;
	}
}
/* ds.web.FabricStyleEcomWebExportResultBean */
export class FabricStyleEcomWebExportResultBean {
	constructor() {
		this.webFabricStyleList = new Array() ;
		this.fabricStyleList = new Array() ;
		this.amazonWebFabricStyleList = new Array() ;
		this.eBayWebFabricStyleList = new Array() ;
		this.shopifyWebFabricStyleList = new Array() ;
		this.walMartWebFabricStyleList = new Array() ;
		this.wayFairWebFabricStyleList = new Array() ;
		this.itsyWebFabricStyleList = new Array() ;
		this.houzzWebFabricStyleList = new Array() ;
		this.sucessFabricStyleExported = new Array() ;
		this.faliedFabricStyleExported = new Array() ;
		this.skippedFabricStyleExported = new Array() ;
		this.processedRowsCount = 0 ;
		this.skippedRowsCount = 0 ;
		this.createdFabricStyleCount = 0 ;
		this.updatedFabricStyleCount = 0 ;
	}
}
/* ds.web.FabricStyleEcomWebExportResultResponseBean */
export class FabricStyleEcomWebExportResultResponseBean {
	constructor() {
		this.resultBean = null ;
		this.errors = new Array() ;
		this.warnings = new Array() ;
		this.infos = new Array() ;
		this.isSuccess = false ;
		this.isSessionExpired = false ;
	}
}
/* ds.web.FabricStyleEcomWebImportResultBean */
export class FabricStyleEcomWebImportResultBean {
	constructor() {
		this.webFabricStyleList = new Array() ;
		this.fabricStyleList = new Array() ;
		this.fabricStyleSkuList = new Array() ;
		this.amazonWebFabricStyleList = new Array() ;
		this.eBayWebFabricStyleList = new Array() ;
		this.shopifyWebFabricStyleList = new Array() ;
		this.walMartWebFabricStyleList = new Array() ;
		this.wayFairWebFabricStyleList = new Array() ;
		this.itsyWebFabricStyleList = new Array() ;
		this.houzzWebFabricStyleList = new Array() ;
		this.sucessFabricStyleExported = new Array() ;
		this.faliedFabricStyleExported = new Array() ;
		this.skippedFabricStyleExported = new Array() ;
		this.sucessFabricAmazonStyleExported = new Array() ;
		this.faliedFabricAmazonStyleExported = new Array() ;
		this.skippedFabricAmazonStyleExported = new Array() ;
		this.sucessFabricEbayStyleExported = new Array() ;
		this.faliedFabricEbayStyleExported = new Array() ;
		this.skippedFabricEbayStyleExported = new Array() ;
		this.sucessFabricShopifyStyleExported = new Array() ;
		this.faliedFabricShopifyStyleExported = new Array() ;
		this.skippedFabricShopifyStyleExported = new Array() ;
		this.sucessFabricWalMartStyleExported = new Array() ;
		this.faliedFabricWalMartStyleExported = new Array() ;
		this.skippedFabricWalMartStyleExported = new Array() ;
		this.sucessFabricWayFairStyleExported = new Array() ;
		this.faliedFabricWayFairStyleExported = new Array() ;
		this.skippedFabricWayFairStyleExported = new Array() ;
		this.sucessFabricItsyStyleExported = new Array() ;
		this.faliedFabricItsyStyleExported = new Array() ;
		this.skippedFabricItsyStyleExported = new Array() ;
		this.sucessFabricHouzzStyleExported = new Array() ;
		this.faliedFabricHouzzStyleExported = new Array() ;
		this.skippedFabricHouzzStyleExported = new Array() ;
		this.processedRowsCount = 0 ;
		this.skippedRowsCount = 0 ;
		this.createdFabricStyleCount = 0 ;
		this.updatedFabricStyleCount = 0 ;
	}
}
/* ds.web.FabricStyleWebExportInputBean */
export class FabricStyleWebExportInputBean {
	constructor() {
		this.companyCode = '' ;
		this.items = new Array() ;
		this.itemListCount = 0 ;
		this.exportType = '' ;
		this.exportTypes = new Array() ;
		this.skuNumbers = new Array() ;
	}
}
/* ds.web.FabricWebExportElectronicInputBean */
export class FabricWebExportElectronicInputBean {
	constructor() {
		this.count = '' ;
		this.Lines = new Array() ;
	}
}
/* ds.web.HouzzFabricStyleBean */
export class HouzzFabricStyleBean {
	constructor() {
		this.skuNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.uomCode = '' ;
		this.imageName = '' ;
		this.imagePath = '' ;
		this.companyCode = '' ;
		this.fullDescription = '' ;
		this.ediDescription = '' ;
		this.inventoryUomCode = '' ;
		this.salesTaxRequiredFlag = false ;
		this.divisionCode = '' ;
		this.departmentCode = '' ;
		this.classCode = '' ;
		this.subClassCode = '' ;
		this.defaultLocationCode = '' ;
		this.currencyCode = '' ;
		this.retailPrice = 0 ;
		this.wholesalePrice = 0 ;
		this.samplePrice = 0 ;
		this.webRetailPrice = 0 ;
		this.cost = 0 ;
		this.standardCost = 0 ;
		this.closeOutFlag = false ;
		this.closeOutPrice = 0 ;
		this.seasonCode = '' ;
		this.cpmTemplateCode = '' ;
		this.copyrightNumber = '' ;
		this.upcLevel = 0 ;
		this.weight = 0 ;
		this.weightUomCode = '' ;
		this.width = '' ;
		this.widthUomCode = '' ;
		this.productTypeCode = '' ;
		this.patternTypeCode = '' ;
		this.makeTypeCode = '' ;
		this.specialCode = '' ;
		this.productTypeName = '' ;
		this.patternTypeName = '' ;
		this.makeTypeName = '' ;
		this.countryOfOrgin = '' ;
		this.isPrepack = false ;
		this.unitsPerBox = 0 ;
		this.boxWidth = 0 ;
		this.boxHeight = 0 ;
		this.boxLength = 0 ;
		this.boxDimentionUomCode = '' ;
		this.boxWeight = 0 ;
		this.boxWeightUomCode = '' ;
		this.boxVolume = 0 ;
		this.availableFromDate = '' ;
		this.availableToDate = '' ;
		this.designerDetail = '' ;
		this.reorderStockLevel = 0 ;
		this.reorderDefaultQuantity = 0 ;
		this.categoryCode = '' ;
		this.subCategoryCode = '' ;
		this.notes = '' ;
		this.yarnDetails = '' ;
		this.filamentDetails = '' ;
		this.fibreDetail = '' ;
		this.usageDetails = '' ;
		this.createdStationCode = '' ;
		this.updatedStationCode = '' ;
		this.patternTypeCategoryCode = '' ;
		this.patternTypeCategoryName = '' ;
		this.isUPCGenerated = false ;
		this.division = null ;
		this.stretchWrapWeftDetails = '' ;
		this.colorFitnessDetails = '' ;
		this.oldSystemCode = '' ;
		this.leadTime = 0 ;
		this.minimumOrderQuantity = 0 ;
		this.cleanCode = '' ;
		this.directionCode = '' ;
		this.abrasionCode = '' ;
		this.contentCode = '' ;
		this.backingCode = '' ;
		this.hts = '' ;
		this.stats = '' ;
		this.styleItemType = '' ;
		this.styleItemTypeName = '' ;
		this.parentProductCode = '' ;
		this.tariffFlag = false ;
		this.businessDivision = '' ;
		this.tariffPercentage = 0 ;
		this.fabricWidth = '' ;
		this.fabricContent = '' ;
		this.fabricRepeat = '' ;
		this.fabricDirection = '' ;
		this.fabricWeight = '' ;
		this.fabricCountryOfOrigin = '' ;
		this.fabricCleaningCode = '' ;
		this.fabricAbrasion = '' ;
		this.fabricStyleType = '' ;
		this.warpYarn = false ;
		this.fillingYarn = false ;
		this.warpYarnSizes = '' ;
		this.fillingYarnSizes = '' ;
		this.warpYarnPerInch = '' ;
		this.fillingYarnPerInch = '' ;
		this.fillingYarnPerCentimeter = '' ;
		this.warpYarnPerCentimeter = '' ;
		this.warpYarnTwisted = false ;
		this.fillingYarnTwisted = false ;
		this.warpYarnTextured = false ;
		this.fillingYarnTextured = false ;
		this.fillingYarnCombed = false ;
		this.fillingYarnCarded = false ;
		this.napped = false ;
		this.printed = false ;
		this.washed = false ;
		this.needlePunched = false ;
		this.backed = false ;
		this.backingType = '' ;
		this.bondedBackingType = '' ;
		this.fibreContentBackingType = '' ;
		this.backingWeightKilo = '' ;
		this.backingWeightPound = '' ;
		this.latexWeightKilo = '' ;
		this.latexWeightPound = '' ;
		this.standardTesting1 = '' ;
		this.standardTesting2 = '' ;
		this.standardTesting3 = '' ;
		this.standardTesting4 = '' ;
		this.standardTesting5 = '' ;
		this.standardTesting6 = '' ;
		this.standardTesting7 = '' ;
		this.standardTesting8 = '' ;
		this.standardTesting9 = '' ;
		this.backingAndFinishingDetails = '' ;
		this.standardTestingDetails = '' ;
		this.contentDetails = '' ;
		this.dutyCharge = 0 ;
		this.fabricSurgeCharge = 0 ;
		this.sampleItemFlag = false ;
		this.rmbCost = 0 ;
		this.landingCost = 0 ;
		this.upcCode = '' ;
		this.metalWeight = 0 ;
		this.metalUomCode = '' ;
		this.oldSystemSkuNumber = '' ;
		this.skuCostBean = null ;
		this.skuPriceBean = null ;
		this.lastSKUCostLineNumber = 0 ;
		this.lastSKUPriceLineNumber = 0 ;
		this.houzzWebPrice = 0 ;
	}
}
/* ds.web.ItsyFabricStyleBean */
export class ItsyFabricStyleBean {
	constructor() {
		this.skuNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.uomCode = '' ;
		this.imageName = '' ;
		this.imagePath = '' ;
		this.companyCode = '' ;
		this.fullDescription = '' ;
		this.ediDescription = '' ;
		this.inventoryUomCode = '' ;
		this.salesTaxRequiredFlag = false ;
		this.divisionCode = '' ;
		this.departmentCode = '' ;
		this.classCode = '' ;
		this.subClassCode = '' ;
		this.defaultLocationCode = '' ;
		this.currencyCode = '' ;
		this.retailPrice = 0 ;
		this.wholesalePrice = 0 ;
		this.samplePrice = 0 ;
		this.webRetailPrice = 0 ;
		this.cost = 0 ;
		this.standardCost = 0 ;
		this.closeOutFlag = false ;
		this.closeOutPrice = 0 ;
		this.seasonCode = '' ;
		this.cpmTemplateCode = '' ;
		this.copyrightNumber = '' ;
		this.upcLevel = 0 ;
		this.weight = 0 ;
		this.weightUomCode = '' ;
		this.width = '' ;
		this.widthUomCode = '' ;
		this.productTypeCode = '' ;
		this.patternTypeCode = '' ;
		this.makeTypeCode = '' ;
		this.specialCode = '' ;
		this.productTypeName = '' ;
		this.patternTypeName = '' ;
		this.makeTypeName = '' ;
		this.countryOfOrgin = '' ;
		this.isPrepack = false ;
		this.unitsPerBox = 0 ;
		this.boxWidth = 0 ;
		this.boxHeight = 0 ;
		this.boxLength = 0 ;
		this.boxDimentionUomCode = '' ;
		this.boxWeight = 0 ;
		this.boxWeightUomCode = '' ;
		this.boxVolume = 0 ;
		this.availableFromDate = '' ;
		this.availableToDate = '' ;
		this.designerDetail = '' ;
		this.reorderStockLevel = 0 ;
		this.reorderDefaultQuantity = 0 ;
		this.categoryCode = '' ;
		this.subCategoryCode = '' ;
		this.notes = '' ;
		this.yarnDetails = '' ;
		this.filamentDetails = '' ;
		this.fibreDetail = '' ;
		this.usageDetails = '' ;
		this.createdStationCode = '' ;
		this.updatedStationCode = '' ;
		this.patternTypeCategoryCode = '' ;
		this.patternTypeCategoryName = '' ;
		this.isUPCGenerated = false ;
		this.division = null ;
		this.stretchWrapWeftDetails = '' ;
		this.colorFitnessDetails = '' ;
		this.oldSystemCode = '' ;
		this.leadTime = 0 ;
		this.minimumOrderQuantity = 0 ;
		this.cleanCode = '' ;
		this.directionCode = '' ;
		this.abrasionCode = '' ;
		this.contentCode = '' ;
		this.backingCode = '' ;
		this.hts = '' ;
		this.stats = '' ;
		this.styleItemType = '' ;
		this.styleItemTypeName = '' ;
		this.parentProductCode = '' ;
		this.tariffFlag = false ;
		this.businessDivision = '' ;
		this.tariffPercentage = 0 ;
		this.fabricWidth = '' ;
		this.fabricContent = '' ;
		this.fabricRepeat = '' ;
		this.fabricDirection = '' ;
		this.fabricWeight = '' ;
		this.fabricCountryOfOrigin = '' ;
		this.fabricCleaningCode = '' ;
		this.fabricAbrasion = '' ;
		this.fabricStyleType = '' ;
		this.warpYarn = false ;
		this.fillingYarn = false ;
		this.warpYarnSizes = '' ;
		this.fillingYarnSizes = '' ;
		this.warpYarnPerInch = '' ;
		this.fillingYarnPerInch = '' ;
		this.fillingYarnPerCentimeter = '' ;
		this.warpYarnPerCentimeter = '' ;
		this.warpYarnTwisted = false ;
		this.fillingYarnTwisted = false ;
		this.warpYarnTextured = false ;
		this.fillingYarnTextured = false ;
		this.fillingYarnCombed = false ;
		this.fillingYarnCarded = false ;
		this.napped = false ;
		this.printed = false ;
		this.washed = false ;
		this.needlePunched = false ;
		this.backed = false ;
		this.backingType = '' ;
		this.bondedBackingType = '' ;
		this.fibreContentBackingType = '' ;
		this.backingWeightKilo = '' ;
		this.backingWeightPound = '' ;
		this.latexWeightKilo = '' ;
		this.latexWeightPound = '' ;
		this.standardTesting1 = '' ;
		this.standardTesting2 = '' ;
		this.standardTesting3 = '' ;
		this.standardTesting4 = '' ;
		this.standardTesting5 = '' ;
		this.standardTesting6 = '' ;
		this.standardTesting7 = '' ;
		this.standardTesting8 = '' ;
		this.standardTesting9 = '' ;
		this.backingAndFinishingDetails = '' ;
		this.standardTestingDetails = '' ;
		this.contentDetails = '' ;
		this.dutyCharge = 0 ;
		this.fabricSurgeCharge = 0 ;
		this.sampleItemFlag = false ;
		this.rmbCost = 0 ;
		this.landingCost = 0 ;
		this.upcCode = '' ;
		this.metalWeight = 0 ;
		this.metalUomCode = '' ;
		this.oldSystemSkuNumber = '' ;
		this.skuCostBean = null ;
		this.skuPriceBean = null ;
		this.lastSKUCostLineNumber = 0 ;
		this.lastSKUPriceLineNumber = 0 ;
		this.itsyWebPrice = 0 ;
	}
}
/* ds.web.MultiWebFabricStyleDataExportResultBean */
export class MultiWebFabricStyleDataExportResultBean {
	constructor() {
		this.fabricStyles = new Array() ;
		this.amazonFabricStyles = new Array() ;
		this.walMartFabricStyles = new Array() ;
		this.shopifyFabricStyles = new Array() ;
		this.ebayFabricStyles = new Array() ;
		this.itsyFabricStyles = new Array() ;
		this.houzzFabricStyles = new Array() ;
		this.wayFairFabricStyles = new Array() ;
	}
}
/* ds.web.ShopifyFabricStyleBean */
export class ShopifyFabricStyleBean {
	constructor() {
		this.skuNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.uomCode = '' ;
		this.imageName = '' ;
		this.imagePath = '' ;
		this.companyCode = '' ;
		this.fullDescription = '' ;
		this.ediDescription = '' ;
		this.inventoryUomCode = '' ;
		this.salesTaxRequiredFlag = false ;
		this.divisionCode = '' ;
		this.departmentCode = '' ;
		this.classCode = '' ;
		this.subClassCode = '' ;
		this.defaultLocationCode = '' ;
		this.currencyCode = '' ;
		this.retailPrice = 0 ;
		this.wholesalePrice = 0 ;
		this.samplePrice = 0 ;
		this.webRetailPrice = 0 ;
		this.cost = 0 ;
		this.standardCost = 0 ;
		this.closeOutFlag = false ;
		this.closeOutPrice = 0 ;
		this.seasonCode = '' ;
		this.cpmTemplateCode = '' ;
		this.copyrightNumber = '' ;
		this.upcLevel = 0 ;
		this.weight = 0 ;
		this.weightUomCode = '' ;
		this.width = '' ;
		this.widthUomCode = '' ;
		this.productTypeCode = '' ;
		this.patternTypeCode = '' ;
		this.makeTypeCode = '' ;
		this.specialCode = '' ;
		this.productTypeName = '' ;
		this.patternTypeName = '' ;
		this.makeTypeName = '' ;
		this.countryOfOrgin = '' ;
		this.isPrepack = false ;
		this.unitsPerBox = 0 ;
		this.boxWidth = 0 ;
		this.boxHeight = 0 ;
		this.boxLength = 0 ;
		this.boxDimentionUomCode = '' ;
		this.boxWeight = 0 ;
		this.boxWeightUomCode = '' ;
		this.boxVolume = 0 ;
		this.availableFromDate = '' ;
		this.availableToDate = '' ;
		this.designerDetail = '' ;
		this.reorderStockLevel = 0 ;
		this.reorderDefaultQuantity = 0 ;
		this.categoryCode = '' ;
		this.subCategoryCode = '' ;
		this.notes = '' ;
		this.yarnDetails = '' ;
		this.filamentDetails = '' ;
		this.fibreDetail = '' ;
		this.usageDetails = '' ;
		this.createdStationCode = '' ;
		this.updatedStationCode = '' ;
		this.patternTypeCategoryCode = '' ;
		this.patternTypeCategoryName = '' ;
		this.isUPCGenerated = false ;
		this.division = null ;
		this.stretchWrapWeftDetails = '' ;
		this.colorFitnessDetails = '' ;
		this.oldSystemCode = '' ;
		this.leadTime = 0 ;
		this.minimumOrderQuantity = 0 ;
		this.cleanCode = '' ;
		this.directionCode = '' ;
		this.abrasionCode = '' ;
		this.contentCode = '' ;
		this.backingCode = '' ;
		this.hts = '' ;
		this.stats = '' ;
		this.styleItemType = '' ;
		this.styleItemTypeName = '' ;
		this.parentProductCode = '' ;
		this.tariffFlag = false ;
		this.businessDivision = '' ;
		this.tariffPercentage = 0 ;
		this.fabricWidth = '' ;
		this.fabricContent = '' ;
		this.fabricRepeat = '' ;
		this.fabricDirection = '' ;
		this.fabricWeight = '' ;
		this.fabricCountryOfOrigin = '' ;
		this.fabricCleaningCode = '' ;
		this.fabricAbrasion = '' ;
		this.fabricStyleType = '' ;
		this.warpYarn = false ;
		this.fillingYarn = false ;
		this.warpYarnSizes = '' ;
		this.fillingYarnSizes = '' ;
		this.warpYarnPerInch = '' ;
		this.fillingYarnPerInch = '' ;
		this.fillingYarnPerCentimeter = '' ;
		this.warpYarnPerCentimeter = '' ;
		this.warpYarnTwisted = false ;
		this.fillingYarnTwisted = false ;
		this.warpYarnTextured = false ;
		this.fillingYarnTextured = false ;
		this.fillingYarnCombed = false ;
		this.fillingYarnCarded = false ;
		this.napped = false ;
		this.printed = false ;
		this.washed = false ;
		this.needlePunched = false ;
		this.backed = false ;
		this.backingType = '' ;
		this.bondedBackingType = '' ;
		this.fibreContentBackingType = '' ;
		this.backingWeightKilo = '' ;
		this.backingWeightPound = '' ;
		this.latexWeightKilo = '' ;
		this.latexWeightPound = '' ;
		this.standardTesting1 = '' ;
		this.standardTesting2 = '' ;
		this.standardTesting3 = '' ;
		this.standardTesting4 = '' ;
		this.standardTesting5 = '' ;
		this.standardTesting6 = '' ;
		this.standardTesting7 = '' ;
		this.standardTesting8 = '' ;
		this.standardTesting9 = '' ;
		this.backingAndFinishingDetails = '' ;
		this.standardTestingDetails = '' ;
		this.contentDetails = '' ;
		this.dutyCharge = 0 ;
		this.fabricSurgeCharge = 0 ;
		this.sampleItemFlag = false ;
		this.rmbCost = 0 ;
		this.landingCost = 0 ;
		this.upcCode = '' ;
		this.metalWeight = 0 ;
		this.metalUomCode = '' ;
		this.oldSystemSkuNumber = '' ;
		this.skuCostBean = null ;
		this.skuPriceBean = null ;
		this.lastSKUCostLineNumber = 0 ;
		this.lastSKUPriceLineNumber = 0 ;
		this.shopifyWebPrice = 0 ;
	}
}
/* ds.web.WalMartFabricStyleBean */
export class WalMartFabricStyleBean {
	constructor() {
		this.skuNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.uomCode = '' ;
		this.imageName = '' ;
		this.imagePath = '' ;
		this.companyCode = '' ;
		this.fullDescription = '' ;
		this.ediDescription = '' ;
		this.inventoryUomCode = '' ;
		this.salesTaxRequiredFlag = false ;
		this.divisionCode = '' ;
		this.departmentCode = '' ;
		this.classCode = '' ;
		this.subClassCode = '' ;
		this.defaultLocationCode = '' ;
		this.currencyCode = '' ;
		this.retailPrice = 0 ;
		this.wholesalePrice = 0 ;
		this.samplePrice = 0 ;
		this.webRetailPrice = 0 ;
		this.cost = 0 ;
		this.standardCost = 0 ;
		this.closeOutFlag = false ;
		this.closeOutPrice = 0 ;
		this.seasonCode = '' ;
		this.cpmTemplateCode = '' ;
		this.copyrightNumber = '' ;
		this.upcLevel = 0 ;
		this.weight = 0 ;
		this.weightUomCode = '' ;
		this.width = '' ;
		this.widthUomCode = '' ;
		this.productTypeCode = '' ;
		this.patternTypeCode = '' ;
		this.makeTypeCode = '' ;
		this.specialCode = '' ;
		this.productTypeName = '' ;
		this.patternTypeName = '' ;
		this.makeTypeName = '' ;
		this.countryOfOrgin = '' ;
		this.isPrepack = false ;
		this.unitsPerBox = 0 ;
		this.boxWidth = 0 ;
		this.boxHeight = 0 ;
		this.boxLength = 0 ;
		this.boxDimentionUomCode = '' ;
		this.boxWeight = 0 ;
		this.boxWeightUomCode = '' ;
		this.boxVolume = 0 ;
		this.availableFromDate = '' ;
		this.availableToDate = '' ;
		this.designerDetail = '' ;
		this.reorderStockLevel = 0 ;
		this.reorderDefaultQuantity = 0 ;
		this.categoryCode = '' ;
		this.subCategoryCode = '' ;
		this.notes = '' ;
		this.yarnDetails = '' ;
		this.filamentDetails = '' ;
		this.fibreDetail = '' ;
		this.usageDetails = '' ;
		this.createdStationCode = '' ;
		this.updatedStationCode = '' ;
		this.patternTypeCategoryCode = '' ;
		this.patternTypeCategoryName = '' ;
		this.isUPCGenerated = false ;
		this.division = null ;
		this.stretchWrapWeftDetails = '' ;
		this.colorFitnessDetails = '' ;
		this.oldSystemCode = '' ;
		this.leadTime = 0 ;
		this.minimumOrderQuantity = 0 ;
		this.cleanCode = '' ;
		this.directionCode = '' ;
		this.abrasionCode = '' ;
		this.contentCode = '' ;
		this.backingCode = '' ;
		this.hts = '' ;
		this.stats = '' ;
		this.styleItemType = '' ;
		this.styleItemTypeName = '' ;
		this.parentProductCode = '' ;
		this.tariffFlag = false ;
		this.businessDivision = '' ;
		this.tariffPercentage = 0 ;
		this.fabricWidth = '' ;
		this.fabricContent = '' ;
		this.fabricRepeat = '' ;
		this.fabricDirection = '' ;
		this.fabricWeight = '' ;
		this.fabricCountryOfOrigin = '' ;
		this.fabricCleaningCode = '' ;
		this.fabricAbrasion = '' ;
		this.fabricStyleType = '' ;
		this.warpYarn = false ;
		this.fillingYarn = false ;
		this.warpYarnSizes = '' ;
		this.fillingYarnSizes = '' ;
		this.warpYarnPerInch = '' ;
		this.fillingYarnPerInch = '' ;
		this.fillingYarnPerCentimeter = '' ;
		this.warpYarnPerCentimeter = '' ;
		this.warpYarnTwisted = false ;
		this.fillingYarnTwisted = false ;
		this.warpYarnTextured = false ;
		this.fillingYarnTextured = false ;
		this.fillingYarnCombed = false ;
		this.fillingYarnCarded = false ;
		this.napped = false ;
		this.printed = false ;
		this.washed = false ;
		this.needlePunched = false ;
		this.backed = false ;
		this.backingType = '' ;
		this.bondedBackingType = '' ;
		this.fibreContentBackingType = '' ;
		this.backingWeightKilo = '' ;
		this.backingWeightPound = '' ;
		this.latexWeightKilo = '' ;
		this.latexWeightPound = '' ;
		this.standardTesting1 = '' ;
		this.standardTesting2 = '' ;
		this.standardTesting3 = '' ;
		this.standardTesting4 = '' ;
		this.standardTesting5 = '' ;
		this.standardTesting6 = '' ;
		this.standardTesting7 = '' ;
		this.standardTesting8 = '' ;
		this.standardTesting9 = '' ;
		this.backingAndFinishingDetails = '' ;
		this.standardTestingDetails = '' ;
		this.contentDetails = '' ;
		this.dutyCharge = 0 ;
		this.fabricSurgeCharge = 0 ;
		this.sampleItemFlag = false ;
		this.rmbCost = 0 ;
		this.landingCost = 0 ;
		this.upcCode = '' ;
		this.metalWeight = 0 ;
		this.metalUomCode = '' ;
		this.oldSystemSkuNumber = '' ;
		this.skuCostBean = null ;
		this.skuPriceBean = null ;
		this.lastSKUCostLineNumber = 0 ;
		this.lastSKUPriceLineNumber = 0 ;
		this.walMartWebPrice = 0 ;
	}
}
/* ds.web.WayFairFabricStyleBean */
export class WayFairFabricStyleBean {
	constructor() {
		this.skuNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.uomCode = '' ;
		this.imageName = '' ;
		this.imagePath = '' ;
		this.companyCode = '' ;
		this.fullDescription = '' ;
		this.ediDescription = '' ;
		this.inventoryUomCode = '' ;
		this.salesTaxRequiredFlag = false ;
		this.divisionCode = '' ;
		this.departmentCode = '' ;
		this.classCode = '' ;
		this.subClassCode = '' ;
		this.defaultLocationCode = '' ;
		this.currencyCode = '' ;
		this.retailPrice = 0 ;
		this.wholesalePrice = 0 ;
		this.samplePrice = 0 ;
		this.webRetailPrice = 0 ;
		this.cost = 0 ;
		this.standardCost = 0 ;
		this.closeOutFlag = false ;
		this.closeOutPrice = 0 ;
		this.seasonCode = '' ;
		this.cpmTemplateCode = '' ;
		this.copyrightNumber = '' ;
		this.upcLevel = 0 ;
		this.weight = 0 ;
		this.weightUomCode = '' ;
		this.width = '' ;
		this.widthUomCode = '' ;
		this.productTypeCode = '' ;
		this.patternTypeCode = '' ;
		this.makeTypeCode = '' ;
		this.specialCode = '' ;
		this.productTypeName = '' ;
		this.patternTypeName = '' ;
		this.makeTypeName = '' ;
		this.countryOfOrgin = '' ;
		this.isPrepack = false ;
		this.unitsPerBox = 0 ;
		this.boxWidth = 0 ;
		this.boxHeight = 0 ;
		this.boxLength = 0 ;
		this.boxDimentionUomCode = '' ;
		this.boxWeight = 0 ;
		this.boxWeightUomCode = '' ;
		this.boxVolume = 0 ;
		this.availableFromDate = '' ;
		this.availableToDate = '' ;
		this.designerDetail = '' ;
		this.reorderStockLevel = 0 ;
		this.reorderDefaultQuantity = 0 ;
		this.categoryCode = '' ;
		this.subCategoryCode = '' ;
		this.notes = '' ;
		this.yarnDetails = '' ;
		this.filamentDetails = '' ;
		this.fibreDetail = '' ;
		this.usageDetails = '' ;
		this.createdStationCode = '' ;
		this.updatedStationCode = '' ;
		this.patternTypeCategoryCode = '' ;
		this.patternTypeCategoryName = '' ;
		this.isUPCGenerated = false ;
		this.division = null ;
		this.stretchWrapWeftDetails = '' ;
		this.colorFitnessDetails = '' ;
		this.oldSystemCode = '' ;
		this.leadTime = 0 ;
		this.minimumOrderQuantity = 0 ;
		this.cleanCode = '' ;
		this.directionCode = '' ;
		this.abrasionCode = '' ;
		this.contentCode = '' ;
		this.backingCode = '' ;
		this.hts = '' ;
		this.stats = '' ;
		this.styleItemType = '' ;
		this.styleItemTypeName = '' ;
		this.parentProductCode = '' ;
		this.tariffFlag = false ;
		this.businessDivision = '' ;
		this.tariffPercentage = 0 ;
		this.fabricWidth = '' ;
		this.fabricContent = '' ;
		this.fabricRepeat = '' ;
		this.fabricDirection = '' ;
		this.fabricWeight = '' ;
		this.fabricCountryOfOrigin = '' ;
		this.fabricCleaningCode = '' ;
		this.fabricAbrasion = '' ;
		this.fabricStyleType = '' ;
		this.warpYarn = false ;
		this.fillingYarn = false ;
		this.warpYarnSizes = '' ;
		this.fillingYarnSizes = '' ;
		this.warpYarnPerInch = '' ;
		this.fillingYarnPerInch = '' ;
		this.fillingYarnPerCentimeter = '' ;
		this.warpYarnPerCentimeter = '' ;
		this.warpYarnTwisted = false ;
		this.fillingYarnTwisted = false ;
		this.warpYarnTextured = false ;
		this.fillingYarnTextured = false ;
		this.fillingYarnCombed = false ;
		this.fillingYarnCarded = false ;
		this.napped = false ;
		this.printed = false ;
		this.washed = false ;
		this.needlePunched = false ;
		this.backed = false ;
		this.backingType = '' ;
		this.bondedBackingType = '' ;
		this.fibreContentBackingType = '' ;
		this.backingWeightKilo = '' ;
		this.backingWeightPound = '' ;
		this.latexWeightKilo = '' ;
		this.latexWeightPound = '' ;
		this.standardTesting1 = '' ;
		this.standardTesting2 = '' ;
		this.standardTesting3 = '' ;
		this.standardTesting4 = '' ;
		this.standardTesting5 = '' ;
		this.standardTesting6 = '' ;
		this.standardTesting7 = '' ;
		this.standardTesting8 = '' ;
		this.standardTesting9 = '' ;
		this.backingAndFinishingDetails = '' ;
		this.standardTestingDetails = '' ;
		this.contentDetails = '' ;
		this.dutyCharge = 0 ;
		this.fabricSurgeCharge = 0 ;
		this.sampleItemFlag = false ;
		this.rmbCost = 0 ;
		this.landingCost = 0 ;
		this.upcCode = '' ;
		this.metalWeight = 0 ;
		this.metalUomCode = '' ;
		this.oldSystemSkuNumber = '' ;
		this.skuCostBean = null ;
		this.skuPriceBean = null ;
		this.lastSKUCostLineNumber = 0 ;
		this.lastSKUPriceLineNumber = 0 ;
		this.wayFairWebPrice = 0 ;
	}
}
/* ds.web.WebAmazonEcomFabricStyleBean */
export class WebAmazonEcomFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleDescription = '' ;
		this.fullDescription = '' ;
		this.price = 0 ;
		this.parentage = '' ;
		this.colorCode = '' ;
	}
}
/* ds.web.WebEbayEcomFabricStyleBean */
export class WebEbayEcomFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleDescription = '' ;
		this.fullDescription = '' ;
		this.price = 0 ;
		this.parentage = '' ;
		this.colorCode = '' ;
	}
}
/* ds.web.WebEcomToErpWebImportResultBean */
export class WebEcomToErpWebImportResultBean {
	constructor() {
		this.fabricStyleList = new Array() ;
		this.sucessFabricStyleExported = new Array() ;
		this.faliedFabricStyleExported = new Array() ;
		this.skippedFabricStyleExported = new Array() ;
		this.createdFabricStyleCount = 0 ;
		this.updatedFabricStyleCount = 0 ;
	}
}
/* ds.web.WebFabricStyleBean */
export class WebFabricStyleBean {
	constructor() {
		this.fabricStyleCode = '' ;
		this.uomCode = '' ;
		this.fullDescription = '' ;
		this.divisionCode = '' ;
		this.departmentCode = '' ;
		this.classCode = '' ;
		this.subClassCode = '' ;
		this.defaultLocationCode = '' ;
		this.currencyCode = '' ;
		this.seasonCode = '' ;
		this.cpmTemplateCode = '' ;
		this.copyrightNumber = '' ;
		this.upcLevel = 0 ;
		this.weight = 0 ;
		this.weightUomCode = '' ;
		this.width = '' ;
		this.widthUomCode = '' ;
		this.productTypeCode = '' ;
		this.patternTypeCode = '' ;
		this.makeTypeCode = '' ;
		this.specialCode = '' ;
		this.productTypeName = '' ;
		this.patternTypeName = '' ;
		this.makeTypeName = '' ;
		this.patternTypeCategoryCode = '' ;
		this.patternTypeCategoryName = '' ;
		this.countryOfOrgin = '' ;
		this.boxDimentionUomCode = '' ;
		this.boxWeightUomCode = '' ;
		this.boxVolume = 0 ;
		this.boxWeight = 0 ;
		this.unitsPerBox = 0 ;
		this.boxWidth = 0 ;
		this.boxHeight = 0 ;
		this.boxLength = 0 ;
		this.parentProductCode = '' ;
		this.businessDivision = '' ;
		this.reorderStockLevel = 0 ;
		this.reorderDefaultQuantity = 0 ;
		this.availableFromDate = '' ;
		this.availableToDate = '' ;
		this.designerDetail = '' ;
		this.categoryCode = '' ;
		this.subCategoryCode = '' ;
		this.notes = '' ;
		this.yarnDetails = '' ;
		this.filamentDetails = '' ;
		this.fibreDetail = '' ;
		this.usageDetails = '' ;
		this.createdStationCode = '' ;
		this.updatedStationCode = '' ;
		this.stretchWrapWeftDetails = '' ;
		this.colorFitnessDetails = '' ;
		this.oldSystemCode = '' ;
		this.leadTime = 0 ;
		this.minimumOrderQuantity = 0 ;
		this.cleanCode = '' ;
		this.directionCode = '' ;
		this.abrasionCode = '' ;
		this.contentCode = '' ;
		this.backingCode = '' ;
		this.hts = '' ;
		this.stats = '' ;
		this.styleItemType = '' ;
		this.styleItemTypeName = '' ;
		this.fabricWidth = '' ;
		this.fabricContent = '' ;
		this.fabricRepeat = '' ;
		this.fabricDirection = '' ;
		this.fabricWeight = '' ;
		this.fabricCountryOfOrigin = '' ;
		this.fabricCleaningCode = '' ;
		this.fabricAbrasion = '' ;
		this.fabricStyleType = '' ;
		this.warpYarnSizes = '' ;
		this.fillingYarnSizes = '' ;
		this.warpYarnPerInch = '' ;
		this.fillingYarnPerInch = '' ;
		this.fillingYarnPerCentimeter = '' ;
		this.warpYarnPerCentimeter = '' ;
		this.backingType = '' ;
		this.bondedBackingType = '' ;
		this.fibreContentBackingType = '' ;
		this.backingWeightKilo = '' ;
		this.backingWeightPound = '' ;
		this.latexWeightKilo = '' ;
		this.latexWeightPound = '' ;
		this.standardTesting1 = '' ;
		this.standardTesting2 = '' ;
		this.standardTesting3 = '' ;
		this.standardTesting4 = '' ;
		this.standardTesting5 = '' ;
		this.standardTesting6 = '' ;
		this.standardTesting7 = '' ;
		this.standardTesting8 = '' ;
		this.standardTesting9 = '' ;
		this.backingAndFinishingDetails = '' ;
		this.standardTestingDetails = '' ;
		this.contentDetails = '' ;
		this.dutyCharge = 0 ;
		this.fabricSurgeCharge = 0 ;
		this.tariffPercentage = 0 ;
		this.retailPrice = 0 ;
		this.wholesalePrice = 0 ;
		this.samplePrice = 0 ;
		this.webRetailPrice = 0 ;
		this.cost = 0 ;
		this.standardCost = 0 ;
		this.closeOutPrice = 0 ;
		this.ecomWebFabricPrice = 0 ;
		this.colorCode = '' ;
		this.parentage = '' ;
		this.metalUom = '' ;
		this.upcCode = '' ;
		this.oldSystemSkuNumber = '' ;
		this.metalWeight = 0 ;
		this.landingCost = 0 ;
		this.rmbCost = 0 ;
		this.imageName = '' ;
	}
}
/* ds.web.WebFabricStyleDataExportResultBean */
export class WebFabricStyleDataExportResultBean {
	constructor() {
		this.fabricStyleBean = null ;
		this.description = '' ;
		this.exportResultType = 0 ;
		this.oldSystemReferenceNumber = '' ;
	}
}
/* ds.web.WebHouzzEcomFabricStyleBean */
export class WebHouzzEcomFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleDescription = '' ;
		this.fullDescription = '' ;
		this.price = 0 ;
		this.parentage = '' ;
		this.colorCode = '' ;
	}
}
/* ds.web.WebItsyEcomFabricStyleBean */
export class WebItsyEcomFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleDescription = '' ;
		this.fullDescription = '' ;
		this.price = 0 ;
		this.parentage = '' ;
		this.colorCode = '' ;
	}
}
/* ds.web.WebShopifyEcomFabricStyleBean */
export class WebShopifyEcomFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleDescription = '' ;
		this.fullDescription = '' ;
		this.parentage = '' ;
		this.colorCode = '' ;
		this.handle = '' ;
		this.title = '' ;
		this.body = '' ;
		this.vendor = '' ;
		this.standardProductType = '' ;
		this.customProductTypeTags = '' ;
		this.published = '' ;
		this.variantInventoryPolicy = '' ;
		this.variantFulfillmentService = '' ;
		this.variantInventoryTracker = '' ;
		this.variantRequiresShipping = '' ;
		this.variantTaxable = '' ;
		this.giftCard = '' ;
		this.sEOTitle = '' ;
		this.sEODescription = '' ;
		this.googleShoppingGoogleProductCategory = '' ;
		this.googleShoppingGender = '' ;
		this.googleShoppingAgeGroup = '' ;
		this.googleShoppingMPN = '' ;
		this.googleShoppingAdWordsGrouping = '' ;
		this.googleShoppingAdWordsLabels = '' ;
		this.googleShoppingCondition = '' ;
		this.googleShoppingCustomProduct = '' ;
		this.googleShoppingCustomLabel0 = '' ;
		this.googleShoppingCustomLabel1 = '' ;
		this.googleShoppingCustomLabel2 = '' ;
		this.googleShoppingCustomLabel3 = '' ;
		this.googleShoppingCustomLabel4 = '' ;
		this.variantTaxCode = '' ;
		this.status = '' ;
		this.option1Name = '' ;
		this.option1Value = '' ;
		this.option2Name = '' ;
		this.option2Value = '' ;
		this.option3Name = '' ;
		this.option3Value = '' ;
		this.variantSKU = '' ;
		this.variantGrams = 0 ;
		this.variantInventoryQuantity = 0 ;
		this.variantBarcode = '' ;
		this.imageSrc = '' ;
		this.imagePosition = 0 ;
		this.imageAltText = '' ;
		this.variantImage = '' ;
		this.variantWeightUnit = '' ;
		this.variantPrice = 0 ;
		this.variantCompareAtPrice = 0 ;
		this.costPerItem = 0 ;
		this.webSiteCode = '' ;
		this.tags = '' ;
		this.newSKU = '' ;
	}
}
/* ds.web.WebWalMartEcomFabricStyleBean */
export class WebWalMartEcomFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleDescription = '' ;
		this.fullDescription = '' ;
		this.price = 0 ;
		this.parentage = '' ;
		this.colorCode = '' ;
	}
}
/* ds.web.WebWayFairEcomFabricStyleBean */
export class WebWayFairEcomFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.productType = '' ;
		this.collectionName = '' ;
		this.marketingCopy = '' ;
		this.featureBullet1 = '' ;
		this.featureBullet2 = '' ;
		this.featureBullet3 = '' ;
		this.featureBullet4 = '' ;
		this.featureBullet5 = '' ;
		this.featureBullet6 = '' ;
		this.featureBullet7 = '' ;
		this.countryOfManufacture = '' ;
		this.californiaProposition65WarningRequired = '' ;
		this.harmonizedCode = '' ;
		this.canadaCode = '' ;
		this.shipType = '' ;
		this.freightClass = '' ;
		this.leadTimeInDayHrs = '' ;
		this.leadTimeInReplacementHrs = '' ;
		this.nmfcCode = '' ;
		this.numberOfBoxes = 0 ;
		this.shippingWeight = 0 ;
		this.cartonHeight = 0 ;
		this.cartonWidth = 0 ;
		this.cartonDepth = 0 ;
		this.typeOfFabric = '' ;
		this.pattern = '' ;
		this.horizontalRepeat = '' ;
		this.frabicWeight = '' ;
		this.color = '' ;
		this.recommendedUse = '' ;
		this.fabricContent = '' ;
		this.genunineLeatherType = '' ;
		this.fauxLeatherType = '' ;
		this.productCare = '' ;
		this.supplierAttended = '' ;
		this.countryOfOrigin = '' ;
		this.cleaningCode = '' ;
		this.treatment = '' ;
		this.treatmentDetails = '' ;
		this.ulListed = '' ;
		this.actFlammabilityCompliant = '' ;
		this.taaCompliant = '' ;
		this.scsCertified = '' ;
		this.nepa701Certified = '' ;
		this.calCompliant = '' ;
		this.uplrCompliant = '' ;
		this.containsFlameRetardantMaterials = '' ;
		this.canadaProductRestriction = '' ;
		this.csaCertified = '' ;
		this.soffaCompliant = '' ;
		this.textileFlammabilityRegulations = '' ;
		this.overallLengthEndToEnd = 0 ;
		this.overallWidthSideToSide = 0 ;
		this.overallProductWeight = 0 ;
		this.weight = 0 ;
		this.commercialWarranty = '' ;
		this.productWarranty = '' ;
		this.webSalesFlag = false ;
		this.cost = 0 ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.supplierPartNumber = '' ;
		this.salesPrice = 0 ;
		this.retailPrice = 0 ;
		this.minimumnOrderQuantity = 0 ;
		this.forceMultiples = 0 ;
		this.displaySetQuantity = 0 ;
		this.image1Code = '' ;
	}
}
/* ds.portal.FabricPortalAsnLine */
export class FabricPortalAsnLine {
	constructor() {
		this.asnLineId = 0 ;
		this.asnId = 0 ;
		this.companyCode = '' ;
		this.asnOrderNumber = '' ;
		this.asnOrderLineNumber = 0 ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderLineNumber = 0 ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.totalAsnQuantity = '' ;
		this.weight = '' ;
		this.length = '' ;
		this.modificationTrackNumber = 0 ;
		this.createdDate = '' ;
		this.lastUpdatedDate = '' ;
		this.rollLines = null ;
	}
}
/* ds.portal.FabricPortalAsnResult */
export class FabricPortalAsnResult {
	constructor() {
		this.asnId = 0 ;
		this.companyCode = '' ;
		this.asnOrderNumber = '' ;
		this.containerNumber = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.billOfLading = '' ;
		this.status = '' ;
		this.statusString = '' ;
		this.modificationTrackNumber = 0 ;
		this.createdDate = '' ;
		this.lastUpdatedDate = '' ;
		this.asnLines = null ;
	}
}
/* ds.portal.FabricPortalCustomer */
export class FabricPortalCustomer {
	constructor() {
		this.customerCodeId = 0 ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.status = '' ;
		this.statusString = '' ;
		this.dbaName = '' ;
		this.legalName = '' ;
		this.currencyCode = '' ;
		this.divisionCode = '' ;
		this.departmentCode = '' ;
		this.classCode = '' ;
		this.subClassCode = '' ;
		this.privateLabelPrefix = null ;
		this.privateLabelCaption = null ;
		this.customerTypeCode = '' ;
		this.allocationPriority = 0 ;
		this.locationCode = null ;
		this.shipViaCode = '' ;
		this.address1 = '' ;
		this.address2 = '' ;
		this.city = '' ;
		this.state = '' ;
		this.country = '' ;
		this.zip = '' ;
		this.email = '' ;
		this.mobilePhone = '' ;
		this.phone1 = '' ;
		this.phone2 = '' ;
		this.fax = '' ;
		this.website = '' ;
		this.contactPerson = '' ;
		this.ccEmail = '' ;
		this.creditLimit = null ;
		this.factorCode = null ;
		this.arTypeCode = null ;
		this.financialTypeCode = null ;
		this.buyingOffice = null ;
		this.legalEntity = null ;
		this.resaleNumber = null ;
		this.accountRepresentative = '' ;
		this.customerSalesRepresentativeCode = null ;
		this.ediId = null ;
		this.federalId = null ;
		this.paymentTermsCode = '' ;
		this.paymentMethodCode = '' ;
		this.discountPercentage = null ;
		this.damageAllowancePercentage = null ;
		this.nationalId = null ;
		this.invoiceTemplateCode = null ;
		this.comments = null ;
		this.instructions = null ;
		this.zoneCode = null ;
		this.regionCode = null ;
		this.districtCode = null ;
		this.territoryCode = null ;
		this.markUpDownPercentage = null ;
		this.accountNumber = null ;
		this.firstName = null ;
		this.lastName = null ;
		this.middleName = null ;
		this.customerCompanyName = null ;
		this.customerAddressNotes = null ;
		this.shippingAccountCountryCode = null ;
		this.shippingAccountPostalCode = null ;
		this.warningNotes = null ;
		this.customerDeliveryTypeCode = null ;
		this.payableEmail = null ;
		this.purchasingEmail = null ;
		this.adminEmail = null ;
		this.generalEmail = null ;
		this.incotermCode = null ;
		this.establishedDate = null ;
		this.customerSpecialTypeCode = null ;
		this.businessDivision = null ;
		this.customerRemarks = null ;
		this.erpCreatedDate = '' ;
		this.createdDate = '' ;
		this.lastUpdatedDate = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.portal.FabricPortalCustomerBillTo */
export class FabricPortalCustomerBillTo {
	constructor() {
		this.customerBillToId = 0 ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.billToCode = '' ;
		this.billToAddress1 = '' ;
		this.billToAddress2 = '' ;
		this.billToAddress3 = '' ;
		this.billToAddress4 = '' ;
		this.billToAddress5 = '' ;
		this.billToAddress6 = '' ;
		this.billToAddress7 = '' ;
		this.billToCity = '' ;
		this.billToState = '' ;
		this.billToCountry = '' ;
		this.billToZip = '' ;
		this.billToEmail = '' ;
		this.billToMobilePhone = '' ;
		this.billToPhone1 = '' ;
		this.billToPhone2 = '' ;
		this.billToFax = '' ;
		this.billToFax2 = '' ;
		this.billToWebsite = '' ;
		this.billToContactPerson = '' ;
		this.billToCcEmail = '' ;
		this.billToCounty = '' ;
	}
}
/* ds.portal.FabricPortalCustomerSalesOrderLine */
export class FabricPortalCustomerSalesOrderLine {
	constructor() {
		this.customerSalesOrderLineId = 0 ;
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.salesOrderLineNumber = 0 ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.orderDate = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.salesOrderStatus = '' ;
		this.salesOrderStatusString = '' ;
		this.lineStatus = '' ;
		this.lineStatusString = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.remarks = '' ;
		this.uomCode = '' ;
		this.currencyCode = '' ;
		this.orderQuantity = '' ;
		this.pickedQuantity = '' ;
		this.shippedQuantity = '' ;
		this.adjustedQuantity = '' ;
		this.openQuantity = '' ;
		this.cost = '' ;
		this.price = '' ;
		this.taxPercentage = '' ;
		this.taxAmount = '' ;
		this.discountPercentage = '' ;
		this.discountAmount = '' ;
		this.extraChargeAmount = '' ;
		this.lineAmount = '' ;
		this.lineNetAmount = '' ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.modificationTrackNumber = 0 ;
		this.erpCreatedDate = '' ;
		this.createdDate = '' ;
		this.lastUpdatedDate = '' ;
		this.revisedShipDate = null ;
		this.shipToCode = null ;
		this.orderType = null ;
	}
}
/* ds.portal.FabricPortalCustomerSalesPersonCommission */
export class FabricPortalCustomerSalesPersonCommission {
	constructor() {
		this.customerCommissionId = 0 ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerCommissionCode = '' ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.productDivisionCode = '' ;
		this.commissionPercentage = '' ;
		this.commissionTypeCode = '' ;
		this.status = '' ;
		this.primary = false ;
	}
}
/* ds.portal.FabricPortalCustomerShipTo */
export class FabricPortalCustomerShipTo {
	constructor() {
		this.customerShipToId = 0 ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.shipToCode = '' ;
		this.billToCode = '' ;
		this.shipToAddress1 = '' ;
		this.shipToAddress2 = '' ;
		this.shipToAddress3 = '' ;
		this.shipToAddress4 = '' ;
		this.shipToAddress5 = '' ;
		this.shipToAddress6 = '' ;
		this.shipToAddress7 = '' ;
		this.shipToCity = '' ;
		this.shipToState = '' ;
		this.shipToCountry = '' ;
		this.shipToZip = '' ;
		this.shipToEmail = '' ;
		this.shipToMobilePhone = '' ;
		this.shipToPhone1 = '' ;
		this.shipToPhone2 = '' ;
		this.shipToFax = '' ;
		this.shipToFax2 = '' ;
		this.shipToWebsite = '' ;
		this.shipToContactPerson = '' ;
		this.shipToCcEmail = '' ;
		this.shipToCounty = '' ;
	}
}
/* ds.portal.FabricPortalError */
export class FabricPortalError {
	constructor() {
		this.messageID = '' ;
		this.messageDescription = '' ;
		this.messageTarget = '' ;
	}
}
/* ds.portal.FabricPortalFabricStyle */
export class FabricPortalFabricStyle {
	constructor() {
		this.fabricStyleId = 0 ;
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.inventoryUOM = '' ;
		this.width = '' ;
		this.widthUOM = '' ;
		this.weightUOM = '' ;
		this.weight = '' ;
		this.retailPrice = '' ;
		this.wholeSalePrice = '' ;
		this.samplePrice = '' ;
		this.webRetailPrice = '' ;
		this.cost = '' ;
		this.standardCost = '' ;
		this.imageName1 = '' ;
		this.imageName2 = '' ;
		this.imageName3 = '' ;
		this.imageName4 = '' ;
		this.imagePath1 = '' ;
		this.imagePath2 = '' ;
		this.imagePath3 = '' ;
		this.imagePath4 = '' ;
		this.erpCreatedDate = '' ;
		this.createdDate = '' ;
		this.lastUpdatedDate = '' ;
		this.modificationTrackNumber = 0 ;
		this.fabricStyleColors = null ;
		this.fabricStyleSkus = null ;
		this.fabricStyleCustomerTypePrices = null ;
	}
}
/* ds.portal.FabricPortalFabricStyleColor */
export class FabricPortalFabricStyleColor {
	constructor() {
		this.fabricStyleColorId = 0 ;
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.fabricStyleColorName = '' ;
		this.imageName = '' ;
		this.imagePath = '' ;
	}
}
/* ds.portal.FabricPortalFabricStyleCustomerTypePrice */
export class FabricPortalFabricStyleCustomerTypePrice {
	constructor() {
		this.fabricStyleCustomerTypePriceId = 0 ;
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.customerTypeCode = '' ;
		this.uomCode = '' ;
		this.currencyCode = '' ;
		this.samplePrice = '' ;
		this.price = '' ;
	}
}
/* ds.portal.FabricPortalFabricStyleSku */
export class FabricPortalFabricStyleSku {
	constructor() {
		this.fabricStyleSkuId = 0 ;
		this.companyCode = '' ;
		this.skuNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.uomCode = '' ;
		this.currencyCode = '' ;
		this.samplePrice = '' ;
		this.wholesalePrice = '' ;
		this.retailPrice = '' ;
		this.webRetailPrice = '' ;
		this.cost = '' ;
		this.rmbCost = '' ;
		this.standardCost = '' ;
		this.landingCost = '' ;
		this.upcCode = '' ;
		this.oldSystemSkuNumber = '' ;
		this.fabricStyleSkuPrice = null ;
		this.fabricStyleSkuCost = null ;
	}
}
/* ds.portal.FabricPortalFabricStyleSkuCost */
export class FabricPortalFabricStyleSkuCost {
	constructor() {
		this.fabricStyleSKUCostId = 0 ;
		this.companyCode = '' ;
		this.skuNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.cost = '' ;
		this.effectiveDate = '' ;
		this.fabricStyleSkuVendorCosts = null ;
	}
}
/* ds.portal.FabricPortalFabricStyleSkuCustomerPrice */
export class FabricPortalFabricStyleSkuCustomerPrice {
	constructor() {
		this.fabricStyleSKUCustomerPriceId = 0 ;
		this.companyCode = '' ;
		this.skuNumber = 0 ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerTypeCode = '' ;
		this.customerTypeName = '' ;
		this.currencyCode = '' ;
		this.uomCode = '' ;
		this.discountPercentage = '' ;
		this.price = '' ;
		this.samplePrice = '' ;
		this.effectiveDate = '' ;
	}
}
/* ds.portal.FabricPortalFabricStyleSkuPrice */
export class FabricPortalFabricStyleSkuPrice {
	constructor() {
		this.fabricStyleSKUPriceId = 0 ;
		this.companyCode = '' ;
		this.skuNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.defaultPrice = '' ;
		this.samplePrice = '' ;
		this.effectiveDate = '' ;
		this.fabricStyleSkuCustomerPrices = null ;
	}
}
/* ds.portal.FabricPortalFabricStyleSkuVendorCost */
export class FabricPortalFabricStyleSkuVendorCost {
	constructor() {
		this.fabricStyleSKUVendorCostId = 0 ;
		this.companyCode = '' ;
		this.skuNumber = 0 ;
		this.lineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleColorCode = '' ;
		this.uomCode = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.effectiveDate = '' ;
		this.cost = '' ;
		this.currencyCode = '' ;
		this.defaultCost = false ;
	}
}
/* ds.portal.FabricPortalInfo */
export class FabricPortalInfo {
	constructor() {
		this.messageID = '' ;
		this.messageDescription = '' ;
		this.messageTarget = '' ;
	}
}
/* ds.portal.FabricPortalInputFromPortalPurchaseOrderLine */
export class FabricPortalInputFromPortalPurchaseOrderLine {
	constructor() {
		this.count = 0 ;
		this.portalPurchaseOrderList = null ;
	}
}
/* ds.portal.FabricPortalInTransitCustomerAllocation */
export class FabricPortalInTransitCustomerAllocation {
	constructor() {
		this.inTransitCustomerAllocationId = 0 ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.inTransitCustomerAllocationCode = '' ;
		this.customerName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.startDate = '' ;
		this.stopDate = '' ;
		this.status = '' ;
		this.statusString = '' ;
		this.inTransitQuantity = '' ;
		this.widthCode = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.locationCode = '' ;
		this.remarks = '' ;
		this.fobCost = '' ;
		this.landedCost = '' ;
		this.containerNumber = '' ;
		this.etaDate = '' ;
		this.modificationTrackNumber = 0 ;
		this.erpCreatedDate = '' ;
		this.lastUpdatedDate = '' ;
		this.createdDate = '' ;
		this.cancelAllocation = false ;
	}
}
/* ds.portal.FabricPortalInTransitRollLine */
export class FabricPortalInTransitRollLine {
	constructor() {
		this.purchaseOrderInTransitRollLineId = 0 ;
		this.companyCode = '' ;
		this.purchaseOrderInTransitNumber = '' ;
		this.inTransitRollLineNumber = 0 ;
		this.inTransitLineNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.rollNumber = '' ;
		this.locationCode = '' ;
		this.locationType = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.widthCode = '' ;
		this.uomCode = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.receivedQuantity = '' ;
		this.inTransitQuantity = '' ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = '' ;
		this.boxNumber = '' ;
		this.vendorLotNumber = '' ;
		this.infoText = null ;
		this.aisleInfoText = '' ;
		this.purchaseOrderNumber = '' ;
		this.adjustedTransitQuantity = '' ;
		this.modificationTrackNumber = 0 ;
		this.erpCreatedDate = null ;
		this.createdDate = null ;
		this.lastUpdatedDate = null ;
	}
}
/* ds.portal.FabricPortalInvoice */
export class FabricPortalInvoice {
	constructor() {
		this.invoiceId = 0 ;
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.invoiceDate = '' ;
		this.paymentDueDate = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.merchandiseAmount = '' ;
		this.nonMerchandiseAmount = '' ;
		this.extraChargesAmount = '' ;
		this.shipmentChargesAmount = '' ;
		this.totalTaxAmount = '' ;
		this.taxPercengate = '' ;
		this.totalDiscountAmount = '' ;
		this.grandTotalAmount = '' ;
		this.totalPaidAmount = '' ;
		this.totalCashPaidAmount = '' ;
		this.totalCreditAppliedAmount = '' ;
		this.currencyCode = '' ;
		this.invoiceStatus = '' ;
		this.invocieStatusString = '' ;
		this.invoiceDocumentPath = null ;
		this.modificationTrackNumber = 0 ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.invoicePDFFilePath = null ;
		this.erpCreatedDate = '' ;
		this.createdDate = '' ;
		this.lastUpdatedDate = '' ;
	}
}
/* ds.portal.FabricPortalInvoiceLine */
export class FabricPortalInvoiceLine {
	constructor() {
		this.invoiceLineId = 0 ;
		this.companyCode = '' ;
		this.invoiceNumber = '' ;
		this.lineNumber = 0 ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleCode = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.upcCode = '' ;
		this.uomCode = '' ;
		this.invoiceStatus = '' ;
		this.invoiceStatusString = '' ;
		this.invoiceLineStatus = '' ;
		this.invoiceLineStatusString = '' ;
		this.price = '' ;
		this.originalPrice = '' ;
		this.discountPercentage = '' ;
		this.onHandQuantity = '' ;
		this.onOrderQuantity = '' ;
		this.shippedQuantity = '' ;
		this.returnQuantity = '' ;
		this.lineTotalAmount = '' ;
		this.lineNetAmount = '' ;
		this.lineDiscountAmount = '' ;
		this.cost = '' ;
		this.locationCode = '' ;
		this.inventoryUomCode = '' ;
		this.currencyCode = '' ;
		this.taxPercentage = '' ;
		this.taxAmount = '' ;
		this.tariffPercentage = '' ;
		this.tariffAmount = '' ;
		this.erpCreatedDate = '' ;
		this.createdDate = '' ;
		this.lastUpdatedDate = '' ;
		this.invoiceDate = '' ;
		this.modificationTrackNumber = 0 ;
	}
}
/* ds.portal.FabricPortalManualCustomerAllocation */
export class FabricPortalManualCustomerAllocation {
	constructor() {
		this.manualCustomerAllocationId = 0 ;
		this.manualCustomerAllocationCode = '' ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.startDate = '' ;
		this.stopDate = '' ;
		this.status = '' ;
		this.statusString = '' ;
		this.allocatedQuantity = '' ;
		this.widthCode = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.remarks = '' ;
		this.createdDate = '' ;
		this.erpCreatedDate = '' ;
		this.lastUpdatedDate = '' ;
		this.updatedDate = '' ;
		this.createdBy = '' ;
		this.updatedBy = '' ;
		this.modificationTrackNumber = 0 ;
		this.cancelAllocation = false ;
	}
}
/* ds.portal.FabricPortalPortalAsnModuleList */
export class FabricPortalPortalAsnModuleList {
	constructor() {
		this.count = 0 ;
		this.asnResults = null ;
	}
}
/* ds.portal.FabricPortalPortalPurchaseOrderList */
export class FabricPortalPortalPurchaseOrderList {
	constructor() {
		this.vendorPurchaseOrderLineId = 0 ;
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderLineNumber = 0 ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.lineStatus = '' ;
		this.lineStatusString = '' ;
		this.purchaseOrderStatus = '' ;
		this.purchaseOrderStatusString = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.upcCode = null ;
		this.uomCode = '' ;
		this.price = '' ;
		this.cost = '' ;
		this.landedCost = '' ;
		this.fobCost = '' ;
		this.openQuantity = '' ;
		this.adjustedQuantity = '' ;
		this.receivedQuantity = '' ;
		this.receivedAdjustedQuantity = '' ;
		this.lineTotalAmount = '' ;
		this.locationCode = '' ;
		this.inDCDate = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.productDivisionCode = '' ;
		this.productDepartmentCode = '' ;
		this.productClassCode = '' ;
		this.productSubClassCode = '' ;
		this.purchaseOrderScheduleNumber = '' ;
		this.techDesigner = null ;
		this.extraCharge = '' ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = '' ;
		this.vendorStyleCode = '' ;
		this.vendorStyleColorCode = '' ;
		this.currencyCode = '' ;
		this.oldSystemPurchaseOrderLineNumber = null ;
		this.inTransitQuantity = '' ;
		this.inTransitAdjustedQuantity = '' ;
		this.productionStatus = null ;
		this.productionNotes = null ;
		this.sts = null ;
		this.availableDate = null ;
		this.sailDate = '' ;
		this.estimatedShipDate = '' ;
		this.orderQuantity = '' ;
		this.modificationTrackNumber = 0 ;
		this.erpCreatedDate = null ;
		this.createdDate = null ;
		this.lastUpdatedDate = null ;
		this.portalModifyDate = '' ;
		this.portalModificationTrackNumber = 0 ;
		this.portalModifyBy = '' ;
		this.remarks = '' ;
	}
}
/* ds.portal.FabricPortalResponse */
export class FabricPortalResponse {
	constructor() {
		this.errors = null ;
		this.warnings = null ;
		this.infos = null ;
		this.success = false ;
		this.sessionExpired = false ;
	}
}
/* ds.portal.FabricPortalRollLine */
export class FabricPortalRollLine {
	constructor() {
		this.asnLineId = 0 ;
		this.asnId = 0 ;
		this.companyCode = '' ;
		this.asnOrderNumber = '' ;
		this.asnOrderLineNumber = 0 ;
		this.asnOrderRollLineNumber = 0 ;
		this.rollSkuNumber = 0 ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderLineNumber = 0 ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.uomCode = '' ;
		this.vendorBatchNumber = '' ;
		this.asnQuantity = '' ;
		this.weight = '' ;
		this.length = '' ;
		this.modificationTrackNumber = 0 ;
		this.createdDate = '' ;
		this.lastUpdatedDate = '' ;
		this.asnRollLineId = 0 ;
	}
}
/* ds.portal.FabricPortalSalesOrder */
export class FabricPortalSalesOrder {
	constructor() {
		this.salesOrderId = 0 ;
		this.companyCode = '' ;
		this.salesOrderNumber = '' ;
		this.salesOrderTypeCode = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.customerPurchaseOrderNumber = '' ;
		this.customerShipToCode = '' ;
		this.customerShipToName = '' ;
		this.customerBillToCode = '' ;
		this.shipViaCode = '' ;
		this.currencyCode = '' ;
		this.freightMethodCode = '' ;
		this.paymentMethodCode = '' ;
		this.paymentTermCode = '' ;
		this.salesOrderDate = '' ;
		this.salesOrderStartDate = '' ;
		this.salesOrderStopDate = '' ;
		this.xDCDate = '' ;
		this.extraChargesAmount = '' ;
		this.shipmentChargesAmount = '' ;
		this.totalTaxAmount = '' ;
		this.taxPercentage = '' ;
		this.totalDiscountAmount = '' ;
		this.grandTotalAmount = '' ;
		this.salesOrderStatus = '' ;
		this.salesOrderStatusString = '' ;
		this.salesOrderDocumentPath = null ;
		this.modificationTrackNumber = 0 ;
		this.salesPersonCode = '' ;
		this.salesPersonName = '' ;
		this.salesOrderPDFFilePath = null ;
		this.erpCreatedDate = '' ;
		this.createdDate = '' ;
		this.lastUpdatedDate = '' ;
	}
}
/* ds.portal.FabricPortalSkuBatchInventory */
export class FabricPortalSkuBatchInventory {
	constructor() {
		this.skuBatchInventoryId = 0 ;
		this.companyCode = '' ;
		this.rollSkuNumber = 0 ;
		this.locationCode = '' ;
		this.rollNumber = '' ;
		this.skuNumber = 0 ;
		this.remarks = '' ;
		this.referenceEntityType = '' ;
		this.referenceEntityNumber = '' ;
		this.uomCode = '' ;
		this.currencyCode = '' ;
		this.onHandQuantity = '' ;
		this.receivedQuantity = '' ;
		this.cost = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.batchBarCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderReceiptNumber = '' ;
		this.rollBarCode = '' ;
		this.vendorBatchNumber = '' ;
		this.boxNumber = '' ;
		this.receivedDate = '' ;
		this.infoText = '' ;
		this.aisleInfoText = '' ;
		this.reserveCustomerCode = '' ;
		this.reserveCustomerName = '' ;
		this.fobCost = '' ;
		this.landedCost = '' ;
		this.modificationTrackNumber = 0 ;
		this.erpCreatedDate = '' ;
		this.createdDate = '' ;
		this.lastUpdatedDate = '' ;
		this.closeOutInventory = false ;
	}
}
/* ds.portal.FabricPortalVendorPurchaseInTransitLine */
export class FabricPortalVendorPurchaseInTransitLine {
	constructor() {
		this.vendorPurchaseInTransitLineId = 0 ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderLineNumber = 0 ;
		this.purchaseOrderInTransitNumber = '' ;
		this.purchaseOrderInTransitLineNumber = 0 ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.containerNumber = '' ;
		this.etaDate = '' ;
		this.transitStatus = '' ;
		this.transitStatusString = '' ;
		this.lineStatus = '' ;
		this.lineStatusString = '' ;
		this.widthCode = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.upcCode = '' ;
		this.uomCode = '' ;
		this.companyCode = '' ;
		this.customerCode = null ;
		this.customerName = null ;
		this.openOrderQuantity = '' ;
		this.purchaseOrderQuantity = '' ;
		this.receivedQuantity = '' ;
		this.receivedQuantityToDate = '' ;
		this.inTransitQuantity = '' ;
		this.inTransitQuantityToDate = '' ;
		this.goodQualityInTransitQuantity = '' ;
		this.badQualityInTransitQuantity = '' ;
		this.locationCode = '' ;
		this.comments = '' ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = '' ;
		this.vendorStyleCode = '' ;
		this.vendorStyleColorCode = '' ;
		this.adjustedTransitQuantity = '' ;
		this.modificationTrackNumber = 0 ;
		this.erpCreatedDate = null ;
		this.createdDate = null ;
		this.lastUpdatedDate = null ;
	}
}
/* ds.portal.FabricPortalVendorPurchaseOrderLine */
export class FabricPortalVendorPurchaseOrderLine {
	constructor() {
		this.vendorPurchaseOrderLineId = 0 ;
		this.companyCode = '' ;
		this.purchaseOrderNumber = '' ;
		this.purchaseOrderLineNumber = 0 ;
		this.vendorCode = '' ;
		this.vendorName = '' ;
		this.fabricStyleCode = '' ;
		this.fabricStyleName = '' ;
		this.lineStatus = '' ;
		this.lineStatusString = '' ;
		this.purchaseOrderStatus = '' ;
		this.purchaseOrderStatusString = '' ;
		this.colorCode = '' ;
		this.widthCode = '' ;
		this.skuNumber = 0 ;
		this.upcCode = '' ;
		this.uomCode = '' ;
		this.price = '' ;
		this.cost = '' ;
		this.landedCost = '' ;
		this.fobCost = '' ;
		this.openQuantity = '' ;
		this.adjustedQuantity = '' ;
		this.receivedQuantity = '' ;
		this.receivedAdjustedQuantity = '' ;
		this.lineTotalAmount = '' ;
		this.locationCode = '' ;
		this.inDCDate = '' ;
		this.orderStartDate = '' ;
		this.orderStopDate = '' ;
		this.productDivisionCode = '' ;
		this.productDepartmentCode = '' ;
		this.productClassCode = '' ;
		this.productSubClassCode = '' ;
		this.purchaseOrderScheduleNumber = '' ;
		this.techDesigner = '' ;
		this.extraCharge = '' ;
		this.inventoryUomCode = '' ;
		this.uomConversionRate = '' ;
		this.vendorStyleCode = '' ;
		this.vendorStyleColorCode = '' ;
		this.currencyCode = '' ;
		this.oldSystemPurchaseOrderLineNumber = '' ;
		this.inTransitQuantity = '' ;
		this.inTransitAdjustedQuantity = '' ;
		this.productionStatus = '' ;
		this.productionNotes = '' ;
		this.sts = '' ;
		this.availableDate = '' ;
		this.sailDate = '' ;
		this.estimatedShipDate = '' ;
		this.orderQuantity = '' ;
		this.modificationTrackNumber = 0 ;
		this.erpCreatedDate = null ;
		this.createdDate = null ;
		this.lastUpdatedDate = null ;
		this.portalModifyDate = null ;
		this.portalModificationTrackNumber = null ;
		this.portalModifyBy = null ;
		this.remarks = null ;
		this.customerCode = null ;
		this.customerName = null ;
		this.orderType = null ;
	}
}
/* ds.portal.FabricPortalWarning */
export class FabricPortalWarning {
	constructor() {
		this.messageID = '' ;
		this.messageDescription = '' ;
		this.messageTarget = '' ;
	}
}
/* ds.deserializer.CustomLocalDateTimeDeserializer */
export class CustomLocalDateTimeDeserializer {
	constructor() {
	}
}
/* ds.ecomm.BaseDataJobWebInventoryBean */
export class BaseDataJobWebInventoryBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.externalItemCode = '' ;
		this.externalItemSku = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.webOnHandQuantity = 0 ;
		this.uomCode = '' ;
	}
}
/* ds.ecomm.BaseShopifyFabricStyleBean */
export class BaseShopifyFabricStyleBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fullDescription = '' ;
		this.handle = '' ;
		this.title = '' ;
		this.body = '' ;
		this.vendor = '' ;
		this.standardProductType = '' ;
		this.customProductTypeTags = '' ;
		this.published = '' ;
		this.variantInventoryPolicy = '' ;
		this.variantFulfillmentService = '' ;
		this.variantInventoryTracker = '' ;
		this.variantRequiresShipping = '' ;
		this.variantTaxable = '' ;
		this.giftCard = '' ;
		this.sEOTitle = '' ;
		this.sEODescription = '' ;
		this.googleShoppingGoogleProductCategory = '' ;
		this.googleShoppingGender = '' ;
		this.googleShoppingAgeGroup = '' ;
		this.googleShoppingMPN = '' ;
		this.googleShoppingAdWordsGrouping = '' ;
		this.googleShoppingAdWordsLabels = '' ;
		this.googleShoppingCondition = '' ;
		this.googleShoppingCustomProduct = '' ;
		this.googleShoppingCustomLabel0 = '' ;
		this.googleShoppingCustomLabel1 = '' ;
		this.googleShoppingCustomLabel2 = '' ;
		this.googleShoppingCustomLabel3 = '' ;
		this.googleShoppingCustomLabel4 = '' ;
		this.variantTaxCode = '' ;
		this.status = '' ;
		this.imageSource = '' ;
		this.altDescription1 = '' ;
		this.altDescription2 = '' ;
		this.tags = '' ;
		this.shippingWeight = 0 ;
		this.collectionName = '' ;
	}
}
/* ds.ecomm.BaseShopifyFabricStyleSKUBean */
export class BaseShopifyFabricStyleSKUBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fullDescription = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.option1Name = '' ;
		this.option1Value = '' ;
		this.option2Name = '' ;
		this.option2Value = '' ;
		this.option3Name = '' ;
		this.option3Value = '' ;
		this.variantSKU = '' ;
		this.variantGrams = 0 ;
		this.variantInventoryQuantity = 0 ;
		this.variantBarcode = '' ;
		this.imageSrc = '' ;
		this.imagePosition = 0 ;
		this.imageAltText = '' ;
		this.variantImage = '' ;
		this.variantWeightUnit = '' ;
		this.variantPrice = 0 ;
		this.variantCompareAtPrice = 0 ;
		this.costPerItem = 0 ;
		this.altImageName = '' ;
	}
}
/* ds.ecomm.DataJobBean */
export class DataJobBean {
	constructor() {
		this.jobId = 0 ;
		this.clientId = 0 ;
		this.clientCode = '' ;
		this.submittedUserId = 0 ;
		this.submittedUserCode = '' ;
		this.submittedDate = null ;
		this.targetWebsite = '' ;
		this.websiteType = '' ;
		this.jobType = '' ;
		this.priority = 0 ;
		this.status = '' ;
		this.processedDate = null ;
		this.processedBy = '' ;
		this.processedUserId = 0 ;
		this.processedUserCode = '' ;
		this.processedStatus = '' ;
		this.processedRows = 0 ;
		this.successRows = 0 ;
		this.failureRows = 0 ;
		this.notProcessedRows = 0 ;
		this.jobResultFilePath = '' ;
		this.processRemarks = '' ;
		this.jobUploadedDate = null ;
		this.cancelledDate = null ;
		this.cancelledUserId = 0 ;
		this.cancelledUserCode = '' ;
	}
}
/* ds.ecomm.EcomOrderDataBean */
export class EcomOrderDataBean {
	constructor() {
		this.orderId = 0 ;
		this.companyCode = '' ;
		this.targetWebsite = '' ;
		this.websiteType = '' ;
		this.salesOrderNumber = '' ;
		this.salesOrderId = '' ;
		this.createdDate = null ;
		this.customerPurchaseOrderNumber = '' ;
		this.customerCode = '' ;
		this.customerName = '' ;
		this.address = null ;
		this.paymentTermCode = '' ;
		this.paymentMethodCode = '' ;
		this.shipViaCode = '' ;
		this.freightMethodCode = '' ;
		this.taxRequiredFlag = false ;
		this.taxPercentage = 0 ;
		this.totalTaxAmount = 0 ;
		this.discountAmount = 0 ;
		this.shipmentChargesAmount = 0 ;
		this.extraChargesAmount = 0 ;
		this.isConfirmed = false ;
		this.currencyCode = '' ;
		this.createdSource = '' ;
		this.cancelledBy = '' ;
		this.isPaymentFlag = false ;
		this.ecomCreatedDate = null ;
		this.address1 = '' ;
		this.address2 = '' ;
		this.cityCode = '' ;
		this.countryCode = '' ;
		this.phoneNumber1 = '' ;
		this.zip = '' ;
		this.stateCode = '' ;
		this.email = '' ;
		this.jsonData = '' ;
		this.billToAddress1 = '' ;
		this.billToAddress2 = '' ;
		this.billToCityCode = '' ;
		this.billToCountryCode = '' ;
		this.billToPhoneNumber1 = '' ;
		this.billToZip = '' ;
		this.billToStateCode = '' ;
		this.billToEmail = '' ;
		this.buyerName = '' ;
		this.originalOrderNumber = '' ;
		this.originalOrderType = '' ;
		this.lastModifiedDate = null ;
		this.shipToAddress1 = '' ;
		this.shipToAddress2 = '' ;
		this.shipToCityCode = '' ;
		this.shipToCountryCode = '' ;
		this.shipToPhoneNumber1 = '' ;
		this.shipToZip = '' ;
		this.shipToStateCode = '' ;
		this.shipToEmail = '' ;
		this.shipDate = null ;
		this.orderLines = new Array() ;
	}
}
/* ds.ecomm.EcomOrderLineBean */
export class EcomOrderLineBean {
	constructor() {
		this.salesOrderLineId = 0 ;
		this.orderId = 0 ;
		this.companyCode = '' ;
		this.customerCode = '' ;
		this.salesOrderNumber = '' ;
		this.salesOrderLineNumber = 0 ;
		this.orderQuantity = 0 ;
		this.price = 0 ;
		this.lineDiscountAmount = 0 ;
		this.skuNumber = 0 ;
		this.productCode = '' ;
		this.productName = '' ;
		this.colorCode = '' ;
	}
}
/* ds.ecomm.InputShopifyFabricStyleBean */
export class InputShopifyFabricStyleBean {
	constructor() {
		this.skuList = null ;
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fullDescription = '' ;
		this.handle = '' ;
		this.title = '' ;
		this.body = '' ;
		this.vendor = '' ;
		this.standardProductType = '' ;
		this.customProductTypeTags = '' ;
		this.published = '' ;
		this.variantInventoryPolicy = '' ;
		this.variantFulfillmentService = '' ;
		this.variantInventoryTracker = '' ;
		this.variantRequiresShipping = '' ;
		this.variantTaxable = '' ;
		this.giftCard = '' ;
		this.sEOTitle = '' ;
		this.sEODescription = '' ;
		this.googleShoppingGoogleProductCategory = '' ;
		this.googleShoppingGender = '' ;
		this.googleShoppingAgeGroup = '' ;
		this.googleShoppingMPN = '' ;
		this.googleShoppingAdWordsGrouping = '' ;
		this.googleShoppingAdWordsLabels = '' ;
		this.googleShoppingCondition = '' ;
		this.googleShoppingCustomProduct = '' ;
		this.googleShoppingCustomLabel0 = '' ;
		this.googleShoppingCustomLabel1 = '' ;
		this.googleShoppingCustomLabel2 = '' ;
		this.googleShoppingCustomLabel3 = '' ;
		this.googleShoppingCustomLabel4 = '' ;
		this.variantTaxCode = '' ;
		this.status = '' ;
		this.imageSource = '' ;
		this.altDescription1 = '' ;
		this.altDescription2 = '' ;
		this.tags = '' ;
		this.shippingWeight = 0 ;
		this.collectionName = '' ;
	}
}
/* ds.ecomm.InputShopifyFabricStyleSKUBean */
export class InputShopifyFabricStyleSKUBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.fullDescription = '' ;
		this.colorCode = '' ;
		this.skuNumber = 0 ;
		this.option1Name = '' ;
		this.option1Value = '' ;
		this.option2Name = '' ;
		this.option2Value = '' ;
		this.option3Name = '' ;
		this.option3Value = '' ;
		this.variantSKU = '' ;
		this.variantGrams = 0 ;
		this.variantInventoryQuantity = 0 ;
		this.variantBarcode = '' ;
		this.imageSrc = '' ;
		this.imagePosition = 0 ;
		this.imageAltText = '' ;
		this.variantImage = '' ;
		this.variantWeightUnit = '' ;
		this.variantPrice = 0 ;
		this.variantCompareAtPrice = 0 ;
		this.costPerItem = 0 ;
		this.altImageName = '' ;
	}
}
/* ds.ecomm.InputWebSkuInventoryBean */
export class InputWebSkuInventoryBean {
	constructor() {
		this.companyCode = '' ;
		this.fabricStyleCode = '' ;
		this.externalItemCode = '' ;
		this.externalItemSku = '' ;
		this.skuNumber = 0 ;
		this.locationCode = '' ;
		this.fabricStyleName = '' ;
		this.fabricStyleColorCode = '' ;
		this.widthCode = '' ;
		this.webOnHandQuantity = 0 ;
		this.uomCode = '' ;
	}
}
/* ds.ecomm.JobInputBean */
export class JobInputBean {
	constructor() {
		this.targetWebsite = '' ;
		this.priority = 0 ;
	}
}
/* ds.ecomm.JobStatusReponseBean */
export class JobStatusReponseBean {
	constructor() {
		this.submitedJobId = 0 ;
		this.processedDate = null ;
		this.processedStatus = '' ;
		this.processedRows = 0 ;
		this.successRows = 0 ;
		this.failureRows = 0 ;
		this.notProcessedRows = 0 ;
		this.processRemarks = '' ;
	}
}
/* ds.ecomm.JobStatusResultBean */
export class JobStatusResultBean {
	constructor() {
		this.count = 0 ;
		this.dataJobList = new Array() ;
	}
}
/* ds.ecomm.JobSubmitReponseBean */
export class JobSubmitReponseBean {
	constructor() {
		this.submitedJobId = 0 ;
		this.submittedDate = null ;
		this.isSuccess = false ;
		this.errorMessage = '' ;
	}
}
/* ds.ecomm.OrderReponseBean */
export class OrderReponseBean {
	constructor() {
		this.processRemarks = '' ;
		this.orderList = null ;
	}
}
/* ds.ecomm.ShopifyItemUploadJobInputBean */
export class ShopifyItemUploadJobInputBean {
	constructor() {
		this.itemList = null ;
		this.inputItemsCount = 0 ;
		this.targetWebsite = '' ;
		this.priority = 0 ;
	}
}
/* ds.ecomm.WebSkuInventoryUploadJobInputBean */
export class WebSkuInventoryUploadJobInputBean {
	constructor() {
		this.webSkuInventoryist = null ;
		this.inputItemsCount = 0 ;
		this.targetWebsite = '' ;
		this.priority = 0 ;
	}
}
